
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
"use strict";
var $e73bf42412feb220$exports = {};
"use strict";
Object.defineProperty($e73bf42412feb220$exports, "__esModule", {
    value: true
});
var $01e5bbe84554cc8b$exports = {};
"use strict";
Object.defineProperty($01e5bbe84554cc8b$exports, "__esModule", {
    value: true
});
$01e5bbe84554cc8b$exports.default = $01e5bbe84554cc8b$var$createHeader;
var $bd47fd16856711d1$exports = {};
$bd47fd16856711d1$exports = new URL("ICGC_white.9dc19513.svg", import.meta.url).toString();


var $01e5bbe84554cc8b$var$_ICGC_white2 = $01e5bbe84554cc8b$var$_interopRequireDefault($bd47fd16856711d1$exports);

function $01e5bbe84554cc8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $01e5bbe84554cc8b$var$createHeader() {
    return `<div class="ui grid">
    <div id="headerPanel" class="row">
        <div class="three wide column">
            <div id="headerLogo">
                <a title="Institut Catogr\xe0fic i Geol\xf2gic de Catalunya" href="https://www.icgc.cat" target="_blank">
                    <img src="${$01e5bbe84554cc8b$var$_ICGC_white2.default}" class="ui image logo">
                </a>
            </div>
        </div>
        <div class="ten wide column">
            <h2 id="headerTitle" class="ui center  aligned block header">
                <div class="content">
                    Geocodificador ICGC
                </div>
            </h2>
        </div>
        <div class="right floated two wide column">
            <div id="headerInfo">
                <a title="Informaci\xf3" href="https://www.icgc.cat" target="_blank">
                    <i class="large info circle link white icon"></i>
                </a>
            </div>
        </div>
    </div>
</div>`;
}


var $e73bf42412feb220$var$_header2 = $e73bf42412feb220$var$_interopRequireDefault($01e5bbe84554cc8b$exports);
var $e3c0f11649453eec$exports = {};
"use strict";
Object.defineProperty($e3c0f11649453eec$exports, "__esModule", {
    value: true
});
$e3c0f11649453eec$exports.default = $e3c0f11649453eec$var$createRoot;
function $e3c0f11649453eec$var$createRoot() {
    return "<div id='map'></div>";
}


var $e73bf42412feb220$var$_root2 = $e73bf42412feb220$var$_interopRequireDefault($e3c0f11649453eec$exports);
var $3e595d6bb3c29eb5$exports = {};
"use strict";
Object.defineProperty($3e595d6bb3c29eb5$exports, "__esModule", {
    value: true
});
$3e595d6bb3c29eb5$exports.default = $3e595d6bb3c29eb5$var$createFooter;
function $3e595d6bb3c29eb5$var$createFooter() {
    return "";
}


var $e73bf42412feb220$var$_footer2 = $e73bf42412feb220$var$_interopRequireDefault($3e595d6bb3c29eb5$exports);
var $49c0293bc888dc3d$exports = {};
"use strict";
Object.defineProperty($49c0293bc888dc3d$exports, "__esModule", {
    value: true
});
$49c0293bc888dc3d$exports.default = $49c0293bc888dc3d$var$createMap;
var $af44cc7d4ea0e537$exports = {};
/* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v1.13.3/LICENSE.txt */ (function(global, factory) {
    $af44cc7d4ea0e537$exports = factory();
})($af44cc7d4ea0e537$exports, function() {
    "use strict";
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk);";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== "undefined") mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: "text/javascript"
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        "use strict";
        function e1(t1, e1) {
            return t1(e1 = {
                exports: {}
            }, e1.exports), e1.exports;
        }
        var r = n;
        function n(t1, e1, r, n) {
            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = n, this.p2x = r, this.p2y = n;
        }
        n.prototype.sampleCurveX = function(t1) {
            return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
        }, n.prototype.sampleCurveY = function(t1) {
            return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
        }, n.prototype.sampleCurveDerivativeX = function(t1) {
            return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
        }, n.prototype.solveCurveX = function(t1, e1) {
            var r, n, i, a, o;
            for(void 0 === e1 && (e1 = 1e-6), i = t1, o = 0; o < 8; o++){
                if (a = this.sampleCurveX(i) - t1, Math.abs(a) < e1) return i;
                var s = this.sampleCurveDerivativeX(i);
                if (Math.abs(s) < 1e-6) break;
                i -= a / s;
            }
            if ((i = t1) < (r = 0)) return r;
            if (i > (n = 1)) return n;
            for(; r < n;){
                if (a = this.sampleCurveX(i), Math.abs(a - t1) < e1) return i;
                t1 > a ? r = i : n = i, i = .5 * (n - r) + r;
            }
            return i;
        }, n.prototype.solve = function(t1, e1) {
            return this.sampleCurveY(this.solveCurveX(t1, e1));
        };
        var i = a;
        function a(t1, e1) {
            this.x = t1, this.y = e1;
        }
        a.prototype = {
            clone: function() {
                return new a(this.x, this.y);
            },
            add: function(t1) {
                return this.clone()._add(t1);
            },
            sub: function(t1) {
                return this.clone()._sub(t1);
            },
            multByPoint: function(t1) {
                return this.clone()._multByPoint(t1);
            },
            divByPoint: function(t1) {
                return this.clone()._divByPoint(t1);
            },
            mult: function(t1) {
                return this.clone()._mult(t1);
            },
            div: function(t1) {
                return this.clone()._div(t1);
            },
            rotate: function(t1) {
                return this.clone()._rotate(t1);
            },
            rotateAround: function(t1, e1) {
                return this.clone()._rotateAround(t1, e1);
            },
            matMult: function(t1) {
                return this.clone()._matMult(t1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t1) {
                return this.x === t1.x && this.y === t1.y;
            },
            dist: function(t1) {
                return Math.sqrt(this.distSqr(t1));
            },
            distSqr: function(t1) {
                var e1 = t1.x - this.x, r = t1.y - this.y;
                return e1 * e1 + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t1) {
                return Math.atan2(this.y - t1.y, this.x - t1.x);
            },
            angleWith: function(t1) {
                return this.angleWithSep(t1.x, t1.y);
            },
            angleWithSep: function(t1, e1) {
                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
            },
            _matMult: function(t1) {
                var e1 = t1[2] * this.x + t1[3] * this.y;
                return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e1, this;
            },
            _add: function(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            },
            _sub: function(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            },
            _mult: function(t1) {
                return this.x *= t1, this.y *= t1, this;
            },
            _div: function(t1) {
                return this.x /= t1, this.y /= t1, this;
            },
            _multByPoint: function(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            },
            _divByPoint: function(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t1 = this.y;
                return this.y = this.x, this.x = -t1, this;
            },
            _rotate: function(t1) {
                var e1 = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e1 * this.y;
                return this.x = e1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t1, e1) {
                var r = Math.cos(t1), n = Math.sin(t1), i = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                return this.x = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, a.convert = function(t1) {
            return t1 instanceof a ? t1 : Array.isArray(t1) ? new a(t1[0], t1[1]) : t1;
        };
        var o = "undefined" != typeof self ? self : {}, s = Math.pow(2, 53) - 1;
        function u(t1, e1, n, i) {
            var a = new r(t1, e1, n, i);
            return function(t1) {
                return a.solve(t1);
            };
        }
        var l = u(.25, .1, .25, 1);
        function p(t1, e1, r) {
            return Math.min(r, Math.max(e1, t1));
        }
        function c(t1, e1, r) {
            var n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
            return i === e1 ? r : i;
        }
        function h(t1) {
            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
            for(var n = 0, i = e1; n < i.length; n += 1){
                var a = i[n];
                for(var o in a)t1[o] = a[o];
            }
            return t1;
        }
        var f = 1;
        function y() {
            return f++;
        }
        function d() {
            return function t1(e1) {
                return e1 ? (e1 ^ 16 * Math.random() >> e1 / 4).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
            }();
        }
        function m(t1) {
            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
        }
        function v(t1, e1) {
            t1.forEach(function(t1) {
                e1[t1] && (e1[t1] = e1[t1].bind(e1));
            });
        }
        function g(t1, e1) {
            return -1 !== t1.indexOf(e1, t1.length - e1.length);
        }
        function x(t1, e1, r) {
            var n = {};
            for(var i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
            return n;
        }
        function b(t1, e1, r) {
            var n = {};
            for(var i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
            return n;
        }
        function w(t1) {
            return Array.isArray(t1) ? t1.map(w) : "object" == typeof t1 && t1 ? x(t1, w) : t1;
        }
        var _ = {};
        function A(t1) {
            _[t1] || ("undefined" != typeof console && console.warn(t1), _[t1] = !0);
        }
        function S(t1, e1, r) {
            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
        }
        function k(t1) {
            for(var e1 = 0, r = 0, n = t1.length, i = n - 1, a = void 0, o = void 0; r < n; i = r++)e1 += ((o = t1[i]).x - (a = t1[r]).x) * (a.y + o.y);
            return e1;
        }
        function I() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function z(t1) {
            var e1 = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function(t1, r, n, i) {
                var a = n || i;
                return e1[r] = !a || a.toLowerCase(), "";
            }), e1["max-age"]) {
                var r = parseInt(e1["max-age"], 10);
                isNaN(r) ? delete e1["max-age"] : e1["max-age"] = r;
            }
            return e1;
        }
        var C = null;
        function E(t1) {
            if (null == C) {
                var e1 = t1.navigator ? t1.navigator.userAgent : null;
                C = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
            }
            return C;
        }
        function P(t1) {
            try {
                var e1 = o[t1];
                return e1.setItem("_mapbox_test_", 1), e1.removeItem("_mapbox_test_"), !0;
            } catch (t1) {
                return !1;
            }
        }
        var M, B, T, V, F = o.performance && o.performance.now ? o.performance.now.bind(o.performance) : Date.now.bind(Date), D = o.requestAnimationFrame || o.mozRequestAnimationFrame || o.webkitRequestAnimationFrame || o.msRequestAnimationFrame, L = o.cancelAnimationFrame || o.mozCancelAnimationFrame || o.webkitCancelAnimationFrame || o.msCancelAnimationFrame, O = {
            now: F,
            frame: function(t1) {
                var e1 = D(t1);
                return {
                    cancel: function() {
                        return L(e1);
                    }
                };
            },
            getImageData: function(t1, e1) {
                void 0 === e1 && (e1 = 0);
                var r = o.document.createElement("canvas"), n = r.getContext("2d");
                if (!n) throw new Error("failed to create canvas 2d context");
                return r.width = t1.width, r.height = t1.height, n.drawImage(t1, 0, 0, t1.width, t1.height), n.getImageData(-e1, -e1, t1.width + 2 * e1, t1.height + 2 * e1);
            },
            resolveURL: function(t1) {
                return M || (M = o.document.createElement("a")), M.href = t1, M.href;
            },
            hardwareConcurrency: o.navigator && o.navigator.hardwareConcurrency || 4,
            get devicePixelRatio () {
                return o.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!o.matchMedia && (null == B && (B = o.matchMedia("(prefers-reduced-motion: reduce)")), B.matches);
            }
        }, R = {
            API_URL: "https://api.mapbox.com",
            get EVENTS_URL () {
                return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null;
            },
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            MAX_PARALLEL_IMAGE_REQUESTS: 16
        }, U = {
            supported: !1,
            testSupport: function(t1) {
                !j && V && (q ? N(t1) : T = t1);
            }
        }, j = !1, q = !1;
        function N(t1) {
            var e1 = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e1);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, V), t1.isContextLost()) return;
                U.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e1), j = !0;
        }
        o.document && ((V = o.document.createElement("img")).onload = function() {
            T && N(T), T = null, q = !0;
        }, V.onerror = function() {
            j = !0, T = null;
        }, V.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        var K = "01", G = function(t1, e1) {
            this._transformRequestFn = t1, this._customAccessToken = e1, this._createSkuToken();
        };
        function Z(t1) {
            return 0 === t1.indexOf("mapbox:");
        }
        G.prototype._createSkuToken = function() {
            var t1 = function() {
                for(var t1 = "", e1 = 0; e1 < 10; e1++)t1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                return {
                    token: [
                        "1",
                        K,
                        t1
                    ].join(""),
                    tokenExpiresAt: Date.now() + 432e5
                };
            }();
            this._skuToken = t1.token, this._skuTokenExpiresAt = t1.tokenExpiresAt;
        }, G.prototype._isSkuTokenExpired = function() {
            return Date.now() > this._skuTokenExpiresAt;
        }, G.prototype.transformRequest = function(t1, e1) {
            return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                url: t1
            };
        }, G.prototype.normalizeStyleURL = function(t1, e1) {
            if (!Z(t1)) return t1;
            var r = Y(t1);
            return r.path = "/styles/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
        }, G.prototype.normalizeGlyphsURL = function(t1, e1) {
            if (!Z(t1)) return t1;
            var r = Y(t1);
            return r.path = "/fonts/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
        }, G.prototype.normalizeSourceURL = function(t1, e1) {
            if (!Z(t1)) return t1;
            var r = Y(t1);
            return r.path = "/v4/" + r.authority + ".json", r.params.push("secure"), this._makeAPIURL(r, this._customAccessToken || e1);
        }, G.prototype.normalizeSpriteURL = function(t1, e1, r, n) {
            var i = Y(t1);
            return Z(t1) ? (i.path = "/styles/v1" + i.path + "/sprite" + e1 + r, this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += "" + e1 + r, $(i));
        }, G.prototype.normalizeTileURL = function(t1, e1) {
            if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !Z(t1)) return t1;
            var r = Y(t1);
            r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, (O.devicePixelRatio >= 2 || 512 === e1 ? "@2x" : "") + (U.supported ? ".webp" : "$1")), r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = "/v4" + r.path;
            var n = this._customAccessToken || function(t1) {
                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                    var n = r[e1].match(/^access_token=(.*)$/);
                    if (n) return n[1];
                }
                return null;
            }(r.params) || R.ACCESS_TOKEN;
            return R.REQUIRE_ACCESS_TOKEN && n && this._skuToken && r.params.push("sku=" + this._skuToken), this._makeAPIURL(r, n);
        }, G.prototype.canonicalizeTileURL = function(t1, e1) {
            var r = Y(t1);
            if (!r.path.match(/(^\/v4\/)/) || !r.path.match(/\.[\w]+$/)) return t1;
            var n = "mapbox://tiles/";
            n += r.path.replace("/v4/", "");
            var i = r.params;
            return e1 && (i = i.filter(function(t1) {
                return !t1.match(/^access_token=/);
            })), i.length && (n += "?" + i.join("&")), n;
        }, G.prototype.canonicalizeTileset = function(t1, e1) {
            for(var r = !!e1 && Z(e1), n = [], i = 0, a = t1.tiles || []; i < a.length; i += 1){
                var o = a[i];
                J(o) ? n.push(this.canonicalizeTileURL(o, r)) : n.push(o);
            }
            return n;
        }, G.prototype._makeAPIURL = function(t1, e1) {
            var r = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes", n = Y(R.API_URL);
            if (t1.protocol = n.protocol, t1.authority = n.authority, "http" === t1.protocol) {
                var i = t1.params.indexOf("secure");
                i >= 0 && t1.params.splice(i, 1);
            }
            if ("/" !== n.path && (t1.path = "" + n.path + t1.path), !R.REQUIRE_ACCESS_TOKEN) return $(t1);
            if (!(e1 = e1 || R.ACCESS_TOKEN)) throw new Error("An API access token is required to use Mapbox GL. " + r);
            if ("s" === e1[0]) throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + r);
            return t1.params = t1.params.filter(function(t1) {
                return -1 === t1.indexOf("access_token");
            }), t1.params.push("access_token=" + e1), $(t1);
        };
        var X = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
        function J(t1) {
            return X.test(t1);
        }
        var H = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function Y(t1) {
            var e1 = t1.match(H);
            if (!e1) throw new Error("Unable to parse URL object");
            return {
                protocol: e1[1],
                authority: e1[2],
                path: e1[3] || "/",
                params: e1[4] ? e1[4].split("&") : []
            };
        }
        function $(t1) {
            var e1 = t1.params.length ? "?" + t1.params.join("&") : "";
            return t1.protocol + "://" + t1.authority + t1.path + e1;
        }
        function W(t1) {
            if (!t1) return null;
            var e1 = t1.split(".");
            if (!e1 || 3 !== e1.length) return null;
            try {
                return JSON.parse(decodeURIComponent(o.atob(e1[1]).split("").map(function(t1) {
                    return "%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2);
                }).join("")));
            } catch (t1) {
                return null;
            }
        }
        var Q = function(t1) {
            this.type = t1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
        };
        Q.prototype.getStorageKey = function(t1) {
            var e1, r = W(R.ACCESS_TOKEN);
            return e1 = r && r.u ? o.btoa(encodeURIComponent(r.u).replace(/%([0-9A-F]{2})/g, function(t1, e1) {
                return String.fromCharCode(Number("0x" + e1));
            })) : R.ACCESS_TOKEN || "", t1 ? "mapbox.eventData." + t1 + ":" + e1 : "mapbox.eventData:" + e1;
        }, Q.prototype.fetchEventData = function() {
            var t1 = P("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
            if (t1) try {
                var n = o.localStorage.getItem(e1);
                n && (this.eventData = JSON.parse(n));
                var i = o.localStorage.getItem(r);
                i && (this.anonId = i);
            } catch (t1) {
                A("Unable to read from LocalStorage");
            }
        }, Q.prototype.saveEventData = function() {
            var t1 = P("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
            if (t1) try {
                o.localStorage.setItem(r, this.anonId), Object.keys(this.eventData).length >= 1 && o.localStorage.setItem(e1, JSON.stringify(this.eventData));
            } catch (t1) {
                A("Unable to write to LocalStorage");
            }
        }, Q.prototype.processRequests = function(t1) {}, Q.prototype.postEvent = function(t1, e1, r, n) {
            var i = this;
            if (R.EVENTS_URL) {
                var a = Y(R.EVENTS_URL);
                a.params.push("access_token=" + (n || R.ACCESS_TOKEN || ""));
                var o = {
                    event: this.type,
                    created: new Date(t1).toISOString(),
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: "1.13.3",
                    skuId: K,
                    userId: this.anonId
                }, s = e1 ? h(o, e1) : o, u = {
                    url: $(a),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        s
                    ])
                };
                this.pendingRequest = wt(u, function(t1) {
                    i.pendingRequest = null, r(t1), i.saveEventData(), i.processRequests(n);
                });
            }
        }, Q.prototype.queueRequest = function(t1, e1) {
            this.queue.push(t1), this.processRequests(e1);
        };
        var tt, et, rt = function(t1) {
            function e1() {
                t1.call(this, "map.load"), this.success = {}, this.skuToken = "";
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.postMapLoadEvent = function(t1, e1, r, n) {
                this.skuToken = r;
                var i = !(!n && !R.ACCESS_TOKEN), a = Array.isArray(t1) && t1.some(function(t1) {
                    return Z(t1) || J(t1);
                });
                R.EVENTS_URL && i && a && this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, n);
            }, e1.prototype.processRequests = function(t1) {
                var e1 = this;
                if (!this.pendingRequest && 0 !== this.queue.length) {
                    var r = this.queue.shift(), n = r.id, i = r.timestamp;
                    n && this.success[n] || (this.anonId || this.fetchEventData(), m(this.anonId) || (this.anonId = d()), this.postEvent(i, {
                        skuToken: this.skuToken
                    }, function(t1) {
                        t1 || n && (e1.success[n] = !0);
                    }, t1));
                }
            }, e1;
        }(Q), nt = new (function(t1) {
            function e1(e1) {
                t1.call(this, "appUserTurnstile"), this._customAccessToken = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.postTurnstileEvent = function(t1, e1) {
                R.EVENTS_URL && R.ACCESS_TOKEN && Array.isArray(t1) && t1.some(function(t1) {
                    return Z(t1) || J(t1);
                }) && this.queueRequest(Date.now(), e1);
            }, e1.prototype.processRequests = function(t1) {
                var e1 = this;
                if (!this.pendingRequest && 0 !== this.queue.length) {
                    this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                    var r = W(R.ACCESS_TOKEN), n = r ? r.u : R.ACCESS_TOKEN, i = n !== this.eventData.tokenU;
                    m(this.anonId) || (this.anonId = d(), i = !0);
                    var a = this.queue.shift();
                    if (this.eventData.lastSuccess) {
                        var o = new Date(this.eventData.lastSuccess), s = new Date(a), u = (a - this.eventData.lastSuccess) / 864e5;
                        i = i || u >= 1 || u < -1 || o.getDate() !== s.getDate();
                    } else i = !0;
                    if (!i) return this.processRequests();
                    this.postEvent(a, {
                        "enabled.telemetry": !1
                    }, function(t1) {
                        t1 || (e1.eventData.lastSuccess = a, e1.eventData.tokenU = n);
                    }, t1);
                }
            }, e1;
        }(Q)), it = nt.postTurnstileEvent.bind(nt), at = new rt, ot = at.postMapLoadEvent.bind(at), st = 500, ut = 50;
        function lt() {
            o.caches && !tt && (tt = o.caches.open("mapbox-tiles"));
        }
        function pt(t1) {
            var e1 = t1.indexOf("?");
            return e1 < 0 ? t1 : t1.slice(0, e1);
        }
        var ct, ht = 1 / 0;
        function ft() {
            return null == ct && (ct = o.OffscreenCanvas && new o.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof o.createImageBitmap), ct;
        }
        var yt = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image"
        };
        "function" == typeof Object.freeze && Object.freeze(yt);
        var dt = function(t1) {
            function e1(e1, r, n) {
                401 === r && J(n) && (e1 += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), t1.call(this, e1), this.status = r, this.url = n, this.name = this.constructor.name, this.message = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.toString = function() {
                return this.name + ": " + this.message + " (" + this.status + "): " + this.url;
            }, e1;
        }(Error), mt = I() ? function() {
            return self.worker && self.worker.referrer;
        } : function() {
            return ("blob:" === o.location.protocol ? o.parent : o).location.href;
        };
        var vt, gt, xt = function(t1, e1) {
            if (!(/^file:/.test(r = t1.url) || /^file:/.test(mt()) && !/^\w+:/.test(r))) {
                if (o.fetch && o.Request && o.AbortController && o.Request.prototype.hasOwnProperty("signal")) return function(t1, e1) {
                    var r, n = new o.AbortController, i = new o.Request(t1.url, {
                        method: t1.method || "GET",
                        body: t1.body,
                        credentials: t1.credentials,
                        headers: t1.headers,
                        referrer: mt(),
                        signal: n.signal
                    }), a = !1, s = !1, u = (r = i.url).indexOf("sku=") > 0 && J(r);
                    "json" === t1.type && i.headers.set("Accept", "application/json");
                    var l = function(r, n, a) {
                        if (!s) {
                            if (r && "SecurityError" !== r.message && A(r), n && a) return p(n);
                            var l = Date.now();
                            o.fetch(i).then(function(r) {
                                if (r.ok) {
                                    var n = u ? r.clone() : null;
                                    return p(r, n, l);
                                }
                                return e1(new dt(r.statusText, r.status, t1.url));
                            }).catch(function(t1) {
                                20 !== t1.code && e1(new Error(t1.message));
                            });
                        }
                    }, p = function(r, n, u) {
                        ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then(function(t1) {
                            s || (n && u && function(t1, e1, r) {
                                if (lt(), tt) {
                                    var n = {
                                        status: e1.status,
                                        statusText: e1.statusText,
                                        headers: new o.Headers
                                    };
                                    e1.headers.forEach(function(t1, e1) {
                                        return n.headers.set(e1, t1);
                                    });
                                    var i = z(e1.headers.get("Cache-Control") || "");
                                    i["no-store"] || (i["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * i["max-age"]).toUTCString()), new Date(n.headers.get("Expires")).getTime() - r < 42e4 || function(t1, e1) {
                                        if (void 0 === et) try {
                                            new Response(new ReadableStream), et = !0;
                                        } catch (t1) {
                                            et = !1;
                                        }
                                        et ? e1(t1.body) : t1.blob().then(e1);
                                    }(e1, function(e1) {
                                        var r = new o.Response(e1, n);
                                        lt(), tt && tt.then(function(e1) {
                                            return e1.put(pt(t1.url), r);
                                        }).catch(function(t1) {
                                            return A(t1.message);
                                        });
                                    }));
                                }
                            }(i, n, u), a = !0, e1(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch(function(t1) {
                            s || e1(new Error(t1.message));
                        });
                    };
                    return u ? function(t1, e1) {
                        if (lt(), !tt) return e1(null);
                        var r = pt(t1.url);
                        tt.then(function(t1) {
                            t1.match(r).then(function(n) {
                                var i = function(t1) {
                                    if (!t1) return !1;
                                    var e1 = new Date(t1.headers.get("Expires") || 0), r = z(t1.headers.get("Cache-Control") || "");
                                    return e1 > Date.now() && !r["no-cache"];
                                }(n);
                                t1.delete(r), i && t1.put(r, n.clone()), e1(null, n, i);
                            }).catch(e1);
                        }).catch(e1);
                    }(i, l) : l(null, null), {
                        cancel: function() {
                            s = !0, a || n.abort();
                        }
                    };
                }(t1, e1);
                if (I() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1, void 0, !0);
            }
            var r;
            return function(t1, e1) {
                var r = new o.XMLHttpRequest;
                for(var n in r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer"), t1.headers)r.setRequestHeader(n, t1.headers[n]);
                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = function() {
                    e1(new Error(r.statusText));
                }, r.onload = function() {
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        var n = r.response;
                        if ("json" === t1.type) try {
                            n = JSON.parse(r.response);
                        } catch (t1) {
                            return e1(t1);
                        }
                        e1(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else e1(new dt(r.statusText, r.status, t1.url));
                }, r.send(t1.body), {
                    cancel: function() {
                        return r.abort();
                    }
                };
            }(t1, e1);
        }, bt = function(t1, e1) {
            return xt(h(t1, {
                type: "arrayBuffer"
            }), e1);
        }, wt = function(t1, e1) {
            return xt(h(t1, {
                method: "POST"
            }), e1);
        }, _t = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        vt = [], gt = 0;
        var At = function(t1, e1) {
            if (U.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), gt >= R.MAX_PARALLEL_IMAGE_REQUESTS) {
                var r = {
                    requestParameters: t1,
                    callback: e1,
                    cancelled: !1,
                    cancel: function() {
                        this.cancelled = !0;
                    }
                };
                return vt.push(r), r;
            }
            gt++;
            var n = !1, i = function() {
                if (!n) for(n = !0, gt--; vt.length && gt < R.MAX_PARALLEL_IMAGE_REQUESTS;){
                    var t1 = vt.shift();
                    t1.cancelled || (t1.cancel = At(t1.requestParameters, t1.callback).cancel);
                }
            }, a = bt(t1, function(t1, r, n, a) {
                i(), t1 ? e1(t1) : r && (ft() ? function(t1, e1) {
                    var r = new o.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    o.createImageBitmap(r).then(function(t1) {
                        e1(null, t1);
                    }).catch(function(t1) {
                        e1(new Error("Could not load image because of " + t1.message + ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    });
                }(r, e1) : function(t1, e1, r, n) {
                    var i = new o.Image, a = o.URL;
                    i.onload = function() {
                        e1(null, i), a.revokeObjectURL(i.src), i.onload = null, o.requestAnimationFrame(function() {
                            i.src = _t;
                        });
                    }, i.onerror = function() {
                        return e1(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    };
                    var s = new o.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    i.cacheControl = r, i.expires = n, i.src = t1.byteLength ? a.createObjectURL(s) : _t;
                }(r, e1, n, a));
            });
            return {
                cancel: function() {
                    a.cancel(), i();
                }
            };
        };
        function St(t1, e1, r) {
            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
        }
        function kt(t1, e1, r) {
            if (r && r[t1]) {
                var n = r[t1].indexOf(e1);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        var It = function(t1, e1) {
            void 0 === e1 && (e1 = {}), h(this, e1), this.type = t1;
        }, zt = function(t1) {
            function e1(e1, r) {
                void 0 === r && (r = {}), t1.call(this, "error", h({
                    error: e1
                }, r));
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(It), Ct = function() {};
        Ct.prototype.on = function(t1, e1) {
            return this._listeners = this._listeners || {}, St(t1, e1, this._listeners), this;
        }, Ct.prototype.off = function(t1, e1) {
            return kt(t1, e1, this._listeners), kt(t1, e1, this._oneTimeListeners), this;
        }, Ct.prototype.once = function(t1, e1) {
            return this._oneTimeListeners = this._oneTimeListeners || {}, St(t1, e1, this._oneTimeListeners), this;
        }, Ct.prototype.fire = function(t1, e1) {
            "string" == typeof t1 && (t1 = new It(t1, e1 || {}));
            var r = t1.type;
            if (this.listens(r)) {
                t1.target = this;
                for(var n = 0, i = this._listeners && this._listeners[r] ? this._listeners[r].slice() : []; n < i.length; n += 1)i[n].call(this, t1);
                for(var a = 0, o = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : []; a < o.length; a += 1){
                    var s = o[a];
                    kt(r, s, this._oneTimeListeners), s.call(this, t1);
                }
                var u = this._eventedParent;
                u && (h(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), u.fire(t1));
            } else t1 instanceof zt && console.error(t1.error);
            return this;
        }, Ct.prototype.listens = function(t1) {
            return this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1);
        }, Ct.prototype.setEventedParent = function(t1, e1) {
            return this._eventedParent = t1, this._eventedParentData = e1, this;
        };
        var Et = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "string"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {}
                    },
                    default: "mapbox"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {},
                    within: {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        }, Pt = function(t1, e1, r, n) {
            this.message = (t1 ? t1 + ": " : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
        };
        function Mt(t1) {
            var e1 = t1.value;
            return e1 ? [
                new Pt(t1.key, e1, "constants have been deprecated as of v8")
            ] : [];
        }
        function Bt(t1) {
            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
            for(var n = 0, i = e1; n < i.length; n += 1){
                var a = i[n];
                for(var o in a)t1[o] = a[o];
            }
            return t1;
        }
        function Tt(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Vt(t1) {
            if (Array.isArray(t1)) return t1.map(Vt);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                var e1 = {};
                for(var r in t1)e1[r] = Vt(t1[r]);
                return e1;
            }
            return Tt(t1);
        }
        var Ft = function(t1) {
            function e1(e1, r) {
                t1.call(this, r), this.message = r, this.key = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(Error), Dt = function(t1, e1) {
            void 0 === e1 && (e1 = []), this.parent = t1, this.bindings = {};
            for(var r = 0, n = e1; r < n.length; r += 1){
                var i = n[r];
                this.bindings[i[0]] = i[1];
            }
        };
        Dt.prototype.concat = function(t1) {
            return new Dt(this, t1);
        }, Dt.prototype.get = function(t1) {
            if (this.bindings[t1]) return this.bindings[t1];
            if (this.parent) return this.parent.get(t1);
            throw new Error(t1 + " not found in scope.");
        }, Dt.prototype.has = function(t1) {
            return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
        };
        var Lt = {
            kind: "null"
        }, Ot = {
            kind: "number"
        }, Rt = {
            kind: "string"
        }, Ut = {
            kind: "boolean"
        }, jt = {
            kind: "color"
        }, qt = {
            kind: "object"
        }, Nt = {
            kind: "value"
        }, Kt = {
            kind: "collator"
        }, Gt = {
            kind: "formatted"
        }, Zt = {
            kind: "resolvedImage"
        };
        function Xt(t1, e1) {
            return {
                kind: "array",
                itemType: t1,
                N: e1
            };
        }
        function Jt(t1) {
            if ("array" === t1.kind) {
                var e1 = Jt(t1.itemType);
                return "number" == typeof t1.N ? "array<" + e1 + ", " + t1.N + ">" : "value" === t1.itemType.kind ? "array" : "array<" + e1 + ">";
            }
            return t1.kind;
        }
        var Ht = [
            Lt,
            Ot,
            Rt,
            Ut,
            jt,
            Gt,
            qt,
            Xt(Nt),
            Zt
        ];
        function Yt(t1, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !Yt(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
            } else {
                if (t1.kind === e1.kind) return null;
                if ("value" === t1.kind) {
                    for(var r = 0, n = Ht; r < n.length; r += 1)if (!Yt(n[r], e1)) return null;
                }
            }
            return "Expected " + Jt(t1) + " but found " + Jt(e1) + " instead.";
        }
        function $t(t1, e1) {
            return e1.some(function(e1) {
                return e1.kind === t1.kind;
            });
        }
        function Wt(t1, e1) {
            return e1.some(function(e1) {
                return "null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1;
            });
        }
        var Qt = e1(function(t1, e1) {
            var r = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function n(t1) {
                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
            }
            function i(t1) {
                return n("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
            }
            function a(t1) {
                var e1;
                return (e1 = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e1 > 1 ? 1 : e1;
            }
            function o(t1, e1, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e1 - t1) * r * 6 : 2 * r < 1 ? e1 : 3 * r < 2 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
            }
            try {
                e1.parseCSSColor = function(t1) {
                    var e1, s = t1.replace(/ /g, "").toLowerCase();
                    if (s in r) return r[s].slice();
                    if ("#" === s[0]) return 4 === s.length ? (e1 = parseInt(s.substr(1), 16)) >= 0 && e1 <= 4095 ? [
                        (3840 & e1) >> 4 | (3840 & e1) >> 8,
                        240 & e1 | (240 & e1) >> 4,
                        15 & e1 | (15 & e1) << 4,
                        1
                    ] : null : 7 === s.length && (e1 = parseInt(s.substr(1), 16)) >= 0 && e1 <= 16777215 ? [
                        (16711680 & e1) >> 16,
                        (65280 & e1) >> 8,
                        255 & e1,
                        1
                    ] : null;
                    var u = s.indexOf("("), l = s.indexOf(")");
                    if (-1 !== u && l + 1 === s.length) {
                        var p = s.substr(0, u), c = s.substr(u + 1, l - (u + 1)).split(","), h = 1;
                        switch(p){
                            case "rgba":
                                if (4 !== c.length) return null;
                                h = a(c.pop());
                            case "rgb":
                                return 3 !== c.length ? null : [
                                    i(c[0]),
                                    i(c[1]),
                                    i(c[2]),
                                    h
                                ];
                            case "hsla":
                                if (4 !== c.length) return null;
                                h = a(c.pop());
                            case "hsl":
                                if (3 !== c.length) return null;
                                var f = (parseFloat(c[0]) % 360 + 360) % 360 / 360, y = a(c[1]), d = a(c[2]), m = d <= .5 ? d * (y + 1) : d + y - d * y, v = 2 * d - m;
                                return [
                                    n(255 * o(v, m, f + 1 / 3)),
                                    n(255 * o(v, m, f)),
                                    n(255 * o(v, m, f - 1 / 3)),
                                    h
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (t1) {}
        }).parseCSSColor, te = function(t1, e1, r, n) {
            void 0 === n && (n = 1), this.r = t1, this.g = e1, this.b = r, this.a = n;
        };
        te.parse = function(t1) {
            if (t1) {
                if (t1 instanceof te) return t1;
                if ("string" == typeof t1) {
                    var e1 = Qt(t1);
                    if (e1) return new te(e1[0] / 255 * e1[3], e1[1] / 255 * e1[3], e1[2] / 255 * e1[3], e1[3]);
                }
            }
        }, te.prototype.toString = function() {
            var t1 = this.toArray(), e1 = t1[1], r = t1[2], n = t1[3];
            return "rgba(" + Math.round(t1[0]) + "," + Math.round(e1) + "," + Math.round(r) + "," + n + ")";
        }, te.prototype.toArray = function() {
            var t1 = this.a;
            return 0 === t1 ? [
                0,
                0,
                0,
                0
            ] : [
                255 * this.r / t1,
                255 * this.g / t1,
                255 * this.b / t1,
                t1
            ];
        }, te.black = new te(0, 0, 0, 1), te.white = new te(1, 1, 1, 1), te.transparent = new te(0, 0, 0, 0), te.red = new te(1, 0, 0, 1);
        var ee = function(t1, e1, r) {
            this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                sensitivity: this.sensitivity,
                usage: "search"
            });
        };
        ee.prototype.compare = function(t1, e1) {
            return this.collator.compare(t1, e1);
        }, ee.prototype.resolvedLocale = function() {
            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        };
        var re = function(t1, e1, r, n, i) {
            this.text = t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
        }, ne = function(t1) {
            this.sections = t1;
        };
        ne.fromString = function(t1) {
            return new ne([
                new re(t1, null, null, null, null)
            ]);
        }, ne.prototype.isEmpty = function() {
            return 0 === this.sections.length || !this.sections.some(function(t1) {
                return 0 !== t1.text.length || t1.image && 0 !== t1.image.name.length;
            });
        }, ne.factory = function(t1) {
            return t1 instanceof ne ? t1 : ne.fromString(t1);
        }, ne.prototype.toString = function() {
            return 0 === this.sections.length ? "" : this.sections.map(function(t1) {
                return t1.text;
            }).join("");
        }, ne.prototype.serialize = function() {
            for(var t1 = [
                "format"
            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                var n = r[e1];
                if (n.image) t1.push([
                    "image",
                    n.image.name
                ]);
                else {
                    t1.push(n.text);
                    var i = {};
                    n.fontStack && (i["text-font"] = [
                        "literal",
                        n.fontStack.split(",")
                    ]), n.scale && (i["font-scale"] = n.scale), n.textColor && (i["text-color"] = [
                        "rgba"
                    ].concat(n.textColor.toArray())), t1.push(i);
                }
            }
            return t1;
        };
        var ie = function(t1) {
            this.name = t1.name, this.available = t1.available;
        };
        function ae(t1, e1, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [" + [
                t1,
                e1,
                r,
                n
            ].join(", ") + "]: 'a' must be between 0 and 1." : "Invalid rgba value [" + ("number" == typeof n ? [
                t1,
                e1,
                r,
                n
            ] : [
                t1,
                e1,
                r
            ]).join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255.";
        }
        function oe(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof te) return !0;
            if (t1 instanceof ee) return !0;
            if (t1 instanceof ne) return !0;
            if (t1 instanceof ie) return !0;
            if (Array.isArray(t1)) {
                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (!oe(r[e1])) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(var n in t1)if (!oe(t1[n])) return !1;
                return !0;
            }
            return !1;
        }
        function se(t1) {
            if (null === t1) return Lt;
            if ("string" == typeof t1) return Rt;
            if ("boolean" == typeof t1) return Ut;
            if ("number" == typeof t1) return Ot;
            if (t1 instanceof te) return jt;
            if (t1 instanceof ee) return Kt;
            if (t1 instanceof ne) return Gt;
            if (t1 instanceof ie) return Zt;
            if (Array.isArray(t1)) {
                for(var e1, r = t1.length, n = 0, i = t1; n < i.length; n += 1){
                    var a = se(i[n]);
                    if (e1) {
                        if (e1 === a) continue;
                        e1 = Nt;
                        break;
                    }
                    e1 = a;
                }
                return Xt(e1 || Nt, r);
            }
            return qt;
        }
        function ue(t1) {
            var e1 = typeof t1;
            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof te || t1 instanceof ne || t1 instanceof ie ? t1.toString() : JSON.stringify(t1);
        }
        ie.prototype.toString = function() {
            return this.name;
        }, ie.fromString = function(t1) {
            return t1 ? new ie({
                name: t1,
                available: !1
            }) : null;
        }, ie.prototype.serialize = function() {
            return [
                "image",
                this.name
            ];
        };
        var le = function(t1, e1) {
            this.type = t1, this.value = e1;
        };
        le.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("'literal' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
            if (!oe(t1[1])) return e1.error("invalid value");
            var r = t1[1], n = se(r), i = e1.expectedType;
            return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new le(n, r);
        }, le.prototype.evaluate = function() {
            return this.value;
        }, le.prototype.eachChild = function() {}, le.prototype.outputDefined = function() {
            return !0;
        }, le.prototype.serialize = function() {
            return "array" === this.type.kind || "object" === this.type.kind ? [
                "literal",
                this.value
            ] : this.value instanceof te ? [
                "rgba"
            ].concat(this.value.toArray()) : this.value instanceof ne ? this.value.serialize() : this.value;
        };
        var pe = function(t1) {
            this.name = "ExpressionEvaluationError", this.message = t1;
        };
        pe.prototype.toJSON = function() {
            return this.message;
        };
        var ce = {
            string: Rt,
            number: Ot,
            boolean: Ut,
            object: qt
        }, he = function(t1, e1) {
            this.type = t1, this.args = e1;
        };
        he.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expected at least one argument.");
            var r, n = 1, i = t1[0];
            if ("array" === i) {
                var a, o;
                if (t1.length > 2) {
                    var s = t1[1];
                    if ("string" != typeof s || !(s in ce) || "object" === s) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                    a = ce[s], n++;
                } else a = Nt;
                if (t1.length > 3) {
                    if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                    o = t1[2], n++;
                }
                r = Xt(a, o);
            } else r = ce[i];
            for(var u = []; n < t1.length; n++){
                var l = e1.parse(t1[n], n, Nt);
                if (!l) return null;
                u.push(l);
            }
            return new he(r, u);
        }, he.prototype.evaluate = function(t1) {
            for(var e1 = 0; e1 < this.args.length; e1++){
                var r = this.args[e1].evaluate(t1);
                if (!Yt(this.type, se(r))) return r;
                if (e1 === this.args.length - 1) throw new pe("Expected value to be of type " + Jt(this.type) + ", but found " + Jt(se(r)) + " instead.");
            }
            return null;
        }, he.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, he.prototype.outputDefined = function() {
            return this.args.every(function(t1) {
                return t1.outputDefined();
            });
        }, he.prototype.serialize = function() {
            var t1 = this.type, e1 = [
                t1.kind
            ];
            if ("array" === t1.kind) {
                var r = t1.itemType;
                if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                    e1.push(r.kind);
                    var n = t1.N;
                    ("number" == typeof n || this.args.length > 1) && e1.push(n);
                }
            }
            return e1.concat(this.args.map(function(t1) {
                return t1.serialize();
            }));
        };
        var fe = function(t1) {
            this.type = Gt, this.sections = t1;
        };
        fe.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expected at least one argument.");
            var r = t1[1];
            if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
            for(var n = [], i = !1, a = 1; a <= t1.length - 1; ++a){
                var o = t1[a];
                if (i && "object" == typeof o && !Array.isArray(o)) {
                    i = !1;
                    var s = null;
                    if (o["font-scale"] && !(s = e1.parse(o["font-scale"], 1, Ot))) return null;
                    var u = null;
                    if (o["text-font"] && !(u = e1.parse(o["text-font"], 1, Xt(Rt)))) return null;
                    var l = null;
                    if (o["text-color"] && !(l = e1.parse(o["text-color"], 1, jt))) return null;
                    var p = n[n.length - 1];
                    p.scale = s, p.font = u, p.textColor = l;
                } else {
                    var c = e1.parse(t1[a], 1, Nt);
                    if (!c) return null;
                    var h = c.type.kind;
                    if ("string" !== h && "value" !== h && "null" !== h && "resolvedImage" !== h) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                    i = !0, n.push({
                        content: c,
                        scale: null,
                        font: null,
                        textColor: null
                    });
                }
            }
            return new fe(n);
        }, fe.prototype.evaluate = function(t1) {
            return new ne(this.sections.map(function(e1) {
                var r = e1.content.evaluate(t1);
                return se(r) === Zt ? new re("", r, null, null, null) : new re(ue(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
            }));
        }, fe.prototype.eachChild = function(t1) {
            for(var e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                var n = r[e1];
                t1(n.content), n.scale && t1(n.scale), n.font && t1(n.font), n.textColor && t1(n.textColor);
            }
        }, fe.prototype.outputDefined = function() {
            return !1;
        }, fe.prototype.serialize = function() {
            for(var t1 = [
                "format"
            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                var n = r[e1];
                t1.push(n.content.serialize());
                var i = {};
                n.scale && (i["font-scale"] = n.scale.serialize()), n.font && (i["text-font"] = n.font.serialize()), n.textColor && (i["text-color"] = n.textColor.serialize()), t1.push(i);
            }
            return t1;
        };
        var ye = function(t1) {
            this.type = Zt, this.input = t1;
        };
        ye.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("Expected two arguments.");
            var r = e1.parse(t1[1], 1, Rt);
            return r ? new ye(r) : e1.error("No image name provided.");
        }, ye.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1), r = ie.fromString(e1);
            return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
        }, ye.prototype.eachChild = function(t1) {
            t1(this.input);
        }, ye.prototype.outputDefined = function() {
            return !1;
        }, ye.prototype.serialize = function() {
            return [
                "image",
                this.input.serialize()
            ];
        };
        var de = {
            "to-boolean": Ut,
            "to-color": jt,
            "to-number": Ot,
            "to-string": Rt
        }, me = function(t1, e1) {
            this.type = t1, this.args = e1;
        };
        me.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expected at least one argument.");
            var r = t1[0];
            if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
            for(var n = de[r], i = [], a = 1; a < t1.length; a++){
                var o = e1.parse(t1[a], a, Nt);
                if (!o) return null;
                i.push(o);
            }
            return new me(n, i);
        }, me.prototype.evaluate = function(t1) {
            if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
            if ("color" === this.type.kind) {
                for(var e1, r, n = 0, i = this.args; n < i.length; n += 1){
                    if (r = null, (e1 = i[n].evaluate(t1)) instanceof te) return e1;
                    if ("string" == typeof e1) {
                        var a = t1.parseColor(e1);
                        if (a) return a;
                    } else if (Array.isArray(e1) && !(r = e1.length < 3 || e1.length > 4 ? "Invalid rbga value " + JSON.stringify(e1) + ": expected an array containing either three or four numeric values." : ae(e1[0], e1[1], e1[2], e1[3]))) return new te(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                }
                throw new pe(r || "Could not parse color from value '" + ("string" == typeof e1 ? e1 : String(JSON.stringify(e1))) + "'");
            }
            if ("number" === this.type.kind) {
                for(var o = null, s = 0, u = this.args; s < u.length; s += 1){
                    if (null === (o = u[s].evaluate(t1))) return 0;
                    var l = Number(o);
                    if (!isNaN(l)) return l;
                }
                throw new pe("Could not convert " + JSON.stringify(o) + " to number.");
            }
            return "formatted" === this.type.kind ? ne.fromString(ue(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? ie.fromString(ue(this.args[0].evaluate(t1))) : ue(this.args[0].evaluate(t1));
        }, me.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, me.prototype.outputDefined = function() {
            return this.args.every(function(t1) {
                return t1.outputDefined();
            });
        }, me.prototype.serialize = function() {
            if ("formatted" === this.type.kind) return new fe([
                {
                    content: this.args[0],
                    scale: null,
                    font: null,
                    textColor: null
                }
            ]).serialize();
            if ("resolvedImage" === this.type.kind) return new ye(this.args[0]).serialize();
            var t1 = [
                "to-" + this.type.kind
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var ve = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], ge = function() {
            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
        };
        ge.prototype.id = function() {
            return this.feature && "id" in this.feature ? this.feature.id : null;
        }, ge.prototype.geometryType = function() {
            return this.feature ? "number" == typeof this.feature.type ? ve[this.feature.type] : this.feature.type : null;
        }, ge.prototype.geometry = function() {
            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }, ge.prototype.canonicalID = function() {
            return this.canonical;
        }, ge.prototype.properties = function() {
            return this.feature && this.feature.properties || {};
        }, ge.prototype.parseColor = function(t1) {
            var e1 = this._parseColorCache[t1];
            return e1 || (e1 = this._parseColorCache[t1] = te.parse(t1)), e1;
        };
        var xe = function(t1, e1, r, n) {
            this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
        };
        xe.prototype.evaluate = function(t1) {
            return this._evaluate(t1, this.args);
        }, xe.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, xe.prototype.outputDefined = function() {
            return !1;
        }, xe.prototype.serialize = function() {
            return [
                this.name
            ].concat(this.args.map(function(t1) {
                return t1.serialize();
            }));
        }, xe.parse = function(t1, e1) {
            var r, n = t1[0], i = xe.definitions[n];
            if (!i) return e1.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
            for(var a = Array.isArray(i) ? i[0] : i.type, o = Array.isArray(i) ? [
                [
                    i[1],
                    i[2]
                ]
            ] : i.overloads, s = o.filter(function(e1) {
                var r = e1[0];
                return !Array.isArray(r) || r.length === t1.length - 1;
            }), u = null, l = 0, p = s; l < p.length; l += 1){
                var c = p[l], h = c[0], f = c[1];
                u = new je(e1.registry, e1.path, null, e1.scope);
                for(var y = [], d = !1, m = 1; m < t1.length; m++){
                    var v = t1[m], g = Array.isArray(h) ? h[m - 1] : h.type, x = u.parse(v, 1 + y.length, g);
                    if (!x) {
                        d = !0;
                        break;
                    }
                    y.push(x);
                }
                if (!d) {
                    if (Array.isArray(h) && h.length !== y.length) u.error("Expected " + h.length + " arguments, but found " + y.length + " instead.");
                    else {
                        for(var b = 0; b < y.length; b++){
                            var w = Array.isArray(h) ? h[b] : h.type, _ = y[b];
                            u.concat(b + 1).checkSubtype(w, _.type);
                        }
                        if (0 === u.errors.length) return new xe(n, a, f, y);
                    }
                }
            }
            if (1 === s.length) (r = e1.errors).push.apply(r, u.errors);
            else {
                for(var A = (s.length ? s : o).map(function(t1) {
                    var e1;
                    return e1 = t1[0], Array.isArray(e1) ? "(" + e1.map(Jt).join(", ") + ")" : "(" + Jt(e1.type) + "...)";
                }).join(" | "), S = [], k = 1; k < t1.length; k++){
                    var I = e1.parse(t1[k], 1 + S.length);
                    if (!I) return null;
                    S.push(Jt(I.type));
                }
                e1.error("Expected arguments of type " + A + ", but found (" + S.join(", ") + ") instead.");
            }
            return null;
        }, xe.register = function(t1, e1) {
            for(var r in xe.definitions = e1, e1)t1[r] = xe;
        };
        var be = function(t1, e1, r) {
            this.type = Kt, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
        };
        function we(t1, e1) {
            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
        }
        function _e(t1, e1) {
            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
        }
        function Ae(t1, e1) {
            var r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(r * i * 8192),
                Math.round(n * i * 8192)
            ];
        }
        function Se(t1, e1, r) {
            return e1[1] > t1[1] != r[1] > t1[1] && t1[0] < (r[0] - e1[0]) * (t1[1] - e1[1]) / (r[1] - e1[1]) + e1[0];
        }
        function ke(t1, e1) {
            for(var r, n, i, a, o, s, u, l = !1, p = 0, c = e1.length; p < c; p++)for(var h = e1[p], f = 0, y = h.length; f < y - 1; f++){
                if ((a = (r = t1)[0] - (n = h[f])[0]) * (u = r[1] - (i = h[f + 1])[1]) - (s = r[0] - i[0]) * (o = r[1] - n[1]) == 0 && a * s <= 0 && o * u <= 0) return !1;
                Se(t1, h[f], h[f + 1]) && (l = !l);
            }
            return l;
        }
        function Ie(t1, e1) {
            for(var r = 0; r < e1.length; r++)if (ke(t1, e1[r])) return !0;
            return !1;
        }
        function ze(t1, e1, r, n) {
            var i = n[0] - r[0], a = n[1] - r[1], o = (t1[0] - r[0]) * a - i * (t1[1] - r[1]), s = (e1[0] - r[0]) * a - i * (e1[1] - r[1]);
            return o > 0 && s < 0 || o < 0 && s > 0;
        }
        function Ce(t1, e1, r) {
            for(var n = 0, i = r; n < i.length; n += 1)for(var a = i[n], o = 0; o < a.length - 1; ++o)if (0 != (c = [
                (p = a[o + 1])[0] - (l = a[o])[0],
                p[1] - l[1]
            ])[0] * (h = [
                (u = e1)[0] - (s = t1)[0],
                u[1] - s[1]
            ])[1] - c[1] * h[0] && ze(s, u, l, p) && ze(l, p, s, u)) return !0;
            var s, u, l, p, c, h;
            return !1;
        }
        function Ee(t1, e1) {
            for(var r = 0; r < t1.length; ++r)if (!ke(t1[r], e1)) return !1;
            for(var n = 0; n < t1.length - 1; ++n)if (Ce(t1[n], t1[n + 1], e1)) return !1;
            return !0;
        }
        function Pe(t1, e1) {
            for(var r = 0; r < e1.length; r++)if (Ee(t1, e1[r])) return !0;
            return !1;
        }
        function Me(t1, e1, r) {
            for(var n = [], i = 0; i < t1.length; i++){
                for(var a = [], o = 0; o < t1[i].length; o++){
                    var s = Ae(t1[i][o], r);
                    we(e1, s), a.push(s);
                }
                n.push(a);
            }
            return n;
        }
        function Be(t1, e1, r) {
            for(var n = [], i = 0; i < t1.length; i++){
                var a = Me(t1[i], e1, r);
                n.push(a);
            }
            return n;
        }
        function Te(t1, e1, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                var i = .5 * n, a = t1[0] - r[0] > i ? -n : r[0] - t1[0] > i ? n : 0;
                0 === a && (a = t1[0] - r[2] > i ? -n : r[2] - t1[0] > i ? n : 0), t1[0] += a;
            }
            we(e1, t1);
        }
        function Ve(t1, e1, r, n) {
            for(var i = 8192 * Math.pow(2, n.z), a = [
                8192 * n.x,
                8192 * n.y
            ], o = [], s = 0, u = t1; s < u.length; s += 1)for(var l = 0, p = u[s]; l < p.length; l += 1){
                var c = p[l], h = [
                    c.x + a[0],
                    c.y + a[1]
                ];
                Te(h, e1, r, i), o.push(h);
            }
            return o;
        }
        function Fe(t1, e1, r, n) {
            for(var i, a = 8192 * Math.pow(2, n.z), o = [
                8192 * n.x,
                8192 * n.y
            ], s = [], u = 0, l = t1; u < l.length; u += 1){
                for(var p = [], c = 0, h = l[u]; c < h.length; c += 1){
                    var f = h[c], y = [
                        f.x + o[0],
                        f.y + o[1]
                    ];
                    we(e1, y), p.push(y);
                }
                s.push(p);
            }
            if (e1[2] - e1[0] <= a / 2) {
                (i = e1)[0] = i[1] = 1 / 0, i[2] = i[3] = -1 / 0;
                for(var d = 0, m = s; d < m.length; d += 1)for(var v = 0, g = m[d]; v < g.length; v += 1)Te(g[v], e1, r, a);
            }
            return s;
        }
        be.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("Expected one argument.");
            var r = t1[1];
            if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
            var n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, Ut);
            if (!n) return null;
            var i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, Ut);
            if (!i) return null;
            var a = null;
            return r.locale && !(a = e1.parse(r.locale, 1, Rt)) ? null : new be(n, i, a);
        }, be.prototype.evaluate = function(t1) {
            return new ee(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
        }, be.prototype.eachChild = function(t1) {
            t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
        }, be.prototype.outputDefined = function() {
            return !1;
        }, be.prototype.serialize = function() {
            var t1 = {};
            return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                "collator",
                t1
            ];
        };
        var De = function(t1, e1) {
            this.type = Ut, this.geojson = t1, this.geometries = e1;
        };
        function Le(t1) {
            if (t1 instanceof xe) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof De) return !1;
            var e1 = !0;
            return t1.eachChild(function(t1) {
                e1 && !Le(t1) && (e1 = !1);
            }), e1;
        }
        function Oe(t1) {
            if (t1 instanceof xe && "feature-state" === t1.name) return !1;
            var e1 = !0;
            return t1.eachChild(function(t1) {
                e1 && !Oe(t1) && (e1 = !1);
            }), e1;
        }
        function Re(t1, e1) {
            if (t1 instanceof xe && e1.indexOf(t1.name) >= 0) return !1;
            var r = !0;
            return t1.eachChild(function(t1) {
                r && !Re(t1, e1) && (r = !1);
            }), r;
        }
        De.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("'within' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
            if (oe(t1[1])) {
                var r = t1[1];
                if ("FeatureCollection" === r.type) for(var n = 0; n < r.features.length; ++n){
                    var i = r.features[n].geometry.type;
                    if ("Polygon" === i || "MultiPolygon" === i) return new De(r, r.features[n].geometry);
                }
                else if ("Feature" === r.type) {
                    var a = r.geometry.type;
                    if ("Polygon" === a || "MultiPolygon" === a) return new De(r, r.geometry);
                } else if ("Polygon" === r.type || "MultiPolygon" === r.type) return new De(r, r);
            }
            return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }, De.prototype.evaluate = function(t1) {
            if (null != t1.geometry() && null != t1.canonicalID()) {
                if ("Point" === t1.geometryType()) return function(t1, e1) {
                    var r = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], i = t1.canonicalID();
                    if ("Polygon" === e1.type) {
                        var a = Me(e1.coordinates, n, i), o = Ve(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var s = 0, u = o; s < u.length; s += 1)if (!ke(u[s], a)) return !1;
                    }
                    if ("MultiPolygon" === e1.type) {
                        var l = Be(e1.coordinates, n, i), p = Ve(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var c = 0, h = p; c < h.length; c += 1)if (!Ie(h[c], l)) return !1;
                    }
                    return !0;
                }(t1, this.geometries);
                if ("LineString" === t1.geometryType()) return function(t1, e1) {
                    var r = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], i = t1.canonicalID();
                    if ("Polygon" === e1.type) {
                        var a = Me(e1.coordinates, n, i), o = Fe(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var s = 0, u = o; s < u.length; s += 1)if (!Ee(u[s], a)) return !1;
                    }
                    if ("MultiPolygon" === e1.type) {
                        var l = Be(e1.coordinates, n, i), p = Fe(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var c = 0, h = p; c < h.length; c += 1)if (!Pe(h[c], l)) return !1;
                    }
                    return !0;
                }(t1, this.geometries);
            }
            return !1;
        }, De.prototype.eachChild = function() {}, De.prototype.outputDefined = function() {
            return !0;
        }, De.prototype.serialize = function() {
            return [
                "within",
                this.geojson
            ];
        };
        var Ue = function(t1, e1) {
            this.type = e1.type, this.name = t1, this.boundExpression = e1;
        };
        Ue.parse = function(t1, e1) {
            if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
            var r = t1[1];
            return e1.scope.has(r) ? new Ue(r, e1.scope.get(r)) : e1.error('Unknown variable "' + r + '". Make sure "' + r + '" has been bound in an enclosing "let" expression before using it.', 1);
        }, Ue.prototype.evaluate = function(t1) {
            return this.boundExpression.evaluate(t1);
        }, Ue.prototype.eachChild = function() {}, Ue.prototype.outputDefined = function() {
            return !1;
        }, Ue.prototype.serialize = function() {
            return [
                "var",
                this.name
            ];
        };
        var je = function(t1, e1, r, n, i) {
            void 0 === e1 && (e1 = []), void 0 === n && (n = new Dt), void 0 === i && (i = []), this.registry = t1, this.path = e1, this.key = e1.map(function(t1) {
                return "[" + t1 + "]";
            }).join(""), this.scope = n, this.errors = i, this.expectedType = r;
        };
        function qe(t1, e1) {
            for(var r, n = t1.length - 1, i = 0, a = n, o = 0; i <= a;)if ((r = t1[o = Math.floor((i + a) / 2)]) <= e1) {
                if (o === n || e1 < t1[o + 1]) return o;
                i = o + 1;
            } else {
                if (!(r > e1)) throw new pe("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        je.prototype.parse = function(t1, e1, r, n, i) {
            return void 0 === i && (i = {}), e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
        }, je.prototype._parse = function(t1, e1) {
            function r(t1, e1, r) {
                return "assert" === r ? new he(e1, [
                    t1
                ]) : "coerce" === r ? new me(e1, [
                    t1
                ]) : t1;
            }
            if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                "literal",
                t1
            ]), Array.isArray(t1)) {
                if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                var n = t1[0];
                if ("string" != typeof n) return this.error("Expression name must be a string, but found " + typeof n + ' instead. If you wanted a literal array, use ["literal", [...]].', 0), null;
                var i = this.registry[n];
                if (i) {
                    var a = i.parse(t1, this);
                    if (!a) return null;
                    if (this.expectedType) {
                        var o = this.expectedType, s = a.type;
                        if ("string" !== o.kind && "number" !== o.kind && "boolean" !== o.kind && "object" !== o.kind && "array" !== o.kind || "value" !== s.kind) {
                            if ("color" !== o.kind && "formatted" !== o.kind && "resolvedImage" !== o.kind || "value" !== s.kind && "string" !== s.kind) {
                                if (this.checkSubtype(o, s)) return null;
                            } else a = r(a, o, e1.typeAnnotation || "coerce");
                        } else a = r(a, o, e1.typeAnnotation || "assert");
                    }
                    if (!(a instanceof le) && "resolvedImage" !== a.type.kind && function t1(e1) {
                        if (e1 instanceof Ue) return t1(e1.boundExpression);
                        if (e1 instanceof xe && "error" === e1.name) return !1;
                        if (e1 instanceof be) return !1;
                        if (e1 instanceof De) return !1;
                        var r = e1 instanceof me || e1 instanceof he, n = !0;
                        return e1.eachChild(function(e1) {
                            n = r ? n && t1(e1) : n && e1 instanceof le;
                        }), !!n && Le(e1) && Re(e1, [
                            "zoom",
                            "heatmap-density",
                            "line-progress",
                            "accumulated",
                            "is-supported-script"
                        ]);
                    }(a)) {
                        var u = new ge;
                        try {
                            a = new le(a.type, a.evaluate(u));
                        } catch (t1) {
                            return this.error(t1.message), null;
                        }
                    }
                    return a;
                }
                return this.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
            }
            return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : "Expected an array, but found " + typeof t1 + " instead.");
        }, je.prototype.concat = function(t1, e1, r) {
            var n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
            return new je(this.registry, n, e1 || null, i, this.errors);
        }, je.prototype.error = function(t1) {
            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
            var n = "" + this.key + e1.map(function(t1) {
                return "[" + t1 + "]";
            }).join("");
            this.errors.push(new Ft(n, t1));
        }, je.prototype.checkSubtype = function(t1, e1) {
            var r = Yt(t1, e1);
            return r && this.error(r), r;
        };
        var Ne = function(t1, e1, r) {
            this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
            for(var n = 0, i = r; n < i.length; n += 1){
                var a = i[n], o = a[1];
                this.labels.push(a[0]), this.outputs.push(o);
            }
        };
        function Ke(t1, e1, r) {
            return t1 * (1 - r) + e1 * r;
        }
        Ne.parse = function(t1, e1) {
            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
            var r = e1.parse(t1[1], 1, Ot);
            if (!r) return null;
            var n = [], i = null;
            e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
            for(var a = 1; a < t1.length; a += 2){
                var o = 1 === a ? -1 / 0 : t1[a], s = t1[a + 1], u = a, l = a + 1;
                if ("number" != typeof o) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', u);
                if (n.length && n[n.length - 1][0] >= o) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', u);
                var p = e1.parse(s, l, i);
                if (!p) return null;
                i = i || p.type, n.push([
                    o,
                    p
                ]);
            }
            return new Ne(i, r, n);
        }, Ne.prototype.evaluate = function(t1) {
            var e1 = this.labels, r = this.outputs;
            if (1 === e1.length) return r[0].evaluate(t1);
            var n = this.input.evaluate(t1);
            if (n <= e1[0]) return r[0].evaluate(t1);
            var i = e1.length;
            return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[qe(e1, n)].evaluate(t1);
        }, Ne.prototype.eachChild = function(t1) {
            t1(this.input);
            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
        }, Ne.prototype.outputDefined = function() {
            return this.outputs.every(function(t1) {
                return t1.outputDefined();
            });
        }, Ne.prototype.serialize = function() {
            for(var t1 = [
                "step",
                this.input.serialize()
            ], e1 = 0; e1 < this.labels.length; e1++)e1 > 0 && t1.push(this.labels[e1]), t1.push(this.outputs[e1].serialize());
            return t1;
        };
        var Ge = Object.freeze({
            __proto__: null,
            number: Ke,
            color: function(t1, e1, r) {
                return new te(Ke(t1.r, e1.r, r), Ke(t1.g, e1.g, r), Ke(t1.b, e1.b, r), Ke(t1.a, e1.a, r));
            },
            array: function(t1, e1, r) {
                return t1.map(function(t1, n) {
                    return Ke(t1, e1[n], r);
                });
            }
        }), Ze = 6 / 29 * 3 * (6 / 29), Xe = Math.PI / 180, Je = 180 / Math.PI;
        function He(t1) {
            return t1 > .008856451679035631 ? Math.pow(t1, 1 / 3) : t1 / Ze + 4 / 29;
        }
        function Ye(t1) {
            return t1 > 6 / 29 ? t1 * t1 * t1 : Ze * (t1 - 4 / 29);
        }
        function $e(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function We(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Qe(t1) {
            var e1 = We(t1.r), r = We(t1.g), n = We(t1.b), i = He((.4124564 * e1 + .3575761 * r + .1804375 * n) / .95047), a = He((.2126729 * e1 + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * a - 16,
                a: 500 * (i - a),
                b: 200 * (a - He((.0193339 * e1 + .119192 * r + .9503041 * n) / 1.08883)),
                alpha: t1.a
            };
        }
        function tr(t1) {
            var e1 = (t1.l + 16) / 116, r = isNaN(t1.a) ? e1 : e1 + t1.a / 500, n = isNaN(t1.b) ? e1 : e1 - t1.b / 200;
            return e1 = 1 * Ye(e1), r = .95047 * Ye(r), n = 1.08883 * Ye(n), new te($e(3.2404542 * r - 1.5371385 * e1 - .4985314 * n), $e(-0.969266 * r + 1.8760108 * e1 + .041556 * n), $e(.0556434 * r - .2040259 * e1 + 1.0572252 * n), t1.alpha);
        }
        function er(t1, e1, r) {
            var n = e1 - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        var rr = {
            forward: Qe,
            reverse: tr,
            interpolate: function(t1, e1, r) {
                return {
                    l: Ke(t1.l, e1.l, r),
                    a: Ke(t1.a, e1.a, r),
                    b: Ke(t1.b, e1.b, r),
                    alpha: Ke(t1.alpha, e1.alpha, r)
                };
            }
        }, nr = {
            forward: function(t1) {
                var e1 = Qe(t1), r = e1.l, n = e1.a, i = e1.b, a = Math.atan2(i, n) * Je;
                return {
                    h: a < 0 ? a + 360 : a,
                    c: Math.sqrt(n * n + i * i),
                    l: r,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                var e1 = t1.h * Xe, r = t1.c;
                return tr({
                    l: t1.l,
                    a: Math.cos(e1) * r,
                    b: Math.sin(e1) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e1, r) {
                return {
                    h: er(t1.h, e1.h, r),
                    c: Ke(t1.c, e1.c, r),
                    l: Ke(t1.l, e1.l, r),
                    alpha: Ke(t1.alpha, e1.alpha, r)
                };
            }
        }, ir = Object.freeze({
            __proto__: null,
            lab: rr,
            hcl: nr
        }), ar = function(t1, e1, r, n, i) {
            this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
            for(var a = 0, o = i; a < o.length; a += 1){
                var s = o[a], u = s[1];
                this.labels.push(s[0]), this.outputs.push(u);
            }
        };
        function or(t1, e1, r, n) {
            var i = n - r, a = t1 - r;
            return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
        }
        ar.interpolationFactor = function(t1, e1, n, i) {
            var a = 0;
            if ("exponential" === t1.name) a = or(e1, t1.base, n, i);
            else if ("linear" === t1.name) a = or(e1, 1, n, i);
            else if ("cubic-bezier" === t1.name) {
                var o = t1.controlPoints;
                a = new r(o[0], o[1], o[2], o[3]).solve(or(e1, 1, n, i));
            }
            return a;
        }, ar.parse = function(t1, e1) {
            var r = t1[0], n = t1[1], i = t1[2], a = t1.slice(3);
            if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
            if ("linear" === n[0]) n = {
                name: "linear"
            };
            else if ("exponential" === n[0]) {
                var o = n[1];
                if ("number" != typeof o) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                n = {
                    name: "exponential",
                    base: o
                };
            } else {
                if ("cubic-bezier" !== n[0]) return e1.error("Unknown interpolation type " + String(n[0]), 1, 0);
                var s = n.slice(1);
                if (4 !== s.length || s.some(function(t1) {
                    return "number" != typeof t1 || t1 < 0 || t1 > 1;
                })) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                n = {
                    name: "cubic-bezier",
                    controlPoints: s
                };
            }
            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
            if (!(i = e1.parse(i, 2, Ot))) return null;
            var u = [], l = null;
            "interpolate-hcl" === r || "interpolate-lab" === r ? l = jt : e1.expectedType && "value" !== e1.expectedType.kind && (l = e1.expectedType);
            for(var p = 0; p < a.length; p += 2){
                var c = a[p], h = a[p + 1], f = p + 3, y = p + 4;
                if ("number" != typeof c) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', f);
                if (u.length && u[u.length - 1][0] >= c) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', f);
                var d = e1.parse(h, y, l);
                if (!d) return null;
                l = l || d.type, u.push([
                    c,
                    d
                ]);
            }
            return "number" === l.kind || "color" === l.kind || "array" === l.kind && "number" === l.itemType.kind && "number" == typeof l.N ? new ar(l, r, n, i, u) : e1.error("Type " + Jt(l) + " is not interpolatable.");
        }, ar.prototype.evaluate = function(t1) {
            var e1 = this.labels, r = this.outputs;
            if (1 === e1.length) return r[0].evaluate(t1);
            var n = this.input.evaluate(t1);
            if (n <= e1[0]) return r[0].evaluate(t1);
            var i = e1.length;
            if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
            var a = qe(e1, n), o = ar.interpolationFactor(this.interpolation, n, e1[a], e1[a + 1]), s = r[a].evaluate(t1), u = r[a + 1].evaluate(t1);
            return "interpolate" === this.operator ? Ge[this.type.kind.toLowerCase()](s, u, o) : "interpolate-hcl" === this.operator ? nr.reverse(nr.interpolate(nr.forward(s), nr.forward(u), o)) : rr.reverse(rr.interpolate(rr.forward(s), rr.forward(u), o));
        }, ar.prototype.eachChild = function(t1) {
            t1(this.input);
            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
        }, ar.prototype.outputDefined = function() {
            return this.outputs.every(function(t1) {
                return t1.outputDefined();
            });
        }, ar.prototype.serialize = function() {
            var t1;
            t1 = "linear" === this.interpolation.name ? [
                "linear"
            ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                "linear"
            ] : [
                "exponential",
                this.interpolation.base
            ] : [
                "cubic-bezier"
            ].concat(this.interpolation.controlPoints);
            for(var e1 = [
                this.operator,
                t1,
                this.input.serialize()
            ], r = 0; r < this.labels.length; r++)e1.push(this.labels[r], this.outputs[r].serialize());
            return e1;
        };
        var sr = function(t1, e1) {
            this.type = t1, this.args = e1;
        };
        sr.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expectected at least one argument.");
            var r = null, n = e1.expectedType;
            n && "value" !== n.kind && (r = n);
            for(var i = [], a = 0, o = t1.slice(1); a < o.length; a += 1){
                var s = e1.parse(o[a], 1 + i.length, r, void 0, {
                    typeAnnotation: "omit"
                });
                if (!s) return null;
                r = r || s.type, i.push(s);
            }
            var u = n && i.some(function(t1) {
                return Yt(n, t1.type);
            });
            return new sr(u ? Nt : r, i);
        }, sr.prototype.evaluate = function(t1) {
            for(var e1, r = null, n = 0, i = 0, a = this.args; i < a.length && (n++, (r = a[i].evaluate(t1)) && r instanceof ie && !r.available && (e1 || (e1 = r.name), r = null, n === this.args.length && (r = e1)), null === r); i += 1);
            return r;
        }, sr.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, sr.prototype.outputDefined = function() {
            return this.args.every(function(t1) {
                return t1.outputDefined();
            });
        }, sr.prototype.serialize = function() {
            var t1 = [
                "coalesce"
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var ur = function(t1, e1) {
            this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
        };
        ur.prototype.evaluate = function(t1) {
            return this.result.evaluate(t1);
        }, ur.prototype.eachChild = function(t1) {
            for(var e1 = 0, r = this.bindings; e1 < r.length; e1 += 1)t1(r[e1][1]);
            t1(this.result);
        }, ur.parse = function(t1, e1) {
            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found " + (t1.length - 1) + " instead.");
            for(var r = [], n = 1; n < t1.length - 1; n += 2){
                var i = t1[n];
                if ("string" != typeof i) return e1.error("Expected string, but found " + typeof i + " instead.", n);
                if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                var a = e1.parse(t1[n + 1], n + 1);
                if (!a) return null;
                r.push([
                    i,
                    a
                ]);
            }
            var o = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
            return o ? new ur(r, o) : null;
        }, ur.prototype.outputDefined = function() {
            return this.result.outputDefined();
        }, ur.prototype.serialize = function() {
            for(var t1 = [
                "let"
            ], e1 = 0, r = this.bindings; e1 < r.length; e1 += 1){
                var n = r[e1];
                t1.push(n[0], n[1].serialize());
            }
            return t1.push(this.result.serialize()), t1;
        };
        var lr = function(t1, e1, r) {
            this.type = t1, this.index = e1, this.input = r;
        };
        lr.parse = function(t1, e1) {
            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Ot), n = e1.parse(t1[2], 2, Xt(e1.expectedType || Nt));
            return r && n ? new lr(n.type.itemType, r, n) : null;
        }, lr.prototype.evaluate = function(t1) {
            var e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
            if (e1 < 0) throw new pe("Array index out of bounds: " + e1 + " < 0.");
            if (e1 >= r.length) throw new pe("Array index out of bounds: " + e1 + " > " + (r.length - 1) + ".");
            if (e1 !== Math.floor(e1)) throw new pe("Array index must be an integer, but found " + e1 + " instead.");
            return r[e1];
        }, lr.prototype.eachChild = function(t1) {
            t1(this.index), t1(this.input);
        }, lr.prototype.outputDefined = function() {
            return !1;
        }, lr.prototype.serialize = function() {
            return [
                "at",
                this.index.serialize(),
                this.input.serialize()
            ];
        };
        var pr = function(t1, e1) {
            this.type = Ut, this.needle = t1, this.haystack = e1;
        };
        pr.parse = function(t1, e1) {
            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Nt), n = e1.parse(t1[2], 2, Nt);
            return r && n ? $t(r.type, [
                Ut,
                Rt,
                Ot,
                Lt,
                Nt
            ]) ? new pr(r, n) : e1.error("Expected first argument to be of type boolean, string, number or null, but found " + Jt(r.type) + " instead") : null;
        }, pr.prototype.evaluate = function(t1) {
            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
            if (!r) return !1;
            if (!Wt(e1, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new pe("Expected first argument to be of type boolean, string, number or null, but found " + Jt(se(e1)) + " instead.");
            if (!Wt(r, [
                "string",
                "array"
            ])) throw new pe("Expected second argument to be of type array or string, but found " + Jt(se(r)) + " instead.");
            return r.indexOf(e1) >= 0;
        }, pr.prototype.eachChild = function(t1) {
            t1(this.needle), t1(this.haystack);
        }, pr.prototype.outputDefined = function() {
            return !0;
        }, pr.prototype.serialize = function() {
            return [
                "in",
                this.needle.serialize(),
                this.haystack.serialize()
            ];
        };
        var cr = function(t1, e1, r) {
            this.type = Ot, this.needle = t1, this.haystack = e1, this.fromIndex = r;
        };
        cr.parse = function(t1, e1) {
            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Nt), n = e1.parse(t1[2], 2, Nt);
            if (!r || !n) return null;
            if (!$t(r.type, [
                Ut,
                Rt,
                Ot,
                Lt,
                Nt
            ])) return e1.error("Expected first argument to be of type boolean, string, number or null, but found " + Jt(r.type) + " instead");
            if (4 === t1.length) {
                var i = e1.parse(t1[3], 3, Ot);
                return i ? new cr(r, n, i) : null;
            }
            return new cr(r, n);
        }, cr.prototype.evaluate = function(t1) {
            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
            if (!Wt(e1, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new pe("Expected first argument to be of type boolean, string, number or null, but found " + Jt(se(e1)) + " instead.");
            if (!Wt(r, [
                "string",
                "array"
            ])) throw new pe("Expected second argument to be of type array or string, but found " + Jt(se(r)) + " instead.");
            if (this.fromIndex) {
                var n = this.fromIndex.evaluate(t1);
                return r.indexOf(e1, n);
            }
            return r.indexOf(e1);
        }, cr.prototype.eachChild = function(t1) {
            t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
        }, cr.prototype.outputDefined = function() {
            return !1;
        }, cr.prototype.serialize = function() {
            if (null != this.fromIndex && void 0 !== this.fromIndex) {
                var t1 = this.fromIndex.serialize();
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize(),
                    t1
                ];
            }
            return [
                "index-of",
                this.needle.serialize(),
                this.haystack.serialize()
            ];
        };
        var hr = function(t1, e1, r, n, i, a) {
            this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
        };
        hr.parse = function(t1, e1) {
            if (t1.length < 5) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
            if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
            var r, n;
            e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
            for(var i = {}, a = [], o = 2; o < t1.length - 1; o += 2){
                var s = t1[o], u = t1[o + 1];
                Array.isArray(s) || (s = [
                    s
                ]);
                var l = e1.concat(o);
                if (0 === s.length) return l.error("Expected at least one branch label.");
                for(var p = 0, c = s; p < c.length; p += 1){
                    var h = c[p];
                    if ("number" != typeof h && "string" != typeof h) return l.error("Branch labels must be numbers or strings.");
                    if ("number" == typeof h && Math.abs(h) > Number.MAX_SAFE_INTEGER) return l.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
                    if ("number" == typeof h && Math.floor(h) !== h) return l.error("Numeric branch labels must be integer values.");
                    if (r) {
                        if (l.checkSubtype(r, se(h))) return null;
                    } else r = se(h);
                    if (void 0 !== i[String(h)]) return l.error("Branch labels must be unique.");
                    i[String(h)] = a.length;
                }
                var f = e1.parse(u, o, n);
                if (!f) return null;
                n = n || f.type, a.push(f);
            }
            var y = e1.parse(t1[1], 1, Nt);
            if (!y) return null;
            var d = e1.parse(t1[t1.length - 1], t1.length - 1, n);
            return d ? "value" !== y.type.kind && e1.concat(1).checkSubtype(r, y.type) ? null : new hr(r, n, y, i, a, d) : null;
        }, hr.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1);
            return (se(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
        }, hr.prototype.eachChild = function(t1) {
            t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
        }, hr.prototype.outputDefined = function() {
            return this.outputs.every(function(t1) {
                return t1.outputDefined();
            }) && this.otherwise.outputDefined();
        }, hr.prototype.serialize = function() {
            for(var t1 = this, e1 = [
                "match",
                this.input.serialize()
            ], r = [], n = {}, i = 0, a = Object.keys(this.cases).sort(); i < a.length; i += 1){
                var o = a[i];
                void 0 === (c = n[this.cases[o]]) ? (n[this.cases[o]] = r.length, r.push([
                    this.cases[o],
                    [
                        o
                    ]
                ])) : r[c][1].push(o);
            }
            for(var s = function(e1) {
                return "number" === t1.inputType.kind ? Number(e1) : e1;
            }, u = 0, l = r; u < l.length; u += 1){
                var p = l[u], c = p[0], h = p[1];
                e1.push(1 === h.length ? s(h[0]) : h.map(s)), e1.push(this.outputs[outputIndex$1].serialize());
            }
            return e1.push(this.otherwise.serialize()), e1;
        };
        var fr = function(t1, e1, r) {
            this.type = t1, this.branches = e1, this.otherwise = r;
        };
        fr.parse = function(t1, e1) {
            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found only " + (t1.length - 1) + ".");
            if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
            var r;
            e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
            for(var n = [], i = 1; i < t1.length - 1; i += 2){
                var a = e1.parse(t1[i], i, Ut);
                if (!a) return null;
                var o = e1.parse(t1[i + 1], i + 1, r);
                if (!o) return null;
                n.push([
                    a,
                    o
                ]), r = r || o.type;
            }
            var s = e1.parse(t1[t1.length - 1], t1.length - 1, r);
            return s ? new fr(r, n, s) : null;
        }, fr.prototype.evaluate = function(t1) {
            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                var n = r[e1], i = n[1];
                if (n[0].evaluate(t1)) return i.evaluate(t1);
            }
            return this.otherwise.evaluate(t1);
        }, fr.prototype.eachChild = function(t1) {
            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                var n = r[e1], i = n[1];
                t1(n[0]), t1(i);
            }
            t1(this.otherwise);
        }, fr.prototype.outputDefined = function() {
            return this.branches.every(function(t1) {
                return t1[1].outputDefined();
            }) && this.otherwise.outputDefined();
        }, fr.prototype.serialize = function() {
            var t1 = [
                "case"
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var yr = function(t1, e1, r, n) {
            this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
        };
        function dr(t1, e1) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function mr(t1, e1, r, n) {
            return 0 === n.compare(e1, r);
        }
        function vr(t1, e1, r) {
            var n = "==" !== t1 && "!=" !== t1;
            return function() {
                function i(t1, e1, r) {
                    this.type = Ut, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                }
                return i.parse = function(t1, e1) {
                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                    var r = t1[0], a = e1.parse(t1[1], 1, Nt);
                    if (!a) return null;
                    if (!dr(r, a.type)) return e1.concat(1).error('"' + r + "\" comparisons are not supported for type '" + Jt(a.type) + "'.");
                    var o = e1.parse(t1[2], 2, Nt);
                    if (!o) return null;
                    if (!dr(r, o.type)) return e1.concat(2).error('"' + r + "\" comparisons are not supported for type '" + Jt(o.type) + "'.");
                    if (a.type.kind !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot compare types '" + Jt(a.type) + "' and '" + Jt(o.type) + "'.");
                    n && ("value" === a.type.kind && "value" !== o.type.kind ? a = new he(o.type, [
                        a
                    ]) : "value" !== a.type.kind && "value" === o.type.kind && (o = new he(a.type, [
                        o
                    ])));
                    var s = null;
                    if (4 === t1.length) {
                        if ("string" !== a.type.kind && "string" !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                        if (!(s = e1.parse(t1[3], 3, Kt))) return null;
                    }
                    return new i(a, o, s);
                }, i.prototype.evaluate = function(i) {
                    var a = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        var s = se(a), u = se(o);
                        if (s.kind !== u.kind || "string" !== s.kind && "number" !== s.kind) throw new pe('Expected arguments for "' + t1 + '" to be (string, string) or (number, number), but found (' + s.kind + ", " + u.kind + ") instead.");
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        var l = se(a), p = se(o);
                        if ("string" !== l.kind || "string" !== p.kind) return e1(i, a, o);
                    }
                    return this.collator ? r(i, a, o, this.collator.evaluate(i)) : e1(i, a, o);
                }, i.prototype.eachChild = function(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }, i.prototype.outputDefined = function() {
                    return !0;
                }, i.prototype.serialize = function() {
                    var e1 = [
                        t1
                    ];
                    return this.eachChild(function(t1) {
                        e1.push(t1.serialize());
                    }), e1;
                }, i;
            }();
        }
        yr.parse = function(t1, e1) {
            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Nt), n = e1.parse(t1[2], 2, Ot);
            if (!r || !n) return null;
            if (!$t(r.type, [
                Xt(Nt),
                Rt,
                Nt
            ])) return e1.error("Expected first argument to be of type array or string, but found " + Jt(r.type) + " instead");
            if (4 === t1.length) {
                var i = e1.parse(t1[3], 3, Ot);
                return i ? new yr(r.type, r, n, i) : null;
            }
            return new yr(r.type, r, n);
        }, yr.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
            if (!Wt(e1, [
                "string",
                "array"
            ])) throw new pe("Expected first argument to be of type array or string, but found " + Jt(se(e1)) + " instead.");
            if (this.endIndex) {
                var n = this.endIndex.evaluate(t1);
                return e1.slice(r, n);
            }
            return e1.slice(r);
        }, yr.prototype.eachChild = function(t1) {
            t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
        }, yr.prototype.outputDefined = function() {
            return !1;
        }, yr.prototype.serialize = function() {
            if (null != this.endIndex && void 0 !== this.endIndex) {
                var t1 = this.endIndex.serialize();
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize(),
                    t1
                ];
            }
            return [
                "slice",
                this.input.serialize(),
                this.beginIndex.serialize()
            ];
        };
        var gr = vr("==", function(t1, e1, r) {
            return e1 === r;
        }, mr), xr = vr("!=", function(t1, e1, r) {
            return e1 !== r;
        }, function(t1, e1, r, n) {
            return !mr(0, e1, r, n);
        }), br = vr("<", function(t1, e1, r) {
            return e1 < r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) < 0;
        }), wr = vr(">", function(t1, e1, r) {
            return e1 > r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) > 0;
        }), _r = vr("<=", function(t1, e1, r) {
            return e1 <= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) <= 0;
        }), Ar = vr(">=", function(t1, e1, r) {
            return e1 >= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) >= 0;
        }), Sr = function(t1, e1, r, n, i) {
            this.type = Rt, this.number = t1, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
        };
        Sr.parse = function(t1, e1) {
            if (3 !== t1.length) return e1.error("Expected two arguments.");
            var r = e1.parse(t1[1], 1, Ot);
            if (!r) return null;
            var n = t1[2];
            if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
            var i = null;
            if (n.locale && !(i = e1.parse(n.locale, 1, Rt))) return null;
            var a = null;
            if (n.currency && !(a = e1.parse(n.currency, 1, Rt))) return null;
            var o = null;
            if (n["min-fraction-digits"] && !(o = e1.parse(n["min-fraction-digits"], 1, Ot))) return null;
            var s = null;
            return n["max-fraction-digits"] && !(s = e1.parse(n["max-fraction-digits"], 1, Ot)) ? null : new Sr(r, i, a, o, s);
        }, Sr.prototype.evaluate = function(t1) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                style: this.currency ? "currency" : "decimal",
                currency: this.currency ? this.currency.evaluate(t1) : void 0,
                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
            }).format(this.number.evaluate(t1));
        }, Sr.prototype.eachChild = function(t1) {
            t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
        }, Sr.prototype.outputDefined = function() {
            return !1;
        }, Sr.prototype.serialize = function() {
            var t1 = {};
            return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                "number-format",
                this.number.serialize(),
                t1
            ];
        };
        var kr = function(t1) {
            this.type = Ot, this.input = t1;
        };
        kr.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("Expected 1 argument, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1);
            return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error("Expected argument of type string or array, but found " + Jt(r.type) + " instead.") : new kr(r) : null;
        }, kr.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1);
            if ("string" == typeof e1) return e1.length;
            if (Array.isArray(e1)) return e1.length;
            throw new pe("Expected value to be of type string or array, but found " + Jt(se(e1)) + " instead.");
        }, kr.prototype.eachChild = function(t1) {
            t1(this.input);
        }, kr.prototype.outputDefined = function() {
            return !1;
        }, kr.prototype.serialize = function() {
            var t1 = [
                "length"
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var Ir = {
            "==": gr,
            "!=": xr,
            ">": wr,
            "<": br,
            ">=": Ar,
            "<=": _r,
            array: he,
            at: lr,
            boolean: he,
            case: fr,
            coalesce: sr,
            collator: be,
            format: fe,
            image: ye,
            in: pr,
            "index-of": cr,
            interpolate: ar,
            "interpolate-hcl": ar,
            "interpolate-lab": ar,
            length: kr,
            let: ur,
            literal: le,
            match: hr,
            number: he,
            "number-format": Sr,
            object: he,
            slice: yr,
            step: Ne,
            string: he,
            "to-boolean": me,
            "to-color": me,
            "to-number": me,
            "to-string": me,
            var: Ue,
            within: De
        };
        function zr(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = e1[3];
            r = r.evaluate(t1), n = n.evaluate(t1), i = i.evaluate(t1);
            var o = a ? a.evaluate(t1) : 1, s = ae(r, n, i, o);
            if (s) throw new pe(s);
            return new te(r / 255 * o, n / 255 * o, i / 255 * o, o);
        }
        function Cr(t1, e1) {
            return t1 in e1;
        }
        function Er(t1, e1) {
            var r = e1[t1];
            return void 0 === r ? null : r;
        }
        function Pr(t1) {
            return {
                type: t1
            };
        }
        function Mr(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function Br(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function Tr(t1) {
            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
        }
        function Vr(t1) {
            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
        }
        function Fr(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function Dr(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        function Lr(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function Or(t1) {
            return t1;
        }
        function Rr(t1, e1, r) {
            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
        }
        function Ur(t1, e1, r, n, i) {
            return Rr(typeof r === i ? n[r] : void 0, t1.default, e1.default);
        }
        function jr(t1, e1, r) {
            if ("number" !== Dr(r)) return Rr(t1.default, e1.default);
            var n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            var i = qe(t1.stops.map(function(t1) {
                return t1[0];
            }), r);
            return t1.stops[i][1];
        }
        function qr(t1, e1, r) {
            var n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== Dr(r)) return Rr(t1.default, e1.default);
            var i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            var a = qe(t1.stops.map(function(t1) {
                return t1[0];
            }), r), o = function(t1, e1, r, n) {
                var i = n - r, a = t1 - r;
                return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), s = t1.stops[a][1], u = t1.stops[a + 1][1], l = Ge[e1.type] || Or;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                var p = ir[t1.colorSpace];
                l = function(t1, e1) {
                    return p.reverse(p.interpolate(p.forward(t1), p.forward(e1), o));
                };
            }
            return "function" == typeof s.evaluate ? {
                evaluate: function() {
                    for(var t1 = [], e1 = arguments.length; e1--;)t1[e1] = arguments[e1];
                    var r = s.evaluate.apply(void 0, t1), n = u.evaluate.apply(void 0, t1);
                    if (void 0 !== r && void 0 !== n) return l(r, n, o);
                }
            } : l(s, u, o);
        }
        function Nr(t1, e1, r) {
            return "color" === e1.type ? r = te.parse(r) : "formatted" === e1.type ? r = ne.fromString(r.toString()) : "resolvedImage" === e1.type ? r = ie.fromString(r.toString()) : Dr(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0), Rr(r, t1.default, e1.default);
        }
        xe.register(Ir, {
            error: [
                {
                    kind: "error"
                },
                [
                    Rt
                ],
                function(t1, e1) {
                    throw new pe(e1[0].evaluate(t1));
                }
            ],
            typeof: [
                Rt,
                [
                    Nt
                ],
                function(t1, e1) {
                    return Jt(se(e1[0].evaluate(t1)));
                }
            ],
            "to-rgba": [
                Xt(Ot, 4),
                [
                    jt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).toArray();
                }
            ],
            rgb: [
                jt,
                [
                    Ot,
                    Ot,
                    Ot
                ],
                zr
            ],
            rgba: [
                jt,
                [
                    Ot,
                    Ot,
                    Ot,
                    Ot
                ],
                zr
            ],
            has: {
                type: Ut,
                overloads: [
                    [
                        [
                            Rt
                        ],
                        function(t1, e1) {
                            return Cr(e1[0].evaluate(t1), t1.properties());
                        }
                    ],
                    [
                        [
                            Rt,
                            qt
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return Cr(e1[0].evaluate(t1), r.evaluate(t1));
                        }
                    ]
                ]
            },
            get: {
                type: Nt,
                overloads: [
                    [
                        [
                            Rt
                        ],
                        function(t1, e1) {
                            return Er(e1[0].evaluate(t1), t1.properties());
                        }
                    ],
                    [
                        [
                            Rt,
                            qt
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return Er(e1[0].evaluate(t1), r.evaluate(t1));
                        }
                    ]
                ]
            },
            "feature-state": [
                Nt,
                [
                    Rt
                ],
                function(t1, e1) {
                    return Er(e1[0].evaluate(t1), t1.featureState || {});
                }
            ],
            properties: [
                qt,
                [],
                function(t1) {
                    return t1.properties();
                }
            ],
            "geometry-type": [
                Rt,
                [],
                function(t1) {
                    return t1.geometryType();
                }
            ],
            id: [
                Nt,
                [],
                function(t1) {
                    return t1.id();
                }
            ],
            zoom: [
                Ot,
                [],
                function(t1) {
                    return t1.globals.zoom;
                }
            ],
            "heatmap-density": [
                Ot,
                [],
                function(t1) {
                    return t1.globals.heatmapDensity || 0;
                }
            ],
            "line-progress": [
                Ot,
                [],
                function(t1) {
                    return t1.globals.lineProgress || 0;
                }
            ],
            accumulated: [
                Nt,
                [],
                function(t1) {
                    return void 0 === t1.globals.accumulated ? null : t1.globals.accumulated;
                }
            ],
            "+": [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    for(var r = 0, n = 0, i = e1; n < i.length; n += 1)r += i[n].evaluate(t1);
                    return r;
                }
            ],
            "*": [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    for(var r = 1, n = 0, i = e1; n < i.length; n += 1)r *= i[n].evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: Ot,
                overloads: [
                    [
                        [
                            Ot,
                            Ot
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return e1[0].evaluate(t1) - r.evaluate(t1);
                        }
                    ],
                    [
                        [
                            Ot
                        ],
                        function(t1, e1) {
                            return -e1[0].evaluate(t1);
                        }
                    ]
                ]
            },
            "/": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[1];
                    return e1[0].evaluate(t1) / r.evaluate(t1);
                }
            ],
            "%": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[1];
                    return e1[0].evaluate(t1) % r.evaluate(t1);
                }
            ],
            ln2: [
                Ot,
                [],
                function() {
                    return Math.LN2;
                }
            ],
            pi: [
                Ot,
                [],
                function() {
                    return Math.PI;
                }
            ],
            e: [
                Ot,
                [],
                function() {
                    return Math.E;
                }
            ],
            "^": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[1];
                    return Math.pow(e1[0].evaluate(t1), r.evaluate(t1));
                }
            ],
            sqrt: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.sqrt(e1[0].evaluate(t1));
                }
            ],
            log10: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.log(e1[0].evaluate(t1)) / Math.LN10;
                }
            ],
            ln: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.log(e1[0].evaluate(t1));
                }
            ],
            log2: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.log(e1[0].evaluate(t1)) / Math.LN2;
                }
            ],
            sin: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.sin(e1[0].evaluate(t1));
                }
            ],
            cos: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.cos(e1[0].evaluate(t1));
                }
            ],
            tan: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.tan(e1[0].evaluate(t1));
                }
            ],
            asin: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.asin(e1[0].evaluate(t1));
                }
            ],
            acos: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.acos(e1[0].evaluate(t1));
                }
            ],
            atan: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.atan(e1[0].evaluate(t1));
                }
            ],
            min: [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    return Math.min.apply(Math, e1.map(function(e1) {
                        return e1.evaluate(t1);
                    }));
                }
            ],
            max: [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    return Math.max.apply(Math, e1.map(function(e1) {
                        return e1.evaluate(t1);
                    }));
                }
            ],
            abs: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.abs(e1[0].evaluate(t1));
                }
            ],
            round: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[0].evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.floor(e1[0].evaluate(t1));
                }
            ],
            ceil: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.ceil(e1[0].evaluate(t1));
                }
            ],
            "filter-==": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1];
                    return t1.properties()[r.value] === n.value;
                }
            ],
            "filter-id-==": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0];
                    return t1.id() === r.value;
                }
            ],
            "filter-type-==": [
                Ut,
                [
                    Rt
                ],
                function(t1, e1) {
                    var r = e1[0];
                    return t1.geometryType() === r.value;
                }
            ],
            "filter-<": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i < a;
                }
            ],
            "filter-id-<": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter->": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i > a;
                }
            ],
            "filter-id->": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-<=": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i <= a;
                }
            ],
            "filter-id-<=": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter->=": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i >= a;
                }
            ],
            "filter-id->=": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-has": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    return e1[0].value in t1.properties();
                }
            ],
            "filter-has-id": [
                Ut,
                [],
                function(t1) {
                    return null !== t1.id() && void 0 !== t1.id();
                }
            ],
            "filter-type-in": [
                Ut,
                [
                    Xt(Rt)
                ],
                function(t1, e1) {
                    return e1[0].value.indexOf(t1.geometryType()) >= 0;
                }
            ],
            "filter-id-in": [
                Ut,
                [
                    Xt(Nt)
                ],
                function(t1, e1) {
                    return e1[0].value.indexOf(t1.id()) >= 0;
                }
            ],
            "filter-in-small": [
                Ut,
                [
                    Rt,
                    Xt(Nt)
                ],
                function(t1, e1) {
                    var r = e1[0];
                    return e1[1].value.indexOf(t1.properties()[r.value]) >= 0;
                }
            ],
            "filter-in-large": [
                Ut,
                [
                    Rt,
                    Xt(Nt)
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1];
                    return function(t1, e1, r, n) {
                        for(; r <= n;){
                            var i = r + n >> 1;
                            if (e1[i] === t1) return !0;
                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    }(t1.properties()[r.value], n.value, 0, n.value.length - 1);
                }
            ],
            all: {
                type: Ut,
                overloads: [
                    [
                        [
                            Ut,
                            Ut
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return e1[0].evaluate(t1) && r.evaluate(t1);
                        }
                    ],
                    [
                        Pr(Ut),
                        function(t1, e1) {
                            for(var r = 0, n = e1; r < n.length; r += 1)if (!n[r].evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Ut,
                overloads: [
                    [
                        [
                            Ut,
                            Ut
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return e1[0].evaluate(t1) || r.evaluate(t1);
                        }
                    ],
                    [
                        Pr(Ut),
                        function(t1, e1) {
                            for(var r = 0, n = e1; r < n.length; r += 1)if (n[r].evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Ut,
                [
                    Ut
                ],
                function(t1, e1) {
                    return !e1[0].evaluate(t1);
                }
            ],
            "is-supported-script": [
                Ut,
                [
                    Rt
                ],
                function(t1, e1) {
                    var r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e1[0].evaluate(t1));
                }
            ],
            upcase: [
                Rt,
                [
                    Rt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).toUpperCase();
                }
            ],
            downcase: [
                Rt,
                [
                    Rt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).toLowerCase();
                }
            ],
            concat: [
                Rt,
                Pr(Nt),
                function(t1, e1) {
                    return e1.map(function(e1) {
                        return ue(e1.evaluate(t1));
                    }).join("");
                }
            ],
            "resolved-locale": [
                Rt,
                [
                    Kt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).resolvedLocale();
                }
            ]
        });
        var Kr = function(t1, e1) {
            this.expression = t1, this._warningHistory = {}, this._evaluator = new ge, this._defaultValue = e1 ? function(t1) {
                return "color" === t1.type && Lr(t1.default) ? new te(0, 0, 0, 0) : "color" === t1.type ? te.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
            }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
        };
        function Gr(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in Ir;
        }
        function Zr(t1, e1) {
            var r = new je(Ir, [], e1 ? function(t1) {
                var e1 = {
                    color: jt,
                    string: Rt,
                    number: Ot,
                    enum: Rt,
                    boolean: Ut,
                    formatted: Gt,
                    resolvedImage: Zt
                };
                return "array" === t1.type ? Xt(e1[t1.value] || Nt, t1.length) : e1[t1.type];
            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? Mr(new Kr(n, e1)) : Br(r.errors);
        }
        Kr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
            return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
        }, Kr.prototype.evaluate = function(t1, e1, r, n, i, a) {
            this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
            try {
                var o = this.expression.evaluate(this._evaluator);
                if (null == o || "number" == typeof o && o != o) return this._defaultValue;
                if (this._enumValues && !(o in this._enumValues)) throw new pe("Expected value to be one of " + Object.keys(this._enumValues).map(function(t1) {
                    return JSON.stringify(t1);
                }).join(", ") + ", but found " + JSON.stringify(o) + " instead.");
                return o;
            } catch (t1) {
                return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
            }
        };
        var Xr = function(t1, e1) {
            this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !Oe(e1.expression);
        };
        Xr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
        }, Xr.prototype.evaluate = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
        };
        var Jr = function(t1, e1, r, n) {
            this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !Oe(e1.expression), this.interpolationType = n;
        };
        function Hr(t1, e1) {
            if ("error" === (t1 = Zr(t1, e1)).result) return t1;
            var r = t1.value.expression, n = Le(r);
            if (!n && !Tr(e1)) return Br([
                new Ft("", "data expressions not supported")
            ]);
            var i = Re(r, [
                "zoom"
            ]);
            if (!i && !Vr(e1)) return Br([
                new Ft("", "zoom expressions not supported")
            ]);
            var a = function t1(e1) {
                var r = null;
                if (e1 instanceof ur) r = t1(e1.result);
                else if (e1 instanceof sr) for(var n = 0, i = e1.args; n < i.length && !(r = t1(i[n])); n += 1);
                else (e1 instanceof Ne || e1 instanceof ar) && e1.input instanceof xe && "zoom" === e1.input.name && (r = e1);
                return r instanceof Ft || e1.eachChild(function(e1) {
                    var n = t1(e1);
                    n instanceof Ft ? r = n : !r && n ? r = new Ft("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : r && n && r !== n && (r = new Ft("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                }), r;
            }(r);
            return a || i ? a instanceof Ft ? Br([
                a
            ]) : a instanceof ar && !Fr(e1) ? Br([
                new Ft("", '"interpolate" expressions cannot be used with this property')
            ]) : Mr(a ? new Jr(n ? "camera" : "composite", t1.value, a.labels, a instanceof ar ? a.interpolation : void 0) : new Xr(n ? "constant" : "source", t1.value)) : Br([
                new Ft("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        Jr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
        }, Jr.prototype.evaluate = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
        }, Jr.prototype.interpolationFactor = function(t1, e1, r) {
            return this.interpolationType ? ar.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
        };
        var Yr = function(t1, e1) {
            this._parameters = t1, this._specification = e1, Bt(this, function t1(e1, r) {
                var n, i, a, o = "color" === r.type, s = e1.stops && "object" == typeof e1.stops[0][0], u = s || !(s || void 0 !== e1.property), l = e1.type || (Fr(r) ? "exponential" : "interval");
                if (o && ((e1 = Bt({}, e1)).stops && (e1.stops = e1.stops.map(function(t1) {
                    return [
                        t1[0],
                        te.parse(t1[1])
                    ];
                })), e1.default = te.parse(e1.default ? e1.default : r.default)), e1.colorSpace && "rgb" !== e1.colorSpace && !ir[e1.colorSpace]) throw new Error("Unknown color space: " + e1.colorSpace);
                if ("exponential" === l) n = qr;
                else if ("interval" === l) n = jr;
                else if ("categorical" === l) {
                    n = Ur, i = Object.create(null);
                    for(var p = 0, c = e1.stops; p < c.length; p += 1){
                        var h = c[p];
                        i[h[0]] = h[1];
                    }
                    a = typeof e1.stops[0][0];
                } else {
                    if ("identity" !== l) throw new Error('Unknown function type "' + l + '"');
                    n = Nr;
                }
                if (s) {
                    for(var f = {}, y = [], d = 0; d < e1.stops.length; d++){
                        var m = e1.stops[d], v = m[0].zoom;
                        void 0 === f[v] && (f[v] = {
                            zoom: v,
                            type: e1.type,
                            property: e1.property,
                            default: e1.default,
                            stops: []
                        }, y.push(v)), f[v].stops.push([
                            m[0].value,
                            m[1]
                        ]);
                    }
                    for(var g = [], x = 0, b = y; x < b.length; x += 1){
                        var w = b[x];
                        g.push([
                            f[w].zoom,
                            t1(f[w], r)
                        ]);
                    }
                    var _ = {
                        name: "linear"
                    };
                    return {
                        kind: "composite",
                        interpolationType: _,
                        interpolationFactor: ar.interpolationFactor.bind(void 0, _),
                        zoomStops: g.map(function(t1) {
                            return t1[0];
                        }),
                        evaluate: function(t1, n) {
                            var i = t1.zoom;
                            return qr({
                                stops: g,
                                base: e1.base
                            }, r, i).evaluate(i, n);
                        }
                    };
                }
                if (u) {
                    var A = "exponential" === l ? {
                        name: "exponential",
                        base: void 0 !== e1.base ? e1.base : 1
                    } : null;
                    return {
                        kind: "camera",
                        interpolationType: A,
                        interpolationFactor: ar.interpolationFactor.bind(void 0, A),
                        zoomStops: e1.stops.map(function(t1) {
                            return t1[0];
                        }),
                        evaluate: function(t1) {
                            return n(e1, r, t1.zoom, i, a);
                        }
                    };
                }
                return {
                    kind: "source",
                    evaluate: function(t1, o) {
                        var s = o && o.properties ? o.properties[e1.property] : void 0;
                        return void 0 === s ? Rr(e1.default, r.default) : n(e1, r, s, i, a);
                    }
                };
            }(this._parameters, this._specification));
        };
        function $r(t1) {
            var e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, a = t1.style, o = t1.styleSpec, s = [], u = Dr(r);
            if ("object" !== u) return [
                new Pt(e1, r, "object expected, " + u + " found")
            ];
            for(var l in r){
                var p = l.split(".")[0], c = n[p] || n["*"], h = void 0;
                if (i[p]) h = i[p];
                else if (n[p]) h = An;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        s.push(new Pt(e1, r[l], 'unknown property "' + l + '"'));
                        continue;
                    }
                    h = An;
                }
                s = s.concat(h({
                    key: (e1 ? e1 + "." : e1) + l,
                    value: r[l],
                    valueSpec: c,
                    style: a,
                    styleSpec: o,
                    object: r,
                    objectKey: l
                }, r));
            }
            for(var f in n)i[f] || n[f].required && void 0 === n[f].default && void 0 === r[f] && s.push(new Pt(e1, r, 'missing required property "' + f + '"'));
            return s;
        }
        function Wr(t1) {
            var e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, a = t1.key, o = t1.arrayElementValidator || An;
            if ("array" !== Dr(e1)) return [
                new Pt(a, e1, "array expected, " + Dr(e1) + " found")
            ];
            if (r.length && e1.length !== r.length) return [
                new Pt(a, e1, "array length " + r.length + " expected, length " + e1.length + " found")
            ];
            if (r["min-length"] && e1.length < r["min-length"]) return [
                new Pt(a, e1, "array length at least " + r["min-length"] + " expected, length " + e1.length + " found")
            ];
            var s = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (s.function = r.function), "object" === Dr(r.value) && (s = r.value);
            for(var u = [], l = 0; l < e1.length; l++)u = u.concat(o({
                array: e1,
                arrayIndex: l,
                value: e1[l],
                valueSpec: s,
                style: n,
                styleSpec: i,
                key: a + "[" + l + "]"
            }));
            return u;
        }
        function Qr(t1) {
            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = Dr(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new Pt(e1, r, "number expected, " + i + " found")
            ] : "minimum" in n && r < n.minimum ? [
                new Pt(e1, r, r + " is less than the minimum value " + n.minimum)
            ] : "maximum" in n && r > n.maximum ? [
                new Pt(e1, r, r + " is greater than the maximum value " + n.maximum)
            ] : [];
        }
        function tn(t1) {
            var e1, r, n, i = t1.valueSpec, a = Tt(t1.value.type), o = {}, s = "categorical" !== a && void 0 === t1.value.property, u = !s, l = "array" === Dr(t1.value.stops) && "array" === Dr(t1.value.stops[0]) && "object" === Dr(t1.value.stops[0][0]), p = $r({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === a) return [
                            new Pt(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        var e1 = [], r = t1.value;
                        return e1 = e1.concat(Wr({
                            key: t1.key,
                            value: r,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: c
                        })), "array" === Dr(r) && 0 === r.length && e1.push(new Pt(t1.key, r, "array must have at least one stop")), e1;
                    },
                    default: function(t1) {
                        return An({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: i,
                            style: t1.style,
                            styleSpec: t1.styleSpec
                        });
                    }
                }
            });
            return "identity" === a && s && p.push(new Pt(t1.key, t1.value, 'missing required property "property"')), "identity" === a || t1.value.stops || p.push(new Pt(t1.key, t1.value, 'missing required property "stops"')), "exponential" === a && t1.valueSpec.expression && !Fr(t1.valueSpec) && p.push(new Pt(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (u && !Tr(t1.valueSpec) ? p.push(new Pt(t1.key, t1.value, "property functions not supported")) : s && !Vr(t1.valueSpec) && p.push(new Pt(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== a && !l || void 0 !== t1.value.property || p.push(new Pt(t1.key, t1.value, '"property" property is required')), p;
            function c(t1) {
                var e1 = [], a = t1.value, s = t1.key;
                if ("array" !== Dr(a)) return [
                    new Pt(s, a, "array expected, " + Dr(a) + " found")
                ];
                if (2 !== a.length) return [
                    new Pt(s, a, "array length 2 expected, length " + a.length + " found")
                ];
                if (l) {
                    if ("object" !== Dr(a[0])) return [
                        new Pt(s, a, "object expected, " + Dr(a[0]) + " found")
                    ];
                    if (void 0 === a[0].zoom) return [
                        new Pt(s, a, "object stop key must have zoom")
                    ];
                    if (void 0 === a[0].value) return [
                        new Pt(s, a, "object stop key must have value")
                    ];
                    if (n && n > Tt(a[0].zoom)) return [
                        new Pt(s, a[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    Tt(a[0].zoom) !== n && (n = Tt(a[0].zoom), r = void 0, o = {}), e1 = e1.concat($r({
                        key: s + "[0]",
                        value: a[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: Qr,
                            value: h
                        }
                    }));
                } else e1 = e1.concat(h({
                    key: s + "[0]",
                    value: a[0],
                    valueSpec: {},
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, a));
                return Gr(Vt(a[1])) ? e1.concat([
                    new Pt(s + "[1]", a[1], "expressions are not allowed in function stops.")
                ]) : e1.concat(An({
                    key: s + "[1]",
                    value: a[1],
                    valueSpec: i,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function h(t1, n) {
                var s = Dr(t1.value), u = Tt(t1.value), l = null !== t1.value ? t1.value : n;
                if (e1) {
                    if (s !== e1) return [
                        new Pt(t1.key, l, s + " stop domain type must match previous stop domain type " + e1)
                    ];
                } else e1 = s;
                if ("number" !== s && "string" !== s && "boolean" !== s) return [
                    new Pt(t1.key, l, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== s && "categorical" !== a) {
                    var p = "number expected, " + s + " found";
                    return Tr(i) && void 0 === a && (p += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Pt(t1.key, l, p)
                    ];
                }
                return "categorical" !== a || "number" !== s || isFinite(u) && Math.floor(u) === u ? "categorical" !== a && "number" === s && void 0 !== r && u < r ? [
                    new Pt(t1.key, l, "stop domain values must appear in ascending order")
                ] : (r = u, "categorical" === a && u in o ? [
                    new Pt(t1.key, l, "stop domain values must be unique")
                ] : (o[u] = !0, [])) : [
                    new Pt(t1.key, l, "integer expected, found " + u)
                ];
            }
        }
        function en(t1) {
            var e1 = ("property" === t1.expressionContext ? Hr : Zr)(Vt(t1.value), t1.valueSpec);
            if ("error" === e1.result) return e1.value.map(function(e1) {
                return new Pt("" + t1.key + e1.key, t1.value, e1.message);
            });
            var r = e1.value.expression || e1.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                new Pt(t1.key, t1.value, 'Invalid data expression for "' + t1.propertyKey + '". Output values must be contained as literals within the expression.')
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !Oe(r)) return [
                new Pt(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext && !Oe(r)) return [
                new Pt(t1.key, t1.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!Re(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Pt(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !Le(r)) return [
                    new Pt(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function rn(t1) {
            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(Tt(r)) && i.push(new Pt(e1, r, "expected one of [" + n.values.join(", ") + "], " + JSON.stringify(r) + " found")) : -1 === Object.keys(n.values).indexOf(Tt(r)) && i.push(new Pt(e1, r, "expected one of [" + Object.keys(n.values).join(", ") + "], " + JSON.stringify(r) + " found")), i;
        }
        function nn(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for(var e1 = 0, r = t1.slice(1); e1 < r.length; e1 += 1){
                        var n = r[e1];
                        if (!nn(n) && "boolean" != typeof n) return !1;
                    }
                    return !0;
                default:
                    return !0;
            }
        }
        Yr.deserialize = function(t1) {
            return new Yr(t1._parameters, t1._specification);
        }, Yr.serialize = function(t1) {
            return {
                _parameters: t1._parameters,
                _specification: t1._specification
            };
        };
        var an = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function on(t1) {
            if (null == t1) return {
                filter: function() {
                    return !0;
                },
                needGeometry: !1
            };
            nn(t1) || (t1 = un(t1));
            var e1 = Zr(t1, an);
            if ("error" === e1.result) throw new Error(e1.value.map(function(t1) {
                return t1.key + ": " + t1.message;
            }).join(", "));
            return {
                filter: function(t1, r, n) {
                    return e1.value.evaluate(t1, r, {}, n);
                },
                needGeometry: function t1(e1) {
                    if (!Array.isArray(e1)) return !1;
                    if ("within" === e1[0]) return !0;
                    for(var r = 1; r < e1.length; r++)if (t1(e1[r])) return !0;
                    return !1;
                }(t1)
            };
        }
        function sn(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function un(t1) {
            if (!t1) return !0;
            var e1, r = t1[0];
            return t1.length <= 1 ? "any" !== r : "==" === r ? ln(t1[1], t1[2], "==") : "!=" === r ? hn(ln(t1[1], t1[2], "==")) : "<" === r || ">" === r || "<=" === r || ">=" === r ? ln(t1[1], t1[2], r) : "any" === r ? (e1 = t1.slice(1), [
                "any"
            ].concat(e1.map(un))) : "all" === r ? [
                "all"
            ].concat(t1.slice(1).map(un)) : "none" === r ? [
                "all"
            ].concat(t1.slice(1).map(un).map(hn)) : "in" === r ? pn(t1[1], t1.slice(2)) : "!in" === r ? hn(pn(t1[1], t1.slice(2))) : "has" === r ? cn(t1[1]) : "!has" === r ? hn(cn(t1[1])) : "within" !== r || t1;
        }
        function ln(t1, e1, r) {
            switch(t1){
                case "$type":
                    return [
                        "filter-type-" + r,
                        e1
                    ];
                case "$id":
                    return [
                        "filter-id-" + r,
                        e1
                    ];
                default:
                    return [
                        "filter-" + r,
                        t1,
                        e1
                    ];
            }
        }
        function pn(t1, e1) {
            if (0 === e1.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some(function(t1) {
                        return typeof t1 != typeof e1[0];
                    }) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e1.sort(sn)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function cn(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function hn(t1) {
            return [
                "!",
                t1
            ];
        }
        function fn(t1) {
            return nn(Vt(t1.value)) ? en(Bt({}, t1, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : function t1(e1) {
                var r = e1.value, n = e1.key;
                if ("array" !== Dr(r)) return [
                    new Pt(n, r, "array expected, " + Dr(r) + " found")
                ];
                var i, a = e1.styleSpec, o = [];
                if (r.length < 1) return [
                    new Pt(n, r, "filter array must have at least 1 element")
                ];
                switch(o = o.concat(rn({
                    key: n + "[0]",
                    value: r[0],
                    valueSpec: a.filter_operator,
                    style: e1.style,
                    styleSpec: e1.styleSpec
                })), Tt(r[0])){
                    case "<":
                    case "<=":
                    case ">":
                    case ">=":
                        r.length >= 2 && "$type" === Tt(r[1]) && o.push(new Pt(n, r, '"$type" cannot be use with operator "' + r[0] + '"'));
                    case "==":
                    case "!=":
                        3 !== r.length && o.push(new Pt(n, r, 'filter array for operator "' + r[0] + '" must have 3 elements'));
                    case "in":
                    case "!in":
                        r.length >= 2 && "string" !== (i = Dr(r[1])) && o.push(new Pt(n + "[1]", r[1], "string expected, " + i + " found"));
                        for(var s = 2; s < r.length; s++)i = Dr(r[s]), "$type" === Tt(r[1]) ? o = o.concat(rn({
                            key: n + "[" + s + "]",
                            value: r[s],
                            valueSpec: a.geometry_type,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        })) : "string" !== i && "number" !== i && "boolean" !== i && o.push(new Pt(n + "[" + s + "]", r[s], "string, number, or boolean expected, " + i + " found"));
                        break;
                    case "any":
                    case "all":
                    case "none":
                        for(var u = 1; u < r.length; u++)o = o.concat(t1({
                            key: n + "[" + u + "]",
                            value: r[u],
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        }));
                        break;
                    case "has":
                    case "!has":
                        i = Dr(r[1]), 2 !== r.length ? o.push(new Pt(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "string" !== i && o.push(new Pt(n + "[1]", r[1], "string expected, " + i + " found"));
                        break;
                    case "within":
                        i = Dr(r[1]), 2 !== r.length ? o.push(new Pt(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "object" !== i && o.push(new Pt(n + "[1]", r[1], "object expected, " + i + " found"));
                }
                return o;
            }(t1);
        }
        function yn(t1, e1) {
            var r = t1.key, n = t1.style, i = t1.styleSpec, a = t1.value, o = t1.objectKey, s = i[e1 + "_" + t1.layerType];
            if (!s) return [];
            var u = o.match(/^(.*)-transition$/);
            if ("paint" === e1 && u && s[u[1]] && s[u[1]].transition) return An({
                key: r,
                value: a,
                valueSpec: i.transition,
                style: n,
                styleSpec: i
            });
            var l, p = t1.valueSpec || s[o];
            if (!p) return [
                new Pt(r, a, 'unknown property "' + o + '"')
            ];
            if ("string" === Dr(a) && Tr(p) && !p.tokens && (l = /^{([^}]+)}$/.exec(a))) return [
                new Pt(r, a, '"' + o + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(l[1]) + " }`.")
            ];
            var c = [];
            return "symbol" === t1.layerType && ("text-field" === o && n && !n.glyphs && c.push(new Pt(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && Lr(Vt(a)) && "identity" === Tt(a.type) && c.push(new Pt(r, a, '"text-font" does not support identity functions'))), c.concat(An({
                key: t1.key,
                value: a,
                valueSpec: p,
                style: n,
                styleSpec: i,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: o
            }));
        }
        function dn(t1) {
            return yn(t1, "paint");
        }
        function mn(t1) {
            return yn(t1, "layout");
        }
        function vn(t1) {
            var e1 = [], r = t1.value, n = t1.key, i = t1.style, a = t1.styleSpec;
            r.type || r.ref || e1.push(new Pt(n, r, 'either "type" or "ref" is required'));
            var o, s = Tt(r.type), u = Tt(r.ref);
            if (r.id) for(var l = Tt(r.id), p = 0; p < t1.arrayIndex; p++){
                var c = i.layers[p];
                Tt(c.id) === l && e1.push(new Pt(n, r.id, 'duplicate layer id "' + r.id + '", previously used at line ' + c.id.__line__));
            }
            if ("ref" in r) [
                "type",
                "source",
                "source-layer",
                "filter",
                "layout"
            ].forEach(function(t1) {
                t1 in r && e1.push(new Pt(n, r[t1], '"' + t1 + '" is prohibited for ref layers'));
            }), i.layers.forEach(function(t1) {
                Tt(t1.id) === u && (o = t1);
            }), o ? o.ref ? e1.push(new Pt(n, r.ref, "ref cannot reference another ref layer")) : s = Tt(o.type) : e1.push(new Pt(n, r.ref, 'ref layer "' + u + '" not found'));
            else if ("background" !== s) {
                if (r.source) {
                    var h = i.sources && i.sources[r.source], f = h && Tt(h.type);
                    h ? "vector" === f && "raster" === s ? e1.push(new Pt(n, r.source, 'layer "' + r.id + '" requires a raster source')) : "raster" === f && "raster" !== s ? e1.push(new Pt(n, r.source, 'layer "' + r.id + '" requires a vector source')) : "vector" !== f || r["source-layer"] ? "raster-dem" === f && "hillshade" !== s ? e1.push(new Pt(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === f && h.lineMetrics || e1.push(new Pt(n, r, 'layer "' + r.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')) : e1.push(new Pt(n, r, 'layer "' + r.id + '" must specify a "source-layer"')) : e1.push(new Pt(n, r.source, 'source "' + r.source + '" not found'));
                } else e1.push(new Pt(n, r, 'missing required property "source"'));
            }
            return e1 = e1.concat($r({
                key: n,
                value: r,
                valueSpec: a.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": function() {
                        return [];
                    },
                    type: function() {
                        return An({
                            key: n + ".type",
                            value: r.type,
                            valueSpec: a.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: r,
                            objectKey: "type"
                        });
                    },
                    filter: fn,
                    layout: function(t1) {
                        return $r({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": function(t1) {
                                    return mn(Bt({
                                        layerType: s
                                    }, t1));
                                }
                            }
                        });
                    },
                    paint: function(t1) {
                        return $r({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": function(t1) {
                                    return dn(Bt({
                                        layerType: s
                                    }, t1));
                                }
                            }
                        });
                    }
                }
            }));
        }
        function gn(t1) {
            var e1 = t1.value, r = t1.key, n = Dr(e1);
            return "string" !== n ? [
                new Pt(r, e1, "string expected, " + n + " found")
            ] : [];
        }
        var xn = {
            promoteId: function(t1) {
                var e1 = t1.key, r = t1.value;
                if ("string" === Dr(r)) return gn({
                    key: e1,
                    value: r
                });
                var n = [];
                for(var i in r)n.push.apply(n, gn({
                    key: e1 + "." + i,
                    value: r[i]
                }));
                return n;
            }
        };
        function bn(t1) {
            var e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style;
            if (!e1.type) return [
                new Pt(r, e1, '"type" is required')
            ];
            var a, o = Tt(e1.type);
            switch(o){
                case "vector":
                case "raster":
                case "raster-dem":
                    return $r({
                        key: r,
                        value: e1,
                        valueSpec: n["source_" + o.replace("-", "_")],
                        style: t1.style,
                        styleSpec: n,
                        objectElementValidators: xn
                    });
                case "geojson":
                    if (a = $r({
                        key: r,
                        value: e1,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        objectElementValidators: xn
                    }), e1.cluster) for(var s in e1.clusterProperties){
                        var u = e1.clusterProperties[s], l = u[0], p = "string" == typeof l ? [
                            l,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                s
                            ]
                        ] : l;
                        a.push.apply(a, en({
                            key: r + "." + s + ".map",
                            value: u[1],
                            expressionContext: "cluster-map"
                        })), a.push.apply(a, en({
                            key: r + "." + s + ".reduce",
                            value: p,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return a;
                case "video":
                    return $r({
                        key: r,
                        value: e1,
                        valueSpec: n.source_video,
                        style: i,
                        styleSpec: n
                    });
                case "image":
                    return $r({
                        key: r,
                        value: e1,
                        valueSpec: n.source_image,
                        style: i,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new Pt(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return rn({
                        key: r + ".type",
                        value: e1.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        styleSpec: n
                    });
            }
        }
        function wn(t1) {
            var e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style, a = [], o = Dr(e1);
            if (void 0 === e1) return a;
            if ("object" !== o) return a.concat([
                new Pt("light", e1, "object expected, " + o + " found")
            ]);
            for(var s in e1){
                var u = s.match(/^(.*)-transition$/);
                a = a.concat(u && n[u[1]] && n[u[1]].transition ? An({
                    key: s,
                    value: e1[s],
                    valueSpec: r.transition,
                    style: i,
                    styleSpec: r
                }) : n[s] ? An({
                    key: s,
                    value: e1[s],
                    valueSpec: n[s],
                    style: i,
                    styleSpec: r
                }) : [
                    new Pt(s, e1[s], 'unknown property "' + s + '"')
                ]);
            }
            return a;
        }
        var _n = {
            "*": function() {
                return [];
            },
            array: Wr,
            boolean: function(t1) {
                var e1 = t1.value, r = t1.key, n = Dr(e1);
                return "boolean" !== n ? [
                    new Pt(r, e1, "boolean expected, " + n + " found")
                ] : [];
            },
            number: Qr,
            color: function(t1) {
                var e1 = t1.key, r = t1.value, n = Dr(r);
                return "string" !== n ? [
                    new Pt(e1, r, "color expected, " + n + " found")
                ] : null === Qt(r) ? [
                    new Pt(e1, r, 'color expected, "' + r + '" found')
                ] : [];
            },
            constants: Mt,
            enum: rn,
            filter: fn,
            function: tn,
            layer: vn,
            object: $r,
            source: bn,
            light: wn,
            string: gn,
            formatted: function(t1) {
                return 0 === gn(t1).length ? [] : en(t1);
            },
            resolvedImage: function(t1) {
                return 0 === gn(t1).length ? [] : en(t1);
            }
        };
        function An(t1) {
            var e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
            return r.expression && Lr(Tt(e1)) ? tn(t1) : r.expression && Gr(Vt(e1)) ? en(t1) : r.type && _n[r.type] ? _n[r.type](t1) : $r(Bt({}, t1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Sn(t1) {
            var e1 = t1.value, r = t1.key, n = gn(t1);
            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new Pt(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new Pt(r, e1, '"glyphs" url must include a "{range}" token'))), n;
        }
        function kn(t1, e1) {
            void 0 === e1 && (e1 = Et);
            var r = [];
            return r = r.concat(An({
                key: "",
                value: t1,
                valueSpec: e1.$root,
                styleSpec: e1,
                style: t1,
                objectElementValidators: {
                    glyphs: Sn,
                    "*": function() {
                        return [];
                    }
                }
            })), t1.constants && (r = r.concat(Mt({
                key: "constants",
                value: t1.constants,
                style: t1,
                styleSpec: e1
            }))), In(r);
        }
        function In(t1) {
            return [].concat(t1).sort(function(t1, e1) {
                return t1.line - e1.line;
            });
        }
        function zn(t1) {
            return function() {
                for(var e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                return In(t1.apply(this, e1));
            };
        }
        kn.source = zn(bn), kn.light = zn(wn), kn.layer = zn(vn), kn.filter = zn(fn), kn.paintProperty = zn(dn), kn.layoutProperty = zn(mn);
        var Cn = kn, En = Cn.light, Pn = Cn.paintProperty, Mn = Cn.layoutProperty;
        function Bn(t1, e1) {
            var r = !1;
            if (e1 && e1.length) for(var n = 0, i = e1; n < i.length; n += 1)t1.fire(new zt(new Error(i[n].message))), r = !0;
            return r;
        }
        var Tn = Vn;
        function Vn(t1, e1, r) {
            var n = this.cells = [];
            if (t1 instanceof ArrayBuffer) {
                this.arrayBuffer = t1;
                var i = new Int32Array(this.arrayBuffer);
                t1 = i[0], this.d = (e1 = i[1]) + 2 * (r = i[2]);
                for(var a = 0; a < this.d * this.d; a++){
                    var o = i[3 + a], s = i[3 + a + 1];
                    n.push(o === s ? null : i.subarray(o, s));
                }
                var u = i[3 + n.length + 1];
                this.keys = i.subarray(i[3 + n.length], u), this.bboxes = i.subarray(u), this.insert = this._insertReadonly;
            } else {
                this.d = e1 + 2 * r;
                for(var l = 0; l < this.d * this.d; l++)n.push([]);
                this.keys = [], this.bboxes = [];
            }
            this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
            var p = r / e1 * t1;
            this.min = -p, this.max = t1 + p;
        }
        Vn.prototype.insert = function(t1, e1, r, n, i) {
            this._forEachCell(e1, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
        }, Vn.prototype._insertReadonly = function() {
            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, Vn.prototype._insertCell = function(t1, e1, r, n, i, a) {
            this.cells[i].push(a);
        }, Vn.prototype.query = function(t1, e1, r, n, i) {
            var a = this.min, o = this.max;
            if (t1 <= a && e1 <= a && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
            var s = [];
            return this._forEachCell(t1, e1, r, n, this._queryCell, s, {}, i), s;
        }, Vn.prototype._queryCell = function(t1, e1, r, n, i, a, o, s) {
            var u = this.cells[i];
            if (null !== u) for(var l = this.keys, p = this.bboxes, c = 0; c < u.length; c++){
                var h = u[c];
                if (void 0 === o[h]) {
                    var f = 4 * h;
                    (s ? s(p[f + 0], p[f + 1], p[f + 2], p[f + 3]) : t1 <= p[f + 2] && e1 <= p[f + 3] && r >= p[f + 0] && n >= p[f + 1]) ? (o[h] = !0, a.push(l[h])) : o[h] = !1;
                }
            }
        }, Vn.prototype._forEachCell = function(t1, e1, r, n, i, a, o, s) {
            for(var u = this._convertToCellCoord(t1), l = this._convertToCellCoord(e1), p = this._convertToCellCoord(r), c = this._convertToCellCoord(n), h = u; h <= p; h++)for(var f = l; f <= c; f++){
                var y = this.d * f + h;
                if ((!s || s(this._convertFromCellCoord(h), this._convertFromCellCoord(f), this._convertFromCellCoord(h + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t1, e1, r, n, y, a, o, s)) return;
            }
        }, Vn.prototype._convertFromCellCoord = function(t1) {
            return (t1 - this.padding) / this.scale;
        }, Vn.prototype._convertToCellCoord = function(t1) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
        }, Vn.prototype.toArrayBuffer = function() {
            if (this.arrayBuffer) return this.arrayBuffer;
            for(var t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++)r += this.cells[n].length;
            var i = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
            i[0] = this.extent, i[1] = this.n, i[2] = this.padding;
            for(var a = e1, o = 0; o < t1.length; o++){
                var s = t1[o];
                i[3 + o] = a, i.set(s, a), a += s.length;
            }
            return i[3 + t1.length] = a, i.set(this.keys, a), i[3 + t1.length + 1] = a += this.keys.length, i.set(this.bboxes, a), a += this.bboxes.length, i.buffer;
        };
        var Fn = o.ImageData, Dn = o.ImageBitmap, Ln = {};
        function On(t1, e1, r) {
            void 0 === r && (r = {}), Object.defineProperty(e1, "_classRegistryKey", {
                value: t1,
                writeable: !1
            }), Ln[t1] = {
                klass: e1,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        for(var Rn in On("Object", Object), Tn.serialize = function(t1, e1) {
            var r = t1.toArrayBuffer();
            return e1 && e1.push(r), {
                buffer: r
            };
        }, Tn.deserialize = function(t1) {
            return new Tn(t1.buffer);
        }, On("Grid", Tn), On("Color", te), On("Error", Error), On("ResolvedImage", ie), On("StylePropertyFunction", Yr), On("StyleExpression", Kr, {
            omit: [
                "_evaluator"
            ]
        }), On("ZoomDependentExpression", Jr), On("ZoomConstantExpression", Xr), On("CompoundExpression", xe, {
            omit: [
                "_evaluate"
            ]
        }), Ir)Ir[Rn]._classRegistryKey || On("Expression_" + Rn, Ir[Rn]);
        function Un(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function jn(t1) {
            return Dn && t1 instanceof Dn;
        }
        function qn(t1, e1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
            if (Un(t1) || jn(t1)) return e1 && e1.push(t1), t1;
            if (ArrayBuffer.isView(t1)) {
                var r = t1;
                return e1 && e1.push(r.buffer), r;
            }
            if (t1 instanceof Fn) return e1 && e1.push(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                for(var n = [], i = 0, a = t1; i < a.length; i += 1)n.push(qn(a[i], e1));
                return n;
            }
            if ("object" == typeof t1) {
                var o = t1.constructor, s = o._classRegistryKey;
                if (!s) throw new Error("can't serialize object of unregistered class");
                var u = o.serialize ? o.serialize(t1, e1) : {};
                if (!o.serialize) {
                    for(var l in t1)if (t1.hasOwnProperty(l) && !(Ln[s].omit.indexOf(l) >= 0)) {
                        var p = t1[l];
                        u[l] = Ln[s].shallow.indexOf(l) >= 0 ? p : qn(p, e1);
                    }
                    t1 instanceof Error && (u.message = t1.message);
                }
                if (u.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== s && (u.$name = s), u;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function Nn(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || Un(t1) || jn(t1) || ArrayBuffer.isView(t1) || t1 instanceof Fn) return t1;
            if (Array.isArray(t1)) return t1.map(Nn);
            if ("object" == typeof t1) {
                var e1 = t1.$name || "Object", r = Ln[e1].klass;
                if (!r) throw new Error("can't deserialize unregistered class " + e1);
                if (r.deserialize) return r.deserialize(t1);
                for(var n = Object.create(r.prototype), i = 0, a = Object.keys(t1); i < a.length; i += 1){
                    var o = a[i];
                    if ("$name" !== o) {
                        var s = t1[o];
                        n[o] = Ln[e1].shallow.indexOf(o) >= 0 ? s : Nn(s);
                    }
                }
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        var Kn = function() {
            this.first = !0;
        };
        Kn.prototype.update = function(t1, e1) {
            var r = Math.floor(t1);
            return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
        };
        var Gn = {
            "Latin-1 Supplement": function(t1) {
                return t1 >= 128 && t1 <= 255;
            },
            Arabic: function(t1) {
                return t1 >= 1536 && t1 <= 1791;
            },
            "Arabic Supplement": function(t1) {
                return t1 >= 1872 && t1 <= 1919;
            },
            "Arabic Extended-A": function(t1) {
                return t1 >= 2208 && t1 <= 2303;
            },
            "Hangul Jamo": function(t1) {
                return t1 >= 4352 && t1 <= 4607;
            },
            "Unified Canadian Aboriginal Syllabics": function(t1) {
                return t1 >= 5120 && t1 <= 5759;
            },
            Khmer: function(t1) {
                return t1 >= 6016 && t1 <= 6143;
            },
            "Unified Canadian Aboriginal Syllabics Extended": function(t1) {
                return t1 >= 6320 && t1 <= 6399;
            },
            "General Punctuation": function(t1) {
                return t1 >= 8192 && t1 <= 8303;
            },
            "Letterlike Symbols": function(t1) {
                return t1 >= 8448 && t1 <= 8527;
            },
            "Number Forms": function(t1) {
                return t1 >= 8528 && t1 <= 8591;
            },
            "Miscellaneous Technical": function(t1) {
                return t1 >= 8960 && t1 <= 9215;
            },
            "Control Pictures": function(t1) {
                return t1 >= 9216 && t1 <= 9279;
            },
            "Optical Character Recognition": function(t1) {
                return t1 >= 9280 && t1 <= 9311;
            },
            "Enclosed Alphanumerics": function(t1) {
                return t1 >= 9312 && t1 <= 9471;
            },
            "Geometric Shapes": function(t1) {
                return t1 >= 9632 && t1 <= 9727;
            },
            "Miscellaneous Symbols": function(t1) {
                return t1 >= 9728 && t1 <= 9983;
            },
            "Miscellaneous Symbols and Arrows": function(t1) {
                return t1 >= 11008 && t1 <= 11263;
            },
            "CJK Radicals Supplement": function(t1) {
                return t1 >= 11904 && t1 <= 12031;
            },
            "Kangxi Radicals": function(t1) {
                return t1 >= 12032 && t1 <= 12255;
            },
            "Ideographic Description Characters": function(t1) {
                return t1 >= 12272 && t1 <= 12287;
            },
            "CJK Symbols and Punctuation": function(t1) {
                return t1 >= 12288 && t1 <= 12351;
            },
            Hiragana: function(t1) {
                return t1 >= 12352 && t1 <= 12447;
            },
            Katakana: function(t1) {
                return t1 >= 12448 && t1 <= 12543;
            },
            Bopomofo: function(t1) {
                return t1 >= 12544 && t1 <= 12591;
            },
            "Hangul Compatibility Jamo": function(t1) {
                return t1 >= 12592 && t1 <= 12687;
            },
            Kanbun: function(t1) {
                return t1 >= 12688 && t1 <= 12703;
            },
            "Bopomofo Extended": function(t1) {
                return t1 >= 12704 && t1 <= 12735;
            },
            "CJK Strokes": function(t1) {
                return t1 >= 12736 && t1 <= 12783;
            },
            "Katakana Phonetic Extensions": function(t1) {
                return t1 >= 12784 && t1 <= 12799;
            },
            "Enclosed CJK Letters and Months": function(t1) {
                return t1 >= 12800 && t1 <= 13055;
            },
            "CJK Compatibility": function(t1) {
                return t1 >= 13056 && t1 <= 13311;
            },
            "CJK Unified Ideographs Extension A": function(t1) {
                return t1 >= 13312 && t1 <= 19903;
            },
            "Yijing Hexagram Symbols": function(t1) {
                return t1 >= 19904 && t1 <= 19967;
            },
            "CJK Unified Ideographs": function(t1) {
                return t1 >= 19968 && t1 <= 40959;
            },
            "Yi Syllables": function(t1) {
                return t1 >= 40960 && t1 <= 42127;
            },
            "Yi Radicals": function(t1) {
                return t1 >= 42128 && t1 <= 42191;
            },
            "Hangul Jamo Extended-A": function(t1) {
                return t1 >= 43360 && t1 <= 43391;
            },
            "Hangul Syllables": function(t1) {
                return t1 >= 44032 && t1 <= 55215;
            },
            "Hangul Jamo Extended-B": function(t1) {
                return t1 >= 55216 && t1 <= 55295;
            },
            "Private Use Area": function(t1) {
                return t1 >= 57344 && t1 <= 63743;
            },
            "CJK Compatibility Ideographs": function(t1) {
                return t1 >= 63744 && t1 <= 64255;
            },
            "Arabic Presentation Forms-A": function(t1) {
                return t1 >= 64336 && t1 <= 65023;
            },
            "Vertical Forms": function(t1) {
                return t1 >= 65040 && t1 <= 65055;
            },
            "CJK Compatibility Forms": function(t1) {
                return t1 >= 65072 && t1 <= 65103;
            },
            "Small Form Variants": function(t1) {
                return t1 >= 65104 && t1 <= 65135;
            },
            "Arabic Presentation Forms-B": function(t1) {
                return t1 >= 65136 && t1 <= 65279;
            },
            "Halfwidth and Fullwidth Forms": function(t1) {
                return t1 >= 65280 && t1 <= 65519;
            }
        };
        function Zn(t1) {
            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (Xn(r[e1].charCodeAt(0))) return !0;
            return !1;
        }
        function Xn(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(Gn["Bopomofo Extended"](t1) || Gn.Bopomofo(t1) || Gn["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || Gn["CJK Compatibility Ideographs"](t1) || Gn["CJK Compatibility"](t1) || Gn["CJK Radicals Supplement"](t1) || Gn["CJK Strokes"](t1) || !(!Gn["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || Gn["CJK Unified Ideographs Extension A"](t1) || Gn["CJK Unified Ideographs"](t1) || Gn["Enclosed CJK Letters and Months"](t1) || Gn["Hangul Compatibility Jamo"](t1) || Gn["Hangul Jamo Extended-A"](t1) || Gn["Hangul Jamo Extended-B"](t1) || Gn["Hangul Jamo"](t1) || Gn["Hangul Syllables"](t1) || Gn.Hiragana(t1) || Gn["Ideographic Description Characters"](t1) || Gn.Kanbun(t1) || Gn["Kangxi Radicals"](t1) || Gn["Katakana Phonetic Extensions"](t1) || Gn.Katakana(t1) && 12540 !== t1 || !(!Gn["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!Gn["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || Gn["Unified Canadian Aboriginal Syllabics"](t1) || Gn["Unified Canadian Aboriginal Syllabics Extended"](t1) || Gn["Vertical Forms"](t1) || Gn["Yijing Hexagram Symbols"](t1) || Gn["Yi Syllables"](t1) || Gn["Yi Radicals"](t1))));
        }
        function Jn(t1) {
            return !(Xn(t1) || function(t1) {
                return !!(Gn["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || Gn["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || Gn["Letterlike Symbols"](t1) || Gn["Number Forms"](t1) || Gn["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || Gn["Control Pictures"](t1) && 9251 !== t1 || Gn["Optical Character Recognition"](t1) || Gn["Enclosed Alphanumerics"](t1) || Gn["Geometric Shapes"](t1) || Gn["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || Gn["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || Gn["CJK Symbols and Punctuation"](t1) || Gn.Katakana(t1) || Gn["Private Use Area"](t1) || Gn["CJK Compatibility Forms"](t1) || Gn["Small Form Variants"](t1) || Gn["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function Hn(t1) {
            return t1 >= 1424 && t1 <= 2303 || Gn["Arabic Presentation Forms-A"](t1) || Gn["Arabic Presentation Forms-B"](t1);
        }
        function Yn(t1, e1) {
            return !(!e1 && Hn(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || Gn.Khmer(t1));
        }
        function $n(t1) {
            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (Hn(r[e1].charCodeAt(0))) return !0;
            return !1;
        }
        var Wn = null, Qn = "unavailable", ti = null, ei = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Qn = "error"), Wn && Wn(t1);
        };
        function ri() {
            ni.fire(new It("pluginStateChange", {
                pluginStatus: Qn,
                pluginURL: ti
            }));
        }
        var ni = new Ct, ii = function() {
            return Qn;
        }, ai = function() {
            if ("deferred" !== Qn || !ti) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Qn = "loading", ri(), ti && bt({
                url: ti
            }, function(t1) {
                t1 ? ei(t1) : (Qn = "loaded", ri());
            });
        }, oi = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: function() {
                return "loaded" === Qn || null != oi.applyArabicShaping;
            },
            isLoading: function() {
                return "loading" === Qn;
            },
            setState: function(t1) {
                Qn = t1.pluginStatus, ti = t1.pluginURL;
            },
            isParsed: function() {
                return null != oi.applyArabicShaping && null != oi.processBidirectionalText && null != oi.processStyledBidirectionalText;
            },
            getPluginURL: function() {
                return ti;
            }
        }, si = function(t1, e1) {
            this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Kn, this.transition = {});
        };
        si.prototype.isSupportedScript = function(t1) {
            return function(t1, e1) {
                for(var r = 0, n = t1; r < n.length; r += 1)if (!Yn(n[r].charCodeAt(0), e1)) return !1;
                return !0;
            }(t1, oi.isLoaded());
        }, si.prototype.crossFadingFactor = function() {
            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
        }, si.prototype.getCrossfadeParameters = function() {
            var t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
            return t1 > this.zoomHistory.lastIntegerZoom ? {
                fromScale: 2,
                toScale: 1,
                t: e1 + (1 - e1) * r
            } : {
                fromScale: .5,
                toScale: 1,
                t: 1 - (1 - r) * e1
            };
        };
        var ui = function(t1, e1) {
            this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                if (Lr(t1)) return new Yr(t1, e1);
                if (Gr(t1)) {
                    var r = Hr(t1, e1);
                    if ("error" === r.result) throw new Error(r.value.map(function(t1) {
                        return t1.key + ": " + t1.message;
                    }).join(", "));
                    return r.value;
                }
                var n = t1;
                return "string" == typeof t1 && "color" === e1.type && (n = te.parse(t1)), {
                    kind: "constant",
                    evaluate: function() {
                        return n;
                    }
                };
            }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
        };
        ui.prototype.isDataDriven = function() {
            return "source" === this.expression.kind || "composite" === this.expression.kind;
        }, ui.prototype.possiblyEvaluate = function(t1, e1, r) {
            return this.property.possiblyEvaluate(this, t1, e1, r);
        };
        var li = function(t1) {
            this.property = t1, this.value = new ui(t1, void 0);
        };
        li.prototype.transitioned = function(t1, e1) {
            return new ci(this.property, this.value, e1, h({}, t1.transition, this.transition), t1.now);
        }, li.prototype.untransitioned = function() {
            return new ci(this.property, this.value, null, {}, 0);
        };
        var pi = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
        };
        pi.prototype.getValue = function(t1) {
            return w(this._values[t1].value.value);
        }, pi.prototype.setValue = function(t1, e1) {
            this._values.hasOwnProperty(t1) || (this._values[t1] = new li(this._values[t1].property)), this._values[t1].value = new ui(this._values[t1].property, null === e1 ? void 0 : w(e1));
        }, pi.prototype.getTransition = function(t1) {
            return w(this._values[t1].transition);
        }, pi.prototype.setTransition = function(t1, e1) {
            this._values.hasOwnProperty(t1) || (this._values[t1] = new li(this._values[t1].property)), this._values[t1].transition = w(e1) || void 0;
        }, pi.prototype.serialize = function() {
            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                var n = r[e1], i = this.getValue(n);
                void 0 !== i && (t1[n] = i);
                var a = this.getTransition(n);
                void 0 !== a && (t1[n + "-transition"] = a);
            }
            return t1;
        }, pi.prototype.transitioned = function(t1, e1) {
            for(var r = new hi(this._properties), n = 0, i = Object.keys(this._values); n < i.length; n += 1){
                var a = i[n];
                r._values[a] = this._values[a].transitioned(t1, e1._values[a]);
            }
            return r;
        }, pi.prototype.untransitioned = function() {
            for(var t1 = new hi(this._properties), e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                var n = r[e1];
                t1._values[n] = this._values[n].untransitioned();
            }
            return t1;
        };
        var ci = function(t1, e1, r, n, i) {
            this.property = t1, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
        };
        ci.prototype.possiblyEvaluate = function(t1, e1, r) {
            var n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), a = this.prior;
            if (a) {
                if (n > this.end) return this.prior = null, i;
                if (this.value.isDataDriven()) return this.prior = null, i;
                if (n < this.begin) return a.possiblyEvaluate(t1, e1, r);
                var o = (n - this.begin) / (this.end - this.begin);
                return this.property.interpolate(a.possiblyEvaluate(t1, e1, r), i, function(t1) {
                    if (t1 <= 0) return 0;
                    if (t1 >= 1) return 1;
                    var e1 = t1 * t1, r = e1 * t1;
                    return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                }(o));
            }
            return i;
        };
        var hi = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
        };
        hi.prototype.possiblyEvaluate = function(t1, e1, r) {
            for(var n = new di(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                var o = a[i];
                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
            }
            return n;
        }, hi.prototype.hasTransition = function() {
            for(var t1 = 0, e1 = Object.keys(this._values); t1 < e1.length; t1 += 1)if (this._values[e1[t1]].prior) return !0;
            return !1;
        };
        var fi = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
        };
        fi.prototype.getValue = function(t1) {
            return w(this._values[t1].value);
        }, fi.prototype.setValue = function(t1, e1) {
            this._values[t1] = new ui(this._values[t1].property, null === e1 ? void 0 : w(e1));
        }, fi.prototype.serialize = function() {
            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                var n = r[e1], i = this.getValue(n);
                void 0 !== i && (t1[n] = i);
            }
            return t1;
        }, fi.prototype.possiblyEvaluate = function(t1, e1, r) {
            for(var n = new di(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                var o = a[i];
                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
            }
            return n;
        };
        var yi = function(t1, e1, r) {
            this.property = t1, this.value = e1, this.parameters = r;
        };
        yi.prototype.isConstant = function() {
            return "constant" === this.value.kind;
        }, yi.prototype.constantOr = function(t1) {
            return "constant" === this.value.kind ? this.value.value : t1;
        }, yi.prototype.evaluate = function(t1, e1, r, n) {
            return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
        };
        var di = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
        };
        di.prototype.get = function(t1) {
            return this._values[t1];
        };
        var mi = function(t1) {
            this.specification = t1;
        };
        mi.prototype.possiblyEvaluate = function(t1, e1) {
            return t1.expression.evaluate(e1);
        }, mi.prototype.interpolate = function(t1, e1, r) {
            var n = Ge[this.specification.type];
            return n ? n(t1, e1, r) : t1;
        };
        var vi = function(t1, e1) {
            this.specification = t1, this.overrides = e1;
        };
        vi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
            return new yi(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                kind: "constant",
                value: t1.expression.evaluate(e1, null, {}, r, n)
            } : t1.expression, e1);
        }, vi.prototype.interpolate = function(t1, e1, r) {
            if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
            if (void 0 === t1.value.value || void 0 === e1.value.value) return new yi(this, {
                kind: "constant",
                value: void 0
            }, t1.parameters);
            var n = Ge[this.specification.type];
            return n ? new yi(this, {
                kind: "constant",
                value: n(t1.value.value, e1.value.value, r)
            }, t1.parameters) : t1;
        }, vi.prototype.evaluate = function(t1, e1, r, n, i, a) {
            return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, a);
        };
        var gi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                if (void 0 === t1.value) return new yi(this, {
                    kind: "constant",
                    value: void 0
                }, e1);
                if ("constant" === t1.expression.kind) {
                    var i = t1.expression.evaluate(e1, null, {}, r, n), a = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, o = this._calculate(a, a, a, e1);
                    return new yi(this, {
                        kind: "constant",
                        value: o
                    }, e1);
                }
                if ("camera" === t1.expression.kind) {
                    var s = this._calculate(t1.expression.evaluate({
                        zoom: e1.zoom - 1
                    }), t1.expression.evaluate({
                        zoom: e1.zoom
                    }), t1.expression.evaluate({
                        zoom: e1.zoom + 1
                    }), e1);
                    return new yi(this, {
                        kind: "constant",
                        value: s
                    }, e1);
                }
                return new yi(this, t1.expression, e1);
            }, e1.prototype.evaluate = function(t1, e1, r, n, i, a) {
                if ("source" === t1.kind) {
                    var o = t1.evaluate(e1, r, n, i, a);
                    return this._calculate(o, o, o, e1);
                }
                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                    zoom: Math.floor(e1.zoom) - 1
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom)
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom) + 1
                }, r, n), e1) : t1.value;
            }, e1.prototype._calculate = function(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1
                } : {
                    from: r,
                    to: e1
                };
            }, e1.prototype.interpolate = function(t1) {
                return t1;
            }, e1;
        }(vi), xi = function(t1) {
            this.specification = t1;
        };
        xi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
            if (void 0 !== t1.value) {
                if ("constant" === t1.expression.kind) {
                    var i = t1.expression.evaluate(e1, null, {}, r, n);
                    return this._calculate(i, i, i, e1);
                }
                return this._calculate(t1.expression.evaluate(new si(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new si(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new si(Math.floor(e1.zoom + 1), e1)), e1);
            }
        }, xi.prototype._calculate = function(t1, e1, r, n) {
            return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                from: t1,
                to: e1
            } : {
                from: r,
                to: e1
            };
        }, xi.prototype.interpolate = function(t1) {
            return t1;
        };
        var bi = function(t1) {
            this.specification = t1;
        };
        bi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
            return !!t1.expression.evaluate(e1, null, {}, r, n);
        }, bi.prototype.interpolate = function() {
            return !1;
        };
        var wi = function(t1) {
            for(var e1 in this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [], t1){
                var r = t1[e1];
                r.specification.overridable && this.overridableProperties.push(e1);
                var n = this.defaultPropertyValues[e1] = new ui(r, void 0), i = this.defaultTransitionablePropertyValues[e1] = new li(r);
                this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = n.possiblyEvaluate({});
            }
        };
        On("DataDrivenProperty", vi), On("DataConstantProperty", mi), On("CrossFadedDataDrivenProperty", gi), On("CrossFadedProperty", xi), On("ColorRampProperty", bi);
        var _i = function(t1) {
            function e1(e1, r) {
                if (t1.call(this), this.id = e1.id, this.type = e1.type, this._featureFilter = {
                    filter: function() {
                        return !0;
                    },
                    needGeometry: !1
                }, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter), r.layout && (this._unevaluatedLayout = new fi(r.layout)), r.paint)) {
                    for(var n in this._transitionablePaint = new pi(r.paint), e1.paint)this.setPaintProperty(n, e1.paint[n], {
                        validate: !1
                    });
                    for(var i in e1.layout)this.setLayoutProperty(i, e1.layout[i], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new di(r.paint);
                }
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getCrossfadeParameters = function() {
                return this._crossfadeParameters;
            }, e1.prototype.getLayoutProperty = function(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }, e1.prototype.setLayoutProperty = function(t1, e1, r) {
                void 0 === r && (r = {}), null != e1 && this._validate(Mn, "layers." + this.id + ".layout." + t1, t1, e1, r) || ("visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1);
            }, e1.prototype.getPaintProperty = function(t1) {
                return g(t1, "-transition") ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
            }, e1.prototype.setPaintProperty = function(t1, e1, r) {
                if (void 0 === r && (r = {}), null != e1 && this._validate(Pn, "layers." + this.id + ".paint." + t1, t1, e1, r)) return !1;
                if (g(t1, "-transition")) return this._transitionablePaint.setTransition(t1.slice(0, -11), e1 || void 0), !1;
                var n = this._transitionablePaint._values[t1], i = "cross-faded-data-driven" === n.property.specification["property-type"], a = n.value.isDataDriven(), o = n.value;
                this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                var s = this._transitionablePaint._values[t1].value;
                return s.isDataDriven() || a || i || this._handleOverridablePaintPropertyUpdate(t1, o, s);
            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {}, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, e1, r) {
                return !1;
            }, e1.prototype.isHidden = function(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }, e1.prototype.updateTransitions = function(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }, e1.prototype.hasTransition = function() {
                return this._transitioningPaint.hasTransition();
            }, e1.prototype.recalculate = function(t1, e1) {
                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
            }, e1.prototype.serialize = function() {
                var t1 = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), b(t1, function(t1, e1) {
                    return !(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length);
                });
            }, e1.prototype._validate = function(t1, e1, r, n, i) {
                return void 0 === i && (i = {}), (!i || !1 !== i.validate) && Bn(this, t1.call(Cn, {
                    key: e1,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: Et,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }, e1.prototype.is3D = function() {
                return !1;
            }, e1.prototype.isTileClipped = function() {
                return !1;
            }, e1.prototype.hasOffscreenPass = function() {
                return !1;
            }, e1.prototype.resize = function() {}, e1.prototype.isStateDependent = function() {
                for(var t1 in this.paint._values){
                    var e1 = this.paint.get(t1);
                    if (e1 instanceof yi && Tr(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                }
                return !1;
            }, e1;
        }(Ct), Ai = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        }, Si = function(t1, e1) {
            this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
        }, ki = function() {
            this.isTransferred = !1, this.capacity = -1, this.resize(0);
        };
        function Ii(t1, e1) {
            void 0 === e1 && (e1 = 1);
            var r = 0, n = 0;
            return {
                members: t1.map(function(t1) {
                    var i = Ai[t1.type].BYTES_PER_ELEMENT, a = r = zi(r, Math.max(e1, i)), o = t1.components || 1;
                    return n = Math.max(n, i), r += i * o, {
                        name: t1.name,
                        type: t1.type,
                        components: o,
                        offset: a
                    };
                }),
                size: zi(r, Math.max(n, e1)),
                alignment: e1
            };
        }
        function zi(t1, e1) {
            return Math.ceil(t1 / e1) * e1;
        }
        ki.serialize = function(t1, e1) {
            return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                length: t1.length,
                arrayBuffer: t1.arrayBuffer
            };
        }, ki.deserialize = function(t1) {
            var e1 = Object.create(this.prototype);
            return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
        }, ki.prototype._trim = function() {
            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
        }, ki.prototype.clear = function() {
            this.length = 0;
        }, ki.prototype.resize = function(t1) {
            this.reserve(t1), this.length = t1;
        }, ki.prototype.reserve = function(t1) {
            if (t1 > this.capacity) {
                this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                var e1 = this.uint8;
                this._refreshViews(), e1 && this.uint8.set(e1);
            }
        }, ki.prototype._refreshViews = function() {
            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
        };
        var Ci = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1) {
                var r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }, e1.prototype.emplace = function(t1, e1, r) {
                var n = 2 * t1;
                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
            }, e1;
        }(ki);
        Ci.prototype.bytesPerElement = 4, On("StructArrayLayout2i4", Ci);
        var Ei = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                var i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                var a = 4 * t1;
                return this.int16[a + 0] = e1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
            }, e1;
        }(ki);
        Ei.prototype.bytesPerElement = 8, On("StructArrayLayout4i8", Ei);
        var Pi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                var o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                var s = 6 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
            }, e1;
        }(ki);
        Pi.prototype.bytesPerElement = 12, On("StructArrayLayout2i4i12", Pi);
        var Mi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                var o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                var s = 4 * t1, u = 8 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = a, this.uint8[u + 7] = o, t1;
            }, e1;
        }(ki);
        Mi.prototype.bytesPerElement = 8, On("StructArrayLayout2i4ub8", Mi);
        var Bi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1) {
                var r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }, e1.prototype.emplace = function(t1, e1, r) {
                var n = 2 * t1;
                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
            }, e1;
        }(ki);
        Bi.prototype.bytesPerElement = 8, On("StructArrayLayout2f8", Bi);
        var Ti = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l) {
                var p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e1, r, n, i, a, o, s, u, l);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p) {
                var c = 10 * t1;
                return this.uint16[c + 0] = e1, this.uint16[c + 1] = r, this.uint16[c + 2] = n, this.uint16[c + 3] = i, this.uint16[c + 4] = a, this.uint16[c + 5] = o, this.uint16[c + 6] = s, this.uint16[c + 7] = u, this.uint16[c + 8] = l, this.uint16[c + 9] = p, t1;
            }, e1;
        }(ki);
        Ti.prototype.bytesPerElement = 20, On("StructArrayLayout10ui20", Ti);
        var Vi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l, p, c) {
                var h = this.length;
                return this.resize(h + 1), this.emplace(h, t1, e1, r, n, i, a, o, s, u, l, p, c);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h) {
                var f = 12 * t1;
                return this.int16[f + 0] = e1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = o, this.uint16[f + 6] = s, this.uint16[f + 7] = u, this.int16[f + 8] = l, this.int16[f + 9] = p, this.int16[f + 10] = c, this.int16[f + 11] = h, t1;
            }, e1;
        }(ki);
        Vi.prototype.bytesPerElement = 24, On("StructArrayLayout4i4ui4i24", Vi);
        var Fi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 3 * t1;
                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }, e1;
        }(ki);
        Fi.prototype.bytesPerElement = 12, On("StructArrayLayout3f12", Fi);
        var Di = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1) {
                var e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }, e1.prototype.emplace = function(t1, e1) {
                return this.uint32[1 * t1 + 0] = e1, t1;
            }, e1;
        }(ki);
        Di.prototype.bytesPerElement = 4, On("StructArrayLayout1ul4", Di);
        var Li = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u) {
                var l = this.length;
                return this.resize(l + 1), this.emplace(l, t1, e1, r, n, i, a, o, s, u);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l) {
                var p = 10 * t1, c = 5 * t1;
                return this.int16[p + 0] = e1, this.int16[p + 1] = r, this.int16[p + 2] = n, this.int16[p + 3] = i, this.int16[p + 4] = a, this.int16[p + 5] = o, this.uint32[c + 3] = s, this.uint16[p + 8] = u, this.uint16[p + 9] = l, t1;
            }, e1;
        }(ki);
        Li.prototype.bytesPerElement = 20, On("StructArrayLayout6i1ul2ui20", Li);
        var Oi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                var o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                var s = 6 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
            }, e1;
        }(ki);
        Oi.prototype.bytesPerElement = 12, On("StructArrayLayout2i2i2i12", Oi);
        var Ri = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i) {
                var a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a) {
                var o = 4 * t1, s = 8 * t1;
                return this.float32[o + 0] = e1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[s + 6] = i, this.int16[s + 7] = a, t1;
            }, e1;
        }(ki);
        Ri.prototype.bytesPerElement = 16, On("StructArrayLayout2f1f2i16", Ri);
        var Ui = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                var i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                var a = 12 * t1, o = 3 * t1;
                return this.uint8[a + 0] = e1, this.uint8[a + 1] = r, this.float32[o + 1] = n, this.float32[o + 2] = i, t1;
            }, e1;
        }(ki);
        Ui.prototype.bytesPerElement = 12, On("StructArrayLayout2ub2f12", Ui);
        var ji = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 3 * t1;
                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }, e1;
        }(ki);
        ji.prototype.bytesPerElement = 6, On("StructArrayLayout3ui6", ji);
        var qi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m) {
                var v = this.length;
                return this.resize(v + 1), this.emplace(v, t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v) {
                var g = 24 * t1, x = 12 * t1, b = 48 * t1;
                return this.int16[g + 0] = e1, this.int16[g + 1] = r, this.uint16[g + 2] = n, this.uint16[g + 3] = i, this.uint32[x + 2] = a, this.uint32[x + 3] = o, this.uint32[x + 4] = s, this.uint16[g + 10] = u, this.uint16[g + 11] = l, this.uint16[g + 12] = p, this.float32[x + 7] = c, this.float32[x + 8] = h, this.uint8[b + 36] = f, this.uint8[b + 37] = y, this.uint8[b + 38] = d, this.uint32[x + 10] = m, this.int16[g + 22] = v, t1;
            }, e1;
        }(ki);
        qi.prototype.bytesPerElement = 48, On("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", qi);
        var Ni = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, A, S, k, I, z) {
                var C = this.length;
                return this.resize(C + 1), this.emplace(C, t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, A, S, k, I, z);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, A, S, k, I, z, C) {
                var E = 34 * t1, P = 17 * t1;
                return this.int16[E + 0] = e1, this.int16[E + 1] = r, this.int16[E + 2] = n, this.int16[E + 3] = i, this.int16[E + 4] = a, this.int16[E + 5] = o, this.int16[E + 6] = s, this.int16[E + 7] = u, this.uint16[E + 8] = l, this.uint16[E + 9] = p, this.uint16[E + 10] = c, this.uint16[E + 11] = h, this.uint16[E + 12] = f, this.uint16[E + 13] = y, this.uint16[E + 14] = d, this.uint16[E + 15] = m, this.uint16[E + 16] = v, this.uint16[E + 17] = g, this.uint16[E + 18] = x, this.uint16[E + 19] = b, this.uint16[E + 20] = w, this.uint16[E + 21] = _, this.uint16[E + 22] = A, this.uint32[P + 12] = S, this.float32[P + 13] = k, this.float32[P + 14] = I, this.float32[P + 15] = z, this.float32[P + 16] = C, t1;
            }, e1;
        }(ki);
        Ni.prototype.bytesPerElement = 68, On("StructArrayLayout8i15ui1ul4f68", Ni);
        var Ki = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1) {
                var e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }, e1.prototype.emplace = function(t1, e1) {
                return this.float32[1 * t1 + 0] = e1, t1;
            }, e1;
        }(ki);
        Ki.prototype.bytesPerElement = 4, On("StructArrayLayout1f4", Ki);
        var Gi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 3 * t1;
                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }, e1;
        }(ki);
        Gi.prototype.bytesPerElement = 6, On("StructArrayLayout3i6", Gi);
        var Zi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 4 * t1;
                return this.uint32[2 * t1 + 0] = e1, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t1;
            }, e1;
        }(ki);
        Zi.prototype.bytesPerElement = 8, On("StructArrayLayout1ul2ui8", Zi);
        var Xi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1) {
                var r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }, e1.prototype.emplace = function(t1, e1, r) {
                var n = 2 * t1;
                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
            }, e1;
        }(ki);
        Xi.prototype.bytesPerElement = 4, On("StructArrayLayout2ui4", Xi);
        var Ji = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1) {
                var e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }, e1.prototype.emplace = function(t1, e1) {
                return this.uint16[1 * t1 + 0] = e1, t1;
            }, e1;
        }(ki);
        Ji.prototype.bytesPerElement = 2, On("StructArrayLayout1ui2", Ji);
        var Hi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                var i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                var a = 4 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
            }, e1;
        }(ki);
        Hi.prototype.bytesPerElement = 16, On("StructArrayLayout4f16", Hi);
        var Yi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                anchorPointX: {
                    configurable: !0
                },
                anchorPointY: {
                    configurable: !0
                },
                x1: {
                    configurable: !0
                },
                y1: {
                    configurable: !0
                },
                x2: {
                    configurable: !0
                },
                y2: {
                    configurable: !0
                },
                featureIndex: {
                    configurable: !0
                },
                sourceLayerIndex: {
                    configurable: !0
                },
                bucketIndex: {
                    configurable: !0
                },
                anchorPoint: {
                    configurable: !0
                }
            };
            return r.anchorPointX.get = function() {
                return this._structArray.int16[this._pos2 + 0];
            }, r.anchorPointY.get = function() {
                return this._structArray.int16[this._pos2 + 1];
            }, r.x1.get = function() {
                return this._structArray.int16[this._pos2 + 2];
            }, r.y1.get = function() {
                return this._structArray.int16[this._pos2 + 3];
            }, r.x2.get = function() {
                return this._structArray.int16[this._pos2 + 4];
            }, r.y2.get = function() {
                return this._structArray.int16[this._pos2 + 5];
            }, r.featureIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 3];
            }, r.sourceLayerIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 8];
            }, r.bucketIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 9];
            }, r.anchorPoint.get = function() {
                return new i(this.anchorPointX, this.anchorPointY);
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        Yi.prototype.size = 20;
        var $i = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new Yi(this, t1);
            }, e1;
        }(Li);
        On("CollisionBoxArray", $i);
        var Wi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                anchorX: {
                    configurable: !0
                },
                anchorY: {
                    configurable: !0
                },
                glyphStartIndex: {
                    configurable: !0
                },
                numGlyphs: {
                    configurable: !0
                },
                vertexStartIndex: {
                    configurable: !0
                },
                lineStartIndex: {
                    configurable: !0
                },
                lineLength: {
                    configurable: !0
                },
                segment: {
                    configurable: !0
                },
                lowerSize: {
                    configurable: !0
                },
                upperSize: {
                    configurable: !0
                },
                lineOffsetX: {
                    configurable: !0
                },
                lineOffsetY: {
                    configurable: !0
                },
                writingMode: {
                    configurable: !0
                },
                placedOrientation: {
                    configurable: !0
                },
                hidden: {
                    configurable: !0
                },
                crossTileID: {
                    configurable: !0
                },
                associatedIconIndex: {
                    configurable: !0
                }
            };
            return r.anchorX.get = function() {
                return this._structArray.int16[this._pos2 + 0];
            }, r.anchorY.get = function() {
                return this._structArray.int16[this._pos2 + 1];
            }, r.glyphStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 2];
            }, r.numGlyphs.get = function() {
                return this._structArray.uint16[this._pos2 + 3];
            }, r.vertexStartIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 2];
            }, r.lineStartIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 3];
            }, r.lineLength.get = function() {
                return this._structArray.uint32[this._pos4 + 4];
            }, r.segment.get = function() {
                return this._structArray.uint16[this._pos2 + 10];
            }, r.lowerSize.get = function() {
                return this._structArray.uint16[this._pos2 + 11];
            }, r.upperSize.get = function() {
                return this._structArray.uint16[this._pos2 + 12];
            }, r.lineOffsetX.get = function() {
                return this._structArray.float32[this._pos4 + 7];
            }, r.lineOffsetY.get = function() {
                return this._structArray.float32[this._pos4 + 8];
            }, r.writingMode.get = function() {
                return this._structArray.uint8[this._pos1 + 36];
            }, r.placedOrientation.get = function() {
                return this._structArray.uint8[this._pos1 + 37];
            }, r.placedOrientation.set = function(t1) {
                this._structArray.uint8[this._pos1 + 37] = t1;
            }, r.hidden.get = function() {
                return this._structArray.uint8[this._pos1 + 38];
            }, r.hidden.set = function(t1) {
                this._structArray.uint8[this._pos1 + 38] = t1;
            }, r.crossTileID.get = function() {
                return this._structArray.uint32[this._pos4 + 10];
            }, r.crossTileID.set = function(t1) {
                this._structArray.uint32[this._pos4 + 10] = t1;
            }, r.associatedIconIndex.get = function() {
                return this._structArray.int16[this._pos2 + 22];
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        Wi.prototype.size = 48;
        var Qi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new Wi(this, t1);
            }, e1;
        }(qi);
        On("PlacedSymbolArray", Qi);
        var ta = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                anchorX: {
                    configurable: !0
                },
                anchorY: {
                    configurable: !0
                },
                rightJustifiedTextSymbolIndex: {
                    configurable: !0
                },
                centerJustifiedTextSymbolIndex: {
                    configurable: !0
                },
                leftJustifiedTextSymbolIndex: {
                    configurable: !0
                },
                verticalPlacedTextSymbolIndex: {
                    configurable: !0
                },
                placedIconSymbolIndex: {
                    configurable: !0
                },
                verticalPlacedIconSymbolIndex: {
                    configurable: !0
                },
                key: {
                    configurable: !0
                },
                textBoxStartIndex: {
                    configurable: !0
                },
                textBoxEndIndex: {
                    configurable: !0
                },
                verticalTextBoxStartIndex: {
                    configurable: !0
                },
                verticalTextBoxEndIndex: {
                    configurable: !0
                },
                iconBoxStartIndex: {
                    configurable: !0
                },
                iconBoxEndIndex: {
                    configurable: !0
                },
                verticalIconBoxStartIndex: {
                    configurable: !0
                },
                verticalIconBoxEndIndex: {
                    configurable: !0
                },
                featureIndex: {
                    configurable: !0
                },
                numHorizontalGlyphVertices: {
                    configurable: !0
                },
                numVerticalGlyphVertices: {
                    configurable: !0
                },
                numIconVertices: {
                    configurable: !0
                },
                numVerticalIconVertices: {
                    configurable: !0
                },
                useRuntimeCollisionCircles: {
                    configurable: !0
                },
                crossTileID: {
                    configurable: !0
                },
                textBoxScale: {
                    configurable: !0
                },
                textOffset0: {
                    configurable: !0
                },
                textOffset1: {
                    configurable: !0
                },
                collisionCircleDiameter: {
                    configurable: !0
                }
            };
            return r.anchorX.get = function() {
                return this._structArray.int16[this._pos2 + 0];
            }, r.anchorY.get = function() {
                return this._structArray.int16[this._pos2 + 1];
            }, r.rightJustifiedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 2];
            }, r.centerJustifiedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 3];
            }, r.leftJustifiedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 4];
            }, r.verticalPlacedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 5];
            }, r.placedIconSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 6];
            }, r.verticalPlacedIconSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 7];
            }, r.key.get = function() {
                return this._structArray.uint16[this._pos2 + 8];
            }, r.textBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 9];
            }, r.textBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 10];
            }, r.verticalTextBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 11];
            }, r.verticalTextBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 12];
            }, r.iconBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 13];
            }, r.iconBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 14];
            }, r.verticalIconBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 15];
            }, r.verticalIconBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 16];
            }, r.featureIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 17];
            }, r.numHorizontalGlyphVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 18];
            }, r.numVerticalGlyphVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 19];
            }, r.numIconVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 20];
            }, r.numVerticalIconVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 21];
            }, r.useRuntimeCollisionCircles.get = function() {
                return this._structArray.uint16[this._pos2 + 22];
            }, r.crossTileID.get = function() {
                return this._structArray.uint32[this._pos4 + 12];
            }, r.crossTileID.set = function(t1) {
                this._structArray.uint32[this._pos4 + 12] = t1;
            }, r.textBoxScale.get = function() {
                return this._structArray.float32[this._pos4 + 13];
            }, r.textOffset0.get = function() {
                return this._structArray.float32[this._pos4 + 14];
            }, r.textOffset1.get = function() {
                return this._structArray.float32[this._pos4 + 15];
            }, r.collisionCircleDiameter.get = function() {
                return this._structArray.float32[this._pos4 + 16];
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        ta.prototype.size = 68;
        var ea = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new ta(this, t1);
            }, e1;
        }(Ni);
        On("SymbolInstanceArray", ea);
        var ra = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getoffsetX = function(t1) {
                return this.float32[1 * t1 + 0];
            }, e1;
        }(Ki);
        On("GlyphOffsetArray", ra);
        var na = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getx = function(t1) {
                return this.int16[3 * t1 + 0];
            }, e1.prototype.gety = function(t1) {
                return this.int16[3 * t1 + 1];
            }, e1.prototype.gettileUnitDistanceFromAnchor = function(t1) {
                return this.int16[3 * t1 + 2];
            }, e1;
        }(Gi);
        On("SymbolLineVertexArray", na);
        var ia = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                featureIndex: {
                    configurable: !0
                },
                sourceLayerIndex: {
                    configurable: !0
                },
                bucketIndex: {
                    configurable: !0
                }
            };
            return r.featureIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 0];
            }, r.sourceLayerIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 2];
            }, r.bucketIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 3];
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        ia.prototype.size = 8;
        var aa = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new ia(this, t1);
            }, e1;
        }(Zi);
        On("FeatureIndexArray", aa);
        var oa = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4).members, sa = function(t1) {
            void 0 === t1 && (t1 = []), this.segments = t1;
        };
        function ua(t1, e1) {
            return 256 * (t1 = p(Math.floor(t1), 0, 255)) + p(Math.floor(e1), 0, 255);
        }
        sa.prototype.prepareSegment = function(t1, e1, r, n) {
            var i = this.segments[this.segments.length - 1];
            return t1 > sa.MAX_VERTEX_ARRAY_LENGTH && A("Max vertices per segment is " + sa.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + t1), (!i || i.vertexLength + t1 > sa.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                vertexOffset: e1.length,
                primitiveOffset: r.length,
                vertexLength: 0,
                primitiveLength: 0
            }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
        }, sa.prototype.get = function() {
            return this.segments;
        }, sa.prototype.destroy = function() {
            for(var t1 = 0, e1 = this.segments; t1 < e1.length; t1 += 1){
                var r = e1[t1];
                for(var n in r.vaos)r.vaos[n].destroy();
            }
        }, sa.simpleSegment = function(t1, e1, r, n) {
            return new sa([
                {
                    vertexOffset: t1,
                    primitiveOffset: e1,
                    vertexLength: r,
                    primitiveLength: n,
                    vaos: {},
                    sortKey: 0
                }
            ]);
        }, sa.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, On("SegmentVector", sa);
        var la = Ii([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]), pa = e1(function(t1) {
            t1.exports = function(t1, e1) {
                var r, n, i, a, o, s, u, l;
                for(n = t1.length - (r = 3 & t1.length), i = e1, o = 3432918353, s = 461845907, l = 0; l < n;)u = 255 & t1.charCodeAt(l) | (255 & t1.charCodeAt(++l)) << 8 | (255 & t1.charCodeAt(++l)) << 16 | (255 & t1.charCodeAt(++l)) << 24, ++l, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= u = (65535 & (u = (u = (65535 & u) * o + (((u >>> 16) * o & 65535) << 16) & 4294967295) << 15 | u >>> 17)) * s + (((u >>> 16) * s & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
                switch(u = 0, r){
                    case 3:
                        u ^= (255 & t1.charCodeAt(l + 2)) << 16;
                    case 2:
                        u ^= (255 & t1.charCodeAt(l + 1)) << 8;
                    case 1:
                        i ^= u = (65535 & (u = (u = (65535 & (u ^= 255 & t1.charCodeAt(l))) * o + (((u >>> 16) * o & 65535) << 16) & 4294967295) << 15 | u >>> 17)) * s + (((u >>> 16) * s & 65535) << 16) & 4294967295;
                }
                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            };
        }), ca = e1(function(t1) {
            t1.exports = function(t1, e1) {
                for(var r, n = t1.length, i = e1 ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
                switch(n){
                    case 3:
                        i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                    case 2:
                        i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            };
        }), ha = pa, fa = ca;
        ha.murmur3 = pa, ha.murmur2 = fa;
        var ya = function() {
            this.ids = [], this.positions = [], this.indexed = !1;
        };
        ya.prototype.add = function(t1, e1, r, n) {
            this.ids.push(ma(t1)), this.positions.push(e1, r, n);
        }, ya.prototype.getPositions = function(t1) {
            for(var e1 = ma(t1), r = 0, n = this.ids.length - 1; r < n;){
                var i = r + n >> 1;
                this.ids[i] >= e1 ? n = i : r = i + 1;
            }
            for(var a = []; this.ids[r] === e1;)a.push({
                index: this.positions[3 * r],
                start: this.positions[3 * r + 1],
                end: this.positions[3 * r + 2]
            }), r++;
            return a;
        }, ya.serialize = function(t1, e1) {
            var r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
            return function t1(e1, r, n, i) {
                for(; n < i;){
                    for(var a = e1[n + i >> 1], o = n - 1, s = i + 1;;){
                        do o++;
                        while (e1[o] < a);
                        do s--;
                        while (e1[s] > a);
                        if (o >= s) break;
                        va(e1, o, s), va(r, 3 * o, 3 * s), va(r, 3 * o + 1, 3 * s + 1), va(r, 3 * o + 2, 3 * s + 2);
                    }
                    s - n < i - s ? (t1(e1, r, n, s), n = s + 1) : (t1(e1, r, s + 1, i), i = s);
                }
            }(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                ids: r,
                positions: n
            };
        }, ya.deserialize = function(t1) {
            var e1 = new ya;
            return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
        };
        var da = Math.pow(2, 53) - 1;
        function ma(t1) {
            var e1 = +t1;
            return !isNaN(e1) && e1 <= da ? e1 : ha(String(t1));
        }
        function va(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        On("FeaturePositionMap", ya);
        var ga = function(t1, e1) {
            this.gl = t1.gl, this.location = e1;
        }, xa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = 0;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1i(this.location, t1));
            }, e1;
        }(ga), ba = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = 0;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1f(this.location, t1));
            }, e1;
        }(ga), wa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = [
                    0,
                    0
                ];
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] || (this.current = t1, this.gl.uniform2f(this.location, t1[0], t1[1]));
            }, e1;
        }(ga), _a = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = [
                    0,
                    0,
                    0
                ];
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] || (this.current = t1, this.gl.uniform3f(this.location, t1[0], t1[1], t1[2]));
            }, e1;
        }(ga), Aa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] && t1[3] === this.current[3] || (this.current = t1, this.gl.uniform4f(this.location, t1[0], t1[1], t1[2], t1[3]));
            }, e1;
        }(ga), Sa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = te.transparent;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1.r === this.current.r && t1.g === this.current.g && t1.b === this.current.b && t1.a === this.current.a || (this.current = t1, this.gl.uniform4f(this.location, t1.r, t1.g, t1.b, t1.a));
            }, e1;
        }(ga), ka = new Float32Array(16), Ia = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = ka;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                if (t1[12] !== this.current[12] || t1[0] !== this.current[0]) return this.current = t1, void this.gl.uniformMatrix4fv(this.location, !1, t1);
                for(var e1 = 1; e1 < 16; e1++)if (t1[e1] !== this.current[e1]) {
                    this.current = t1, this.gl.uniformMatrix4fv(this.location, !1, t1);
                    break;
                }
            }, e1;
        }(ga);
        function za(t1) {
            return [
                ua(255 * t1.r, 255 * t1.g),
                ua(255 * t1.b, 255 * t1.a)
            ];
        }
        var Ca = function(t1, e1, r) {
            this.value = t1, this.uniformNames = e1.map(function(t1) {
                return "u_" + t1;
            }), this.type = r;
        };
        Ca.prototype.setUniform = function(t1, e1, r) {
            t1.set(r.constantOr(this.value));
        }, Ca.prototype.getBinding = function(t1, e1, r) {
            return "color" === this.type ? new Sa(t1, e1) : new ba(t1, e1);
        };
        var Ea = function(t1, e1) {
            this.uniformNames = e1.map(function(t1) {
                return "u_" + t1;
            }), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
        };
        Ea.prototype.setConstantPatternPositions = function(t1, e1) {
            this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t1.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t1.tlbr;
        }, Ea.prototype.setUniform = function(t1, e1, r, n) {
            var i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
            i && t1.set(i);
        }, Ea.prototype.getBinding = function(t1, e1, r) {
            return "u_pattern" === r.substr(0, 9) ? new Aa(t1, e1) : new ba(t1, e1);
        };
        var Pa = function(t1, e1, r, n) {
            this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                return {
                    name: "a_" + t1,
                    type: "Float32",
                    components: "color" === r ? 2 : 1,
                    offset: 0
                };
            }), this.paintVertexArray = new n;
        };
        Pa.prototype.populatePaintArray = function(t1, e1, r, n, i) {
            var a = this.paintVertexArray.length, o = this.expression.evaluate(new si(0), e1, {}, n, [], i);
            this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, o);
        }, Pa.prototype.updatePaintArray = function(t1, e1, r, n) {
            var i = this.expression.evaluate({
                zoom: 0
            }, r, n);
            this._setPaintValue(t1, e1, i);
        }, Pa.prototype._setPaintValue = function(t1, e1, r) {
            if ("color" === this.type) for(var n = za(r), i = t1; i < e1; i++)this.paintVertexArray.emplace(i, n[0], n[1]);
            else {
                for(var a = t1; a < e1; a++)this.paintVertexArray.emplace(a, r);
                this.maxValue = Math.max(this.maxValue, Math.abs(r));
            }
        }, Pa.prototype.upload = function(t1) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }, Pa.prototype.destroy = function() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        };
        var Ma = function(t1, e1, r, n, i, a) {
            this.expression = t1, this.uniformNames = e1.map(function(t1) {
                return "u_" + t1 + "_t";
            }), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                return {
                    name: "a_" + t1,
                    type: "Float32",
                    components: "color" === r ? 4 : 2,
                    offset: 0
                };
            }), this.paintVertexArray = new a;
        };
        Ma.prototype.populatePaintArray = function(t1, e1, r, n, i) {
            var a = this.expression.evaluate(new si(this.zoom), e1, {}, n, [], i), o = this.expression.evaluate(new si(this.zoom + 1), e1, {}, n, [], i), s = this.paintVertexArray.length;
            this.paintVertexArray.resize(t1), this._setPaintValue(s, t1, a, o);
        }, Ma.prototype.updatePaintArray = function(t1, e1, r, n) {
            var i = this.expression.evaluate({
                zoom: this.zoom
            }, r, n), a = this.expression.evaluate({
                zoom: this.zoom + 1
            }, r, n);
            this._setPaintValue(t1, e1, i, a);
        }, Ma.prototype._setPaintValue = function(t1, e1, r, n) {
            if ("color" === this.type) for(var i = za(r), a = za(n), o = t1; o < e1; o++)this.paintVertexArray.emplace(o, i[0], i[1], a[0], a[1]);
            else {
                for(var s = t1; s < e1; s++)this.paintVertexArray.emplace(s, r, n);
                this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
            }
        }, Ma.prototype.upload = function(t1) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }, Ma.prototype.destroy = function() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }, Ma.prototype.setUniform = function(t1, e1) {
            var r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, n = p(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
            t1.set(n);
        }, Ma.prototype.getBinding = function(t1, e1, r) {
            return new ba(t1, e1);
        };
        var Ba = function(t1, e1, r, n, i, a) {
            this.expression = t1, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
        };
        Ba.prototype.populatePaintArray = function(t1, e1, r) {
            var n = this.zoomInPaintVertexArray.length;
            this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
        }, Ba.prototype.updatePaintArray = function(t1, e1, r, n, i) {
            this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], i);
        }, Ba.prototype._setPaintValues = function(t1, e1, r, n) {
            if (n && r) {
                var i = n[r.min], a = n[r.mid], o = n[r.max];
                if (i && a && o) for(var s = t1; s < e1; s++)this.zoomInPaintVertexArray.emplace(s, a.tl[0], a.tl[1], a.br[0], a.br[1], i.tl[0], i.tl[1], i.br[0], i.br[1], a.pixelRatio, i.pixelRatio), this.zoomOutPaintVertexArray.emplace(s, a.tl[0], a.tl[1], a.br[0], a.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], a.pixelRatio, o.pixelRatio);
            }
        }, Ba.prototype.upload = function(t1) {
            this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, la.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, la.members, this.expression.isStateDependent));
        }, Ba.prototype.destroy = function() {
            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
        };
        var Ta = function(t1, e1, r) {
            this.binders = {}, this._buffers = [];
            var n = [];
            for(var i in t1.paint._values)if (r(i)) {
                var a = t1.paint.get(i);
                if (a instanceof yi && Tr(a.property.specification)) {
                    var o = Fa(i, t1.type), s = a.value, u = a.property.specification.type, l = a.property.useIntegerZoom, p = a.property.specification["property-type"], c = "cross-faded" === p || "cross-faded-data-driven" === p;
                    if ("constant" === s.kind) this.binders[i] = c ? new Ea(s.value, o) : new Ca(s.value, o, u), n.push("/u_" + i);
                    else if ("source" === s.kind || c) {
                        var h = Da(i, u, "source");
                        this.binders[i] = c ? new Ba(s, u, l, e1, h, t1.id) : new Pa(s, o, u, h), n.push("/a_" + i);
                    } else {
                        var f = Da(i, u, "composite");
                        this.binders[i] = new Ma(s, o, u, l, e1, f), n.push("/z_" + i);
                    }
                }
            }
            this.cacheKey = n.sort().join("");
        };
        Ta.prototype.getMaxValue = function(t1) {
            var e1 = this.binders[t1];
            return e1 instanceof Pa || e1 instanceof Ma ? e1.maxValue : 0;
        }, Ta.prototype.populatePaintArrays = function(t1, e1, r, n, i) {
            for(var a in this.binders){
                var o = this.binders[a];
                (o instanceof Pa || o instanceof Ma || o instanceof Ba) && o.populatePaintArray(t1, e1, r, n, i);
            }
        }, Ta.prototype.setConstantPatternPositions = function(t1, e1) {
            for(var r in this.binders){
                var n = this.binders[r];
                n instanceof Ea && n.setConstantPatternPositions(t1, e1);
            }
        }, Ta.prototype.updatePaintArrays = function(t1, e1, r, n, i) {
            var a = !1;
            for(var o in t1)for(var s = 0, u = e1.getPositions(o); s < u.length; s += 1){
                var l = u[s], p = r.feature(l.index);
                for(var c in this.binders){
                    var h = this.binders[c];
                    if ((h instanceof Pa || h instanceof Ma || h instanceof Ba) && !0 === h.expression.isStateDependent) {
                        var f = n.paint.get(c);
                        h.expression = f.value, h.updatePaintArray(l.start, l.end, p, t1[o], i), a = !0;
                    }
                }
            }
            return a;
        }, Ta.prototype.defines = function() {
            var t1 = [];
            for(var e1 in this.binders){
                var r = this.binders[e1];
                (r instanceof Ca || r instanceof Ea) && t1.push.apply(t1, r.uniformNames.map(function(t1) {
                    return "#define HAS_UNIFORM_" + t1;
                }));
            }
            return t1;
        }, Ta.prototype.getBinderAttributes = function() {
            var t1 = [];
            for(var e1 in this.binders){
                var r = this.binders[e1];
                if (r instanceof Pa || r instanceof Ma) for(var n = 0; n < r.paintVertexAttributes.length; n++)t1.push(r.paintVertexAttributes[n].name);
                else if (r instanceof Ba) for(var i = 0; i < la.members.length; i++)t1.push(la.members[i].name);
            }
            return t1;
        }, Ta.prototype.getBinderUniforms = function() {
            var t1 = [];
            for(var e1 in this.binders){
                var r = this.binders[e1];
                if (r instanceof Ca || r instanceof Ea || r instanceof Ma) for(var n = 0, i = r.uniformNames; n < i.length; n += 1)t1.push(i[n]);
            }
            return t1;
        }, Ta.prototype.getPaintVertexBuffers = function() {
            return this._buffers;
        }, Ta.prototype.getUniforms = function(t1, e1) {
            var r = [];
            for(var n in this.binders){
                var i = this.binders[n];
                if (i instanceof Ca || i instanceof Ea || i instanceof Ma) for(var a = 0, o = i.uniformNames; a < o.length; a += 1){
                    var s = o[a];
                    if (e1[s]) {
                        var u = i.getBinding(t1, e1[s], s);
                        r.push({
                            name: s,
                            property: n,
                            binding: u
                        });
                    }
                }
            }
            return r;
        }, Ta.prototype.setUniforms = function(t1, e1, r, n) {
            for(var i = 0, a = e1; i < a.length; i += 1){
                var o = a[i], s = o.name, u = o.property;
                this.binders[u].setUniform(o.binding, n, r.get(u), s);
            }
        }, Ta.prototype.updatePaintBuffers = function(t1) {
            for(var e1 in this._buffers = [], this.binders){
                var r = this.binders[e1];
                if (t1 && r instanceof Ba) {
                    var n = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                    n && this._buffers.push(n);
                } else (r instanceof Pa || r instanceof Ma) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
            }
        }, Ta.prototype.upload = function(t1) {
            for(var e1 in this.binders){
                var r = this.binders[e1];
                (r instanceof Pa || r instanceof Ma || r instanceof Ba) && r.upload(t1);
            }
            this.updatePaintBuffers();
        }, Ta.prototype.destroy = function() {
            for(var t1 in this.binders){
                var e1 = this.binders[t1];
                (e1 instanceof Pa || e1 instanceof Ma || e1 instanceof Ba) && e1.destroy();
            }
        };
        var Va = function(t1, e1, r) {
            void 0 === r && (r = function() {
                return !0;
            }), this.programConfigurations = {};
            for(var n = 0, i = t1; n < i.length; n += 1){
                var a = i[n];
                this.programConfigurations[a.id] = new Ta(a, e1, r);
            }
            this.needsUpload = !1, this._featureMap = new ya, this._bufferOffset = 0;
        };
        function Fa(t1, e1) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t1] || [
                t1.replace(e1 + "-", "").replace(/-/g, "_")
            ];
        }
        function Da(t1, e1, r) {
            var n = {
                color: {
                    source: Bi,
                    composite: Hi
                },
                number: {
                    source: Ki,
                    composite: Bi
                }
            }, i = function(t1) {
                return ({
                    "line-pattern": {
                        source: Ti,
                        composite: Ti
                    },
                    "fill-pattern": {
                        source: Ti,
                        composite: Ti
                    },
                    "fill-extrusion-pattern": {
                        source: Ti,
                        composite: Ti
                    }
                })[t1];
            }(t1);
            return i && i[r] || n[e1][r];
        }
        Va.prototype.populatePaintArrays = function(t1, e1, r, n, i, a) {
            for(var o in this.programConfigurations)this.programConfigurations[o].populatePaintArrays(t1, e1, n, i, a);
            void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
        }, Va.prototype.updatePaintArrays = function(t1, e1, r, n) {
            for(var i = 0, a = r; i < a.length; i += 1){
                var o = a[i];
                this.needsUpload = this.programConfigurations[o.id].updatePaintArrays(t1, this._featureMap, e1, o, n) || this.needsUpload;
            }
        }, Va.prototype.get = function(t1) {
            return this.programConfigurations[t1];
        }, Va.prototype.upload = function(t1) {
            if (this.needsUpload) {
                for(var e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                this.needsUpload = !1;
            }
        }, Va.prototype.destroy = function() {
            for(var t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
        }, On("ConstantBinder", Ca), On("CrossFadedConstantBinder", Ea), On("SourceExpressionBinder", Pa), On("CrossFadedCompositeBinder", Ba), On("CompositeExpressionBinder", Ma), On("ProgramConfiguration", Ta, {
            omit: [
                "_buffers"
            ]
        }), On("ProgramConfigurationSet", Va);
        var La = Math.pow(2, 14) - 1, Oa = -La - 1;
        function Ra(t1) {
            for(var e1 = 8192 / t1.extent, r = t1.loadGeometry(), n = 0; n < r.length; n++)for(var i = r[n], a = 0; a < i.length; a++){
                var o = i[a], s = Math.round(o.x * e1), u = Math.round(o.y * e1);
                o.x = p(s, Oa, La), o.y = p(u, Oa, La), (s < o.x || s > o.x + 1 || u < o.y || u > o.y + 1) && A("Geometry exceeds allowed extent, reduce your vector tile buffer size");
            }
            return r;
        }
        function Ua(t1, e1) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e1 ? Ra(t1) : []
            };
        }
        function ja(t1, e1, r, n, i) {
            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        var qa = function(t1) {
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new Ci, this.indexArray = new ji, this.segments = new sa, this.programConfigurations = new Va(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        function Na(t1, e1) {
            for(var r = 0; r < t1.length; r++)if (Wa(e1, t1[r])) return !0;
            for(var n = 0; n < e1.length; n++)if (Wa(t1, e1[n])) return !0;
            return !!Xa(t1, e1);
        }
        function Ka(t1, e1, r) {
            return !!Wa(t1, e1) || !!Ha(e1, t1, r);
        }
        function Ga(t1, e1) {
            if (1 === t1.length) return $a(e1, t1[0]);
            for(var r = 0; r < e1.length; r++)for(var n = e1[r], i = 0; i < n.length; i++)if (Wa(t1, n[i])) return !0;
            for(var a = 0; a < t1.length; a++)if ($a(e1, t1[a])) return !0;
            for(var o = 0; o < e1.length; o++)if (Xa(t1, e1[o])) return !0;
            return !1;
        }
        function Za(t1, e1, r) {
            if (t1.length > 1) {
                if (Xa(t1, e1)) return !0;
                for(var n = 0; n < e1.length; n++)if (Ha(e1[n], t1, r)) return !0;
            }
            for(var i = 0; i < t1.length; i++)if (Ha(t1[i], e1, r)) return !0;
            return !1;
        }
        function Xa(t1, e1) {
            if (0 === t1.length || 0 === e1.length) return !1;
            for(var r = 0; r < t1.length - 1; r++)for(var n = t1[r], i = t1[r + 1], a = 0; a < e1.length - 1; a++)if (Ja(n, i, e1[a], e1[a + 1])) return !0;
            return !1;
        }
        function Ja(t1, e1, r, n) {
            return S(t1, r, n) !== S(e1, r, n) && S(t1, e1, r) !== S(t1, e1, n);
        }
        function Ha(t1, e1, r) {
            var n = r * r;
            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
            for(var i = 1; i < e1.length; i++)if (Ya(t1, e1[i - 1], e1[i]) < n) return !0;
            return !1;
        }
        function Ya(t1, e1, r) {
            var n = e1.distSqr(r);
            if (0 === n) return t1.distSqr(e1);
            var i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
            return t1.distSqr(i < 0 ? e1 : i > 1 ? r : r.sub(e1)._mult(i)._add(e1));
        }
        function $a(t1, e1) {
            for(var r, n, i, a = !1, o = 0; o < t1.length; o++)for(var s = 0, u = (r = t1[o]).length - 1; s < r.length; u = s++)(n = r[s]).y > e1.y != (i = r[u]).y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (a = !a);
            return a;
        }
        function Wa(t1, e1) {
            for(var r = !1, n = 0, i = t1.length - 1; n < t1.length; i = n++){
                var a = t1[n], o = t1[i];
                a.y > e1.y != o.y > e1.y && e1.x < (o.x - a.x) * (e1.y - a.y) / (o.y - a.y) + a.x && (r = !r);
            }
            return r;
        }
        function Qa(t1, e1, r) {
            var n = r[0], i = r[2];
            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
            var a = S(t1, e1, r[0]);
            return a !== S(t1, e1, r[1]) || a !== S(t1, e1, r[2]) || a !== S(t1, e1, r[3]);
        }
        function to(t1, e1, r) {
            var n = e1.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
        }
        function eo(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function ro(t1, e1, r, n, a) {
            if (!e1[0] && !e1[1]) return t1;
            var o = i.convert(e1)._mult(a);
            "viewport" === r && o._rotate(-n);
            for(var s = [], u = 0; u < t1.length; u++)s.push(t1[u].sub(o));
            return s;
        }
        qa.prototype.populate = function(t1, e1, r) {
            var n = this.layers[0], i = [], a = null;
            "circle" === n.type && (a = n.layout.get("circle-sort-key"));
            for(var o = 0, s = t1; o < s.length; o += 1){
                var u = s[o], l = u.feature, p = u.id, c = u.index, h = u.sourceLayerIndex, f = this.layers[0]._featureFilter.needGeometry, y = Ua(l, f);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), y, r)) {
                    var d = a ? a.evaluate(y, {}, r) : void 0, m = {
                        id: p,
                        properties: l.properties,
                        type: l.type,
                        sourceLayerIndex: h,
                        index: c,
                        geometry: f ? y.geometry : Ra(l),
                        patterns: {},
                        sortKey: d
                    };
                    i.push(m);
                }
            }
            a && i.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var v = 0, g = i; v < g.length; v += 1){
                var x = g[v], b = x.geometry, w = x.index, _ = x.sourceLayerIndex, A = t1[w].feature;
                this.addFeature(x, b, w, r), e1.featureIndex.insert(A, b, w, _, this.index);
            }
        }, qa.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, qa.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, qa.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, qa.prototype.upload = function(t1) {
            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, oa), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, qa.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }, qa.prototype.addFeature = function(t1, e1, r, n) {
            for(var i = 0, a = e1; i < a.length; i += 1)for(var o = 0, s = a[i]; o < s.length; o += 1){
                var u = s[o], l = u.x, p = u.y;
                if (!(l < 0 || l >= 8192 || p < 0 || p >= 8192)) {
                    var c = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), h = c.vertexLength;
                    ja(this.layoutVertexArray, l, p, -1, -1), ja(this.layoutVertexArray, l, p, 1, -1), ja(this.layoutVertexArray, l, p, 1, 1), ja(this.layoutVertexArray, l, p, -1, 1), this.indexArray.emplaceBack(h, h + 1, h + 2), this.indexArray.emplaceBack(h, h + 3, h + 2), c.vertexLength += 4, c.primitiveLength += 2;
                }
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n);
        }, On("CircleBucket", qa, {
            omit: [
                "layers"
            ]
        });
        var no = new wi({
            "circle-sort-key": new vi(Et.layout_circle["circle-sort-key"])
        }), io = {
            paint: new wi({
                "circle-radius": new vi(Et.paint_circle["circle-radius"]),
                "circle-color": new vi(Et.paint_circle["circle-color"]),
                "circle-blur": new vi(Et.paint_circle["circle-blur"]),
                "circle-opacity": new vi(Et.paint_circle["circle-opacity"]),
                "circle-translate": new mi(Et.paint_circle["circle-translate"]),
                "circle-translate-anchor": new mi(Et.paint_circle["circle-translate-anchor"]),
                "circle-pitch-scale": new mi(Et.paint_circle["circle-pitch-scale"]),
                "circle-pitch-alignment": new mi(Et.paint_circle["circle-pitch-alignment"]),
                "circle-stroke-width": new vi(Et.paint_circle["circle-stroke-width"]),
                "circle-stroke-color": new vi(Et.paint_circle["circle-stroke-color"]),
                "circle-stroke-opacity": new vi(Et.paint_circle["circle-stroke-opacity"])
            }),
            layout: no
        }, ao = "undefined" != typeof Float32Array ? Float32Array : Array;
        function oo(t1) {
            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function so(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], u = e1[5], l = e1[6], p = e1[7], c = e1[8], h = e1[9], f = e1[10], y = e1[11], d = e1[12], m = e1[13], v = e1[14], g = e1[15], x = r[0], b = r[1], w = r[2], _ = r[3];
            return t1[0] = x * n + b * s + w * c + _ * d, t1[1] = x * i + b * u + w * h + _ * m, t1[2] = x * a + b * l + w * f + _ * v, t1[3] = x * o + b * p + w * y + _ * g, t1[4] = (x = r[4]) * n + (b = r[5]) * s + (w = r[6]) * c + (_ = r[7]) * d, t1[5] = x * i + b * u + w * h + _ * m, t1[6] = x * a + b * l + w * f + _ * v, t1[7] = x * o + b * p + w * y + _ * g, t1[8] = (x = r[8]) * n + (b = r[9]) * s + (w = r[10]) * c + (_ = r[11]) * d, t1[9] = x * i + b * u + w * h + _ * m, t1[10] = x * a + b * l + w * f + _ * v, t1[11] = x * o + b * p + w * y + _ * g, t1[12] = (x = r[12]) * n + (b = r[13]) * s + (w = r[14]) * c + (_ = r[15]) * d, t1[13] = x * i + b * u + w * h + _ * m, t1[14] = x * a + b * l + w * f + _ * v, t1[15] = x * o + b * p + w * y + _ * g, t1;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t1 = arguments, e1 = 0, r = arguments.length; r--;)e1 += t1[r] * t1[r];
            return Math.sqrt(e1);
        });
        var uo, lo = so;
        function po(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = e1[3];
            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t1;
        }
        uo = new ao(3), ao != Float32Array && (uo[0] = 0, uo[1] = 0, uo[2] = 0), function() {
            var t1 = new ao(4);
            ao != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0);
        }();
        var co = (function() {
            var t1 = new ao(2);
            ao != Float32Array && (t1[0] = 0, t1[1] = 0);
        }(), function(t1) {
            function e1(e1) {
                t1.call(this, e1, io);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.createBucket = function(t1) {
                return new qa(t1);
            }, e1.prototype.queryRadius = function(t1) {
                var e1 = t1;
                return to("circle-radius", this, e1) + to("circle-stroke-width", this, e1) + eo(this.paint.get("circle-translate"));
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o, s) {
                for(var u = ro(t1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, o), l = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r), p = "map" === this.paint.get("circle-pitch-alignment"), c = p ? u : function(t1, e1) {
                    return t1.map(function(t1) {
                        return ho(t1, e1);
                    });
                }(u, s), h = p ? l * o : l, f = 0, y = n; f < y.length; f += 1)for(var d = 0, m = y[f]; d < m.length; d += 1){
                    var v = m[d], g = p ? v : ho(v, s), x = h, b = po([], [
                        v.x,
                        v.y,
                        0,
                        1
                    ], s);
                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? x *= b[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (x *= a.cameraToCenterDistance / b[3]), Ka(c, g, x)) return !0;
                }
                return !1;
            }, e1;
        }(_i));
        function ho(t1, e1) {
            var r = po([], [
                t1.x,
                t1.y,
                0,
                1
            ], e1);
            return new i(r[0] / r[3], r[1] / r[3]);
        }
        var fo = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(qa);
        function yo(t1, e1, r, n) {
            var i = e1.width, a = e1.height;
            if (n) {
                if (n instanceof Uint8ClampedArray) n = new Uint8Array(n.buffer);
                else if (n.length !== i * a * r) throw new RangeError("mismatched image size");
            } else n = new Uint8Array(i * a * r);
            return t1.width = i, t1.height = a, t1.data = n, t1;
        }
        function mo(t1, e1, r) {
            var n = e1.width, i = e1.height;
            if (n !== t1.width || i !== t1.height) {
                var a = yo({}, {
                    width: n,
                    height: i
                }, r);
                vo(t1, a, {
                    x: 0,
                    y: 0
                }, {
                    x: 0,
                    y: 0
                }, {
                    width: Math.min(t1.width, n),
                    height: Math.min(t1.height, i)
                }, r), t1.width = n, t1.height = i, t1.data = a.data;
            }
        }
        function vo(t1, e1, r, n, i, a) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            for(var o = t1.data, s = e1.data, u = 0; u < i.height; u++)for(var l = ((r.y + u) * t1.width + r.x) * a, p = ((n.y + u) * e1.width + n.x) * a, c = 0; c < i.width * a; c++)s[p + c] = o[l + c];
            return e1;
        }
        On("HeatmapBucket", fo, {
            omit: [
                "layers"
            ]
        });
        var go = function(t1, e1) {
            yo(this, t1, 1, e1);
        };
        go.prototype.resize = function(t1) {
            mo(this, t1, 1);
        }, go.prototype.clone = function() {
            return new go({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }, go.copy = function(t1, e1, r, n, i) {
            vo(t1, e1, r, n, i, 1);
        };
        var xo = function(t1, e1) {
            yo(this, t1, 4, e1);
        };
        xo.prototype.resize = function(t1) {
            mo(this, t1, 4);
        }, xo.prototype.replace = function(t1, e1) {
            e1 ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
        }, xo.prototype.clone = function() {
            return new xo({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }, xo.copy = function(t1, e1, r, n, i) {
            vo(t1, e1, r, n, i, 4);
        }, On("AlphaImage", go), On("RGBAImage", xo);
        var bo = {
            paint: new wi({
                "heatmap-radius": new vi(Et.paint_heatmap["heatmap-radius"]),
                "heatmap-weight": new vi(Et.paint_heatmap["heatmap-weight"]),
                "heatmap-intensity": new mi(Et.paint_heatmap["heatmap-intensity"]),
                "heatmap-color": new bi(Et.paint_heatmap["heatmap-color"]),
                "heatmap-opacity": new mi(Et.paint_heatmap["heatmap-opacity"])
            })
        };
        function wo(t1) {
            var e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new xo({
                width: r,
                height: n
            }), a = function(r, n, a) {
                e1[t1.evaluationKey] = a;
                var o = t1.expression.evaluate(e1);
                i.data[r + n + 0] = Math.floor(255 * o.r / o.a), i.data[r + n + 1] = Math.floor(255 * o.g / o.a), i.data[r + n + 2] = Math.floor(255 * o.b / o.a), i.data[r + n + 3] = Math.floor(255 * o.a);
            };
            if (t1.clips) for(var o = 0, s = 0; o < n; ++o, s += 4 * r)for(var u = 0, l = 0; u < r; u++, l += 4){
                var p = u / (r - 1), c = t1.clips[o];
                a(s, l, c.start * (1 - p) + c.end * p);
            }
            else for(var h = 0, f = 0; h < r; h++, f += 4)a(0, f, h / (r - 1));
            return i;
        }
        var _o = function(t1) {
            function e1(e1) {
                t1.call(this, e1, bo), this._updateColorRamp();
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.createBucket = function(t1) {
                return new fo(t1);
            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                "heatmap-color" === t1 && this._updateColorRamp();
            }, e1.prototype._updateColorRamp = function() {
                this.colorRamp = wo({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }, e1.prototype.resize = function() {
                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
            }, e1.prototype.queryRadius = function() {
                return 0;
            }, e1.prototype.queryIntersectsFeature = function() {
                return !1;
            }, e1.prototype.hasOffscreenPass = function() {
                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }, e1;
        }(_i), Ao = {
            paint: new wi({
                "hillshade-illumination-direction": new mi(Et.paint_hillshade["hillshade-illumination-direction"]),
                "hillshade-illumination-anchor": new mi(Et.paint_hillshade["hillshade-illumination-anchor"]),
                "hillshade-exaggeration": new mi(Et.paint_hillshade["hillshade-exaggeration"]),
                "hillshade-shadow-color": new mi(Et.paint_hillshade["hillshade-shadow-color"]),
                "hillshade-highlight-color": new mi(Et.paint_hillshade["hillshade-highlight-color"]),
                "hillshade-accent-color": new mi(Et.paint_hillshade["hillshade-accent-color"])
            })
        }, So = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Ao);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.hasOffscreenPass = function() {
                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }, e1;
        }(_i), ko = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4).members, Io = Co, zo = Co;
        function Co(t1, e1, r) {
            r = r || 2;
            var n, i, a, o, s, u, l, p = e1 && e1.length, c = p ? e1[0] * r : t1.length, h = Eo(t1, 0, c, r, !0), f = [];
            if (!h || h.next === h.prev) return f;
            if (p && (h = function(t1, e1, r, n) {
                var i, a, o, s = [];
                for(i = 0, a = e1.length; i < a; i++)(o = Eo(t1, e1[i] * n, i < a - 1 ? e1[i + 1] * n : t1.length, n, !1)) === o.next && (o.steiner = !0), s.push(Uo(o));
                for(s.sort(Do), i = 0; i < s.length; i++)Lo(s[i], r), r = Po(r, r.next);
                return r;
            }(t1, e1, h, r)), t1.length > 80 * r) {
                n = a = t1[0], i = o = t1[1];
                for(var y = r; y < c; y += r)(s = t1[y]) < n && (n = s), (u = t1[y + 1]) < i && (i = u), s > a && (a = s), u > o && (o = u);
                l = 0 !== (l = Math.max(a - n, o - i)) ? 1 / l : 0;
            }
            return Mo(h, f, r, n, i, l), f;
        }
        function Eo(t1, e1, r, n, i) {
            var a, o;
            if (i === Qo(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)o = Yo(a, t1[a], t1[a + 1], o);
            else for(a = r - n; a >= e1; a -= n)o = Yo(a, t1[a], t1[a + 1], o);
            return o && Ko(o, o.next) && ($o(o), o = o.next), o;
        }
        function Po(t1, e1) {
            if (!t1) return t1;
            e1 || (e1 = t1);
            var r, n = t1;
            do if (r = !1, n.steiner || !Ko(n, n.next) && 0 !== No(n.prev, n, n.next)) n = n.next;
            else {
                if ($o(n), (n = e1 = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e1);
            return e1;
        }
        function Mo(t1, e1, r, n, i, a, o) {
            if (t1) {
                !o && a && function(t1, e1, r, n) {
                    var i = t1;
                    do null === i.z && (i.z = Ro(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t1);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                        var e1, r, n, i, a, o, s, u, l = 1;
                        do {
                            for(r = t1, t1 = null, a = null, o = 0; r;){
                                for(o++, n = r, s = 0, e1 = 0; e1 < l && (s++, n = n.nextZ); e1++);
                                for(u = l; s > 0 || u > 0 && n;)0 !== s && (0 === u || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, u--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                r = n;
                            }
                            a.nextZ = null, l *= 2;
                        }while (o > 1);
                    }(i);
                }(t1, n, i, a);
                for(var s, u, l = t1; t1.prev !== t1.next;)if (s = t1.prev, u = t1.next, a ? To(t1, n, i, a) : Bo(t1)) e1.push(s.i / r), e1.push(t1.i / r), e1.push(u.i / r), $o(t1), t1 = u.next, l = u.next;
                else if ((t1 = u) === l) {
                    o ? 1 === o ? Mo(t1 = Vo(Po(t1), e1, r), e1, r, n, i, a, 2) : 2 === o && Fo(t1, e1, r, n, i, a) : Mo(Po(t1), e1, r, n, i, a, 1);
                    break;
                }
            }
        }
        function Bo(t1) {
            var e1 = t1.prev, r = t1, n = t1.next;
            if (No(e1, r, n) >= 0) return !1;
            for(var i = t1.next.next; i !== t1.prev;){
                if (jo(e1.x, e1.y, r.x, r.y, n.x, n.y, i.x, i.y) && No(i.prev, i, i.next) >= 0) return !1;
                i = i.next;
            }
            return !0;
        }
        function To(t1, e1, r, n) {
            var i = t1.prev, a = t1, o = t1.next;
            if (No(i, a, o) >= 0) return !1;
            for(var s = i.x > a.x ? i.x > o.x ? i.x : o.x : a.x > o.x ? a.x : o.x, u = i.y > a.y ? i.y > o.y ? i.y : o.y : a.y > o.y ? a.y : o.y, l = Ro(i.x < a.x ? i.x < o.x ? i.x : o.x : a.x < o.x ? a.x : o.x, i.y < a.y ? i.y < o.y ? i.y : o.y : a.y < o.y ? a.y : o.y, e1, r, n), p = Ro(s, u, e1, r, n), c = t1.prevZ, h = t1.nextZ; c && c.z >= l && h && h.z <= p;){
                if (c !== t1.prev && c !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, c.x, c.y) && No(c.prev, c, c.next) >= 0) return !1;
                if (c = c.prevZ, h !== t1.prev && h !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, h.x, h.y) && No(h.prev, h, h.next) >= 0) return !1;
                h = h.nextZ;
            }
            for(; c && c.z >= l;){
                if (c !== t1.prev && c !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, c.x, c.y) && No(c.prev, c, c.next) >= 0) return !1;
                c = c.prevZ;
            }
            for(; h && h.z <= p;){
                if (h !== t1.prev && h !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, h.x, h.y) && No(h.prev, h, h.next) >= 0) return !1;
                h = h.nextZ;
            }
            return !0;
        }
        function Vo(t1, e1, r) {
            var n = t1;
            do {
                var i = n.prev, a = n.next.next;
                !Ko(i, a) && Go(i, n, n.next, a) && Jo(i, a) && Jo(a, i) && (e1.push(i.i / r), e1.push(n.i / r), e1.push(a.i / r), $o(n), $o(n.next), n = t1 = a), n = n.next;
            }while (n !== t1);
            return Po(n);
        }
        function Fo(t1, e1, r, n, i, a) {
            var o = t1;
            do {
                for(var s = o.next.next; s !== o.prev;){
                    if (o.i !== s.i && qo(o, s)) {
                        var u = Ho(o, s);
                        return o = Po(o, o.next), u = Po(u, u.next), Mo(o, e1, r, n, i, a), void Mo(u, e1, r, n, i, a);
                    }
                    s = s.next;
                }
                o = o.next;
            }while (o !== t1);
        }
        function Do(t1, e1) {
            return t1.x - e1.x;
        }
        function Lo(t1, e1) {
            if (e1 = function(t1, e1) {
                var r, n = e1, i = t1.x, a = t1.y, o = -1 / 0;
                do {
                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                        var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (s <= i && s > o) {
                            if (o = s, s === i) {
                                if (a === n.y) return n;
                                if (a === n.next.y) return n.next;
                            }
                            r = n.x < n.next.x ? n : n.next;
                        }
                    }
                    n = n.next;
                }while (n !== e1);
                if (!r) return null;
                if (i === o) return r;
                var u, l = r, p = r.x, c = r.y, h = 1 / 0;
                n = r;
                do i >= n.x && n.x >= p && i !== n.x && jo(a < c ? i : o, a, p, c, a < c ? o : i, a, n.x, n.y) && (u = Math.abs(a - n.y) / (i - n.x), Jo(n, t1) && (u < h || u === h && (n.x > r.x || n.x === r.x && Oo(r, n))) && (r = n, h = u)), n = n.next;
                while (n !== l);
                return r;
            }(t1, e1)) {
                var r = Ho(e1, t1);
                Po(e1, e1.next), Po(r, r.next);
            }
        }
        function Oo(t1, e1) {
            return No(t1.prev, t1, e1.prev) < 0 && No(e1.next, t1, t1.next) < 0;
        }
        function Ro(t1, e1, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = 32767 * (t1 - r) * i) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = 32767 * (e1 - n) * i) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function Uo(t1) {
            var e1 = t1, r = t1;
            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
            while (e1 !== t1);
            return r;
        }
        function jo(t1, e1, r, n, i, a, o, s) {
            return (i - o) * (e1 - s) - (t1 - o) * (a - s) >= 0 && (t1 - o) * (n - s) - (r - o) * (e1 - s) >= 0 && (r - o) * (a - s) - (i - o) * (n - s) >= 0;
        }
        function qo(t1, e1) {
            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                var r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && Go(r, r.next, t1, e1)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e1) && (Jo(t1, e1) && Jo(e1, t1) && function(t1, e1) {
                var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e1) && (No(t1.prev, t1, e1.prev) || No(t1, e1.prev, e1)) || Ko(t1, e1) && No(t1.prev, t1, t1.next) > 0 && No(e1.prev, e1, e1.next) > 0);
        }
        function No(t1, e1, r) {
            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
        }
        function Ko(t1, e1) {
            return t1.x === e1.x && t1.y === e1.y;
        }
        function Go(t1, e1, r, n) {
            var i = Xo(No(t1, e1, r)), a = Xo(No(t1, e1, n)), o = Xo(No(r, n, t1)), s = Xo(No(r, n, e1));
            return i !== a && o !== s || !(0 !== i || !Zo(t1, r, e1)) || !(0 !== a || !Zo(t1, n, e1)) || !(0 !== o || !Zo(r, t1, n)) || !(0 !== s || !Zo(r, e1, n));
        }
        function Zo(t1, e1, r) {
            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
        }
        function Xo(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function Jo(t1, e1) {
            return No(t1.prev, t1, t1.next) < 0 ? No(t1, e1, t1.next) >= 0 && No(t1, t1.prev, e1) >= 0 : No(t1, e1, t1.prev) < 0 || No(t1, t1.next, e1) < 0;
        }
        function Ho(t1, e1) {
            var r = new Wo(t1.i, t1.x, t1.y), n = new Wo(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
        }
        function Yo(t1, e1, r, n) {
            var i = new Wo(t1, e1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function $o(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Wo(t1, e1, r) {
            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Qo(t1, e1, r, n) {
            for(var i = 0, a = e1, o = r - n; a < r; a += n)i += (t1[o] - t1[a]) * (t1[a + 1] + t1[o + 1]), o = a;
            return i;
        }
        function ts(t1, e1, r, n, i) {
            !function t1(e1, r, n, i, a) {
                for(; i > n;){
                    if (i - n > 600) {
                        var o = i - n + 1, s = r - n + 1, u = Math.log(o), l = .5 * Math.exp(2 * u / 3), p = .5 * Math.sqrt(u * l * (o - l) / o) * (s - o / 2 < 0 ? -1 : 1);
                        t1(e1, r, Math.max(n, Math.floor(r - s * l / o + p)), Math.min(i, Math.floor(r + (o - s) * l / o + p)), a);
                    }
                    var c = e1[r], h = n, f = i;
                    for(es(e1, n, r), a(e1[i], c) > 0 && es(e1, n, i); h < f;){
                        for(es(e1, h, f), h++, f--; a(e1[h], c) < 0;)h++;
                        for(; a(e1[f], c) > 0;)f--;
                    }
                    0 === a(e1[n], c) ? es(e1, n, f) : es(e1, ++f, i), f <= r && (n = f + 1), r <= f && (i = f - 1);
                }
            }(t1, e1, r || 0, n || t1.length - 1, i || rs);
        }
        function es(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        function rs(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function ns(t1, e1) {
            var r = t1.length;
            if (r <= 1) return [
                t1
            ];
            for(var n, i, a = [], o = 0; o < r; o++){
                var s = k(t1[o]);
                0 !== s && (t1[o].area = Math.abs(s), void 0 === i && (i = s < 0), i === s < 0 ? (n && a.push(n), n = [
                    t1[o]
                ]) : n.push(t1[o]));
            }
            if (n && a.push(n), e1 > 1) for(var u = 0; u < a.length; u++)a[u].length <= e1 || (ts(a[u], e1, 1, a[u].length - 1, is), a[u] = a[u].slice(0, e1));
            return a;
        }
        function is(t1, e1) {
            return e1.area - t1.area;
        }
        function as(t1, e1, r) {
            for(var n = r.patternDependencies, i = !1, a = 0, o = e1; a < o.length; a += 1){
                var s = o[a].paint.get(t1 + "-pattern");
                s.isConstant() || (i = !0);
                var u = s.constantOr(null);
                u && (i = !0, n[u.to] = !0, n[u.from] = !0);
            }
            return i;
        }
        function os(t1, e1, r, n, i) {
            for(var a = i.patternDependencies, o = 0, s = e1; o < s.length; o += 1){
                var u = s[o], l = u.paint.get(t1 + "-pattern").value;
                if ("constant" !== l.kind) {
                    var p = l.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), c = l.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), h = l.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    c = c && c.name ? c.name : c, h = h && h.name ? h.name : h, a[p = p && p.name ? p.name : p] = !0, a[c] = !0, a[h] = !0, r.patterns[u.id] = {
                        min: p,
                        mid: c,
                        max: h
                    };
                }
            }
            return r;
        }
        Co.deviation = function(t1, e1, r, n) {
            var i = e1 && e1.length, a = Math.abs(Qo(t1, 0, i ? e1[0] * r : t1.length, r));
            if (i) for(var o = 0, s = e1.length; o < s; o++)a -= Math.abs(Qo(t1, e1[o] * r, o < s - 1 ? e1[o + 1] * r : t1.length, r));
            var u = 0;
            for(o = 0; o < n.length; o += 3){
                var l = n[o] * r, p = n[o + 1] * r, c = n[o + 2] * r;
                u += Math.abs((t1[l] - t1[c]) * (t1[p + 1] - t1[l + 1]) - (t1[l] - t1[p]) * (t1[c + 1] - t1[l + 1]));
            }
            return 0 === a && 0 === u ? 0 : Math.abs((u - a) / a);
        }, Co.flatten = function(t1) {
            for(var e1 = t1[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e1
            }, n = 0, i = 0; i < t1.length; i++){
                for(var a = 0; a < t1[i].length; a++)for(var o = 0; o < e1; o++)r.vertices.push(t1[i][a][o]);
                i > 0 && r.holes.push(n += t1[i - 1].length);
            }
            return r;
        }, Io.default = zo;
        var ss = function(t1) {
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Ci, this.indexArray = new ji, this.indexArray2 = new Xi, this.programConfigurations = new Va(t1.layers, t1.zoom), this.segments = new sa, this.segments2 = new sa, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        ss.prototype.populate = function(t1, e1, r) {
            this.hasPattern = as("fill", this.layers, e1);
            for(var n = this.layers[0].layout.get("fill-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                var s = o[a], u = s.feature, l = s.id, p = s.index, c = s.sourceLayerIndex, h = this.layers[0]._featureFilter.needGeometry, f = Ua(u, h);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), f, r)) {
                    var y = n ? n.evaluate(f, {}, r, e1.availableImages) : void 0, d = {
                        id: l,
                        properties: u.properties,
                        type: u.type,
                        sourceLayerIndex: c,
                        index: p,
                        geometry: h ? f.geometry : Ra(u),
                        patterns: {},
                        sortKey: y
                    };
                    i.push(d);
                }
            }
            n && i.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var m = 0, v = i; m < v.length; m += 1){
                var g = v[m], x = g.geometry, b = g.index, w = g.sourceLayerIndex;
                if (this.hasPattern) {
                    var _ = os("fill", this.layers, g, this.zoom, e1);
                    this.patternFeatures.push(_);
                } else this.addFeature(g, x, b, r, {});
                e1.featureIndex.insert(t1[b].feature, x, b, w, this.index);
            }
        }, ss.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, ss.prototype.addFeatures = function(t1, e1, r) {
            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                var a = i[n];
                this.addFeature(a, a.geometry, a.index, e1, r);
            }
        }, ss.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, ss.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, ss.prototype.upload = function(t1) {
            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ko), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, ss.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
        }, ss.prototype.addFeature = function(t1, e1, r, n, i) {
            for(var a = 0, o = ns(e1, 500); a < o.length; a += 1){
                for(var s = o[a], u = 0, l = 0, p = s; l < p.length; l += 1)u += p[l].length;
                for(var c = this.segments.prepareSegment(u, this.layoutVertexArray, this.indexArray), h = c.vertexLength, f = [], y = [], d = 0, m = s; d < m.length; d += 1){
                    var v = m[d];
                    if (0 !== v.length) {
                        v !== s[0] && y.push(f.length / 2);
                        var g = this.segments2.prepareSegment(v.length, this.layoutVertexArray, this.indexArray2), x = g.vertexLength;
                        this.layoutVertexArray.emplaceBack(v[0].x, v[0].y), this.indexArray2.emplaceBack(x + v.length - 1, x), f.push(v[0].x), f.push(v[0].y);
                        for(var b = 1; b < v.length; b++)this.layoutVertexArray.emplaceBack(v[b].x, v[b].y), this.indexArray2.emplaceBack(x + b - 1, x + b), f.push(v[b].x), f.push(v[b].y);
                        g.vertexLength += v.length, g.primitiveLength += v.length;
                    }
                }
                for(var w = Io(f, y), _ = 0; _ < w.length; _ += 3)this.indexArray.emplaceBack(h + w[_], h + w[_ + 1], h + w[_ + 2]);
                c.vertexLength += u, c.primitiveLength += w.length / 3;
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
        }, On("FillBucket", ss, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var us = new wi({
            "fill-sort-key": new vi(Et.layout_fill["fill-sort-key"])
        }), ls = {
            paint: new wi({
                "fill-antialias": new mi(Et.paint_fill["fill-antialias"]),
                "fill-opacity": new vi(Et.paint_fill["fill-opacity"]),
                "fill-color": new vi(Et.paint_fill["fill-color"]),
                "fill-outline-color": new vi(Et.paint_fill["fill-outline-color"]),
                "fill-translate": new mi(Et.paint_fill["fill-translate"]),
                "fill-translate-anchor": new mi(Et.paint_fill["fill-translate-anchor"]),
                "fill-pattern": new gi(Et.paint_fill["fill-pattern"])
            }),
            layout: us
        }, ps = function(t1) {
            function e1(e1) {
                t1.call(this, e1, ls);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.recalculate = function(e1, r) {
                t1.prototype.recalculate.call(this, e1, r);
                var n = this.paint._values["fill-outline-color"];
                "constant" === n.value.kind && void 0 === n.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }, e1.prototype.createBucket = function(t1) {
                return new ss(t1);
            }, e1.prototype.queryRadius = function() {
                return eo(this.paint.get("fill-translate"));
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o) {
                return Ga(ro(t1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, o), n);
            }, e1.prototype.isTileClipped = function() {
                return !0;
            }, e1;
        }(_i), cs = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4).members, hs = fs;
        function fs(t1, e1, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(ys, this, e1);
        }
        function ys(t1, e1, r) {
            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                    e1.properties[n] = i;
                }
            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
        }
        function ds(t1) {
            for(var e1, r, n = 0, i = 0, a = t1.length, o = a - 1; i < a; o = i++)n += ((r = t1[o]).x - (e1 = t1[i]).x) * (e1.y + r.y);
            return n;
        }
        fs.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], fs.prototype.loadGeometry = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1, r = t1.readVarint() + t1.pos, n = 1, a = 0, o = 0, s = 0, u = []; t1.pos < r;){
                if (a <= 0) {
                    var l = t1.readVarint();
                    n = 7 & l, a = l >> 3;
                }
                if (a--, 1 === n || 2 === n) o += t1.readSVarint(), s += t1.readSVarint(), 1 === n && (e1 && u.push(e1), e1 = []), e1.push(new i(o, s));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e1 && e1.push(e1[0].clone());
                }
            }
            return e1 && u.push(e1), u;
        }, fs.prototype.bbox = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, o = 1 / 0, s = -1 / 0, u = 1 / 0, l = -1 / 0; t1.pos < e1;){
                if (n <= 0) {
                    var p = t1.readVarint();
                    r = 7 & p, n = p >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < o && (o = i), i > s && (s = i), (a += t1.readSVarint()) < u && (u = a), a > l && (l = a);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                o,
                u,
                s,
                l
            ];
        }, fs.prototype.toGeoJSON = function(t1, e1, r) {
            var n, i, a = this.extent * Math.pow(2, r), o = this.extent * t1, s = this.extent * e1, u = this.loadGeometry(), l = fs.types[this.type];
            function p(t1) {
                for(var e1 = 0; e1 < t1.length; e1++){
                    var r = t1[e1];
                    t1[e1] = [
                        360 * (r.x + o) / a - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + s) / a) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var c = [];
                    for(n = 0; n < u.length; n++)c[n] = u[n][0];
                    p(u = c);
                    break;
                case 2:
                    for(n = 0; n < u.length; n++)p(u[n]);
                    break;
                case 3:
                    for(u = function(t1) {
                        var e1 = t1.length;
                        if (e1 <= 1) return [
                            t1
                        ];
                        for(var r, n, i = [], a = 0; a < e1; a++){
                            var o = ds(t1[a]);
                            0 !== o && (void 0 === n && (n = o < 0), n === o < 0 ? (r && i.push(r), r = [
                                t1[a]
                            ]) : r.push(t1[a]));
                        }
                        return r && i.push(r), i;
                    }(u), n = 0; n < u.length; n++)for(i = 0; i < u[n].length; i++)p(u[n][i]);
            }
            1 === u.length ? u = u[0] : l = "Multi" + l;
            var h = {
                type: "Feature",
                geometry: {
                    type: l,
                    coordinates: u
                },
                properties: this.properties
            };
            return "id" in this && (h.id = this.id), h;
        };
        var ms = vs;
        function vs(t1, e1) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(gs, this, e1), this.length = this._features.length;
        }
        function gs(t1, e1, r) {
            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = t1.readVarint() >> 3;
                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                }
                return e1;
            }(r));
        }
        function xs(t1, e1, r) {
            if (3 === t1) {
                var n = new ms(r, r.readVarint() + r.pos);
                n.length && (e1[n.name] = n);
            }
        }
        vs.prototype.feature = function(t1) {
            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t1];
            var e1 = this._pbf.readVarint() + this._pbf.pos;
            return new hs(this._pbf, e1, this.extent, this._keys, this._values);
        };
        var bs = {
            VectorTile: function(t1, e1) {
                this.layers = t1.readFields(xs, {}, e1);
            },
            VectorTileFeature: hs,
            VectorTileLayer: ms
        }, ws = bs.VectorTileFeature.types, _s = Math.pow(2, 13);
        function As(t1, e1, r, n, i, a, o, s) {
            t1.emplaceBack(e1, r, 2 * Math.floor(n * _s) + o, i * _s * 2, a * _s * 2, Math.round(s));
        }
        var Ss = function(t1) {
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new Pi, this.indexArray = new ji, this.programConfigurations = new Va(t1.layers, t1.zoom), this.segments = new sa, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        function ks(t1, e1) {
            return t1.x === e1.x && (t1.x < 0 || t1.x > 8192) || t1.y === e1.y && (t1.y < 0 || t1.y > 8192);
        }
        Ss.prototype.populate = function(t1, e1, r) {
            this.features = [], this.hasPattern = as("fill-extrusion", this.layers, e1);
            for(var n = 0, i = t1; n < i.length; n += 1){
                var a = i[n], o = a.feature, s = a.id, u = a.index, l = a.sourceLayerIndex, p = this.layers[0]._featureFilter.needGeometry, c = Ua(o, p);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), c, r)) {
                    var h = {
                        id: s,
                        sourceLayerIndex: l,
                        index: u,
                        geometry: p ? c.geometry : Ra(o),
                        properties: o.properties,
                        type: o.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(os("fill-extrusion", this.layers, h, this.zoom, e1)) : this.addFeature(h, h.geometry, u, r, {}), e1.featureIndex.insert(o, h.geometry, u, l, this.index, !0);
                }
            }
        }, Ss.prototype.addFeatures = function(t1, e1, r) {
            for(var n = 0, i = this.features; n < i.length; n += 1){
                var a = i[n];
                this.addFeature(a, a.geometry, a.index, e1, r);
            }
        }, Ss.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, Ss.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, Ss.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, Ss.prototype.upload = function(t1) {
            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, cs), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, Ss.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }, Ss.prototype.addFeature = function(t1, e1, r, n, i) {
            for(var a = 0, o = ns(e1, 500); a < o.length; a += 1){
                for(var s = o[a], u = 0, l = 0, p = s; l < p.length; l += 1)u += p[l].length;
                for(var c = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray), h = 0, f = s; h < f.length; h += 1){
                    var y = f[h];
                    if (0 !== y.length && !((B = y).every(function(t1) {
                        return t1.x < 0;
                    }) || B.every(function(t1) {
                        return t1.x > 8192;
                    }) || B.every(function(t1) {
                        return t1.y < 0;
                    }) || B.every(function(t1) {
                        return t1.y > 8192;
                    }))) for(var d = 0, m = 0; m < y.length; m++){
                        var v = y[m];
                        if (m >= 1) {
                            var g = y[m - 1];
                            if (!ks(v, g)) {
                                c.vertexLength + 4 > sa.MAX_VERTEX_ARRAY_LENGTH && (c = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                var x = v.sub(g)._perp()._unit(), b = g.dist(v);
                                d + b > 32768 && (d = 0), As(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 0, d), As(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 1, d), As(this.layoutVertexArray, g.x, g.y, x.x, x.y, 0, 0, d += b), As(this.layoutVertexArray, g.x, g.y, x.x, x.y, 0, 1, d);
                                var w = c.vertexLength;
                                this.indexArray.emplaceBack(w, w + 2, w + 1), this.indexArray.emplaceBack(w + 1, w + 2, w + 3), c.vertexLength += 4, c.primitiveLength += 2;
                            }
                        }
                    }
                }
                if (c.vertexLength + u > sa.MAX_VERTEX_ARRAY_LENGTH && (c = this.segments.prepareSegment(u, this.layoutVertexArray, this.indexArray)), "Polygon" === ws[t1.type]) {
                    for(var _ = [], A = [], S = c.vertexLength, k = 0, I = s; k < I.length; k += 1){
                        var z = I[k];
                        if (0 !== z.length) {
                            z !== s[0] && A.push(_.length / 2);
                            for(var C = 0; C < z.length; C++){
                                var E = z[C];
                                As(this.layoutVertexArray, E.x, E.y, 0, 0, 1, 1, 0), _.push(E.x), _.push(E.y);
                            }
                        }
                    }
                    for(var P = Io(_, A), M = 0; M < P.length; M += 3)this.indexArray.emplaceBack(S + P[M], S + P[M + 2], S + P[M + 1]);
                    c.primitiveLength += P.length / 3, c.vertexLength += u;
                }
            }
            var B;
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
        }, On("FillExtrusionBucket", Ss, {
            omit: [
                "layers",
                "features"
            ]
        });
        var Is = {
            paint: new wi({
                "fill-extrusion-opacity": new mi(Et["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                "fill-extrusion-color": new vi(Et["paint_fill-extrusion"]["fill-extrusion-color"]),
                "fill-extrusion-translate": new mi(Et["paint_fill-extrusion"]["fill-extrusion-translate"]),
                "fill-extrusion-translate-anchor": new mi(Et["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                "fill-extrusion-pattern": new gi(Et["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                "fill-extrusion-height": new vi(Et["paint_fill-extrusion"]["fill-extrusion-height"]),
                "fill-extrusion-base": new vi(Et["paint_fill-extrusion"]["fill-extrusion-base"]),
                "fill-extrusion-vertical-gradient": new mi(Et["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
            })
        }, zs = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Is);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.createBucket = function(t1) {
                return new Ss(t1);
            }, e1.prototype.queryRadius = function() {
                return eo(this.paint.get("fill-extrusion-translate"));
            }, e1.prototype.is3D = function() {
                return !0;
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, a, o, s, u) {
                var l = ro(t1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, s), p = this.paint.get("fill-extrusion-height").evaluate(e1, r), c = this.paint.get("fill-extrusion-base").evaluate(e1, r), h = function(t1, e1, r, n) {
                    for(var a = [], o = 0, s = t1; o < s.length; o += 1){
                        var u = s[o], l = [
                            u.x,
                            u.y,
                            0,
                            1
                        ];
                        po(l, l, e1), a.push(new i(l[0] / l[3], l[1] / l[3]));
                    }
                    return a;
                }(l, u), f = function(t1, e1, r, n) {
                    for(var a = [], o = [], s = n[8] * e1, u = n[9] * e1, l = n[10] * e1, p = n[11] * e1, c = n[8] * r, h = n[9] * r, f = n[10] * r, y = n[11] * r, d = 0, m = t1; d < m.length; d += 1){
                        for(var v = [], g = [], x = 0, b = m[d]; x < b.length; x += 1){
                            var w = b[x], _ = w.x, A = w.y, S = n[0] * _ + n[4] * A + n[12], k = n[1] * _ + n[5] * A + n[13], I = n[2] * _ + n[6] * A + n[14], z = n[3] * _ + n[7] * A + n[15], C = I + l, E = z + p, P = S + c, M = k + h, B = I + f, T = z + y, V = new i((S + s) / E, (k + u) / E);
                            V.z = C / E, v.push(V);
                            var F = new i(P / T, M / T);
                            F.z = B / T, g.push(F);
                        }
                        a.push(v), o.push(g);
                    }
                    return [
                        a,
                        o
                    ];
                }(n, c, p, u);
                return function(t1, e1, r) {
                    var n = 1 / 0;
                    Ga(r, e1) && (n = Es(r, e1[0]));
                    for(var i = 0; i < e1.length; i++)for(var a = e1[i], o = t1[i], s = 0; s < a.length - 1; s++){
                        var u = a[s], l = [
                            u,
                            a[s + 1],
                            o[s + 1],
                            o[s],
                            u
                        ];
                        Na(r, l) && (n = Math.min(n, Es(r, l)));
                    }
                    return n !== 1 / 0 && n;
                }(f[0], f[1], h);
            }, e1;
        }(_i);
        function Cs(t1, e1) {
            return t1.x * e1.x + t1.y * e1.y;
        }
        function Es(t1, e1) {
            if (1 === t1.length) {
                for(var r, n = 0, i = e1[n++]; !r || i.equals(r);)if (!(r = e1[n++])) return 1 / 0;
                for(; n < e1.length; n++){
                    var a = e1[n], o = t1[0], s = r.sub(i), u = a.sub(i), l = o.sub(i), p = Cs(s, s), c = Cs(s, u), h = Cs(u, u), f = Cs(l, s), y = Cs(l, u), d = p * h - c * c, m = (h * f - c * y) / d, v = (p * y - c * f) / d, g = i.z * (1 - m - v) + r.z * m + a.z * v;
                    if (isFinite(g)) return g;
                }
                return 1 / 0;
            }
            for(var x = 1 / 0, b = 0, w = e1; b < w.length; b += 1)x = Math.min(x, w[b].z);
            return x;
        }
        var Ps = Ii([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4).members, Ms = Ii([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]).members, Bs = bs.VectorTileFeature.types, Ts = Math.cos(Math.PI / 180 * 37.5), Vs = Math.pow(2, 14) / .5, Fs = function(t1) {
            var e1 = this;
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach(function(t1) {
                e1.gradients[t1.id] = {};
            }), this.layoutVertexArray = new Mi, this.layoutVertexArray2 = new Bi, this.indexArray = new ji, this.programConfigurations = new Va(t1.layers, t1.zoom), this.segments = new sa, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        Fs.prototype.populate = function(t1, e1, r) {
            this.hasPattern = as("line", this.layers, e1);
            for(var n = this.layers[0].layout.get("line-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                var s = o[a], u = s.feature, l = s.id, p = s.index, c = s.sourceLayerIndex, h = this.layers[0]._featureFilter.needGeometry, f = Ua(u, h);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), f, r)) {
                    var y = n ? n.evaluate(f, {}, r) : void 0, d = {
                        id: l,
                        properties: u.properties,
                        type: u.type,
                        sourceLayerIndex: c,
                        index: p,
                        geometry: h ? f.geometry : Ra(u),
                        patterns: {},
                        sortKey: y
                    };
                    i.push(d);
                }
            }
            n && i.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var m = 0, v = i; m < v.length; m += 1){
                var g = v[m], x = g.geometry, b = g.index, w = g.sourceLayerIndex;
                if (this.hasPattern) {
                    var _ = os("line", this.layers, g, this.zoom, e1);
                    this.patternFeatures.push(_);
                } else this.addFeature(g, x, b, r, {});
                e1.featureIndex.insert(t1[b].feature, x, b, w, this.index);
            }
        }, Fs.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, Fs.prototype.addFeatures = function(t1, e1, r) {
            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                var a = i[n];
                this.addFeature(a, a.geometry, a.index, e1, r);
            }
        }, Fs.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, Fs.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, Fs.prototype.upload = function(t1) {
            this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, Ms)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Ps), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, Fs.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }, Fs.prototype.lineFeatureClips = function(t1) {
            if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                start: +t1.properties.mapbox_clip_start,
                end: +t1.properties.mapbox_clip_end
            };
        }, Fs.prototype.addFeature = function(t1, e1, r, n, i) {
            var a = this.layers[0].layout, o = a.get("line-join").evaluate(t1, {}), s = a.get("line-cap"), u = a.get("line-miter-limit"), l = a.get("line-round-limit");
            this.lineClips = this.lineFeatureClips(t1);
            for(var p = 0, c = e1; p < c.length; p += 1)this.addLine(c[p], t1, o, s, u, l);
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
        }, Fs.prototype.addLine = function(t1, e1, r, n, i, a) {
            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                this.lineClipsArray.push(this.lineClips);
                for(var o = 0; o < t1.length - 1; o++)this.totalDistance += t1[o].dist(t1[o + 1]);
                this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
            }
            for(var s = "Polygon" === Bs[e1.type], u = t1.length; u >= 2 && t1[u - 1].equals(t1[u - 2]);)u--;
            for(var l = 0; l < u - 1 && t1[l].equals(t1[l + 1]);)l++;
            if (!(u < (s ? 3 : 2))) {
                "bevel" === r && (i = 1.05);
                var p, c = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, h = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray), f = void 0, y = void 0, d = void 0, m = void 0;
                this.e1 = this.e2 = -1, s && (m = t1[l].sub(p = t1[u - 2])._unit()._perp());
                for(var v = l; v < u; v++)if (!(y = v === u - 1 ? s ? t1[l + 1] : void 0 : t1[v + 1]) || !t1[v].equals(y)) {
                    m && (d = m), p && (f = p), p = t1[v], m = y ? y.sub(p)._unit()._perp() : d;
                    var g = (d = d || m).add(m);
                    0 === g.x && 0 === g.y || g._unit();
                    var x = d.x * m.x + d.y * m.y, b = g.x * m.x + g.y * m.y, w = 0 !== b ? 1 / b : 1 / 0, _ = 2 * Math.sqrt(2 - 2 * b), A = b < Ts && f && y, S = d.x * m.y - d.y * m.x > 0;
                    if (A && v > l) {
                        var k = p.dist(f);
                        if (k > 2 * c) {
                            var I = p.sub(p.sub(f)._mult(c / k)._round());
                            this.updateDistance(f, I), this.addCurrentVertex(I, d, 0, 0, h), f = I;
                        }
                    }
                    var z = f && y, C = z ? r : s ? "butt" : n;
                    if (z && "round" === C && (w < a ? C = "miter" : w <= 2 && (C = "fakeround")), "miter" === C && w > i && (C = "bevel"), "bevel" === C && (w > 2 && (C = "flipbevel"), w < i && (C = "miter")), f && this.updateDistance(f, p), "miter" === C) g._mult(w), this.addCurrentVertex(p, g, 0, 0, h);
                    else if ("flipbevel" === C) {
                        if (w > 100) g = m.mult(-1);
                        else {
                            var E = w * d.add(m).mag() / d.sub(m).mag();
                            g._perp()._mult(E * (S ? -1 : 1));
                        }
                        this.addCurrentVertex(p, g, 0, 0, h), this.addCurrentVertex(p, g.mult(-1), 0, 0, h);
                    } else if ("bevel" === C || "fakeround" === C) {
                        var P = -Math.sqrt(w * w - 1), M = S ? P : 0, B = S ? 0 : P;
                        if (f && this.addCurrentVertex(p, d, M, B, h), "fakeround" === C) for(var T = Math.round(180 * _ / Math.PI / 20), V = 1; V < T; V++){
                            var F = V / T;
                            if (.5 !== F) {
                                var D = F - .5;
                                F += F * D * (F - 1) * ((1.0904 + x * (x * (3.55645 - 1.43519 * x) - 3.2452)) * D * D + (.848013 + x * (.215638 * x - 1.06021)));
                            }
                            var L = m.sub(d)._mult(F)._add(d)._unit()._mult(S ? -1 : 1);
                            this.addHalfVertex(p, L.x, L.y, !1, S, 0, h);
                        }
                        y && this.addCurrentVertex(p, m, -M, -B, h);
                    } else if ("butt" === C) this.addCurrentVertex(p, g, 0, 0, h);
                    else if ("square" === C) {
                        var O = f ? 1 : -1;
                        this.addCurrentVertex(p, g, O, O, h);
                    } else "round" === C && (f && (this.addCurrentVertex(p, d, 0, 0, h), this.addCurrentVertex(p, d, 1, 1, h, !0)), y && (this.addCurrentVertex(p, m, -1, -1, h, !0), this.addCurrentVertex(p, m, 0, 0, h)));
                    if (A && v < u - 1) {
                        var R = p.dist(y);
                        if (R > 2 * c) {
                            var U = p.add(y.sub(p)._mult(c / R)._round());
                            this.updateDistance(p, U), this.addCurrentVertex(U, m, 0, 0, h), p = U;
                        }
                    }
                }
            }
        }, Fs.prototype.addCurrentVertex = function(t1, e1, r, n, i, a) {
            void 0 === a && (a = !1);
            var o = e1.y * n - e1.x, s = -e1.y - e1.x * n;
            this.addHalfVertex(t1, e1.x + e1.y * r, e1.y - e1.x * r, a, !1, r, i), this.addHalfVertex(t1, o, s, a, !0, -n, i), this.distance > Vs / 2 && 0 === this.totalDistance && (this.distance = 0, this.addCurrentVertex(t1, e1, r, n, i, a));
        }, Fs.prototype.addHalfVertex = function(t1, e1, r, n, i, a, o) {
            var s = .5 * (this.lineClips ? this.scaledDistance * (Vs - 1) : this.scaledDistance);
            this.layoutVertexArray.emplaceBack((t1.x << 1) + (n ? 1 : 0), (t1.y << 1) + (i ? 1 : 0), Math.round(63 * e1) + 128, Math.round(63 * r) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & s) << 2, s >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
            var u = o.vertexLength++;
            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), i ? this.e2 = u : this.e1 = u;
        }, Fs.prototype.updateScaledDistance = function() {
            this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
        }, Fs.prototype.updateDistance = function(t1, e1) {
            this.distance += t1.dist(e1), this.updateScaledDistance();
        }, On("LineBucket", Fs, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var Ds = new wi({
            "line-cap": new mi(Et.layout_line["line-cap"]),
            "line-join": new vi(Et.layout_line["line-join"]),
            "line-miter-limit": new mi(Et.layout_line["line-miter-limit"]),
            "line-round-limit": new mi(Et.layout_line["line-round-limit"]),
            "line-sort-key": new vi(Et.layout_line["line-sort-key"])
        }), Ls = {
            paint: new wi({
                "line-opacity": new vi(Et.paint_line["line-opacity"]),
                "line-color": new vi(Et.paint_line["line-color"]),
                "line-translate": new mi(Et.paint_line["line-translate"]),
                "line-translate-anchor": new mi(Et.paint_line["line-translate-anchor"]),
                "line-width": new vi(Et.paint_line["line-width"]),
                "line-gap-width": new vi(Et.paint_line["line-gap-width"]),
                "line-offset": new vi(Et.paint_line["line-offset"]),
                "line-blur": new vi(Et.paint_line["line-blur"]),
                "line-dasharray": new xi(Et.paint_line["line-dasharray"]),
                "line-pattern": new gi(Et.paint_line["line-pattern"]),
                "line-gradient": new bi(Et.paint_line["line-gradient"])
            }),
            layout: Ds
        }, Os = new (function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.possiblyEvaluate = function(e1, r) {
                return r = new si(Math.floor(r.zoom), {
                    now: r.now,
                    fadeDuration: r.fadeDuration,
                    zoomHistory: r.zoomHistory,
                    transition: r.transition
                }), t1.prototype.possiblyEvaluate.call(this, e1, r);
            }, e1.prototype.evaluate = function(e1, r, n, i) {
                return r = h({}, r, {
                    zoom: Math.floor(r.zoom)
                }), t1.prototype.evaluate.call(this, e1, r, n, i);
            }, e1;
        }(vi))(Ls.paint.properties["line-width"].specification);
        Os.useIntegerZoom = !0;
        var Rs = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Ls), this.gradientVersion = 0;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                "line-gradient" === t1 && (this.stepInterpolant = this._transitionablePaint._values["line-gradient"].value.expression._styleExpression.expression instanceof Ne, this.gradientVersion = (this.gradientVersion + 1) % s);
            }, e1.prototype.gradientExpression = function() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }, e1.prototype.recalculate = function(e1, r) {
                t1.prototype.recalculate.call(this, e1, r), this.paint._values["line-floorwidth"] = Os.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
            }, e1.prototype.createBucket = function(t1) {
                return new Fs(t1);
            }, e1.prototype.queryRadius = function(t1) {
                var e1 = t1, r = Us(to("line-width", this, e1), to("line-gap-width", this, e1)), n = to("line-offset", this, e1);
                return r / 2 + Math.abs(n) + eo(this.paint.get("line-translate"));
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, a, o, s) {
                var u = ro(t1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, s), l = s / 2 * Us(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), p = this.paint.get("line-offset").evaluate(e1, r);
                return p && (n = function(t1, e1) {
                    for(var r = [], n = new i(0, 0), a = 0; a < t1.length; a++){
                        for(var o = t1[a], s = [], u = 0; u < o.length; u++){
                            var l = o[u], p = o[u + 1], c = 0 === u ? n : l.sub(o[u - 1])._unit()._perp(), h = u === o.length - 1 ? n : p.sub(l)._unit()._perp(), f = c._add(h)._unit();
                            f._mult(1 / (f.x * h.x + f.y * h.y)), s.push(f._mult(e1)._add(l));
                        }
                        r.push(s);
                    }
                    return r;
                }(n, p * s)), function(t1, e1, r) {
                    for(var n = 0; n < e1.length; n++){
                        var i = e1[n];
                        if (t1.length >= 3) {
                            for(var a = 0; a < i.length; a++)if (Wa(t1, i[a])) return !0;
                        }
                        if (Za(t1, i, r)) return !0;
                    }
                    return !1;
                }(u, n, l);
            }, e1.prototype.isTileClipped = function() {
                return !0;
            }, e1;
        }(_i);
        function Us(t1, e1) {
            return e1 > 0 ? e1 + 2 * t1 : t1;
        }
        var js = Ii([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), qs = Ii([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4), Ns = (Ii([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4), Ii([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ])), Ks = (Ii([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]), Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4)), Gs = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function Zs(t1, e1, r) {
            return t1.sections.forEach(function(t1) {
                t1.text = function(t1, e1, r) {
                    var n = e1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), oi.applyArabicShaping && (t1 = oi.applyArabicShaping(t1)), t1;
                }(t1.text, e1, r);
            }), t1;
        }
        Ii([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Ii([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), Ii([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            }
        ]), Ii([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Ii([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]);
        var Xs = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        }, Js = function(t1, e1, r, n, i) {
            var a, o, s = 8 * i - n - 1, u = (1 << s) - 1, l = u >> 1, p = -7, c = r ? i - 1 : 0, h = r ? -1 : 1, f = t1[e1 + c];
            for(c += h, a = f & (1 << -p) - 1, f >>= -p, p += s; p > 0; a = 256 * a + t1[e1 + c], c += h, p -= 8);
            for(o = a & (1 << -p) - 1, a >>= -p, p += n; p > 0; o = 256 * o + t1[e1 + c], c += h, p -= 8);
            if (0 === a) a = 1 - l;
            else {
                if (a === u) return o ? NaN : 1 / 0 * (f ? -1 : 1);
                o += Math.pow(2, n), a -= l;
            }
            return (f ? -1 : 1) * o * Math.pow(2, a - n);
        }, Hs = function(t1, e1, r, n, i, a) {
            var o, s, u, l = 8 * a - i - 1, p = (1 << l) - 1, c = p >> 1, h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : a - 1, y = n ? 1 : -1, d = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = p) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), (e1 += o + c >= 1 ? h / u : h * Math.pow(2, 1 - c)) * u >= 2 && (o++, u /= 2), o + c >= p ? (s = 0, o = p) : o + c >= 1 ? (s = (e1 * u - 1) * Math.pow(2, i), o += c) : (s = e1 * Math.pow(2, c - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + f] = 255 & s, f += y, s /= 256, i -= 8);
            for(o = o << i | s, l += i; l > 0; t1[r + f] = 255 & o, f += y, o /= 256, l -= 8);
            t1[r + f - y] |= 128 * d;
        }, Ys = $s;
        function $s(t1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        $s.Varint = 0, $s.Fixed64 = 1, $s.Bytes = 2, $s.Fixed32 = 5;
        var Ws = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function Qs(t1) {
            return t1.type === $s.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
        }
        function tu(t1, e1, r) {
            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
        }
        function eu(t1, e1, r) {
            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
        }
        function ru(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
        }
        function nu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
        }
        function iu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
        }
        function au(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
        }
        function ou(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
        }
        function su(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
        }
        function uu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
        }
        function lu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
        }
        function pu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
        }
        function cu(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
        }
        function hu(t1, e1, r) {
            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
        }
        function fu(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
        }
        function yu(t1, e1, r) {
            1 === t1 && r.readMessage(du, e1);
        }
        function du(t1, e1, r) {
            if (3 === t1) {
                var n = r.readMessage(mu, {}), i = n.width, a = n.height, o = n.left, s = n.top, u = n.advance;
                e1.push({
                    id: n.id,
                    bitmap: new go({
                        width: i + 6,
                        height: a + 6
                    }, n.bitmap),
                    metrics: {
                        width: i,
                        height: a,
                        left: o,
                        top: s,
                        advance: u
                    }
                });
            }
        }
        function mu(t1, e1, r) {
            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
        }
        function vu(t1) {
            for(var e1 = 0, r = 0, n = 0, i = t1; n < i.length; n += 1){
                var a = i[n];
                e1 += a.w * a.h, r = Math.max(r, a.w);
            }
            t1.sort(function(t1, e1) {
                return e1.h - t1.h;
            });
            for(var o = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                    h: 1 / 0
                }
            ], s = 0, u = 0, l = 0, p = t1; l < p.length; l += 1)for(var c = p[l], h = o.length - 1; h >= 0; h--){
                var f = o[h];
                if (!(c.w > f.w || c.h > f.h)) {
                    if (c.x = f.x, c.y = f.y, u = Math.max(u, c.y + c.h), s = Math.max(s, c.x + c.w), c.w === f.w && c.h === f.h) {
                        var y = o.pop();
                        h < o.length && (o[h] = y);
                    } else c.h === f.h ? (f.x += c.w, f.w -= c.w) : c.w === f.w ? (f.y += c.h, f.h -= c.h) : (o.push({
                        x: f.x + c.w,
                        y: f.y,
                        w: f.w - c.w,
                        h: c.h
                    }), f.y += c.h, f.h -= c.h);
                    break;
                }
            }
            return {
                w: s,
                h: u,
                fill: e1 / (s * u) || 0
            };
        }
        $s.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t1, e1, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                    this.type = 7 & n, t1(i, e1, this), this.pos === a && this.skip(n);
                }
                return e1;
            },
            readMessage: function(t1, e1) {
                return this.readFields(t1, e1, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t1 = cu(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readSFixed32: function() {
                var t1 = fu(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readFixed64: function() {
                var t1 = cu(this.buf, this.pos) + 4294967296 * cu(this.buf, this.pos + 4);
                return this.pos += 8, t1;
            },
            readSFixed64: function() {
                var t1 = cu(this.buf, this.pos) + 4294967296 * fu(this.buf, this.pos + 4);
                return this.pos += 8, t1;
            },
            readFloat: function() {
                var t1 = Js(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t1;
            },
            readDouble: function() {
                var t1 = Js(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t1;
            },
            readVarint: function(t1) {
                var e1, r, n = this.buf;
                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                    var n, i, a = r.buf;
                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return tu(t1, n, e1);
                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return tu(t1, n, e1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t1 = this.readVarint();
                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                return this.pos = t1, t1 - e1 >= 12 && Ws ? function(t1, e1, r) {
                    return Ws.decode(t1.subarray(e1, r));
                }(this.buf, e1, t1) : function(t1, e1, r) {
                    for(var n = "", i = e1; i < r;){
                        var a, o, s, u = t1[i], l = null, p = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
                        if (i + p > r) break;
                        1 === p ? u < 128 && (l = u) : 2 === p ? 128 == (192 & (a = t1[i + 1])) && (l = (31 & u) << 6 | 63 & a) <= 127 && (l = null) : 3 === p ? (o = t1[i + 2], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & o) && ((l = (15 & u) << 12 | (63 & a) << 6 | 63 & o) <= 2047 || l >= 55296 && l <= 57343) && (l = null)) : 4 === p && (o = t1[i + 2], s = t1[i + 3], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & o) && 128 == (192 & s) && ((l = (15 & u) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) <= 65535 || l >= 1114112) && (l = null)), null === l ? (l = 65533, p = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), i += p;
                    }
                    return n;
                }(this.buf, e1, t1);
            },
            readBytes: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                return this.pos = t1, e1;
            },
            readPackedVarint: function(t1, e1) {
                if (this.type !== $s.Bytes) return t1.push(this.readVarint(e1));
                var r = Qs(this);
                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                return t1;
            },
            readPackedSVarint: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readSVarint());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                return t1;
            },
            readPackedBoolean: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readBoolean());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                return t1;
            },
            readPackedFloat: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readFloat());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                return t1;
            },
            readPackedDouble: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readDouble());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                return t1;
            },
            readPackedFixed32: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readFixed32());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                return t1;
            },
            readPackedSFixed32: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readSFixed32());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                return t1;
            },
            readPackedFixed64: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readFixed64());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                return t1;
            },
            readPackedSFixed64: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readSFixed64());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                return t1;
            },
            skip: function(t1) {
                var e1 = 7 & t1;
                if (e1 === $s.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e1 === $s.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e1 === $s.Fixed32) this.pos += 4;
                else {
                    if (e1 !== $s.Fixed64) throw new Error("Unimplemented type: " + e1);
                    this.pos += 8;
                }
            },
            writeTag: function(t1, e1) {
                this.writeVarint(t1 << 3 | e1);
            },
            realloc: function(t1) {
                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                if (e1 !== this.length) {
                    var r = new Uint8Array(e1);
                    r.set(this.buf), this.buf = r, this.length = e1;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t1) {
                this.realloc(4), hu(this.buf, t1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t1) {
                this.realloc(4), hu(this.buf, t1, this.pos), this.pos += 4;
            },
            writeFixed64: function(t1) {
                this.realloc(8), hu(this.buf, -1 & t1, this.pos), hu(this.buf, Math.floor(t1 * (1 / 4294967296)), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t1) {
                this.realloc(8), hu(this.buf, -1 & t1, this.pos), hu(this.buf, Math.floor(t1 * (1 / 4294967296)), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t1) {
                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                    var r, n;
                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e1.realloc(10), function(t1, e1, r) {
                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                    }(r, 0, e1), function(t1, e1) {
                        var r = (7 & t1) << 4;
                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                    }(n, e1);
                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
            },
            writeSVarint: function(t1) {
                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
            },
            writeBoolean: function(t1) {
                this.writeVarint(Boolean(t1));
            },
            writeString: function(t1) {
                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                var e1 = this.pos;
                this.pos = function(t1, e1, r) {
                    for(var n, i, a = 0; a < e1.length; a++){
                        if ((n = e1.charCodeAt(a)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || a + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t1, this.pos);
                var r = this.pos - e1;
                r >= 128 && eu(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t1) {
                this.realloc(4), Hs(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t1) {
                this.realloc(8), Hs(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t1) {
                var e1 = t1.length;
                this.writeVarint(e1), this.realloc(e1);
                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
            },
            writeRawMessage: function(t1, e1) {
                this.pos++;
                var r = this.pos;
                t1(e1, this);
                var n = this.pos - r;
                n >= 128 && eu(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t1, e1, r) {
                this.writeTag(t1, $s.Bytes), this.writeRawMessage(e1, r);
            },
            writePackedVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, ru, e1);
            },
            writePackedSVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, nu, e1);
            },
            writePackedBoolean: function(t1, e1) {
                e1.length && this.writeMessage(t1, ou, e1);
            },
            writePackedFloat: function(t1, e1) {
                e1.length && this.writeMessage(t1, iu, e1);
            },
            writePackedDouble: function(t1, e1) {
                e1.length && this.writeMessage(t1, au, e1);
            },
            writePackedFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, su, e1);
            },
            writePackedSFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, uu, e1);
            },
            writePackedFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, lu, e1);
            },
            writePackedSFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, pu, e1);
            },
            writeBytesField: function(t1, e1) {
                this.writeTag(t1, $s.Bytes), this.writeBytes(e1);
            },
            writeFixed32Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed32), this.writeFixed32(e1);
            },
            writeSFixed32Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed32), this.writeSFixed32(e1);
            },
            writeFixed64Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed64), this.writeFixed64(e1);
            },
            writeSFixed64Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed64), this.writeSFixed64(e1);
            },
            writeVarintField: function(t1, e1) {
                this.writeTag(t1, $s.Varint), this.writeVarint(e1);
            },
            writeSVarintField: function(t1, e1) {
                this.writeTag(t1, $s.Varint), this.writeSVarint(e1);
            },
            writeStringField: function(t1, e1) {
                this.writeTag(t1, $s.Bytes), this.writeString(e1);
            },
            writeFloatField: function(t1, e1) {
                this.writeTag(t1, $s.Fixed32), this.writeFloat(e1);
            },
            writeDoubleField: function(t1, e1) {
                this.writeTag(t1, $s.Fixed64), this.writeDouble(e1);
            },
            writeBooleanField: function(t1, e1) {
                this.writeVarintField(t1, Boolean(e1));
            }
        };
        var gu = function(t1, e1) {
            var r = e1.pixelRatio, n = e1.version, i = e1.stretchX, a = e1.stretchY, o = e1.content;
            this.paddedRect = t1, this.pixelRatio = r, this.stretchX = i, this.stretchY = a, this.content = o, this.version = n;
        }, xu = {
            tl: {
                configurable: !0
            },
            br: {
                configurable: !0
            },
            tlbr: {
                configurable: !0
            },
            displaySize: {
                configurable: !0
            }
        };
        xu.tl.get = function() {
            return [
                this.paddedRect.x + 1,
                this.paddedRect.y + 1
            ];
        }, xu.br.get = function() {
            return [
                this.paddedRect.x + this.paddedRect.w - 1,
                this.paddedRect.y + this.paddedRect.h - 1
            ];
        }, xu.tlbr.get = function() {
            return this.tl.concat(this.br);
        }, xu.displaySize.get = function() {
            return [
                (this.paddedRect.w - 2) / this.pixelRatio,
                (this.paddedRect.h - 2) / this.pixelRatio
            ];
        }, Object.defineProperties(gu.prototype, xu);
        var bu = function(t1, e1) {
            var r = {}, n = {};
            this.haveRenderCallbacks = [];
            var i = [];
            this.addImages(t1, r, i), this.addImages(e1, n, i);
            var a = vu(i), o = new xo({
                width: a.w || 1,
                height: a.h || 1
            });
            for(var s in t1){
                var u = t1[s], l = r[s].paddedRect;
                xo.copy(u.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: l.x + 1,
                    y: l.y + 1
                }, u.data);
            }
            for(var p in e1){
                var c = e1[p], h = n[p].paddedRect, f = h.x + 1, y = h.y + 1, d = c.data.width, m = c.data.height;
                xo.copy(c.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: f,
                    y: y
                }, c.data), xo.copy(c.data, o, {
                    x: 0,
                    y: m - 1
                }, {
                    x: f,
                    y: y - 1
                }, {
                    width: d,
                    height: 1
                }), xo.copy(c.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: f,
                    y: y + m
                }, {
                    width: d,
                    height: 1
                }), xo.copy(c.data, o, {
                    x: d - 1,
                    y: 0
                }, {
                    x: f - 1,
                    y: y
                }, {
                    width: 1,
                    height: m
                }), xo.copy(c.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: f + d,
                    y: y
                }, {
                    width: 1,
                    height: m
                });
            }
            this.image = o, this.iconPositions = r, this.patternPositions = n;
        };
        bu.prototype.addImages = function(t1, e1, r) {
            for(var n in t1){
                var i = t1[n], a = {
                    x: 0,
                    y: 0,
                    w: i.data.width + 2,
                    h: i.data.height + 2
                };
                r.push(a), e1[n] = new gu(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
            }
        }, bu.prototype.patchUpdatedImages = function(t1, e1) {
            for(var r in t1.dispatchRenderCallbacks(this.haveRenderCallbacks), t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
        }, bu.prototype.patchUpdatedImage = function(t1, e1, r) {
            if (t1 && e1 && t1.version !== e1.version) {
                t1.version = e1.version;
                var n = t1.tl;
                r.update(e1.data, void 0, {
                    x: n[0],
                    y: n[1]
                });
            }
        }, On("ImagePosition", gu), On("ImageAtlas", bu);
        var wu = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        }, _u = function() {
            this.scale = 1, this.fontStack = "", this.imageName = null;
        };
        _u.forText = function(t1, e1) {
            var r = new _u;
            return r.scale = t1 || 1, r.fontStack = e1, r;
        }, _u.forImage = function(t1) {
            var e1 = new _u;
            return e1.imageName = t1, e1;
        };
        var Au = function() {
            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
        };
        function Su(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d) {
            var m, v = Au.fromFeature(t1, i);
            c === wu.vertical && v.verticalizePunctuation();
            var g = oi.processBidirectionalText, x = oi.processStyledBidirectionalText;
            if (g && 1 === v.sections.length) {
                m = [];
                for(var b = 0, w = g(v.toString(), Mu(v, l, a, e1, n, f, y)); b < w.length; b += 1){
                    var _ = w[b], A = new Au;
                    A.text = _, A.sections = v.sections;
                    for(var S = 0; S < _.length; S++)A.sectionIndex.push(0);
                    m.push(A);
                }
            } else if (x) {
                m = [];
                for(var k = 0, I = x(v.text, v.sectionIndex, Mu(v, l, a, e1, n, f, y)); k < I.length; k += 1){
                    var z = I[k], C = new Au;
                    C.text = z[0], C.sectionIndex = z[1], C.sections = v.sections, m.push(C);
                }
            } else m = function(t1, e1) {
                for(var r = [], n = t1.text, i = 0, a = 0, o = e1; a < o.length; a += 1){
                    var s = o[a];
                    r.push(t1.substring(i, s)), i = s;
                }
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(v, Mu(v, l, a, e1, n, f, y));
            var E = [], P = {
                positionedLines: E,
                text: v.toString(),
                top: p[1],
                bottom: p[1],
                left: p[0],
                right: p[0],
                writingMode: c,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(t1, e1, r, n, i, a, o, s, u, l, p, c) {
                for(var h = 0, f = -17, y = 0, d = 0, m = "right" === s ? 1 : "left" === s ? 0 : .5, v = 0, g = 0, x = i; g < x.length; g += 1){
                    var b = x[g];
                    b.trim();
                    var w = b.getMaxScale(), _ = 24 * (w - 1), A = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[v] = A;
                    var S = A.positionedGlyphs, k = 0;
                    if (b.length()) {
                        for(var I = 0; I < b.length(); I++){
                            var z = b.getSection(I), C = b.getSectionIndex(I), E = b.getCharCode(I), P = 0, M = null, B = null, T = null, V = 24, F = !(u === wu.horizontal || !p && !Xn(E) || p && (ku[E] || (K = E, Gn.Arabic(K) || Gn["Arabic Supplement"](K) || Gn["Arabic Extended-A"](K) || Gn["Arabic Presentation Forms-A"](K) || Gn["Arabic Presentation Forms-B"](K))));
                            if (z.imageName) {
                                var D = n[z.imageName];
                                if (!D) continue;
                                T = z.imageName, t1.iconsInText = t1.iconsInText || !0, B = D.paddedRect;
                                var L = D.displaySize;
                                z.scale = 24 * z.scale / c, P = _ + (24 - L[1] * z.scale), V = (M = {
                                    width: L[0],
                                    height: L[1],
                                    left: 1,
                                    top: -3,
                                    advance: F ? L[1] : L[0]
                                }).advance;
                                var O = F ? L[0] * z.scale - 24 * w : L[1] * z.scale - 24 * w;
                                O > 0 && O > k && (k = O);
                            } else {
                                var R = r[z.fontStack], U = R && R[E];
                                if (U && U.rect) B = U.rect, M = U.metrics;
                                else {
                                    var j = e1[z.fontStack], q = j && j[E];
                                    if (!q) continue;
                                    M = q.metrics;
                                }
                                P = 24 * (w - z.scale);
                            }
                            F ? (t1.verticalizable = !0, S.push({
                                glyph: E,
                                imageName: T,
                                x: h,
                                y: f + P,
                                vertical: F,
                                scale: z.scale,
                                fontStack: z.fontStack,
                                sectionIndex: C,
                                metrics: M,
                                rect: B
                            }), h += V * z.scale + l) : (S.push({
                                glyph: E,
                                imageName: T,
                                x: h,
                                y: f + P,
                                vertical: F,
                                scale: z.scale,
                                fontStack: z.fontStack,
                                sectionIndex: C,
                                metrics: M,
                                rect: B
                            }), h += M.advance * z.scale + l);
                        }
                        0 !== S.length && (y = Math.max(h - l, y), Tu(S, 0, S.length - 1, m, k)), h = 0;
                        var N = a * w + k;
                        A.lineOffset = Math.max(k, _), f += N, d = Math.max(N, d), ++v;
                    } else f += a, ++v;
                }
                var K, G = f - -17, Z = Bu(o), X = Z.horizontalAlign, J = Z.verticalAlign;
                (function(t1, e1, r, n, i, a, o, s, u) {
                    var l, p = (e1 - r) * i;
                    l = a !== o ? -s * n - -17 : (-n * u + .5) * o;
                    for(var c = 0, h = t1; c < h.length; c += 1)for(var f = 0, y = h[c].positionedGlyphs; f < y.length; f += 1){
                        var d = y[f];
                        d.x += p, d.y += l;
                    }
                })(t1.positionedLines, m, X, J, y, d, a, G, i.length), t1.top += -J * G, t1.bottom = t1.top + G, t1.left += -X * y, t1.right = t1.left + y;
            }(P, e1, r, n, m, o, s, u, c, l, h, d), !function(t1) {
                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (0 !== r[e1].positionedGlyphs.length) return !1;
                return !0;
            }(E) && P;
        }
        Au.fromFeature = function(t1, e1) {
            for(var r = new Au, n = 0; n < t1.sections.length; n++){
                var i = t1.sections[n];
                i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
            }
            return r;
        }, Au.prototype.length = function() {
            return this.text.length;
        }, Au.prototype.getSection = function(t1) {
            return this.sections[this.sectionIndex[t1]];
        }, Au.prototype.getSectionIndex = function(t1) {
            return this.sectionIndex[t1];
        }, Au.prototype.getCharCode = function(t1) {
            return this.text.charCodeAt(t1);
        }, Au.prototype.verticalizePunctuation = function() {
            this.text = function(t1) {
                for(var e1 = "", r = 0; r < t1.length; r++){
                    var n = t1.charCodeAt(r + 1) || null, i = t1.charCodeAt(r - 1) || null;
                    e1 += n && Jn(n) && !Xs[t1[r + 1]] || i && Jn(i) && !Xs[t1[r - 1]] || !Xs[t1[r]] ? t1[r] : Xs[t1[r]];
                }
                return e1;
            }(this.text);
        }, Au.prototype.trim = function() {
            for(var t1 = 0, e1 = 0; e1 < this.text.length && ku[this.text.charCodeAt(e1)]; e1++)t1++;
            for(var r = this.text.length, n = this.text.length - 1; n >= 0 && n >= t1 && ku[this.text.charCodeAt(n)]; n--)r--;
            this.text = this.text.substring(t1, r), this.sectionIndex = this.sectionIndex.slice(t1, r);
        }, Au.prototype.substring = function(t1, e1) {
            var r = new Au;
            return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
        }, Au.prototype.toString = function() {
            return this.text;
        }, Au.prototype.getMaxScale = function() {
            var t1 = this;
            return this.sectionIndex.reduce(function(e1, r) {
                return Math.max(e1, t1.sections[r].scale);
            }, 0);
        }, Au.prototype.addTextSection = function(t1, e1) {
            this.text += t1.text, this.sections.push(_u.forText(t1.scale, t1.fontStack || e1));
            for(var r = this.sections.length - 1, n = 0; n < t1.text.length; ++n)this.sectionIndex.push(r);
        }, Au.prototype.addImageSection = function(t1) {
            var e1 = t1.image ? t1.image.name : "";
            if (0 !== e1.length) {
                var r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(_u.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : A("Reached maximum number of images 6401");
            } else A("Can't add FormattedSection with an empty image.");
        }, Au.prototype.getNextImageSectionCharCode = function() {
            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
        };
        var ku = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Iu = {};
        function zu(t1, e1, r, n, i, a) {
            if (e1.imageName) {
                var o = n[e1.imageName];
                return o ? o.displaySize[0] * e1.scale * 24 / a + i : 0;
            }
            var s = r[e1.fontStack], u = s && s[t1];
            return u ? u.metrics.advance * e1.scale + i : 0;
        }
        function Cu(t1, e1, r, n) {
            var i = Math.pow(t1 - e1, 2);
            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function Eu(t1, e1, r) {
            var n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
        }
        function Pu(t1, e1, r, n, i, a) {
            for(var o = null, s = Cu(e1, r, i, a), u = 0, l = n; u < l.length; u += 1){
                var p = l[u], c = Cu(e1 - p.x, r, i, a) + p.badness;
                c <= s && (o = p, s = c);
            }
            return {
                index: t1,
                x: e1,
                priorBreak: o,
                badness: s
            };
        }
        function Mu(t1, e1, r, n, i, a, o) {
            if ("point" !== a) return [];
            if (!t1) return [];
            for(var s, u = [], l = function(t1, e1, r, n, i, a) {
                for(var o = 0, s = 0; s < t1.length(); s++){
                    var u = t1.getSection(s);
                    o += zu(t1.getCharCode(s), u, n, i, e1, a);
                }
                return o / Math.max(1, Math.ceil(o / r));
            }(t1, e1, r, n, i, o), p = t1.text.indexOf("\u200B") >= 0, c = 0, h = 0; h < t1.length(); h++){
                var f = t1.getSection(h), y = t1.getCharCode(h);
                if (ku[y] || (c += zu(y, f, n, i, e1, o)), h < t1.length() - 1) {
                    var d = !((s = y) < 11904 || !(Gn["Bopomofo Extended"](s) || Gn.Bopomofo(s) || Gn["CJK Compatibility Forms"](s) || Gn["CJK Compatibility Ideographs"](s) || Gn["CJK Compatibility"](s) || Gn["CJK Radicals Supplement"](s) || Gn["CJK Strokes"](s) || Gn["CJK Symbols and Punctuation"](s) || Gn["CJK Unified Ideographs Extension A"](s) || Gn["CJK Unified Ideographs"](s) || Gn["Enclosed CJK Letters and Months"](s) || Gn["Halfwidth and Fullwidth Forms"](s) || Gn.Hiragana(s) || Gn["Ideographic Description Characters"](s) || Gn["Kangxi Radicals"](s) || Gn["Katakana Phonetic Extensions"](s) || Gn.Katakana(s) || Gn["Vertical Forms"](s) || Gn["Yi Radicals"](s) || Gn["Yi Syllables"](s)));
                    (Iu[y] || d || f.imageName) && u.push(Pu(h + 1, c, l, u, Eu(y, t1.getCharCode(h + 1), d && p), !1));
                }
            }
            return function t1(e1) {
                return e1 ? t1(e1.priorBreak).concat(e1.index) : [];
            }(Pu(t1.length(), c, l, u, 0, !0));
        }
        function Bu(t1) {
            var e1 = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e1 = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e1,
                verticalAlign: r
            };
        }
        function Tu(t1, e1, r, n, i) {
            if (n || i) for(var a = t1[r], o = (t1[r].x + a.metrics.advance * a.scale) * n, s = e1; s <= r; s++)t1[s].x -= o, t1[s].y += i;
        }
        function Vu(t1, e1, r, n, i, a) {
            var o, s = t1.image;
            if (s.content) {
                var u = s.content, l = s.pixelRatio || 1;
                o = [
                    u[0] / l,
                    u[1] / l,
                    s.displaySize[0] - u[2] / l,
                    s.displaySize[1] - u[3] / l
                ];
            }
            var p, c, h, f, y = e1.left * a, d = e1.right * a;
            "width" === r || "both" === r ? (f = i[0] + y - n[3], c = i[0] + d + n[1]) : c = (f = i[0] + (y + d - s.displaySize[0]) / 2) + s.displaySize[0];
            var m = e1.top * a, v = e1.bottom * a;
            return "height" === r || "both" === r ? (p = i[1] + m - n[0], h = i[1] + v + n[2]) : h = (p = i[1] + (m + v - s.displaySize[1]) / 2) + s.displaySize[1], {
                image: s,
                top: p,
                right: c,
                bottom: h,
                left: f,
                collisionPadding: o
            };
        }
        Iu[10] = !0, Iu[32] = !0, Iu[38] = !0, Iu[40] = !0, Iu[41] = !0, Iu[43] = !0, Iu[45] = !0, Iu[47] = !0, Iu[173] = !0, Iu[183] = !0, Iu[8203] = !0, Iu[8208] = !0, Iu[8211] = !0, Iu[8231] = !0;
        var Fu = function(t1) {
            function e1(e1, r, n, i) {
                t1.call(this, e1, r), this.angle = n, void 0 !== i && (this.segment = i);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.clone = function() {
                return new e1(this.x, this.y, this.angle, this.segment);
            }, e1;
        }(i);
        function Du(t1, e1) {
            var r = e1.expression;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new si(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            for(var n = r.zoomStops, i = r.interpolationType, a = 0; a < n.length && n[a] <= t1;)a++;
            for(var o = a = Math.max(0, a - 1); o < n.length && n[o] < t1 + 1;)o++;
            o = Math.min(n.length - 1, o);
            var s = n[a], u = n[o];
            return "composite" === r.kind ? {
                kind: "composite",
                minZoom: s,
                maxZoom: u,
                interpolationType: i
            } : {
                kind: "camera",
                minZoom: s,
                maxZoom: u,
                minSize: r.evaluate(new si(s)),
                maxSize: r.evaluate(new si(u)),
                interpolationType: i
            };
        }
        function Lu(t1, e1, r) {
            var n = e1.uSize, i = r.lowerSize;
            return "source" === t1.kind ? i / 128 : "composite" === t1.kind ? Ke(i / 128, r.upperSize / 128, e1.uSizeT) : n;
        }
        function Ou(t1, e1) {
            var r = 0, n = 0;
            if ("constant" === t1.kind) n = t1.layoutSize;
            else if ("source" !== t1.kind) {
                var i = t1.interpolationType, a = i ? p(ar.interpolationFactor(i, e1, t1.minZoom, t1.maxZoom), 0, 1) : 0;
                "camera" === t1.kind ? n = Ke(t1.minSize, t1.maxSize, a) : r = a;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }
        On("Anchor", Fu);
        var Ru = Object.freeze({
            __proto__: null,
            getSizeData: Du,
            evaluateSizeForFeature: Lu,
            evaluateSizeForZoom: Ou,
            SIZE_PACK_FACTOR: 128
        });
        function Uu(t1, e1, r, n, i) {
            if (void 0 === e1.segment) return !0;
            for(var a = e1, o = e1.segment + 1, s = 0; s > -r / 2;){
                if (--o < 0) return !1;
                s -= t1[o].dist(a), a = t1[o];
            }
            s += t1[o].dist(t1[o + 1]), o++;
            for(var u = [], l = 0; s < r / 2;){
                var p = t1[o], c = t1[o + 1];
                if (!c) return !1;
                var h = t1[o - 1].angleTo(p) - p.angleTo(c);
                for(h = Math.abs((h + 3 * Math.PI) % (2 * Math.PI) - Math.PI), u.push({
                    distance: s,
                    angleDelta: h
                }), l += h; s - u[0].distance > n;)l -= u.shift().angleDelta;
                if (l > i) return !1;
                o++, s += p.dist(c);
            }
            return !0;
        }
        function ju(t1) {
            for(var e1 = 0, r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
            return e1;
        }
        function qu(t1, e1, r) {
            return t1 ? .6 * e1 * r : 0;
        }
        function Nu(t1, e1) {
            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function Ku(t1, e1, r, n, i, a) {
            for(var o = qu(r, i, a), s = Nu(r, n) * a, u = 0, l = ju(t1) / 2, p = 0; p < t1.length - 1; p++){
                var c = t1[p], h = t1[p + 1], f = c.dist(h);
                if (u + f > l) {
                    var y = (l - u) / f, d = Ke(c.x, h.x, y), m = Ke(c.y, h.y, y), v = new Fu(d, m, h.angleTo(c), p);
                    return v._round(), !o || Uu(t1, v, s, o, e1) ? v : void 0;
                }
                u += f;
            }
        }
        function Gu(t1, e1, r, n, i, a, o, s, u) {
            var l = qu(n, a, o), p = Nu(n, i), c = p * o, h = 0 === t1[0].x || t1[0].x === u || 0 === t1[0].y || t1[0].y === u;
            return e1 - c < e1 / 4 && (e1 = c + e1 / 4), function t1(e1, r, n, i, a, o, s, u, l) {
                for(var p = o / 2, c = ju(e1), h = 0, f = r - n, y = [], d = 0; d < e1.length - 1; d++){
                    for(var m = e1[d], v = e1[d + 1], g = m.dist(v), x = v.angleTo(m); f + n < h + g;){
                        var b = ((f += n) - h) / g, w = Ke(m.x, v.x, b), _ = Ke(m.y, v.y, b);
                        if (w >= 0 && w < l && _ >= 0 && _ < l && f - p >= 0 && f + p <= c) {
                            var A = new Fu(w, _, x, d);
                            A._round(), i && !Uu(e1, A, o, i, a) || y.push(A);
                        }
                    }
                    h += g;
                }
                return u || y.length || s || (y = t1(e1, h / 2, n, i, a, o, s, !0, l)), y;
            }(t1, h ? e1 / 2 * s % e1 : (p / 2 + 2 * a) * o * s % e1, e1, l, r, c, h, !1, u);
        }
        function Zu(t1, e1, r, n, a) {
            for(var o = [], s = 0; s < t1.length; s++)for(var u = t1[s], l = void 0, p = 0; p < u.length - 1; p++){
                var c = u[p], h = u[p + 1];
                c.x < e1 && h.x < e1 || (c.x < e1 ? c = new i(e1, c.y + (e1 - c.x) / (h.x - c.x) * (h.y - c.y))._round() : h.x < e1 && (h = new i(e1, c.y + (e1 - c.x) / (h.x - c.x) * (h.y - c.y))._round()), c.y < r && h.y < r || (c.y < r ? c = new i(c.x + (r - c.y) / (h.y - c.y) * (h.x - c.x), r)._round() : h.y < r && (h = new i(c.x + (r - c.y) / (h.y - c.y) * (h.x - c.x), r)._round()), c.x >= n && h.x >= n || (c.x >= n ? c = new i(n, c.y + (n - c.x) / (h.x - c.x) * (h.y - c.y))._round() : h.x >= n && (h = new i(n, c.y + (n - c.x) / (h.x - c.x) * (h.y - c.y))._round()), c.y >= a && h.y >= a || (c.y >= a ? c = new i(c.x + (a - c.y) / (h.y - c.y) * (h.x - c.x), a)._round() : h.y >= a && (h = new i(c.x + (a - c.y) / (h.y - c.y) * (h.x - c.x), a)._round()), l && c.equals(l[l.length - 1]) || o.push(l = [
                    c
                ]), l.push(h)))));
            }
            return o;
        }
        function Xu(t1, e1, r, n) {
            var a = [], o = t1.image, s = o.pixelRatio, u = o.paddedRect.w - 2, l = o.paddedRect.h - 2, p = t1.right - t1.left, c = t1.bottom - t1.top, h = o.stretchX || [
                [
                    0,
                    u
                ]
            ], f = o.stretchY || [
                [
                    0,
                    l
                ]
            ], y = function(t1, e1) {
                return t1 + e1[1] - e1[0];
            }, d = h.reduce(y, 0), m = f.reduce(y, 0), v = u - d, g = l - m, x = 0, b = d, w = 0, _ = m, A = 0, S = v, k = 0, I = g;
            if (o.content && n) {
                var z = o.content;
                x = Ju(h, 0, z[0]), w = Ju(f, 0, z[1]), b = Ju(h, z[0], z[2]), _ = Ju(f, z[1], z[3]), A = z[0] - x, k = z[1] - w, S = z[2] - z[0] - b, I = z[3] - z[1] - _;
            }
            var C = function(n, a, u, l) {
                var h = Yu(n.stretch - x, b, p, t1.left), f = $u(n.fixed - A, S, n.stretch, d), y = Yu(a.stretch - w, _, c, t1.top), v = $u(a.fixed - k, I, a.stretch, m), g = Yu(u.stretch - x, b, p, t1.left), z = $u(u.fixed - A, S, u.stretch, d), C = Yu(l.stretch - w, _, c, t1.top), E = $u(l.fixed - k, I, l.stretch, m), P = new i(h, y), M = new i(g, y), B = new i(g, C), T = new i(h, C), V = new i(f / s, v / s), F = new i(z / s, E / s), D = e1 * Math.PI / 180;
                if (D) {
                    var L = Math.sin(D), O = Math.cos(D), R = [
                        O,
                        -L,
                        L,
                        O
                    ];
                    P._matMult(R), M._matMult(R), T._matMult(R), B._matMult(R);
                }
                var U = n.stretch + n.fixed, j = a.stretch + a.fixed;
                return {
                    tl: P,
                    tr: M,
                    bl: T,
                    br: B,
                    tex: {
                        x: o.paddedRect.x + 1 + U,
                        y: o.paddedRect.y + 1 + j,
                        w: u.stretch + u.fixed - U,
                        h: l.stretch + l.fixed - j
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: V,
                    pixelOffsetBR: F,
                    minFontScaleX: S / s / p,
                    minFontScaleY: I / s / c,
                    isSDF: r
                };
            };
            if (n && (o.stretchX || o.stretchY)) for(var E = Hu(h, v, d), P = Hu(f, g, m), M = 0; M < E.length - 1; M++)for(var B = E[M], T = E[M + 1], V = 0; V < P.length - 1; V++)a.push(C(B, P[V], T, P[V + 1]));
            else a.push(C({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: u + 1
            }, {
                fixed: 0,
                stretch: l + 1
            }));
            return a;
        }
        function Ju(t1, e1, r) {
            for(var n = 0, i = 0, a = t1; i < a.length; i += 1){
                var o = a[i];
                n += Math.max(e1, Math.min(r, o[1])) - Math.max(e1, Math.min(r, o[0]));
            }
            return n;
        }
        function Hu(t1, e1, r) {
            for(var n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ], i = 0, a = t1; i < a.length; i += 1){
                var o = a[i], s = o[0], u = o[1], l = n[n.length - 1];
                n.push({
                    fixed: s - l.stretch,
                    stretch: l.stretch
                }), n.push({
                    fixed: s - l.stretch,
                    stretch: l.stretch + (u - s)
                });
            }
            return n.push({
                fixed: e1 + 1,
                stretch: r
            }), n;
        }
        function Yu(t1, e1, r, n) {
            return t1 / e1 * r + n;
        }
        function $u(t1, e1, r, n) {
            return t1 - e1 * r / n;
        }
        var Wu = function(t1, e1, r, n, a, o, s, u, l, p) {
            if (this.boxStartIndex = t1.length, l) {
                var c = o.top, h = o.bottom, f = o.collisionPadding;
                f && (c -= f[1], h += f[3]);
                var y = h - c;
                y > 0 && (y = Math.max(10, y), this.circleDiameter = y);
            } else {
                var d = o.top * s - u, m = o.bottom * s + u, v = o.left * s - u, g = o.right * s + u, x = o.collisionPadding;
                if (x && (v -= x[0] * s, d -= x[1] * s, g += x[2] * s, m += x[3] * s), p) {
                    var b = new i(v, d), w = new i(g, d), _ = new i(v, m), A = new i(g, m), S = p * Math.PI / 180;
                    b._rotate(S), w._rotate(S), _._rotate(S), A._rotate(S), v = Math.min(b.x, w.x, _.x, A.x), g = Math.max(b.x, w.x, _.x, A.x), d = Math.min(b.y, w.y, _.y, A.y), m = Math.max(b.y, w.y, _.y, A.y);
                }
                t1.emplaceBack(e1.x, e1.y, v, d, g, m, r, n, a);
            }
            this.boxEndIndex = t1.length;
        }, Qu = function(t1, e1) {
            if (void 0 === t1 && (t1 = []), void 0 === e1 && (e1 = tl), this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
        };
        function tl(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function el(t1, e1, r) {
            void 0 === e1 && (e1 = 1), void 0 === r && (r = !1);
            for(var n = 1 / 0, a = 1 / 0, o = -1 / 0, s = -1 / 0, u = t1[0], l = 0; l < u.length; l++){
                var p = u[l];
                (!l || p.x < n) && (n = p.x), (!l || p.y < a) && (a = p.y), (!l || p.x > o) && (o = p.x), (!l || p.y > s) && (s = p.y);
            }
            var c = Math.min(o - n, s - a), h = c / 2, f = new Qu([], rl);
            if (0 === c) return new i(n, a);
            for(var y = n; y < o; y += c)for(var d = a; d < s; d += c)f.push(new nl(y + h, d + h, h, t1));
            for(var m = function(t1) {
                for(var e1 = 0, r = 0, n = 0, i = t1[0], a = 0, o = i.length, s = o - 1; a < o; s = a++){
                    var u = i[a], l = i[s], p = u.x * l.y - l.x * u.y;
                    r += (u.x + l.x) * p, n += (u.y + l.y) * p, e1 += 3 * p;
                }
                return new nl(r / e1, n / e1, 0, t1);
            }(t1), v = f.length; f.length;){
                var g = f.pop();
                (g.d > m.d || !m.d) && (m = g, r && console.log("found best %d after %d probes", Math.round(1e4 * g.d) / 1e4, v)), g.max - m.d <= e1 || (f.push(new nl(g.p.x - (h = g.h / 2), g.p.y - h, h, t1)), f.push(new nl(g.p.x + h, g.p.y - h, h, t1)), f.push(new nl(g.p.x - h, g.p.y + h, h, t1)), f.push(new nl(g.p.x + h, g.p.y + h, h, t1)), v += 4);
            }
            return r && (console.log("num probes: " + v), console.log("best distance: " + m.d)), m.p;
        }
        function rl(t1, e1) {
            return e1.max - t1.max;
        }
        function nl(t1, e1, r, n) {
            this.p = new i(t1, e1), this.h = r, this.d = function(t1, e1) {
                for(var r = !1, n = 1 / 0, i = 0; i < e1.length; i++)for(var a = e1[i], o = 0, s = a.length, u = s - 1; o < s; u = o++){
                    var l = a[o], p = a[u];
                    l.y > t1.y != p.y > t1.y && t1.x < (p.x - l.x) * (t1.y - l.y) / (p.y - l.y) + l.x && (r = !r), n = Math.min(n, Ya(t1, l, p));
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        Qu.prototype.push = function(t1) {
            this.data.push(t1), this.length++, this._up(this.length - 1);
        }, Qu.prototype.pop = function() {
            if (0 !== this.length) {
                var t1 = this.data[0], e1 = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
            }
        }, Qu.prototype.peek = function() {
            return this.data[0];
        }, Qu.prototype._up = function(t1) {
            for(var e1 = this.data, r = this.compare, n = e1[t1]; t1 > 0;){
                var i = t1 - 1 >> 1, a = e1[i];
                if (r(n, a) >= 0) break;
                e1[t1] = a, t1 = i;
            }
            e1[t1] = n;
        }, Qu.prototype._down = function(t1) {
            for(var e1 = this.data, r = this.compare, n = this.length >> 1, i = e1[t1]; t1 < n;){
                var a = 1 + (t1 << 1), o = e1[a], s = a + 1;
                if (s < this.length && r(e1[s], o) < 0 && (a = s, o = e1[s]), r(o, i) >= 0) break;
                e1[t1] = o, t1 = a;
            }
            e1[t1] = i;
        };
        var il = Number.POSITIVE_INFINITY;
        function al(t1, e1) {
            return e1[1] !== il ? function(t1, e1, r) {
                var n = 0, i = 0;
                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e1;
                }
                return [
                    n,
                    i
                ];
            }(t1, e1[0], e1[1]) : function(t1, e1) {
                var r = 0, n = 0;
                e1 < 0 && (e1 = 0);
                var i = e1 / Math.sqrt(2);
                switch(t1){
                    case "top-right":
                    case "top-left":
                        n = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = 7 - i;
                        break;
                    case "bottom":
                        n = 7 - e1;
                        break;
                    case "top":
                        n = e1 - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e1;
                        break;
                    case "right":
                        r = -e1;
                }
                return [
                    r,
                    n
                ];
            }(t1, e1[0]);
        }
        function ol(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function sl(t1, e1, r, n, a, o, s, u, l, p, c, h, f, y, d) {
            var m = function(t1, e1, r, n, a, o, s, u) {
                for(var l = n.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, p = [], c = 0, h = e1.positionedLines; c < h.length; c += 1)for(var f = h[c], y = 0, d = f.positionedGlyphs; y < d.length; y += 1){
                    var m = d[y];
                    if (m.rect) {
                        var v = m.rect || {}, g = 4, x = !0, b = 1, w = 0, _ = (a || u) && m.vertical, A = m.metrics.advance * m.scale / 2;
                        if (u && e1.verticalizable && (w = f.lineOffset / 2 - (m.imageName ? -(24 - m.metrics.width * m.scale) / 2 : 24 * (m.scale - 1))), m.imageName) {
                            var S = s[m.imageName];
                            x = S.sdf, g = 1 / (b = S.pixelRatio);
                        }
                        var k = a ? [
                            m.x + A,
                            m.y
                        ] : [
                            0,
                            0
                        ], I = a ? [
                            0,
                            0
                        ] : [
                            m.x + A + r[0],
                            m.y + r[1] - w
                        ], z = [
                            0,
                            0
                        ];
                        _ && (z = I, I = [
                            0,
                            0
                        ]);
                        var C = (m.metrics.left - g) * m.scale - A + I[0], E = (-m.metrics.top - g) * m.scale + I[1], P = C + v.w * m.scale / b, M = E + v.h * m.scale / b, B = new i(C, E), T = new i(P, E), V = new i(C, M), F = new i(P, M);
                        if (_) {
                            var D = new i(-A, A - -17), L = -Math.PI / 2, O = 12 - A, R = new i(22 - O, -(m.imageName ? O : 0)), U = new (Function.prototype.bind.apply(i, [
                                null
                            ].concat(z)));
                            B._rotateAround(L, D)._add(R)._add(U), T._rotateAround(L, D)._add(R)._add(U), V._rotateAround(L, D)._add(R)._add(U), F._rotateAround(L, D)._add(R)._add(U);
                        }
                        if (l) {
                            var j = Math.sin(l), q = Math.cos(l), N = [
                                q,
                                -j,
                                j,
                                q
                            ];
                            B._matMult(N), T._matMult(N), V._matMult(N), F._matMult(N);
                        }
                        var K = new i(0, 0), G = new i(0, 0);
                        p.push({
                            tl: B,
                            tr: T,
                            bl: V,
                            br: F,
                            tex: v,
                            writingMode: e1.writingMode,
                            glyphOffset: k,
                            sectionIndex: m.sectionIndex,
                            isSDF: x,
                            pixelOffsetTL: K,
                            pixelOffsetBR: G,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return p;
            }(0, r, u, a, o, s, n, t1.allowVerticalPlacement), v = t1.textSizeData, g = null;
            "source" === v.kind ? (g = [
                128 * a.layout.get("text-size").evaluate(s, {})
            ])[0] > 32640 && A(t1.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".') : "composite" === v.kind && ((g = [
                128 * y.compositeTextSizes[0].evaluate(s, {}, d),
                128 * y.compositeTextSizes[1].evaluate(s, {}, d)
            ])[0] > 32640 || g[1] > 32640) && A(t1.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".'), t1.addSymbols(t1.text, m, g, u, o, s, p, e1, l.lineStartIndex, l.lineLength, f, d);
            for(var x = 0, b = c; x < b.length; x += 1)h[b[x]] = t1.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function ul(t1) {
            for(var e1 in t1)return t1[e1];
            return null;
        }
        function ll(t1, e1, r, n) {
            var i = t1.compareText;
            if (e1 in i) {
                for(var a = i[e1], o = a.length - 1; o >= 0; o--)if (n.dist(a[o]) < r) return !0;
            } else i[e1] = [];
            return i[e1].push(n), !1;
        }
        var pl = bs.VectorTileFeature.types, cl = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function hl(t1, e1, r, n, i, a, o, s, u, l, p, c, h) {
            var f = s ? Math.min(32640, Math.round(s[0])) : 0, y = s ? Math.min(32640, Math.round(s[1])) : 0;
            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), a, o, (f << 1) + (u ? 1 : 0), y, 16 * l, 16 * p, 256 * c, 256 * h);
        }
        function fl(t1, e1, r) {
            t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r);
        }
        function yl(t1) {
            for(var e1 = 0, r = t1.sections; e1 < r.length; e1 += 1)if ($n(r[e1].text)) return !0;
            return !1;
        }
        var dl = function(t1) {
            this.layoutVertexArray = new Vi, this.indexArray = new ji, this.programConfigurations = t1, this.segments = new sa, this.dynamicLayoutVertexArray = new Fi, this.opacityVertexArray = new Di, this.placedSymbolArray = new Qi;
        };
        dl.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
        }, dl.prototype.upload = function(t1, e1, r, n) {
            this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, js.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, qs.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, cl, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
        }, dl.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
        }, On("SymbolBuffers", dl);
        var ml = function(t1, e1, r) {
            this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new sa, this.collisionVertexArray = new Ui;
        };
        ml.prototype.upload = function(t1) {
            this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, Ns.members, !0);
        }, ml.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
        }, On("CollisionBuffers", ml);
        var vl = function(t1) {
            this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = oo([]), this.placementViewportMatrix = oo([]);
            var e1 = this.layers[0]._unevaluatedLayout._values;
            this.textSizeData = Du(this.zoom, e1["text-size"]), this.iconSizeData = Du(this.zoom, e1["icon-size"]);
            var r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
            this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, "point" === r.get("symbol-placement") && (this.writingModes = r.get("text-writing-mode").map(function(t1) {
                return wu[t1];
            })), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            }), this.sourceID = t1.sourceID;
        };
        vl.prototype.createArrays = function() {
            this.text = new dl(new Va(this.layers, this.zoom, function(t1) {
                return /^text/.test(t1);
            })), this.icon = new dl(new Va(this.layers, this.zoom, function(t1) {
                return /^icon/.test(t1);
            })), this.glyphOffsetArray = new ra, this.lineVertexArray = new na, this.symbolInstances = new ea;
        }, vl.prototype.calculateGlyphDependencies = function(t1, e1, r, n, i) {
            for(var a = 0; a < t1.length; a++)if (e1[t1.charCodeAt(a)] = !0, (r || n) && i) {
                var o = Xs[t1.charAt(a)];
                o && (e1[o.charCodeAt(0)] = !0);
            }
        }, vl.prototype.populate = function(t1, e1, r) {
            var n = this.layers[0], i = n.layout, a = i.get("text-font"), o = i.get("text-field"), s = i.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof ne && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), l = "constant" !== s.value.kind || !!s.value.value || Object.keys(s.parameters).length > 0, p = i.get("symbol-sort-key");
            if (this.features = [], u || l) {
                for(var c = e1.iconDependencies, h = e1.glyphDependencies, f = e1.availableImages, y = new si(this.zoom), d = 0, m = t1; d < m.length; d += 1){
                    var v = m[d], g = v.feature, x = v.id, b = v.index, w = v.sourceLayerIndex, _ = n._featureFilter.needGeometry, A = Ua(g, _);
                    if (n._featureFilter.filter(y, A, r)) {
                        _ || (A.geometry = Ra(g));
                        var S = void 0;
                        if (u) {
                            var k = n.getValueAndResolveTokens("text-field", A, r, f), I = ne.factory(k);
                            yl(I) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ii() || this.hasRTLText && oi.isParsed()) && (S = Zs(I, n, A));
                        }
                        var z = void 0;
                        if (l) {
                            var C = n.getValueAndResolveTokens("icon-image", A, r, f);
                            z = C instanceof ie ? C : ie.fromString(C);
                        }
                        if (S || z) {
                            var E = this.sortFeaturesByKey ? p.evaluate(A, {}, r) : void 0;
                            if (this.features.push({
                                id: x,
                                text: S,
                                icon: z,
                                index: b,
                                sourceLayerIndex: w,
                                geometry: A.geometry,
                                properties: g.properties,
                                type: pl[g.type],
                                sortKey: E
                            }), z && (c[z.name] = !0), S) {
                                var P = a.evaluate(A, {}, r).join(","), M = "map" === i.get("text-rotation-alignment") && "point" !== i.get("symbol-placement");
                                this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(wu.vertical) >= 0;
                                for(var B = 0, T = S.sections; B < T.length; B += 1){
                                    var V = T[B];
                                    if (V.image) c[V.image.name] = !0;
                                    else {
                                        var F = Zn(S.toString()), D = V.fontStack || P, L = h[D] = h[D] || {};
                                        this.calculateGlyphDependencies(V.text, L, M, this.allowVerticalPlacement, F);
                                    }
                                }
                            }
                        }
                    }
                }
                "line" === i.get("symbol-placement") && (this.features = function(t1) {
                    var e1 = {}, r = {}, n = [], i = 0;
                    function a(e1) {
                        n.push(t1[e1]), i++;
                    }
                    function o(t1, e1, i) {
                        var a = r[t1];
                        return delete r[t1], r[e1] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                    }
                    function s(t1, r, i) {
                        var a = e1[r];
                        return delete e1[r], e1[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                    }
                    function u(t1, e1, r) {
                        var n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                        return t1 + ":" + n.x + ":" + n.y;
                    }
                    for(var l = 0; l < t1.length; l++){
                        var p = t1[l], c = p.geometry, h = p.text ? p.text.toString() : null;
                        if (h) {
                            var f = u(h, c), y = u(h, c, !0);
                            if (f in r && y in e1 && r[f] !== e1[y]) {
                                var d = s(f, y, c), m = o(f, y, n[d].geometry);
                                delete e1[f], delete r[y], r[u(h, n[m].geometry, !0)] = m, n[d].geometry = null;
                            } else f in r ? o(f, y, c) : y in e1 ? s(f, y, c) : (a(l), e1[f] = i - 1, r[y] = i - 1);
                        } else a(l);
                    }
                    return n.filter(function(t1) {
                        return t1.geometry;
                    });
                }(this.features)), this.sortFeaturesByKey && this.features.sort(function(t1, e1) {
                    return t1.sortKey - e1.sortKey;
                });
            }
        }, vl.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r));
        }, vl.prototype.isEmpty = function() {
            return 0 === this.symbolInstances.length && !this.hasRTLText;
        }, vl.prototype.uploadPending = function() {
            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
        }, vl.prototype.upload = function(t1) {
            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
        }, vl.prototype.destroyDebugData = function() {
            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
        }, vl.prototype.destroy = function() {
            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
        }, vl.prototype.addToLineVertexArray = function(t1, e1) {
            var r = this.lineVertexArray.length;
            if (void 0 !== t1.segment) {
                for(var n = t1.dist(e1[t1.segment + 1]), i = t1.dist(e1[t1.segment]), a = {}, o = t1.segment + 1; o < e1.length; o++)a[o] = {
                    x: e1[o].x,
                    y: e1[o].y,
                    tileUnitDistanceFromAnchor: n
                }, o < e1.length - 1 && (n += e1[o + 1].dist(e1[o]));
                for(var s = t1.segment || 0; s >= 0; s--)a[s] = {
                    x: e1[s].x,
                    y: e1[s].y,
                    tileUnitDistanceFromAnchor: i
                }, s > 0 && (i += e1[s - 1].dist(e1[s]));
                for(var u = 0; u < e1.length; u++){
                    var l = a[u];
                    this.lineVertexArray.emplaceBack(l.x, l.y, l.tileUnitDistanceFromAnchor);
                }
            }
            return {
                lineStartIndex: r,
                lineLength: this.lineVertexArray.length - r
            };
        }, vl.prototype.addSymbols = function(t1, e1, r, n, i, a, o, s, u, l, p, c) {
            for(var h = t1.indexArray, f = t1.layoutVertexArray, y = t1.segments.prepareSegment(4 * e1.length, f, h, this.canOverlap ? a.sortKey : void 0), d = this.glyphOffsetArray.length, m = y.vertexLength, v = this.allowVerticalPlacement && o === wu.vertical ? Math.PI / 2 : 0, g = a.text && a.text.sections, x = 0; x < e1.length; x++){
                var b = e1[x], w = b.tl, _ = b.tr, A = b.bl, S = b.br, k = b.tex, I = b.pixelOffsetTL, z = b.pixelOffsetBR, C = b.minFontScaleX, E = b.minFontScaleY, P = b.glyphOffset, M = b.isSDF, B = b.sectionIndex, T = y.vertexLength, V = P[1];
                hl(f, s.x, s.y, w.x, V + w.y, k.x, k.y, r, M, I.x, I.y, C, E), hl(f, s.x, s.y, _.x, V + _.y, k.x + k.w, k.y, r, M, z.x, I.y, C, E), hl(f, s.x, s.y, A.x, V + A.y, k.x, k.y + k.h, r, M, I.x, z.y, C, E), hl(f, s.x, s.y, S.x, V + S.y, k.x + k.w, k.y + k.h, r, M, z.x, z.y, C, E), fl(t1.dynamicLayoutVertexArray, s, v), h.emplaceBack(T, T + 1, T + 2), h.emplaceBack(T + 1, T + 2, T + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(P[0]), x !== e1.length - 1 && B === e1[x + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(f.length, a, a.index, {}, c, g && g[B]);
            }
            t1.placedSymbolArray.emplaceBack(s.x, s.y, d, this.glyphOffsetArray.length - d, m, u, l, s.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], o, 0, !1, 0, p);
        }, vl.prototype._addCollisionDebugVertex = function(t1, e1, r, n, i, a) {
            return e1.emplaceBack(0, 0), t1.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
        }, vl.prototype.addCollisionDebugVertices = function(t1, e1, r, n, a, o, s) {
            var u = a.segments.prepareSegment(4, a.layoutVertexArray, a.indexArray), l = u.vertexLength, p = a.layoutVertexArray, c = a.collisionVertexArray, h = s.anchorX, f = s.anchorY;
            this._addCollisionDebugVertex(p, c, o, h, f, new i(t1, e1)), this._addCollisionDebugVertex(p, c, o, h, f, new i(r, e1)), this._addCollisionDebugVertex(p, c, o, h, f, new i(r, n)), this._addCollisionDebugVertex(p, c, o, h, f, new i(t1, n)), u.vertexLength += 4;
            var y = a.indexArray;
            y.emplaceBack(l, l + 1), y.emplaceBack(l + 1, l + 2), y.emplaceBack(l + 2, l + 3), y.emplaceBack(l + 3, l), u.primitiveLength += 4;
        }, vl.prototype.addDebugCollisionBoxes = function(t1, e1, r, n) {
            for(var i = t1; i < e1; i++){
                var a = this.collisionBoxArray.get(i);
                this.addCollisionDebugVertices(a.x1, a.y1, a.x2, a.y2, n ? this.textCollisionBox : this.iconCollisionBox, a.anchorPoint, r);
            }
        }, vl.prototype.generateCollisionDebugBuffers = function() {
            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new ml(Oi, Ks.members, Xi), this.iconCollisionBox = new ml(Oi, Ks.members, Xi);
            for(var t1 = 0; t1 < this.symbolInstances.length; t1++){
                var e1 = this.symbolInstances.get(t1);
                this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
            }
        }, vl.prototype._deserializeCollisionBoxesForSymbol = function(t1, e1, r, n, i, a, o, s, u) {
            for(var l = {}, p = e1; p < r; p++){
                var c = t1.get(p);
                l.textBox = {
                    x1: c.x1,
                    y1: c.y1,
                    x2: c.x2,
                    y2: c.y2,
                    anchorPointX: c.anchorPointX,
                    anchorPointY: c.anchorPointY
                }, l.textFeatureIndex = c.featureIndex;
                break;
            }
            for(var h = n; h < i; h++){
                var f = t1.get(h);
                l.verticalTextBox = {
                    x1: f.x1,
                    y1: f.y1,
                    x2: f.x2,
                    y2: f.y2,
                    anchorPointX: f.anchorPointX,
                    anchorPointY: f.anchorPointY
                }, l.verticalTextFeatureIndex = f.featureIndex;
                break;
            }
            for(var y = a; y < o; y++){
                var d = t1.get(y);
                l.iconBox = {
                    x1: d.x1,
                    y1: d.y1,
                    x2: d.x2,
                    y2: d.y2,
                    anchorPointX: d.anchorPointX,
                    anchorPointY: d.anchorPointY
                }, l.iconFeatureIndex = d.featureIndex;
                break;
            }
            for(var m = s; m < u; m++){
                var v = t1.get(m);
                l.verticalIconBox = {
                    x1: v.x1,
                    y1: v.y1,
                    x2: v.x2,
                    y2: v.y2,
                    anchorPointX: v.anchorPointX,
                    anchorPointY: v.anchorPointY
                }, l.verticalIconFeatureIndex = v.featureIndex;
                break;
            }
            return l;
        }, vl.prototype.deserializeCollisionBoxes = function(t1) {
            this.collisionArrays = [];
            for(var e1 = 0; e1 < this.symbolInstances.length; e1++){
                var r = this.symbolInstances.get(e1);
                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
            }
        }, vl.prototype.hasTextData = function() {
            return this.text.segments.get().length > 0;
        }, vl.prototype.hasIconData = function() {
            return this.icon.segments.get().length > 0;
        }, vl.prototype.hasDebugData = function() {
            return this.textCollisionBox && this.iconCollisionBox;
        }, vl.prototype.hasTextCollisionBoxData = function() {
            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
        }, vl.prototype.hasIconCollisionBoxData = function() {
            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
        }, vl.prototype.addIndicesForPlacedSymbol = function(t1, e1) {
            for(var r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs, i = r.vertexStartIndex; i < n; i += 4)t1.indexArray.emplaceBack(i, i + 1, i + 2), t1.indexArray.emplaceBack(i + 1, i + 2, i + 3);
        }, vl.prototype.getSortedSymbolIndexes = function(t1) {
            if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
            for(var e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [], o = 0; o < this.symbolInstances.length; ++o){
                a.push(o);
                var s = this.symbolInstances.get(o);
                n.push(0 | Math.round(e1 * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
            }
            return a.sort(function(t1, e1) {
                return n[t1] - n[e1] || i[e1] - i[t1];
            }), a;
        }, vl.prototype.addToSortKeyRanges = function(t1, e1) {
            var r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
            r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                sortKey: e1,
                symbolInstanceStart: t1,
                symbolInstanceEnd: t1 + 1
            });
        }, vl.prototype.sortFeatures = function(t1) {
            var e1 = this;
            if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                for(var r = 0, n = this.symbolInstanceIndexes; r < n.length; r += 1){
                    var i = this.symbolInstances.get(n[r]);
                    this.featureSortOrder.push(i.featureIndex), [
                        i.rightJustifiedTextSymbolIndex,
                        i.centerJustifiedTextSymbolIndex,
                        i.leftJustifiedTextSymbolIndex
                    ].forEach(function(t1, r, n) {
                        t1 >= 0 && n.indexOf(t1) === r && e1.addIndicesForPlacedSymbol(e1.text, t1);
                    }), i.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, i.verticalPlacedTextSymbolIndex), i.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, i.placedIconSymbolIndex), i.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, i.verticalPlacedIconSymbolIndex);
                }
                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
            }
        }, On("SymbolBucket", vl, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), vl.MAX_GLYPHS = 65535, vl.addDynamicAttributes = fl;
        var gl = new wi({
            "symbol-placement": new mi(Et.layout_symbol["symbol-placement"]),
            "symbol-spacing": new mi(Et.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new mi(Et.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new vi(Et.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new mi(Et.layout_symbol["symbol-z-order"]),
            "icon-allow-overlap": new mi(Et.layout_symbol["icon-allow-overlap"]),
            "icon-ignore-placement": new mi(Et.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new mi(Et.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new mi(Et.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new vi(Et.layout_symbol["icon-size"]),
            "icon-text-fit": new mi(Et.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new mi(Et.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new vi(Et.layout_symbol["icon-image"]),
            "icon-rotate": new vi(Et.layout_symbol["icon-rotate"]),
            "icon-padding": new mi(Et.layout_symbol["icon-padding"]),
            "icon-keep-upright": new mi(Et.layout_symbol["icon-keep-upright"]),
            "icon-offset": new vi(Et.layout_symbol["icon-offset"]),
            "icon-anchor": new vi(Et.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new mi(Et.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new mi(Et.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new mi(Et.layout_symbol["text-rotation-alignment"]),
            "text-field": new vi(Et.layout_symbol["text-field"]),
            "text-font": new vi(Et.layout_symbol["text-font"]),
            "text-size": new vi(Et.layout_symbol["text-size"]),
            "text-max-width": new vi(Et.layout_symbol["text-max-width"]),
            "text-line-height": new mi(Et.layout_symbol["text-line-height"]),
            "text-letter-spacing": new vi(Et.layout_symbol["text-letter-spacing"]),
            "text-justify": new vi(Et.layout_symbol["text-justify"]),
            "text-radial-offset": new vi(Et.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new mi(Et.layout_symbol["text-variable-anchor"]),
            "text-anchor": new vi(Et.layout_symbol["text-anchor"]),
            "text-max-angle": new mi(Et.layout_symbol["text-max-angle"]),
            "text-writing-mode": new mi(Et.layout_symbol["text-writing-mode"]),
            "text-rotate": new vi(Et.layout_symbol["text-rotate"]),
            "text-padding": new mi(Et.layout_symbol["text-padding"]),
            "text-keep-upright": new mi(Et.layout_symbol["text-keep-upright"]),
            "text-transform": new vi(Et.layout_symbol["text-transform"]),
            "text-offset": new vi(Et.layout_symbol["text-offset"]),
            "text-allow-overlap": new mi(Et.layout_symbol["text-allow-overlap"]),
            "text-ignore-placement": new mi(Et.layout_symbol["text-ignore-placement"]),
            "text-optional": new mi(Et.layout_symbol["text-optional"])
        }), xl = {
            paint: new wi({
                "icon-opacity": new vi(Et.paint_symbol["icon-opacity"]),
                "icon-color": new vi(Et.paint_symbol["icon-color"]),
                "icon-halo-color": new vi(Et.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new vi(Et.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new vi(Et.paint_symbol["icon-halo-blur"]),
                "icon-translate": new mi(Et.paint_symbol["icon-translate"]),
                "icon-translate-anchor": new mi(Et.paint_symbol["icon-translate-anchor"]),
                "text-opacity": new vi(Et.paint_symbol["text-opacity"]),
                "text-color": new vi(Et.paint_symbol["text-color"], {
                    runtimeType: jt,
                    getOverride: function(t1) {
                        return t1.textColor;
                    },
                    hasOverride: function(t1) {
                        return !!t1.textColor;
                    }
                }),
                "text-halo-color": new vi(Et.paint_symbol["text-halo-color"]),
                "text-halo-width": new vi(Et.paint_symbol["text-halo-width"]),
                "text-halo-blur": new vi(Et.paint_symbol["text-halo-blur"]),
                "text-translate": new mi(Et.paint_symbol["text-translate"]),
                "text-translate-anchor": new mi(Et.paint_symbol["text-translate-anchor"])
            }),
            layout: gl
        }, bl = function(t1) {
            this.type = t1.property.overrides ? t1.property.overrides.runtimeType : Lt, this.defaultValue = t1;
        };
        bl.prototype.evaluate = function(t1) {
            if (t1.formattedSection) {
                var e1 = this.defaultValue.property.overrides;
                if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
            }
            return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
        }, bl.prototype.eachChild = function(t1) {
            this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
        }, bl.prototype.outputDefined = function() {
            return !1;
        }, bl.prototype.serialize = function() {
            return null;
        }, On("FormatSectionOverride", bl, {
            omit: [
                "defaultValue"
            ]
        });
        var wl = function(t1) {
            function e1(e1) {
                t1.call(this, e1, xl);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.recalculate = function(e1, r) {
                if (t1.prototype.recalculate.call(this, e1, r), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    var n = this.layout.get("text-writing-mode");
                    if (n) {
                        for(var i = [], a = 0, o = n; a < o.length; a += 1){
                            var s = o[a];
                            i.indexOf(s) < 0 && i.push(s);
                        }
                        this.layout._values["text-writing-mode"] = i;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }, e1.prototype.getValueAndResolveTokens = function(t1, e1, r, n) {
                var i = this.layout.get(t1).evaluate(e1, {}, r, n), a = this._unevaluatedLayout._values[t1];
                return a.isDataDriven() || Gr(a.value) || !i ? i : function(t1, e1) {
                    return e1.replace(/{([^{}]+)}/g, function(e1, r) {
                        return r in t1 ? String(t1[r]) : "";
                    });
                }(e1.properties, i);
            }, e1.prototype.createBucket = function(t1) {
                return new vl(t1);
            }, e1.prototype.queryRadius = function() {
                return 0;
            }, e1.prototype.queryIntersectsFeature = function() {
                return !1;
            }, e1.prototype._setPaintOverrides = function() {
                for(var t1 = 0, r = xl.paint.overridableProperties; t1 < r.length; t1 += 1){
                    var n = r[t1];
                    if (e1.hasPaintOverride(this.layout, n)) {
                        var i, a = this.paint.get(n), o = new bl(a), s = new Kr(o, a.property.specification);
                        i = "constant" === a.value.kind || "source" === a.value.kind ? new Xr("source", s) : new Jr("composite", s, a.value.zoomStops, a.value._interpolationType), this.paint._values[n] = new yi(a.property, i, a.parameters);
                    }
                }
            }, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, r, n) {
                return !(!this.layout || r.isDataDriven() || n.isDataDriven()) && e1.hasPaintOverride(this.layout, t1);
            }, e1.hasPaintOverride = function(t1, e1) {
                var r = t1.get("text-field"), n = xl.paint.properties[e1], i = !1, a = function(t1) {
                    for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (n.overrides && n.overrides.hasOverride(r[e1])) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof ne) a(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    var o = function(t1) {
                        i || (t1 instanceof le && se(t1.value) === Gt ? a(t1.value.sections) : t1 instanceof fe ? a(t1.sections) : t1.eachChild(o));
                    }, s = r.value;
                    s._styleExpression && o(s._styleExpression.expression);
                }
                return i;
            }, e1;
        }(_i), _l = {
            paint: new wi({
                "background-color": new mi(Et.paint_background["background-color"]),
                "background-pattern": new xi(Et.paint_background["background-pattern"]),
                "background-opacity": new mi(Et.paint_background["background-opacity"])
            })
        }, Al = function(t1) {
            function e1(e1) {
                t1.call(this, e1, _l);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(_i), Sl = {
            paint: new wi({
                "raster-opacity": new mi(Et.paint_raster["raster-opacity"]),
                "raster-hue-rotate": new mi(Et.paint_raster["raster-hue-rotate"]),
                "raster-brightness-min": new mi(Et.paint_raster["raster-brightness-min"]),
                "raster-brightness-max": new mi(Et.paint_raster["raster-brightness-max"]),
                "raster-saturation": new mi(Et.paint_raster["raster-saturation"]),
                "raster-contrast": new mi(Et.paint_raster["raster-contrast"]),
                "raster-resampling": new mi(Et.paint_raster["raster-resampling"]),
                "raster-fade-duration": new mi(Et.paint_raster["raster-fade-duration"])
            })
        }, kl = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Sl);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(_i), Il = function(t1) {
            function e1(e1) {
                t1.call(this, e1, {}), this.implementation = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.is3D = function() {
                return "3d" === this.implementation.renderingMode;
            }, e1.prototype.hasOffscreenPass = function() {
                return void 0 !== this.implementation.prerender;
            }, e1.prototype.recalculate = function() {}, e1.prototype.updateTransitions = function() {}, e1.prototype.hasTransition = function() {}, e1.prototype.serialize = function() {}, e1.prototype.onAdd = function(t1) {
                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
            }, e1.prototype.onRemove = function(t1) {
                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
            }, e1;
        }(_i), zl = {
            circle: co,
            heatmap: _o,
            hillshade: So,
            fill: ps,
            "fill-extrusion": zs,
            line: Rs,
            symbol: wl,
            background: Al,
            raster: kl
        }, Cl = o.HTMLImageElement, El = o.HTMLCanvasElement, Pl = o.HTMLVideoElement, Ml = o.ImageData, Bl = o.ImageBitmap, Tl = function(t1, e1, r, n) {
            this.context = t1, this.format = r, this.texture = t1.gl.createTexture(), this.update(e1, n);
        };
        Tl.prototype.update = function(t1, e1, r) {
            var n = t1.width, i = t1.height, a = !(this.size && this.size[0] === n && this.size[1] === i || r), o = this.context, s = o.gl;
            if (this.useMipmap = Boolean(e1 && e1.useMipmap), s.bindTexture(s.TEXTURE_2D, this.texture), o.pixelStoreUnpackFlipY.set(!1), o.pixelStoreUnpack.set(1), o.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA && (!e1 || !1 !== e1.premultiply)), a) this.size = [
                n,
                i
            ], t1 instanceof Cl || t1 instanceof El || t1 instanceof Pl || t1 instanceof Ml || Bl && t1 instanceof Bl ? s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, s.UNSIGNED_BYTE, t1) : s.texImage2D(s.TEXTURE_2D, 0, this.format, n, i, 0, this.format, s.UNSIGNED_BYTE, t1.data);
            else {
                var u = r || {
                    x: 0,
                    y: 0
                }, l = u.x, p = u.y;
                t1 instanceof Cl || t1 instanceof El || t1 instanceof Pl || t1 instanceof Ml || Bl && t1 instanceof Bl ? s.texSubImage2D(s.TEXTURE_2D, 0, l, p, s.RGBA, s.UNSIGNED_BYTE, t1) : s.texSubImage2D(s.TEXTURE_2D, 0, l, p, n, i, s.RGBA, s.UNSIGNED_BYTE, t1.data);
            }
            this.useMipmap && this.isSizePowerOfTwo() && s.generateMipmap(s.TEXTURE_2D);
        }, Tl.prototype.bind = function(t1, e1, r) {
            var n = this.context.gl;
            n.bindTexture(n.TEXTURE_2D, this.texture), r !== n.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = n.LINEAR), t1 !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, r || t1), this.filter = t1), e1 !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e1), this.wrap = e1);
        }, Tl.prototype.isSizePowerOfTwo = function() {
            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
        }, Tl.prototype.destroy = function() {
            this.context.gl.deleteTexture(this.texture), this.texture = null;
        };
        var Vl = function(t1) {
            var e1 = this;
            this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = function() {
                e1._triggered = !1, e1._callback();
            });
        };
        Vl.prototype.trigger = function() {
            var t1 = this;
            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function() {
                t1._triggered = !1, t1._callback();
            }, 0));
        }, Vl.prototype.remove = function() {
            delete this._channel, this._callback = function() {};
        };
        var Fl = function(t1, e1, r) {
            this.target = t1, this.parent = e1, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, v([
                "receive",
                "process"
            ], this), this.invoker = new Vl(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = I() ? t1 : o;
        };
        function Dl(t1, e1, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t1 * n - 2 * Math.PI * 6378137 / 2,
                e1 * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        Fl.prototype.send = function(t1, e1, r, n, i) {
            var a = this;
            void 0 === i && (i = !1);
            var o = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
            r && (this.callbacks[o] = r);
            var s = E(this.globalScope) ? void 0 : [];
            return this.target.postMessage({
                id: o,
                type: t1,
                hasCallback: !!r,
                targetMapId: n,
                mustQueue: i,
                sourceMapId: this.mapId,
                data: qn(e1, s)
            }, s), {
                cancel: function() {
                    r && delete a.callbacks[o], a.target.postMessage({
                        id: o,
                        type: "<cancel>",
                        targetMapId: n,
                        sourceMapId: a.mapId
                    });
                }
            };
        }, Fl.prototype.receive = function(t1) {
            var e1 = t1.data, r = e1.id;
            if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                if ("<cancel>" === e1.type) {
                    delete this.tasks[r];
                    var n = this.cancelCallbacks[r];
                    delete this.cancelCallbacks[r], n && n();
                } else I() || e1.mustQueue ? (this.tasks[r] = e1, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e1);
            }
        }, Fl.prototype.process = function() {
            if (this.taskQueue.length) {
                var t1 = this.taskQueue.shift(), e1 = this.tasks[t1];
                delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), e1 && this.processTask(t1, e1);
            }
        }, Fl.prototype.processTask = function(t1, e1) {
            var r = this;
            if ("<response>" === e1.type) {
                var n = this.callbacks[t1];
                delete this.callbacks[t1], n && (e1.error ? n(Nn(e1.error)) : n(null, Nn(e1.data)));
            } else {
                var i = !1, a = E(this.globalScope) ? void 0 : [], o = e1.hasCallback ? function(e1, n) {
                    i = !0, delete r.cancelCallbacks[t1], r.target.postMessage({
                        id: t1,
                        type: "<response>",
                        sourceMapId: r.mapId,
                        error: e1 ? qn(e1) : null,
                        data: qn(n, a)
                    }, a);
                } : function(t1) {
                    i = !0;
                }, s = null, u = Nn(e1.data);
                if (this.parent[e1.type]) s = this.parent[e1.type](e1.sourceMapId, u, o);
                else if (this.parent.getWorkerSource) {
                    var l = e1.type.split(".");
                    s = this.parent.getWorkerSource(e1.sourceMapId, l[0], u.source)[l[1]](u, o);
                } else o(new Error("Could not find function " + e1.type));
                !i && s && s.cancel && (this.cancelCallbacks[t1] = s.cancel);
            }
        }, Fl.prototype.remove = function() {
            this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
        };
        var Ll = function(t1, e1) {
            t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : 4 === t1.length ? this.setSouthWest([
                t1[0],
                t1[1]
            ]).setNorthEast([
                t1[2],
                t1[3]
            ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1]));
        };
        Ll.prototype.setNorthEast = function(t1) {
            return this._ne = t1 instanceof Ol ? new Ol(t1.lng, t1.lat) : Ol.convert(t1), this;
        }, Ll.prototype.setSouthWest = function(t1) {
            return this._sw = t1 instanceof Ol ? new Ol(t1.lng, t1.lat) : Ol.convert(t1), this;
        }, Ll.prototype.extend = function(t1) {
            var e1, r, n = this._sw, i = this._ne;
            if (t1 instanceof Ol) e1 = t1, r = t1;
            else {
                if (!(t1 instanceof Ll)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(Ll.convert(t1)) : this.extend(Ol.convert(t1)) : this;
                if (r = t1._ne, !(e1 = t1._sw) || !r) return this;
            }
            return n || i ? (n.lng = Math.min(e1.lng, n.lng), n.lat = Math.min(e1.lat, n.lat), i.lng = Math.max(r.lng, i.lng), i.lat = Math.max(r.lat, i.lat)) : (this._sw = new Ol(e1.lng, e1.lat), this._ne = new Ol(r.lng, r.lat)), this;
        }, Ll.prototype.getCenter = function() {
            return new Ol((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
        }, Ll.prototype.getSouthWest = function() {
            return this._sw;
        }, Ll.prototype.getNorthEast = function() {
            return this._ne;
        }, Ll.prototype.getNorthWest = function() {
            return new Ol(this.getWest(), this.getNorth());
        }, Ll.prototype.getSouthEast = function() {
            return new Ol(this.getEast(), this.getSouth());
        }, Ll.prototype.getWest = function() {
            return this._sw.lng;
        }, Ll.prototype.getSouth = function() {
            return this._sw.lat;
        }, Ll.prototype.getEast = function() {
            return this._ne.lng;
        }, Ll.prototype.getNorth = function() {
            return this._ne.lat;
        }, Ll.prototype.toArray = function() {
            return [
                this._sw.toArray(),
                this._ne.toArray()
            ];
        }, Ll.prototype.toString = function() {
            return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")";
        }, Ll.prototype.isEmpty = function() {
            return !(this._sw && this._ne);
        }, Ll.prototype.contains = function(t1) {
            var e1 = Ol.convert(t1), r = e1.lng, n = e1.lat, i = this._sw.lng <= r && r <= this._ne.lng;
            return this._sw.lng > this._ne.lng && (i = this._sw.lng >= r && r >= this._ne.lng), this._sw.lat <= n && n <= this._ne.lat && i;
        }, Ll.convert = function(t1) {
            return !t1 || t1 instanceof Ll ? t1 : new Ll(t1);
        };
        var Ol = function(t1, e1) {
            if (isNaN(t1) || isNaN(e1)) throw new Error("Invalid LngLat object: (" + t1 + ", " + e1 + ")");
            if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
        };
        Ol.prototype.wrap = function() {
            return new Ol(c(this.lng, -180, 180), this.lat);
        }, Ol.prototype.toArray = function() {
            return [
                this.lng,
                this.lat
            ];
        }, Ol.prototype.toString = function() {
            return "LngLat(" + this.lng + ", " + this.lat + ")";
        }, Ol.prototype.distanceTo = function(t1) {
            var e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
            return 6371008.8 * Math.acos(Math.min(i, 1));
        }, Ol.prototype.toBounds = function(t1) {
            void 0 === t1 && (t1 = 0);
            var e1 = 360 * t1 / 40075017, r = e1 / Math.cos(Math.PI / 180 * this.lat);
            return new Ll(new Ol(this.lng - r, this.lat - e1), new Ol(this.lng + r, this.lat + e1));
        }, Ol.convert = function(t1) {
            if (t1 instanceof Ol) return t1;
            if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new Ol(Number(t1[0]), Number(t1[1]));
            if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new Ol(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
        };
        var Rl = 2 * Math.PI * 6371008.8;
        function Ul(t1) {
            return Rl * Math.cos(t1 * Math.PI / 180);
        }
        function jl(t1) {
            return (180 + t1) / 360;
        }
        function ql(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function Nl(t1, e1) {
            return t1 / Ul(e1);
        }
        function Kl(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        var Gl = function(t1, e1, r) {
            void 0 === r && (r = 0), this.x = +t1, this.y = +e1, this.z = +r;
        };
        Gl.fromLngLat = function(t1, e1) {
            void 0 === e1 && (e1 = 0);
            var r = Ol.convert(t1);
            return new Gl(jl(r.lng), ql(r.lat), Nl(e1, r.lat));
        }, Gl.prototype.toLngLat = function() {
            return new Ol(360 * this.x - 180, Kl(this.y));
        }, Gl.prototype.toAltitude = function() {
            return this.z * Ul(Kl(this.y));
        }, Gl.prototype.meterInMercatorCoordinateUnits = function() {
            var t1;
            return 1 / Rl * (t1 = Kl(this.y), 1 / Math.cos(t1 * Math.PI / 180));
        };
        var Zl = function(t1, e1, r) {
            this.z = t1, this.x = e1, this.y = r, this.key = Hl(0, t1, t1, e1, r);
        };
        Zl.prototype.equals = function(t1) {
            return this.z === t1.z && this.x === t1.x && this.y === t1.y;
        }, Zl.prototype.url = function(t1, e1) {
            var r, n, i, a, o, s = (n = this.y, i = this.z, a = Dl(256 * (r = this.x), 256 * (n = Math.pow(2, i) - n - 1), i), o = Dl(256 * (r + 1), 256 * (n + 1), i), a[0] + "," + a[1] + "," + o[0] + "," + o[1]), u = function(t1, e1, r) {
                for(var n, i = "", a = t1; a > 0; a--)i += (e1 & (n = 1 << a - 1) ? 1 : 0) + (r & n ? 2 : 0);
                return i;
            }(this.z, this.x, this.y);
            return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String("tms" === e1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", u).replace("{bbox-epsg-3857}", s);
        }, Zl.prototype.getTilePoint = function(t1) {
            var e1 = Math.pow(2, this.z);
            return new i(8192 * (t1.x * e1 - this.x), 8192 * (t1.y * e1 - this.y));
        }, Zl.prototype.toString = function() {
            return this.z + "/" + this.x + "/" + this.y;
        };
        var Xl = function(t1, e1) {
            this.wrap = t1, this.canonical = e1, this.key = Hl(t1, e1.z, e1.z, e1.x, e1.y);
        }, Jl = function(t1, e1, r, n, i) {
            this.overscaledZ = t1, this.wrap = e1, this.canonical = new Zl(r, +n, +i), this.key = Hl(e1, t1, r, n, i);
        };
        function Hl(t1, e1, r, n, i) {
            (t1 *= 2) < 0 && (t1 = -1 * t1 - 1);
            var a = 1 << r;
            return (a * a * t1 + a * i + n).toString(36) + r.toString(36) + e1.toString(36);
        }
        Jl.prototype.equals = function(t1) {
            return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
        }, Jl.prototype.scaledTo = function(t1) {
            var e1 = this.canonical.z - t1;
            return t1 > this.canonical.z ? new Jl(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Jl(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
        }, Jl.prototype.calculateScaledKey = function(t1, e1) {
            var r = this.canonical.z - t1;
            return t1 > this.canonical.z ? Hl(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y) : Hl(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
        }, Jl.prototype.isChildOf = function(t1) {
            if (t1.wrap !== this.wrap) return !1;
            var e1 = this.canonical.z - t1.canonical.z;
            return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
        }, Jl.prototype.children = function(t1) {
            if (this.overscaledZ >= t1) return [
                new Jl(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
            ];
            var e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
            return [
                new Jl(e1, this.wrap, e1, r, n),
                new Jl(e1, this.wrap, e1, r + 1, n),
                new Jl(e1, this.wrap, e1, r, n + 1),
                new Jl(e1, this.wrap, e1, r + 1, n + 1)
            ];
        }, Jl.prototype.isLessThan = function(t1) {
            return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
        }, Jl.prototype.wrapped = function() {
            return new Jl(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
        }, Jl.prototype.unwrapTo = function(t1) {
            return new Jl(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
        }, Jl.prototype.overscaleFactor = function() {
            return Math.pow(2, this.overscaledZ - this.canonical.z);
        }, Jl.prototype.toUnwrapped = function() {
            return new Xl(this.wrap, this.canonical);
        }, Jl.prototype.toString = function() {
            return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y;
        }, Jl.prototype.getTilePoint = function(t1) {
            return this.canonical.getTilePoint(new Gl(t1.x - this.wrap, t1.y));
        }, On("CanonicalTileID", Zl), On("OverscaledTileID", Jl, {
            omit: [
                "posMatrix"
            ]
        });
        var Yl = function(t1, e1, r) {
            if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
            if (r && "mapbox" !== r && "terrarium" !== r) return A('"' + r + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
            this.stride = e1.height;
            var n = this.dim = e1.height - 2;
            this.data = new Uint32Array(e1.data.buffer), this.encoding = r || "mapbox";
            for(var i = 0; i < n; i++)this.data[this._idx(-1, i)] = this.data[this._idx(0, i)], this.data[this._idx(n, i)] = this.data[this._idx(n - 1, i)], this.data[this._idx(i, -1)] = this.data[this._idx(i, 0)], this.data[this._idx(i, n)] = this.data[this._idx(i, n - 1)];
            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(n, -1)] = this.data[this._idx(n - 1, 0)], this.data[this._idx(-1, n)] = this.data[this._idx(0, n - 1)], this.data[this._idx(n, n)] = this.data[this._idx(n - 1, n - 1)];
        };
        Yl.prototype.get = function(t1, e1) {
            var r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t1, e1);
            return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(r[n], r[n + 1], r[n + 2]);
        }, Yl.prototype.getUnpackVector = function() {
            return "terrarium" === this.encoding ? [
                256,
                1,
                1 / 256,
                32768
            ] : [
                6553.6,
                25.6,
                .1,
                1e4
            ];
        }, Yl.prototype._idx = function(t1, e1) {
            if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
            return (e1 + 1) * this.stride + (t1 + 1);
        }, Yl.prototype._unpackMapbox = function(t1, e1, r) {
            return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
        }, Yl.prototype._unpackTerrarium = function(t1, e1, r) {
            return 256 * t1 + e1 + r / 256 - 32768;
        }, Yl.prototype.getPixels = function() {
            return new xo({
                width: this.stride,
                height: this.stride
            }, new Uint8Array(this.data.buffer));
        }, Yl.prototype.backfillBorder = function(t1, e1, r) {
            if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
            var n = e1 * this.dim, i = e1 * this.dim + this.dim, a = r * this.dim, o = r * this.dim + this.dim;
            switch(e1){
                case -1:
                    n = i - 1;
                    break;
                case 1:
                    i = n + 1;
            }
            switch(r){
                case -1:
                    a = o - 1;
                    break;
                case 1:
                    o = a + 1;
            }
            for(var s = -e1 * this.dim, u = -r * this.dim, l = a; l < o; l++)for(var p = n; p < i; p++)this.data[this._idx(p, l)] = t1.data[this._idx(p + s, l + u)];
        }, On("DEMData", Yl);
        var $l = function(t1) {
            this._stringToNumber = {}, this._numberToString = [];
            for(var e1 = 0; e1 < t1.length; e1++){
                var r = t1[e1];
                this._stringToNumber[r] = e1, this._numberToString[e1] = r;
            }
        };
        $l.prototype.encode = function(t1) {
            return this._stringToNumber[t1];
        }, $l.prototype.decode = function(t1) {
            return this._numberToString[t1];
        };
        var Wl = function(t1, e1, r, n, i) {
            this.type = "Feature", this._vectorTileFeature = t1, t1._z = e1, t1._x = r, t1._y = n, this.properties = t1.properties, this.id = i;
        }, Ql = {
            geometry: {
                configurable: !0
            }
        };
        Ql.geometry.get = function() {
            return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
        }, Ql.geometry.set = function(t1) {
            this._geometry = t1;
        }, Wl.prototype.toJSON = function() {
            var t1 = {
                geometry: this.geometry
            };
            for(var e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && (t1[e1] = this[e1]);
            return t1;
        }, Object.defineProperties(Wl.prototype, Ql);
        var tp = function() {
            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
        };
        tp.prototype.updateState = function(t1, e1, r) {
            var n = String(e1);
            if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][n] = this.stateChanges[t1][n] || {}, h(this.stateChanges[t1][n], r), null === this.deletedStates[t1]) for(var i in this.deletedStates[t1] = {}, this.state[t1])i !== n && (this.deletedStates[t1][i] = null);
            else if (this.deletedStates[t1] && null === this.deletedStates[t1][n]) for(var a in this.deletedStates[t1][n] = {}, this.state[t1][n])r[a] || (this.deletedStates[t1][n][a] = null);
            else for(var o in r)this.deletedStates[t1] && this.deletedStates[t1][n] && null === this.deletedStates[t1][n][o] && delete this.deletedStates[t1][n][o];
        }, tp.prototype.removeFeatureState = function(t1, e1, r) {
            if (null !== this.deletedStates[t1]) {
                var n = String(e1);
                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, r && void 0 !== e1) null !== this.deletedStates[t1][n] && (this.deletedStates[t1][n] = this.deletedStates[t1][n] || {}, this.deletedStates[t1][n][r] = null);
                else if (void 0 !== e1) {
                    if (this.stateChanges[t1] && this.stateChanges[t1][n]) for(r in this.deletedStates[t1][n] = {}, this.stateChanges[t1][n])this.deletedStates[t1][n][r] = null;
                    else this.deletedStates[t1][n] = null;
                } else this.deletedStates[t1] = null;
            }
        }, tp.prototype.getState = function(t1, e1) {
            var r = String(e1), n = h({}, (this.state[t1] || {})[r], (this.stateChanges[t1] || {})[r]);
            if (null === this.deletedStates[t1]) return {};
            if (this.deletedStates[t1]) {
                var i = this.deletedStates[t1][e1];
                if (null === i) return {};
                for(var a in i)delete n[a];
            }
            return n;
        }, tp.prototype.initializeTileState = function(t1, e1) {
            t1.setFeatureState(this.state, e1);
        }, tp.prototype.coalesceChanges = function(t1, e1) {
            var r = {};
            for(var n in this.stateChanges){
                this.state[n] = this.state[n] || {};
                var i = {};
                for(var a in this.stateChanges[n])this.state[n][a] || (this.state[n][a] = {}), h(this.state[n][a], this.stateChanges[n][a]), i[a] = this.state[n][a];
                r[n] = i;
            }
            for(var o in this.deletedStates){
                this.state[o] = this.state[o] || {};
                var s = {};
                if (null === this.deletedStates[o]) for(var u in this.state[o])s[u] = {}, this.state[o][u] = {};
                else for(var l in this.deletedStates[o]){
                    if (null === this.deletedStates[o][l]) this.state[o][l] = {};
                    else for(var p = 0, c = Object.keys(this.deletedStates[o][l]); p < c.length; p += 1)delete this.state[o][l][c[p]];
                    s[l] = this.state[o][l];
                }
                r[o] = r[o] || {}, h(r[o], s);
            }
            if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for(var f in t1)t1[f].setFeatureState(r, e1);
        };
        var ep = function(t1, e1) {
            this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new Tn(8192, 16, 0), this.grid3D = new Tn(8192, 16, 0), this.featureIndexArray = new aa, this.promoteId = e1;
        };
        function rp(t1, e1, r, n, i) {
            return x(t1, function(t1, a) {
                var o = e1 instanceof di ? e1.get(a) : null;
                return o && o.evaluate ? o.evaluate(r, n, i) : o;
            });
        }
        function np(t1) {
            for(var e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0, a = 0, o = t1; a < o.length; a += 1){
                var s = o[a];
                e1 = Math.min(e1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            }
            return {
                minX: e1,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function ip(t1, e1) {
            return e1 - t1;
        }
        ep.prototype.insert = function(t1, e1, r, n, i, a) {
            var o = this.featureIndexArray.length;
            this.featureIndexArray.emplaceBack(r, n, i);
            for(var s = a ? this.grid3D : this.grid, u = 0; u < e1.length; u++){
                for(var l = e1[u], p = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], c = 0; c < l.length; c++){
                    var h = l[c];
                    p[0] = Math.min(p[0], h.x), p[1] = Math.min(p[1], h.y), p[2] = Math.max(p[2], h.x), p[3] = Math.max(p[3], h.y);
                }
                p[0] < 8192 && p[1] < 8192 && p[2] >= 0 && p[3] >= 0 && s.insert(o, p[0], p[1], p[2], p[3]);
            }
        }, ep.prototype.loadVTLayers = function() {
            return this.vtLayers || (this.vtLayers = new bs.VectorTile(new Ys(this.rawTileData)).layers, this.sourceLayerCoder = new $l(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                "_geojsonTileLayer"
            ])), this.vtLayers;
        }, ep.prototype.query = function(t1, e1, r, n) {
            var a = this;
            this.loadVTLayers();
            for(var o = t1.params || {}, s = 8192 / t1.tileSize / t1.scale, u = on(o.filter), l = t1.queryGeometry, p = t1.queryPadding * s, c = np(l), h = this.grid.query(c.minX - p, c.minY - p, c.maxX + p, c.maxY + p), f = np(t1.cameraQueryGeometry), y = this.grid3D.query(f.minX - p, f.minY - p, f.maxX + p, f.maxY + p, function(e1, r, n, a) {
                return function(t1, e1, r, n, a) {
                    for(var o = 0, s = t1; o < s.length; o += 1){
                        var u = s[o];
                        if (e1 <= u.x && r <= u.y && n >= u.x && a >= u.y) return !0;
                    }
                    var l = [
                        new i(e1, r),
                        new i(e1, a),
                        new i(n, a),
                        new i(n, r)
                    ];
                    if (t1.length > 2) {
                        for(var p = 0, c = l; p < c.length; p += 1)if (Wa(t1, c[p])) return !0;
                    }
                    for(var h = 0; h < t1.length - 1; h++)if (Qa(t1[h], t1[h + 1], l)) return !0;
                    return !1;
                }(t1.cameraQueryGeometry, e1 - p, r - p, n + p, a + p);
            }), d = 0, m = y; d < m.length; d += 1)h.push(m[d]);
            h.sort(ip);
            for(var v, g = {}, x = function(i) {
                var p = h[i];
                if (p !== v) {
                    v = p;
                    var c = a.featureIndexArray.get(p), f = null;
                    a.loadMatchingFeature(g, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, u, o.layers, o.availableImages, e1, r, n, function(e1, r, n) {
                        return f || (f = Ra(e1)), r.queryIntersectsFeature(l, e1, n, f, a.z, t1.transform, s, t1.pixelPosMatrix);
                    });
                }
            }, b = 0; b < h.length; b++)x(b);
            return g;
        }, ep.prototype.loadMatchingFeature = function(t1, e1, r, n, i, a, o, s, u, l, p) {
            var c = this.bucketLayerIDs[e1];
            if (!a || function(t1, e1) {
                for(var r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                return !1;
            }(a, c)) {
                var f = this.sourceLayerCoder.decode(r), y = this.vtLayers[f].feature(n);
                if (i.needGeometry) {
                    var d = Ua(y, !0);
                    if (!i.filter(new si(this.tileID.overscaledZ), d, this.tileID.canonical)) return;
                } else if (!i.filter(new si(this.tileID.overscaledZ), y)) return;
                for(var m = this.getId(y, f), v = 0; v < c.length; v++){
                    var g = c[v];
                    if (!(a && a.indexOf(g) < 0)) {
                        var x = s[g];
                        if (x) {
                            var b = {};
                            void 0 !== m && l && (b = l.getState(x.sourceLayer || "_geojsonTileLayer", m));
                            var w = h({}, u[g]);
                            w.paint = rp(w.paint, x.paint, y, b, o), w.layout = rp(w.layout, x.layout, y, b, o);
                            var _ = !p || p(y, x, b);
                            if (_) {
                                var A = new Wl(y, this.z, this.x, this.y, m);
                                A.layer = w;
                                var S = t1[g];
                                void 0 === S && (S = t1[g] = []), S.push({
                                    featureIndex: n,
                                    feature: A,
                                    intersectionZ: _
                                });
                            }
                        }
                    }
                }
            }
        }, ep.prototype.lookupSymbolFeatures = function(t1, e1, r, n, i, a, o, s) {
            var u = {};
            this.loadVTLayers();
            for(var l = on(i), p = 0, c = t1; p < c.length; p += 1)this.loadMatchingFeature(u, r, n, c[p], l, a, o, s, e1);
            return u;
        }, ep.prototype.hasLayer = function(t1) {
            for(var e1 = 0, r = this.bucketLayerIDs; e1 < r.length; e1 += 1)for(var n = 0, i = r[e1]; n < i.length; n += 1)if (t1 === i[n]) return !0;
            return !1;
        }, ep.prototype.getId = function(t1, e1) {
            var r = t1.id;
            return this.promoteId && "boolean" == typeof (r = t1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1]]) && (r = Number(r)), r;
        }, On("FeatureIndex", ep, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        var ap = function(t1, e1) {
            this.tileID = t1, this.uid = y(), this.uses = 0, this.tileSize = e1, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.expiredRequestCount = 0, this.state = "loading";
        };
        ap.prototype.registerFadeDuration = function(t1) {
            var e1 = t1 + this.timeAdded;
            e1 < O.now() || this.fadeEndTime && e1 < this.fadeEndTime || (this.fadeEndTime = e1);
        }, ap.prototype.wasRequested = function() {
            return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
        }, ap.prototype.loadVectorData = function(t1, e1, r) {
            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", t1) {
                for(var n in t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(t1, e1) {
                    var r = {};
                    if (!e1) return r;
                    for(var n = function() {
                        var t1 = a[i], n = t1.layerIds.map(function(t1) {
                            return e1.getLayer(t1);
                        }).filter(Boolean);
                        if (0 !== n.length) {
                            t1.layers = n, t1.stateDependentLayerIds && (t1.stateDependentLayers = t1.stateDependentLayerIds.map(function(t1) {
                                return n.filter(function(e1) {
                                    return e1.id === t1;
                                })[0];
                            }));
                            for(var o = 0, s = n; o < s.length; o += 1)r[s[o].id] = t1;
                        }
                    }, i = 0, a = t1; i < a.length; i += 1)n();
                    return r;
                }(t1.buckets, e1.style), this.hasSymbolBuckets = !1, this.buckets){
                    var i = this.buckets[n];
                    if (i instanceof vl) {
                        if (this.hasSymbolBuckets = !0, !r) break;
                        i.justReloaded = !0;
                    }
                }
                if (this.hasRTLText = !1, this.hasSymbolBuckets) for(var a in this.buckets){
                    var o = this.buckets[a];
                    if (o instanceof vl && o.hasRTLText) {
                        this.hasRTLText = !0, oi.isLoading() || oi.isLoaded() || "deferred" !== ii() || ai();
                        break;
                    }
                }
                for(var s in this.queryPadding = 0, this.buckets){
                    var u = this.buckets[s];
                    this.queryPadding = Math.max(this.queryPadding, e1.style.getLayer(s).queryRadius(u));
                }
                t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage);
            } else this.collisionBoxArray = new $i;
        }, ap.prototype.unloadVectorData = function() {
            for(var t1 in this.buckets)this.buckets[t1].destroy();
            this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
        }, ap.prototype.getBucket = function(t1) {
            return this.buckets[t1.id];
        }, ap.prototype.upload = function(t1) {
            for(var e1 in this.buckets){
                var r = this.buckets[e1];
                r.uploadPending() && r.upload(t1);
            }
            var n = t1.gl;
            this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new Tl(t1, this.imageAtlas.image, n.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new Tl(t1, this.glyphAtlasImage, n.ALPHA), this.glyphAtlasImage = null);
        }, ap.prototype.prepare = function(t1) {
            this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
        }, ap.prototype.queryRenderedFeatures = function(t1, e1, r, n, i, a, o, s, u, l) {
            return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                queryGeometry: n,
                cameraQueryGeometry: i,
                scale: a,
                tileSize: this.tileSize,
                pixelPosMatrix: l,
                transform: s,
                params: o,
                queryPadding: this.queryPadding * u
            }, t1, e1, r) : {};
        }, ap.prototype.querySourceFeatures = function(t1, e1) {
            var r = this.latestFeatureIndex;
            if (r && r.rawTileData) {
                var n = r.loadVTLayers(), i = e1 ? e1.sourceLayer : "", a = n._geojsonTileLayer || n[i];
                if (a) for(var o = on(e1 && e1.filter), s = this.tileID.canonical, u = s.z, l = s.x, p = s.y, c = {
                    z: u,
                    x: l,
                    y: p
                }, h = 0; h < a.length; h++){
                    var f = a.feature(h);
                    if (o.needGeometry) {
                        var y = Ua(f, !0);
                        if (!o.filter(new si(this.tileID.overscaledZ), y, this.tileID.canonical)) continue;
                    } else if (!o.filter(new si(this.tileID.overscaledZ), f)) continue;
                    var d = r.getId(f, i), m = new Wl(f, u, l, p, d);
                    m.tile = c, t1.push(m);
                }
            }
        }, ap.prototype.hasData = function() {
            return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
        }, ap.prototype.patternsLoaded = function() {
            return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
        }, ap.prototype.setExpiryData = function(t1) {
            var e1 = this.expirationTime;
            if (t1.cacheControl) {
                var r = z(t1.cacheControl);
                r["max-age"] && (this.expirationTime = Date.now() + 1e3 * r["max-age"]);
            } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
            if (this.expirationTime) {
                var n = Date.now(), i = !1;
                if (this.expirationTime > n) i = !1;
                else if (e1) {
                    if (this.expirationTime < e1) i = !0;
                    else {
                        var a = this.expirationTime - e1;
                        a ? this.expirationTime = n + Math.max(a, 3e4) : i = !0;
                    }
                } else i = !0;
                i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
            }
        }, ap.prototype.getExpiryTimeout = function() {
            if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
        }, ap.prototype.setFeatureState = function(t1, e1) {
            if (this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(t1).length) {
                var r = this.latestFeatureIndex.loadVTLayers();
                for(var n in this.buckets)if (e1.style.hasLayer(n)) {
                    var i = this.buckets[n], a = i.layers[0].sourceLayer || "_geojsonTileLayer", o = r[a], s = t1[a];
                    if (o && s && 0 !== Object.keys(s).length) {
                        i.update(s, o, this.imageAtlas && this.imageAtlas.patternPositions || {});
                        var u = e1 && e1.style && e1.style.getLayer(n);
                        u && (this.queryPadding = Math.max(this.queryPadding, u.queryRadius(i)));
                    }
                }
            }
        }, ap.prototype.holdingForFade = function() {
            return void 0 !== this.symbolFadeHoldUntil;
        }, ap.prototype.symbolFadeFinished = function() {
            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < O.now();
        }, ap.prototype.clearFadeHold = function() {
            this.symbolFadeHoldUntil = void 0;
        }, ap.prototype.setHoldDuration = function(t1) {
            this.symbolFadeHoldUntil = O.now() + t1;
        }, ap.prototype.setDependencies = function(t1, e1) {
            for(var r = {}, n = 0, i = e1; n < i.length; n += 1)r[i[n]] = !0;
            this.dependencies[t1] = r;
        }, ap.prototype.hasDependency = function(t1, e1) {
            for(var r = 0, n = t1; r < n.length; r += 1){
                var i = this.dependencies[n[r]];
                if (i) {
                    for(var a = 0, o = e1; a < o.length; a += 1)if (i[o[a]]) return !0;
                }
            }
            return !1;
        };
        var op = o.performance, sp = function(t1) {
            this._marks = {
                start: [
                    t1.url,
                    "start"
                ].join("#"),
                end: [
                    t1.url,
                    "end"
                ].join("#"),
                measure: t1.url.toString()
            }, op.mark(this._marks.start);
        };
        sp.prototype.finish = function() {
            op.mark(this._marks.end);
            var t1 = op.getEntriesByName(this._marks.measure);
            return 0 === t1.length && (op.measure(this._marks.measure, this._marks.start, this._marks.end), t1 = op.getEntriesByName(this._marks.measure), op.clearMarks(this._marks.start), op.clearMarks(this._marks.end), op.clearMeasures(this._marks.measure)), t1;
        }, t1.Actor = Fl, t1.AlphaImage = go, t1.CanonicalTileID = Zl, t1.CollisionBoxArray = $i, t1.Color = te, t1.DEMData = Yl, t1.DataConstantProperty = mi, t1.DictionaryCoder = $l, t1.EXTENT = 8192, t1.ErrorEvent = zt, t1.EvaluationParameters = si, t1.Event = It, t1.Evented = Ct, t1.FeatureIndex = ep, t1.FillBucket = ss, t1.FillExtrusionBucket = Ss, t1.ImageAtlas = bu, t1.ImagePosition = gu, t1.LineBucket = Fs, t1.LngLat = Ol, t1.LngLatBounds = Ll, t1.MercatorCoordinate = Gl, t1.ONE_EM = 24, t1.OverscaledTileID = Jl, t1.Point = i, t1.Point$1 = i, t1.Properties = wi, t1.Protobuf = Ys, t1.RGBAImage = xo, t1.RequestManager = G, t1.RequestPerformance = sp, t1.ResourceType = yt, t1.SegmentVector = sa, t1.SourceFeatureState = tp, t1.StructArrayLayout1ui2 = Ji, t1.StructArrayLayout2f1f2i16 = Ri, t1.StructArrayLayout2i4 = Ci, t1.StructArrayLayout3ui6 = ji, t1.StructArrayLayout4i8 = Ei, t1.SymbolBucket = vl, t1.Texture = Tl, t1.Tile = ap, t1.Transitionable = pi, t1.Uniform1f = ba, t1.Uniform1i = xa, t1.Uniform2f = wa, t1.Uniform3f = _a, t1.Uniform4f = Aa, t1.UniformColor = Sa, t1.UniformMatrix4f = Ia, t1.UnwrappedTileID = Xl, t1.ValidationError = Pt, t1.WritingMode = wu, t1.ZoomHistory = Kn, t1.add = function(t1, e1, r) {
            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
        }, t1.addDynamicAttributes = fl, t1.asyncAll = function(t1, e1, r) {
            if (!t1.length) return r(null, []);
            var n = t1.length, i = new Array(t1.length), a = null;
            t1.forEach(function(t1, o) {
                e1(t1, function(t1, e1) {
                    t1 && (a = t1), i[o] = e1, 0 == --n && r(a, i);
                });
            });
        }, t1.bezier = u, t1.bindAll = v, t1.browser = O, t1.cacheEntryPossiblyAdded = function(t1) {
            ++ht > ut && (t1.getActor().send("enforceCacheSizeLimit", st), ht = 0);
        }, t1.clamp = p, t1.clearTileCache = function(t1) {
            var e1 = o.caches.delete("mapbox-tiles");
            t1 && e1.catch(t1).then(function() {
                return t1();
            });
        }, t1.clipLine = Zu, t1.clone = function(t1) {
            var e1 = new ao(16);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }, t1.clone$1 = w, t1.clone$2 = function(t1) {
            var e1 = new ao(3);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
        }, t1.collisionCircleLayout = Gs, t1.config = R, t1.create = function() {
            var t1 = new ao(16);
            return ao != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
        }, t1.create$1 = function() {
            var t1 = new ao(9);
            return ao != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
        }, t1.create$2 = function() {
            var t1 = new ao(4);
            return ao != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
        }, t1.createCommonjsModule = e1, t1.createExpression = Zr, t1.createLayout = Ii, t1.createStyleLayer = function(t1) {
            return "custom" === t1.type ? new Il(t1) : new zl[t1.type](t1);
        }, t1.cross = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], u = r[2];
            return t1[0] = i * u - a * s, t1[1] = a * o - n * u, t1[2] = n * s - i * o, t1;
        }, t1.deepEqual = function t1(e1, r) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(r) || e1.length !== r.length) return !1;
                for(var n = 0; n < e1.length; n++)if (!t1(e1[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(e1).length !== Object.keys(r).length) return !1;
                for(var i in e1)if (!t1(e1[i], r[i])) return !1;
                return !0;
            }
            return e1 === r;
        }, t1.dot = function(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
        }, t1.dot$1 = function(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
        }, t1.ease = l, t1.emitValidationErrors = Bn, t1.endsWith = g, t1.enforceCacheSizeLimit = function(t1) {
            lt(), tt && tt.then(function(e1) {
                e1.keys().then(function(r) {
                    for(var n = 0; n < r.length - t1; n++)e1.delete(r[n]);
                });
            });
        }, t1.evaluateSizeForFeature = Lu, t1.evaluateSizeForZoom = Ou, t1.evaluateVariableOffset = al, t1.evented = ni, t1.extend = h, t1.featureFilter = on, t1.filterObject = b, t1.fromRotation = function(t1, e1) {
            var r = Math.sin(e1), n = Math.cos(e1);
            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
        }, t1.getAnchorAlignment = Bu, t1.getAnchorJustification = ol, t1.getArrayBuffer = bt, t1.getImage = At, t1.getJSON = function(t1, e1) {
            return xt(h(t1, {
                type: "json"
            }), e1);
        }, t1.getRTLTextPluginStatus = ii, t1.getReferrer = mt, t1.getVideo = function(t1, e1) {
            var r, n, i = o.document.createElement("video");
            i.muted = !0, i.onloadstart = function() {
                e1(null, i);
            };
            for(var a = 0; a < t1.length; a++){
                var s = o.document.createElement("source");
                r = t1[a], n = void 0, (n = o.document.createElement("a")).href = r, (n.protocol !== o.document.location.protocol || n.host !== o.document.location.host) && (i.crossOrigin = "Anonymous"), s.src = t1[a], i.appendChild(s);
            }
            return {
                cancel: function() {}
            };
        }, t1.identity = oo, t1.invert = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], u = e1[6], l = e1[7], p = e1[8], c = e1[9], h = e1[10], f = e1[11], y = e1[12], d = e1[13], m = e1[14], v = e1[15], g = r * s - n * o, x = r * u - i * o, b = r * l - a * o, w = n * u - i * s, _ = n * l - a * s, A = i * l - a * u, S = p * d - c * y, k = p * m - h * y, I = p * v - f * y, z = c * m - h * d, C = c * v - f * d, E = h * v - f * m, P = g * E - x * C + b * z + w * I - _ * k + A * S;
            return P ? (t1[0] = (s * E - u * C + l * z) * (P = 1 / P), t1[1] = (i * C - n * E - a * z) * P, t1[2] = (d * A - m * _ + v * w) * P, t1[3] = (h * _ - c * A - f * w) * P, t1[4] = (u * I - o * E - l * k) * P, t1[5] = (r * E - i * I + a * k) * P, t1[6] = (m * b - y * A - v * x) * P, t1[7] = (p * A - h * b + f * x) * P, t1[8] = (o * C - s * I + l * S) * P, t1[9] = (n * I - r * C - a * S) * P, t1[10] = (y * _ - d * b + v * g) * P, t1[11] = (c * b - p * _ - f * g) * P, t1[12] = (s * k - o * z - u * S) * P, t1[13] = (r * z - n * k + i * S) * P, t1[14] = (d * x - y * w - m * g) * P, t1[15] = (p * w - c * x + h * g) * P, t1) : null;
        }, t1.isChar = Gn, t1.isMapboxURL = Z, t1.keysDifference = function(t1, e1) {
            var r = [];
            for(var n in t1)n in e1 || r.push(n);
            return r;
        }, t1.makeRequest = xt, t1.mapObject = x, t1.mercatorXfromLng = jl, t1.mercatorYfromLat = ql, t1.mercatorZfromAltitude = Nl, t1.mul = lo, t1.multiply = so, t1.mvt = bs, t1.nextPowerOfTwo = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }, t1.normalize = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
            return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a, t1;
        }, t1.number = Ke, t1.offscreenCanvasSupported = ft, t1.ortho = function(t1, e1, r, n, i, a, o) {
            var s = 1 / (e1 - r), u = 1 / (n - i), l = 1 / (a - o);
            return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * u, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * l, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * u, t1[14] = (o + a) * l, t1[15] = 1, t1;
        }, t1.parseGlyphPBF = function(t1) {
            return new Ys(t1).readFields(yu, []);
        }, t1.pbf = Ys, t1.performSymbolLayout = function(t1, e1, r, n, i, a, o) {
            t1.createArrays(), t1.tilePixelRatio = 8192 / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            var s = t1.layers[0].layout, u = t1.layers[0]._unevaluatedLayout._values, l = {};
            if ("composite" === t1.textSizeData.kind) {
                var p = t1.textSizeData, c = p.maxZoom;
                l.compositeTextSizes = [
                    u["text-size"].possiblyEvaluate(new si(p.minZoom), o),
                    u["text-size"].possiblyEvaluate(new si(c), o)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                var h = t1.iconSizeData, f = h.maxZoom;
                l.compositeIconSizes = [
                    u["icon-size"].possiblyEvaluate(new si(h.minZoom), o),
                    u["icon-size"].possiblyEvaluate(new si(f), o)
                ];
            }
            l.layoutTextSize = u["text-size"].possiblyEvaluate(new si(t1.zoom + 1), o), l.layoutIconSize = u["icon-size"].possiblyEvaluate(new si(t1.zoom + 1), o), l.textMaxSize = u["text-size"].possiblyEvaluate(new si(18));
            for(var y = 24 * s.get("text-line-height"), d = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement"), m = s.get("text-keep-upright"), v = s.get("text-size"), g = function() {
                var a = b[x], u = s.get("text-font").evaluate(a, {}, o).join(","), p = v.evaluate(a, {}, o), c = l.layoutTextSize.evaluate(a, {}, o), h = l.layoutIconSize.evaluate(a, {}, o), f = {
                    horizontal: {},
                    vertical: void 0
                }, g = a.text, w = [
                    0,
                    0
                ];
                if (g) {
                    var _ = g.toString(), S = 24 * s.get("text-letter-spacing").evaluate(a, {}, o), k = function(t1) {
                        for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (n = r[e1].charCodeAt(0), Gn.Arabic(n) || Gn["Arabic Supplement"](n) || Gn["Arabic Extended-A"](n) || Gn["Arabic Presentation Forms-A"](n) || Gn["Arabic Presentation Forms-B"](n)) return !1;
                        var n;
                        return !0;
                    }(_) ? S : 0, I = s.get("text-anchor").evaluate(a, {}, o), z = s.get("text-variable-anchor");
                    if (!z) {
                        var C = s.get("text-radial-offset").evaluate(a, {}, o);
                        w = C ? al(I, [
                            24 * C,
                            il
                        ]) : s.get("text-offset").evaluate(a, {}, o).map(function(t1) {
                            return 24 * t1;
                        });
                    }
                    var E = d ? "center" : s.get("text-justify").evaluate(a, {}, o), P = s.get("symbol-placement"), M = "point" === P ? 24 * s.get("text-max-width").evaluate(a, {}, o) : 0, B = function() {
                        t1.allowVerticalPlacement && Zn(_) && (f.vertical = Su(g, e1, r, i, u, M, y, I, "left", k, w, wu.vertical, !0, P, c, p));
                    };
                    if (!d && z) {
                        for(var T = "auto" === E ? z.map(function(t1) {
                            return ol(t1);
                        }) : [
                            E
                        ], V = !1, F = 0; F < T.length; F++){
                            var D = T[F];
                            if (!f.horizontal[D]) {
                                if (V) f.horizontal[D] = f.horizontal[0];
                                else {
                                    var L = Su(g, e1, r, i, u, M, y, "center", D, k, w, wu.horizontal, !1, P, c, p);
                                    L && (f.horizontal[D] = L, V = 1 === L.positionedLines.length);
                                }
                            }
                        }
                        B();
                    } else {
                        "auto" === E && (E = ol(I));
                        var O = Su(g, e1, r, i, u, M, y, I, E, k, w, wu.horizontal, !1, P, c, p);
                        O && (f.horizontal[E] = O), B(), Zn(_) && d && m && (f.vertical = Su(g, e1, r, i, u, M, y, I, E, k, w, wu.vertical, !1, P, c, p));
                    }
                }
                var R = void 0, U = !1;
                if (a.icon && a.icon.name) {
                    var j = n[a.icon.name];
                    j && (R = function(t1, e1, r) {
                        var n = Bu(r), i = e1[0] - t1.displaySize[0] * n.horizontalAlign, a = e1[1] - t1.displaySize[1] * n.verticalAlign;
                        return {
                            image: t1,
                            top: a,
                            bottom: a + t1.displaySize[1],
                            left: i,
                            right: i + t1.displaySize[0]
                        };
                    }(i[a.icon.name], s.get("icon-offset").evaluate(a, {}, o), s.get("icon-anchor").evaluate(a, {}, o)), U = j.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = j.sdf : t1.sdfIcons !== j.sdf && A("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (j.pixelRatio !== t1.pixelRatio || 0 !== s.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                }
                var q = ul(f.horizontal) || f.vertical;
                t1.iconsInText = !!q && q.iconsInText, (q || R) && function(t1, e1, r, n, i, a, o, s, u, l, p) {
                    var c = a.textMaxSize.evaluate(e1, {});
                    void 0 === c && (c = o);
                    var h, f = t1.layers[0].layout, y = f.get("icon-offset").evaluate(e1, {}, p), d = ul(r.horizontal), m = o / 24, v = t1.tilePixelRatio * m, g = t1.tilePixelRatio * c / 24, x = t1.tilePixelRatio * s, b = t1.tilePixelRatio * f.get("symbol-spacing"), w = f.get("text-padding") * t1.tilePixelRatio, _ = f.get("icon-padding") * t1.tilePixelRatio, S = f.get("text-max-angle") / 180 * Math.PI, k = "map" === f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), I = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement"), z = f.get("symbol-placement"), C = b / 2, E = f.get("icon-text-fit");
                    n && "none" !== E && (t1.allowVerticalPlacement && r.vertical && (h = Vu(n, r.vertical, E, f.get("icon-text-fit-padding"), y, m)), d && (n = Vu(n, d, E, f.get("icon-text-fit-padding"), y, m)));
                    var P = function(s, c) {
                        c.x < 0 || c.x >= 8192 || c.y < 0 || c.y >= 8192 || function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, S, k) {
                            var I, z, C, E, P, M = t1.addToLineVertexArray(e1, r), B = 0, T = 0, V = 0, F = 0, D = -1, L = -1, O = {}, R = ha(""), U = 0, j = 0;
                            if (void 0 === s._unevaluatedLayout.getValue("text-radial-offset") ? (U = (I = s.layout.get("text-offset").evaluate(b, {}, S).map(function(t1) {
                                return 24 * t1;
                            }))[0], j = I[1]) : (U = 24 * s.layout.get("text-radial-offset").evaluate(b, {}, S), j = il), t1.allowVerticalPlacement && n.vertical) {
                                var q = s.layout.get("text-rotate").evaluate(b, {}, S) + 90;
                                E = new Wu(u, e1, l, p, c, n.vertical, h, f, y, q), o && (P = new Wu(u, e1, l, p, c, o, m, v, y, q));
                            }
                            if (i) {
                                var N = s.layout.get("icon-rotate").evaluate(b, {}), K = "none" !== s.layout.get("icon-text-fit"), G = Xu(i, N, _, K), Z = o ? Xu(o, N, _, K) : void 0;
                                C = new Wu(u, e1, l, p, c, i, m, v, !1, N), B = 4 * G.length;
                                var X = t1.iconSizeData, J = null;
                                "source" === X.kind ? (J = [
                                    128 * s.layout.get("icon-size").evaluate(b, {})
                                ])[0] > 32640 && A(t1.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".') : "composite" === X.kind && ((J = [
                                    128 * w.compositeIconSizes[0].evaluate(b, {}, S),
                                    128 * w.compositeIconSizes[1].evaluate(b, {}, S)
                                ])[0] > 32640 || J[1] > 32640) && A(t1.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".'), t1.addSymbols(t1.icon, G, J, x, g, b, !1, e1, M.lineStartIndex, M.lineLength, -1, S), D = t1.icon.placedSymbolArray.length - 1, Z && (T = 4 * Z.length, t1.addSymbols(t1.icon, Z, J, x, g, b, wu.vertical, e1, M.lineStartIndex, M.lineLength, -1, S), L = t1.icon.placedSymbolArray.length - 1);
                            }
                            for(var H in n.horizontal){
                                var Y = n.horizontal[H];
                                if (!z) {
                                    R = ha(Y.text);
                                    var $ = s.layout.get("text-rotate").evaluate(b, {}, S);
                                    z = new Wu(u, e1, l, p, c, Y, h, f, y, $);
                                }
                                var W = 1 === Y.positionedLines.length;
                                if (V += sl(t1, e1, Y, a, s, y, b, d, M, n.vertical ? wu.horizontal : wu.horizontalOnly, W ? Object.keys(n.horizontal) : [
                                    H
                                ], O, D, w, S), W) break;
                            }
                            n.vertical && (F += sl(t1, e1, n.vertical, a, s, y, b, d, M, wu.vertical, [
                                "vertical"
                            ], O, L, w, S));
                            var Q = z ? z.boxStartIndex : t1.collisionBoxArray.length, tt = z ? z.boxEndIndex : t1.collisionBoxArray.length, et = E ? E.boxStartIndex : t1.collisionBoxArray.length, rt = E ? E.boxEndIndex : t1.collisionBoxArray.length, nt = C ? C.boxStartIndex : t1.collisionBoxArray.length, it = C ? C.boxEndIndex : t1.collisionBoxArray.length, at = P ? P.boxStartIndex : t1.collisionBoxArray.length, ot = P ? P.boxEndIndex : t1.collisionBoxArray.length, st = -1, ut = function(t1, e1) {
                                return t1 && t1.circleDiameter ? Math.max(t1.circleDiameter, e1) : e1;
                            };
                            st = ut(z, st), st = ut(E, st), st = ut(C, st);
                            var lt = (st = ut(P, st)) > -1 ? 1 : 0;
                            lt && (st *= k / 24), t1.glyphOffsetArray.length >= vl.MAX_GLYPHS && A("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey), t1.symbolInstances.emplaceBack(e1.x, e1.y, O.right >= 0 ? O.right : -1, O.center >= 0 ? O.center : -1, O.left >= 0 ? O.left : -1, O.vertical || -1, D, L, R, Q, tt, et, rt, nt, it, at, ot, l, V, F, B, T, lt, 0, h, U, j, st);
                        }(t1, c, s, r, n, i, h, t1.layers[0], t1.collisionBoxArray, e1.index, e1.sourceLayerIndex, t1.index, v, w, k, u, x, _, I, y, e1, a, l, p, o);
                    };
                    if ("line" === z) for(var M = 0, B = Zu(e1.geometry, 0, 0, 8192, 8192); M < B.length; M += 1)for(var T = B[M], V = 0, F = Gu(T, b, S, r.vertical || d, n, 24, g, t1.overscaling, 8192); V < F.length; V += 1){
                        var D = F[V];
                        d && ll(t1, d.text, C, D) || P(T, D);
                    }
                    else if ("line-center" === z) for(var L = 0, O = e1.geometry; L < O.length; L += 1){
                        var R = O[L];
                        if (R.length > 1) {
                            var U = Ku(R, S, r.vertical || d, n, 24, g);
                            U && P(R, U);
                        }
                    }
                    else if ("Polygon" === e1.type) for(var j = 0, q = ns(e1.geometry, 0); j < q.length; j += 1){
                        var N = q[j], K = el(N, 16);
                        P(N[0], new Fu(K.x, K.y, 0));
                    }
                    else if ("LineString" === e1.type) for(var G = 0, Z = e1.geometry; G < Z.length; G += 1){
                        var X = Z[G];
                        P(X, new Fu(X[0].x, X[0].y, 0));
                    }
                    else if ("Point" === e1.type) for(var J = 0, H = e1.geometry; J < H.length; J += 1)for(var Y = 0, $ = H[J]; Y < $.length; Y += 1){
                        var W = $[Y];
                        P([
                            W
                        ], new Fu(W.x, W.y, 0));
                    }
                }(t1, a, f, R, n, l, c, h, w, U, o);
            }, x = 0, b = t1.features; x < b.length; x += 1)g();
            a && t1.generateCollisionDebugBuffers();
        }, t1.perspective = function(t1, e1, r, n, i) {
            var a, o = 1 / Math.tan(e1 / 2);
            return t1[0] = o / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = o, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (a = 1 / (n - i)), t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
        }, t1.pick = function(t1, e1) {
            for(var r = {}, n = 0; n < e1.length; n++){
                var i = e1[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.plugin = oi, t1.polygonIntersectsPolygon = Na, t1.postMapLoadEvent = ot, t1.postTurnstileEvent = it, t1.potpack = vu, t1.refProperties = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.register = On, t1.registerForPluginStateChange = function(t1) {
            return t1({
                pluginStatus: Qn,
                pluginURL: ti
            }), ni.on("pluginStateChange", t1), t1;
        }, t1.renderColorRamp = wo, t1.rotate = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = Math.sin(r), u = Math.cos(r);
            return t1[0] = n * u + a * s, t1[1] = i * u + o * s, t1[2] = n * -s + a * u, t1[3] = i * -s + o * u, t1;
        }, t1.rotateX = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], u = e1[7], l = e1[8], p = e1[9], c = e1[10], h = e1[11];
            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + l * n, t1[5] = o * i + p * n, t1[6] = s * i + c * n, t1[7] = u * i + h * n, t1[8] = l * i - a * n, t1[9] = p * i - o * n, t1[10] = c * i - s * n, t1[11] = h * i - u * n, t1;
        }, t1.rotateZ = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], u = e1[3], l = e1[4], p = e1[5], c = e1[6], h = e1[7];
            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + l * n, t1[1] = o * i + p * n, t1[2] = s * i + c * n, t1[3] = u * i + h * n, t1[4] = l * i - a * n, t1[5] = p * i - o * n, t1[6] = c * i - s * n, t1[7] = h * i - u * n, t1;
        }, t1.scale = function(t1, e1, r) {
            var n = r[0], i = r[1], a = r[2];
            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }, t1.scale$1 = function(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
        }, t1.scale$2 = function(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
        }, t1.setCacheLimits = function(t1, e1) {
            st = t1, ut = e1;
        }, t1.setRTLTextPlugin = function(t1, e1, r) {
            if (void 0 === r && (r = !1), "deferred" === Qn || "loading" === Qn || "loaded" === Qn) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            ti = O.resolveURL(t1), Qn = "deferred", Wn = e1, ri(), r || ai();
        }, t1.sphericalToCartesian = function(t1) {
            var e1 = t1[0], r = t1[1], n = t1[2];
            return r += 90, r *= Math.PI / 180, n *= Math.PI / 180, {
                x: e1 * Math.cos(r) * Math.sin(n),
                y: e1 * Math.sin(r) * Math.sin(n),
                z: e1 * Math.cos(n)
            };
        }, t1.sqrLen = function(t1) {
            var e1 = t1[0], r = t1[1];
            return e1 * e1 + r * r;
        }, t1.styleSpec = Et, t1.sub = function(t1, e1, r) {
            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
        }, t1.symbolSize = Ru, t1.transformMat3 = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2];
            return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
        }, t1.transformMat4 = po, t1.translate = function(t1, e1, r) {
            var n, i, a, o, s, u, l, p, c, h, f, y, d = r[0], m = r[1], v = r[2];
            return e1 === t1 ? (t1[12] = e1[0] * d + e1[4] * m + e1[8] * v + e1[12], t1[13] = e1[1] * d + e1[5] * m + e1[9] * v + e1[13], t1[14] = e1[2] * d + e1[6] * m + e1[10] * v + e1[14], t1[15] = e1[3] * d + e1[7] * m + e1[11] * v + e1[15]) : (i = e1[1], a = e1[2], o = e1[3], s = e1[4], u = e1[5], l = e1[6], p = e1[7], c = e1[8], h = e1[9], f = e1[10], y = e1[11], t1[0] = n = e1[0], t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = u, t1[6] = l, t1[7] = p, t1[8] = c, t1[9] = h, t1[10] = f, t1[11] = y, t1[12] = n * d + s * m + c * v + e1[12], t1[13] = i * d + u * m + h * v + e1[13], t1[14] = a * d + l * m + f * v + e1[14], t1[15] = o * d + p * m + y * v + e1[15]), t1;
        }, t1.triggerPluginCompletionEvent = ei, t1.uniqueId = y, t1.validateCustomStyleLayer = function(t1) {
            var e1 = [], r = t1.id;
            return void 0 === r && e1.push({
                message: "layers." + r + ': missing required property "id"'
            }), void 0 === t1.render && e1.push({
                message: "layers." + r + ': missing required method "render"'
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                message: "layers." + r + ': property "renderingMode" must be either "2d" or "3d"'
            }), e1;
        }, t1.validateLight = En, t1.validateStyle = Cn, t1.values = function(t1) {
            var e1 = [];
            for(var r in t1)e1.push(t1[r]);
            return e1;
        }, t1.vectorTile = bs, t1.version = "1.13.3", t1.warnOnce = A, t1.webpSupported = U, t1.window = o, t1.wrap = c;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t1(e1) {
            var r = typeof e1;
            if ("number" === r || "boolean" === r || "string" === r || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                for(var i = "[", o = 0, n = e1; o < n.length; o += 1)i += t1(n[o]) + ",";
                return i + "]";
            }
            for(var a = Object.keys(e1).sort(), s = "{", l = 0; l < a.length; l++)s += JSON.stringify(a[l]) + ":" + t1(e1[a[l]]) + ",";
            return s + "}";
        }
        function r(r) {
            for(var i = "", o = 0, n = e1.refProperties; o < n.length; o += 1)i += "/" + t1(r[n[o]]);
            return i;
        }
        var i = function(e1) {
            this.keyCache = {}, e1 && this.replace(e1);
        };
        i.prototype.replace = function(e1) {
            this._layerConfigs = {}, this._layers = {}, this.update(e1, []);
        }, i.prototype.update = function(t1, i) {
            for(var o = this, n = 0, a = t1; n < a.length; n += 1){
                var s = a[n];
                this._layerConfigs[s.id] = s;
                var l = this._layers[s.id] = e1.createStyleLayer(s);
                l._featureFilter = e1.featureFilter(l.filter), this.keyCache[s.id] && delete this.keyCache[s.id];
            }
            for(var u = 0, h = i; u < h.length; u += 1){
                var c = h[u];
                delete this.keyCache[c], delete this._layerConfigs[c], delete this._layers[c];
            }
            this.familiesBySource = {};
            for(var p = 0, f = function(e1, t1) {
                for(var i = {}, o = 0; o < e1.length; o++){
                    var n = t1 && t1[e1[o].id] || r(e1[o]);
                    t1 && (t1[e1[o].id] = n);
                    var a = i[n];
                    a || (a = i[n] = []), a.push(e1[o]);
                }
                var s = [];
                for(var l in i)s.push(i[l]);
                return s;
            }(e1.values(this._layerConfigs), this.keyCache); p < f.length; p += 1){
                var d = f[p].map(function(e1) {
                    return o._layers[e1.id];
                }), g = d[0];
                if ("none" !== g.visibility) {
                    var v = g.source || "", m = this.familiesBySource[v];
                    m || (m = this.familiesBySource[v] = {});
                    var y = g.sourceLayer || "_geojsonTileLayer", x = m[y];
                    x || (x = m[y] = []), x.push(d);
                }
            }
        };
        var o = function(t1) {
            var r = {}, i = [];
            for(var o in t1){
                var n = t1[o], a = r[o] = {};
                for(var s in n){
                    var l = n[+s];
                    if (l && 0 !== l.bitmap.width && 0 !== l.bitmap.height) {
                        var u = {
                            x: 0,
                            y: 0,
                            w: l.bitmap.width + 2,
                            h: l.bitmap.height + 2
                        };
                        i.push(u), a[s] = {
                            rect: u,
                            metrics: l.metrics
                        };
                    }
                }
            }
            var h = e1.potpack(i), c = new e1.AlphaImage({
                width: h.w || 1,
                height: h.h || 1
            });
            for(var p in t1){
                var f = t1[p];
                for(var d in f){
                    var g = f[+d];
                    if (g && 0 !== g.bitmap.width && 0 !== g.bitmap.height) {
                        var v = r[p][d].rect;
                        e1.AlphaImage.copy(g.bitmap, c, {
                            x: 0,
                            y: 0
                        }, {
                            x: v.x + 1,
                            y: v.y + 1
                        }, g.bitmap);
                    }
                }
            }
            this.image = c, this.positions = r;
        };
        e1.register("GlyphAtlas", o);
        var n = function(t1) {
            this.tileID = new e1.OverscaledTileID(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.uid = t1.uid, this.zoom = t1.zoom, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.collectResourceTiming, this.returnDependencies = !!t1.returnDependencies, this.promoteId = t1.promoteId;
        };
        function a(t1, r, i) {
            for(var o = new e1.EvaluationParameters(r), n = 0, a = t1; n < a.length; n += 1)a[n].recalculate(o, i);
        }
        function s(t1, r) {
            var i = e1.getArrayBuffer(t1.request, function(t1, i, o, n) {
                t1 ? r(t1) : i && r(null, {
                    vectorTile: new e1.vectorTile.VectorTile(new e1.pbf(i)),
                    rawData: i,
                    cacheControl: o,
                    expires: n
                });
            });
            return function() {
                i.cancel(), r();
            };
        }
        n.prototype.parse = function(t1, r, i, n, s) {
            var l = this;
            this.status = "parsing", this.data = t1, this.collisionBoxArray = new e1.CollisionBoxArray;
            var u = new e1.DictionaryCoder(Object.keys(t1.layers).sort()), h = new e1.FeatureIndex(this.tileID, this.promoteId);
            h.bucketLayerIDs = [];
            var c, p, f, d, g = {}, v = {
                featureIndex: h,
                iconDependencies: {},
                patternDependencies: {},
                glyphDependencies: {},
                availableImages: i
            }, m = r.familiesBySource[this.source];
            for(var y in m){
                var x = t1.layers[y];
                if (x) {
                    1 === x.version && e1.warnOnce('Vector tile source "' + this.source + '" layer "' + y + '" does not use vector tile spec v2 and therefore may have some rendering errors.');
                    for(var w = u.encode(y), S = [], I = 0; I < x.length; I++){
                        var M = x.feature(I), b = h.getId(M, y);
                        S.push({
                            feature: M,
                            id: b,
                            index: I,
                            sourceLayerIndex: w
                        });
                    }
                    for(var _ = 0, k = m[y]; _ < k.length; _ += 1){
                        var P = k[_], T = P[0];
                        T.minzoom && this.zoom < Math.floor(T.minzoom) || T.maxzoom && this.zoom >= T.maxzoom || "none" !== T.visibility && (a(P, this.zoom, i), (g[T.id] = T.createBucket({
                            index: h.bucketLayerIDs.length,
                            layers: P,
                            zoom: this.zoom,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: w,
                            sourceID: this.source
                        })).populate(S, v, this.tileID.canonical), h.bucketLayerIDs.push(P.map(function(e1) {
                            return e1.id;
                        })));
                    }
                }
            }
            var C = e1.mapObject(v.glyphDependencies, function(e1) {
                return Object.keys(e1).map(Number);
            });
            Object.keys(C).length ? n.send("getGlyphs", {
                uid: this.uid,
                stacks: C
            }, function(e1, t1) {
                c || (c = e1, p = t1, z.call(l));
            }) : p = {};
            var D = Object.keys(v.iconDependencies);
            D.length ? n.send("getImages", {
                icons: D,
                source: this.source,
                tileID: this.tileID,
                type: "icons"
            }, function(e1, t1) {
                c || (c = e1, f = t1, z.call(l));
            }) : f = {};
            var L = Object.keys(v.patternDependencies);
            function z() {
                if (c) return s(c);
                if (p && f && d) {
                    var t1 = new o(p), r = new e1.ImageAtlas(f, d);
                    for(var n in g){
                        var l = g[n];
                        l instanceof e1.SymbolBucket ? (a(l.layers, this.zoom, i), e1.performSymbolLayout(l, p, t1.positions, f, r.iconPositions, this.showCollisionBoxes, this.tileID.canonical)) : l.hasPattern && (l instanceof e1.LineBucket || l instanceof e1.FillBucket || l instanceof e1.FillExtrusionBucket) && (a(l.layers, this.zoom, i), l.addFeatures(v, this.tileID.canonical, r.patternPositions));
                    }
                    this.status = "done", s(null, {
                        buckets: e1.values(g).filter(function(e1) {
                            return !e1.isEmpty();
                        }),
                        featureIndex: h,
                        collisionBoxArray: this.collisionBoxArray,
                        glyphAtlasImage: t1.image,
                        imageAtlas: r,
                        glyphMap: this.returnDependencies ? p : null,
                        iconMap: this.returnDependencies ? f : null,
                        glyphPositions: this.returnDependencies ? t1.positions : null
                    });
                }
            }
            L.length ? n.send("getImages", {
                icons: L,
                source: this.source,
                tileID: this.tileID,
                type: "patterns"
            }, function(e1, t1) {
                c || (c = e1, d = t1, z.call(l));
            }) : d = {}, z.call(this);
        };
        var l = function(e1, t1, r, i) {
            this.actor = e1, this.layerIndex = t1, this.availableImages = r, this.loadVectorData = i || s, this.loading = {}, this.loaded = {};
        };
        l.prototype.loadTile = function(t1, r) {
            var i = this, o = t1.uid;
            this.loading || (this.loading = {});
            var a = !!(t1 && t1.request && t1.request.collectResourceTiming) && new e1.RequestPerformance(t1.request), s = this.loading[o] = new n(t1);
            s.abort = this.loadVectorData(t1, function(t1, n) {
                if (delete i.loading[o], t1 || !n) return s.status = "done", i.loaded[o] = s, r(t1);
                var l = n.rawData, u = {};
                n.expires && (u.expires = n.expires), n.cacheControl && (u.cacheControl = n.cacheControl);
                var h = {};
                if (a) {
                    var c = a.finish();
                    c && (h.resourceTiming = JSON.parse(JSON.stringify(c)));
                }
                s.vectorTile = n.vectorTile, s.parse(n.vectorTile, i.layerIndex, i.availableImages, i.actor, function(t1, i) {
                    if (t1 || !i) return r(t1);
                    r(null, e1.extend({
                        rawTileData: l.slice(0)
                    }, i, u, h));
                }), i.loaded = i.loaded || {}, i.loaded[o] = s;
            });
        }, l.prototype.reloadTile = function(e1, t1) {
            var r = this, i = this.loaded, o = e1.uid, n = this;
            if (i && i[o]) {
                var a = i[o];
                a.showCollisionBoxes = e1.showCollisionBoxes;
                var s = function(e1, i) {
                    var o = a.reloadCallback;
                    o && (delete a.reloadCallback, a.parse(a.vectorTile, n.layerIndex, r.availableImages, n.actor, o)), t1(e1, i);
                };
                "parsing" === a.status ? a.reloadCallback = s : "done" === a.status && (a.vectorTile ? a.parse(a.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
            }
        }, l.prototype.abortTile = function(e1, t1) {
            var r = this.loading, i = e1.uid;
            r && r[i] && r[i].abort && (r[i].abort(), delete r[i]), t1();
        }, l.prototype.removeTile = function(e1, t1) {
            var r = this.loaded, i = e1.uid;
            r && r[i] && delete r[i], t1();
        };
        var u = e1.window.ImageBitmap, h = function() {
            this.loaded = {};
        };
        function c(e1, t1) {
            if (0 !== e1.length) {
                p(e1[0], t1);
                for(var r = 1; r < e1.length; r++)p(e1[r], !t1);
            }
        }
        function p(e1, t1) {
            for(var r = 0, i = 0, o = 0, n = e1.length, a = n - 1; o < n; a = o++){
                var s = (e1[o][0] - e1[a][0]) * (e1[a][1] + e1[o][1]), l = r + s;
                i += Math.abs(r) >= Math.abs(s) ? r - l + s : s - l + r, r = l;
            }
            r + i >= 0 != !!t1 && e1.reverse();
        }
        h.prototype.loadTile = function(t1, r) {
            var i = t1.uid, o = t1.encoding, n = t1.rawImageData, a = u && n instanceof u ? this.getImageData(n) : n, s = new e1.DEMData(i, a, o);
            this.loaded = this.loaded || {}, this.loaded[i] = s, r(null, s);
        }, h.prototype.getImageData = function(t1) {
            this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(t1.width, t1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = t1.width, this.offscreenCanvas.height = t1.height, this.offscreenCanvasContext.drawImage(t1, 0, 0, t1.width, t1.height);
            var r = this.offscreenCanvasContext.getImageData(-1, -1, t1.width + 2, t1.height + 2);
            return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new e1.RGBAImage({
                width: r.width,
                height: r.height
            }, r.data);
        }, h.prototype.removeTile = function(e1) {
            var t1 = this.loaded, r = e1.uid;
            t1 && t1[r] && delete t1[r];
        };
        var f = e1.vectorTile.VectorTileFeature.prototype.toGeoJSON, d = function(t1) {
            this._feature = t1, this.extent = e1.EXTENT, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
        };
        d.prototype.loadGeometry = function() {
            if (1 === this._feature.type) {
                for(var t1 = [], r = 0, i = this._feature.geometry; r < i.length; r += 1){
                    var o = i[r];
                    t1.push([
                        new e1.Point$1(o[0], o[1])
                    ]);
                }
                return t1;
            }
            for(var n = [], a = 0, s = this._feature.geometry; a < s.length; a += 1){
                for(var l = [], u = 0, h = s[a]; u < h.length; u += 1){
                    var c = h[u];
                    l.push(new e1.Point$1(c[0], c[1]));
                }
                n.push(l);
            }
            return n;
        }, d.prototype.toGeoJSON = function(e1, t1, r) {
            return f.call(this, e1, t1, r);
        };
        var g = function(t1) {
            this.layers = {
                _geojsonTileLayer: this
            }, this.name = "_geojsonTileLayer", this.extent = e1.EXTENT, this.length = t1.length, this._features = t1;
        };
        g.prototype.feature = function(e1) {
            return new d(this._features[e1]);
        };
        var v = e1.vectorTile.VectorTileFeature, m = y;
        function y(e1, t1) {
            this.options = t1 || {}, this.features = e1, this.length = e1.length;
        }
        function x(e1, t1) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t1 || 4096;
        }
        y.prototype.feature = function(e1) {
            return new x(this.features[e1], this.options.extent);
        }, x.prototype.loadGeometry = function() {
            var t1 = this.rawGeometry;
            this.geometry = [];
            for(var r = 0; r < t1.length; r++){
                for(var i = t1[r], o = [], n = 0; n < i.length; n++)o.push(new e1.Point$1(i[n][0], i[n][1]));
                this.geometry.push(o);
            }
            return this.geometry;
        }, x.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t1 = 1 / 0, r = -1 / 0, i = 1 / 0, o = -1 / 0, n = 0; n < e1.length; n++)for(var a = e1[n], s = 0; s < a.length; s++){
                var l = a[s];
                t1 = Math.min(t1, l.x), r = Math.max(r, l.x), i = Math.min(i, l.y), o = Math.max(o, l.y);
            }
            return [
                t1,
                i,
                r,
                o
            ];
        }, x.prototype.toGeoJSON = v.prototype.toGeoJSON;
        var w = I, S = m;
        function I(t1) {
            var r = new e1.pbf;
            return function(e1, t1) {
                for(var r in e1.layers)t1.writeMessage(3, M, e1.layers[r]);
            }(t1, r), r.finish();
        }
        function M(e1, t1) {
            var r;
            t1.writeVarintField(15, e1.version || 1), t1.writeStringField(1, e1.name || ""), t1.writeVarintField(5, e1.extent || 4096);
            var i = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(r = 0; r < e1.length; r++)i.feature = e1.feature(r), t1.writeMessage(2, b, i);
            var o = i.keys;
            for(r = 0; r < o.length; r++)t1.writeStringField(3, o[r]);
            var n = i.values;
            for(r = 0; r < n.length; r++)t1.writeMessage(4, C, n[r]);
        }
        function b(e1, t1) {
            var r = e1.feature;
            void 0 !== r.id && t1.writeVarintField(1, r.id), t1.writeMessage(2, _, e1), t1.writeVarintField(3, r.type), t1.writeMessage(4, T, r);
        }
        function _(e1, t1) {
            var r = e1.feature, i = e1.keys, o = e1.values, n = e1.keycache, a = e1.valuecache;
            for(var s in r.properties){
                var l = n[s];
                void 0 === l && (i.push(s), n[s] = l = i.length - 1), t1.writeVarint(l);
                var u = r.properties[s], h = typeof u;
                "string" !== h && "boolean" !== h && "number" !== h && (u = JSON.stringify(u));
                var c = h + ":" + u, p = a[c];
                void 0 === p && (o.push(u), a[c] = p = o.length - 1), t1.writeVarint(p);
            }
        }
        function k(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function P(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function T(e1, t1) {
            for(var r = e1.loadGeometry(), i = e1.type, o = 0, n = 0, a = r.length, s = 0; s < a; s++){
                var l = r[s], u = 1;
                1 === i && (u = l.length), t1.writeVarint(k(1, u));
                for(var h = 3 === i ? l.length - 1 : l.length, c = 0; c < h; c++){
                    1 === c && 1 !== i && t1.writeVarint(k(2, h - 1));
                    var p = l[c].x - o, f = l[c].y - n;
                    t1.writeVarint(P(p)), t1.writeVarint(P(f)), o += p, n += f;
                }
                3 === i && t1.writeVarint(k(7, 1));
            }
        }
        function C(e1, t1) {
            var r = typeof e1;
            "string" === r ? t1.writeStringField(1, e1) : "boolean" === r ? t1.writeBooleanField(7, e1) : "number" === r && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        function D(e1, t1, r, i) {
            L(e1, r, i), L(t1, 2 * r, 2 * i), L(t1, 2 * r + 1, 2 * i + 1);
        }
        function L(e1, t1, r) {
            var i = e1[t1];
            e1[t1] = e1[r], e1[r] = i;
        }
        function z(e1, t1, r, i) {
            var o = e1 - r, n = t1 - i;
            return o * o + n * n;
        }
        w.fromVectorTileJs = I, w.fromGeojsonVt = function(e1, t1) {
            t1 = t1 || {};
            var r = {};
            for(var i in e1)r[i] = new m(e1[i].features, t1), r[i].name = i, r[i].version = t1.version, r[i].extent = t1.extent;
            return I({
                layers: r
            });
        }, w.GeoJSONWrapper = S;
        var O = function(e1) {
            return e1[0];
        }, E = function(e1) {
            return e1[1];
        }, F = function(e1, t1, r, i, o) {
            void 0 === t1 && (t1 = O), void 0 === r && (r = E), void 0 === i && (i = 64), void 0 === o && (o = Float64Array), this.nodeSize = i, this.points = e1;
            for(var n = e1.length < 65536 ? Uint16Array : Uint32Array, a = this.ids = new n(e1.length), s = this.coords = new o(2 * e1.length), l = 0; l < e1.length; l++)a[l] = l, s[2 * l] = t1(e1[l]), s[2 * l + 1] = r(e1[l]);
            !function e1(t1, r, i, o, n, a) {
                if (!(n - o <= i)) {
                    var s = o + n >> 1;
                    !function e1(t1, r, i, o, n, a) {
                        for(; n > o;){
                            if (n - o > 600) {
                                var s = n - o + 1, l = i - o + 1, u = Math.log(s), h = .5 * Math.exp(2 * u / 3), c = .5 * Math.sqrt(u * h * (s - h) / s) * (l - s / 2 < 0 ? -1 : 1);
                                e1(t1, r, i, Math.max(o, Math.floor(i - l * h / s + c)), Math.min(n, Math.floor(i + (s - l) * h / s + c)), a);
                            }
                            var p = r[2 * i + a], f = o, d = n;
                            for(D(t1, r, o, i), r[2 * n + a] > p && D(t1, r, o, n); f < d;){
                                for(D(t1, r, f, d), f++, d--; r[2 * f + a] < p;)f++;
                                for(; r[2 * d + a] > p;)d--;
                            }
                            r[2 * o + a] === p ? D(t1, r, o, d) : D(t1, r, ++d, n), d <= i && (o = d + 1), i <= d && (n = d - 1);
                        }
                    }(t1, r, s, o, n, a % 2), e1(t1, r, i, o, s - 1, a + 1), e1(t1, r, i, s + 1, n, a + 1);
                }
            }(a, s, i, 0, a.length - 1, 0);
        };
        F.prototype.range = function(e1, t1, r, i) {
            return function(e1, t1, r, i, o, n, a) {
                for(var s, l, u = [
                    0,
                    e1.length - 1,
                    0
                ], h = []; u.length;){
                    var c = u.pop(), p = u.pop(), f = u.pop();
                    if (p - f <= a) for(var d = f; d <= p; d++)l = t1[2 * d + 1], (s = t1[2 * d]) >= r && s <= o && l >= i && l <= n && h.push(e1[d]);
                    else {
                        var g = Math.floor((f + p) / 2);
                        l = t1[2 * g + 1], (s = t1[2 * g]) >= r && s <= o && l >= i && l <= n && h.push(e1[g]);
                        var v = (c + 1) % 2;
                        (0 === c ? r <= s : i <= l) && (u.push(f), u.push(g - 1), u.push(v)), (0 === c ? o >= s : n >= l) && (u.push(g + 1), u.push(p), u.push(v));
                    }
                }
                return h;
            }(this.ids, this.coords, e1, t1, r, i, this.nodeSize);
        }, F.prototype.within = function(e1, t1, r) {
            return function(e1, t1, r, i, o, n) {
                for(var a = [
                    0,
                    e1.length - 1,
                    0
                ], s = [], l = o * o; a.length;){
                    var u = a.pop(), h = a.pop(), c = a.pop();
                    if (h - c <= n) for(var p = c; p <= h; p++)z(t1[2 * p], t1[2 * p + 1], r, i) <= l && s.push(e1[p]);
                    else {
                        var f = Math.floor((c + h) / 2), d = t1[2 * f], g = t1[2 * f + 1];
                        z(d, g, r, i) <= l && s.push(e1[f]);
                        var v = (u + 1) % 2;
                        (0 === u ? r - o <= d : i - o <= g) && (a.push(c), a.push(f - 1), a.push(v)), (0 === u ? r + o >= d : i + o >= g) && (a.push(f + 1), a.push(h), a.push(v));
                    }
                }
                return s;
            }(this.ids, this.coords, e1, t1, r, this.nodeSize);
        };
        var N = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: function(e1) {
                return e1;
            }
        }, J = function(e1) {
            this.options = V(Object.create(N), e1), this.trees = new Array(this.options.maxZoom + 1);
        };
        function Z(e1, t1, r, i, o) {
            return {
                x: e1,
                y: t1,
                zoom: 1 / 0,
                id: r,
                parentId: -1,
                numPoints: i,
                properties: o
            };
        }
        function A(e1, t1) {
            var r = e1.geometry.coordinates, i = r[1];
            return {
                x: Y(r[0]),
                y: j(i),
                zoom: 1 / 0,
                index: t1,
                parentId: -1
            };
        }
        function B(e1) {
            var t1, r, i;
            return {
                type: "Feature",
                id: e1.id,
                properties: G(e1),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e1.x, 360 * (i - .5)),
                        (t1 = e1.y, r = (180 - 360 * t1) * Math.PI / 180, 360 * Math.atan(Math.exp(r)) / Math.PI - 90)
                    ]
                }
            };
        }
        function G(e1) {
            var t1 = e1.numPoints, r = t1 >= 1e4 ? Math.round(t1 / 1e3) + "k" : t1 >= 1e3 ? Math.round(t1 / 100) / 10 + "k" : t1;
            return V(V({}, e1.properties), {
                cluster: !0,
                cluster_id: e1.id,
                point_count: t1,
                point_count_abbreviated: r
            });
        }
        function Y(e1) {
            return e1 / 360 + .5;
        }
        function j(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function V(e1, t1) {
            for(var r in t1)e1[r] = t1[r];
            return e1;
        }
        function X(e1) {
            return e1.x;
        }
        function W(e1) {
            return e1.y;
        }
        function R(e1, t1, r, i, o, n) {
            var a = o - r, s = n - i;
            if (0 !== a || 0 !== s) {
                var l = ((e1 - r) * a + (t1 - i) * s) / (a * a + s * s);
                l > 1 ? (r = o, i = n) : l > 0 && (r += a * l, i += s * l);
            }
            return (a = e1 - r) * a + (s = t1 - i) * s;
        }
        function q(e1, t1, r, i) {
            var o = {
                id: void 0 === e1 ? null : e1,
                type: t1,
                geometry: r,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e1) {
                var t1 = e1.geometry, r = e1.type;
                if ("Point" === r || "MultiPoint" === r || "LineString" === r) U(e1, t1);
                else if ("Polygon" === r || "MultiLineString" === r) for(var i = 0; i < t1.length; i++)U(e1, t1[i]);
                else if ("MultiPolygon" === r) for(i = 0; i < t1.length; i++)for(var o = 0; o < t1[i].length; o++)U(e1, t1[i][o]);
            }(o), o;
        }
        function U(e1, t1) {
            for(var r = 0; r < t1.length; r += 3)e1.minX = Math.min(e1.minX, t1[r]), e1.minY = Math.min(e1.minY, t1[r + 1]), e1.maxX = Math.max(e1.maxX, t1[r]), e1.maxY = Math.max(e1.maxY, t1[r + 1]);
        }
        function $(e1, t1, r, i) {
            if (t1.geometry) {
                var o = t1.geometry.coordinates, n = t1.geometry.type, a = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2), s = [], l = t1.id;
                if (r.promoteId ? l = t1.properties[r.promoteId] : r.generateId && (l = i || 0), "Point" === n) H(o, s);
                else if ("MultiPoint" === n) for(var u = 0; u < o.length; u++)H(o[u], s);
                else if ("LineString" === n) K(o, s, a, !1);
                else if ("MultiLineString" === n) {
                    if (r.lineMetrics) {
                        for(u = 0; u < o.length; u++)K(o[u], s = [], a, !1), e1.push(q(l, "LineString", s, t1.properties));
                        return;
                    }
                    Q(o, s, a, !1);
                } else if ("Polygon" === n) Q(o, s, a, !0);
                else {
                    if ("MultiPolygon" !== n) {
                        if ("GeometryCollection" === n) {
                            for(u = 0; u < t1.geometry.geometries.length; u++)$(e1, {
                                id: l,
                                geometry: t1.geometry.geometries[u],
                                properties: t1.properties
                            }, r, i);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(u = 0; u < o.length; u++){
                        var h = [];
                        Q(o[u], h, a, !0), s.push(h);
                    }
                }
                e1.push(q(l, n, s, t1.properties));
            }
        }
        function H(e1, t1) {
            t1.push(ee(e1[0])), t1.push(te(e1[1])), t1.push(0);
        }
        function K(e1, t1, r, i) {
            for(var o, n, a = 0, s = 0; s < e1.length; s++){
                var l = ee(e1[s][0]), u = te(e1[s][1]);
                t1.push(l), t1.push(u), t1.push(0), s > 0 && (a += i ? (o * u - l * n) / 2 : Math.sqrt(Math.pow(l - o, 2) + Math.pow(u - n, 2))), o = l, n = u;
            }
            var h = t1.length - 3;
            t1[2] = 1, function e1(t1, r, i, o) {
                for(var n, a = o, s = i - r >> 1, l = i - r, u = t1[r], h = t1[r + 1], c = t1[i], p = t1[i + 1], f = r + 3; f < i; f += 3){
                    var d = R(t1[f], t1[f + 1], u, h, c, p);
                    if (d > a) n = f, a = d;
                    else if (d === a) {
                        var g = Math.abs(f - s);
                        g < l && (n = f, l = g);
                    }
                }
                a > o && (n - r > 3 && e1(t1, r, n, o), t1[n + 2] = a, i - n > 3 && e1(t1, n, i, o));
            }(t1, 0, h, r), t1[h + 2] = 1, t1.size = Math.abs(a), t1.start = 0, t1.end = t1.size;
        }
        function Q(e1, t1, r, i) {
            for(var o = 0; o < e1.length; o++){
                var n = [];
                K(e1[o], n, r, i), t1.push(n);
            }
        }
        function ee(e1) {
            return e1 / 360 + .5;
        }
        function te(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function re(e1, t1, r, i, o, n, a, s) {
            if (i /= t1, n >= (r /= t1) && a < i) return e1;
            if (a < r || n >= i) return null;
            for(var l = [], u = 0; u < e1.length; u++){
                var h = e1[u], c = h.geometry, p = h.type, f = 0 === o ? h.minX : h.minY, d = 0 === o ? h.maxX : h.maxY;
                if (f >= r && d < i) l.push(h);
                else if (!(d < r || f >= i)) {
                    var g = [];
                    if ("Point" === p || "MultiPoint" === p) ie(c, g, r, i, o);
                    else if ("LineString" === p) oe(c, g, r, i, o, !1, s.lineMetrics);
                    else if ("MultiLineString" === p) ae(c, g, r, i, o, !1);
                    else if ("Polygon" === p) ae(c, g, r, i, o, !0);
                    else if ("MultiPolygon" === p) for(var v = 0; v < c.length; v++){
                        var m = [];
                        ae(c[v], m, r, i, o, !0), m.length && g.push(m);
                    }
                    if (g.length) {
                        if (s.lineMetrics && "LineString" === p) {
                            for(v = 0; v < g.length; v++)l.push(q(h.id, p, g[v], h.tags));
                            continue;
                        }
                        "LineString" !== p && "MultiLineString" !== p || (1 === g.length ? (p = "LineString", g = g[0]) : p = "MultiLineString"), "Point" !== p && "MultiPoint" !== p || (p = 3 === g.length ? "Point" : "MultiPoint"), l.push(q(h.id, p, g, h.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function ie(e1, t1, r, i, o) {
            for(var n = 0; n < e1.length; n += 3){
                var a = e1[n + o];
                a >= r && a <= i && (t1.push(e1[n]), t1.push(e1[n + 1]), t1.push(e1[n + 2]));
            }
        }
        function oe(e1, t1, r, i, o, n, a) {
            for(var s, l, u = ne(e1), h = 0 === o ? le : ue, c = e1.start, p = 0; p < e1.length - 3; p += 3){
                var f = e1[p], d = e1[p + 1], g = e1[p + 2], v = e1[p + 3], m = e1[p + 4], y = 0 === o ? f : d, x = 0 === o ? v : m, w = !1;
                a && (s = Math.sqrt(Math.pow(f - v, 2) + Math.pow(d - m, 2))), y < r ? x > r && (l = h(u, f, d, v, m, r), a && (u.start = c + s * l)) : y > i ? x < i && (l = h(u, f, d, v, m, i), a && (u.start = c + s * l)) : se(u, f, d, g), x < r && y >= r && (l = h(u, f, d, v, m, r), w = !0), x > i && y <= i && (l = h(u, f, d, v, m, i), w = !0), !n && w && (a && (u.end = c + s * l), t1.push(u), u = ne(e1)), a && (c += s);
            }
            var S = e1.length - 3;
            f = e1[S], d = e1[S + 1], g = e1[S + 2], (y = 0 === o ? f : d) >= r && y <= i && se(u, f, d, g), S = u.length - 3, n && S >= 3 && (u[S] !== u[0] || u[S + 1] !== u[1]) && se(u, u[0], u[1], u[2]), u.length && t1.push(u);
        }
        function ne(e1) {
            var t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function ae(e1, t1, r, i, o, n) {
            for(var a = 0; a < e1.length; a++)oe(e1[a], t1, r, i, o, n, !1);
        }
        function se(e1, t1, r, i) {
            e1.push(t1), e1.push(r), e1.push(i);
        }
        function le(e1, t1, r, i, o, n) {
            var a = (n - t1) / (i - t1);
            return e1.push(n), e1.push(r + (o - r) * a), e1.push(1), a;
        }
        function ue(e1, t1, r, i, o, n) {
            var a = (n - r) / (o - r);
            return e1.push(t1 + (i - t1) * a), e1.push(n), e1.push(1), a;
        }
        function he(e1, t1) {
            for(var r = [], i = 0; i < e1.length; i++){
                var o, n = e1[i], a = n.type;
                if ("Point" === a || "MultiPoint" === a || "LineString" === a) o = ce(n.geometry, t1);
                else if ("MultiLineString" === a || "Polygon" === a) {
                    o = [];
                    for(var s = 0; s < n.geometry.length; s++)o.push(ce(n.geometry[s], t1));
                } else if ("MultiPolygon" === a) for(o = [], s = 0; s < n.geometry.length; s++){
                    for(var l = [], u = 0; u < n.geometry[s].length; u++)l.push(ce(n.geometry[s][u], t1));
                    o.push(l);
                }
                r.push(q(n.id, a, o, n.tags));
            }
            return r;
        }
        function ce(e1, t1) {
            var r = [];
            r.size = e1.size, void 0 !== e1.start && (r.start = e1.start, r.end = e1.end);
            for(var i = 0; i < e1.length; i += 3)r.push(e1[i] + t1, e1[i + 1], e1[i + 2]);
            return r;
        }
        function pe(e1, t1) {
            if (e1.transformed) return e1;
            var r, i, o, n = 1 << e1.z, a = e1.x, s = e1.y;
            for(r = 0; r < e1.features.length; r++){
                var l = e1.features[r], u = l.geometry, h = l.type;
                if (l.geometry = [], 1 === h) for(i = 0; i < u.length; i += 2)l.geometry.push(fe(u[i], u[i + 1], t1, n, a, s));
                else for(i = 0; i < u.length; i++){
                    var c = [];
                    for(o = 0; o < u[i].length; o += 2)c.push(fe(u[i][o], u[i][o + 1], t1, n, a, s));
                    l.geometry.push(c);
                }
            }
            return e1.transformed = !0, e1;
        }
        function fe(e1, t1, r, i, o, n) {
            return [
                Math.round(r * (e1 * i - o)),
                Math.round(r * (t1 * i - n))
            ];
        }
        function de(e1, t1, r, i, o) {
            for(var n = t1 === o.maxZoom ? 0 : o.tolerance / ((1 << t1) * o.extent), a = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: r,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, s = 0; s < e1.length; s++){
                a.numFeatures++, ge(a, e1[s], n, o);
                var l = e1[s].minX, u = e1[s].minY, h = e1[s].maxX, c = e1[s].maxY;
                l < a.minX && (a.minX = l), u < a.minY && (a.minY = u), h > a.maxX && (a.maxX = h), c > a.maxY && (a.maxY = c);
            }
            return a;
        }
        function ge(e1, t1, r, i) {
            var o = t1.geometry, n = t1.type, a = [];
            if ("Point" === n || "MultiPoint" === n) for(var s = 0; s < o.length; s += 3)a.push(o[s]), a.push(o[s + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === n) ve(a, o, e1, r, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(s = 0; s < o.length; s++)ve(a, o[s], e1, r, "Polygon" === n, 0 === s);
            else if ("MultiPolygon" === n) for(var l = 0; l < o.length; l++){
                var u = o[l];
                for(s = 0; s < u.length; s++)ve(a, u[s], e1, r, !0, 0 === s);
            }
            if (a.length) {
                var h = t1.tags || null;
                if ("LineString" === n && i.lineMetrics) {
                    for(var c in h = {}, t1.tags)h[c] = t1.tags[c];
                    h.mapbox_clip_start = o.start / o.size, h.mapbox_clip_end = o.end / o.size;
                }
                var p = {
                    geometry: a,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: h
                };
                null !== t1.id && (p.id = t1.id), e1.features.push(p);
            }
        }
        function ve(e1, t1, r, i, o, n) {
            var a = i * i;
            if (i > 0 && t1.size < (o ? a : i)) r.numPoints += t1.length / 3;
            else {
                for(var s = [], l = 0; l < t1.length; l += 3)(0 === i || t1[l + 2] > a) && (r.numSimplified++, s.push(t1[l]), s.push(t1[l + 1])), r.numPoints++;
                o && function(e1, t1) {
                    for(var r = 0, i = 0, o = e1.length, n = o - 2; i < o; n = i, i += 2)r += (e1[i] - e1[n]) * (e1[i + 1] + e1[n + 1]);
                    if (r > 0 === t1) for(i = 0, o = e1.length; i < o / 2; i += 2){
                        var a = e1[i], s = e1[i + 1];
                        e1[i] = e1[o - 2 - i], e1[i + 1] = e1[o - 1 - i], e1[o - 2 - i] = a, e1[o - 1 - i] = s;
                    }
                }(s, n), e1.push(s);
            }
        }
        function me(e1, t1) {
            var r = (t1 = this.options = function(e1, t1) {
                for(var r in t1)e1[r] = t1[r];
                return e1;
            }(Object.create(this.options), t1)).debug;
            if (r && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var i = function(e1, t1) {
                var r = [];
                if ("FeatureCollection" === e1.type) for(var i = 0; i < e1.features.length; i++)$(r, e1.features[i], t1, i);
                else $(r, "Feature" === e1.type ? e1 : {
                    geometry: e1
                }, t1);
                return r;
            }(e1, t1);
            this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (i = function(e1, t1) {
                var r = t1.buffer / t1.extent, i = e1, o = re(e1, 1, -1 - r, r, 0, -1, 2, t1), n = re(e1, 1, 1 - r, 2 + r, 0, -1, 2, t1);
                return (o || n) && (i = re(e1, 1, -r, 1 + r, 0, -1, 2, t1) || [], o && (i = he(o, 1).concat(i)), n && (i = i.concat(he(n, -1)))), i;
            }(i, t1)).length && this.splitTile(i, 0, 0, 0), r && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function ye(e1, t1, r) {
            return 32 * ((1 << e1) * r + t1) + e1;
        }
        function xe(e1, t1) {
            var r = e1.tileID.canonical;
            if (!this._geoJSONIndex) return t1(null, null);
            var i = this._geoJSONIndex.getTile(r.z, r.x, r.y);
            if (!i) return t1(null, null);
            var o = new g(i.features), n = w(o);
            0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), t1(null, {
                vectorTile: o,
                rawData: n.buffer
            });
        }
        J.prototype.load = function(e1) {
            var t1 = this.options, r = t1.log, i = t1.minZoom, o = t1.maxZoom, n = t1.nodeSize;
            r && console.time("total time");
            var a = "prepare " + e1.length + " points";
            r && console.time(a), this.points = e1;
            for(var s = [], l = 0; l < e1.length; l++)e1[l].geometry && s.push(A(e1[l], l));
            this.trees[o + 1] = new F(s, X, W, n, Float32Array), r && console.timeEnd(a);
            for(var u = o; u >= i; u--){
                var h = +Date.now();
                s = this._cluster(s, u), this.trees[u] = new F(s, X, W, n, Float32Array), r && console.log("z%d: %d clusters in %dms", u, s.length, +Date.now() - h);
            }
            return r && console.timeEnd("total time"), this;
        }, J.prototype.getClusters = function(e1, t1) {
            var r = ((e1[0] + 180) % 360 + 360) % 360 - 180, i = Math.max(-90, Math.min(90, e1[1])), o = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180, n = Math.max(-90, Math.min(90, e1[3]));
            if (e1[2] - e1[0] >= 360) r = -180, o = 180;
            else if (r > o) {
                var a = this.getClusters([
                    r,
                    i,
                    180,
                    n
                ], t1), s = this.getClusters([
                    -180,
                    i,
                    o,
                    n
                ], t1);
                return a.concat(s);
            }
            for(var l = this.trees[this._limitZoom(t1)], u = [], h = 0, c = l.range(Y(r), j(n), Y(o), j(i)); h < c.length; h += 1){
                var p = l.points[c[h]];
                u.push(p.numPoints ? B(p) : this.points[p.index]);
            }
            return u;
        }, J.prototype.getChildren = function(e1) {
            var t1 = this._getOriginId(e1), r = this._getOriginZoom(e1), i = "No cluster with the specified id.", o = this.trees[r];
            if (!o) throw new Error(i);
            var n = o.points[t1];
            if (!n) throw new Error(i);
            for(var a = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), s = [], l = 0, u = o.within(n.x, n.y, a); l < u.length; l += 1){
                var h = o.points[u[l]];
                h.parentId === e1 && s.push(h.numPoints ? B(h) : this.points[h.index]);
            }
            if (0 === s.length) throw new Error(i);
            return s;
        }, J.prototype.getLeaves = function(e1, t1, r) {
            var i = [];
            return this._appendLeaves(i, e1, t1 = t1 || 10, r = r || 0, 0), i;
        }, J.prototype.getTile = function(e1, t1, r) {
            var i = this.trees[this._limitZoom(e1)], o = Math.pow(2, e1), n = this.options, a = n.radius / n.extent, s = (r - a) / o, l = (r + 1 + a) / o, u = {
                features: []
            };
            return this._addTileFeatures(i.range((t1 - a) / o, s, (t1 + 1 + a) / o, l), i.points, t1, r, o, u), 0 === t1 && this._addTileFeatures(i.range(1 - a / o, s, 1, l), i.points, o, r, o, u), t1 === o - 1 && this._addTileFeatures(i.range(0, s, a / o, l), i.points, -1, r, o, u), u.features.length ? u : null;
        }, J.prototype.getClusterExpansionZoom = function(e1) {
            for(var t1 = this._getOriginZoom(e1) - 1; t1 <= this.options.maxZoom;){
                var r = this.getChildren(e1);
                if (t1++, 1 !== r.length) break;
                e1 = r[0].properties.cluster_id;
            }
            return t1;
        }, J.prototype._appendLeaves = function(e1, t1, r, i, o) {
            for(var n = 0, a = this.getChildren(t1); n < a.length; n += 1){
                var s = a[n], l = s.properties;
                if (l && l.cluster ? o + l.point_count <= i ? o += l.point_count : o = this._appendLeaves(e1, l.cluster_id, r, i, o) : o < i ? o++ : e1.push(s), e1.length === r) break;
            }
            return o;
        }, J.prototype._addTileFeatures = function(e1, t1, r, i, o, n) {
            for(var a = 0, s = e1; a < s.length; a += 1){
                var l = t1[s[a]], u = l.numPoints, h = {
                    type: 1,
                    geometry: [
                        [
                            Math.round(this.options.extent * (l.x * o - r)),
                            Math.round(this.options.extent * (l.y * o - i))
                        ]
                    ],
                    tags: u ? G(l) : this.points[l.index].properties
                }, c = void 0;
                u ? c = l.id : this.options.generateId ? c = l.index : this.points[l.index].id && (c = this.points[l.index].id), void 0 !== c && (h.id = c), n.features.push(h);
            }
        }, J.prototype._limitZoom = function(e1) {
            return Math.max(this.options.minZoom, Math.min(+e1, this.options.maxZoom + 1));
        }, J.prototype._cluster = function(e1, t1) {
            for(var r = [], i = this.options, o = i.reduce, n = i.minPoints, a = i.radius / (i.extent * Math.pow(2, t1)), s = 0; s < e1.length; s++){
                var l = e1[s];
                if (!(l.zoom <= t1)) {
                    l.zoom = t1;
                    for(var u = this.trees[t1 + 1], h = u.within(l.x, l.y, a), c = l.numPoints || 1, p = c, f = 0, d = h; f < d.length; f += 1){
                        var g = u.points[d[f]];
                        g.zoom > t1 && (p += g.numPoints || 1);
                    }
                    if (p >= n) {
                        for(var v = l.x * c, m = l.y * c, y = o && c > 1 ? this._map(l, !0) : null, x = (s << 5) + (t1 + 1) + this.points.length, w = 0, S = h; w < S.length; w += 1){
                            var I = u.points[S[w]];
                            if (!(I.zoom <= t1)) {
                                I.zoom = t1;
                                var M = I.numPoints || 1;
                                v += I.x * M, m += I.y * M, I.parentId = x, o && (y || (y = this._map(l, !0)), o(y, this._map(I)));
                            }
                        }
                        l.parentId = x, r.push(Z(v / p, m / p, x, p, y));
                    } else if (r.push(l), p > 1) for(var b = 0, _ = h; b < _.length; b += 1){
                        var k = u.points[_[b]];
                        k.zoom <= t1 || (k.zoom = t1, r.push(k));
                    }
                }
            }
            return r;
        }, J.prototype._getOriginId = function(e1) {
            return e1 - this.points.length >> 5;
        }, J.prototype._getOriginZoom = function(e1) {
            return (e1 - this.points.length) % 32;
        }, J.prototype._map = function(e1, t1) {
            if (e1.numPoints) return t1 ? V({}, e1.properties) : e1.properties;
            var r = this.points[e1.index].properties, i = this.options.map(r);
            return t1 && i === r ? V({}, i) : i;
        }, me.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, me.prototype.splitTile = function(e1, t1, r, i, o, n, a) {
            for(var s = [
                e1,
                t1,
                r,
                i
            ], l = this.options, u = l.debug; s.length;){
                i = s.pop(), r = s.pop(), t1 = s.pop(), e1 = s.pop();
                var h = 1 << t1, c = ye(t1, r, i), p = this.tiles[c];
                if (!p && (u > 1 && console.time("creation"), p = this.tiles[c] = de(e1, t1, r, i, l), this.tileCoords.push({
                    z: t1,
                    x: r,
                    y: i
                }), u)) {
                    u > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, r, i, p.numFeatures, p.numPoints, p.numSimplified), console.timeEnd("creation"));
                    var f = "z" + t1;
                    this.stats[f] = (this.stats[f] || 0) + 1, this.total++;
                }
                if (p.source = e1, o) {
                    if (t1 === l.maxZoom || t1 === o) continue;
                    var d = 1 << o - t1;
                    if (r !== Math.floor(n / d) || i !== Math.floor(a / d)) continue;
                } else if (t1 === l.indexMaxZoom || p.numPoints <= l.indexMaxPoints) continue;
                if (p.source = null, 0 !== e1.length) {
                    u > 1 && console.time("clipping");
                    var g, v, m, y, x, w, S = .5 * l.buffer / l.extent, I = .5 - S, M = .5 + S, b = 1 + S;
                    g = v = m = y = null, x = re(e1, h, r - S, r + M, 0, p.minX, p.maxX, l), w = re(e1, h, r + I, r + b, 0, p.minX, p.maxX, l), e1 = null, x && (g = re(x, h, i - S, i + M, 1, p.minY, p.maxY, l), v = re(x, h, i + I, i + b, 1, p.minY, p.maxY, l), x = null), w && (m = re(w, h, i - S, i + M, 1, p.minY, p.maxY, l), y = re(w, h, i + I, i + b, 1, p.minY, p.maxY, l), w = null), u > 1 && console.timeEnd("clipping"), s.push(g || [], t1 + 1, 2 * r, 2 * i), s.push(v || [], t1 + 1, 2 * r, 2 * i + 1), s.push(m || [], t1 + 1, 2 * r + 1, 2 * i), s.push(y || [], t1 + 1, 2 * r + 1, 2 * i + 1);
                }
            }
        }, me.prototype.getTile = function(e1, t1, r) {
            var i = this.options, o = i.extent, n = i.debug;
            if (e1 < 0 || e1 > 24) return null;
            var a = 1 << e1, s = ye(e1, t1 = (t1 % a + a) % a, r);
            if (this.tiles[s]) return pe(this.tiles[s], o);
            n > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, r);
            for(var l, u = e1, h = t1, c = r; !l && u > 0;)u--, h = Math.floor(h / 2), c = Math.floor(c / 2), l = this.tiles[ye(u, h, c)];
            return l && l.source ? (n > 1 && console.log("found parent tile z%d-%d-%d", u, h, c), n > 1 && console.time("drilling down"), this.splitTile(l.source, u, h, c, e1, t1, r), n > 1 && console.timeEnd("drilling down"), this.tiles[s] ? pe(this.tiles[s], o) : null) : null;
        };
        var we = function(t1) {
            function r(e1, r, i, o) {
                t1.call(this, e1, r, i, xe), o && (this.loadGeoJSON = o);
            }
            return t1 && (r.__proto__ = t1), (r.prototype = Object.create(t1 && t1.prototype)).constructor = r, r.prototype.loadData = function(e1, t1) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), this._pendingCallback = t1, this._pendingLoadDataParams = e1, this._state && "Idle" !== this._state ? this._state = "NeedsLoadData" : (this._state = "Coalescing", this._loadData());
            }, r.prototype._loadData = function() {
                var t1 = this;
                if (this._pendingCallback && this._pendingLoadDataParams) {
                    var r = this._pendingCallback, i = this._pendingLoadDataParams;
                    delete this._pendingCallback, delete this._pendingLoadDataParams;
                    var o = !!(i && i.request && i.request.collectResourceTiming) && new e1.RequestPerformance(i.request);
                    this.loadGeoJSON(i, function(n, a) {
                        if (n || !a) return r(n);
                        if ("object" != typeof a) return r(new Error("Input data given to '" + i.source + "' is not a valid GeoJSON object."));
                        !function e1(t1, r) {
                            var i, o = t1 && t1.type;
                            if ("FeatureCollection" === o) for(i = 0; i < t1.features.length; i++)e1(t1.features[i], r);
                            else if ("GeometryCollection" === o) for(i = 0; i < t1.geometries.length; i++)e1(t1.geometries[i], r);
                            else if ("Feature" === o) e1(t1.geometry, r);
                            else if ("Polygon" === o) c(t1.coordinates, r);
                            else if ("MultiPolygon" === o) for(i = 0; i < t1.coordinates.length; i++)c(t1.coordinates[i], r);
                            return t1;
                        }(a, !0);
                        try {
                            if (i.filter) {
                                var s = e1.createExpression(i.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === s.result) throw new Error(s.value.map(function(e1) {
                                    return e1.key + ": " + e1.message;
                                }).join(", "));
                                var l = a.features.filter(function(e1) {
                                    return s.value.evaluate({
                                        zoom: 0
                                    }, e1);
                                });
                                a = {
                                    type: "FeatureCollection",
                                    features: l
                                };
                            }
                            t1._geoJSONIndex = i.cluster ? new J(function(t1) {
                                var r = t1.superclusterOptions, i = t1.clusterProperties;
                                if (!i || !r) return r;
                                for(var o = {}, n = {}, a = {
                                    accumulated: null,
                                    zoom: 0
                                }, s = {
                                    properties: null
                                }, l = Object.keys(i), u = 0, h = l; u < h.length; u += 1){
                                    var c = h[u], p = i[c], f = p[0], d = e1.createExpression(p[1]), g = e1.createExpression("string" == typeof f ? [
                                        f,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            c
                                        ]
                                    ] : f);
                                    o[c] = d.value, n[c] = g.value;
                                }
                                return r.map = function(e1) {
                                    s.properties = e1;
                                    for(var t1 = {}, r = 0, i = l; r < i.length; r += 1){
                                        var n = i[r];
                                        t1[n] = o[n].evaluate(a, s);
                                    }
                                    return t1;
                                }, r.reduce = function(e1, t1) {
                                    s.properties = t1;
                                    for(var r = 0, i = l; r < i.length; r += 1){
                                        var o = i[r];
                                        a.accumulated = e1[o], e1[o] = n[o].evaluate(a, s);
                                    }
                                }, r;
                            }(i)).load(a.features) : function(e1, t1) {
                                return new me(e1, t1);
                            }(a, i.geojsonVtOptions);
                        } catch (n) {
                            return r(n);
                        }
                        t1.loaded = {};
                        var u = {};
                        if (o) {
                            var h = o.finish();
                            h && (u.resourceTiming = {}, u.resourceTiming[i.source] = JSON.parse(JSON.stringify(h)));
                        }
                        r(null, u);
                    });
                }
            }, r.prototype.coalesce = function() {
                "Coalescing" === this._state ? this._state = "Idle" : "NeedsLoadData" === this._state && (this._state = "Coalescing", this._loadData());
            }, r.prototype.reloadTile = function(e1, r) {
                var i = this.loaded;
                return i && i[e1.uid] ? t1.prototype.reloadTile.call(this, e1, r) : this.loadTile(e1, r);
            }, r.prototype.loadGeoJSON = function(t1, r) {
                if (t1.request) e1.getJSON(t1.request, r);
                else {
                    if ("string" != typeof t1.data) return r(new Error("Input data given to '" + t1.source + "' is not a valid GeoJSON object."));
                    try {
                        return r(null, JSON.parse(t1.data));
                    } catch (e1) {
                        return r(new Error("Input data given to '" + t1.source + "' is not a valid GeoJSON object."));
                    }
                }
            }, r.prototype.removeSource = function(e1, t1) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), t1();
            }, r.prototype.getClusterExpansionZoom = function(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }, r.prototype.getClusterChildren = function(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }, r.prototype.getClusterLeaves = function(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t1(e1);
                }
            }, r;
        }(l), Se = function(t1) {
            var r = this;
            this.self = t1, this.actor = new e1.Actor(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                vector: l,
                geojson: we
            }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = function(e1, t1) {
                if (r.workerSourceTypes[e1]) throw new Error('Worker source with name "' + e1 + '" already registered.');
                r.workerSourceTypes[e1] = t1;
            }, this.self.registerRTLTextPlugin = function(t1) {
                if (e1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                e1.plugin.applyArabicShaping = t1.applyArabicShaping, e1.plugin.processBidirectionalText = t1.processBidirectionalText, e1.plugin.processStyledBidirectionalText = t1.processStyledBidirectionalText;
            };
        };
        return Se.prototype.setReferrer = function(e1, t1) {
            this.referrer = t1;
        }, Se.prototype.setImages = function(e1, t1, r) {
            for(var i in this.availableImages[e1] = t1, this.workerSources[e1]){
                var o = this.workerSources[e1][i];
                for(var n in o)o[n].availableImages = t1;
            }
            r();
        }, Se.prototype.setLayers = function(e1, t1, r) {
            this.getLayerIndex(e1).replace(t1), r();
        }, Se.prototype.updateLayers = function(e1, t1, r) {
            this.getLayerIndex(e1).update(t1.layers, t1.removedIds), r();
        }, Se.prototype.loadTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).loadTile(t1, r);
        }, Se.prototype.loadDEMTile = function(e1, t1, r) {
            this.getDEMWorkerSource(e1, t1.source).loadTile(t1, r);
        }, Se.prototype.reloadTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).reloadTile(t1, r);
        }, Se.prototype.abortTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).abortTile(t1, r);
        }, Se.prototype.removeTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).removeTile(t1, r);
        }, Se.prototype.removeDEMTile = function(e1, t1) {
            this.getDEMWorkerSource(e1, t1.source).removeTile(t1);
        }, Se.prototype.removeSource = function(e1, t1, r) {
            if (this.workerSources[e1] && this.workerSources[e1][t1.type] && this.workerSources[e1][t1.type][t1.source]) {
                var i = this.workerSources[e1][t1.type][t1.source];
                delete this.workerSources[e1][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, r) : r();
            }
        }, Se.prototype.loadWorkerSource = function(e1, t1, r) {
            try {
                this.self.importScripts(t1.url), r();
            } catch (e1) {
                r(e1.toString());
            }
        }, Se.prototype.syncRTLPluginState = function(t1, r, i) {
            try {
                e1.plugin.setState(r);
                var o = e1.plugin.getPluginURL();
                if (e1.plugin.isLoaded() && !e1.plugin.isParsed() && null != o) {
                    this.self.importScripts(o);
                    var n = e1.plugin.isParsed();
                    i(n ? void 0 : new Error("RTL Text Plugin failed to import scripts from " + o), n);
                }
            } catch (e1) {
                i(e1.toString());
            }
        }, Se.prototype.getAvailableImages = function(e1) {
            var t1 = this.availableImages[e1];
            return t1 || (t1 = []), t1;
        }, Se.prototype.getLayerIndex = function(e1) {
            var t1 = this.layerIndexes[e1];
            return t1 || (t1 = this.layerIndexes[e1] = new i), t1;
        }, Se.prototype.getWorkerSource = function(e1, t1, r) {
            var i = this;
            return this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t1] || (this.workerSources[e1][t1] = {}), this.workerSources[e1][t1][r] || (this.workerSources[e1][t1][r] = new this.workerSourceTypes[t1]({
                send: function(t1, r, o) {
                    i.actor.send(t1, r, o, e1);
                }
            }, this.getLayerIndex(e1), this.getAvailableImages(e1))), this.workerSources[e1][t1][r];
        }, Se.prototype.getDEMWorkerSource = function(e1, t1) {
            return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t1] || (this.demWorkerSources[e1][t1] = new h), this.demWorkerSources[e1][t1];
        }, Se.prototype.enforceCacheSizeLimit = function(t1, r) {
            e1.enforceCacheSizeLimit(r);
        }, "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new Se(self)), Se;
    });
    define([
        "./shared"
    ], function(t1) {
        "use strict";
        var e1 = t1.createCommonjsModule(function(t1) {
            function e1(t1) {
                return !i(t1);
            }
            function i(t1) {
                var i;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var t1, e1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        e1 = new Worker(o), t1 = !0;
                    } catch (e1) {
                        t1 = !1;
                    }
                    return e1 && e1.terminate(), URL.revokeObjectURL(o), t1;
                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                    var t1 = document.createElement("canvas");
                    t1.width = t1.height = 1;
                    var e1 = t1.getContext("2d");
                    if (!e1) return !1;
                    var i = e1.getImageData(0, 0, 1, 1);
                    return i && i.width === t1.width;
                }() ? (void 0 === o[i = t1 && t1.failIfMajorPerformanceCaveat] && (o[i] = function(t1) {
                    var i = function(t1) {
                        var i = document.createElement("canvas"), o = Object.create(e1.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, i.probablySupportsContext ? i.probablySupportsContext("webgl", o) || i.probablySupportsContext("experimental-webgl", o) : i.supportsContext ? i.supportsContext("webgl", o) || i.supportsContext("experimental-webgl", o) : i.getContext("webgl", o) || i.getContext("experimental-webgl", o);
                    }(t1);
                    if (!i) return !1;
                    var o = i.createShader(i.VERTEX_SHADER);
                    return !(!o || i.isContextLost()) && (i.shaderSource(o, "void main() {}"), i.compileShader(o), !0 === i.getShaderParameter(o, i.COMPILE_STATUS));
                }(i)), o[i] ? void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }
            t1.exports ? t1.exports = e1 : window && (window.mapboxgl = window.mapboxgl || {}, window.mapboxgl.supported = e1, window.mapboxgl.notSupportedReason = i);
            var o = {};
            e1.webGLContextAttributes = {
                antialias: !1,
                alpha: !0,
                stencil: !0,
                depth: !0
            };
        }), i = {
            create: function(e1, i, o) {
                var r = t1.window.document.createElement(e1);
                return void 0 !== i && (r.className = i), o && o.appendChild(r), r;
            },
            createNS: function(e1, i) {
                return t1.window.document.createElementNS(e1, i);
            }
        }, o = t1.window.document && t1.window.document.documentElement.style;
        function r(t1) {
            if (!o) return t1[0];
            for(var e1 = 0; e1 < t1.length; e1++)if (t1[e1] in o) return t1[e1];
            return t1[0];
        }
        var a, n = r([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]);
        i.disableDrag = function() {
            o && n && (a = o[n], o[n] = "none");
        }, i.enableDrag = function() {
            o && n && (o[n] = a);
        };
        var s = r([
            "transform",
            "WebkitTransform"
        ]);
        i.setTransform = function(t1, e1) {
            t1.style[s] = e1;
        };
        var l = !1;
        try {
            var c = Object.defineProperty({}, "passive", {
                get: function() {
                    l = !0;
                }
            });
            t1.window.addEventListener("test", c, c), t1.window.removeEventListener("test", c, c);
        } catch (t1) {
            l = !1;
        }
        i.addEventListener = function(t1, e1, i, o) {
            void 0 === o && (o = {}), t1.addEventListener(e1, i, "passive" in o && l ? o : o.capture);
        }, i.removeEventListener = function(t1, e1, i, o) {
            void 0 === o && (o = {}), t1.removeEventListener(e1, i, "passive" in o && l ? o : o.capture);
        };
        var u = function(e1) {
            e1.preventDefault(), e1.stopPropagation(), t1.window.removeEventListener("click", u, !0);
        };
        function h(t1) {
            var e1 = t1.userImage;
            return !!(e1 && e1.render && e1.render()) && (t1.data.replace(new Uint8Array(e1.data.buffer)), !0);
        }
        i.suppressClick = function() {
            t1.window.addEventListener("click", u, !0), t1.window.setTimeout(function() {
                t1.window.removeEventListener("click", u, !0);
            }, 0);
        }, i.mousePos = function(e1, i) {
            var o = e1.getBoundingClientRect();
            return new t1.Point(i.clientX - o.left - e1.clientLeft, i.clientY - o.top - e1.clientTop);
        }, i.touchPos = function(e1, i) {
            for(var o = e1.getBoundingClientRect(), r = [], a = 0; a < i.length; a++)r.push(new t1.Point(i[a].clientX - o.left - e1.clientLeft, i[a].clientY - o.top - e1.clientTop));
            return r;
        }, i.mouseButton = function(e1) {
            return void 0 !== t1.window.InstallTrigger && 2 === e1.button && e1.ctrlKey && t1.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e1.button;
        }, i.remove = function(t1) {
            t1.parentNode && t1.parentNode.removeChild(t1);
        };
        var p = function(e1) {
            function i() {
                e1.call(this), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t1.RGBAImage({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.isLoaded = function() {
                return this.loaded;
            }, i.prototype.setLoaded = function(t1) {
                if (this.loaded !== t1 && (this.loaded = t1, t1)) {
                    for(var e1 = 0, i = this.requestors; e1 < i.length; e1 += 1){
                        var o = i[e1];
                        this._notify(o.ids, o.callback);
                    }
                    this.requestors = [];
                }
            }, i.prototype.getImage = function(t1) {
                return this.images[t1];
            }, i.prototype.addImage = function(t1, e1) {
                this._validate(t1, e1) && (this.images[t1] = e1);
            }, i.prototype._validate = function(e1, i) {
                var o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchX" value'))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchY" value'))), o = !1), this._validateContent(i.content, i) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "content" value'))), o = !1), o;
            }, i.prototype._validateStretch = function(t1, e1) {
                if (!t1) return !0;
                for(var i = 0, o = 0, r = t1; o < r.length; o += 1){
                    var a = r[o];
                    if (a[0] < i || a[1] < a[0] || e1 < a[1]) return !1;
                    i = a[1];
                }
                return !0;
            }, i.prototype._validateContent = function(t1, e1) {
                return !(t1 && (4 !== t1.length || t1[0] < 0 || e1.data.width < t1[0] || t1[1] < 0 || e1.data.height < t1[1] || t1[2] < 0 || e1.data.width < t1[2] || t1[3] < 0 || e1.data.height < t1[3] || t1[2] < t1[0] || t1[3] < t1[1]));
            }, i.prototype.updateImage = function(t1, e1) {
                e1.version = this.images[t1].version + 1, this.images[t1] = e1, this.updatedImages[t1] = !0;
            }, i.prototype.removeImage = function(t1) {
                var e1 = this.images[t1];
                delete this.images[t1], delete this.patterns[t1], e1.userImage && e1.userImage.onRemove && e1.userImage.onRemove();
            }, i.prototype.listImages = function() {
                return Object.keys(this.images);
            }, i.prototype.getImages = function(t1, e1) {
                var i = !0;
                if (!this.isLoaded()) for(var o = 0, r = t1; o < r.length; o += 1)this.images[r[o]] || (i = !1);
                this.isLoaded() || i ? this._notify(t1, e1) : this.requestors.push({
                    ids: t1,
                    callback: e1
                });
            }, i.prototype._notify = function(e1, i) {
                for(var o = {}, r = 0, a = e1; r < a.length; r += 1){
                    var n = a[r];
                    this.images[n] || this.fire(new t1.Event("styleimagemissing", {
                        id: n
                    }));
                    var s = this.images[n];
                    s ? o[n] = {
                        data: s.data.clone(),
                        pixelRatio: s.pixelRatio,
                        sdf: s.sdf,
                        version: s.version,
                        stretchX: s.stretchX,
                        stretchY: s.stretchY,
                        content: s.content,
                        hasRenderCallback: Boolean(s.userImage && s.userImage.render)
                    } : t1.warnOnce('Image "' + n + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
                }
                i(null, o);
            }, i.prototype.getPixelSize = function() {
                var t1 = this.atlasImage;
                return {
                    width: t1.width,
                    height: t1.height
                };
            }, i.prototype.getPattern = function(e1) {
                var i = this.patterns[e1], o = this.getImage(e1);
                if (!o) return null;
                if (i && i.position.version === o.version) return i.position;
                if (i) i.position.version = o.version;
                else {
                    var r = {
                        w: o.data.width + 2,
                        h: o.data.height + 2,
                        x: 0,
                        y: 0
                    }, a = new t1.ImagePosition(r, o);
                    this.patterns[e1] = {
                        bin: r,
                        position: a
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e1].position;
            }, i.prototype.bind = function(e1) {
                var i = e1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t1.Texture(e1, this.atlasImage, i.RGBA), this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }, i.prototype._updatePatternAtlas = function() {
                var e1 = [];
                for(var i in this.patterns)e1.push(this.patterns[i].bin);
                var o = t1.potpack(e1), r = o.w, a = o.h, n = this.atlasImage;
                for(var s in n.resize({
                    width: r || 1,
                    height: a || 1
                }), this.patterns){
                    var l = this.patterns[s].bin, c = l.x + 1, u = l.y + 1, h = this.images[s].data, p = h.width, d = h.height;
                    t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: c,
                        y: u
                    }, {
                        width: p,
                        height: d
                    }), t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: d - 1
                    }, {
                        x: c,
                        y: u - 1
                    }, {
                        width: p,
                        height: 1
                    }), t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: c,
                        y: u + d
                    }, {
                        width: p,
                        height: 1
                    }), t1.RGBAImage.copy(h, n, {
                        x: p - 1,
                        y: 0
                    }, {
                        x: c - 1,
                        y: u
                    }, {
                        width: 1,
                        height: d
                    }), t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: c + p,
                        y: u
                    }, {
                        width: 1,
                        height: d
                    });
                }
                this.dirty = !0;
            }, i.prototype.beginFrame = function() {
                this.callbackDispatchedThisFrame = {};
            }, i.prototype.dispatchRenderCallbacks = function(t1) {
                for(var e1 = 0, i = t1; e1 < i.length; e1 += 1){
                    var o = i[e1];
                    if (!this.callbackDispatchedThisFrame[o]) {
                        this.callbackDispatchedThisFrame[o] = !0;
                        var r = this.images[o];
                        h(r) && this.updateImage(o, r);
                    }
                }
            }, i;
        }(t1.Evented), d = m, _ = m, f = 1e20;
        function m(t1, e1, i, o, r, a) {
            this.fontSize = t1 || 24, this.buffer = void 0 === e1 ? 3 : e1, this.cutoff = o || .25, this.fontFamily = r || "sans-serif", this.fontWeight = a || "normal", this.radius = i || 8;
            var n = this.size = this.fontSize + 2 * this.buffer;
            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = n, this.ctx = this.canvas.getContext("2d"), this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.d = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Int16Array(n), this.middle = Math.round(n / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
        }
        function g(t1, e1, i, o, r, a, n) {
            for(var s = 0; s < e1; s++){
                for(var l = 0; l < i; l++)o[l] = t1[l * e1 + s];
                for(v(o, r, a, n, i), l = 0; l < i; l++)t1[l * e1 + s] = r[l];
            }
            for(l = 0; l < i; l++){
                for(s = 0; s < e1; s++)o[s] = t1[l * e1 + s];
                for(v(o, r, a, n, e1), s = 0; s < e1; s++)t1[l * e1 + s] = Math.sqrt(r[s]);
            }
        }
        function v(t1, e1, i, o, r) {
            i[0] = 0, o[0] = -f, o[1] = +f;
            for(var a = 1, n = 0; a < r; a++){
                for(var s = (t1[a] + a * a - (t1[i[n]] + i[n] * i[n])) / (2 * a - 2 * i[n]); s <= o[n];)n--, s = (t1[a] + a * a - (t1[i[n]] + i[n] * i[n])) / (2 * a - 2 * i[n]);
                i[++n] = a, o[n] = s, o[n + 1] = +f;
            }
            for(a = 0, n = 0; a < r; a++){
                for(; o[n + 1] < a;)n++;
                e1[a] = (a - i[n]) * (a - i[n]) + t1[i[n]];
            }
        }
        m.prototype.draw = function(t1) {
            this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.fillText(t1, this.buffer, this.middle);
            for(var e1 = this.ctx.getImageData(0, 0, this.size, this.size), i = new Uint8ClampedArray(this.size * this.size), o = 0; o < this.size * this.size; o++){
                var r = e1.data[4 * o + 3] / 255;
                this.gridOuter[o] = 1 === r ? 0 : 0 === r ? f : Math.pow(Math.max(0, .5 - r), 2), this.gridInner[o] = 1 === r ? f : 0 === r ? 0 : Math.pow(Math.max(0, r - .5), 2);
            }
            for(g(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z), g(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z), o = 0; o < this.size * this.size; o++)i[o] = Math.max(0, Math.min(255, Math.round(255 - 255 * ((this.gridOuter[o] - this.gridInner[o]) / this.radius + this.cutoff))));
            return i;
        }, d.default = _;
        var y = function(t1, e1) {
            this.requestManager = t1, this.localIdeographFontFamily = e1, this.entries = {};
        };
        y.prototype.setURL = function(t1) {
            this.url = t1;
        }, y.prototype.getGlyphs = function(e1, i) {
            var o = this, r = [];
            for(var a in e1)for(var n = 0, s = e1[a]; n < s.length; n += 1)r.push({
                stack: a,
                id: s[n]
            });
            t1.asyncAll(r, function(t1, e1) {
                var i = t1.stack, r = t1.id, a = o.entries[i];
                a || (a = o.entries[i] = {
                    glyphs: {},
                    requests: {},
                    ranges: {}
                });
                var n = a.glyphs[r];
                if (void 0 === n) {
                    if (n = o._tinySDF(a, i, r)) return a.glyphs[r] = n, void e1(null, {
                        stack: i,
                        id: r,
                        glyph: n
                    });
                    var s = Math.floor(r / 256);
                    if (256 * s > 65535) e1(new Error("glyphs > 65535 not supported"));
                    else if (a.ranges[s]) e1(null, {
                        stack: i,
                        id: r,
                        glyph: n
                    });
                    else {
                        var l = a.requests[s];
                        l || (l = a.requests[s] = [], y.loadGlyphRange(i, s, o.url, o.requestManager, function(t1, e1) {
                            if (e1) {
                                for(var i in e1)o._doesCharSupportLocalGlyph(+i) || (a.glyphs[+i] = e1[+i]);
                                a.ranges[s] = !0;
                            }
                            for(var r = 0, n = l; r < n.length; r += 1)(0, n[r])(t1, e1);
                            delete a.requests[s];
                        })), l.push(function(t1, o) {
                            t1 ? e1(t1) : o && e1(null, {
                                stack: i,
                                id: r,
                                glyph: o[r] || null
                            });
                        });
                    }
                } else e1(null, {
                    stack: i,
                    id: r,
                    glyph: n
                });
            }, function(t1, e1) {
                if (t1) i(t1);
                else if (e1) {
                    for(var o = {}, r = 0, a = e1; r < a.length; r += 1){
                        var n = a[r], s = n.stack, l = n.id, c = n.glyph;
                        (o[s] || (o[s] = {}))[l] = c && {
                            id: c.id,
                            bitmap: c.bitmap.clone(),
                            metrics: c.metrics
                        };
                    }
                    i(null, o);
                }
            });
        }, y.prototype._doesCharSupportLocalGlyph = function(e1) {
            return !!this.localIdeographFontFamily && (t1.isChar["CJK Unified Ideographs"](e1) || t1.isChar["Hangul Syllables"](e1) || t1.isChar.Hiragana(e1) || t1.isChar.Katakana(e1));
        }, y.prototype._tinySDF = function(e1, i, o) {
            var r = this.localIdeographFontFamily;
            if (r && this._doesCharSupportLocalGlyph(o)) {
                var a = e1.tinySDF;
                if (!a) {
                    var n = "400";
                    /bold/i.test(i) ? n = "900" : /medium/i.test(i) ? n = "500" : /light/i.test(i) && (n = "200"), a = e1.tinySDF = new y.TinySDF(24, 3, 8, .25, r, n);
                }
                return {
                    id: o,
                    bitmap: new t1.AlphaImage({
                        width: 30,
                        height: 30
                    }, a.draw(String.fromCharCode(o))),
                    metrics: {
                        width: 24,
                        height: 24,
                        left: 0,
                        top: -8,
                        advance: 24
                    }
                };
            }
        }, y.loadGlyphRange = function(e1, i, o, r, a) {
            var n = 256 * i, s = n + 255, l = r.transformRequest(r.normalizeGlyphsURL(o).replace("{fontstack}", e1).replace("{range}", n + "-" + s), t1.ResourceType.Glyphs);
            t1.getArrayBuffer(l, function(e1, i) {
                if (e1) a(e1);
                else if (i) {
                    for(var o = {}, r = 0, n = t1.parseGlyphPBF(i); r < n.length; r += 1){
                        var s = n[r];
                        o[s.id] = s;
                    }
                    a(null, o);
                }
            });
        }, y.TinySDF = d;
        var x = function() {
            this.specification = t1.styleSpec.light.position;
        };
        x.prototype.possiblyEvaluate = function(e1, i) {
            return t1.sphericalToCartesian(e1.expression.evaluate(i));
        }, x.prototype.interpolate = function(e1, i, o) {
            return {
                x: t1.number(e1.x, i.x, o),
                y: t1.number(e1.y, i.y, o),
                z: t1.number(e1.z, i.z, o)
            };
        };
        var b = new t1.Properties({
            anchor: new t1.DataConstantProperty(t1.styleSpec.light.anchor),
            position: new x,
            color: new t1.DataConstantProperty(t1.styleSpec.light.color),
            intensity: new t1.DataConstantProperty(t1.styleSpec.light.intensity)
        }), w = function(e1) {
            function i(i) {
                e1.call(this), this._transitionable = new t1.Transitionable(b), this.setLight(i), this._transitioning = this._transitionable.untransitioned();
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getLight = function() {
                return this._transitionable.serialize();
            }, i.prototype.setLight = function(e1, i) {
                if (void 0 === i && (i = {}), !this._validate(t1.validateLight, e1, i)) for(var o in e1){
                    var r = e1[o];
                    t1.endsWith(o, "-transition") ? this._transitionable.setTransition(o.slice(0, -11), r) : this._transitionable.setValue(o, r);
                }
            }, i.prototype.updateTransitions = function(t1) {
                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
            }, i.prototype.hasTransition = function() {
                return this._transitioning.hasTransition();
            }, i.prototype.recalculate = function(t1) {
                this.properties = this._transitioning.possiblyEvaluate(t1);
            }, i.prototype._validate = function(e1, i, o) {
                return (!o || !1 !== o.validate) && t1.emitValidationErrors(this, e1.call(t1.validateStyle, t1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t1.styleSpec
                })));
            }, i;
        }(t1.Evented), T = function(t1, e1) {
            this.width = t1, this.height = e1, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
        };
        T.prototype.getDash = function(t1, e1) {
            var i = t1.join(",") + String(e1);
            return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(t1, e1)), this.dashEntry[i];
        }, T.prototype.getDashRanges = function(t1, e1, i) {
            var o = [], r = t1.length % 2 == 1 ? -t1[t1.length - 1] * i : 0, a = t1[0] * i, n = !0;
            o.push({
                left: r,
                right: a,
                isDash: n,
                zeroLength: 0 === t1[0]
            });
            for(var s = t1[0], l = 1; l < t1.length; l++){
                var c = t1[l];
                o.push({
                    left: r = s * i,
                    right: a = (s += c) * i,
                    isDash: n = !n,
                    zeroLength: 0 === c
                });
            }
            return o;
        }, T.prototype.addRoundDash = function(t1, e1, i) {
            for(var o = e1 / 2, r = -i; r <= i; r++)for(var a = this.width * (this.nextRow + i + r), n = 0, s = t1[n], l = 0; l < this.width; l++){
                l / s.right > 1 && (s = t1[++n]);
                var c = Math.abs(l - s.left), u = Math.abs(l - s.right), h = Math.min(c, u), p = void 0, d = r / i * (o + 1);
                if (s.isDash) {
                    var _ = o - Math.abs(d);
                    p = Math.sqrt(h * h + _ * _);
                } else p = o - Math.sqrt(h * h + d * d);
                this.data[a + l] = Math.max(0, Math.min(255, p + 128));
            }
        }, T.prototype.addRegularDash = function(t1) {
            for(var e1 = t1.length - 1; e1 >= 0; --e1){
                var i = t1[e1], o = t1[e1 + 1];
                i.zeroLength ? t1.splice(e1, 1) : o && o.isDash === i.isDash && (o.left = i.left, t1.splice(e1, 1));
            }
            var r = t1[0], a = t1[t1.length - 1];
            r.isDash === a.isDash && (r.left = a.left - this.width, a.right = r.right + this.width);
            for(var n = this.width * this.nextRow, s = 0, l = t1[s], c = 0; c < this.width; c++){
                c / l.right > 1 && (l = t1[++s]);
                var u = Math.abs(c - l.left), h = Math.abs(c - l.right), p = Math.min(u, h);
                this.data[n + c] = Math.max(0, Math.min(255, (l.isDash ? p : -p) + 128));
            }
        }, T.prototype.addDash = function(e1, i) {
            var o = i ? 7 : 0, r = 2 * o + 1;
            if (this.nextRow + r > this.height) return t1.warnOnce("LineAtlas out of space"), null;
            for(var a = 0, n = 0; n < e1.length; n++)a += e1[n];
            if (0 !== a) {
                var s = this.width / a, l = this.getDashRanges(e1, this.width, s);
                i ? this.addRoundDash(l, s, o) : this.addRegularDash(l);
            }
            var c = {
                y: (this.nextRow + o + .5) / this.height,
                height: 2 * o / this.height,
                width: a
            };
            return this.nextRow += r, this.dirty = !0, c;
        }, T.prototype.bind = function(t1) {
            var e1 = t1.gl;
            this.texture ? (e1.bindTexture(e1.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e1.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, this.width, this.height, e1.ALPHA, e1.UNSIGNED_BYTE, this.data))) : (this.texture = e1.createTexture(), e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, e1.LINEAR), e1.texImage2D(e1.TEXTURE_2D, 0, e1.ALPHA, this.width, this.height, 0, e1.ALPHA, e1.UNSIGNED_BYTE, this.data));
        };
        var E = function e1(i, o) {
            this.workerPool = i, this.actors = [], this.currentActor = 0, this.id = t1.uniqueId();
            for(var r = this.workerPool.acquire(this.id), a = 0; a < r.length; a++){
                var n = new e1.Actor(r[a], o, this.id);
                n.name = "Worker " + a, this.actors.push(n);
            }
        };
        function I(e1, i, o) {
            var r = function(r, a) {
                if (r) return o(r);
                if (a) {
                    var n = t1.pick(t1.extend(a, e1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    a.vector_layers && (n.vectorLayers = a.vector_layers, n.vectorLayerIds = n.vectorLayers.map(function(t1) {
                        return t1.id;
                    })), n.tiles = i.canonicalizeTileset(n, e1.url), o(null, n);
                }
            };
            return e1.url ? t1.getJSON(i.transformRequest(i.normalizeSourceURL(e1.url), t1.ResourceType.Source), r) : t1.browser.frame(function() {
                return r(null, e1);
            });
        }
        E.prototype.broadcast = function(e1, i, o) {
            t1.asyncAll(this.actors, function(t1, o) {
                t1.send(e1, i, o);
            }, o = o || function() {});
        }, E.prototype.getActor = function() {
            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
        }, E.prototype.remove = function() {
            this.actors.forEach(function(t1) {
                t1.remove();
            }), this.actors = [], this.workerPool.release(this.id);
        }, E.Actor = t1.Actor;
        var P = function(e1, i, o) {
            this.bounds = t1.LngLatBounds.convert(this.validateBounds(e1)), this.minzoom = i || 0, this.maxzoom = o || 24;
        };
        P.prototype.validateBounds = function(t1) {
            return Array.isArray(t1) && 4 === t1.length ? [
                Math.max(-180, t1[0]),
                Math.max(-90, t1[1]),
                Math.min(180, t1[2]),
                Math.min(90, t1[3])
            ] : [
                -180,
                -90,
                180,
                90
            ];
        }, P.prototype.contains = function(e1) {
            var i = Math.pow(2, e1.z), o = Math.floor(t1.mercatorXfromLng(this.bounds.getWest()) * i), r = Math.floor(t1.mercatorYfromLat(this.bounds.getNorth()) * i), a = Math.ceil(t1.mercatorXfromLng(this.bounds.getEast()) * i), n = Math.ceil(t1.mercatorYfromLat(this.bounds.getSouth()) * i);
            return e1.x >= o && e1.x < a && e1.y >= r && e1.y < n;
        };
        var S = function(e1) {
            function i(i, o, r, a) {
                if (e1.call(this), this.id = i, this.dispatcher = r, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t1.extend(this, t1.pick(o, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = t1.extend({
                    type: "vector"
                }, o), this._collectResourceTiming = o.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(a);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = I(this._options, this.map._requestManager, function(i, o) {
                    e1._tileJSONRequest = null, e1._loaded = !0, i ? e1.fire(new t1.ErrorEvent(i)) : o && (t1.extend(e1, o), o.bounds && (e1.tileBounds = new P(o.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(o.tiles, e1.map._requestManager._customAccessToken), t1.postMapLoadEvent(o.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken, e1.map._requestManager._customAccessToken), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.hasTile = function(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.setSourceProperty = function(t1) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t1(), this.map.style.sourceCaches[this.id].clearTiles(), this.load();
            }, i.prototype.setTiles = function(t1) {
                var e1 = this;
                return this.setSourceProperty(function() {
                    e1._options.tiles = t1;
                }), this;
            }, i.prototype.setUrl = function(t1) {
                var e1 = this;
                return this.setSourceProperty(function() {
                    e1.url = t1, e1._options.url = t1;
                }), this;
            }, i.prototype.onRemove = function() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }, i.prototype.serialize = function() {
                return t1.extend({}, this._options);
            }, i.prototype.loadTile = function(e1, i) {
                var o = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                    request: this.map._requestManager.transformRequest(o, t1.ResourceType.Tile),
                    uid: e1.uid,
                    tileID: e1.tileID,
                    zoom: e1.tileID.overscaledZ,
                    tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    pixelRatio: t1.browser.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                function a(o, r) {
                    return delete e1.request, e1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (r && r.resourceTiming && (e1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && e1.setExpiryData(r), e1.loadVectorData(r, this.map.painter), t1.cacheEntryPossiblyAdded(this.dispatcher), i(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null)));
                }
                r.request.collectResourceTiming = this._collectResourceTiming, e1.actor && "expired" !== e1.state ? "loading" === e1.state ? e1.reloadCallback = i : e1.request = e1.actor.send("reloadTile", r, a.bind(this)) : (e1.actor = this.dispatcher.getActor(), e1.request = e1.actor.send("loadTile", r, a.bind(this)));
            }, i.prototype.abortTile = function(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.actor && t1.actor.send("abortTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }, i.prototype.unloadTile = function(t1) {
                t1.unloadVectorData(), t1.actor && t1.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), C = function(e1) {
            function i(i, o, r, a) {
                e1.call(this), this.id = i, this.dispatcher = r, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t1.extend({
                    type: "raster"
                }, o), t1.extend(this, t1.pick(o, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = I(this._options, this.map._requestManager, function(i, o) {
                    e1._tileJSONRequest = null, e1._loaded = !0, i ? e1.fire(new t1.ErrorEvent(i)) : o && (t1.extend(e1, o), o.bounds && (e1.tileBounds = new P(o.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(o.tiles), t1.postMapLoadEvent(o.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.onRemove = function() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }, i.prototype.serialize = function() {
                return t1.extend({}, this._options);
            }, i.prototype.hasTile = function(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }, i.prototype.loadTile = function(e1, i) {
                var o = this, r = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                e1.request = t1.getImage(this.map._requestManager.transformRequest(r, t1.ResourceType.Tile), function(r, a) {
                    if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                    else if (r) e1.state = "errored", i(r);
                    else if (a) {
                        o.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                        var n = o.map.painter.context, s = n.gl;
                        e1.texture = o.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                            useMipmap: !0
                        }) : (e1.texture = new t1.Texture(n, a, s.RGBA, {
                            useMipmap: !0
                        }), e1.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_NEAREST), n.extTextureFilterAnisotropic && s.texParameterf(s.TEXTURE_2D, n.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, n.extTextureFilterAnisotropicMax)), e1.state = "loaded", t1.cacheEntryPossiblyAdded(o.dispatcher), i(null);
                    }
                });
            }, i.prototype.abortTile = function(t1, e1) {
                t1.request && (t1.request.cancel(), delete t1.request), e1();
            }, i.prototype.unloadTile = function(t1, e1) {
                t1.texture && this.map.painter.saveTileTexture(t1.texture), e1();
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), z = function(e1) {
            function i(i, o, r, a) {
                e1.call(this, i, o, r, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t1.extend({
                    type: "raster-dem"
                }, o), this.encoding = o.encoding || "mapbox";
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.serialize = function() {
                return {
                    type: "raster-dem",
                    url: this.url,
                    tileSize: this.tileSize,
                    tiles: this.tiles,
                    bounds: this.bounds,
                    encoding: this.encoding
                };
            }, i.prototype.loadTile = function(e1, i) {
                var o = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                function r(t1, o) {
                    t1 && (e1.state = "errored", i(t1)), o && (e1.dem = o, e1.needsHillshadePrepare = !0, e1.state = "loaded", i(null));
                }
                e1.request = t1.getImage(this.map._requestManager.transformRequest(o, t1.ResourceType.Tile), (function(o, a) {
                    if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                    else if (o) e1.state = "errored", i(o);
                    else if (a) {
                        this.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                        var n = t1.window.ImageBitmap && a instanceof t1.window.ImageBitmap && t1.offscreenCanvasSupported() ? a : t1.browser.getImageData(a, 1), s = {
                            uid: e1.uid,
                            coord: e1.tileID,
                            source: this.id,
                            rawImageData: n,
                            encoding: this.encoding
                        };
                        e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", s, r.bind(this)));
                    }
                }).bind(this)), e1.neighboringTiles = this._getNeighboringTiles(e1.tileID);
            }, i.prototype._getNeighboringTiles = function(e1) {
                var i = e1.canonical, o = Math.pow(2, i.z), r = (i.x - 1 + o) % o, a = 0 === i.x ? e1.wrap - 1 : e1.wrap, n = (i.x + 1 + o) % o, s = i.x + 1 === o ? e1.wrap + 1 : e1.wrap, l = {};
                return l[new t1.OverscaledTileID(e1.overscaledZ, a, i.z, r, i.y).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, i.z, n, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t1.OverscaledTileID(e1.overscaledZ, a, i.z, r, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, i.z, n, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < o && (l[new t1.OverscaledTileID(e1.overscaledZ, a, i.z, r, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, i.z, n, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }, i.prototype.unloadTile = function(t1) {
                t1.demTexture && this.map.painter.saveTileTexture(t1.demTexture), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), t1.dem && delete t1.dem, delete t1.neighboringTiles, t1.state = "unloaded", t1.actor && t1.actor.send("removeDEMTile", {
                    uid: t1.uid,
                    source: this.id
                });
            }, i;
        }(C), D = function(e1) {
            function i(i, o, r, a) {
                e1.call(this), this.id = i, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._loaded = !1, this.actor = r.getActor(), this.setEventedParent(a), this._data = o.data, this._options = t1.extend({}, o), this._collectResourceTiming = o.collectResourceTiming, this._resourceTiming = [], void 0 !== o.maxzoom && (this.maxzoom = o.maxzoom), o.type && (this.type = o.type), o.attribution && (this.attribution = o.attribution), this.promoteId = o.promoteId;
                var n = t1.EXTENT / this.tileSize;
                this.workerOptions = t1.extend({
                    source: this.id,
                    cluster: o.cluster || !1,
                    geojsonVtOptions: {
                        buffer: (void 0 !== o.buffer ? o.buffer : 128) * n,
                        tolerance: (void 0 !== o.tolerance ? o.tolerance : .375) * n,
                        extent: t1.EXTENT,
                        maxZoom: this.maxzoom,
                        lineMetrics: o.lineMetrics || !1,
                        generateId: o.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== o.clusterMaxZoom ? Math.min(o.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                        minPoints: Math.max(2, o.clusterMinPoints || 2),
                        extent: t1.EXTENT,
                        radius: (o.clusterRadius || 50) * n,
                        log: !1,
                        generateId: o.generateId || !1
                    },
                    clusterProperties: o.clusterProperties,
                    filter: o.filter
                }, o.workerOptions);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._updateWorkerData(function(i) {
                    if (i) e1.fire(new t1.ErrorEvent(i));
                    else {
                        var o = {
                            dataType: "source",
                            sourceDataType: "metadata"
                        };
                        e1._collectResourceTiming && e1._resourceTiming && e1._resourceTiming.length > 0 && (o.resourceTiming = e1._resourceTiming, e1._resourceTiming = []), e1.fire(new t1.Event("data", o));
                    }
                });
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.setData = function(e1) {
                var i = this;
                return this._data = e1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._updateWorkerData(function(e1) {
                    if (e1) i.fire(new t1.ErrorEvent(e1));
                    else {
                        var o = {
                            dataType: "source",
                            sourceDataType: "content"
                        };
                        i._collectResourceTiming && i._resourceTiming && i._resourceTiming.length > 0 && (o.resourceTiming = i._resourceTiming, i._resourceTiming = []), i.fire(new t1.Event("data", o));
                    }
                }), this;
            }, i.prototype.getClusterExpansionZoom = function(t1, e1) {
                return this.actor.send("geojson.getClusterExpansionZoom", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }, i.prototype.getClusterChildren = function(t1, e1) {
                return this.actor.send("geojson.getClusterChildren", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }, i.prototype.getClusterLeaves = function(t1, e1, i, o) {
                return this.actor.send("geojson.getClusterLeaves", {
                    source: this.id,
                    clusterId: t1,
                    limit: e1,
                    offset: i
                }, o), this;
            }, i.prototype._updateWorkerData = function(e1) {
                var i = this;
                this._loaded = !1;
                var o = t1.extend({}, this.workerOptions), r = this._data;
                "string" == typeof r ? (o.request = this.map._requestManager.transformRequest(t1.browser.resolveURL(r), t1.ResourceType.Source), o.request.collectResourceTiming = this._collectResourceTiming) : o.data = JSON.stringify(r), this.actor.send(this.type + ".loadData", o, function(t1, r) {
                    i._removed || r && r.abandoned || (i._loaded = !0, r && r.resourceTiming && r.resourceTiming[i.id] && (i._resourceTiming = r.resourceTiming[i.id].slice(0)), i.actor.send(i.type + ".coalesce", {
                        source: o.source
                    }, null), e1(t1));
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.loadTile = function(e1, i) {
                var o = this, r = e1.actor ? "reloadTile" : "loadTile";
                e1.actor = this.actor, e1.request = this.actor.send(r, {
                    type: this.type,
                    uid: e1.uid,
                    tileID: e1.tileID,
                    zoom: e1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    tileSize: this.tileSize,
                    source: this.id,
                    pixelRatio: t1.browser.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                }, function(t1, a) {
                    return delete e1.request, e1.unloadVectorData(), e1.aborted ? i(null) : t1 ? i(t1) : (e1.loadVectorData(a, o.map.painter, "reloadTile" === r), i(null));
                });
            }, i.prototype.abortTile = function(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.aborted = !0;
            }, i.prototype.unloadTile = function(t1) {
                t1.unloadVectorData(), this.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                });
            }, i.prototype.onRemove = function() {
                this._removed = !0, this.actor.send("removeSource", {
                    type: this.type,
                    source: this.id
                });
            }, i.prototype.serialize = function() {
                return t1.extend({}, this._options, {
                    type: this.type,
                    data: this._data
                });
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), A = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]), M = function(e1) {
            function i(t1, i, o, r) {
                e1.call(this), this.id = t1, this.dispatcher = o, this.coordinates = i.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(r), this.options = i;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function(e1, i) {
                var o = this;
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, t1.getImage(this.map._requestManager.transformRequest(this.url, t1.ResourceType.Image), function(r, a) {
                    o._loaded = !0, r ? o.fire(new t1.ErrorEvent(r)) : a && (o.image = a, e1 && (o.coordinates = e1), i && i(), o._finishLoading());
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.updateImage = function(t1) {
                var e1 = this;
                return this.image && t1.url ? (this.options.url = t1.url, this.load(t1.coordinates, function() {
                    e1.texture = null;
                }), this) : this;
            }, i.prototype._finishLoading = function() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.setCoordinates = function(e1) {
                var i = this;
                this.coordinates = e1;
                var o = e1.map(t1.MercatorCoordinate.fromLngLat);
                this.tileID = function(e1) {
                    for(var i = 1 / 0, o = 1 / 0, r = -1 / 0, a = -1 / 0, n = 0, s = e1; n < s.length; n += 1){
                        var l = s[n];
                        i = Math.min(i, l.x), o = Math.min(o, l.y), r = Math.max(r, l.x), a = Math.max(a, l.y);
                    }
                    var c = Math.max(r - i, a - o), u = Math.max(0, Math.floor(-Math.log(c) / Math.LN2)), h = Math.pow(2, u);
                    return new t1.CanonicalTileID(u, Math.floor((i + r) / 2 * h), Math.floor((o + a) / 2 * h));
                }(o), this.minzoom = this.maxzoom = this.tileID.z;
                var r = o.map(function(t1) {
                    return i.tileID.getTilePoint(t1)._round();
                });
                return this._boundsArray = new t1.StructArrayLayout4i8, this._boundsArray.emplaceBack(r[0].x, r[0].y, 0, 0), this._boundsArray.emplaceBack(r[1].x, r[1].y, t1.EXTENT, 0), this._boundsArray.emplaceBack(r[3].x, r[3].y, 0, t1.EXTENT), this._boundsArray.emplaceBack(r[2].x, r[2].y, t1.EXTENT, t1.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }, i.prototype.prepare = function() {
                if (0 !== Object.keys(this.tiles).length && this.image) {
                    var e1 = this.map.painter.context, i = e1.gl;
                    for(var o in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, A.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new t1.Texture(e1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this.tiles){
                        var r = this.tiles[o];
                        "loaded" !== r.state && (r.state = "loaded", r.texture = this.texture);
                    }
                }
            }, i.prototype.loadTile = function(t1, e1) {
                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e1(null)) : (t1.state = "errored", e1(null));
            }, i.prototype.serialize = function() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), L = function(e1) {
            function i(t1, i, o, r) {
                e1.call(this, t1, i, o, r), this.roundZoom = !0, this.type = "video", this.options = i;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this._loaded = !1;
                var i = this.options;
                this.urls = [];
                for(var o = 0, r = i.urls; o < r.length; o += 1)this.urls.push(this.map._requestManager.transformRequest(r[o], t1.ResourceType.Source).url);
                t1.getVideo(this.urls, function(i, o) {
                    e1._loaded = !0, i ? e1.fire(new t1.ErrorEvent(i)) : o && (e1.video = o, e1.video.loop = !0, e1.video.setAttribute("playsinline", ""), e1.video.addEventListener("playing", function() {
                        e1.map.triggerRepaint();
                    }), e1.map && e1.video.play(), e1._finishLoading());
                });
            }, i.prototype.pause = function() {
                this.video && this.video.pause();
            }, i.prototype.play = function() {
                this.video && this.video.play();
            }, i.prototype.seek = function(e1) {
                if (this.video) {
                    var i = this.video.seekable;
                    e1 < i.start(0) || e1 > i.end(0) ? this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + this.id, null, "Playback for this video can be set only between the " + i.start(0) + " and " + i.end(0) + "-second mark."))) : this.video.currentTime = e1;
                }
            }, i.prototype.getVideo = function() {
                return this.video;
            }, i.prototype.onAdd = function(t1) {
                this.map || (this.map = t1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }, i.prototype.prepare = function() {
                if (!(0 === Object.keys(this.tiles).length || this.video.readyState < 2)) {
                    var e1 = this.map.painter.context, i = e1.gl;
                    for(var o in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, A.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new t1.Texture(e1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this.tiles){
                        var r = this.tiles[o];
                        "loaded" !== r.state && (r.state = "loaded", r.texture = this.texture);
                    }
                }
            }, i.prototype.serialize = function() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }, i.prototype.hasTransition = function() {
                return this.video && !this.video.paused;
            }, i;
        }(M), R = function(e1) {
            function i(i, o, r, a) {
                e1.call(this, i, o, r, a), o.coordinates ? Array.isArray(o.coordinates) && 4 === o.coordinates.length && !o.coordinates.some(function(t1) {
                    return !Array.isArray(t1) || 2 !== t1.length || t1.some(function(t1) {
                        return "number" != typeof t1;
                    });
                }) || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, 'missing required property "coordinates"'))), o.animate && "boolean" != typeof o.animate && this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, 'optional "animate" property must be a boolean value'))), o.canvas ? "string" == typeof o.canvas || o.canvas instanceof t1.window.HTMLCanvasElement || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, 'missing required property "canvas"'))), this.options = o, this.animate = void 0 === o.animate || o.animate;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof t1.window.HTMLCanvasElement ? this.options.canvas : t1.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                    this._playing = !0, this.map.triggerRepaint();
                }, this.pause = function() {
                    this._playing && (this.prepare(), this._playing = !1);
                }, this._finishLoading());
            }, i.prototype.getCanvas = function() {
                return this.canvas;
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load(), this.canvas && this.animate && this.play();
            }, i.prototype.onRemove = function() {
                this.pause();
            }, i.prototype.prepare = function() {
                var e1 = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), !this._hasInvalidDimensions() && 0 !== Object.keys(this.tiles).length) {
                    var i = this.map.painter.context, o = i.gl;
                    for(var r in this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, A.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new t1.Texture(i, this.canvas, o.RGBA, {
                        premultiply: !0
                    }), this.tiles){
                        var a = this.tiles[r];
                        "loaded" !== a.state && (a.state = "loaded", a.texture = this.texture);
                    }
                }
            }, i.prototype.serialize = function() {
                return {
                    type: "canvas",
                    coordinates: this.coordinates
                };
            }, i.prototype.hasTransition = function() {
                return this._playing;
            }, i.prototype._hasInvalidDimensions = function() {
                for(var t1 = 0, e1 = [
                    this.canvas.width,
                    this.canvas.height
                ]; t1 < e1.length; t1 += 1){
                    var i = e1[t1];
                    if (isNaN(i) || i <= 0) return !0;
                }
                return !1;
            }, i;
        }(M), k = {
            vector: S,
            raster: C,
            "raster-dem": z,
            geojson: D,
            video: L,
            image: M,
            canvas: R
        };
        function B(e1, i) {
            var o = t1.identity([]);
            return t1.translate(o, o, [
                1,
                1,
                0
            ]), t1.scale(o, o, [
                .5 * e1.width,
                .5 * e1.height,
                1
            ]), t1.multiply(o, o, e1.calculatePosMatrix(i.toUnwrapped()));
        }
        function O(t1, e1, i, o, r, a) {
            var n = function(t1, e1, i) {
                if (t1) for(var o = 0, r = t1; o < r.length; o += 1){
                    var a = e1[r[o]];
                    if (a && a.source === i && "fill-extrusion" === a.type) return !0;
                }
                else for(var n in e1){
                    var s = e1[n];
                    if (s.source === i && "fill-extrusion" === s.type) return !0;
                }
                return !1;
            }(r && r.layers, e1, t1.id), s = a.maxPitchScaleFactor(), l = t1.tilesIn(o, s, n);
            l.sort(F);
            for(var c = [], u = 0, h = l; u < h.length; u += 1){
                var p = h[u];
                c.push({
                    wrappedTileID: p.tileID.wrapped().key,
                    queryResults: p.tile.queryRenderedFeatures(e1, i, t1._state, p.queryGeometry, p.cameraQueryGeometry, p.scale, r, a, s, B(t1.transform, p.tileID))
                });
            }
            var d = function(t1) {
                for(var e1 = {}, i = {}, o = 0, r = t1; o < r.length; o += 1){
                    var a = r[o], n = a.queryResults, s = a.wrappedTileID, l = i[s] = i[s] || {};
                    for(var c in n)for(var u = n[c], h = l[c] = l[c] || {}, p = e1[c] = e1[c] || [], d = 0, _ = u; d < _.length; d += 1){
                        var f = _[d];
                        h[f.featureIndex] || (h[f.featureIndex] = !0, p.push(f));
                    }
                }
                return e1;
            }(c);
            for(var _ in d)d[_].forEach(function(e1) {
                var i = e1.feature, o = t1.getFeatureState(i.layer["source-layer"], i.id);
                i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
            });
            return d;
        }
        function F(t1, e1) {
            var i = t1.tileID, o = e1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        var U = function(t1, e1) {
            this.max = t1, this.onRemove = e1, this.reset();
        };
        U.prototype.reset = function() {
            for(var t1 in this.data)for(var e1 = 0, i = this.data[t1]; e1 < i.length; e1 += 1){
                var o = i[e1];
                o.timeout && clearTimeout(o.timeout), this.onRemove(o.value);
            }
            return this.data = {}, this.order = [], this;
        }, U.prototype.add = function(t1, e1, i) {
            var o = this, r = t1.wrapped().key;
            void 0 === this.data[r] && (this.data[r] = []);
            var a = {
                value: e1,
                timeout: void 0
            };
            if (void 0 !== i && (a.timeout = setTimeout(function() {
                o.remove(t1, a);
            }, i)), this.data[r].push(a), this.order.push(r), this.order.length > this.max) {
                var n = this._getAndRemoveByKey(this.order[0]);
                n && this.onRemove(n);
            }
            return this;
        }, U.prototype.has = function(t1) {
            return t1.wrapped().key in this.data;
        }, U.prototype.getAndRemove = function(t1) {
            return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
        }, U.prototype._getAndRemoveByKey = function(t1) {
            var e1 = this.data[t1].shift();
            return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
        }, U.prototype.getByKey = function(t1) {
            var e1 = this.data[t1];
            return e1 ? e1[0].value : null;
        }, U.prototype.get = function(t1) {
            return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
        }, U.prototype.remove = function(t1, e1) {
            if (!this.has(t1)) return this;
            var i = t1.wrapped().key, o = void 0 === e1 ? 0 : this.data[i].indexOf(e1), r = this.data[i][o];
            return this.data[i].splice(o, 1), r.timeout && clearTimeout(r.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(r.value), this.order.splice(this.order.indexOf(i), 1), this;
        }, U.prototype.setMaxSize = function(t1) {
            for(this.max = t1; this.order.length > this.max;){
                var e1 = this._getAndRemoveByKey(this.order[0]);
                e1 && this.onRemove(e1);
            }
            return this;
        }, U.prototype.filter = function(t1) {
            var e1 = [];
            for(var i in this.data)for(var o = 0, r = this.data[i]; o < r.length; o += 1){
                var a = r[o];
                t1(a.value) || e1.push(a);
            }
            for(var n = 0, s = e1; n < s.length; n += 1){
                var l = s[n];
                this.remove(l.value.tileID, l);
            }
        };
        var N = function(t1, e1, i) {
            this.context = t1;
            var o = t1.gl;
            this.buffer = o.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), t1.bindElementBuffer.set(this.buffer), o.bufferData(o.ELEMENT_ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? o.DYNAMIC_DRAW : o.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
        };
        N.prototype.bind = function() {
            this.context.bindElementBuffer.set(this.buffer);
        }, N.prototype.updateData = function(t1) {
            var e1 = this.context.gl;
            this.context.unbindVAO(), this.bind(), e1.bufferSubData(e1.ELEMENT_ARRAY_BUFFER, 0, t1.arrayBuffer);
        }, N.prototype.destroy = function() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        };
        var Z = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        }, q = function(t1, e1, i, o) {
            this.length = e1.length, this.attributes = i, this.itemSize = e1.bytesPerElement, this.dynamicDraw = o, this.context = t1;
            var r = t1.gl;
            this.buffer = r.createBuffer(), t1.bindVertexBuffer.set(this.buffer), r.bufferData(r.ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
        };
        q.prototype.bind = function() {
            this.context.bindVertexBuffer.set(this.buffer);
        }, q.prototype.updateData = function(t1) {
            var e1 = this.context.gl;
            this.bind(), e1.bufferSubData(e1.ARRAY_BUFFER, 0, t1.arrayBuffer);
        }, q.prototype.enableAttributes = function(t1, e1) {
            for(var i = 0; i < this.attributes.length; i++){
                var o = e1.attributes[this.attributes[i].name];
                void 0 !== o && t1.enableVertexAttribArray(o);
            }
        }, q.prototype.setVertexAttribPointers = function(t1, e1, i) {
            for(var o = 0; o < this.attributes.length; o++){
                var r = this.attributes[o], a = e1.attributes[r.name];
                void 0 !== a && t1.vertexAttribPointer(a, r.components, t1[Z[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0));
            }
        }, q.prototype.destroy = function() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        };
        var j = function(t1) {
            this.gl = t1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
        };
        j.prototype.get = function() {
            return this.current;
        }, j.prototype.set = function(t1) {}, j.prototype.getDefault = function() {
            return this.default;
        }, j.prototype.setDefault = function() {
            this.set(this.default);
        };
        var V = function(e1) {
            function i() {
                e1.apply(this, arguments);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getDefault = function() {
                return t1.Color.transparent;
            }, i.prototype.set = function(t1) {
                var e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.clearColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }, i;
        }(j), G = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 1;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearDepth(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), W = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 0;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearStencil(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), X = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.colorMask(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), H = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !0;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthMask(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), K = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 255;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.stencilMask(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), Y = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1.func !== e1.func || t1.ref !== e1.ref || t1.mask !== e1.mask || this.dirty) && (this.gl.stencilFunc(t1.func, t1.ref, t1.mask), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), J = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                var t1 = this.gl;
                return [
                    t1.KEEP,
                    t1.KEEP,
                    t1.KEEP
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || this.dirty) && (this.gl.stencilOp(t1[0], t1[1], t1[2]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), Q = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.STENCIL_TEST) : e1.disable(e1.STENCIL_TEST), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), $ = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return [
                    0,
                    1
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.depthRange(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), tt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.DEPTH_TEST) : e1.disable(e1.DEPTH_TEST), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), et = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.LESS;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthFunc(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), it = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.BLEND) : e1.disable(e1.BLEND), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), ot = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                var t1 = this.gl;
                return [
                    t1.ONE,
                    t1.ZERO
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.blendFunc(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), rt = function(e1) {
            function i() {
                e1.apply(this, arguments);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getDefault = function() {
                return t1.Color.transparent;
            }, i.prototype.set = function(t1) {
                var e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.blendColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }, i;
        }(j), at = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.FUNC_ADD;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.blendEquation(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), nt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.CULL_FACE) : e1.disable(e1.CULL_FACE), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), st = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.BACK;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.cullFace(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), lt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.CCW;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.frontFace(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), ct = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.useProgram(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), ut = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.TEXTURE0;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.activeTexture(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), ht = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                var t1 = this.gl;
                return [
                    0,
                    0,
                    t1.drawingBufferWidth,
                    t1.drawingBufferHeight
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.viewport(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), pt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindFramebuffer(e1.FRAMEBUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), dt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindRenderbuffer(e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), _t = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindTexture(e1.TEXTURE_2D, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), ft = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindBuffer(e1.ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), mt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                var e1 = this.gl;
                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
            }, e1;
        }(j), gt = function(t1) {
            function e1(e1) {
                t1.call(this, e1), this.vao = e1.extVertexArrayObject;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                this.vao && (t1 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), vt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 4;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.pixelStorei(e1.UNPACK_ALIGNMENT, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), yt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), xt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), bt = function(t1) {
            function e1(e1, i) {
                t1.call(this, e1), this.context = e1, this.parent = i;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1;
        }(j), wt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.setDirty = function() {
                this.dirty = !0;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    this.context.bindFramebuffer.set(this.parent);
                    var e1 = this.gl;
                    e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t1, 0), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(bt), Tt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    this.context.bindFramebuffer.set(this.parent);
                    var e1 = this.gl;
                    e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(bt), Et = function(t1, e1, i, o) {
            this.context = t1, this.width = e1, this.height = i;
            var r = this.framebuffer = t1.gl.createFramebuffer();
            this.colorAttachment = new wt(t1, r), o && (this.depthAttachment = new Tt(t1, r));
        };
        Et.prototype.destroy = function() {
            var t1 = this.context.gl, e1 = this.colorAttachment.get();
            if (e1 && t1.deleteTexture(e1), this.depthAttachment) {
                var i = this.depthAttachment.get();
                i && t1.deleteRenderbuffer(i);
            }
            t1.deleteFramebuffer(this.framebuffer);
        };
        var It = function(t1, e1, i) {
            this.func = t1, this.mask = e1, this.range = i;
        };
        It.ReadOnly = !1, It.ReadWrite = !0, It.disabled = new It(519, It.ReadOnly, [
            0,
            1
        ]);
        var Pt = function(t1, e1, i, o, r, a) {
            this.test = t1, this.ref = e1, this.mask = i, this.fail = o, this.depthFail = r, this.pass = a;
        };
        Pt.disabled = new Pt({
            func: 519,
            mask: 0
        }, 0, 0, 7680, 7680, 7680);
        var St = function(t1, e1, i) {
            this.blendFunction = t1, this.blendColor = e1, this.mask = i;
        };
        St.disabled = new St(St.Replace = [
            1,
            0
        ], t1.Color.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), St.unblended = new St(St.Replace, t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), St.alphaBlended = new St([
            1,
            771
        ], t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        var Ct = function(t1, e1, i) {
            this.enable = t1, this.mode = e1, this.frontFace = i;
        };
        Ct.disabled = new Ct(!1, 1029, 2305), Ct.backCCW = new Ct(!0, 1029, 2305);
        var zt = function(t1) {
            this.gl = t1, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new V(this), this.clearDepth = new G(this), this.clearStencil = new W(this), this.colorMask = new X(this), this.depthMask = new H(this), this.stencilMask = new K(this), this.stencilFunc = new Y(this), this.stencilOp = new J(this), this.stencilTest = new Q(this), this.depthRange = new $(this), this.depthTest = new tt(this), this.depthFunc = new et(this), this.blend = new it(this), this.blendFunc = new ot(this), this.blendColor = new rt(this), this.blendEquation = new at(this), this.cullFace = new nt(this), this.cullFaceSide = new st(this), this.frontFace = new lt(this), this.program = new ct(this), this.activeTexture = new ut(this), this.viewport = new ht(this), this.bindFramebuffer = new pt(this), this.bindRenderbuffer = new dt(this), this.bindTexture = new _t(this), this.bindVertexBuffer = new ft(this), this.bindElementBuffer = new mt(this), this.bindVertexArrayOES = this.extVertexArrayObject && new gt(this), this.pixelStoreUnpack = new vt(this), this.pixelStoreUnpackPremultiplyAlpha = new yt(this), this.pixelStoreUnpackFlipY = new xt(this), this.extTextureFilterAnisotropic = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureHalfFloat = t1.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (t1.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = t1.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = t1.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = t1.getParameter(t1.MAX_TEXTURE_SIZE);
        };
        zt.prototype.setDefault = function() {
            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
        }, zt.prototype.setDirty = function() {
            this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
        }, zt.prototype.createIndexBuffer = function(t1, e1) {
            return new N(this, t1, e1);
        }, zt.prototype.createVertexBuffer = function(t1, e1, i) {
            return new q(this, t1, e1, i);
        }, zt.prototype.createRenderbuffer = function(t1, e1, i) {
            var o = this.gl, r = o.createRenderbuffer();
            return this.bindRenderbuffer.set(r), o.renderbufferStorage(o.RENDERBUFFER, t1, e1, i), this.bindRenderbuffer.set(null), r;
        }, zt.prototype.createFramebuffer = function(t1, e1, i) {
            return new Et(this, t1, e1, i);
        }, zt.prototype.clear = function(t1) {
            var e1 = t1.color, i = t1.depth, o = this.gl, r = 0;
            e1 && (r |= o.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                !0,
                !0,
                !0,
                !0
            ])), void 0 !== i && (r |= o.DEPTH_BUFFER_BIT, this.depthRange.set([
                0,
                1
            ]), this.clearDepth.set(i), this.depthMask.set(!0)), o.clear(r);
        }, zt.prototype.setCullFace = function(t1) {
            !1 === t1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t1.mode), this.frontFace.set(t1.frontFace));
        }, zt.prototype.setDepthMode = function(t1) {
            t1.func !== this.gl.ALWAYS || t1.mask ? (this.depthTest.set(!0), this.depthFunc.set(t1.func), this.depthMask.set(t1.mask), this.depthRange.set(t1.range)) : this.depthTest.set(!1);
        }, zt.prototype.setStencilMode = function(t1) {
            t1.test.func !== this.gl.ALWAYS || t1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t1.mask), this.stencilOp.set([
                t1.fail,
                t1.depthFail,
                t1.pass
            ]), this.stencilFunc.set({
                func: t1.test.func,
                ref: t1.ref,
                mask: t1.test.mask
            })) : this.stencilTest.set(!1);
        }, zt.prototype.setColorMode = function(e1) {
            t1.deepEqual(e1.blendFunction, St.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
        }, zt.prototype.unbindVAO = function() {
            this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
        };
        var Dt = function(e1) {
            function i(i, o, r) {
                var a = this;
                e1.call(this), this.id = i, this.dispatcher = r, this.on("data", function(t1) {
                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (a._sourceLoaded = !0), a._sourceLoaded && !a._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (a.reload(), a.transform && a.update(a.transform));
                }), this.on("error", function() {
                    a._sourceErrored = !0;
                }), this._source = function(e1, i, o, r) {
                    var a = new k[i.type](e1, i, o, r);
                    if (a.id !== e1) throw new Error("Expected Source id to be " + e1 + " instead of " + a.id);
                    return t1.bindAll([
                        "load",
                        "abort",
                        "unload",
                        "serialize",
                        "prepare"
                    ], a), a;
                }(i, o, r, this), this._tiles = {}, this._cache = new U(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new t1.SourceFeatureState;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.onAdd = function(t1) {
                this.map = t1, this._maxTileCacheSize = t1 ? t1._maxTileCacheSize : null, this._source && this._source.onAdd && this._source.onAdd(t1);
            }, i.prototype.onRemove = function(t1) {
                this._source && this._source.onRemove && this._source.onRemove(t1);
            }, i.prototype.loaded = function() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(var t1 in this._tiles){
                    var e1 = this._tiles[t1];
                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                }
                return !0;
            }, i.prototype.getSource = function() {
                return this._source;
            }, i.prototype.pause = function() {
                this._paused = !0;
            }, i.prototype.resume = function() {
                if (this._paused) {
                    var t1 = this._shouldReloadOnResume;
                    this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform);
                }
            }, i.prototype._loadTile = function(t1, e1) {
                return this._source.loadTile(t1, e1);
            }, i.prototype._unloadTile = function(t1) {
                if (this._source.unloadTile) return this._source.unloadTile(t1, function() {});
            }, i.prototype._abortTile = function(t1) {
                if (this._source.abortTile) return this._source.abortTile(t1, function() {});
            }, i.prototype.serialize = function() {
                return this._source.serialize();
            }, i.prototype.prepare = function(t1) {
                for(var e1 in this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null), this._tiles){
                    var i = this._tiles[e1];
                    i.upload(t1), i.prepare(this.map.style.imageManager);
                }
            }, i.prototype.getIds = function() {
                return t1.values(this._tiles).map(function(t1) {
                    return t1.tileID;
                }).sort(At).map(function(t1) {
                    return t1.key;
                });
            }, i.prototype.getRenderableIds = function(e1) {
                var i = this, o = [];
                for(var r in this._tiles)this._isIdRenderable(r, e1) && o.push(this._tiles[r]);
                return e1 ? o.sort(function(e1, o) {
                    var r = e1.tileID, a = o.tileID, n = new t1.Point(r.canonical.x, r.canonical.y)._rotate(i.transform.angle), s = new t1.Point(a.canonical.x, a.canonical.y)._rotate(i.transform.angle);
                    return r.overscaledZ - a.overscaledZ || s.y - n.y || s.x - n.x;
                }).map(function(t1) {
                    return t1.tileID.key;
                }) : o.map(function(t1) {
                    return t1.tileID;
                }).sort(At).map(function(t1) {
                    return t1.key;
                });
            }, i.prototype.hasRenderableParent = function(t1) {
                var e1 = this.findLoadedParent(t1, 0);
                return !!e1 && this._isIdRenderable(e1.tileID.key);
            }, i.prototype._isIdRenderable = function(t1, e1) {
                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
            }, i.prototype.reload = function() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else for(var t1 in this._cache.reset(), this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(t1, "reloading");
            }, i.prototype._reloadTile = function(t1, e1) {
                var i = this._tiles[t1];
                i && ("loading" !== i.state && (i.state = e1), this._loadTile(i, this._tileLoaded.bind(this, i, t1, e1)));
            }, i.prototype._tileLoaded = function(e1, i, o, r) {
                if (r) return e1.state = "errored", void (404 !== r.status ? this._source.fire(new t1.ErrorEvent(r, {
                    tile: e1
                })) : this.update(this.transform));
                e1.timeAdded = t1.browser.now(), "expired" === o && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e1), "raster-dem" === this.getSource().type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._source.fire(new t1.Event("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID
                }));
            }, i.prototype._backfillDEM = function(t1) {
                for(var e1 = this.getRenderableIds(), i = 0; i < e1.length; i++){
                    var o = e1[i];
                    if (t1.neighboringTiles && t1.neighboringTiles[o]) {
                        var r = this.getTileByID(o);
                        a(t1, r), a(r, t1);
                    }
                }
                function a(t1, e1) {
                    t1.needsHillshadePrepare = !0;
                    var i = e1.tileID.canonical.x - t1.tileID.canonical.x, o = e1.tileID.canonical.y - t1.tileID.canonical.y, r = Math.pow(2, t1.tileID.canonical.z), a = e1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, i, o), t1.neighboringTiles && t1.neighboringTiles[a] && (t1.neighboringTiles[a].backfilled = !0)));
                }
            }, i.prototype.getTile = function(t1) {
                return this.getTileByID(t1.key);
            }, i.prototype.getTileByID = function(t1) {
                return this._tiles[t1];
            }, i.prototype._retainLoadedChildren = function(t1, e1, i, o) {
                for(var r in this._tiles){
                    var a = this._tiles[r];
                    if (!(o[r] || !a.hasData() || a.tileID.overscaledZ <= e1 || a.tileID.overscaledZ > i)) {
                        for(var n = a.tileID; a && a.tileID.overscaledZ > e1 + 1;){
                            var s = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                            (a = this._tiles[s.key]) && a.hasData() && (n = s);
                        }
                        for(var l = n; l.overscaledZ > e1;)if (t1[(l = l.scaledTo(l.overscaledZ - 1)).key]) {
                            o[n.key] = n;
                            break;
                        }
                    }
                }
            }, i.prototype.findLoadedParent = function(t1, e1) {
                if (t1.key in this._loadedParentTiles) {
                    var i = this._loadedParentTiles[t1.key];
                    return i && i.tileID.overscaledZ >= e1 ? i : null;
                }
                for(var o = t1.overscaledZ - 1; o >= e1; o--){
                    var r = t1.scaledTo(o), a = this._getLoadedTile(r);
                    if (a) return a;
                }
            }, i.prototype._getLoadedTile = function(t1) {
                var e1 = this._tiles[t1.key];
                return e1 && e1.hasData() ? e1 : this._cache.getByKey(t1.wrapped().key);
            }, i.prototype.updateCacheSize = function(t1) {
                var e1 = Math.ceil(t1.width / this._source.tileSize) + 1, i = Math.ceil(t1.height / this._source.tileSize) + 1, o = Math.floor(e1 * i * 5), r = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(r);
            }, i.prototype.handleWrapJump = function(t1) {
                var e1 = Math.round((t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360);
                if (this._prevLng = t1, e1) {
                    var i = {};
                    for(var o in this._tiles){
                        var r = this._tiles[o];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + e1), i[r.tileID.key] = r;
                    }
                    for(var a in this._tiles = i, this._timers)clearTimeout(this._timers[a]), delete this._timers[a];
                    for(var n in this._tiles)this._setTileReloadTimer(n, this._tiles[n]);
                }
            }, i.prototype.update = function(e1) {
                var o = this;
                if (this.transform = e1, this._sourceLoaded && !this._paused) {
                    var r;
                    this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used ? this._source.tileID ? r = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e1) {
                        return new t1.OverscaledTileID(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y);
                    }) : (r = e1.coveringTiles({
                        tileSize: this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom,
                        reparseOverscaled: this._source.reparseOverscaled
                    }), this._source.hasTile && (r = r.filter(function(t1) {
                        return o._source.hasTile(t1);
                    }))) : r = [];
                    var a = e1.coveringZoomLevel(this._source), n = Math.max(a - i.maxOverzooming, this._source.minzoom), s = Math.max(a + i.maxUnderzooming, this._source.minzoom), l = this._updateRetainedTiles(r, a);
                    if (Mt(this._source.type)) {
                        for(var c = {}, u = {}, h = 0, p = Object.keys(l); h < p.length; h += 1){
                            var d = p[h], _ = l[d], f = this._tiles[d];
                            if (f && !(f.fadeEndTime && f.fadeEndTime <= t1.browser.now())) {
                                var m = this.findLoadedParent(_, n);
                                m && (this._addTile(m.tileID), c[m.tileID.key] = m.tileID), u[d] = _;
                            }
                        }
                        for(var g in this._retainLoadedChildren(u, a, s, l), c)l[g] || (this._coveredTiles[g] = !0, l[g] = c[g]);
                    }
                    for(var v in l)this._tiles[v].clearFadeHold();
                    for(var y = 0, x = t1.keysDifference(this._tiles, l); y < x.length; y += 1){
                        var b = x[y], w = this._tiles[b];
                        w.hasSymbolBuckets && !w.holdingForFade() ? w.setHoldDuration(this.map._fadeDuration) : w.hasSymbolBuckets && !w.symbolFadeFinished() || this._removeTile(b);
                    }
                    this._updateLoadedParentTileCache();
                }
            }, i.prototype.releaseSymbolFadeTiles = function() {
                for(var t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(t1);
            }, i.prototype._updateRetainedTiles = function(t1, e1) {
                for(var o = {}, r = {}, a = Math.max(e1 - i.maxOverzooming, this._source.minzoom), n = Math.max(e1 + i.maxUnderzooming, this._source.minzoom), s = {}, l = 0, c = t1; l < c.length; l += 1){
                    var u = c[l], h = this._addTile(u);
                    o[u.key] = u, h.hasData() || e1 < this._source.maxzoom && (s[u.key] = u);
                }
                this._retainLoadedChildren(s, e1, n, o);
                for(var p = 0, d = t1; p < d.length; p += 1){
                    var _ = d[p], f = this._tiles[_.key];
                    if (!f.hasData()) {
                        if (e1 + 1 > this._source.maxzoom) {
                            var m = _.children(this._source.maxzoom)[0], g = this.getTile(m);
                            if (g && g.hasData()) {
                                o[m.key] = m;
                                continue;
                            }
                        } else {
                            var v = _.children(this._source.maxzoom);
                            if (o[v[0].key] && o[v[1].key] && o[v[2].key] && o[v[3].key]) continue;
                        }
                        for(var y = f.wasRequested(), x = _.overscaledZ - 1; x >= a; --x){
                            var b = _.scaledTo(x);
                            if (r[b.key]) break;
                            if (r[b.key] = !0, !(f = this.getTile(b)) && y && (f = this._addTile(b)), f && (o[b.key] = b, y = f.wasRequested(), f.hasData())) break;
                        }
                    }
                }
                return o;
            }, i.prototype._updateLoadedParentTileCache = function() {
                for(var t1 in this._loadedParentTiles = {}, this._tiles){
                    for(var e1 = [], i = void 0, o = this._tiles[t1].tileID; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        e1.push(o.key);
                        var r = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(r)) break;
                        o = r;
                    }
                    for(var a = 0, n = e1; a < n.length; a += 1)this._loadedParentTiles[n[a]] = i;
                }
            }, i.prototype._addTile = function(e1) {
                var i = this._tiles[e1.key];
                if (i) return i;
                (i = this._cache.getAndRemove(e1)) && (this._setTileReloadTimer(e1.key, i), i.tileID = e1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, i)));
                var o = Boolean(i);
                return o || (i = new t1.Tile(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(i, this._tileLoaded.bind(this, i, e1.key, i.state))), i ? (i.uses++, this._tiles[e1.key] = i, o || this._source.fire(new t1.Event("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i) : null;
            }, i.prototype._setTileReloadTimer = function(t1, e1) {
                var i = this;
                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                var o = e1.getExpiryTimeout();
                o && (this._timers[t1] = setTimeout(function() {
                    i._reloadTile(t1, "expired"), delete i._timers[t1];
                }, o));
            }, i.prototype._removeTile = function(t1) {
                var e1 = this._tiles[t1];
                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
            }, i.prototype.clearTiles = function() {
                for(var t1 in this._shouldReloadOnResume = !1, this._paused = !1, this._tiles)this._removeTile(t1);
                this._cache.reset();
            }, i.prototype.tilesIn = function(e1, i, o) {
                var r = this, a = [], n = this.transform;
                if (!n) return a;
                for(var s = o ? n.getCameraQueryGeometry(e1) : e1, l = e1.map(function(t1) {
                    return n.pointCoordinate(t1);
                }), c = s.map(function(t1) {
                    return n.pointCoordinate(t1);
                }), u = this.getIds(), h = 1 / 0, p = 1 / 0, d = -1 / 0, _ = -1 / 0, f = 0, m = c; f < m.length; f += 1){
                    var g = m[f];
                    h = Math.min(h, g.x), p = Math.min(p, g.y), d = Math.max(d, g.x), _ = Math.max(_, g.y);
                }
                for(var v = function(e1) {
                    var o = r._tiles[u[e1]];
                    if (!o.holdingForFade()) {
                        var s = o.tileID, f = Math.pow(2, n.zoom - o.tileID.overscaledZ), m = i * o.queryPadding * t1.EXTENT / o.tileSize / f, g = [
                            s.getTilePoint(new t1.MercatorCoordinate(h, p)),
                            s.getTilePoint(new t1.MercatorCoordinate(d, _))
                        ];
                        if (g[0].x - m < t1.EXTENT && g[0].y - m < t1.EXTENT && g[1].x + m >= 0 && g[1].y + m >= 0) {
                            var v = l.map(function(t1) {
                                return s.getTilePoint(t1);
                            }), y = c.map(function(t1) {
                                return s.getTilePoint(t1);
                            });
                            a.push({
                                tile: o,
                                tileID: s,
                                queryGeometry: v,
                                cameraQueryGeometry: y,
                                scale: f
                            });
                        }
                    }
                }, y = 0; y < u.length; y++)v(y);
                return a;
            }, i.prototype.getVisibleCoordinates = function(t1) {
                for(var e1 = this, i = this.getRenderableIds(t1).map(function(t1) {
                    return e1._tiles[t1].tileID;
                }), o = 0, r = i; o < r.length; o += 1){
                    var a = r[o];
                    a.posMatrix = this.transform.calculatePosMatrix(a.toUnwrapped());
                }
                return i;
            }, i.prototype.hasTransition = function() {
                if (this._source.hasTransition()) return !0;
                if (Mt(this._source.type)) for(var e1 in this._tiles){
                    var i = this._tiles[e1];
                    if (void 0 !== i.fadeEndTime && i.fadeEndTime >= t1.browser.now()) return !0;
                }
                return !1;
            }, i.prototype.setFeatureState = function(t1, e1, i) {
                this._state.updateState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }, i.prototype.removeFeatureState = function(t1, e1, i) {
                this._state.removeFeatureState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }, i.prototype.getFeatureState = function(t1, e1) {
                return this._state.getState(t1 = t1 || "_geojsonTileLayer", e1);
            }, i.prototype.setDependencies = function(t1, e1, i) {
                var o = this._tiles[t1];
                o && o.setDependencies(e1, i);
            }, i.prototype.reloadTilesForDependencies = function(t1, e1) {
                for(var i in this._tiles)this._tiles[i].hasDependency(t1, e1) && this._reloadTile(i, "reloading");
                this._cache.filter(function(i) {
                    return !i.hasDependency(t1, e1);
                });
            }, i;
        }(t1.Evented);
        function At(t1, e1) {
            var i = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), o = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t1.overscaledZ - e1.overscaledZ || o - i || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
        }
        function Mt(t1) {
            return "raster" === t1 || "image" === t1 || "video" === t1;
        }
        function Lt() {
            return new t1.window.Worker(Kr.workerUrl);
        }
        Dt.maxOverzooming = 10, Dt.maxUnderzooming = 3;
        var Rt = "mapboxgl_preloaded_worker_pool", kt = function() {
            this.active = {};
        };
        kt.prototype.acquire = function(t1) {
            if (!this.workers) for(this.workers = []; this.workers.length < kt.workerCount;)this.workers.push(new Lt);
            return this.active[t1] = !0, this.workers.slice();
        }, kt.prototype.release = function(t1) {
            delete this.active[t1], 0 === this.numActive() && (this.workers.forEach(function(t1) {
                t1.terminate();
            }), this.workers = null);
        }, kt.prototype.isPreloaded = function() {
            return !!this.active[Rt];
        }, kt.prototype.numActive = function() {
            return Object.keys(this.active).length;
        };
        var Bt, Ot = Math.floor(t1.browser.hardwareConcurrency / 2);
        function Ft() {
            return Bt || (Bt = new kt), Bt;
        }
        function Ut(e1, i) {
            var o = {};
            for(var r in e1)"ref" !== r && (o[r] = e1[r]);
            return t1.refProperties.forEach(function(t1) {
                t1 in i && (o[t1] = i[t1]);
            }), o;
        }
        function Nt(t1) {
            t1 = t1.slice();
            for(var e1 = Object.create(null), i = 0; i < t1.length; i++)e1[t1[i].id] = t1[i];
            for(var o = 0; o < t1.length; o++)"ref" in t1[o] && (t1[o] = Ut(t1[o], e1[t1[o].ref]));
            return t1;
        }
        kt.workerCount = Math.max(Math.min(Ot, 6), 1);
        var Zt = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight"
        };
        function qt(t1, e1, i) {
            i.push({
                command: Zt.addSource,
                args: [
                    t1,
                    e1[t1]
                ]
            });
        }
        function jt(t1, e1, i) {
            e1.push({
                command: Zt.removeSource,
                args: [
                    t1
                ]
            }), i[t1] = !0;
        }
        function Vt(t1, e1, i, o) {
            jt(t1, i, o), qt(t1, e1, i);
        }
        function Gt(e1, i, o) {
            var r;
            for(r in e1[o])if (e1[o].hasOwnProperty(r) && "data" !== r && !t1.deepEqual(e1[o][r], i[o][r])) return !1;
            for(r in i[o])if (i[o].hasOwnProperty(r) && "data" !== r && !t1.deepEqual(e1[o][r], i[o][r])) return !1;
            return !0;
        }
        function Wt(e1, i, o, r, a, n) {
            var s;
            for(s in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], i[s]) || o.push({
                command: n,
                args: [
                    r,
                    s,
                    i[s],
                    a
                ]
            }));
            for(s in i)i.hasOwnProperty(s) && !e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], i[s]) || o.push({
                command: n,
                args: [
                    r,
                    s,
                    i[s],
                    a
                ]
            }));
        }
        function Xt(t1) {
            return t1.id;
        }
        function Ht(t1, e1) {
            return t1[e1.id] = e1, t1;
        }
        var Kt = function(t1, e1) {
            this.reset(t1, e1);
        };
        Kt.prototype.reset = function(t1, e1) {
            this.points = t1 || [], this._distances = [
                0
            ];
            for(var i = 1; i < this.points.length; i++)this._distances[i] = this._distances[i - 1] + this.points[i].dist(this.points[i - 1]);
            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
        }, Kt.prototype.lerp = function(e1) {
            if (1 === this.points.length) return this.points[0];
            e1 = t1.clamp(e1, 0, 1);
            for(var i = 1, o = this._distances[i], r = e1 * this.paddedLength + this.padding; o < r && i < this._distances.length;)o = this._distances[++i];
            var a = i - 1, n = this._distances[a], s = o - n, l = s > 0 ? (r - n) / s : 0;
            return this.points[a].mult(1 - l).add(this.points[i].mult(l));
        };
        var Yt = function(t1, e1, i) {
            var o = this.boxCells = [], r = this.circleCells = [];
            this.xCellCount = Math.ceil(t1 / i), this.yCellCount = Math.ceil(e1 / i);
            for(var a = 0; a < this.xCellCount * this.yCellCount; a++)o.push([]), r.push([]);
            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t1, this.height = e1, this.xScale = this.xCellCount / t1, this.yScale = this.yCellCount / e1, this.boxUid = 0, this.circleUid = 0;
        };
        function Jt(e1, i, o, r, a) {
            var n = t1.create();
            return i ? (t1.scale(n, n, [
                1 / a,
                1 / a,
                1
            ]), o || t1.rotateZ(n, n, r.angle)) : t1.multiply(n, r.labelPlaneMatrix, e1), n;
        }
        function Qt(e1, i, o, r, a) {
            if (i) {
                var n = t1.clone(e1);
                return t1.scale(n, n, [
                    a,
                    a,
                    1
                ]), o || t1.rotateZ(n, n, -r.angle), n;
            }
            return r.glCoordMatrix;
        }
        function $t(e1, i) {
            var o = [
                e1.x,
                e1.y,
                0,
                1
            ];
            ue(o, o, i);
            var r = o[3];
            return {
                point: new t1.Point(o[0] / r, o[1] / r),
                signedDistanceFromCamera: r
            };
        }
        function te(t1, e1) {
            return .5 + t1 / e1 * .5;
        }
        function ee(t1, e1) {
            var i = t1[0] / t1[3], o = t1[1] / t1[3];
            return i >= -e1[0] && i <= e1[0] && o >= -e1[1] && o <= e1[1];
        }
        function ie(e1, i, o, r, a, n, s, l) {
            var c = r ? e1.textSizeData : e1.iconSizeData, u = t1.evaluateSizeForZoom(c, o.transform.zoom), h = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], p = r ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            p.clear();
            for(var d = e1.lineVertexArray, _ = r ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, f = o.transform.width / o.transform.height, m = !1, g = 0; g < _.length; g++){
                var v = _.get(g);
                if (v.hidden || v.writingMode === t1.WritingMode.vertical && !m) ce(v.numGlyphs, p);
                else {
                    m = !1;
                    var y = [
                        v.anchorX,
                        v.anchorY,
                        0,
                        1
                    ];
                    if (t1.transformMat4(y, y, i), ee(y, h)) {
                        var x = te(o.transform.cameraToCenterDistance, y[3]), b = t1.evaluateSizeForFeature(c, u, v), w = s ? b / x : b * x, T = new t1.Point(v.anchorX, v.anchorY), E = $t(T, a).point, I = {}, P = ae(v, w, !1, l, i, a, n, e1.glyphOffsetArray, d, p, E, T, I, f);
                        m = P.useVertical, (P.notEnoughRoom || m || P.needsFlipping && ae(v, w, !0, l, i, a, n, e1.glyphOffsetArray, d, p, E, T, I, f).notEnoughRoom) && ce(v.numGlyphs, p);
                    } else ce(v.numGlyphs, p);
                }
            }
            r ? e1.text.dynamicLayoutVertexBuffer.updateData(p) : e1.icon.dynamicLayoutVertexBuffer.updateData(p);
        }
        function oe(t1, e1, i, o, r, a, n, s, l, c, u) {
            var h = s.glyphStartIndex + s.numGlyphs, p = s.lineStartIndex, d = s.lineStartIndex + s.lineLength, _ = e1.getoffsetX(s.glyphStartIndex), f = e1.getoffsetX(h - 1), m = se(t1 * _, i, o, r, a, n, s.segment, p, d, l, c, u);
            if (!m) return null;
            var g = se(t1 * f, i, o, r, a, n, s.segment, p, d, l, c, u);
            return g ? {
                first: m,
                last: g
            } : null;
        }
        function re(e1, i, o, r) {
            return e1 === t1.WritingMode.horizontal && Math.abs(o.y - i.y) > Math.abs(o.x - i.x) * r ? {
                useVertical: !0
            } : (e1 === t1.WritingMode.vertical ? i.y < o.y : i.x > o.x) ? {
                needsFlipping: !0
            } : null;
        }
        function ae(e1, i, o, r, a, n, s, l, c, u, h, p, d, _) {
            var f, m = i / 24, g = e1.lineOffsetX * m, v = e1.lineOffsetY * m;
            if (e1.numGlyphs > 1) {
                var y = e1.glyphStartIndex + e1.numGlyphs, x = e1.lineStartIndex, b = e1.lineStartIndex + e1.lineLength, w = oe(m, l, g, v, o, h, p, e1, c, n, d);
                if (!w) return {
                    notEnoughRoom: !0
                };
                var T = $t(w.first.point, s).point, E = $t(w.last.point, s).point;
                if (r && !o) {
                    var I = re(e1.writingMode, T, E, _);
                    if (I) return I;
                }
                f = [
                    w.first
                ];
                for(var P = e1.glyphStartIndex + 1; P < y - 1; P++)f.push(se(m * l.getoffsetX(P), g, v, o, h, p, e1.segment, x, b, c, n, d));
                f.push(w.last);
            } else {
                if (r && !o) {
                    var S = $t(p, a).point, C = e1.lineStartIndex + e1.segment + 1, z = new t1.Point(c.getx(C), c.gety(C)), D = $t(z, a), A = D.signedDistanceFromCamera > 0 ? D.point : ne(p, z, S, 1, a), M = re(e1.writingMode, S, A, _);
                    if (M) return M;
                }
                var L = se(m * l.getoffsetX(e1.glyphStartIndex), g, v, o, h, p, e1.segment, e1.lineStartIndex, e1.lineStartIndex + e1.lineLength, c, n, d);
                if (!L) return {
                    notEnoughRoom: !0
                };
                f = [
                    L
                ];
            }
            for(var R = 0, k = f; R < k.length; R += 1){
                var B = k[R];
                t1.addDynamicAttributes(u, B.point, B.angle);
            }
            return {};
        }
        function ne(t1, e1, i, o, r) {
            var a = $t(t1.add(t1.sub(e1)._unit()), r).point, n = i.sub(a);
            return i.add(n._mult(o / n.mag()));
        }
        function se(e1, i, o, r, a, n, s, l, c, u, h, p) {
            var d = r ? e1 - i : e1 + i, _ = d > 0 ? 1 : -1, f = 0;
            r && (_ *= -1, f = Math.PI), _ < 0 && (f += Math.PI);
            for(var m = _ > 0 ? l + s : l + s + 1, g = a, v = a, y = 0, x = 0, b = Math.abs(d), w = []; y + x <= b;){
                if ((m += _) < l || m >= c) return null;
                if (v = g, w.push(g), void 0 === (g = p[m])) {
                    var T = new t1.Point(u.getx(m), u.gety(m)), E = $t(T, h);
                    if (E.signedDistanceFromCamera > 0) g = p[m] = E.point;
                    else {
                        var I = m - _;
                        g = ne(0 === y ? n : new t1.Point(u.getx(I), u.gety(I)), T, v, b - y + 1, h);
                    }
                }
                y += x, x = v.dist(g);
            }
            var P = (b - y) / x, S = g.sub(v), C = S.mult(P)._add(v);
            C._add(S._unit()._perp()._mult(o * _));
            var z = f + Math.atan2(g.y - v.y, g.x - v.x);
            return w.push(C), {
                point: C,
                angle: z,
                path: w
            };
        }
        Yt.prototype.keysLength = function() {
            return this.boxKeys.length + this.circleKeys.length;
        }, Yt.prototype.insert = function(t1, e1, i, o, r) {
            this._forEachCell(e1, i, o, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t1), this.bboxes.push(e1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(r);
        }, Yt.prototype.insertCircle = function(t1, e1, i, o) {
            this._forEachCell(e1 - o, i - o, e1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t1), this.circles.push(e1), this.circles.push(i), this.circles.push(o);
        }, Yt.prototype._insertBoxCell = function(t1, e1, i, o, r, a) {
            this.boxCells[r].push(a);
        }, Yt.prototype._insertCircleCell = function(t1, e1, i, o, r, a) {
            this.circleCells[r].push(a);
        }, Yt.prototype._query = function(t1, e1, i, o, r, a) {
            if (i < 0 || t1 > this.width || o < 0 || e1 > this.height) return !r && [];
            var n = [];
            if (t1 <= 0 && e1 <= 0 && this.width <= i && this.height <= o) {
                if (r) return !0;
                for(var s = 0; s < this.boxKeys.length; s++)n.push({
                    key: this.boxKeys[s],
                    x1: this.bboxes[4 * s],
                    y1: this.bboxes[4 * s + 1],
                    x2: this.bboxes[4 * s + 2],
                    y2: this.bboxes[4 * s + 3]
                });
                for(var l = 0; l < this.circleKeys.length; l++){
                    var c = this.circles[3 * l], u = this.circles[3 * l + 1], h = this.circles[3 * l + 2];
                    n.push({
                        key: this.circleKeys[l],
                        x1: c - h,
                        y1: u - h,
                        x2: c + h,
                        y2: u + h
                    });
                }
                return a ? n.filter(a) : n;
            }
            return this._forEachCell(t1, e1, i, o, this._queryCell, n, {
                hitTest: r,
                seenUids: {
                    box: {},
                    circle: {}
                }
            }, a), r ? n.length > 0 : n;
        }, Yt.prototype._queryCircle = function(t1, e1, i, o, r) {
            var a = t1 - i, n = t1 + i, s = e1 - i, l = e1 + i;
            if (n < 0 || a > this.width || l < 0 || s > this.height) return !o && [];
            var c = [];
            return this._forEachCell(a, s, n, l, this._queryCellCircle, c, {
                hitTest: o,
                circle: {
                    x: t1,
                    y: e1,
                    radius: i
                },
                seenUids: {
                    box: {},
                    circle: {}
                }
            }, r), o ? c.length > 0 : c;
        }, Yt.prototype.query = function(t1, e1, i, o, r) {
            return this._query(t1, e1, i, o, !1, r);
        }, Yt.prototype.hitTest = function(t1, e1, i, o, r) {
            return this._query(t1, e1, i, o, !0, r);
        }, Yt.prototype.hitTestCircle = function(t1, e1, i, o) {
            return this._queryCircle(t1, e1, i, !0, o);
        }, Yt.prototype._queryCell = function(t1, e1, i, o, r, a, n, s) {
            var l = n.seenUids, c = this.boxCells[r];
            if (null !== c) for(var u = this.bboxes, h = 0, p = c; h < p.length; h += 1){
                var d = p[h];
                if (!l.box[d]) {
                    l.box[d] = !0;
                    var _ = 4 * d;
                    if (t1 <= u[_ + 2] && e1 <= u[_ + 3] && i >= u[_ + 0] && o >= u[_ + 1] && (!s || s(this.boxKeys[d]))) {
                        if (n.hitTest) return a.push(!0), !0;
                        a.push({
                            key: this.boxKeys[d],
                            x1: u[_],
                            y1: u[_ + 1],
                            x2: u[_ + 2],
                            y2: u[_ + 3]
                        });
                    }
                }
            }
            var f = this.circleCells[r];
            if (null !== f) for(var m = this.circles, g = 0, v = f; g < v.length; g += 1){
                var y = v[g];
                if (!l.circle[y]) {
                    l.circle[y] = !0;
                    var x = 3 * y;
                    if (this._circleAndRectCollide(m[x], m[x + 1], m[x + 2], t1, e1, i, o) && (!s || s(this.circleKeys[y]))) {
                        if (n.hitTest) return a.push(!0), !0;
                        var b = m[x], w = m[x + 1], T = m[x + 2];
                        a.push({
                            key: this.circleKeys[y],
                            x1: b - T,
                            y1: w - T,
                            x2: b + T,
                            y2: w + T
                        });
                    }
                }
            }
        }, Yt.prototype._queryCellCircle = function(t1, e1, i, o, r, a, n, s) {
            var l = n.circle, c = n.seenUids, u = this.boxCells[r];
            if (null !== u) for(var h = this.bboxes, p = 0, d = u; p < d.length; p += 1){
                var _ = d[p];
                if (!c.box[_]) {
                    c.box[_] = !0;
                    var f = 4 * _;
                    if (this._circleAndRectCollide(l.x, l.y, l.radius, h[f + 0], h[f + 1], h[f + 2], h[f + 3]) && (!s || s(this.boxKeys[_]))) return a.push(!0), !0;
                }
            }
            var m = this.circleCells[r];
            if (null !== m) for(var g = this.circles, v = 0, y = m; v < y.length; v += 1){
                var x = y[v];
                if (!c.circle[x]) {
                    c.circle[x] = !0;
                    var b = 3 * x;
                    if (this._circlesCollide(g[b], g[b + 1], g[b + 2], l.x, l.y, l.radius) && (!s || s(this.circleKeys[x]))) return a.push(!0), !0;
                }
            }
        }, Yt.prototype._forEachCell = function(t1, e1, i, o, r, a, n, s) {
            for(var l = this._convertToXCellCoord(t1), c = this._convertToYCellCoord(e1), u = this._convertToXCellCoord(i), h = this._convertToYCellCoord(o), p = l; p <= u; p++)for(var d = c; d <= h; d++)if (r.call(this, t1, e1, i, o, this.xCellCount * d + p, a, n, s)) return;
        }, Yt.prototype._convertToXCellCoord = function(t1) {
            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t1 * this.xScale)));
        }, Yt.prototype._convertToYCellCoord = function(t1) {
            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t1 * this.yScale)));
        }, Yt.prototype._circlesCollide = function(t1, e1, i, o, r, a) {
            var n = o - t1, s = r - e1, l = i + a;
            return l * l > n * n + s * s;
        }, Yt.prototype._circleAndRectCollide = function(t1, e1, i, o, r, a, n) {
            var s = (a - o) / 2, l = Math.abs(t1 - (o + s));
            if (l > s + i) return !1;
            var c = (n - r) / 2, u = Math.abs(e1 - (r + c));
            if (u > c + i) return !1;
            if (l <= s || u <= c) return !0;
            var h = l - s, p = u - c;
            return h * h + p * p <= i * i;
        };
        var le = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function ce(t1, e1) {
            for(var i = 0; i < t1; i++){
                var o = e1.length;
                e1.resize(o + 4), e1.float32.set(le, 3 * o);
            }
        }
        function ue(t1, e1, i) {
            var o = e1[0], r = e1[1];
            return t1[0] = i[0] * o + i[4] * r + i[12], t1[1] = i[1] * o + i[5] * r + i[13], t1[3] = i[3] * o + i[7] * r + i[15], t1;
        }
        var he = function(t1, e1, i) {
            void 0 === e1 && (e1 = new Yt(t1.width + 200, t1.height + 200, 25)), void 0 === i && (i = new Yt(t1.width + 200, t1.height + 200, 25)), this.transform = t1, this.grid = e1, this.ignoredGrid = i, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + 100, this.screenBottomBoundary = t1.height + 100, this.gridRightBoundary = t1.width + 200, this.gridBottomBoundary = t1.height + 200;
        };
        function pe(e1, i, o) {
            return i * (t1.EXTENT / (e1.tileSize * Math.pow(2, o - e1.tileID.overscaledZ)));
        }
        he.prototype.placeCollisionBox = function(t1, e1, i, o, r) {
            var a = this.projectAndGetPerspectiveRatio(o, t1.anchorPointX, t1.anchorPointY), n = i * a.perspectiveRatio, s = t1.x1 * n + a.point.x, l = t1.y1 * n + a.point.y, c = t1.x2 * n + a.point.x, u = t1.y2 * n + a.point.y;
            return !this.isInsideGrid(s, l, c, u) || !e1 && this.grid.hitTest(s, l, c, u, r) ? {
                box: [],
                offscreen: !1
            } : {
                box: [
                    s,
                    l,
                    c,
                    u
                ],
                offscreen: this.isOffscreen(s, l, c, u)
            };
        }, he.prototype.placeCollisionCircles = function(e1, i, o, r, a, n, s, l, c, u, h, p, d) {
            var _ = [], f = new t1.Point(i.anchorX, i.anchorY), m = $t(f, n), g = te(this.transform.cameraToCenterDistance, m.signedDistanceFromCamera), v = (u ? a / g : a * g) / t1.ONE_EM, y = $t(f, s).point, x = oe(v, r, i.lineOffsetX * v, i.lineOffsetY * v, !1, y, f, i, o, s, {}), b = !1, w = !1, T = !0;
            if (x) {
                for(var E = .5 * p * g + d, I = new t1.Point(-100, -100), P = new t1.Point(this.screenRightBoundary, this.screenBottomBoundary), S = new Kt, C = x.first, z = x.last, D = [], A = C.path.length - 1; A >= 1; A--)D.push(C.path[A]);
                for(var M = 1; M < z.path.length; M++)D.push(z.path[M]);
                var L = 2.5 * E;
                if (l) {
                    var R = D.map(function(t1) {
                        return $t(t1, l);
                    });
                    D = R.some(function(t1) {
                        return t1.signedDistanceFromCamera <= 0;
                    }) ? [] : R.map(function(t1) {
                        return t1.point;
                    });
                }
                var k = [];
                if (D.length > 0) {
                    for(var B = D[0].clone(), O = D[0].clone(), F = 1; F < D.length; F++)B.x = Math.min(B.x, D[F].x), B.y = Math.min(B.y, D[F].y), O.x = Math.max(O.x, D[F].x), O.y = Math.max(O.y, D[F].y);
                    k = B.x >= I.x && O.x <= P.x && B.y >= I.y && O.y <= P.y ? [
                        D
                    ] : O.x < I.x || B.x > P.x || O.y < I.y || B.y > P.y ? [] : t1.clipLine([
                        D
                    ], I.x, I.y, P.x, P.y);
                }
                for(var U = 0, N = k; U < N.length; U += 1){
                    var Z;
                    S.reset(N[U], .25 * E), Z = S.length <= .5 * E ? 1 : Math.ceil(S.paddedLength / L) + 1;
                    for(var q = 0; q < Z; q++){
                        var j = q / Math.max(Z - 1, 1), V = S.lerp(j), G = V.x + 100, W = V.y + 100;
                        _.push(G, W, E, 0);
                        var X = G - E, H = W - E, K = G + E, Y = W + E;
                        if (T = T && this.isOffscreen(X, H, K, Y), w = w || this.isInsideGrid(X, H, K, Y), !e1 && this.grid.hitTestCircle(G, W, E, h) && (b = !0, !c)) return {
                            circles: [],
                            offscreen: !1,
                            collisionDetected: b
                        };
                    }
                }
            }
            return {
                circles: !c && b || !w ? [] : _,
                offscreen: T,
                collisionDetected: b
            };
        }, he.prototype.queryRenderedSymbols = function(e1) {
            if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
            for(var i = [], o = 1 / 0, r = 1 / 0, a = -1 / 0, n = -1 / 0, s = 0, l = e1; s < l.length; s += 1){
                var c = l[s], u = new t1.Point(c.x + 100, c.y + 100);
                o = Math.min(o, u.x), r = Math.min(r, u.y), a = Math.max(a, u.x), n = Math.max(n, u.y), i.push(u);
            }
            for(var h = {}, p = {}, d = 0, _ = this.grid.query(o, r, a, n).concat(this.ignoredGrid.query(o, r, a, n)); d < _.length; d += 1){
                var f = _[d], m = f.key;
                if (void 0 === h[m.bucketInstanceId] && (h[m.bucketInstanceId] = {}), !h[m.bucketInstanceId][m.featureIndex]) {
                    var g = [
                        new t1.Point(f.x1, f.y1),
                        new t1.Point(f.x2, f.y1),
                        new t1.Point(f.x2, f.y2),
                        new t1.Point(f.x1, f.y2)
                    ];
                    t1.polygonIntersectsPolygon(i, g) && (h[m.bucketInstanceId][m.featureIndex] = !0, void 0 === p[m.bucketInstanceId] && (p[m.bucketInstanceId] = []), p[m.bucketInstanceId].push(m.featureIndex));
                }
            }
            return p;
        }, he.prototype.insertCollisionBox = function(t1, e1, i, o, r) {
            (e1 ? this.ignoredGrid : this.grid).insert({
                bucketInstanceId: i,
                featureIndex: o,
                collisionGroupID: r
            }, t1[0], t1[1], t1[2], t1[3]);
        }, he.prototype.insertCollisionCircles = function(t1, e1, i, o, r) {
            for(var a = e1 ? this.ignoredGrid : this.grid, n = {
                bucketInstanceId: i,
                featureIndex: o,
                collisionGroupID: r
            }, s = 0; s < t1.length; s += 4)a.insertCircle(n, t1[s], t1[s + 1], t1[s + 2]);
        }, he.prototype.projectAndGetPerspectiveRatio = function(e1, i, o) {
            var r = [
                i,
                o,
                0,
                1
            ];
            return ue(r, r, e1), {
                point: new t1.Point((r[0] / r[3] + 1) / 2 * this.transform.width + 100, (-r[1] / r[3] + 1) / 2 * this.transform.height + 100),
                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / r[3] * .5
            };
        }, he.prototype.isOffscreen = function(t1, e1, i, o) {
            return i < 100 || t1 >= this.screenRightBoundary || o < 100 || e1 > this.screenBottomBoundary;
        }, he.prototype.isInsideGrid = function(t1, e1, i, o) {
            return i >= 0 && t1 < this.gridRightBoundary && o >= 0 && e1 < this.gridBottomBoundary;
        }, he.prototype.getViewportMatrix = function() {
            var e1 = t1.identity([]);
            return t1.translate(e1, e1, [
                -100,
                -100,
                0
            ]), e1;
        };
        var de = function(t1, e1, i, o) {
            this.opacity = t1 ? Math.max(0, Math.min(1, t1.opacity + (t1.placed ? e1 : -e1))) : o && i ? 1 : 0, this.placed = i;
        };
        de.prototype.isHidden = function() {
            return 0 === this.opacity && !this.placed;
        };
        var _e = function(t1, e1, i, o, r) {
            this.text = new de(t1 ? t1.text : null, e1, i, r), this.icon = new de(t1 ? t1.icon : null, e1, o, r);
        };
        _e.prototype.isHidden = function() {
            return this.text.isHidden() && this.icon.isHidden();
        };
        var fe = function(t1, e1, i) {
            this.text = t1, this.icon = e1, this.skipFade = i;
        }, me = function() {
            this.invProjMatrix = t1.create(), this.viewportMatrix = t1.create(), this.circles = [];
        }, ge = function(t1, e1, i, o, r) {
            this.bucketInstanceId = t1, this.featureIndex = e1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = r;
        }, ve = function(t1) {
            this.crossSourceCollisions = t1, this.maxGroupID = 0, this.collisionGroups = {};
        };
        function ye(e1, i, o, r, a) {
            var n = t1.getAnchorAlignment(e1), s = -(n.horizontalAlign - .5) * i, l = -(n.verticalAlign - .5) * o, c = t1.evaluateVariableOffset(e1, r);
            return new t1.Point(s + c[0] * a, l + c[1] * a);
        }
        function xe(e1, i, o, r, a, n) {
            var s = e1.x1, l = e1.x2, c = e1.y1, u = e1.y2, h = e1.anchorPointX, p = e1.anchorPointY, d = new t1.Point(i, o);
            return r && d._rotate(a ? n : -n), {
                x1: s + d.x,
                y1: c + d.y,
                x2: l + d.x,
                y2: u + d.y,
                anchorPointX: h,
                anchorPointY: p
            };
        }
        ve.prototype.get = function(t1) {
            if (this.crossSourceCollisions) return {
                ID: 0,
                predicate: null
            };
            if (!this.collisionGroups[t1]) {
                var e1 = ++this.maxGroupID;
                this.collisionGroups[t1] = {
                    ID: e1,
                    predicate: function(t1) {
                        return t1.collisionGroupID === e1;
                    }
                };
            }
            return this.collisionGroups[t1];
        };
        var be = function(t1, e1, i, o) {
            this.transform = t1.clone(), this.collisionIndex = new he(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = e1, this.retainedQueryData = {}, this.collisionGroups = new ve(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
        };
        function we(t1, e1, i, o, r) {
            t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0);
        }
        be.prototype.getBucketParts = function(e1, i, o, r) {
            var a = o.getBucket(i), n = o.latestFeatureIndex;
            if (a && n && i.id === a.layerIds[0]) {
                var s = o.collisionBoxArray, l = a.layers[0].layout, c = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), u = o.tileSize / t1.EXTENT, h = this.transform.calculatePosMatrix(o.tileID.toUnwrapped()), p = "map" === l.get("text-pitch-alignment"), d = "map" === l.get("text-rotation-alignment"), _ = pe(o, 1, this.transform.zoom), f = Jt(h, p, d, this.transform, _), m = null;
                if (p) {
                    var g = Qt(h, p, d, this.transform, _);
                    m = t1.multiply([], this.transform.labelPlaneMatrix, g);
                }
                this.retainedQueryData[a.bucketInstanceId] = new ge(a.bucketInstanceId, n, a.sourceLayerIndex, a.index, o.tileID);
                var v = {
                    bucket: a,
                    layout: l,
                    posMatrix: h,
                    textLabelPlaneMatrix: f,
                    labelToScreenMatrix: m,
                    scale: c,
                    textPixelRatio: u,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: s,
                    partiallyEvaluatedTextSize: t1.evaluateSizeForZoom(a.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(a.sourceID)
                };
                if (r) for(var y = 0, x = a.sortKeyRanges; y < x.length; y += 1){
                    var b = x[y];
                    e1.push({
                        sortKey: b.sortKey,
                        symbolInstanceStart: b.symbolInstanceStart,
                        symbolInstanceEnd: b.symbolInstanceEnd,
                        parameters: v
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: a.symbolInstances.length,
                    parameters: v
                });
            }
        }, be.prototype.attemptAnchorPlacement = function(t1, e1, i, o, r, a, n, s, l, c, u, h, p, d, _) {
            var f, m = [
                h.textOffset0,
                h.textOffset1
            ], g = ye(t1, i, o, m, r), v = this.collisionIndex.placeCollisionBox(xe(e1, g.x, g.y, a, n, this.transform.angle), u, s, l, c.predicate);
            if (!_ || 0 !== this.collisionIndex.placeCollisionBox(xe(_, g.x, g.y, a, n, this.transform.angle), u, s, l, c.predicate).box.length) return v.box.length > 0 ? (this.prevPlacement && this.prevPlacement.variableOffsets[h.crossTileID] && this.prevPlacement.placements[h.crossTileID] && this.prevPlacement.placements[h.crossTileID].text && (f = this.prevPlacement.variableOffsets[h.crossTileID].anchor), this.variableOffsets[h.crossTileID] = {
                textOffset: m,
                width: i,
                height: o,
                anchor: t1,
                textBoxScale: r,
                prevAnchor: f
            }, this.markUsedJustification(p, t1, h, d), p.allowVerticalPlacement && (this.markUsedOrientation(p, d, h), this.placedOrientations[h.crossTileID] = d), {
                shift: g,
                placedGlyphBoxes: v
            }) : void 0;
        }, be.prototype.placeLayerBucketPart = function(e1, i, o) {
            var r = this, a = e1.parameters, n = a.bucket, s = a.layout, l = a.posMatrix, c = a.textLabelPlaneMatrix, u = a.labelToScreenMatrix, h = a.textPixelRatio, p = a.holdingForFade, d = a.collisionBoxArray, _ = a.partiallyEvaluatedTextSize, f = a.collisionGroup, m = s.get("text-optional"), g = s.get("icon-optional"), v = s.get("text-allow-overlap"), y = s.get("icon-allow-overlap"), x = "map" === s.get("text-rotation-alignment"), b = "map" === s.get("text-pitch-alignment"), w = "none" !== s.get("icon-text-fit"), T = "viewport-y" === s.get("symbol-z-order"), E = v && (y || !n.hasIconData() || g), I = y && (v || !n.hasTextData() || m);
            !n.collisionArrays && d && n.deserializeCollisionBoxes(d);
            var P = function(e1, a) {
                if (!i[e1.crossTileID]) {
                    if (p) r.placements[e1.crossTileID] = new fe(!1, !1, !1);
                    else {
                        var d, T = !1, P = !1, S = !0, C = null, z = {
                            box: null,
                            offscreen: null
                        }, D = {
                            box: null,
                            offscreen: null
                        }, A = null, M = null, L = 0, R = 0, k = 0;
                        a.textFeatureIndex ? L = a.textFeatureIndex : e1.useRuntimeCollisionCircles && (L = e1.featureIndex), a.verticalTextFeatureIndex && (R = a.verticalTextFeatureIndex);
                        var B = a.textBox;
                        if (B) {
                            var O = function(i) {
                                var o = t1.WritingMode.horizontal;
                                if (n.allowVerticalPlacement && !i && r.prevPlacement) {
                                    var a = r.prevPlacement.placedOrientations[e1.crossTileID];
                                    a && (r.placedOrientations[e1.crossTileID] = a, r.markUsedOrientation(n, o = a, e1));
                                }
                                return o;
                            }, F = function(i, o) {
                                if (n.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && a.verticalTextBox) for(var r = 0, s = n.writingModes; r < s.length && (s[r] === t1.WritingMode.vertical ? (z = o(), D = z) : z = i(), !(z && z.box && z.box.length)); r += 1);
                                else z = i();
                            };
                            if (s.get("text-variable-anchor")) {
                                var U = s.get("text-variable-anchor");
                                if (r.prevPlacement && r.prevPlacement.variableOffsets[e1.crossTileID]) {
                                    var N = r.prevPlacement.variableOffsets[e1.crossTileID];
                                    U.indexOf(N.anchor) > 0 && (U = U.filter(function(t1) {
                                        return t1 !== N.anchor;
                                    })).unshift(N.anchor);
                                }
                                var Z = function(t1, i, o) {
                                    for(var a = t1.x2 - t1.x1, s = t1.y2 - t1.y1, c = e1.textBoxScale, u = w && !y ? i : null, p = {
                                        box: [],
                                        offscreen: !1
                                    }, d = v ? 2 * U.length : U.length, _ = 0; _ < d; ++_){
                                        var m = r.attemptAnchorPlacement(U[_ % U.length], t1, a, s, c, x, b, h, l, f, _ >= U.length, e1, n, o, u);
                                        if (m && (p = m.placedGlyphBoxes) && p.box && p.box.length) {
                                            T = !0, C = m.shift;
                                            break;
                                        }
                                    }
                                    return p;
                                };
                                F(function() {
                                    return Z(B, a.iconBox, t1.WritingMode.horizontal);
                                }, function() {
                                    var i = a.verticalTextBox;
                                    return n.allowVerticalPlacement && !(z && z.box && z.box.length) && e1.numVerticalGlyphVertices > 0 && i ? Z(i, a.verticalIconBox, t1.WritingMode.vertical) : {
                                        box: null,
                                        offscreen: null
                                    };
                                }), z && (T = z.box, S = z.offscreen);
                                var q = O(z && z.box);
                                if (!T && r.prevPlacement) {
                                    var j = r.prevPlacement.variableOffsets[e1.crossTileID];
                                    j && (r.variableOffsets[e1.crossTileID] = j, r.markUsedJustification(n, j.anchor, e1, q));
                                }
                            } else {
                                var V = function(t1, i) {
                                    var o = r.collisionIndex.placeCollisionBox(t1, v, h, l, f.predicate);
                                    return o && o.box && o.box.length && (r.markUsedOrientation(n, i, e1), r.placedOrientations[e1.crossTileID] = i), o;
                                };
                                F(function() {
                                    return V(B, t1.WritingMode.horizontal);
                                }, function() {
                                    var i = a.verticalTextBox;
                                    return n.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && i ? V(i, t1.WritingMode.vertical) : {
                                        box: null,
                                        offscreen: null
                                    };
                                }), O(z && z.box && z.box.length);
                            }
                        }
                        if (T = (d = z) && d.box && d.box.length > 0, S = d && d.offscreen, e1.useRuntimeCollisionCircles) {
                            var G = n.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), W = t1.evaluateSizeForFeature(n.textSizeData, _, G), X = s.get("text-padding");
                            A = r.collisionIndex.placeCollisionCircles(v, G, n.lineVertexArray, n.glyphOffsetArray, W, l, c, u, o, b, f.predicate, e1.collisionCircleDiameter, X), T = v || A.circles.length > 0 && !A.collisionDetected, S = S && A.offscreen;
                        }
                        if (a.iconFeatureIndex && (k = a.iconFeatureIndex), a.iconBox) {
                            var H = function(t1) {
                                var e1 = w && C ? xe(t1, C.x, C.y, x, b, r.transform.angle) : t1;
                                return r.collisionIndex.placeCollisionBox(e1, y, h, l, f.predicate);
                            };
                            P = D && D.box && D.box.length && a.verticalIconBox ? (M = H(a.verticalIconBox)).box.length > 0 : (M = H(a.iconBox)).box.length > 0, S = S && M.offscreen;
                        }
                        var K = m || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, Y = g || 0 === e1.numIconVertices;
                        if (K || Y ? Y ? K || (P = P && T) : T = P && T : P = T = P && T, T && d && d.box && r.collisionIndex.insertCollisionBox(d.box, s.get("text-ignore-placement"), n.bucketInstanceId, D && D.box && R ? R : L, f.ID), P && M && r.collisionIndex.insertCollisionBox(M.box, s.get("icon-ignore-placement"), n.bucketInstanceId, k, f.ID), A && (T && r.collisionIndex.insertCollisionCircles(A.circles, s.get("text-ignore-placement"), n.bucketInstanceId, L, f.ID), o)) {
                            var J = n.bucketInstanceId, Q = r.collisionCircleArrays[J];
                            void 0 === Q && (Q = r.collisionCircleArrays[J] = new me);
                            for(var $ = 0; $ < A.circles.length; $ += 4)Q.circles.push(A.circles[$ + 0]), Q.circles.push(A.circles[$ + 1]), Q.circles.push(A.circles[$ + 2]), Q.circles.push(A.collisionDetected ? 1 : 0);
                        }
                        r.placements[e1.crossTileID] = new fe(T || E, P || I, S || n.justReloaded), i[e1.crossTileID] = !0;
                    }
                }
            };
            if (T) for(var S = n.getSortedSymbolIndexes(this.transform.angle), C = S.length - 1; C >= 0; --C){
                var z = S[C];
                P(n.symbolInstances.get(z), n.collisionArrays[z]);
            }
            else for(var D = e1.symbolInstanceStart; D < e1.symbolInstanceEnd; D++)P(n.symbolInstances.get(D), n.collisionArrays[D]);
            if (o && n.bucketInstanceId in this.collisionCircleArrays) {
                var A = this.collisionCircleArrays[n.bucketInstanceId];
                t1.invert(A.invProjMatrix, l), A.viewportMatrix = this.collisionIndex.getViewportMatrix();
            }
            n.justReloaded = !1;
        }, be.prototype.markUsedJustification = function(e1, i, o, r) {
            var a;
            a = r === t1.WritingMode.vertical ? o.verticalPlacedTextSymbolIndex : ({
                left: o.leftJustifiedTextSymbolIndex,
                center: o.centerJustifiedTextSymbolIndex,
                right: o.rightJustifiedTextSymbolIndex
            })[t1.getAnchorJustification(i)];
            for(var n = 0, s = [
                o.leftJustifiedTextSymbolIndex,
                o.centerJustifiedTextSymbolIndex,
                o.rightJustifiedTextSymbolIndex,
                o.verticalPlacedTextSymbolIndex
            ]; n < s.length; n += 1){
                var l = s[n];
                l >= 0 && (e1.text.placedSymbolArray.get(l).crossTileID = a >= 0 && l !== a ? 0 : o.crossTileID);
            }
        }, be.prototype.markUsedOrientation = function(e1, i, o) {
            for(var r = i === t1.WritingMode.horizontal || i === t1.WritingMode.horizontalOnly ? i : 0, a = i === t1.WritingMode.vertical ? i : 0, n = 0, s = [
                o.leftJustifiedTextSymbolIndex,
                o.centerJustifiedTextSymbolIndex,
                o.rightJustifiedTextSymbolIndex
            ]; n < s.length; n += 1)e1.text.placedSymbolArray.get(s[n]).placedOrientation = r;
            o.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation = a);
        }, be.prototype.commit = function(t1) {
            this.commitTime = t1, this.zoomAtLastRecencyCheck = this.transform.zoom;
            var e1 = this.prevPlacement, i = !1;
            this.prevZoomAdjustment = e1 ? e1.zoomAdjustment(this.transform.zoom) : 0;
            var o = e1 ? e1.symbolFadeChange(t1) : 1, r = e1 ? e1.opacities : {}, a = e1 ? e1.variableOffsets : {}, n = e1 ? e1.placedOrientations : {};
            for(var s in this.placements){
                var l = this.placements[s], c = r[s];
                c ? (this.opacities[s] = new _e(c, o, l.text, l.icon), i = i || l.text !== c.text.placed || l.icon !== c.icon.placed) : (this.opacities[s] = new _e(null, o, l.text, l.icon, l.skipFade), i = i || l.text || l.icon);
            }
            for(var u in r){
                var h = r[u];
                if (!this.opacities[u]) {
                    var p = new _e(h, o, !1, !1);
                    p.isHidden() || (this.opacities[u] = p, i = i || h.text.placed || h.icon.placed);
                }
            }
            for(var d in a)this.variableOffsets[d] || !this.opacities[d] || this.opacities[d].isHidden() || (this.variableOffsets[d] = a[d]);
            for(var _ in n)this.placedOrientations[_] || !this.opacities[_] || this.opacities[_].isHidden() || (this.placedOrientations[_] = n[_]);
            i ? this.lastPlacementChangeTime = t1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e1 ? e1.lastPlacementChangeTime : t1);
        }, be.prototype.updateLayerOpacities = function(t1, e1) {
            for(var i = {}, o = 0, r = e1; o < r.length; o += 1){
                var a = r[o], n = a.getBucket(t1);
                n && a.latestFeatureIndex && t1.id === n.layerIds[0] && this.updateBucketOpacities(n, i, a.collisionBoxArray);
            }
        }, be.prototype.updateBucketOpacities = function(e1, i, o) {
            var r = this;
            e1.hasTextData() && e1.text.opacityVertexArray.clear(), e1.hasIconData() && e1.icon.opacityVertexArray.clear(), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
            var a = e1.layers[0].layout, n = new _e(null, 0, !1, !1, !0), s = a.get("text-allow-overlap"), l = a.get("icon-allow-overlap"), c = a.get("text-variable-anchor"), u = "map" === a.get("text-rotation-alignment"), h = "map" === a.get("text-pitch-alignment"), p = "none" !== a.get("icon-text-fit"), d = new _e(null, 0, s && (l || !e1.hasIconData() || a.get("icon-optional")), l && (s || !e1.hasTextData() || a.get("text-optional")), !0);
            !e1.collisionArrays && o && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(o);
            for(var _ = function(t1, e1, i) {
                for(var o = 0; o < e1 / 4; o++)t1.opacityVertexArray.emplaceBack(i);
            }, f = function(o) {
                var a = e1.symbolInstances.get(o), s = a.numHorizontalGlyphVertices, l = a.numVerticalGlyphVertices, f = a.crossTileID, m = r.opacities[f];
                i[f] ? m = n : m || (r.opacities[f] = m = d), i[f] = !0;
                var g = a.numIconVertices > 0, v = r.placedOrientations[a.crossTileID], y = v === t1.WritingMode.vertical, x = v === t1.WritingMode.horizontal || v === t1.WritingMode.horizontalOnly;
                if (s > 0 || l > 0) {
                    var b = De(m.text);
                    _(e1.text, s, y ? Ae : b), _(e1.text, l, x ? Ae : b);
                    var w = m.text.isHidden();
                    [
                        a.rightJustifiedTextSymbolIndex,
                        a.centerJustifiedTextSymbolIndex,
                        a.leftJustifiedTextSymbolIndex
                    ].forEach(function(t1) {
                        t1 >= 0 && (e1.text.placedSymbolArray.get(t1).hidden = w || y ? 1 : 0);
                    }), a.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = w || x ? 1 : 0);
                    var T = r.variableOffsets[a.crossTileID];
                    T && r.markUsedJustification(e1, T.anchor, a, v);
                    var E = r.placedOrientations[a.crossTileID];
                    E && (r.markUsedJustification(e1, "left", a, E), r.markUsedOrientation(e1, E, a));
                }
                if (g) {
                    var I = De(m.icon), P = !(p && a.verticalPlacedIconSymbolIndex && y);
                    a.placedIconSymbolIndex >= 0 && (_(e1.icon, a.numIconVertices, P ? I : Ae), e1.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = m.icon.isHidden()), a.verticalPlacedIconSymbolIndex >= 0 && (_(e1.icon, a.numVerticalIconVertices, P ? Ae : I), e1.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = m.icon.isHidden());
                }
                if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                    var S = e1.collisionArrays[o];
                    if (S) {
                        var C = new t1.Point(0, 0);
                        if (S.textBox || S.verticalTextBox) {
                            var z = !0;
                            if (c) {
                                var D = r.variableOffsets[f];
                                D ? (C = ye(D.anchor, D.width, D.height, D.textOffset, D.textBoxScale), u && C._rotate(h ? r.transform.angle : -r.transform.angle)) : z = !1;
                            }
                            S.textBox && we(e1.textCollisionBox.collisionVertexArray, m.text.placed, !z || y, C.x, C.y), S.verticalTextBox && we(e1.textCollisionBox.collisionVertexArray, m.text.placed, !z || x, C.x, C.y);
                        }
                        var A = Boolean(!x && S.verticalIconBox);
                        S.iconBox && we(e1.iconCollisionBox.collisionVertexArray, m.icon.placed, A, p ? C.x : 0, p ? C.y : 0), S.verticalIconBox && we(e1.iconCollisionBox.collisionVertexArray, m.icon.placed, !A, p ? C.x : 0, p ? C.y : 0);
                    }
                }
            }, m = 0; m < e1.symbolInstances.length; m++)f(m);
            if (e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.bucketInstanceId in this.collisionCircleArrays) {
                var g = this.collisionCircleArrays[e1.bucketInstanceId];
                e1.placementInvProjMatrix = g.invProjMatrix, e1.placementViewportMatrix = g.viewportMatrix, e1.collisionCircleArray = g.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
            }
        }, be.prototype.symbolFadeChange = function(t1) {
            return 0 === this.fadeDuration ? 1 : (t1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
        }, be.prototype.zoomAdjustment = function(t1) {
            return Math.max(0, (this.transform.zoom - t1) / 1.5);
        }, be.prototype.hasTransitions = function(t1) {
            return this.stale || t1 - this.lastPlacementChangeTime < this.fadeDuration;
        }, be.prototype.stillRecent = function(t1, e1) {
            var i = this.zoomAtLastRecencyCheck === e1 ? 1 - this.zoomAdjustment(e1) : 1;
            return this.zoomAtLastRecencyCheck = e1, this.commitTime + this.fadeDuration * i > t1;
        }, be.prototype.setStale = function() {
            this.stale = !0;
        };
        var Te = Math.pow(2, 25), Ee = Math.pow(2, 24), Ie = Math.pow(2, 17), Pe = Math.pow(2, 16), Se = Math.pow(2, 9), Ce = Math.pow(2, 8), ze = Math.pow(2, 1);
        function De(t1) {
            if (0 === t1.opacity && !t1.placed) return 0;
            if (1 === t1.opacity && t1.placed) return 4294967295;
            var e1 = t1.placed ? 1 : 0, i = Math.floor(127 * t1.opacity);
            return i * Te + e1 * Ee + i * Ie + e1 * Pe + i * Se + e1 * Ce + i * ze + e1;
        }
        var Ae = 0, Me = function(t1) {
            this._sortAcrossTiles = "viewport-y" !== t1.layout.get("symbol-z-order") && void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
        };
        Me.prototype.continuePlacement = function(t1, e1, i, o, r) {
            for(var a = this._bucketParts; this._currentTileIndex < t1.length;)if (e1.getBucketParts(a, o, t1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
            for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            })); this._currentPartIndex < a.length;)if (e1.placeLayerBucketPart(a[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, r()) return !0;
            return !1;
        };
        var Le = function(t1, e1, i, o, r, a, n) {
            this.placement = new be(t1, r, a, n), this._currentPlacementIndex = e1.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
        };
        Le.prototype.isDone = function() {
            return this._done;
        }, Le.prototype.continuePlacement = function(e1, i, o) {
            for(var r = this, a = t1.browser.now(), n = function() {
                var e1 = t1.browser.now() - a;
                return !r._forceFullPlacement && e1 > 2;
            }; this._currentPlacementIndex >= 0;){
                var s = i[e1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                if ("symbol" === s.type && (!s.minzoom || s.minzoom <= l) && (!s.maxzoom || s.maxzoom > l)) {
                    if (this._inProgressLayer || (this._inProgressLayer = new Me(s)), this._inProgressLayer.continuePlacement(o[s.source], this.placement, this._showCollisionBoxes, s, n)) return;
                    delete this._inProgressLayer;
                }
                this._currentPlacementIndex--;
            }
            this._done = !0;
        }, Le.prototype.commit = function(t1) {
            return this.placement.commit(t1), this.placement;
        };
        var Re = 512 / t1.EXTENT / 2, ke = function(t1, e1, i) {
            this.tileID = t1, this.indexedSymbolInstances = {}, this.bucketInstanceId = i;
            for(var o = 0; o < e1.length; o++){
                var r = e1.get(o), a = r.key;
                this.indexedSymbolInstances[a] || (this.indexedSymbolInstances[a] = []), this.indexedSymbolInstances[a].push({
                    crossTileID: r.crossTileID,
                    coord: this.getScaledCoordinates(r, t1)
                });
            }
        };
        ke.prototype.getScaledCoordinates = function(e1, i) {
            var o = Re / Math.pow(2, i.canonical.z - this.tileID.canonical.z);
            return {
                x: Math.floor((i.canonical.x * t1.EXTENT + e1.anchorX) * o),
                y: Math.floor((i.canonical.y * t1.EXTENT + e1.anchorY) * o)
            };
        }, ke.prototype.findMatches = function(t1, e1, i) {
            for(var o = this.tileID.canonical.z < e1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e1.canonical.z), r = 0; r < t1.length; r++){
                var a = t1.get(r);
                if (!a.crossTileID) {
                    var n = this.indexedSymbolInstances[a.key];
                    if (n) for(var s = this.getScaledCoordinates(a, e1), l = 0, c = n; l < c.length; l += 1){
                        var u = c[l];
                        if (Math.abs(u.coord.x - s.x) <= o && Math.abs(u.coord.y - s.y) <= o && !i[u.crossTileID]) {
                            i[u.crossTileID] = !0, a.crossTileID = u.crossTileID;
                            break;
                        }
                    }
                }
            }
        };
        var Be = function() {
            this.maxCrossTileID = 0;
        };
        Be.prototype.generate = function() {
            return ++this.maxCrossTileID;
        };
        var Oe = function() {
            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
        };
        Oe.prototype.handleWrapJump = function(t1) {
            var e1 = Math.round((t1 - this.lng) / 360);
            if (0 !== e1) for(var i in this.indexes){
                var o = this.indexes[i], r = {};
                for(var a in o){
                    var n = o[a];
                    n.tileID = n.tileID.unwrapTo(n.tileID.wrap + e1), r[n.tileID.key] = n;
                }
                this.indexes[i] = r;
            }
            this.lng = t1;
        }, Oe.prototype.addBucket = function(t1, e1, i) {
            if (this.indexes[t1.overscaledZ] && this.indexes[t1.overscaledZ][t1.key]) {
                if (this.indexes[t1.overscaledZ][t1.key].bucketInstanceId === e1.bucketInstanceId) return !1;
                this.removeBucketCrossTileIDs(t1.overscaledZ, this.indexes[t1.overscaledZ][t1.key]);
            }
            for(var o = 0; o < e1.symbolInstances.length; o++)e1.symbolInstances.get(o).crossTileID = 0;
            this.usedCrossTileIDs[t1.overscaledZ] || (this.usedCrossTileIDs[t1.overscaledZ] = {});
            var r = this.usedCrossTileIDs[t1.overscaledZ];
            for(var a in this.indexes){
                var n = this.indexes[a];
                if (Number(a) > t1.overscaledZ) for(var s in n){
                    var l = n[s];
                    l.tileID.isChildOf(t1) && l.findMatches(e1.symbolInstances, t1, r);
                }
                else {
                    var c = n[t1.scaledTo(Number(a)).key];
                    c && c.findMatches(e1.symbolInstances, t1, r);
                }
            }
            for(var u = 0; u < e1.symbolInstances.length; u++){
                var h = e1.symbolInstances.get(u);
                h.crossTileID || (h.crossTileID = i.generate(), r[h.crossTileID] = !0);
            }
            return void 0 === this.indexes[t1.overscaledZ] && (this.indexes[t1.overscaledZ] = {}), this.indexes[t1.overscaledZ][t1.key] = new ke(t1, e1.symbolInstances, e1.bucketInstanceId), !0;
        }, Oe.prototype.removeBucketCrossTileIDs = function(t1, e1) {
            for(var i in e1.indexedSymbolInstances)for(var o = 0, r = e1.indexedSymbolInstances[i]; o < r.length; o += 1)delete this.usedCrossTileIDs[t1][r[o].crossTileID];
        }, Oe.prototype.removeStaleBuckets = function(t1) {
            var e1 = !1;
            for(var i in this.indexes){
                var o = this.indexes[i];
                for(var r in o)t1[o[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[r]), delete o[r], e1 = !0);
            }
            return e1;
        };
        var Fe = function() {
            this.layerIndexes = {}, this.crossTileIDs = new Be, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
        };
        Fe.prototype.addLayer = function(t1, e1, i) {
            var o = this.layerIndexes[t1.id];
            void 0 === o && (o = this.layerIndexes[t1.id] = new Oe);
            var r = !1, a = {};
            o.handleWrapJump(i);
            for(var n = 0, s = e1; n < s.length; n += 1){
                var l = s[n], c = l.getBucket(t1);
                c && t1.id === c.layerIds[0] && (c.bucketInstanceId || (c.bucketInstanceId = ++this.maxBucketInstanceId), o.addBucket(l.tileID, c, this.crossTileIDs) && (r = !0), a[c.bucketInstanceId] = !0);
            }
            return o.removeStaleBuckets(a) && (r = !0), r;
        }, Fe.prototype.pruneUnusedLayers = function(t1) {
            var e1 = {};
            for(var i in t1.forEach(function(t1) {
                e1[t1] = !0;
            }), this.layerIndexes)e1[i] || delete this.layerIndexes[i];
        };
        var Ue = function(e1, i) {
            return t1.emitValidationErrors(e1, i && i.filter(function(t1) {
                return "source.canvas" !== t1.identifier;
            }));
        }, Ne = t1.pick(Zt, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData"
        ]), Ze = t1.pick(Zt, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), qe = function() {
            var e1 = {}, i = t1.styleSpec.$version;
            for(var o in t1.styleSpec.$root){
                var r, a = t1.styleSpec.$root[o];
                if (a.required) null != (r = "version" === o ? i : "array" === a.type ? [] : {}) && (e1[o] = r);
            }
            return e1;
        }(), je = function(e1) {
            function i(o, r) {
                var a = this;
                void 0 === r && (r = {}), e1.call(this), this.map = o, this.dispatcher = new E(Ft(), this), this.imageManager = new p, this.imageManager.setEventedParent(this), this.glyphManager = new y(o._requestManager, r.localIdeographFontFamily), this.lineAtlas = new T(256, 512), this.crossTileSymbolIndex = new Fe, this._layers = {}, this._serializedLayers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t1.ZoomHistory, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t1.getReferrer());
                var n = this;
                this._rtlTextPluginCallback = i.registerForPluginStateChange(function(e1) {
                    n.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e1.pluginStatus,
                        pluginURL: e1.pluginURL
                    }, function(e1, i) {
                        if (t1.triggerPluginCompletionEvent(e1), i && i.every(function(t1) {
                            return t1;
                        })) for(var o in n.sourceCaches)n.sourceCaches[o].reload();
                    });
                }), this.on("data", function(t1) {
                    if ("source" === t1.dataType && "metadata" === t1.sourceDataType) {
                        var e1 = a.sourceCaches[t1.sourceId];
                        if (e1) {
                            var i = e1.getSource();
                            if (i && i.vectorLayerIds) for(var o in a._layers){
                                var r = a._layers[o];
                                r.source === i.id && a._validateLayer(r);
                            }
                        }
                    }
                });
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.loadURL = function(e1, i) {
                var o = this;
                void 0 === i && (i = {}), this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                }));
                var r = "boolean" == typeof i.validate ? i.validate : !t1.isMapboxURL(e1);
                e1 = this.map._requestManager.normalizeStyleURL(e1, i.accessToken);
                var a = this.map._requestManager.transformRequest(e1, t1.ResourceType.Style);
                this._request = t1.getJSON(a, function(e1, i) {
                    o._request = null, e1 ? o.fire(new t1.ErrorEvent(e1)) : i && o._load(i, r);
                });
            }, i.prototype.loadJSON = function(e1, i) {
                var o = this;
                void 0 === i && (i = {}), this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._request = t1.browser.frame(function() {
                    o._request = null, o._load(e1, !1 !== i.validate);
                });
            }, i.prototype.loadEmpty = function() {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._load(qe, !1);
            }, i.prototype._load = function(e1, i) {
                if (!i || !Ue(this, t1.validateStyle(e1))) {
                    for(var o in this._loaded = !0, this.stylesheet = e1, e1.sources)this.addSource(o, e1.sources[o], {
                        validate: !1
                    });
                    e1.sprite ? this._loadSprite(e1.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(e1.glyphs);
                    var r = Nt(this.stylesheet.layers);
                    this._order = r.map(function(t1) {
                        return t1.id;
                    }), this._layers = {}, this._serializedLayers = {};
                    for(var a = 0, n = r; a < n.length; a += 1){
                        var s = n[a];
                        (s = t1.createStyleLayer(s)).setEventedParent(this, {
                            layer: {
                                id: s.id
                            }
                        }), this._layers[s.id] = s, this._serializedLayers[s.id] = s.serialize();
                    }
                    this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new w(this.stylesheet.light), this.fire(new t1.Event("data", {
                        dataType: "style"
                    })), this.fire(new t1.Event("style.load"));
                }
            }, i.prototype._loadSprite = function(e1) {
                var i = this;
                this._spriteRequest = function(e1, i, o) {
                    var r, a, n, s = t1.browser.devicePixelRatio > 1 ? "@2x" : "", l = t1.getJSON(i.transformRequest(i.normalizeSpriteURL(e1, s, ".json"), t1.ResourceType.SpriteJSON), function(t1, e1) {
                        l = null, n || (n = t1, r = e1, u());
                    }), c = t1.getImage(i.transformRequest(i.normalizeSpriteURL(e1, s, ".png"), t1.ResourceType.SpriteImage), function(t1, e1) {
                        c = null, n || (n = t1, a = e1, u());
                    });
                    function u() {
                        if (n) o(n);
                        else if (r && a) {
                            var e1 = t1.browser.getImageData(a), i = {};
                            for(var s in r){
                                var l = r[s], c = l.width, u = l.height, h = l.x, p = l.y, d = l.sdf, _ = l.pixelRatio, f = l.stretchX, m = l.stretchY, g = l.content, v = new t1.RGBAImage({
                                    width: c,
                                    height: u
                                });
                                t1.RGBAImage.copy(e1, v, {
                                    x: h,
                                    y: p
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: c,
                                    height: u
                                }), i[s] = {
                                    data: v,
                                    pixelRatio: _,
                                    sdf: d,
                                    stretchX: f,
                                    stretchY: m,
                                    content: g
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel: function() {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(e1, this.map._requestManager, function(e1, o) {
                    if (i._spriteRequest = null, e1) i.fire(new t1.ErrorEvent(e1));
                    else if (o) for(var r in o)i.imageManager.addImage(r, o[r]);
                    i.imageManager.setLoaded(!0), i._availableImages = i.imageManager.listImages(), i.dispatcher.broadcast("setImages", i._availableImages), i.fire(new t1.Event("data", {
                        dataType: "style"
                    }));
                });
            }, i.prototype._validateLayer = function(e1) {
                var i = this.sourceCaches[e1.source];
                if (i) {
                    var o = e1.sourceLayer;
                    if (o) {
                        var r = i.getSource();
                        ("geojson" === r.type || r.vectorLayerIds && -1 === r.vectorLayerIds.indexOf(o)) && this.fire(new t1.ErrorEvent(new Error('Source layer "' + o + '" does not exist on source "' + r.id + '" as specified by style layer "' + e1.id + '"')));
                    }
                }
            }, i.prototype.loaded = function() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(var t1 in this.sourceCaches)if (!this.sourceCaches[t1].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }, i.prototype._serializeLayers = function(t1) {
                for(var e1 = [], i = 0, o = t1; i < o.length; i += 1){
                    var r = this._layers[o[i]];
                    "custom" !== r.type && e1.push(r.serialize());
                }
                return e1;
            }, i.prototype.hasTransitions = function() {
                if (this.light && this.light.hasTransition()) return !0;
                for(var t1 in this.sourceCaches)if (this.sourceCaches[t1].hasTransition()) return !0;
                for(var e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }, i.prototype._checkLoaded = function() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }, i.prototype.update = function(e1) {
                if (this._loaded) {
                    var i = this._changed;
                    if (this._changed) {
                        var o = Object.keys(this._updatedLayers), r = Object.keys(this._removedLayers);
                        for(var a in (o.length || r.length) && this._updateWorkerLayers(o, r), this._updatedSources){
                            var n = this._updatedSources[a];
                            "reload" === n ? this._reloadSource(a) : "clear" === n && this._clearSource(a);
                        }
                        for(var s in this._updateTilesForChangedImages(), this._updatedPaintProps)this._layers[s].updateTransitions(e1);
                        this.light.updateTransitions(e1), this._resetUpdates();
                    }
                    var l = {};
                    for(var c in this.sourceCaches){
                        var u = this.sourceCaches[c];
                        l[c] = u.used, u.used = !1;
                    }
                    for(var h = 0, p = this._order; h < p.length; h += 1){
                        var d = this._layers[p[h]];
                        d.recalculate(e1, this._availableImages), !d.isHidden(e1.zoom) && d.source && (this.sourceCaches[d.source].used = !0);
                    }
                    for(var _ in l){
                        var f = this.sourceCaches[_];
                        l[_] !== f.used && f.fire(new t1.Event("data", {
                            sourceDataType: "visibility",
                            dataType: "source",
                            sourceId: _
                        }));
                    }
                    this.light.recalculate(e1), this.z = e1.zoom, i && this.fire(new t1.Event("data", {
                        dataType: "style"
                    }));
                }
            }, i.prototype._updateTilesForChangedImages = function() {
                var t1 = Object.keys(this._changedImages);
                if (t1.length) {
                    for(var e1 in this.sourceCaches)this.sourceCaches[e1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], t1);
                    this._changedImages = {};
                }
            }, i.prototype._updateWorkerLayers = function(t1, e1) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeLayers(t1),
                    removedIds: e1
                });
            }, i.prototype._resetUpdates = function() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
            }, i.prototype.setState = function(e1) {
                var i = this;
                if (this._checkLoaded(), Ue(this, t1.validateStyle(e1))) return !1;
                (e1 = t1.clone$1(e1)).layers = Nt(e1.layers);
                var o = (function(e1, i) {
                    if (!e1) return [
                        {
                            command: Zt.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    var o = [];
                    try {
                        if (!t1.deepEqual(e1.version, i.version)) return [
                            {
                                command: Zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        t1.deepEqual(e1.center, i.center) || o.push({
                            command: Zt.setCenter,
                            args: [
                                i.center
                            ]
                        }), t1.deepEqual(e1.zoom, i.zoom) || o.push({
                            command: Zt.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), t1.deepEqual(e1.bearing, i.bearing) || o.push({
                            command: Zt.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), t1.deepEqual(e1.pitch, i.pitch) || o.push({
                            command: Zt.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), t1.deepEqual(e1.sprite, i.sprite) || o.push({
                            command: Zt.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), t1.deepEqual(e1.glyphs, i.glyphs) || o.push({
                            command: Zt.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), t1.deepEqual(e1.transition, i.transition) || o.push({
                            command: Zt.setTransition,
                            args: [
                                i.transition
                            ]
                        }), t1.deepEqual(e1.light, i.light) || o.push({
                            command: Zt.setLight,
                            args: [
                                i.light
                            ]
                        });
                        var r = {}, a = [];
                        !function(e1, i, o, r) {
                            var a;
                            for(a in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(a) && (i.hasOwnProperty(a) || jt(a, o, r));
                            for(a in i)i.hasOwnProperty(a) && (e1.hasOwnProperty(a) ? t1.deepEqual(e1[a], i[a]) || ("geojson" === e1[a].type && "geojson" === i[a].type && Gt(e1, i, a) ? o.push({
                                command: Zt.setGeoJSONSourceData,
                                args: [
                                    a,
                                    i[a].data
                                ]
                            }) : Vt(a, i, o, r)) : qt(a, i, o));
                        }(e1.sources, i.sources, a, r);
                        var n = [];
                        e1.layers && e1.layers.forEach(function(t1) {
                            r[t1.source] ? o.push({
                                command: Zt.removeLayer,
                                args: [
                                    t1.id
                                ]
                            }) : n.push(t1);
                        }), o = o.concat(a), function(e1, i, o) {
                            i = i || [];
                            var r, a, n, s, l, c, u, h = (e1 = e1 || []).map(Xt), p = i.map(Xt), d = e1.reduce(Ht, {}), _ = i.reduce(Ht, {}), f = h.slice(), m = Object.create(null);
                            for(r = 0, a = 0; r < h.length; r++)_.hasOwnProperty(n = h[r]) ? a++ : (o.push({
                                command: Zt.removeLayer,
                                args: [
                                    n
                                ]
                            }), f.splice(f.indexOf(n, a), 1));
                            for(r = 0, a = 0; r < p.length; r++)f[f.length - 1 - r] !== (n = p[p.length - 1 - r]) && (d.hasOwnProperty(n) ? (o.push({
                                command: Zt.removeLayer,
                                args: [
                                    n
                                ]
                            }), f.splice(f.lastIndexOf(n, f.length - a), 1)) : a++, o.push({
                                command: Zt.addLayer,
                                args: [
                                    _[n],
                                    c = f[f.length - r]
                                ]
                            }), f.splice(f.length - r, 0, n), m[n] = !0);
                            for(r = 0; r < p.length; r++)if (s = d[n = p[r]], l = _[n], !m[n] && !t1.deepEqual(s, l)) {
                                if (t1.deepEqual(s.source, l.source) && t1.deepEqual(s["source-layer"], l["source-layer"]) && t1.deepEqual(s.type, l.type)) {
                                    for(u in Wt(s.layout, l.layout, o, n, null, Zt.setLayoutProperty), Wt(s.paint, l.paint, o, n, null, Zt.setPaintProperty), t1.deepEqual(s.filter, l.filter) || o.push({
                                        command: Zt.setFilter,
                                        args: [
                                            n,
                                            l.filter
                                        ]
                                    }), t1.deepEqual(s.minzoom, l.minzoom) && t1.deepEqual(s.maxzoom, l.maxzoom) || o.push({
                                        command: Zt.setLayerZoomRange,
                                        args: [
                                            n,
                                            l.minzoom,
                                            l.maxzoom
                                        ]
                                    }), s)s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Wt(s[u], l[u], o, n, u.slice(6), Zt.setPaintProperty) : t1.deepEqual(s[u], l[u]) || o.push({
                                        command: Zt.setLayerProperty,
                                        args: [
                                            n,
                                            u,
                                            l[u]
                                        ]
                                    }));
                                    for(u in l)l.hasOwnProperty(u) && !s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Wt(s[u], l[u], o, n, u.slice(6), Zt.setPaintProperty) : t1.deepEqual(s[u], l[u]) || o.push({
                                        command: Zt.setLayerProperty,
                                        args: [
                                            n,
                                            u,
                                            l[u]
                                        ]
                                    }));
                                } else o.push({
                                    command: Zt.removeLayer,
                                    args: [
                                        n
                                    ]
                                }), c = f[f.lastIndexOf(n) + 1], o.push({
                                    command: Zt.addLayer,
                                    args: [
                                        l,
                                        c
                                    ]
                                });
                            }
                        }(n, i.layers, o);
                    } catch (t1) {
                        console.warn("Unable to compute style diff:", t1), o = [
                            {
                                command: Zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), e1).filter(function(t1) {
                    return !(t1.command in Ze);
                });
                if (0 === o.length) return !1;
                var r = o.filter(function(t1) {
                    return !(t1.command in Ne);
                });
                if (r.length > 0) throw new Error("Unimplemented: " + r.map(function(t1) {
                    return t1.command;
                }).join(", ") + ".");
                return o.forEach(function(t1) {
                    "setTransition" !== t1.command && i[t1.command].apply(i, t1.args);
                }), this.stylesheet = e1, !0;
            }, i.prototype.addImage = function(e1, i) {
                if (this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("An image with this name already exists.")));
                this.imageManager.addImage(e1, i), this._afterImageUpdated(e1);
            }, i.prototype.updateImage = function(t1, e1) {
                this.imageManager.updateImage(t1, e1);
            }, i.prototype.getImage = function(t1) {
                return this.imageManager.getImage(t1);
            }, i.prototype.removeImage = function(e1) {
                if (!this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("No image with this name exists.")));
                this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
            }, i.prototype._afterImageUpdated = function(e1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                    dataType: "style"
                }));
            }, i.prototype.listImages = function() {
                return this._checkLoaded(), this.imageManager.listImages();
            }, i.prototype.addSource = function(e1, i, o) {
                var r = this;
                if (void 0 === o && (o = {}), this._checkLoaded(), void 0 !== this.sourceCaches[e1]) throw new Error("There is already a source with this ID");
                if (!i.type) throw new Error("The type property must be defined, but only the following properties were given: " + Object.keys(i).join(", ") + ".");
                if (!([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t1.validateStyle.source, "sources." + e1, i, null, o))) {
                    this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                    var a = this.sourceCaches[e1] = new Dt(e1, i, this.dispatcher);
                    a.style = this, a.setEventedParent(this, function() {
                        return {
                            isSourceLoaded: r.loaded(),
                            source: a.serialize(),
                            sourceId: e1
                        };
                    }), a.onAdd(this.map), this._changed = !0;
                }
            }, i.prototype.removeSource = function(e1) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e1]) throw new Error("There is no source with this ID");
                for(var i in this._layers)if (this._layers[i].source === e1) return this.fire(new t1.ErrorEvent(new Error('Source "' + e1 + '" cannot be removed while layer "' + i + '" is using it.')));
                var o = this.sourceCaches[e1];
                delete this.sourceCaches[e1], delete this._updatedSources[e1], o.fire(new t1.Event("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e1
                })), o.setEventedParent(null), o.clearTiles(), o.onRemove && o.onRemove(this.map), this._changed = !0;
            }, i.prototype.setGeoJSONSourceData = function(t1, e1) {
                this._checkLoaded(), this.sourceCaches[t1].getSource().setData(e1), this._changed = !0;
            }, i.prototype.getSource = function(t1) {
                return this.sourceCaches[t1] && this.sourceCaches[t1].getSource();
            }, i.prototype.addLayer = function(e1, i, o) {
                void 0 === o && (o = {}), this._checkLoaded();
                var r = e1.id;
                if (this.getLayer(r)) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + r + '" already exists on this map')));
                else {
                    var a;
                    if ("custom" === e1.type) {
                        if (Ue(this, t1.validateCustomStyleLayer(e1))) return;
                        a = t1.createStyleLayer(e1);
                    } else {
                        if ("object" == typeof e1.source && (this.addSource(r, e1.source), e1 = t1.clone$1(e1), e1 = t1.extend(e1, {
                            source: r
                        })), this._validate(t1.validateStyle.layer, "layers." + r, e1, {
                            arrayIndex: -1
                        }, o)) return;
                        a = t1.createStyleLayer(e1), this._validateLayer(a), a.setEventedParent(this, {
                            layer: {
                                id: r
                            }
                        }), this._serializedLayers[a.id] = a.serialize();
                    }
                    var n = i ? this._order.indexOf(i) : this._order.length;
                    if (i && -1 === n) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + i + '" does not exist on this map.')));
                    else {
                        if (this._order.splice(n, 0, r), this._layerOrderChanged = !0, this._layers[r] = a, this._removedLayers[r] && a.source && "custom" !== a.type) {
                            var s = this._removedLayers[r];
                            delete this._removedLayers[r], s.type !== a.type ? this._updatedSources[a.source] = "clear" : (this._updatedSources[a.source] = "reload", this.sourceCaches[a.source].pause());
                        }
                        this._updateLayer(a), a.onAdd && a.onAdd(this.map);
                    }
                }
            }, i.prototype.moveLayer = function(e1, i) {
                if (this._checkLoaded(), this._changed = !0, this._layers[e1]) {
                    if (e1 !== i) {
                        var o = this._order.indexOf(e1);
                        this._order.splice(o, 1);
                        var r = i ? this._order.indexOf(i) : this._order.length;
                        i && -1 === r ? this.fire(new t1.ErrorEvent(new Error('Layer with id "' + i + '" does not exist on this map.'))) : (this._order.splice(r, 0, e1), this._layerOrderChanged = !0);
                    }
                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be moved.")));
            }, i.prototype.removeLayer = function(e1) {
                this._checkLoaded();
                var i = this._layers[e1];
                if (i) {
                    i.setEventedParent(null);
                    var o = this._order.indexOf(e1);
                    this._order.splice(o, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = i, delete this._layers[e1], delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], i.onRemove && i.onRemove(this.map);
                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be removed.")));
            }, i.prototype.getLayer = function(t1) {
                return this._layers[t1];
            }, i.prototype.hasLayer = function(t1) {
                return t1 in this._layers;
            }, i.prototype.setLayerZoomRange = function(e1, i, o) {
                this._checkLoaded();
                var r = this.getLayer(e1);
                r ? r.minzoom === i && r.maxzoom === o || (null != i && (r.minzoom = i), null != o && (r.maxzoom = o), this._updateLayer(r)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot have zoom extent.")));
            }, i.prototype.setFilter = function(e1, i, o) {
                void 0 === o && (o = {}), this._checkLoaded();
                var r = this.getLayer(e1);
                if (r) {
                    if (!t1.deepEqual(r.filter, i)) return null == i ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(t1.validateStyle.filter, "layers." + r.id + ".filter", i, null, o) || (r.filter = t1.clone$1(i), this._updateLayer(r)));
                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be filtered.")));
            }, i.prototype.getFilter = function(e1) {
                return t1.clone$1(this.getLayer(e1).filter);
            }, i.prototype.setLayoutProperty = function(e1, i, o, r) {
                void 0 === r && (r = {}), this._checkLoaded();
                var a = this.getLayer(e1);
                a ? t1.deepEqual(a.getLayoutProperty(i), o) || (a.setLayoutProperty(i, o, r), this._updateLayer(a)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
            }, i.prototype.getLayoutProperty = function(e1, i) {
                var o = this.getLayer(e1);
                if (o) return o.getLayoutProperty(i);
                this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style.")));
            }, i.prototype.setPaintProperty = function(e1, i, o, r) {
                void 0 === r && (r = {}), this._checkLoaded();
                var a = this.getLayer(e1);
                a ? t1.deepEqual(a.getPaintProperty(i), o) || (a.setPaintProperty(i, o, r) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[e1] = !0) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
            }, i.prototype.getPaintProperty = function(t1, e1) {
                return this.getLayer(t1).getPaintProperty(e1);
            }, i.prototype.setFeatureState = function(e1, i) {
                this._checkLoaded();
                var o = e1.source, r = e1.sourceLayer, a = this.sourceCaches[o];
                if (void 0 !== a) {
                    var n = a.getSource().type;
                    "geojson" === n && r ? this.fire(new t1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== n || r ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), a.setFeatureState(r, e1.id, i)) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new t1.ErrorEvent(new Error("The source '" + o + "' does not exist in the map's style.")));
            }, i.prototype.removeFeatureState = function(e1, i) {
                this._checkLoaded();
                var o = e1.source, r = this.sourceCaches[o];
                if (void 0 !== r) {
                    var a = r.getSource().type, n = "vector" === a ? e1.sourceLayer : void 0;
                    "vector" !== a || n ? i && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t1.ErrorEvent(new Error("A feature id is required to remove its specific state property."))) : r.removeFeatureState(n, e1.id, i) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new t1.ErrorEvent(new Error("The source '" + o + "' does not exist in the map's style.")));
            }, i.prototype.getFeatureState = function(e1) {
                this._checkLoaded();
                var i = e1.source, o = e1.sourceLayer, r = this.sourceCaches[i];
                if (void 0 !== r) {
                    if ("vector" !== r.getSource().type || o) return void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), r.getFeatureState(o, e1.id);
                    this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new t1.ErrorEvent(new Error("The source '" + i + "' does not exist in the map's style.")));
            }, i.prototype.getTransition = function() {
                return t1.extend({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }, i.prototype.serialize = function() {
                return t1.filterObject({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    light: this.stylesheet.light,
                    center: this.stylesheet.center,
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    sources: t1.mapObject(this.sourceCaches, function(t1) {
                        return t1.serialize();
                    }),
                    layers: this._serializeLayers(this._order)
                }, function(t1) {
                    return void 0 !== t1;
                });
            }, i.prototype._updateLayer = function(t1) {
                this._updatedLayers[t1.id] = !0, t1.source && !this._updatedSources[t1.source] && "raster" !== this.sourceCaches[t1.source].getSource().type && (this._updatedSources[t1.source] = "reload", this.sourceCaches[t1.source].pause()), this._changed = !0;
            }, i.prototype._flattenAndSortRenderedFeatures = function(t1) {
                for(var e1 = this, i = function(t1) {
                    return "fill-extrusion" === e1._layers[t1].type;
                }, o = {}, r = [], a = this._order.length - 1; a >= 0; a--){
                    var n = this._order[a];
                    if (i(n)) {
                        o[n] = a;
                        for(var s = 0, l = t1; s < l.length; s += 1){
                            var c = l[s][n];
                            if (c) for(var u = 0, h = c; u < h.length; u += 1)r.push(h[u]);
                        }
                    }
                }
                r.sort(function(t1, e1) {
                    return e1.intersectionZ - t1.intersectionZ;
                });
                for(var p = [], d = this._order.length - 1; d >= 0; d--){
                    var _ = this._order[d];
                    if (i(_)) for(var f = r.length - 1; f >= 0; f--){
                        var m = r[f].feature;
                        if (o[m.layer.id] < d) break;
                        p.push(m), r.pop();
                    }
                    else for(var g = 0, v = t1; g < v.length; g += 1){
                        var y = v[g][_];
                        if (y) for(var x = 0, b = y; x < b.length; x += 1)p.push(b[x].feature);
                    }
                }
                return p;
            }, i.prototype.queryRenderedFeatures = function(e1, i, o) {
                i && i.filter && this._validate(t1.validateStyle.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                var r = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new t1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                    for(var a = 0, n = i.layers; a < n.length; a += 1){
                        var s = n[a], l = this._layers[s];
                        if (!l) return this.fire(new t1.ErrorEvent(new Error("The layer '" + s + "' does not exist in the map's style and cannot be queried for features."))), [];
                        r[l.source] = !0;
                    }
                }
                var c = [];
                for(var u in i.availableImages = this._availableImages, this.sourceCaches)i.layers && !r[u] || c.push(O(this.sourceCaches[u], this._layers, this._serializedLayers, e1, i, o));
                return this.placement && c.push(function(t1, e1, i, o, r, a, n) {
                    for(var s = {}, l = a.queryRenderedSymbols(o), c = [], u = 0, h = Object.keys(l).map(Number); u < h.length; u += 1)c.push(n[h[u]]);
                    c.sort(F);
                    for(var p = function() {
                        var i = _[d], o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], e1, i.bucketIndex, i.sourceLayerIndex, r.filter, r.layers, r.availableImages, t1);
                        for(var a in o){
                            var n = s[a] = s[a] || [], c = o[a];
                            c.sort(function(t1, e1) {
                                var o = i.featureSortOrder;
                                if (o) {
                                    var r = o.indexOf(t1.featureIndex);
                                    return o.indexOf(e1.featureIndex) - r;
                                }
                                return e1.featureIndex - t1.featureIndex;
                            });
                            for(var u = 0, h = c; u < h.length; u += 1)n.push(h[u]);
                        }
                    }, d = 0, _ = c; d < _.length; d += 1)p();
                    var f = function(e1) {
                        s[e1].forEach(function(o) {
                            var r = o.feature, a = i[t1[e1].source].getFeatureState(r.layer["source-layer"], r.id);
                            r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = a;
                        });
                    };
                    for(var m in s)f(m);
                    return s;
                }(this._layers, this._serializedLayers, this.sourceCaches, e1, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(c);
            }, i.prototype.querySourceFeatures = function(e1, i) {
                i && i.filter && this._validate(t1.validateStyle.filter, "querySourceFeatures.filter", i.filter, null, i);
                var o = this.sourceCaches[e1];
                return o ? function(t1, e1) {
                    for(var i = t1.getRenderableIds().map(function(e1) {
                        return t1.getTileByID(e1);
                    }), o = [], r = {}, a = 0; a < i.length; a++){
                        var n = i[a], s = n.tileID.canonical.key;
                        r[s] || (r[s] = !0, n.querySourceFeatures(o, e1));
                    }
                    return o;
                }(o, i) : [];
            }, i.prototype.addSourceType = function(t1, e1, o) {
                return i.getSourceType(t1) ? o(new Error('A source type called "' + t1 + '" already exists.')) : (i.setSourceType(t1, e1), e1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: t1,
                    url: e1.workerSourceURL
                }, o) : o(null, null));
            }, i.prototype.getLight = function() {
                return this.light.getLight();
            }, i.prototype.setLight = function(e1, i) {
                void 0 === i && (i = {}), this._checkLoaded();
                var o = this.light.getLight(), r = !1;
                for(var a in e1)if (!t1.deepEqual(e1[a], o[a])) {
                    r = !0;
                    break;
                }
                if (r) {
                    var n = {
                        now: t1.browser.now(),
                        transition: t1.extend({
                            duration: 300,
                            delay: 0
                        }, this.stylesheet.transition)
                    };
                    this.light.setLight(e1, i), this.light.updateTransitions(n);
                }
            }, i.prototype._validate = function(e1, i, o, r, a) {
                return void 0 === a && (a = {}), (!a || !1 !== a.validate) && Ue(this, e1.call(t1.validateStyle, t1.extend({
                    key: i,
                    style: this.serialize(),
                    value: o,
                    styleSpec: t1.styleSpec
                }, r)));
            }, i.prototype._remove = function() {
                for(var e1 in this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t1.evented.off("pluginStateChange", this._rtlTextPluginCallback), this._layers)this._layers[e1].setEventedParent(null);
                for(var i in this.sourceCaches)this.sourceCaches[i].clearTiles(), this.sourceCaches[i].setEventedParent(null);
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
            }, i.prototype._clearSource = function(t1) {
                this.sourceCaches[t1].clearTiles();
            }, i.prototype._reloadSource = function(t1) {
                this.sourceCaches[t1].resume(), this.sourceCaches[t1].reload();
            }, i.prototype._updateSources = function(t1) {
                for(var e1 in this.sourceCaches)this.sourceCaches[e1].update(t1);
            }, i.prototype._generateCollisionBoxes = function() {
                for(var t1 in this.sourceCaches)this._reloadSource(t1);
            }, i.prototype._updatePlacement = function(e1, i, o, r, a) {
                void 0 === a && (a = !1);
                for(var n = !1, s = !1, l = {}, c = 0, u = this._order; c < u.length; c += 1){
                    var h = this._layers[u[c]];
                    if ("symbol" === h.type) {
                        if (!l[h.source]) {
                            var p = this.sourceCaches[h.source];
                            l[h.source] = p.getRenderableIds(!0).map(function(t1) {
                                return p.getTileByID(t1);
                            }).sort(function(t1, e1) {
                                return e1.tileID.overscaledZ - t1.tileID.overscaledZ || (t1.tileID.isLessThan(e1.tileID) ? -1 : 1);
                            });
                        }
                        var d = this.crossTileSymbolIndex.addLayer(h, l[h.source], e1.center.lng);
                        n = n || d;
                    }
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((a = a || this._layerOrderChanged || 0 === o) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t1.browser.now(), e1.zoom)) && (this.pauseablePlacement = new Le(e1, this._order, a, i, o, r, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t1.browser.now()), s = !0), n && this.pauseablePlacement.placement.setStale()), s || n) for(var _ = 0, f = this._order; _ < f.length; _ += 1){
                    var m = this._layers[f[_]];
                    "symbol" === m.type && this.placement.updateLayerOpacities(m, l[m.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t1.browser.now());
            }, i.prototype._releaseSymbolFadeTiles = function() {
                for(var t1 in this.sourceCaches)this.sourceCaches[t1].releaseSymbolFadeTiles();
            }, i.prototype.getImages = function(t1, e1, i) {
                this.imageManager.getImages(e1.icons, i), this._updateTilesForChangedImages();
                var o = this.sourceCaches[e1.source];
                o && o.setDependencies(e1.tileID.key, e1.type, e1.icons);
            }, i.prototype.getGlyphs = function(t1, e1, i) {
                this.glyphManager.getGlyphs(e1.stacks, i);
            }, i.prototype.getResource = function(e1, i, o) {
                return t1.makeRequest(i, o);
            }, i;
        }(t1.Evented);
        je.getSourceType = function(t1) {
            return k[t1];
        }, je.setSourceType = function(t1, e1) {
            k[t1] = e1;
        }, je.registerForPluginStateChange = t1.registerForPluginStateChange;
        var Ve = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]), Ge = gi("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"), We = gi("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), Xe = gi("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"), He = gi("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"), Ke = gi("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), Ye = gi("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"), Je = gi("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"), Qe = gi("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"), $e = gi("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), ti = gi("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}"), ei = gi("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"), ii = gi("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), oi = gi("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), ri = gi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"), ai = gi("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"), ni = gi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"), si = gi("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), li = gi("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"), ci = gi("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), ui = gi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), hi = gi("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"), pi = gi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"), di = gi("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"), _i = gi("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"), fi = gi("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"), mi = gi("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");
        function gi(t1, e1) {
            var i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, o = e1.match(/attribute ([\w]+) ([\w]+)/g), r = t1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), n = a ? a.concat(r) : r, s = {};
            return {
                fragmentSource: t1 = t1.replace(i, function(t1, e1, i, o, r) {
                    return s[r] = !0, "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + r + "\nvarying " + i + " " + o + " " + r + ";\n#else\nuniform " + i + " " + o + " u_" + r + ";\n#endif\n" : "\n#ifdef HAS_UNIFORM_u_" + r + "\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n";
                }),
                vertexSource: e1 = e1.replace(i, function(t1, e1, i, o, r) {
                    var a = "float" === o ? "vec2" : "vec4", n = r.match(/color/) ? "color" : a;
                    return s[r] ? "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + r + "\nuniform lowp float u_" + r + "_t;\nattribute " + i + " " + a + " a_" + r + ";\nvarying " + i + " " + o + " " + r + ";\n#else\nuniform " + i + " " + o + " u_" + r + ";\n#endif\n" : "vec4" === n ? "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + r + " = a_" + r + ";\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + r + " = unpack_mix_" + n + "(a_" + r + ", u_" + r + "_t);\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n" : "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + r + "\nuniform lowp float u_" + r + "_t;\nattribute " + i + " " + a + " a_" + r + ";\n#else\nuniform " + i + " " + o + " u_" + r + ";\n#endif\n" : "vec4" === n ? "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + i + " " + o + " " + r + " = a_" + r + ";\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + i + " " + o + " " + r + " = unpack_mix_" + n + "(a_" + r + ", u_" + r + "_t);\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n";
                }),
                staticAttributes: o,
                staticUniforms: n
            };
        }
        var vi = Object.freeze({
            __proto__: null,
            prelude: Ge,
            background: We,
            backgroundPattern: Xe,
            circle: He,
            clippingMask: Ke,
            heatmap: Ye,
            heatmapTexture: Je,
            collisionBox: Qe,
            collisionCircle: $e,
            debug: ti,
            fill: ei,
            fillOutline: ii,
            fillOutlinePattern: oi,
            fillPattern: ri,
            fillExtrusion: ai,
            fillExtrusionPattern: ni,
            hillshadePrepare: si,
            hillshade: li,
            line: ci,
            lineGradient: ui,
            linePattern: hi,
            lineSDF: pi,
            raster: di,
            symbolIcon: _i,
            symbolSDF: fi,
            symbolTextAndIcon: mi
        }), yi = function() {
            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
        };
        function xi(t1) {
            for(var e1 = [], i = 0; i < t1.length; i++)if (null !== t1[i]) {
                var o = t1[i].split(" ");
                e1.push(o.pop());
            }
            return e1;
        }
        yi.prototype.bind = function(t1, e1, i, o, r, a, n, s) {
            this.context = t1;
            for(var l = this.boundPaintVertexBuffers.length !== o.length, c = 0; !l && c < o.length; c++)this.boundPaintVertexBuffers[c] !== o[c] && (l = !0);
            t1.extVertexArrayObject && this.vao && this.boundProgram === e1 && this.boundLayoutVertexBuffer === i && !l && this.boundIndexBuffer === r && this.boundVertexOffset === a && this.boundDynamicVertexBuffer === n && this.boundDynamicVertexBuffer2 === s ? (t1.bindVertexArrayOES.set(this.vao), n && n.bind(), r && r.dynamicDraw && r.bind(), s && s.bind()) : this.freshBind(e1, i, o, r, a, n, s);
        }, yi.prototype.freshBind = function(t1, e1, i, o, r, a, n) {
            var s, l = t1.numAttributes, c = this.context, u = c.gl;
            if (c.extVertexArrayObject) this.vao && this.destroy(), this.vao = c.extVertexArrayObject.createVertexArrayOES(), c.bindVertexArrayOES.set(this.vao), s = 0, this.boundProgram = t1, this.boundLayoutVertexBuffer = e1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = r, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = n;
            else {
                s = c.currentNumAttributes || 0;
                for(var h = l; h < s; h++)u.disableVertexAttribArray(h);
            }
            e1.enableAttributes(u, t1);
            for(var p = 0, d = i; p < d.length; p += 1)d[p].enableAttributes(u, t1);
            a && a.enableAttributes(u, t1), n && n.enableAttributes(u, t1), e1.bind(), e1.setVertexAttribPointers(u, t1, r);
            for(var _ = 0, f = i; _ < f.length; _ += 1){
                var m = f[_];
                m.bind(), m.setVertexAttribPointers(u, t1, r);
            }
            a && (a.bind(), a.setVertexAttribPointers(u, t1, r)), o && o.bind(), n && (n.bind(), n.setVertexAttribPointers(u, t1, r)), c.currentNumAttributes = l;
        }, yi.prototype.destroy = function() {
            this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
        };
        var bi = function(t1, e1, i, o, r, a) {
            var n = t1.gl;
            this.program = n.createProgram();
            for(var s = xi(i.staticAttributes), l = o ? o.getBinderAttributes() : [], c = s.concat(l), u = i.staticUniforms ? xi(i.staticUniforms) : [], h = o ? o.getBinderUniforms() : [], p = [], d = 0, _ = u.concat(h); d < _.length; d += 1){
                var f = _[d];
                p.indexOf(f) < 0 && p.push(f);
            }
            var m = o ? o.defines() : [];
            a && m.push("#define OVERDRAW_INSPECTOR;");
            var g = m.concat(Ge.fragmentSource, i.fragmentSource).join("\n"), v = m.concat(Ge.vertexSource, i.vertexSource).join("\n"), y = n.createShader(n.FRAGMENT_SHADER);
            if (n.isContextLost()) this.failedToCreate = !0;
            else {
                n.shaderSource(y, g), n.compileShader(y), n.attachShader(this.program, y);
                var x = n.createShader(n.VERTEX_SHADER);
                if (n.isContextLost()) this.failedToCreate = !0;
                else {
                    n.shaderSource(x, v), n.compileShader(x), n.attachShader(this.program, x), this.attributes = {};
                    var b = {};
                    this.numAttributes = c.length;
                    for(var w = 0; w < this.numAttributes; w++)c[w] && (n.bindAttribLocation(this.program, w, c[w]), this.attributes[c[w]] = w);
                    n.linkProgram(this.program), n.deleteShader(x), n.deleteShader(y);
                    for(var T = 0; T < p.length; T++){
                        var E = p[T];
                        if (E && !b[E]) {
                            var I = n.getUniformLocation(this.program, E);
                            I && (b[E] = I);
                        }
                    }
                    this.fixedUniforms = r(t1, b), this.binderUniforms = o ? o.getUniforms(t1, b) : [];
                }
            }
        };
        function wi(t1, e1, i) {
            var o = 1 / pe(i, 1, e1.transform.tileZoom), r = Math.pow(2, i.tileID.overscaledZ), a = i.tileSize * Math.pow(2, e1.transform.tileZoom) / r, n = a * (i.tileID.canonical.x + i.tileID.wrap * r), s = a * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    o,
                    t1.fromScale,
                    t1.toScale
                ],
                u_fade: t1.t,
                u_pixel_coord_upper: [
                    n >> 16,
                    s >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & s
                ]
            };
        }
        bi.prototype.draw = function(t1, e1, i, o, r, a, n, s, l, c, u, h, p, d, _, f) {
            var m, g = t1.gl;
            if (!this.failedToCreate) {
                for(var v in t1.program.set(this.program), t1.setDepthMode(i), t1.setStencilMode(o), t1.setColorMode(r), t1.setCullFace(a), this.fixedUniforms)this.fixedUniforms[v].set(n[v]);
                d && d.setUniforms(t1, this.binderUniforms, h, {
                    zoom: p
                });
                for(var y = (m = {}, m[g.LINES] = 2, m[g.TRIANGLES] = 3, m[g.LINE_STRIP] = 1, m)[e1], x = 0, b = u.get(); x < b.length; x += 1){
                    var w = b[x], T = w.vaos || (w.vaos = {});
                    (T[s] || (T[s] = new yi)).bind(t1, this, l, d ? d.getPaintVertexBuffers() : [], c, w.vertexOffset, _, f), g.drawElements(e1, w.primitiveLength * y, g.UNSIGNED_SHORT, w.primitiveOffset * y * 2);
                }
            }
        };
        var Ti = function(e1, i, o, r) {
            var a = i.style.light, n = a.properties.get("position"), s = [
                n.x,
                n.y,
                n.z
            ], l = t1.create$1();
            "viewport" === a.properties.get("anchor") && t1.fromRotation(l, -i.transform.angle), t1.transformMat3(s, s, l);
            var c = a.properties.get("color");
            return {
                u_matrix: e1,
                u_lightpos: s,
                u_lightintensity: a.properties.get("intensity"),
                u_lightcolor: [
                    c.r,
                    c.g,
                    c.b
                ],
                u_vertical_gradient: +o,
                u_opacity: r
            };
        }, Ei = function(e1, i, o, r, a, n, s) {
            return t1.extend(Ti(e1, i, o, r), wi(n, i, s), {
                u_height_factor: -Math.pow(2, a.overscaledZ) / s.tileSize / 8
            });
        }, Ii = function(t1) {
            return {
                u_matrix: t1
            };
        }, Pi = function(e1, i, o, r) {
            return t1.extend(Ii(e1), wi(o, i, r));
        }, Si = function(t1, e1) {
            return {
                u_matrix: t1,
                u_world: e1
            };
        }, Ci = function(e1, i, o, r, a) {
            return t1.extend(Pi(e1, i, o, r), {
                u_world: a
            });
        }, zi = function(e1, i, o, r) {
            var a, n, s = e1.transform;
            if ("map" === r.paint.get("circle-pitch-alignment")) {
                var l = pe(o, 1, s.zoom);
                a = !0, n = [
                    l,
                    l
                ];
            } else a = !1, n = s.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_scale_with_map: +("map" === r.paint.get("circle-pitch-scale")),
                u_matrix: e1.translatePosMatrix(i.posMatrix, o, r.paint.get("circle-translate"), r.paint.get("circle-translate-anchor")),
                u_pitch_with_map: +a,
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_extrude_scale: n
            };
        }, Di = function(t1, e1, i) {
            var o = pe(i, 1, e1.zoom), r = Math.pow(2, e1.zoom - i.tileID.overscaledZ), a = i.tileID.overscaleFactor();
            return {
                u_matrix: t1,
                u_camera_to_center_distance: e1.cameraToCenterDistance,
                u_pixels_to_tile_units: o,
                u_extrude_scale: [
                    e1.pixelsToGLUnits[0] / (o * r),
                    e1.pixelsToGLUnits[1] / (o * r)
                ],
                u_overscale_factor: a
            };
        }, Ai = function(t1, e1, i) {
            return {
                u_matrix: t1,
                u_inv_matrix: e1,
                u_camera_to_center_distance: i.cameraToCenterDistance,
                u_viewport_size: [
                    i.width,
                    i.height
                ]
            };
        }, Mi = function(t1, e1, i) {
            return void 0 === i && (i = 1), {
                u_matrix: t1,
                u_color: e1,
                u_overlay: 0,
                u_overlay_scale: i
            };
        }, Li = function(t1) {
            return {
                u_matrix: t1
            };
        }, Ri = function(t1, e1, i, o) {
            return {
                u_matrix: t1,
                u_extrude_scale: pe(e1, 1, i),
                u_intensity: o
            };
        }, ki = function(e1, i, o) {
            var r = e1.transform;
            return {
                u_matrix: Ni(e1, i, o),
                u_ratio: 1 / pe(i, 1, r.zoom),
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_units_to_pixels: [
                    1 / r.pixelsToGLUnits[0],
                    1 / r.pixelsToGLUnits[1]
                ]
            };
        }, Bi = function(e1, i, o, r) {
            return t1.extend(ki(e1, i, o), {
                u_image: 0,
                u_image_height: r
            });
        }, Oi = function(e1, i, o, r) {
            var a = e1.transform, n = Ui(i, a);
            return {
                u_matrix: Ni(e1, i, o),
                u_texsize: i.imageAtlasTexture.size,
                u_ratio: 1 / pe(i, 1, a.zoom),
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_image: 0,
                u_scale: [
                    n,
                    r.fromScale,
                    r.toScale
                ],
                u_fade: r.t,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ]
            };
        }, Fi = function(e1, i, o, r, a) {
            var n = e1.lineAtlas, s = Ui(i, e1.transform), l = "round" === o.layout.get("line-cap"), c = n.getDash(r.from, l), u = n.getDash(r.to, l), h = c.width * a.fromScale, p = u.width * a.toScale;
            return t1.extend(ki(e1, i, o), {
                u_patternscale_a: [
                    s / h,
                    -c.height / 2
                ],
                u_patternscale_b: [
                    s / p,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(h, p) * t1.browser.devicePixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: c.y,
                u_tex_y_b: u.y,
                u_mix: a.t
            });
        };
        function Ui(t1, e1) {
            return 1 / pe(t1, 1, e1.tileZoom);
        }
        function Ni(t1, e1, i) {
            return t1.translatePosMatrix(e1.tileID.posMatrix, e1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        var Zi = function(t1, e1, i, o, r) {
            var a, n;
            return {
                u_matrix: t1,
                u_tl_parent: e1,
                u_scale_parent: i,
                u_buffer_scale: 1,
                u_fade_t: o.mix,
                u_opacity: o.opacity * r.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: r.paint.get("raster-brightness-min"),
                u_brightness_high: r.paint.get("raster-brightness-max"),
                u_saturation_factor: (n = r.paint.get("raster-saturation"), n > 0 ? 1 - 1 / (1.001 - n) : -n),
                u_contrast_factor: (a = r.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
                u_spin_weights: qi(r.paint.get("raster-hue-rotate"))
            };
        };
        function qi(t1) {
            t1 *= Math.PI / 180;
            var e1 = Math.sin(t1), i = Math.cos(t1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * e1 - i + 1) / 3,
                (Math.sqrt(3) * e1 - i + 1) / 3
            ];
        }
        var ji, Vi = function(t1, e1, i, o, r, a, n, s, l, c) {
            var u = r.transform;
            return {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: e1 ? e1.uSizeT : 0,
                u_size: e1 ? e1.uSize : 0,
                u_camera_to_center_distance: u.cameraToCenterDistance,
                u_pitch: u.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: u.width / u.height,
                u_fade_change: r.options.fadeDuration ? r.symbolFadeChange : 1,
                u_matrix: a,
                u_label_plane_matrix: n,
                u_coord_matrix: s,
                u_is_text: +l,
                u_pitch_with_map: +o,
                u_texsize: c,
                u_texture: 0
            };
        }, Gi = function(e1, i, o, r, a, n, s, l, c, u, h) {
            var p = a.transform;
            return t1.extend(Vi(e1, i, o, r, a, n, s, l, c, u), {
                u_gamma_scale: r ? Math.cos(p._pitch) * p.cameraToCenterDistance : 1,
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_is_halo: +h
            });
        }, Wi = function(e1, i, o, r, a, n, s, l, c, u) {
            return t1.extend(Gi(e1, i, o, r, a, n, s, l, !0, c, !0), {
                u_texsize_icon: u,
                u_texture_icon: 1
            });
        }, Xi = function(t1, e1, i) {
            return {
                u_matrix: t1,
                u_opacity: e1,
                u_color: i
            };
        }, Hi = function(e1, i, o, r, a, n) {
            return t1.extend(function(t1, e1, i, o) {
                var r = i.imageManager.getPattern(t1.from.toString()), a = i.imageManager.getPattern(t1.to.toString()), n = i.imageManager.getPixelSize(), s = n.width, l = n.height, c = Math.pow(2, o.tileID.overscaledZ), u = o.tileSize * Math.pow(2, i.transform.tileZoom) / c, h = u * (o.tileID.canonical.x + o.tileID.wrap * c), p = u * o.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: r.tl,
                    u_pattern_br_a: r.br,
                    u_pattern_tl_b: a.tl,
                    u_pattern_br_b: a.br,
                    u_texsize: [
                        s,
                        l
                    ],
                    u_mix: e1.t,
                    u_pattern_size_a: r.displaySize,
                    u_pattern_size_b: a.displaySize,
                    u_scale_a: e1.fromScale,
                    u_scale_b: e1.toScale,
                    u_tile_units_to_pixels: 1 / pe(o, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        h >> 16,
                        p >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & h,
                        65535 & p
                    ]
                };
            }(r, n, o, a), {
                u_matrix: e1,
                u_opacity: i
            });
        }, Ki = {
            fillExtrusion: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                };
            },
            fillExtrusionPattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_height_factor: new t1.Uniform1f(e1, i.u_height_factor),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                };
            },
            fill: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            fillPattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                };
            },
            fillOutline: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world)
                };
            },
            fillOutlinePattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                };
            },
            circle: function(e1, i) {
                return {
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_scale_with_map: new t1.Uniform1i(e1, i.u_scale_with_map),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            collisionBox: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pixels_to_tile_units: new t1.Uniform1f(e1, i.u_pixels_to_tile_units),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_overscale_factor: new t1.Uniform1f(e1, i.u_overscale_factor)
                };
            },
            collisionCircle: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_inv_matrix: new t1.UniformMatrix4f(e1, i.u_inv_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_viewport_size: new t1.Uniform2f(e1, i.u_viewport_size)
                };
            },
            debug: function(e1, i) {
                return {
                    u_color: new t1.UniformColor(e1, i.u_color),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_overlay: new t1.Uniform1i(e1, i.u_overlay),
                    u_overlay_scale: new t1.Uniform1f(e1, i.u_overlay_scale)
                };
            },
            clippingMask: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            heatmap: function(e1, i) {
                return {
                    u_extrude_scale: new t1.Uniform1f(e1, i.u_extrude_scale),
                    u_intensity: new t1.Uniform1f(e1, i.u_intensity),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            heatmapTexture: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_color_ramp: new t1.Uniform1i(e1, i.u_color_ramp),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                };
            },
            hillshade: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_latrange: new t1.Uniform2f(e1, i.u_latrange),
                    u_light: new t1.Uniform2f(e1, i.u_light),
                    u_shadow: new t1.UniformColor(e1, i.u_shadow),
                    u_highlight: new t1.UniformColor(e1, i.u_highlight),
                    u_accent: new t1.UniformColor(e1, i.u_accent)
                };
            },
            hillshadePrepare: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_dimension: new t1.Uniform2f(e1, i.u_dimension),
                    u_zoom: new t1.Uniform1f(e1, i.u_zoom),
                    u_unpack: new t1.Uniform4f(e1, i.u_unpack)
                };
            },
            line: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels)
                };
            },
            lineGradient: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_image_height: new t1.Uniform1f(e1, i.u_image_height)
                };
            },
            linePattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                };
            },
            lineSDF: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_patternscale_a: new t1.Uniform2f(e1, i.u_patternscale_a),
                    u_patternscale_b: new t1.Uniform2f(e1, i.u_patternscale_b),
                    u_sdfgamma: new t1.Uniform1f(e1, i.u_sdfgamma),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_tex_y_a: new t1.Uniform1f(e1, i.u_tex_y_a),
                    u_tex_y_b: new t1.Uniform1f(e1, i.u_tex_y_b),
                    u_mix: new t1.Uniform1f(e1, i.u_mix)
                };
            },
            raster: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_tl_parent: new t1.Uniform2f(e1, i.u_tl_parent),
                    u_scale_parent: new t1.Uniform1f(e1, i.u_scale_parent),
                    u_buffer_scale: new t1.Uniform1f(e1, i.u_buffer_scale),
                    u_fade_t: new t1.Uniform1f(e1, i.u_fade_t),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image0: new t1.Uniform1i(e1, i.u_image0),
                    u_image1: new t1.Uniform1i(e1, i.u_image1),
                    u_brightness_low: new t1.Uniform1f(e1, i.u_brightness_low),
                    u_brightness_high: new t1.Uniform1f(e1, i.u_brightness_high),
                    u_saturation_factor: new t1.Uniform1f(e1, i.u_saturation_factor),
                    u_contrast_factor: new t1.Uniform1f(e1, i.u_contrast_factor),
                    u_spin_weights: new t1.Uniform3f(e1, i.u_spin_weights)
                };
            },
            symbolIcon: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture)
                };
            },
            symbolSDF: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                };
            },
            symbolTextAndIcon: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texsize_icon: new t1.Uniform2f(e1, i.u_texsize_icon),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_texture_icon: new t1.Uniform1i(e1, i.u_texture_icon),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                };
            },
            background: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_color: new t1.UniformColor(e1, i.u_color)
                };
            },
            backgroundPattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_pattern_tl_a: new t1.Uniform2f(e1, i.u_pattern_tl_a),
                    u_pattern_br_a: new t1.Uniform2f(e1, i.u_pattern_br_a),
                    u_pattern_tl_b: new t1.Uniform2f(e1, i.u_pattern_tl_b),
                    u_pattern_br_b: new t1.Uniform2f(e1, i.u_pattern_br_b),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_mix: new t1.Uniform1f(e1, i.u_mix),
                    u_pattern_size_a: new t1.Uniform2f(e1, i.u_pattern_size_a),
                    u_pattern_size_b: new t1.Uniform2f(e1, i.u_pattern_size_b),
                    u_scale_a: new t1.Uniform1f(e1, i.u_scale_a),
                    u_scale_b: new t1.Uniform1f(e1, i.u_scale_b),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t1.Uniform1f(e1, i.u_tile_units_to_pixels)
                };
            }
        };
        function Yi(e1, i, o, r, a, n, s) {
            for(var l = e1.context, c = l.gl, u = e1.useProgram("collisionBox"), h = [], p = 0, d = 0, _ = 0; _ < r.length; _++){
                var f = r[_], m = i.getTile(f), g = m.getBucket(o);
                if (g) {
                    var v = f.posMatrix;
                    0 === a[0] && 0 === a[1] || (v = e1.translatePosMatrix(f.posMatrix, m, a, n));
                    var y = s ? g.textCollisionBox : g.iconCollisionBox, x = g.collisionCircleArray;
                    if (x.length > 0) {
                        var b = t1.create(), w = v;
                        t1.mul(b, g.placementInvProjMatrix, e1.transform.glCoordMatrix), t1.mul(b, b, g.placementViewportMatrix), h.push({
                            circleArray: x,
                            circleOffset: d,
                            transform: w,
                            invTransform: b
                        }), d = p += x.length / 4;
                    }
                    y && u.draw(l, c.LINES, It.disabled, Pt.disabled, e1.colorModeForRenderPass(), Ct.disabled, Di(v, e1.transform, m), o.id, y.layoutVertexBuffer, y.indexBuffer, y.segments, null, e1.transform.zoom, null, null, y.collisionVertexBuffer);
                }
            }
            if (s && h.length) {
                var T = e1.useProgram("collisionCircle"), E = new t1.StructArrayLayout2f1f2i16;
                E.resize(4 * p), E._trim();
                for(var I = 0, P = 0, S = h; P < S.length; P += 1)for(var C = S[P], z = 0; z < C.circleArray.length / 4; z++){
                    var D = 4 * z, A = C.circleArray[D + 0], M = C.circleArray[D + 1], L = C.circleArray[D + 2], R = C.circleArray[D + 3];
                    E.emplace(I++, A, M, L, R, 0), E.emplace(I++, A, M, L, R, 1), E.emplace(I++, A, M, L, R, 2), E.emplace(I++, A, M, L, R, 3);
                }
                (!ji || ji.length < 2 * p) && (ji = function(e1) {
                    var i = 2 * e1, o = new t1.StructArrayLayout3ui6;
                    o.resize(i), o._trim();
                    for(var r = 0; r < i; r++){
                        var a = 6 * r;
                        o.uint16[a + 0] = 4 * r + 0, o.uint16[a + 1] = 4 * r + 1, o.uint16[a + 2] = 4 * r + 2, o.uint16[a + 3] = 4 * r + 2, o.uint16[a + 4] = 4 * r + 3, o.uint16[a + 5] = 4 * r + 0;
                    }
                    return o;
                }(p));
                for(var k = l.createIndexBuffer(ji, !0), B = l.createVertexBuffer(E, t1.collisionCircleLayout.members, !0), O = 0, F = h; O < F.length; O += 1){
                    var U = F[O], N = Ai(U.transform, U.invTransform, e1.transform);
                    T.draw(l, c.TRIANGLES, It.disabled, Pt.disabled, e1.colorModeForRenderPass(), Ct.disabled, N, o.id, B, k, t1.SegmentVector.simpleSegment(0, 2 * U.circleOffset, U.circleArray.length, U.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
                }
                B.destroy(), k.destroy();
            }
        }
        var Ji = t1.identity(new Float32Array(16));
        function Qi(e1, i, o, r, a, n) {
            var s = t1.getAnchorAlignment(e1), l = -(s.horizontalAlign - .5) * i, c = -(s.verticalAlign - .5) * o, u = t1.evaluateVariableOffset(e1, r);
            return new t1.Point((l / a + u[0]) * n, (c / a + u[1]) * n);
        }
        function $i(e1, i, o, r, a, n, s, l, c, u, h) {
            var p = e1.text.placedSymbolArray, d = e1.text.dynamicLayoutVertexArray, _ = e1.icon.dynamicLayoutVertexArray, f = {};
            d.clear();
            for(var m = 0; m < p.length; m++){
                var g = p.get(m), v = g.hidden || !g.crossTileID || e1.allowVerticalPlacement && !g.placedOrientation ? null : r[g.crossTileID];
                if (v) {
                    var y = new t1.Point(g.anchorX, g.anchorY), x = $t(y, o ? l : s), b = te(n.cameraToCenterDistance, x.signedDistanceFromCamera), w = a.evaluateSizeForFeature(e1.textSizeData, u, g) * b / t1.ONE_EM;
                    o && (w *= e1.tilePixelRatio / c);
                    for(var T = Qi(v.anchor, v.width, v.height, v.textOffset, v.textBoxScale, w), E = o ? $t(y.add(T), s).point : x.point.add(i ? T.rotate(-n.angle) : T), I = e1.allowVerticalPlacement && g.placedOrientation === t1.WritingMode.vertical ? Math.PI / 2 : 0, P = 0; P < g.numGlyphs; P++)t1.addDynamicAttributes(d, E, I);
                    h && g.associatedIconIndex >= 0 && (f[g.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: I
                    });
                } else ce(g.numGlyphs, d);
            }
            if (h) {
                _.clear();
                for(var S = e1.icon.placedSymbolArray, C = 0; C < S.length; C++){
                    var z = S.get(C);
                    if (z.hidden) ce(z.numGlyphs, _);
                    else {
                        var D = f[C];
                        if (D) for(var A = 0; A < z.numGlyphs; A++)t1.addDynamicAttributes(_, D.shiftedAnchor, D.angle);
                        else ce(z.numGlyphs, _);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(_);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(d);
        }
        function to(t1, e1, i) {
            return i.iconsInText && e1 ? "symbolTextAndIcon" : t1 ? "symbolSDF" : "symbolIcon";
        }
        function eo(e1, i, o, r, a, n, s, l, c, u, h, p) {
            for(var d = e1.context, _ = d.gl, f = e1.transform, m = "map" === l, g = "map" === c, v = m && "point" !== o.layout.get("symbol-placement"), y = m && !g && !v, x = void 0 !== o.layout.get("symbol-sort-key").constantOr(1), b = !1, w = e1.depthModeForSublayer(0, It.ReadOnly), T = o.layout.get("text-variable-anchor"), E = [], I = 0, P = r; I < P.length; I += 1){
                var S = P[I], C = i.getTile(S), z = C.getBucket(o);
                if (z) {
                    var D = a ? z.text : z.icon;
                    if (D && D.segments.get().length) {
                        var A = D.programConfigurations.get(o.id), M = a || z.sdfIcons, L = a ? z.textSizeData : z.iconSizeData, R = g || 0 !== f.pitch, k = e1.useProgram(to(M, a, z), A), B = t1.evaluateSizeForZoom(L, f.zoom), O = void 0, F = [
                            0,
                            0
                        ], U = void 0, N = void 0, Z = null, q = void 0;
                        if (a) U = C.glyphAtlasTexture, N = _.LINEAR, O = C.glyphAtlasTexture.size, z.iconsInText && (F = C.imageAtlasTexture.size, Z = C.imageAtlasTexture, q = R || e1.options.rotating || e1.options.zooming || "composite" === L.kind || "camera" === L.kind ? _.LINEAR : _.NEAREST);
                        else {
                            var j = 1 !== o.layout.get("icon-size").constantOr(0) || z.iconsNeedLinear;
                            U = C.imageAtlasTexture, N = M || e1.options.rotating || e1.options.zooming || j || R ? _.LINEAR : _.NEAREST, O = C.imageAtlasTexture.size;
                        }
                        var V = pe(C, 1, e1.transform.zoom), G = Jt(S.posMatrix, g, m, e1.transform, V), W = Qt(S.posMatrix, g, m, e1.transform, V), X = T && z.hasTextData(), H = "none" !== o.layout.get("icon-text-fit") && X && z.hasIconData();
                        v && ie(z, S.posMatrix, e1, a, G, W, g, u);
                        var K = e1.translatePosMatrix(S.posMatrix, C, n, s), Y = v || a && T || H ? Ji : G, J = e1.translatePosMatrix(W, C, n, s, !0), Q = M && 0 !== o.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1), $ = {
                            program: k,
                            buffers: D,
                            uniformValues: M ? z.iconsInText ? Wi(L.kind, B, y, g, e1, K, Y, J, O, F) : Gi(L.kind, B, y, g, e1, K, Y, J, a, O, !0) : Vi(L.kind, B, y, g, e1, K, Y, J, a, O),
                            atlasTexture: U,
                            atlasTextureIcon: Z,
                            atlasInterpolation: N,
                            atlasInterpolationIcon: q,
                            isSDF: M,
                            hasHalo: Q
                        };
                        if (x && z.canOverlap) {
                            b = !0;
                            for(var tt = 0, et = D.segments.get(); tt < et.length; tt += 1){
                                var it = et[tt];
                                E.push({
                                    segments: new t1.SegmentVector([
                                        it
                                    ]),
                                    sortKey: it.sortKey,
                                    state: $
                                });
                            }
                        } else E.push({
                            segments: D.segments,
                            sortKey: 0,
                            state: $
                        });
                    }
                }
            }
            b && E.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var ot = 0, rt = E; ot < rt.length; ot += 1){
                var at = rt[ot], nt = at.state;
                if (d.activeTexture.set(_.TEXTURE0), nt.atlasTexture.bind(nt.atlasInterpolation, _.CLAMP_TO_EDGE), nt.atlasTextureIcon && (d.activeTexture.set(_.TEXTURE1), nt.atlasTextureIcon && nt.atlasTextureIcon.bind(nt.atlasInterpolationIcon, _.CLAMP_TO_EDGE)), nt.isSDF) {
                    var st = nt.uniformValues;
                    nt.hasHalo && (st.u_is_halo = 1, io(nt.buffers, at.segments, o, e1, nt.program, w, h, p, st)), st.u_is_halo = 0;
                }
                io(nt.buffers, at.segments, o, e1, nt.program, w, h, p, nt.uniformValues);
            }
        }
        function io(t1, e1, i, o, r, a, n, s, l) {
            var c = o.context;
            r.draw(c, c.gl.TRIANGLES, a, n, s, Ct.disabled, l, i.id, t1.layoutVertexBuffer, t1.indexBuffer, e1, i.paint, o.transform.zoom, t1.programConfigurations.get(i.id), t1.dynamicLayoutVertexBuffer, t1.opacityVertexBuffer);
        }
        function oo(t1, e1, i, o, r, a, n) {
            var s, l, c, u, h, p = t1.context.gl, d = i.paint.get("fill-pattern"), _ = d && d.constantOr(1), f = i.getCrossfadeParameters();
            n ? (l = _ && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", s = p.LINES) : (l = _ ? "fillPattern" : "fill", s = p.TRIANGLES);
            for(var m = 0, g = o; m < g.length; m += 1){
                var v = g[m], y = e1.getTile(v);
                if (!_ || y.patternsLoaded()) {
                    var x = y.getBucket(i);
                    if (x) {
                        var b = x.programConfigurations.get(i.id), w = t1.useProgram(l, b);
                        _ && (t1.context.activeTexture.set(p.TEXTURE0), y.imageAtlasTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE), b.updatePaintBuffers(f));
                        var T = d.constantOr(null);
                        if (T && y.imageAtlas) {
                            var E = y.imageAtlas, I = E.patternPositions[T.to.toString()], P = E.patternPositions[T.from.toString()];
                            I && P && b.setConstantPatternPositions(I, P);
                        }
                        var S = t1.translatePosMatrix(v.posMatrix, y, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                        if (n) {
                            u = x.indexBuffer2, h = x.segments2;
                            var C = [
                                p.drawingBufferWidth,
                                p.drawingBufferHeight
                            ];
                            c = "fillOutlinePattern" === l && _ ? Ci(S, t1, f, y, C) : Si(S, C);
                        } else u = x.indexBuffer, h = x.segments, c = _ ? Pi(S, t1, f, y) : Ii(S);
                        w.draw(t1.context, s, r, t1.stencilModeForClipping(v), a, Ct.disabled, c, i.id, x.layoutVertexBuffer, u, h, i.paint, t1.transform.zoom, b);
                    }
                }
            }
        }
        function ro(t1, e1, i, o, r, a, n) {
            for(var s = t1.context, l = s.gl, c = i.paint.get("fill-extrusion-pattern"), u = c.constantOr(1), h = i.getCrossfadeParameters(), p = i.paint.get("fill-extrusion-opacity"), d = 0, _ = o; d < _.length; d += 1){
                var f = _[d], m = e1.getTile(f), g = m.getBucket(i);
                if (g) {
                    var v = g.programConfigurations.get(i.id), y = t1.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", v);
                    u && (t1.context.activeTexture.set(l.TEXTURE0), m.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), v.updatePaintBuffers(h));
                    var x = c.constantOr(null);
                    if (x && m.imageAtlas) {
                        var b = m.imageAtlas, w = b.patternPositions[x.to.toString()], T = b.patternPositions[x.from.toString()];
                        w && T && v.setConstantPatternPositions(w, T);
                    }
                    var E = t1.translatePosMatrix(f.posMatrix, m, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), I = i.paint.get("fill-extrusion-vertical-gradient"), P = u ? Ei(E, t1, I, p, f, h, m) : Ti(E, t1, I, p);
                    y.draw(s, s.gl.TRIANGLES, r, a, n, Ct.backCCW, P, i.id, g.layoutVertexBuffer, g.indexBuffer, g.segments, i.paint, t1.transform.zoom, v);
                }
            }
        }
        function ao(e1, i, o, r, a, n) {
            var s = e1.context, l = s.gl, c = i.fbo;
            if (c) {
                var u = e1.useProgram("hillshade");
                s.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, c.colorAttachment.get());
                var h = function(e1, i, o) {
                    var r = o.paint.get("hillshade-shadow-color"), a = o.paint.get("hillshade-highlight-color"), n = o.paint.get("hillshade-accent-color"), s = o.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                    "viewport" === o.paint.get("hillshade-illumination-anchor") && (s -= e1.transform.angle);
                    var l, c, u, h = !e1.options.moving;
                    return {
                        u_matrix: e1.transform.calculatePosMatrix(i.tileID.toUnwrapped(), h),
                        u_image: 0,
                        u_latrange: (l = i.tileID, c = Math.pow(2, l.canonical.z), u = l.canonical.y, [
                            new t1.MercatorCoordinate(0, u / c).toLngLat().lat,
                            new t1.MercatorCoordinate(0, (u + 1) / c).toLngLat().lat
                        ]),
                        u_light: [
                            o.paint.get("hillshade-exaggeration"),
                            s
                        ],
                        u_shadow: r,
                        u_highlight: a,
                        u_accent: n
                    };
                }(e1, i, o);
                u.draw(s, l.TRIANGLES, r, a, n, Ct.disabled, h, o.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments);
            }
        }
        function no(e1, i, o, r, a, n) {
            var s = e1.context, l = s.gl, c = i.dem;
            if (c && c.data) {
                var u = c.dim, h = c.stride, p = c.getPixels();
                if (s.activeTexture.set(l.TEXTURE1), s.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || e1.getTileTexture(h), i.demTexture) {
                    var d = i.demTexture;
                    d.update(p, {
                        premultiply: !1
                    }), d.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                } else i.demTexture = new t1.Texture(s, p, l.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                s.activeTexture.set(l.TEXTURE0);
                var _ = i.fbo;
                if (!_) {
                    var f = new t1.Texture(s, {
                        width: u,
                        height: u,
                        data: null
                    }, l.RGBA);
                    f.bind(l.LINEAR, l.CLAMP_TO_EDGE), (_ = i.fbo = s.createFramebuffer(u, u, !0)).colorAttachment.set(f.texture);
                }
                s.bindFramebuffer.set(_.framebuffer), s.viewport.set([
                    0,
                    0,
                    u,
                    u
                ]), e1.useProgram("hillshadePrepare").draw(s, l.TRIANGLES, r, a, n, Ct.disabled, function(e1, i) {
                    var o = i.stride, r = t1.create();
                    return t1.ortho(r, 0, t1.EXTENT, -t1.EXTENT, 0, 0, 1), t1.translate(r, r, [
                        0,
                        -t1.EXTENT,
                        0
                    ]), {
                        u_matrix: r,
                        u_image: 1,
                        u_dimension: [
                            o,
                            o
                        ],
                        u_zoom: e1.overscaledZ,
                        u_unpack: i.getUnpackVector()
                    };
                }(i.tileID, c), o.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        }
        function so(e1, i, o, r, a) {
            var n = r.paint.get("raster-fade-duration");
            if (n > 0) {
                var s = t1.browser.now(), l = (s - e1.timeAdded) / n, c = i ? (s - i.timeAdded) / n : -1, u = o.getSource(), h = a.coveringZoomLevel({
                    tileSize: u.tileSize,
                    roundZoom: u.roundZoom
                }), p = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(e1.tileID.overscaledZ - h), d = p && e1.refreshedUponExpiration ? 1 : t1.clamp(p ? l : 1 - c, 0, 1);
                return e1.refreshedUponExpiration && l >= 1 && (e1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        var lo = new t1.Color(1, 0, 0, 1), co = new t1.Color(0, 1, 0, 1), uo = new t1.Color(0, 0, 1, 1), ho = new t1.Color(1, 0, 1, 1), po = new t1.Color(0, 1, 1, 1);
        function _o(t1, e1, i, o) {
            mo(t1, 0, e1 + i / 2, t1.transform.width, i, o);
        }
        function fo(t1, e1, i, o) {
            mo(t1, e1 - i / 2, 0, i, t1.transform.height, o);
        }
        function mo(e1, i, o, r, a, n) {
            var s = e1.context, l = s.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * t1.browser.devicePixelRatio, o * t1.browser.devicePixelRatio, r * t1.browser.devicePixelRatio, a * t1.browser.devicePixelRatio), s.clear({
                color: n
            }), l.disable(l.SCISSOR_TEST);
        }
        function go(e1, i, o) {
            var r = e1.context, a = r.gl, n = o.posMatrix, s = e1.useProgram("debug"), l = It.disabled, c = Pt.disabled, u = e1.colorModeForRenderPass();
            r.activeTexture.set(a.TEXTURE0), e1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.draw(r, a.LINE_STRIP, l, c, u, Ct.disabled, Mi(n, t1.Color.red), "$debug", e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
            var h = i.getTileByID(o.key).latestRawTileData, p = Math.floor((h && h.byteLength || 0) / 1024), d = i.getTile(o).tileSize, _ = 512 / Math.min(d, 512) * (o.overscaledZ / e1.transform.zoom) * .5, f = o.canonical.toString();
            o.overscaledZ !== o.canonical.z && (f += " => " + o.overscaledZ), function(t1, e1) {
                t1.initDebugOverlayCanvas();
                var i = t1.debugOverlayCanvas, o = t1.context.gl, r = t1.debugOverlayCanvas.getContext("2d");
                r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(e1, 5, 5), r.strokeText(e1, 5, 5), t1.debugOverlayTexture.update(i), t1.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }(e1, f + " " + p + "kb"), s.draw(r, a.TRIANGLES, l, c, St.alphaBlended, Ct.disabled, Mi(n, t1.Color.transparent, _), "$debug", e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments);
        }
        var vo = {
            symbol: function(e1, i, o, r, a) {
                if ("translucent" === e1.renderPass) {
                    var n = Pt.disabled, s = e1.colorModeForRenderPass();
                    o.layout.get("text-variable-anchor") && function(e1, i, o, r, a, n, s) {
                        for(var l = i.transform, c = "map" === a, u = "map" === n, h = 0, p = e1; h < p.length; h += 1){
                            var d = p[h], _ = r.getTile(d), f = _.getBucket(o);
                            if (f && f.text && f.text.segments.get().length) {
                                var m = t1.evaluateSizeForZoom(f.textSizeData, l.zoom), g = pe(_, 1, i.transform.zoom), v = Jt(d.posMatrix, u, c, i.transform, g), y = "none" !== o.layout.get("icon-text-fit") && f.hasIconData();
                                if (m) {
                                    var x = Math.pow(2, l.zoom - _.tileID.overscaledZ);
                                    $i(f, c, u, s, t1.symbolSize, l, v, d.posMatrix, x, m, y);
                                }
                            }
                        }
                    }(r, e1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), a), 0 !== o.paint.get("icon-opacity").constantOr(1) && eo(e1, i, o, r, !1, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), o.layout.get("icon-rotation-alignment"), o.layout.get("icon-pitch-alignment"), o.layout.get("icon-keep-upright"), n, s), 0 !== o.paint.get("text-opacity").constantOr(1) && eo(e1, i, o, r, !0, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), o.layout.get("text-keep-upright"), n, s), i.map.showCollisionBoxes && (Yi(e1, i, o, r, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), Yi(e1, i, o, r, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
                }
            },
            circle: function(e1, i, o, r) {
                if ("translucent" === e1.renderPass) {
                    var a = o.paint.get("circle-opacity"), n = o.paint.get("circle-stroke-width"), s = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1);
                    if (0 !== a.constantOr(1) || 0 !== n.constantOr(1) && 0 !== s.constantOr(1)) {
                        for(var c = e1.context, u = c.gl, h = e1.depthModeForSublayer(0, It.ReadOnly), p = Pt.disabled, d = e1.colorModeForRenderPass(), _ = [], f = 0; f < r.length; f++){
                            var m = r[f], g = i.getTile(m), v = g.getBucket(o);
                            if (v) {
                                var y = v.programConfigurations.get(o.id), x = {
                                    programConfiguration: y,
                                    program: e1.useProgram("circle", y),
                                    layoutVertexBuffer: v.layoutVertexBuffer,
                                    indexBuffer: v.indexBuffer,
                                    uniformValues: zi(e1, m, g, o)
                                };
                                if (l) for(var b = 0, w = v.segments.get(); b < w.length; b += 1){
                                    var T = w[b];
                                    _.push({
                                        segments: new t1.SegmentVector([
                                            T
                                        ]),
                                        sortKey: T.sortKey,
                                        state: x
                                    });
                                }
                                else _.push({
                                    segments: v.segments,
                                    sortKey: 0,
                                    state: x
                                });
                            }
                        }
                        l && _.sort(function(t1, e1) {
                            return t1.sortKey - e1.sortKey;
                        });
                        for(var E = 0, I = _; E < I.length; E += 1){
                            var P = I[E], S = P.state;
                            S.program.draw(c, u.TRIANGLES, h, p, d, Ct.disabled, S.uniformValues, o.id, S.layoutVertexBuffer, S.indexBuffer, P.segments, o.paint, e1.transform.zoom, S.programConfiguration);
                        }
                    }
                }
            },
            heatmap: function(e1, i, o, r) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === e1.renderPass) {
                        var a = e1.context, n = a.gl, s = Pt.disabled, l = new St([
                            n.ONE,
                            n.ONE
                        ], t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(t1, e1, i) {
                            var o = t1.gl;
                            t1.activeTexture.set(o.TEXTURE1), t1.viewport.set([
                                0,
                                0,
                                e1.width / 4,
                                e1.height / 4
                            ]);
                            var r = i.heatmapFbo;
                            if (r) o.bindTexture(o.TEXTURE_2D, r.colorAttachment.get()), t1.bindFramebuffer.set(r.framebuffer);
                            else {
                                var a = o.createTexture();
                                o.bindTexture(o.TEXTURE_2D, a), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR), r = i.heatmapFbo = t1.createFramebuffer(e1.width / 4, e1.height / 4, !1), function(t1, e1, i, o) {
                                    var r = t1.gl;
                                    r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, e1.width / 4, e1.height / 4, 0, r.RGBA, t1.extRenderToTextureHalfFloat ? t1.extTextureHalfFloat.HALF_FLOAT_OES : r.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(t1, e1, a, r);
                            }
                        }(a, e1, o), a.clear({
                            color: t1.Color.transparent
                        });
                        for(var c = 0; c < r.length; c++){
                            var u = r[c];
                            if (!i.hasRenderableParent(u)) {
                                var h = i.getTile(u), p = h.getBucket(o);
                                if (p) {
                                    var d = p.programConfigurations.get(o.id);
                                    e1.useProgram("heatmap", d).draw(a, n.TRIANGLES, It.disabled, s, l, Ct.disabled, Ri(u.posMatrix, h, e1.transform.zoom, o.paint.get("heatmap-intensity")), o.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, o.paint, e1.transform.zoom, d);
                                }
                            }
                        }
                        a.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, i) {
                        var o = e1.context, r = o.gl, a = i.heatmapFbo;
                        if (a) {
                            o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, a.colorAttachment.get()), o.activeTexture.set(r.TEXTURE1);
                            var n = i.colorRampTexture;
                            n || (n = i.colorRampTexture = new t1.Texture(o, i.colorRamp, r.RGBA)), n.bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(o, r.TRIANGLES, It.disabled, Pt.disabled, e1.colorModeForRenderPass(), Ct.disabled, function(e1, i, o, r) {
                                var a = t1.create();
                                t1.ortho(a, 0, e1.width, e1.height, 0, 0, 1);
                                var n = e1.context.gl;
                                return {
                                    u_matrix: a,
                                    u_world: [
                                        n.drawingBufferWidth,
                                        n.drawingBufferHeight
                                    ],
                                    u_image: 0,
                                    u_color_ramp: 1,
                                    u_opacity: i.paint.get("heatmap-opacity")
                                };
                            }(e1, i), i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom);
                        }
                    }(e1, o));
                }
            },
            line: function(e1, i, o, r) {
                if ("translucent" === e1.renderPass) {
                    var a = o.paint.get("line-opacity"), n = o.paint.get("line-width");
                    if (0 !== a.constantOr(1) && 0 !== n.constantOr(1)) for(var s = e1.depthModeForSublayer(0, It.ReadOnly), l = e1.colorModeForRenderPass(), c = o.paint.get("line-dasharray"), u = o.paint.get("line-pattern"), h = u.constantOr(1), p = o.paint.get("line-gradient"), d = o.getCrossfadeParameters(), _ = h ? "linePattern" : c ? "lineSDF" : p ? "lineGradient" : "line", f = e1.context, m = f.gl, g = !0, v = 0, y = r; v < y.length; v += 1){
                        var x = y[v], b = i.getTile(x);
                        if (!h || b.patternsLoaded()) {
                            var w = b.getBucket(o);
                            if (w) {
                                var T = w.programConfigurations.get(o.id), E = e1.context.program.get(), I = e1.useProgram(_, T), P = g || I.program !== E, S = u.constantOr(null);
                                if (S && b.imageAtlas) {
                                    var C = b.imageAtlas, z = C.patternPositions[S.to.toString()], D = C.patternPositions[S.from.toString()];
                                    z && D && T.setConstantPatternPositions(z, D);
                                }
                                var A = h ? Oi(e1, b, o, d) : c ? Fi(e1, b, o, c, d) : p ? Bi(e1, b, o, w.lineClipsArray.length) : ki(e1, b, o);
                                if (h) f.activeTexture.set(m.TEXTURE0), b.imageAtlasTexture.bind(m.LINEAR, m.CLAMP_TO_EDGE), T.updatePaintBuffers(d);
                                else if (c && (P || e1.lineAtlas.dirty)) f.activeTexture.set(m.TEXTURE0), e1.lineAtlas.bind(f);
                                else if (p) {
                                    var M = w.gradients[o.id], L = M.texture;
                                    if (o.gradientVersion !== M.version) {
                                        var R = 256;
                                        if (o.stepInterpolant) {
                                            var k = i.getSource().maxzoom, B = x.canonical.z === k ? Math.ceil(1 << e1.transform.maxZoom - x.canonical.z) : 1;
                                            R = t1.clamp(t1.nextPowerOfTwo(w.maxLineLength / t1.EXTENT * 1024 * B), 256, f.maxTextureSize);
                                        }
                                        M.gradient = t1.renderColorRamp({
                                            expression: o.gradientExpression(),
                                            evaluationKey: "lineProgress",
                                            resolution: R,
                                            image: M.gradient || void 0,
                                            clips: w.lineClipsArray
                                        }), M.texture ? M.texture.update(M.gradient) : M.texture = new t1.Texture(f, M.gradient, m.RGBA), M.version = o.gradientVersion, L = M.texture;
                                    }
                                    f.activeTexture.set(m.TEXTURE0), L.bind(o.stepInterpolant ? m.NEAREST : m.LINEAR, m.CLAMP_TO_EDGE);
                                }
                                I.draw(f, m.TRIANGLES, s, e1.stencilModeForClipping(x), l, Ct.disabled, A, o.id, w.layoutVertexBuffer, w.indexBuffer, w.segments, o.paint, e1.transform.zoom, T, w.layoutVertexBuffer2), g = !1;
                            }
                        }
                    }
                }
            },
            fill: function(e1, i, o, r) {
                var a = o.paint.get("fill-color"), n = o.paint.get("fill-opacity");
                if (0 !== n.constantOr(1)) {
                    var s = e1.colorModeForRenderPass(), l = o.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === a.constantOr(t1.Color.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                    if (e1.renderPass === c) {
                        var u = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? It.ReadWrite : It.ReadOnly);
                        oo(e1, i, o, r, u, s, !1);
                    }
                    if ("translucent" === e1.renderPass && o.paint.get("fill-antialias")) {
                        var h = e1.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, It.ReadOnly);
                        oo(e1, i, o, r, h, s, !0);
                    }
                }
            },
            "fill-extrusion": function(t1, e1, i, o) {
                var r = i.paint.get("fill-extrusion-opacity");
                if (0 !== r && "translucent" === t1.renderPass) {
                    var a = new It(t1.context.gl.LEQUAL, It.ReadWrite, t1.depthRangeFor3D);
                    if (1 !== r || i.paint.get("fill-extrusion-pattern").constantOr(1)) ro(t1, e1, i, o, a, Pt.disabled, St.disabled), ro(t1, e1, i, o, a, t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                    else {
                        var n = t1.colorModeForRenderPass();
                        ro(t1, e1, i, o, a, Pt.disabled, n);
                    }
                }
            },
            hillshade: function(t1, e1, i, o) {
                if ("offscreen" === t1.renderPass || "translucent" === t1.renderPass) {
                    for(var r = t1.context, a = t1.depthModeForSublayer(0, It.ReadOnly), n = t1.colorModeForRenderPass(), s = "translucent" === t1.renderPass ? t1.stencilConfigForOverlap(o) : [
                        {},
                        o
                    ], l = s[0], c = 0, u = s[1]; c < u.length; c += 1){
                        var h = u[c], p = e1.getTile(h);
                        p.needsHillshadePrepare && "offscreen" === t1.renderPass ? no(t1, p, i, a, Pt.disabled, n) : "translucent" === t1.renderPass && ao(t1, p, i, a, l[h.overscaledZ], n);
                    }
                    r.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }
            },
            raster: function(t1, e1, i, o) {
                if ("translucent" === t1.renderPass && 0 !== i.paint.get("raster-opacity") && o.length) for(var r = t1.context, a = r.gl, n = e1.getSource(), s = t1.useProgram("raster"), l = t1.colorModeForRenderPass(), c = n instanceof M ? [
                    {},
                    o
                ] : t1.stencilConfigForOverlap(o), u = c[0], h = c[1], p = h[h.length - 1].overscaledZ, d = !t1.options.moving, _ = 0, f = h; _ < f.length; _ += 1){
                    var m = f[_], g = t1.depthModeForSublayer(m.overscaledZ - p, 1 === i.paint.get("raster-opacity") ? It.ReadWrite : It.ReadOnly, a.LESS), v = e1.getTile(m), y = t1.transform.calculatePosMatrix(m.toUnwrapped(), d);
                    v.registerFadeDuration(i.paint.get("raster-fade-duration"));
                    var x = e1.findLoadedParent(m, 0), b = so(v, x, e1, i, t1.transform), w = void 0, T = void 0, E = "nearest" === i.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;
                    r.activeTexture.set(a.TEXTURE0), v.texture.bind(E, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), r.activeTexture.set(a.TEXTURE1), x ? (x.texture.bind(E, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), w = Math.pow(2, x.tileID.overscaledZ - v.tileID.overscaledZ), T = [
                        v.tileID.canonical.x * w % 1,
                        v.tileID.canonical.y * w % 1
                    ]) : v.texture.bind(E, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST);
                    var I = Zi(y, T || [
                        0,
                        0
                    ], w || 1, b, i);
                    n instanceof M ? s.draw(r, a.TRIANGLES, g, Pt.disabled, l, Ct.disabled, I, i.id, n.boundsBuffer, t1.quadTriangleIndexBuffer, n.boundsSegments) : s.draw(r, a.TRIANGLES, g, u[m.overscaledZ], l, Ct.disabled, I, i.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                }
            },
            background: function(t1, e1, i) {
                var o = i.paint.get("background-color"), r = i.paint.get("background-opacity");
                if (0 !== r) {
                    var a = t1.context, n = a.gl, s = t1.transform, l = s.tileSize, c = i.paint.get("background-pattern");
                    if (!t1.isPatternMissing(c)) {
                        var u = !c && 1 === o.a && 1 === r && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                        if (t1.renderPass === u) {
                            var h = Pt.disabled, p = t1.depthModeForSublayer(0, "opaque" === u ? It.ReadWrite : It.ReadOnly), d = t1.colorModeForRenderPass(), _ = t1.useProgram(c ? "backgroundPattern" : "background"), f = s.coveringTiles({
                                tileSize: l
                            });
                            c && (a.activeTexture.set(n.TEXTURE0), t1.imageManager.bind(t1.context));
                            for(var m = i.getCrossfadeParameters(), g = 0, v = f; g < v.length; g += 1){
                                var y = v[g], x = t1.transform.calculatePosMatrix(y.toUnwrapped()), b = c ? Hi(x, r, t1, c, {
                                    tileID: y,
                                    tileSize: l
                                }, m) : Xi(x, r, o);
                                _.draw(a, n.TRIANGLES, p, h, d, Ct.disabled, b, i.id, t1.tileExtentBuffer, t1.quadTriangleIndexBuffer, t1.tileExtentSegments);
                            }
                        }
                    }
                }
            },
            debug: function(t1, e1, i) {
                for(var o = 0; o < i.length; o++)go(t1, e1, i[o]);
            },
            custom: function(t1, e1, i) {
                var o = t1.context, r = i.implementation;
                if ("offscreen" === t1.renderPass) {
                    var a = r.prerender;
                    a && (t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), a.call(r, o.gl, t1.transform.customLayerMatrix()), o.setDirty(), t1.setBaseState());
                } else if ("translucent" === t1.renderPass) {
                    t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), o.setStencilMode(Pt.disabled);
                    var n = "3d" === r.renderingMode ? new It(t1.context.gl.LEQUAL, It.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, It.ReadOnly);
                    o.setDepthMode(n), r.render(o.gl, t1.transform.customLayerMatrix()), o.setDirty(), t1.setBaseState(), o.bindFramebuffer.set(null);
                }
            }
        }, yo = function(t1, e1) {
            this.context = new zt(t1), this.transform = e1, this._tileTextures = {}, this.setup(), this.numSublayers = Dt.maxUnderzooming + Dt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Fe, this.gpuTimers = {};
        };
        yo.prototype.resize = function(e1, i) {
            if (this.width = e1 * t1.browser.devicePixelRatio, this.height = i * t1.browser.devicePixelRatio, this.context.viewport.set([
                0,
                0,
                this.width,
                this.height
            ]), this.style) for(var o = 0, r = this.style._order; o < r.length; o += 1)this.style._layers[r[o]].resize();
        }, yo.prototype.setup = function() {
            var e1 = this.context, i = new t1.StructArrayLayout2i4;
            i.emplaceBack(0, 0), i.emplaceBack(t1.EXTENT, 0), i.emplaceBack(0, t1.EXTENT), i.emplaceBack(t1.EXTENT, t1.EXTENT), this.tileExtentBuffer = e1.createVertexBuffer(i, Ve.members), this.tileExtentSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
            var o = new t1.StructArrayLayout2i4;
            o.emplaceBack(0, 0), o.emplaceBack(t1.EXTENT, 0), o.emplaceBack(0, t1.EXTENT), o.emplaceBack(t1.EXTENT, t1.EXTENT), this.debugBuffer = e1.createVertexBuffer(o, Ve.members), this.debugSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 5);
            var r = new t1.StructArrayLayout4i8;
            r.emplaceBack(0, 0, 0, 0), r.emplaceBack(t1.EXTENT, 0, t1.EXTENT, 0), r.emplaceBack(0, t1.EXTENT, 0, t1.EXTENT), r.emplaceBack(t1.EXTENT, t1.EXTENT, t1.EXTENT, t1.EXTENT), this.rasterBoundsBuffer = e1.createVertexBuffer(r, A.members), this.rasterBoundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
            var a = new t1.StructArrayLayout2i4;
            a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(a, Ve.members), this.viewportSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
            var n = new t1.StructArrayLayout1ui2;
            n.emplaceBack(0), n.emplaceBack(1), n.emplaceBack(3), n.emplaceBack(2), n.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(n);
            var s = new t1.StructArrayLayout3ui6;
            s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s), this.emptyTexture = new t1.Texture(e1, {
                width: 1,
                height: 1,
                data: new Uint8Array([
                    0,
                    0,
                    0,
                    0
                ])
            }, e1.gl.RGBA);
            var l = this.context.gl;
            this.stencilClearMode = new Pt({
                func: l.ALWAYS,
                mask: 0
            }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
        }, yo.prototype.clearStencil = function() {
            var e1 = this.context, i = e1.gl;
            this.nextStencilID = 1, this.currentStencilSource = void 0;
            var o = t1.create();
            t1.ortho(o, 0, this.width, this.height, 0, 0, 1), t1.scale(o, o, [
                i.drawingBufferWidth,
                i.drawingBufferHeight,
                0
            ]), this.useProgram("clippingMask").draw(e1, i.TRIANGLES, It.disabled, this.stencilClearMode, St.disabled, Ct.disabled, Li(o), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
        }, yo.prototype._renderTileClippingMasks = function(t1, e1) {
            if (this.currentStencilSource !== t1.source && t1.isTileClipped() && e1 && e1.length) {
                this.currentStencilSource = t1.source;
                var i = this.context, o = i.gl;
                this.nextStencilID + e1.length > 256 && this.clearStencil(), i.setColorMode(St.disabled), i.setDepthMode(It.disabled);
                var r = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for(var a = 0, n = e1; a < n.length; a += 1){
                    var s = n[a], l = this._tileClippingMaskIDs[s.key] = this.nextStencilID++;
                    r.draw(i, o.TRIANGLES, It.disabled, new Pt({
                        func: o.ALWAYS,
                        mask: 0
                    }, l, 255, o.KEEP, o.KEEP, o.REPLACE), St.disabled, Ct.disabled, Li(s.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                }
            }
        }, yo.prototype.stencilModeFor3D = function() {
            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
            var t1 = this.nextStencilID++, e1 = this.context.gl;
            return new Pt({
                func: e1.NOTEQUAL,
                mask: 255
            }, t1, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
        }, yo.prototype.stencilModeForClipping = function(t1) {
            var e1 = this.context.gl;
            return new Pt({
                func: e1.EQUAL,
                mask: 255
            }, this._tileClippingMaskIDs[t1.key], 0, e1.KEEP, e1.KEEP, e1.REPLACE);
        }, yo.prototype.stencilConfigForOverlap = function(t1) {
            var e1, i = this.context.gl, o = t1.sort(function(t1, e1) {
                return e1.overscaledZ - t1.overscaledZ;
            }), r = o[o.length - 1].overscaledZ, a = o[0].overscaledZ - r + 1;
            if (a > 1) {
                this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                for(var n = {}, s = 0; s < a; s++)n[s + r] = new Pt({
                    func: i.GEQUAL,
                    mask: 255
                }, s + this.nextStencilID, 255, i.KEEP, i.KEEP, i.REPLACE);
                return this.nextStencilID += a, [
                    n,
                    o
                ];
            }
            return [
                (e1 = {}, e1[r] = Pt.disabled, e1),
                o
            ];
        }, yo.prototype.colorModeForRenderPass = function() {
            var e1 = this.context.gl;
            return this._showOverdrawInspector ? new St([
                e1.CONSTANT_COLOR,
                e1.ONE
            ], new t1.Color(1 / 8, 1 / 8, 1 / 8, 0), [
                !0,
                !0,
                !0,
                !0
            ]) : "opaque" === this.renderPass ? St.unblended : St.alphaBlended;
        }, yo.prototype.depthModeForSublayer = function(t1, e1, i) {
            if (!this.opaquePassEnabledForLayer()) return It.disabled;
            var o = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
            return new It(i || this.context.gl.LEQUAL, e1, [
                o,
                o
            ]);
        }, yo.prototype.opaquePassEnabledForLayer = function() {
            return this.currentLayer < this.opaquePassCutoff;
        }, yo.prototype.render = function(e1, i) {
            var o = this;
            this.style = e1, this.options = i, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(t1.browser.now()), this.imageManager.beginFrame();
            var r = this.style._order, a = this.style.sourceCaches;
            for(var n in a){
                var s = a[n];
                s.used && s.prepare(this.context);
            }
            var l, c, u = {}, h = {}, p = {};
            for(var d in a){
                var _ = a[d];
                u[d] = _.getVisibleCoordinates(), h[d] = u[d].slice().reverse(), p[d] = _.getVisibleCoordinates(!0).reverse();
            }
            this.opaquePassCutoff = 1 / 0;
            for(var f = 0; f < r.length; f++)if (this.style._layers[r[f]].is3D()) {
                this.opaquePassCutoff = f;
                break;
            }
            this.renderPass = "offscreen";
            for(var m = 0, g = r; m < g.length; m += 1){
                var v = this.style._layers[g[m]];
                if (v.hasOffscreenPass() && !v.isHidden(this.transform.zoom)) {
                    var y = h[v.source];
                    ("custom" === v.type || y.length) && this.renderLayer(this, a[v.source], v, y);
                }
            }
            for(this.context.bindFramebuffer.set(null), this.context.clear({
                color: i.showOverdrawInspector ? t1.Color.black : t1.Color.transparent,
                depth: 1
            }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                0,
                1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
            ], this.renderPass = "opaque", this.currentLayer = r.length - 1; this.currentLayer >= 0; this.currentLayer--){
                var x = this.style._layers[r[this.currentLayer]], b = a[x.source], w = u[x.source];
                this._renderTileClippingMasks(x, w), this.renderLayer(this, b, x, w);
            }
            for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < r.length; this.currentLayer++){
                var T = this.style._layers[r[this.currentLayer]], E = a[T.source], I = ("symbol" === T.type ? p : h)[T.source];
                this._renderTileClippingMasks(T, u[T.source]), this.renderLayer(this, E, T, I);
            }
            this.options.showTileBoundaries && (t1.values(this.style._layers).forEach(function(t1) {
                t1.source && !t1.isHidden(o.transform.zoom) && (t1.source !== (c && c.id) && (c = o.style.sourceCaches[t1.source]), (!l || l.getSource().maxzoom < c.getSource().maxzoom) && (l = c));
            }), l && vo.debug(this, l, l.getVisibleCoordinates())), this.options.showPadding && function(t1) {
                var e1 = t1.transform.padding;
                _o(t1, t1.transform.height - (e1.top || 0), 3, lo), _o(t1, e1.bottom || 0, 3, co), fo(t1, e1.left || 0, 3, uo), fo(t1, t1.transform.width - (e1.right || 0), 3, ho);
                var i = t1.transform.centerPoint;
                !function(t1, e1, i, o) {
                    mo(t1, e1 - 1, i - 10, 2, 20, o), mo(t1, e1 - 10, i - 1, 20, 2, o);
                }(t1, i.x, t1.transform.height - i.y, po);
            }(this), this.context.setDefault();
        }, yo.prototype.renderLayer = function(t1, e1, i, o) {
            i.isHidden(this.transform.zoom) || ("background" === i.type || "custom" === i.type || o.length) && (this.id = i.id, this.gpuTimingStart(i), vo[i.type](t1, e1, i, o, this.style.placement.variableOffsets), this.gpuTimingEnd());
        }, yo.prototype.gpuTimingStart = function(t1) {
            if (this.options.gpuTiming) {
                var e1 = this.context.extTimerQuery, i = this.gpuTimers[t1.id];
                i || (i = this.gpuTimers[t1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: e1.createQueryEXT()
                }), i.calls++, e1.beginQueryEXT(e1.TIME_ELAPSED_EXT, i.query);
            }
        }, yo.prototype.gpuTimingEnd = function() {
            if (this.options.gpuTiming) {
                var t1 = this.context.extTimerQuery;
                t1.endQueryEXT(t1.TIME_ELAPSED_EXT);
            }
        }, yo.prototype.collectGpuTimers = function() {
            var t1 = this.gpuTimers;
            return this.gpuTimers = {}, t1;
        }, yo.prototype.queryGpuTimers = function(t1) {
            var e1 = {};
            for(var i in t1){
                var o = t1[i], r = this.context.extTimerQuery, a = r.getQueryObjectEXT(o.query, r.QUERY_RESULT_EXT) / 1e6;
                r.deleteQueryEXT(o.query), e1[i] = a;
            }
            return e1;
        }, yo.prototype.translatePosMatrix = function(e1, i, o, r, a) {
            if (!o[0] && !o[1]) return e1;
            var n = a ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
            if (n) {
                var s = Math.sin(n), l = Math.cos(n);
                o = [
                    o[0] * l - o[1] * s,
                    o[0] * s + o[1] * l
                ];
            }
            var c = [
                a ? o[0] : pe(i, o[0], this.transform.zoom),
                a ? o[1] : pe(i, o[1], this.transform.zoom),
                0
            ], u = new Float32Array(16);
            return t1.translate(u, e1, c), u;
        }, yo.prototype.saveTileTexture = function(t1) {
            var e1 = this._tileTextures[t1.size[0]];
            e1 ? e1.push(t1) : this._tileTextures[t1.size[0]] = [
                t1
            ];
        }, yo.prototype.getTileTexture = function(t1) {
            var e1 = this._tileTextures[t1];
            return e1 && e1.length > 0 ? e1.pop() : null;
        }, yo.prototype.isPatternMissing = function(t1) {
            if (!t1) return !1;
            if (!t1.from || !t1.to) return !0;
            var e1 = this.imageManager.getPattern(t1.from.toString()), i = this.imageManager.getPattern(t1.to.toString());
            return !e1 || !i;
        }, yo.prototype.useProgram = function(t1, e1) {
            this.cache = this.cache || {};
            var i = "" + t1 + (e1 ? e1.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "");
            return this.cache[i] || (this.cache[i] = new bi(this.context, t1, vi[t1], e1, Ki[t1], this._showOverdrawInspector)), this.cache[i];
        }, yo.prototype.setCustomLayerDefaults = function() {
            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
        }, yo.prototype.setBaseState = function() {
            var t1 = this.context.gl;
            this.context.cullFace.set(!1), this.context.viewport.set([
                0,
                0,
                this.width,
                this.height
            ]), this.context.blendEquation.set(t1.FUNC_ADD);
        }, yo.prototype.initDebugOverlayCanvas = function() {
            null == this.debugOverlayCanvas && (this.debugOverlayCanvas = t1.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new t1.Texture(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
        }, yo.prototype.destroy = function() {
            this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
        };
        var xo = function(t1, e1) {
            this.points = t1, this.planes = e1;
        };
        xo.fromInvProjectionMatrix = function(e1, i, o) {
            var r = Math.pow(2, o), a = [
                [
                    -1,
                    1,
                    -1,
                    1
                ],
                [
                    1,
                    1,
                    -1,
                    1
                ],
                [
                    1,
                    -1,
                    -1,
                    1
                ],
                [
                    -1,
                    -1,
                    -1,
                    1
                ],
                [
                    -1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    -1,
                    1,
                    1
                ],
                [
                    -1,
                    -1,
                    1,
                    1
                ]
            ].map(function(i) {
                return t1.transformMat4([], i, e1);
            }).map(function(e1) {
                return t1.scale$1([], e1, 1 / e1[3] / i * r);
            }), n = [
                [
                    0,
                    1,
                    2
                ],
                [
                    6,
                    5,
                    4
                ],
                [
                    0,
                    3,
                    7
                ],
                [
                    2,
                    1,
                    5
                ],
                [
                    3,
                    2,
                    6
                ],
                [
                    0,
                    4,
                    5
                ]
            ].map(function(e1) {
                var i = t1.sub([], a[e1[0]], a[e1[1]]), o = t1.sub([], a[e1[2]], a[e1[1]]), r = t1.normalize([], t1.cross([], i, o)), n = -t1.dot(r, a[e1[1]]);
                return r.concat(n);
            });
            return new xo(a, n);
        };
        var bo = function(e1, i) {
            this.min = e1, this.max = i, this.center = t1.scale$2([], t1.add([], this.min, this.max), .5);
        };
        bo.prototype.quadrant = function(e1) {
            for(var i = [
                e1 % 2 == 0,
                e1 < 2
            ], o = t1.clone$2(this.min), r = t1.clone$2(this.max), a = 0; a < i.length; a++)o[a] = i[a] ? this.min[a] : this.center[a], r[a] = i[a] ? this.center[a] : this.max[a];
            return r[2] = this.max[2], new bo(o, r);
        }, bo.prototype.distanceX = function(t1) {
            return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
        }, bo.prototype.distanceY = function(t1) {
            return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
        }, bo.prototype.intersects = function(e1) {
            for(var i = [
                [
                    this.min[0],
                    this.min[1],
                    0,
                    1
                ],
                [
                    this.max[0],
                    this.min[1],
                    0,
                    1
                ],
                [
                    this.max[0],
                    this.max[1],
                    0,
                    1
                ],
                [
                    this.min[0],
                    this.max[1],
                    0,
                    1
                ]
            ], o = !0, r = 0; r < e1.planes.length; r++){
                for(var a = e1.planes[r], n = 0, s = 0; s < i.length; s++)n += t1.dot$1(a, i[s]) >= 0;
                if (0 === n) return 0;
                n !== i.length && (o = !1);
            }
            if (o) return 2;
            for(var l = 0; l < 3; l++){
                for(var c = Number.MAX_VALUE, u = -Number.MAX_VALUE, h = 0; h < e1.points.length; h++){
                    var p = e1.points[h][l] - this.min[l];
                    c = Math.min(c, p), u = Math.max(u, p);
                }
                if (u < 0 || c > this.max[l] - this.min[l]) return 0;
            }
            return 1;
        };
        var wo = function(t1, e1, i, o) {
            if (void 0 === t1 && (t1 = 0), void 0 === e1 && (e1 = 0), void 0 === i && (i = 0), void 0 === o && (o = 0), isNaN(t1) || t1 < 0 || isNaN(e1) || e1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
            this.top = t1, this.bottom = e1, this.left = i, this.right = o;
        };
        wo.prototype.interpolate = function(e1, i, o) {
            return null != i.top && null != e1.top && (this.top = t1.number(e1.top, i.top, o)), null != i.bottom && null != e1.bottom && (this.bottom = t1.number(e1.bottom, i.bottom, o)), null != i.left && null != e1.left && (this.left = t1.number(e1.left, i.left, o)), null != i.right && null != e1.right && (this.right = t1.number(e1.right, i.right, o)), this;
        }, wo.prototype.getCenter = function(e1, i) {
            var o = t1.clamp((this.left + e1 - this.right) / 2, 0, e1), r = t1.clamp((this.top + i - this.bottom) / 2, 0, i);
            return new t1.Point(o, r);
        }, wo.prototype.equals = function(t1) {
            return this.top === t1.top && this.bottom === t1.bottom && this.left === t1.left && this.right === t1.right;
        }, wo.prototype.clone = function() {
            return new wo(this.top, this.bottom, this.left, this.right);
        }, wo.prototype.toJSON = function() {
            return {
                top: this.top,
                bottom: this.bottom,
                left: this.left,
                right: this.right
            };
        };
        var To = function(e1, i, o, r, a) {
            this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = void 0 === a || a, this._minZoom = e1 || 0, this._maxZoom = i || 22, this._minPitch = null == o ? 0 : o, this._maxPitch = null == r ? 60 : r, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t1.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new wo, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
        }, Eo = {
            minZoom: {
                configurable: !0
            },
            maxZoom: {
                configurable: !0
            },
            minPitch: {
                configurable: !0
            },
            maxPitch: {
                configurable: !0
            },
            renderWorldCopies: {
                configurable: !0
            },
            worldSize: {
                configurable: !0
            },
            centerOffset: {
                configurable: !0
            },
            size: {
                configurable: !0
            },
            bearing: {
                configurable: !0
            },
            pitch: {
                configurable: !0
            },
            fov: {
                configurable: !0
            },
            zoom: {
                configurable: !0
            },
            center: {
                configurable: !0
            },
            padding: {
                configurable: !0
            },
            centerPoint: {
                configurable: !0
            },
            unmodified: {
                configurable: !0
            },
            point: {
                configurable: !0
            }
        };
        To.prototype.clone = function() {
            var t1 = new To(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
            return t1.tileSize = this.tileSize, t1.latRange = this.latRange, t1.width = this.width, t1.height = this.height, t1._center = this._center, t1.zoom = this.zoom, t1.angle = this.angle, t1._fov = this._fov, t1._pitch = this._pitch, t1._unmodified = this._unmodified, t1._edgeInsets = this._edgeInsets.clone(), t1._calcMatrices(), t1;
        }, Eo.minZoom.get = function() {
            return this._minZoom;
        }, Eo.minZoom.set = function(t1) {
            this._minZoom !== t1 && (this._minZoom = t1, this.zoom = Math.max(this.zoom, t1));
        }, Eo.maxZoom.get = function() {
            return this._maxZoom;
        }, Eo.maxZoom.set = function(t1) {
            this._maxZoom !== t1 && (this._maxZoom = t1, this.zoom = Math.min(this.zoom, t1));
        }, Eo.minPitch.get = function() {
            return this._minPitch;
        }, Eo.minPitch.set = function(t1) {
            this._minPitch !== t1 && (this._minPitch = t1, this.pitch = Math.max(this.pitch, t1));
        }, Eo.maxPitch.get = function() {
            return this._maxPitch;
        }, Eo.maxPitch.set = function(t1) {
            this._maxPitch !== t1 && (this._maxPitch = t1, this.pitch = Math.min(this.pitch, t1));
        }, Eo.renderWorldCopies.get = function() {
            return this._renderWorldCopies;
        }, Eo.renderWorldCopies.set = function(t1) {
            void 0 === t1 ? t1 = !0 : null === t1 && (t1 = !1), this._renderWorldCopies = t1;
        }, Eo.worldSize.get = function() {
            return this.tileSize * this.scale;
        }, Eo.centerOffset.get = function() {
            return this.centerPoint._sub(this.size._div(2));
        }, Eo.size.get = function() {
            return new t1.Point(this.width, this.height);
        }, Eo.bearing.get = function() {
            return -this.angle / Math.PI * 180;
        }, Eo.bearing.set = function(e1) {
            var i = -t1.wrap(e1, -180, 180) * Math.PI / 180;
            this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = t1.create$2(), t1.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
        }, Eo.pitch.get = function() {
            return this._pitch / Math.PI * 180;
        }, Eo.pitch.set = function(e1) {
            var i = t1.clamp(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
            this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
        }, Eo.fov.get = function() {
            return this._fov / Math.PI * 180;
        }, Eo.fov.set = function(t1) {
            t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = t1 / 180 * Math.PI, this._calcMatrices());
        }, Eo.zoom.get = function() {
            return this._zoom;
        }, Eo.zoom.set = function(t1) {
            var e1 = Math.min(Math.max(t1, this.minZoom), this.maxZoom);
            this._zoom !== e1 && (this._unmodified = !1, this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom, this._constrain(), this._calcMatrices());
        }, Eo.center.get = function() {
            return this._center;
        }, Eo.center.set = function(t1) {
            t1.lat === this._center.lat && t1.lng === this._center.lng || (this._unmodified = !1, this._center = t1, this._constrain(), this._calcMatrices());
        }, Eo.padding.get = function() {
            return this._edgeInsets.toJSON();
        }, Eo.padding.set = function(t1) {
            this._edgeInsets.equals(t1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t1, 1), this._calcMatrices());
        }, Eo.centerPoint.get = function() {
            return this._edgeInsets.getCenter(this.width, this.height);
        }, To.prototype.isPaddingEqual = function(t1) {
            return this._edgeInsets.equals(t1);
        }, To.prototype.interpolatePadding = function(t1, e1, i) {
            this._unmodified = !1, this._edgeInsets.interpolate(t1, e1, i), this._constrain(), this._calcMatrices();
        }, To.prototype.coveringZoomLevel = function(t1) {
            var e1 = (t1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t1.tileSize));
            return Math.max(0, e1);
        }, To.prototype.getVisibleUnwrappedCoordinates = function(e1) {
            var i = [
                new t1.UnwrappedTileID(0, e1)
            ];
            if (this._renderWorldCopies) for(var o = this.pointCoordinate(new t1.Point(0, 0)), r = this.pointCoordinate(new t1.Point(this.width, 0)), a = this.pointCoordinate(new t1.Point(this.width, this.height)), n = this.pointCoordinate(new t1.Point(0, this.height)), s = Math.floor(Math.min(o.x, r.x, a.x, n.x)), l = Math.floor(Math.max(o.x, r.x, a.x, n.x)), c = s - 1; c <= l + 1; c++)0 !== c && i.push(new t1.UnwrappedTileID(c, e1));
            return i;
        }, To.prototype.coveringTiles = function(e1) {
            var i = this.coveringZoomLevel(e1), o = i;
            if (void 0 !== e1.minzoom && i < e1.minzoom) return [];
            void 0 !== e1.maxzoom && i > e1.maxzoom && (i = e1.maxzoom);
            var r = t1.MercatorCoordinate.fromLngLat(this.center), a = Math.pow(2, i), n = [
                a * r.x,
                a * r.y,
                0
            ], s = xo.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i), l = e1.minzoom || 0;
            this.pitch <= 60 && this._edgeInsets.top < .1 && (l = i);
            var c = function(t1) {
                return {
                    aabb: new bo([
                        t1 * a,
                        0,
                        0
                    ], [
                        (t1 + 1) * a,
                        a,
                        0
                    ]),
                    zoom: 0,
                    x: 0,
                    y: 0,
                    wrap: t1,
                    fullyVisible: !1
                };
            }, u = [], h = [], p = i, d = e1.reparseOverscaled ? o : i;
            if (this._renderWorldCopies) for(var _ = 1; _ <= 3; _++)u.push(c(-_)), u.push(c(_));
            for(u.push(c(0)); u.length > 0;){
                var f = u.pop(), m = f.x, g = f.y, v = f.fullyVisible;
                if (!v) {
                    var y = f.aabb.intersects(s);
                    if (0 === y) continue;
                    v = 2 === y;
                }
                var x = f.aabb.distanceX(n), b = f.aabb.distanceY(n), w = Math.max(Math.abs(x), Math.abs(b));
                if (f.zoom === p || w > 3 + (1 << p - f.zoom) - 2 && f.zoom >= l) h.push({
                    tileID: new t1.OverscaledTileID(f.zoom === p ? d : f.zoom, f.wrap, f.zoom, m, g),
                    distanceSq: t1.sqrLen([
                        n[0] - .5 - m,
                        n[1] - .5 - g
                    ])
                });
                else for(var T = 0; T < 4; T++){
                    var E = (m << 1) + T % 2, I = (g << 1) + (T >> 1);
                    u.push({
                        aabb: f.aabb.quadrant(T),
                        zoom: f.zoom + 1,
                        x: E,
                        y: I,
                        wrap: f.wrap,
                        fullyVisible: v
                    });
                }
            }
            return h.sort(function(t1, e1) {
                return t1.distanceSq - e1.distanceSq;
            }).map(function(t1) {
                return t1.tileID;
            });
        }, To.prototype.resize = function(t1, e1) {
            this.width = t1, this.height = e1, this.pixelsToGLUnits = [
                2 / t1,
                -2 / e1
            ], this._constrain(), this._calcMatrices();
        }, Eo.unmodified.get = function() {
            return this._unmodified;
        }, To.prototype.zoomScale = function(t1) {
            return Math.pow(2, t1);
        }, To.prototype.scaleZoom = function(t1) {
            return Math.log(t1) / Math.LN2;
        }, To.prototype.project = function(e1) {
            var i = t1.clamp(e1.lat, -this.maxValidLatitude, this.maxValidLatitude);
            return new t1.Point(t1.mercatorXfromLng(e1.lng) * this.worldSize, t1.mercatorYfromLat(i) * this.worldSize);
        }, To.prototype.unproject = function(e1) {
            return new t1.MercatorCoordinate(e1.x / this.worldSize, e1.y / this.worldSize).toLngLat();
        }, Eo.point.get = function() {
            return this.project(this.center);
        }, To.prototype.setLocationAtPoint = function(e1, i) {
            var o = this.pointCoordinate(i), r = this.pointCoordinate(this.centerPoint), a = this.locationCoordinate(e1), n = new t1.MercatorCoordinate(a.x - (o.x - r.x), a.y - (o.y - r.y));
            this.center = this.coordinateLocation(n), this._renderWorldCopies && (this.center = this.center.wrap());
        }, To.prototype.locationPoint = function(t1) {
            return this.coordinatePoint(this.locationCoordinate(t1));
        }, To.prototype.pointLocation = function(t1) {
            return this.coordinateLocation(this.pointCoordinate(t1));
        }, To.prototype.locationCoordinate = function(e1) {
            return t1.MercatorCoordinate.fromLngLat(e1);
        }, To.prototype.coordinateLocation = function(t1) {
            return t1.toLngLat();
        }, To.prototype.pointCoordinate = function(e1) {
            var i = [
                e1.x,
                e1.y,
                0,
                1
            ], o = [
                e1.x,
                e1.y,
                1,
                1
            ];
            t1.transformMat4(i, i, this.pixelMatrixInverse), t1.transformMat4(o, o, this.pixelMatrixInverse);
            var r = i[3], a = o[3], n = i[1] / r, s = o[1] / a, l = i[2] / r, c = o[2] / a, u = l === c ? 0 : (0 - l) / (c - l);
            return new t1.MercatorCoordinate(t1.number(i[0] / r, o[0] / a, u) / this.worldSize, t1.number(n, s, u) / this.worldSize);
        }, To.prototype.coordinatePoint = function(e1) {
            var i = [
                e1.x * this.worldSize,
                e1.y * this.worldSize,
                0,
                1
            ];
            return t1.transformMat4(i, i, this.pixelMatrix), new t1.Point(i[0] / i[3], i[1] / i[3]);
        }, To.prototype.getBounds = function() {
            return (new t1.LngLatBounds).extend(this.pointLocation(new t1.Point(0, 0))).extend(this.pointLocation(new t1.Point(this.width, 0))).extend(this.pointLocation(new t1.Point(this.width, this.height))).extend(this.pointLocation(new t1.Point(0, this.height)));
        }, To.prototype.getMaxBounds = function() {
            return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new t1.LngLatBounds([
                this.lngRange[0],
                this.latRange[0]
            ], [
                this.lngRange[1],
                this.latRange[1]
            ]) : null;
        }, To.prototype.setMaxBounds = function(t1) {
            t1 ? (this.lngRange = [
                t1.getWest(),
                t1.getEast()
            ], this.latRange = [
                t1.getSouth(),
                t1.getNorth()
            ], this._constrain()) : (this.lngRange = null, this.latRange = [
                -this.maxValidLatitude,
                this.maxValidLatitude
            ]);
        }, To.prototype.calculatePosMatrix = function(e1, i) {
            void 0 === i && (i = !1);
            var o = e1.key, r = i ? this._alignedPosMatrixCache : this._posMatrixCache;
            if (r[o]) return r[o];
            var a = e1.canonical, n = this.worldSize / this.zoomScale(a.z), s = a.x + Math.pow(2, a.z) * e1.wrap, l = t1.identity(new Float64Array(16));
            return t1.translate(l, l, [
                s * n,
                a.y * n,
                0
            ]), t1.scale(l, l, [
                n / t1.EXTENT,
                n / t1.EXTENT,
                1
            ]), t1.multiply(l, i ? this.alignedProjMatrix : this.projMatrix, l), r[o] = new Float32Array(l), r[o];
        }, To.prototype.customLayerMatrix = function() {
            return this.mercatorMatrix.slice();
        }, To.prototype._constrain = function() {
            if (this.center && this.width && this.height && !this._constraining) {
                this._constraining = !0;
                var e1, i, o, r, a = -90, n = 90, s = -180, l = 180, c = this.size, u = this._unmodified;
                if (this.latRange) {
                    var h = this.latRange;
                    a = t1.mercatorYfromLat(h[1]) * this.worldSize, e1 = (n = t1.mercatorYfromLat(h[0]) * this.worldSize) - a < c.y ? c.y / (n - a) : 0;
                }
                if (this.lngRange) {
                    var p = this.lngRange;
                    s = t1.mercatorXfromLng(p[0]) * this.worldSize, i = (l = t1.mercatorXfromLng(p[1]) * this.worldSize) - s < c.x ? c.x / (l - s) : 0;
                }
                var d = this.point, _ = Math.max(i || 0, e1 || 0);
                if (_) return this.center = this.unproject(new t1.Point(i ? (l + s) / 2 : d.x, e1 ? (n + a) / 2 : d.y)), this.zoom += this.scaleZoom(_), this._unmodified = u, void (this._constraining = !1);
                if (this.latRange) {
                    var f = d.y, m = c.y / 2;
                    f - m < a && (r = a + m), f + m > n && (r = n - m);
                }
                if (this.lngRange) {
                    var g = d.x, v = c.x / 2;
                    g - v < s && (o = s + v), g + v > l && (o = l - v);
                }
                void 0 === o && void 0 === r || (this.center = this.unproject(new t1.Point(void 0 !== o ? o : d.x, void 0 !== r ? r : d.y))), this._unmodified = u, this._constraining = !1;
            }
        }, To.prototype._calcMatrices = function() {
            if (this.height) {
                var e1 = this.centerOffset;
                this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height;
                var i = Math.PI / 2 + this._pitch, o = this._fov * (.5 + e1.y / this.height), r = Math.sin(o) * this.cameraToCenterDistance / Math.sin(t1.clamp(Math.PI - i - o, .01, Math.PI - .01)), a = this.point, n = a.x, s = a.y, l = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * r + this.cameraToCenterDistance), c = this.height / 50, u = new Float64Array(16);
                t1.perspective(u, this._fov, this.width / this.height, c, l), u[8] = 2 * -e1.x / this.width, u[9] = 2 * e1.y / this.height, t1.scale(u, u, [
                    1,
                    -1,
                    1
                ]), t1.translate(u, u, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t1.rotateX(u, u, this._pitch), t1.rotateZ(u, u, this.angle), t1.translate(u, u, [
                    -n,
                    -s,
                    0
                ]), this.mercatorMatrix = t1.scale([], u, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t1.scale(u, u, [
                    1,
                    1,
                    t1.mercatorZfromAltitude(1, this.center.lat) * this.worldSize,
                    1
                ]), this.projMatrix = u, this.invProjMatrix = t1.invert([], this.projMatrix);
                var h = this.width % 2 / 2, p = this.height % 2 / 2, d = Math.cos(this.angle), _ = Math.sin(this.angle), f = n - Math.round(n) + d * h + _ * p, m = s - Math.round(s) + d * p + _ * h, g = new Float64Array(u);
                if (t1.translate(g, g, [
                    f > .5 ? f - 1 : f,
                    m > .5 ? m - 1 : m,
                    0
                ]), this.alignedProjMatrix = g, u = t1.create(), t1.scale(u, u, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), t1.translate(u, u, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = u, u = t1.create(), t1.scale(u, u, [
                    1,
                    -1,
                    1
                ]), t1.translate(u, u, [
                    -1,
                    -1,
                    0
                ]), t1.scale(u, u, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = u, this.pixelMatrix = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), !(u = t1.invert(new Float64Array(16), this.pixelMatrix))) throw new Error("failed to invert matrix");
                this.pixelMatrixInverse = u, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
        }, To.prototype.maxPitchScaleFactor = function() {
            if (!this.pixelMatrixInverse) return 1;
            var e1 = this.pointCoordinate(new t1.Point(0, 0)), i = [
                e1.x * this.worldSize,
                e1.y * this.worldSize,
                0,
                1
            ];
            return t1.transformMat4(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance;
        }, To.prototype.getCameraPoint = function() {
            var e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
            return this.centerPoint.add(new t1.Point(0, e1));
        }, To.prototype.getCameraQueryGeometry = function(e1) {
            var i = this.getCameraPoint();
            if (1 === e1.length) return [
                e1[0],
                i
            ];
            for(var o = i.x, r = i.y, a = i.x, n = i.y, s = 0, l = e1; s < l.length; s += 1){
                var c = l[s];
                o = Math.min(o, c.x), r = Math.min(r, c.y), a = Math.max(a, c.x), n = Math.max(n, c.y);
            }
            return [
                new t1.Point(o, r),
                new t1.Point(a, r),
                new t1.Point(a, n),
                new t1.Point(o, n),
                new t1.Point(o, r)
            ];
        }, Object.defineProperties(To.prototype, Eo);
        var Io = function(e1) {
            var i, o, r, a;
            this._hashName = e1 && encodeURIComponent(e1), t1.bindAll([
                "_getCurrentHash",
                "_onHashChange",
                "_updateHash"
            ], this), this._updateHash = (i = this._updateHashUnthrottled.bind(this), o = !1, r = null, a = function() {
                r = null, o && (i(), r = setTimeout(a, 300), o = !1);
            }, function() {
                return o = !0, r || a(), r;
            });
        };
        Io.prototype.addTo = function(e1) {
            return this._map = e1, t1.window.addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
        }, Io.prototype.remove = function() {
            return t1.window.removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
        }, Io.prototype.getHashString = function(e1) {
            var i = this._map.getCenter(), o = Math.round(100 * this._map.getZoom()) / 100, r = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, r), n = Math.round(i.lng * a) / a, s = Math.round(i.lat * a) / a, l = this._map.getBearing(), c = this._map.getPitch(), u = "";
            if (u += e1 ? "/" + n + "/" + s + "/" + o : o + "/" + s + "/" + n, (l || c) && (u += "/" + Math.round(10 * l) / 10), c && (u += "/" + Math.round(c)), this._hashName) {
                var h = this._hashName, p = !1, d = t1.window.location.hash.slice(1).split("&").map(function(t1) {
                    var e1 = t1.split("=")[0];
                    return e1 === h ? (p = !0, e1 + "=" + u) : t1;
                }).filter(function(t1) {
                    return t1;
                });
                return p || d.push(h + "=" + u), "#" + d.join("&");
            }
            return "#" + u;
        }, Io.prototype._getCurrentHash = function() {
            var e1, i = this, o = t1.window.location.hash.replace("#", "");
            return this._hashName ? (o.split("&").map(function(t1) {
                return t1.split("=");
            }).forEach(function(t1) {
                t1[0] === i._hashName && (e1 = t1);
            }), (e1 && e1[1] || "").split("/")) : o.split("/");
        }, Io.prototype._onHashChange = function() {
            var t1 = this._getCurrentHash();
            if (t1.length >= 3 && !t1.some(function(t1) {
                return isNaN(t1);
            })) {
                var e1 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : this._map.getBearing();
                return this._map.jumpTo({
                    center: [
                        +t1[2],
                        +t1[1]
                    ],
                    zoom: +t1[0],
                    bearing: e1,
                    pitch: +(t1[4] || 0)
                }), !0;
            }
            return !1;
        }, Io.prototype._updateHashUnthrottled = function() {
            var e1 = t1.window.location.href.replace(/(#.+)?$/, this.getHashString());
            try {
                t1.window.history.replaceState(t1.window.history.state, null, e1);
            } catch (t1) {}
        };
        var Po = {
            linearity: .3,
            easing: t1.bezier(0, 0, .3, 1)
        }, So = t1.extend({
            deceleration: 2500,
            maxSpeed: 1400
        }, Po), Co = t1.extend({
            deceleration: 20,
            maxSpeed: 1400
        }, Po), zo = t1.extend({
            deceleration: 1e3,
            maxSpeed: 360
        }, Po), Do = t1.extend({
            deceleration: 1e3,
            maxSpeed: 90
        }, Po), Ao = function(t1) {
            this._map = t1, this.clear();
        };
        function Mo(t1, e1) {
            (!t1.duration || t1.duration < e1.duration) && (t1.duration = e1.duration, t1.easing = e1.easing);
        }
        function Lo(e1, i, o) {
            var r = o.maxSpeed, a = o.linearity, n = o.deceleration, s = t1.clamp(e1 * a / (i / 1e3), -r, r), l = Math.abs(s) / (n * a);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: s * (l / 2)
            };
        }
        Ao.prototype.clear = function() {
            this._inertiaBuffer = [];
        }, Ao.prototype.record = function(e1) {
            this._drainInertiaBuffer(), this._inertiaBuffer.push({
                time: t1.browser.now(),
                settings: e1
            });
        }, Ao.prototype._drainInertiaBuffer = function() {
            for(var e1 = this._inertiaBuffer, i = t1.browser.now(); e1.length > 0 && i - e1[0].time > 160;)e1.shift();
        }, Ao.prototype._onMoveEnd = function(e1) {
            if (this._drainInertiaBuffer(), !(this._inertiaBuffer.length < 2)) {
                for(var i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new t1.Point(0, 0),
                    pinchAround: void 0,
                    around: void 0
                }, o = 0, r = this._inertiaBuffer; o < r.length; o += 1){
                    var a = r[o].settings;
                    i.zoom += a.zoomDelta || 0, i.bearing += a.bearingDelta || 0, i.pitch += a.pitchDelta || 0, a.panDelta && i.pan._add(a.panDelta), a.around && (i.around = a.around), a.pinchAround && (i.pinchAround = a.pinchAround);
                }
                var n = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                if (i.pan.mag()) {
                    var l = Lo(i.pan.mag(), n, t1.extend({}, So, e1 || {}));
                    s.offset = i.pan.mult(l.amount / i.pan.mag()), s.center = this._map.transform.center, Mo(s, l);
                }
                if (i.zoom) {
                    var c = Lo(i.zoom, n, Co);
                    s.zoom = this._map.transform.zoom + c.amount, Mo(s, c);
                }
                if (i.bearing) {
                    var u = Lo(i.bearing, n, zo);
                    s.bearing = this._map.transform.bearing + t1.clamp(u.amount, -179, 179), Mo(s, u);
                }
                if (i.pitch) {
                    var h = Lo(i.pitch, n, Do);
                    s.pitch = this._map.transform.pitch + h.amount, Mo(s, h);
                }
                if (s.zoom || s.bearing) {
                    var p = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    s.around = p ? this._map.unproject(p) : this._map.getCenter();
                }
                return this.clear(), t1.extend(s, {
                    noMoveStart: !0
                });
            }
        };
        var Ro = function(e1) {
            function o(o, r, a, n) {
                void 0 === n && (n = {});
                var s = i.mousePos(r.getCanvasContainer(), a), l = r.unproject(s);
                e1.call(this, o, t1.extend({
                    point: s,
                    lngLat: l,
                    originalEvent: a
                }, n)), this._defaultPrevented = !1, this.target = r;
            }
            e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o;
            var r = {
                defaultPrevented: {
                    configurable: !0
                }
            };
            return o.prototype.preventDefault = function() {
                this._defaultPrevented = !0;
            }, r.defaultPrevented.get = function() {
                return this._defaultPrevented;
            }, Object.defineProperties(o.prototype, r), o;
        }(t1.Event), ko = function(e1) {
            function o(o, r, a) {
                var n = "touchend" === o ? a.changedTouches : a.touches, s = i.touchPos(r.getCanvasContainer(), n), l = s.map(function(t1) {
                    return r.unproject(t1);
                }), c = s.reduce(function(t1, e1, i, o) {
                    return t1.add(e1.div(o.length));
                }, new t1.Point(0, 0)), u = r.unproject(c);
                e1.call(this, o, {
                    points: s,
                    point: c,
                    lngLats: l,
                    lngLat: u,
                    originalEvent: a
                }), this._defaultPrevented = !1;
            }
            e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o;
            var r = {
                defaultPrevented: {
                    configurable: !0
                }
            };
            return o.prototype.preventDefault = function() {
                this._defaultPrevented = !0;
            }, r.defaultPrevented.get = function() {
                return this._defaultPrevented;
            }, Object.defineProperties(o.prototype, r), o;
        }(t1.Event), Bo = function(t1) {
            function e1(e1, i, o) {
                t1.call(this, e1, {
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var i = {
                defaultPrevented: {
                    configurable: !0
                }
            };
            return e1.prototype.preventDefault = function() {
                this._defaultPrevented = !0;
            }, i.defaultPrevented.get = function() {
                return this._defaultPrevented;
            }, Object.defineProperties(e1.prototype, i), e1;
        }(t1.Event), Oo = function(t1, e1) {
            this._map = t1, this._clickTolerance = e1.clickTolerance;
        };
        Oo.prototype.reset = function() {
            delete this._mousedownPos;
        }, Oo.prototype.wheel = function(t1) {
            return this._firePreventable(new Bo(t1.type, this._map, t1));
        }, Oo.prototype.mousedown = function(t1, e1) {
            return this._mousedownPos = e1, this._firePreventable(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.mouseup = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.click = function(t1, e1) {
            this._mousedownPos && this._mousedownPos.dist(e1) >= this._clickTolerance || this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.dblclick = function(t1) {
            return this._firePreventable(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.mouseover = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.mouseout = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.touchstart = function(t1) {
            return this._firePreventable(new ko(t1.type, this._map, t1));
        }, Oo.prototype.touchmove = function(t1) {
            this._map.fire(new ko(t1.type, this._map, t1));
        }, Oo.prototype.touchend = function(t1) {
            this._map.fire(new ko(t1.type, this._map, t1));
        }, Oo.prototype.touchcancel = function(t1) {
            this._map.fire(new ko(t1.type, this._map, t1));
        }, Oo.prototype._firePreventable = function(t1) {
            if (this._map.fire(t1), t1.defaultPrevented) return {};
        }, Oo.prototype.isEnabled = function() {
            return !0;
        }, Oo.prototype.isActive = function() {
            return !1;
        }, Oo.prototype.enable = function() {}, Oo.prototype.disable = function() {};
        var Fo = function(t1) {
            this._map = t1;
        };
        Fo.prototype.reset = function() {
            this._delayContextMenu = !1, delete this._contextMenuEvent;
        }, Fo.prototype.mousemove = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Fo.prototype.mousedown = function() {
            this._delayContextMenu = !0;
        }, Fo.prototype.mouseup = function() {
            this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Ro("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
        }, Fo.prototype.contextmenu = function(t1) {
            this._delayContextMenu ? this._contextMenuEvent = t1 : this._map.fire(new Ro(t1.type, this._map, t1)), this._map.listens("contextmenu") && t1.preventDefault();
        }, Fo.prototype.isEnabled = function() {
            return !0;
        }, Fo.prototype.isActive = function() {
            return !1;
        }, Fo.prototype.enable = function() {}, Fo.prototype.disable = function() {};
        var Uo = function(t1, e1) {
            this._map = t1, this._el = t1.getCanvasContainer(), this._container = t1.getContainer(), this._clickTolerance = e1.clickTolerance || 1;
        };
        function No(t1, e1) {
            for(var i = {}, o = 0; o < t1.length; o++)i[t1[o].identifier] = e1[o];
            return i;
        }
        Uo.prototype.isEnabled = function() {
            return !!this._enabled;
        }, Uo.prototype.isActive = function() {
            return !!this._active;
        }, Uo.prototype.enable = function() {
            this.isEnabled() || (this._enabled = !0);
        }, Uo.prototype.disable = function() {
            this.isEnabled() && (this._enabled = !1);
        }, Uo.prototype.mousedown = function(t1, e1) {
            this.isEnabled() && t1.shiftKey && 0 === t1.button && (i.disableDrag(), this._startPos = this._lastPos = e1, this._active = !0);
        }, Uo.prototype.mousemoveWindow = function(t1, e1) {
            if (this._active) {
                var o = e1;
                if (!(this._lastPos.equals(o) || !this._box && o.dist(this._startPos) < this._clickTolerance)) {
                    var r = this._startPos;
                    this._lastPos = o, this._box || (this._box = i.create("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", t1));
                    var a = Math.min(r.x, o.x), n = Math.max(r.x, o.x), s = Math.min(r.y, o.y), l = Math.max(r.y, o.y);
                    i.setTransform(this._box, "translate(" + a + "px," + s + "px)"), this._box.style.width = n - a + "px", this._box.style.height = l - s + "px";
                }
            }
        }, Uo.prototype.mouseupWindow = function(e1, o) {
            var r = this;
            if (this._active && 0 === e1.button) {
                var a = this._startPos, n = o;
                if (this.reset(), i.suppressClick(), a.x !== n.x || a.y !== n.y) return this._map.fire(new t1.Event("boxzoomend", {
                    originalEvent: e1
                })), {
                    cameraAnimation: function(t1) {
                        return t1.fitScreenCoordinates(a, n, r._map.getBearing(), {
                            linear: !0
                        });
                    }
                };
                this._fireEvent("boxzoomcancel", e1);
            }
        }, Uo.prototype.keydown = function(t1) {
            this._active && 27 === t1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t1));
        }, Uo.prototype.blur = function() {
            this.reset();
        }, Uo.prototype.reset = function() {
            this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (i.remove(this._box), this._box = null), i.enableDrag(), delete this._startPos, delete this._lastPos;
        }, Uo.prototype._fireEvent = function(e1, i) {
            return this._map.fire(new t1.Event(e1, {
                originalEvent: i
            }));
        };
        var Zo = function(t1) {
            this.reset(), this.numTouches = t1.numTouches;
        };
        Zo.prototype.reset = function() {
            delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
        }, Zo.prototype.touchstart = function(e1, i, o) {
            (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), o.length === this.numTouches && (this.centroid = function(e1) {
                for(var i = new t1.Point(0, 0), o = 0, r = e1; o < r.length; o += 1)i._add(r[o]);
                return i.div(e1.length);
            }(i), this.touches = No(o, i)));
        }, Zo.prototype.touchmove = function(t1, e1, i) {
            if (!this.aborted && this.centroid) {
                var o = No(i, e1);
                for(var r in this.touches){
                    var a = o[r];
                    (!a || a.dist(this.touches[r]) > 30) && (this.aborted = !0);
                }
            }
        }, Zo.prototype.touchend = function(t1, e1, i) {
            if ((!this.centroid || t1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                var o = !this.aborted && this.centroid;
                if (this.reset(), o) return o;
            }
        };
        var qo = function(t1) {
            this.singleTap = new Zo(t1), this.numTaps = t1.numTaps, this.reset();
        };
        qo.prototype.reset = function() {
            this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
        }, qo.prototype.touchstart = function(t1, e1, i) {
            this.singleTap.touchstart(t1, e1, i);
        }, qo.prototype.touchmove = function(t1, e1, i) {
            this.singleTap.touchmove(t1, e1, i);
        }, qo.prototype.touchend = function(t1, e1, i) {
            var o = this.singleTap.touchend(t1, e1, i);
            if (o) {
                var r = t1.timeStamp - this.lastTime < 500, a = !this.lastTap || this.lastTap.dist(o) < 30;
                if (r && a || this.reset(), this.count++, this.lastTime = t1.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
            }
        };
        var jo = function() {
            this._zoomIn = new qo({
                numTouches: 1,
                numTaps: 2
            }), this._zoomOut = new qo({
                numTouches: 2,
                numTaps: 1
            }), this.reset();
        };
        jo.prototype.reset = function() {
            this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
        }, jo.prototype.touchstart = function(t1, e1, i) {
            this._zoomIn.touchstart(t1, e1, i), this._zoomOut.touchstart(t1, e1, i);
        }, jo.prototype.touchmove = function(t1, e1, i) {
            this._zoomIn.touchmove(t1, e1, i), this._zoomOut.touchmove(t1, e1, i);
        }, jo.prototype.touchend = function(t1, e1, i) {
            var o = this, r = this._zoomIn.touchend(t1, e1, i), a = this._zoomOut.touchend(t1, e1, i);
            return r ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                return o.reset();
            }, 0), {
                cameraAnimation: function(e1) {
                    return e1.easeTo({
                        duration: 300,
                        zoom: e1.getZoom() + 1,
                        around: e1.unproject(r)
                    }, {
                        originalEvent: t1
                    });
                }
            }) : a ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                return o.reset();
            }, 0), {
                cameraAnimation: function(e1) {
                    return e1.easeTo({
                        duration: 300,
                        zoom: e1.getZoom() - 1,
                        around: e1.unproject(a)
                    }, {
                        originalEvent: t1
                    });
                }
            }) : void 0;
        }, jo.prototype.touchcancel = function() {
            this.reset();
        }, jo.prototype.enable = function() {
            this._enabled = !0;
        }, jo.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, jo.prototype.isEnabled = function() {
            return this._enabled;
        }, jo.prototype.isActive = function() {
            return this._active;
        };
        var Vo = {
            0: 1,
            2: 2
        }, Go = function(t1) {
            this.reset(), this._clickTolerance = t1.clickTolerance || 1;
        };
        Go.prototype.blur = function() {
            this.reset();
        }, Go.prototype.reset = function() {
            this._active = !1, this._moved = !1, delete this._lastPoint, delete this._eventButton;
        }, Go.prototype._correctButton = function(t1, e1) {
            return !1;
        }, Go.prototype._move = function(t1, e1) {
            return {};
        }, Go.prototype.mousedown = function(t1, e1) {
            if (!this._lastPoint) {
                var o = i.mouseButton(t1);
                this._correctButton(t1, o) && (this._lastPoint = e1, this._eventButton = o);
            }
        }, Go.prototype.mousemoveWindow = function(t1, e1) {
            var i = this._lastPoint;
            if (i) {
                if (t1.preventDefault(), function(t1, e1) {
                    var i = Vo[e1];
                    return void 0 === t1.buttons || (t1.buttons & i) !== i;
                }(t1, this._eventButton)) this.reset();
                else if (this._moved || !(e1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = e1, this._move(i, e1);
            }
        }, Go.prototype.mouseupWindow = function(t1) {
            this._lastPoint && i.mouseButton(t1) === this._eventButton && (this._moved && i.suppressClick(), this.reset());
        }, Go.prototype.enable = function() {
            this._enabled = !0;
        }, Go.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, Go.prototype.isEnabled = function() {
            return this._enabled;
        }, Go.prototype.isActive = function() {
            return this._active;
        };
        var Wo = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.mousedown = function(e1, i) {
                t1.prototype.mousedown.call(this, e1, i), this._lastPoint && (this._active = !0);
            }, e1.prototype._correctButton = function(t1, e1) {
                return 0 === e1 && !t1.ctrlKey;
            }, e1.prototype._move = function(t1, e1) {
                return {
                    around: e1,
                    panDelta: e1.sub(t1)
                };
            }, e1;
        }(Go), Xo = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                return 0 === e1 && t1.ctrlKey || 2 === e1;
            }, e1.prototype._move = function(t1, e1) {
                var i = .8 * (e1.x - t1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }, e1.prototype.contextmenu = function(t1) {
                t1.preventDefault();
            }, e1;
        }(Go), Ho = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                return 0 === e1 && t1.ctrlKey || 2 === e1;
            }, e1.prototype._move = function(t1, e1) {
                var i = -0.5 * (e1.y - t1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }, e1.prototype.contextmenu = function(t1) {
                t1.preventDefault();
            }, e1;
        }(Go), Ko = function(t1) {
            this._minTouches = 1, this._clickTolerance = t1.clickTolerance || 1, this.reset();
        };
        Ko.prototype.reset = function() {
            this._active = !1, this._touches = {}, this._sum = new t1.Point(0, 0);
        }, Ko.prototype.touchstart = function(t1, e1, i) {
            return this._calculateTransform(t1, e1, i);
        }, Ko.prototype.touchmove = function(t1, e1, i) {
            if (this._active && !(i.length < this._minTouches)) return t1.preventDefault(), this._calculateTransform(t1, e1, i);
        }, Ko.prototype.touchend = function(t1, e1, i) {
            this._calculateTransform(t1, e1, i), this._active && i.length < this._minTouches && this.reset();
        }, Ko.prototype.touchcancel = function() {
            this.reset();
        }, Ko.prototype._calculateTransform = function(e1, i, o) {
            o.length > 0 && (this._active = !0);
            var r = No(o, i), a = new t1.Point(0, 0), n = new t1.Point(0, 0), s = 0;
            for(var l in r){
                var c = r[l], u = this._touches[l];
                u && (a._add(c), n._add(c.sub(u)), s++, r[l] = c);
            }
            if (this._touches = r, !(s < this._minTouches) && n.mag()) {
                var h = n.div(s);
                if (this._sum._add(h), !(this._sum.mag() < this._clickTolerance)) return {
                    around: a.div(s),
                    panDelta: h
                };
            }
        }, Ko.prototype.enable = function() {
            this._enabled = !0;
        }, Ko.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, Ko.prototype.isEnabled = function() {
            return this._enabled;
        }, Ko.prototype.isActive = function() {
            return this._active;
        };
        var Yo = function() {
            this.reset();
        };
        function Jo(t1, e1, i) {
            for(var o = 0; o < t1.length; o++)if (t1[o].identifier === i) return e1[o];
        }
        function Qo(t1, e1) {
            return Math.log(t1 / e1) / Math.LN2;
        }
        Yo.prototype.reset = function() {
            this._active = !1, delete this._firstTwoTouches;
        }, Yo.prototype._start = function(t1) {}, Yo.prototype._move = function(t1, e1, i) {
            return {};
        }, Yo.prototype.touchstart = function(t1, e1, i) {
            this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                i[0].identifier,
                i[1].identifier
            ], this._start([
                e1[0],
                e1[1]
            ]));
        }, Yo.prototype.touchmove = function(t1, e1, i) {
            if (this._firstTwoTouches) {
                t1.preventDefault();
                var o = this._firstTwoTouches, r = o[1], a = Jo(i, e1, o[0]), n = Jo(i, e1, r);
                if (a && n) {
                    var s = this._aroundCenter ? null : a.add(n).div(2);
                    return this._move([
                        a,
                        n
                    ], s, t1);
                }
            }
        }, Yo.prototype.touchend = function(t1, e1, o) {
            if (this._firstTwoTouches) {
                var r = this._firstTwoTouches, a = r[1], n = Jo(o, e1, r[0]), s = Jo(o, e1, a);
                n && s || (this._active && i.suppressClick(), this.reset());
            }
        }, Yo.prototype.touchcancel = function() {
            this.reset();
        }, Yo.prototype.enable = function(t1) {
            this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around;
        }, Yo.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, Yo.prototype.isEnabled = function() {
            return this._enabled;
        }, Yo.prototype.isActive = function() {
            return this._active;
        };
        var $o = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.reset = function() {
                t1.prototype.reset.call(this), delete this._distance, delete this._startDistance;
            }, e1.prototype._start = function(t1) {
                this._startDistance = this._distance = t1[0].dist(t1[1]);
            }, e1.prototype._move = function(t1, e1) {
                var i = this._distance;
                if (this._distance = t1[0].dist(t1[1]), this._active || !(Math.abs(Qo(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Qo(this._distance, i),
                    pinchAround: e1
                };
            }, e1;
        }(Yo);
        function tr(t1, e1) {
            return 180 * t1.angleWith(e1) / Math.PI;
        }
        var er = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.reset = function() {
                t1.prototype.reset.call(this), delete this._minDiameter, delete this._startVector, delete this._vector;
            }, e1.prototype._start = function(t1) {
                this._startVector = this._vector = t1[0].sub(t1[1]), this._minDiameter = t1[0].dist(t1[1]);
            }, e1.prototype._move = function(t1, e1) {
                var i = this._vector;
                if (this._vector = t1[0].sub(t1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: tr(this._vector, i),
                    pinchAround: e1
                };
            }, e1.prototype._isBelowThreshold = function(t1) {
                this._minDiameter = Math.min(this._minDiameter, t1.mag());
                var e1 = 25 / (Math.PI * this._minDiameter) * 360, i = tr(t1, this._startVector);
                return Math.abs(i) < e1;
            }, e1;
        }(Yo);
        function ir(t1) {
            return Math.abs(t1.y) > Math.abs(t1.x);
        }
        var or = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.reset = function() {
                t1.prototype.reset.call(this), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }, e1.prototype._start = function(t1) {
                this._lastPoints = t1, ir(t1[0].sub(t1[1])) && (this._valid = !1);
            }, e1.prototype._move = function(t1, e1, i) {
                var o = t1[0].sub(this._lastPoints[0]), r = t1[1].sub(this._lastPoints[1]);
                if (this._valid = this.gestureBeginsVertically(o, r, i.timeStamp), this._valid) return this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (o.y + r.y) / 2 * -0.5
                };
            }, e1.prototype.gestureBeginsVertically = function(t1, e1, i) {
                if (void 0 !== this._valid) return this._valid;
                var o = t1.mag() >= 2, r = e1.mag() >= 2;
                if (o || r) {
                    if (!o || !r) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                    var a = t1.y > 0 == e1.y > 0;
                    return ir(t1) && ir(e1) && a;
                }
            }, e1;
        }(Yo), rr = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        }, ar = function() {
            var t1 = rr;
            this._panStep = t1.panStep, this._bearingStep = t1.bearingStep, this._pitchStep = t1.pitchStep, this._rotationDisabled = !1;
        };
        function nr(t1) {
            return t1 * (2 - t1);
        }
        ar.prototype.blur = function() {
            this.reset();
        }, ar.prototype.reset = function() {
            this._active = !1;
        }, ar.prototype.keydown = function(t1) {
            var e1 = this;
            if (!(t1.altKey || t1.ctrlKey || t1.metaKey)) {
                var i = 0, o = 0, r = 0, a = 0, n = 0;
                switch(t1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        i = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        i = -1;
                        break;
                    case 37:
                        t1.shiftKey ? o = -1 : (t1.preventDefault(), a = -1);
                        break;
                    case 39:
                        t1.shiftKey ? o = 1 : (t1.preventDefault(), a = 1);
                        break;
                    case 38:
                        t1.shiftKey ? r = 1 : (t1.preventDefault(), n = -1);
                        break;
                    case 40:
                        t1.shiftKey ? r = -1 : (t1.preventDefault(), n = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (o = 0, r = 0), {
                    cameraAnimation: function(s) {
                        var l = s.getZoom();
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: nr,
                            zoom: i ? Math.round(l) + i * (t1.shiftKey ? 2 : 1) : l,
                            bearing: s.getBearing() + o * e1._bearingStep,
                            pitch: s.getPitch() + r * e1._pitchStep,
                            offset: [
                                -a * e1._panStep,
                                -n * e1._panStep
                            ],
                            center: s.getCenter()
                        }, {
                            originalEvent: t1
                        });
                    }
                };
            }
        }, ar.prototype.enable = function() {
            this._enabled = !0;
        }, ar.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, ar.prototype.isEnabled = function() {
            return this._enabled;
        }, ar.prototype.isActive = function() {
            return this._active;
        }, ar.prototype.disableRotation = function() {
            this._rotationDisabled = !0;
        }, ar.prototype.enableRotation = function() {
            this._rotationDisabled = !1;
        };
        var sr = function(e1, i) {
            this._map = e1, this._el = e1.getCanvasContainer(), this._handler = i, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = 1 / 450, t1.bindAll([
                "_onTimeout"
            ], this);
        };
        sr.prototype.setZoomRate = function(t1) {
            this._defaultZoomRate = t1;
        }, sr.prototype.setWheelZoomRate = function(t1) {
            this._wheelZoomRate = t1;
        }, sr.prototype.isEnabled = function() {
            return !!this._enabled;
        }, sr.prototype.isActive = function() {
            return !!this._active || void 0 !== this._finishTimeout;
        }, sr.prototype.isZooming = function() {
            return !!this._zooming;
        }, sr.prototype.enable = function(t1) {
            this.isEnabled() || (this._enabled = !0, this._aroundCenter = t1 && "center" === t1.around);
        }, sr.prototype.disable = function() {
            this.isEnabled() && (this._enabled = !1);
        }, sr.prototype.wheel = function(e1) {
            if (this.isEnabled()) {
                var i = e1.deltaMode === t1.window.WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY, o = t1.browser.now(), r = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % 4.000244140625 == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= i, this._active || this._start(e1)), e1.preventDefault();
            }
        }, sr.prototype._onTimeout = function(t1) {
            this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t1);
        }, sr.prototype._start = function(e1) {
            if (this._delta) {
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                var o = i.mousePos(this._el, e1);
                this._around = t1.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(o)), this._aroundPoint = this._map.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
        }, sr.prototype.renderFrame = function() {
            var e1 = this;
            if (this._frameId && (this._frameId = null, this.isActive())) {
                var i = this._map.transform;
                if (0 !== this._delta) {
                    var o = "wheel" === this._type && Math.abs(this._delta) > 4.000244140625 ? this._wheelZoomRate : this._defaultZoomRate, r = 2 / (1 + Math.exp(-Math.abs(this._delta * o)));
                    this._delta < 0 && 0 !== r && (r = 1 / r);
                    var a = "number" == typeof this._targetZoom ? i.zoomScale(this._targetZoom) : i.scale;
                    this._targetZoom = Math.min(i.maxZoom, Math.max(i.minZoom, i.scaleZoom(a * r))), "wheel" === this._type && (this._startZoom = i.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                var n, s = "number" == typeof this._targetZoom ? this._targetZoom : i.zoom, l = this._startZoom, c = this._easing, u = !1;
                if ("wheel" === this._type && l && c) {
                    var h = Math.min((t1.browser.now() - this._lastWheelEventTime) / 200, 1), p = c(h);
                    n = t1.number(l, s, p), h < 1 ? this._frameId || (this._frameId = !0) : u = !0;
                } else n = s, u = !0;
                return this._active = !0, u && (this._active = !1, this._finishTimeout = setTimeout(function() {
                    e1._zooming = !1, e1._handler._triggerRenderFrame(), delete e1._targetZoom, delete e1._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !u,
                    zoomDelta: n - i.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
        }, sr.prototype._smoothOutEasing = function(e1) {
            var i = t1.ease;
            if (this._prevEase) {
                var o = this._prevEase, r = (t1.browser.now() - o.start) / o.duration, a = o.easing(r + .01) - o.easing(r), n = .27 / Math.sqrt(a * a + 1e-4) * .01, s = Math.sqrt(.0729 - n * n);
                i = t1.bezier(n, s, .25, 1);
            }
            return this._prevEase = {
                start: t1.browser.now(),
                duration: e1,
                easing: i
            }, i;
        }, sr.prototype.blur = function() {
            this.reset();
        }, sr.prototype.reset = function() {
            this._active = !1;
        };
        var lr = function(t1, e1) {
            this._clickZoom = t1, this._tapZoom = e1;
        };
        lr.prototype.enable = function() {
            this._clickZoom.enable(), this._tapZoom.enable();
        }, lr.prototype.disable = function() {
            this._clickZoom.disable(), this._tapZoom.disable();
        }, lr.prototype.isEnabled = function() {
            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
        }, lr.prototype.isActive = function() {
            return this._clickZoom.isActive() || this._tapZoom.isActive();
        };
        var cr = function() {
            this.reset();
        };
        cr.prototype.reset = function() {
            this._active = !1;
        }, cr.prototype.blur = function() {
            this.reset();
        }, cr.prototype.dblclick = function(t1, e1) {
            return t1.preventDefault(), {
                cameraAnimation: function(i) {
                    i.easeTo({
                        duration: 300,
                        zoom: i.getZoom() + (t1.shiftKey ? -1 : 1),
                        around: i.unproject(e1)
                    }, {
                        originalEvent: t1
                    });
                }
            };
        }, cr.prototype.enable = function() {
            this._enabled = !0;
        }, cr.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, cr.prototype.isEnabled = function() {
            return this._enabled;
        }, cr.prototype.isActive = function() {
            return this._active;
        };
        var ur = function() {
            this._tap = new qo({
                numTouches: 1,
                numTaps: 1
            }), this.reset();
        };
        ur.prototype.reset = function() {
            this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
        }, ur.prototype.touchstart = function(t1, e1, i) {
            this._swipePoint || (this._tapTime && t1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = e1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(t1, e1, i));
        }, ur.prototype.touchmove = function(t1, e1, i) {
            if (this._tapTime) {
                if (this._swipePoint) {
                    if (i[0].identifier !== this._swipeTouch) return;
                    var o = e1[0], r = o.y - this._swipePoint.y;
                    return this._swipePoint = o, t1.preventDefault(), this._active = !0, {
                        zoomDelta: r / 128
                    };
                }
            } else this._tap.touchmove(t1, e1, i);
        }, ur.prototype.touchend = function(t1, e1, i) {
            this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(t1, e1, i) && (this._tapTime = t1.timeStamp);
        }, ur.prototype.touchcancel = function() {
            this.reset();
        }, ur.prototype.enable = function() {
            this._enabled = !0;
        }, ur.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, ur.prototype.isEnabled = function() {
            return this._enabled;
        }, ur.prototype.isActive = function() {
            return this._active;
        };
        var hr = function(t1, e1, i) {
            this._el = t1, this._mousePan = e1, this._touchPan = i;
        };
        hr.prototype.enable = function(t1) {
            this._inertiaOptions = t1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
        }, hr.prototype.disable = function() {
            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
        }, hr.prototype.isEnabled = function() {
            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
        }, hr.prototype.isActive = function() {
            return this._mousePan.isActive() || this._touchPan.isActive();
        };
        var pr = function(t1, e1, i) {
            this._pitchWithRotate = t1.pitchWithRotate, this._mouseRotate = e1, this._mousePitch = i;
        };
        pr.prototype.enable = function() {
            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
        }, pr.prototype.disable = function() {
            this._mouseRotate.disable(), this._mousePitch.disable();
        }, pr.prototype.isEnabled = function() {
            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
        }, pr.prototype.isActive = function() {
            return this._mouseRotate.isActive() || this._mousePitch.isActive();
        };
        var dr = function(t1, e1, i, o) {
            this._el = t1, this._touchZoom = e1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
        };
        dr.prototype.enable = function(t1) {
            this._touchZoom.enable(t1), this._rotationDisabled || this._touchRotate.enable(t1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
        }, dr.prototype.disable = function() {
            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
        }, dr.prototype.isEnabled = function() {
            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
        }, dr.prototype.isActive = function() {
            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
        }, dr.prototype.disableRotation = function() {
            this._rotationDisabled = !0, this._touchRotate.disable();
        }, dr.prototype.enableRotation = function() {
            this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
        };
        var _r = function(t1) {
            return t1.zoom || t1.drag || t1.pitch || t1.rotate;
        }, fr = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(t1.Event);
        function mr(t1) {
            return t1.panDelta && t1.panDelta.mag() || t1.zoomDelta || t1.bearingDelta || t1.pitchDelta;
        }
        var gr = function(e1, o) {
            this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Ao(e1), this._bearingSnap = o.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(o), t1.bindAll([
                "handleEvent",
                "handleWindowEvent"
            ], this);
            var r = this._el;
            this._listeners = [
                [
                    r,
                    "touchstart",
                    {
                        passive: !0
                    }
                ],
                [
                    r,
                    "touchmove",
                    {
                        passive: !1
                    }
                ],
                [
                    r,
                    "touchend",
                    void 0
                ],
                [
                    r,
                    "touchcancel",
                    void 0
                ],
                [
                    r,
                    "mousedown",
                    void 0
                ],
                [
                    r,
                    "mousemove",
                    void 0
                ],
                [
                    r,
                    "mouseup",
                    void 0
                ],
                [
                    t1.window.document,
                    "mousemove",
                    {
                        capture: !0
                    }
                ],
                [
                    t1.window.document,
                    "mouseup",
                    void 0
                ],
                [
                    r,
                    "mouseover",
                    void 0
                ],
                [
                    r,
                    "mouseout",
                    void 0
                ],
                [
                    r,
                    "dblclick",
                    void 0
                ],
                [
                    r,
                    "click",
                    void 0
                ],
                [
                    r,
                    "keydown",
                    {
                        capture: !1
                    }
                ],
                [
                    r,
                    "keyup",
                    void 0
                ],
                [
                    r,
                    "wheel",
                    {
                        passive: !1
                    }
                ],
                [
                    r,
                    "contextmenu",
                    void 0
                ],
                [
                    t1.window,
                    "blur",
                    void 0
                ]
            ];
            for(var a = 0, n = this._listeners; a < n.length; a += 1){
                var s = n[a], l = s[0];
                i.addEventListener(l, s[1], l === t1.window.document ? this.handleWindowEvent : this.handleEvent, s[2]);
            }
        };
        gr.prototype.destroy = function() {
            for(var e1 = 0, o = this._listeners; e1 < o.length; e1 += 1){
                var r = o[e1], a = r[0];
                i.removeEventListener(a, r[1], a === t1.window.document ? this.handleWindowEvent : this.handleEvent, r[2]);
            }
        }, gr.prototype._addDefaultHandlers = function(t1) {
            var e1 = this._map, i = e1.getCanvasContainer();
            this._add("mapEvent", new Oo(e1, t1));
            var o = e1.boxZoom = new Uo(e1, t1);
            this._add("boxZoom", o);
            var r = new jo, a = new cr;
            e1.doubleClickZoom = new lr(a, r), this._add("tapZoom", r), this._add("clickZoom", a);
            var n = new ur;
            this._add("tapDragZoom", n);
            var s = e1.touchPitch = new or;
            this._add("touchPitch", s);
            var l = new Xo(t1), c = new Ho(t1);
            e1.dragRotate = new pr(t1, l, c), this._add("mouseRotate", l, [
                "mousePitch"
            ]), this._add("mousePitch", c, [
                "mouseRotate"
            ]);
            var u = new Wo(t1), h = new Ko(t1);
            e1.dragPan = new hr(i, u, h), this._add("mousePan", u), this._add("touchPan", h, [
                "touchZoom",
                "touchRotate"
            ]);
            var p = new er, d = new $o;
            e1.touchZoomRotate = new dr(i, d, p, n), this._add("touchRotate", p, [
                "touchPan",
                "touchZoom"
            ]), this._add("touchZoom", d, [
                "touchPan",
                "touchRotate"
            ]);
            var _ = e1.scrollZoom = new sr(e1, this);
            this._add("scrollZoom", _, [
                "mousePan"
            ]);
            var f = e1.keyboard = new ar;
            this._add("keyboard", f), this._add("blockableMapEvent", new Fo(e1));
            for(var m = 0, g = [
                "boxZoom",
                "doubleClickZoom",
                "tapDragZoom",
                "touchPitch",
                "dragRotate",
                "dragPan",
                "touchZoomRotate",
                "scrollZoom",
                "keyboard"
            ]; m < g.length; m += 1){
                var v = g[m];
                t1.interactive && t1[v] && e1[v].enable(t1[v]);
            }
        }, gr.prototype._add = function(t1, e1, i) {
            this._handlers.push({
                handlerName: t1,
                handler: e1,
                allowed: i
            }), this._handlersById[t1] = e1;
        }, gr.prototype.stop = function(t1) {
            if (!this._updatingCamera) {
                for(var e1 = 0, i = this._handlers; e1 < i.length; e1 += 1)i[e1].handler.reset();
                this._inertia.clear(), this._fireEvents({}, {}, t1), this._changes = [];
            }
        }, gr.prototype.isActive = function() {
            for(var t1 = 0, e1 = this._handlers; t1 < e1.length; t1 += 1)if (e1[t1].handler.isActive()) return !0;
            return !1;
        }, gr.prototype.isZooming = function() {
            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
        }, gr.prototype.isRotating = function() {
            return !!this._eventsInProgress.rotate;
        }, gr.prototype.isMoving = function() {
            return Boolean(_r(this._eventsInProgress)) || this.isZooming();
        }, gr.prototype._blockedByActive = function(t1, e1, i) {
            for(var o in t1)if (o !== i && (!e1 || e1.indexOf(o) < 0)) return !0;
            return !1;
        }, gr.prototype.handleWindowEvent = function(t1) {
            this.handleEvent(t1, t1.type + "Window");
        }, gr.prototype._getMapTouches = function(t1) {
            for(var e1 = [], i = 0, o = t1; i < o.length; i += 1){
                var r = o[i];
                this._el.contains(r.target) && e1.push(r);
            }
            return e1;
        }, gr.prototype.handleEvent = function(t1, e1) {
            this._updatingCamera = !0;
            for(var o = "renderFrame" === t1.type ? void 0 : t1, r = {
                needsRenderFrame: !1
            }, a = {}, n = {}, s = t1.touches ? this._getMapTouches(t1.touches) : void 0, l = s ? i.touchPos(this._el, s) : i.mousePos(this._el, t1), c = 0, u = this._handlers; c < u.length; c += 1){
                var h = u[c], p = h.handlerName, d = h.handler, _ = h.allowed;
                if (d.isEnabled()) {
                    var f = void 0;
                    this._blockedByActive(n, _, p) ? d.reset() : d[e1 || t1.type] && (f = d[e1 || t1.type](t1, l, s), this.mergeHandlerResult(r, a, f, p, o), f && f.needsRenderFrame && this._triggerRenderFrame()), (f || d.isActive()) && (n[p] = d);
                }
            }
            var m = {};
            for(var g in this._previousActiveHandlers)n[g] || (m[g] = o);
            this._previousActiveHandlers = n, (Object.keys(m).length || mr(r)) && (this._changes.push([
                r,
                a,
                m
            ]), this._triggerRenderFrame()), (Object.keys(n).length || mr(r)) && this._map._stop(!0), this._updatingCamera = !1;
            var v = r.cameraAnimation;
            v && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], v(this._map));
        }, gr.prototype.mergeHandlerResult = function(e1, i, o, r, a) {
            if (o) {
                t1.extend(e1, o);
                var n = {
                    handlerName: r,
                    originalEvent: o.originalEvent || a
                };
                void 0 !== o.zoomDelta && (i.zoom = n), void 0 !== o.panDelta && (i.drag = n), void 0 !== o.pitchDelta && (i.pitch = n), void 0 !== o.bearingDelta && (i.rotate = n);
            }
        }, gr.prototype._applyChanges = function() {
            for(var e1 = {}, i = {}, o = {}, r = 0, a = this._changes; r < a.length; r += 1){
                var n = a[r], s = n[0], l = n[1], c = n[2];
                s.panDelta && (e1.panDelta = (e1.panDelta || new t1.Point(0, 0))._add(s.panDelta)), s.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (e1.around = s.around), void 0 !== s.pinchAround && (e1.pinchAround = s.pinchAround), s.noInertia && (e1.noInertia = s.noInertia), t1.extend(i, l), t1.extend(o, c);
            }
            this._updateMapTransform(e1, i, o), this._changes = [];
        }, gr.prototype._updateMapTransform = function(t1, e1, i) {
            var o = this._map, r = o.transform;
            if (!mr(t1)) return this._fireEvents(e1, i, !0);
            var a = t1.panDelta, n = t1.zoomDelta, s = t1.bearingDelta, l = t1.pitchDelta, c = t1.around, u = t1.pinchAround;
            void 0 !== u && (c = u), o._stop(!0), c = c || o.transform.centerPoint;
            var h = r.pointLocation(a ? c.sub(a) : c);
            s && (r.bearing += s), l && (r.pitch += l), n && (r.zoom += n), r.setLocationAtPoint(h, c), this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(e1, i, !0);
        }, gr.prototype._fireEvents = function(e1, i, o) {
            var r = this, a = _r(this._eventsInProgress), n = _r(e1), s = {};
            for(var l in e1)this._eventsInProgress[l] || (s[l + "start"] = e1[l].originalEvent), this._eventsInProgress[l] = e1[l];
            for(var c in !a && n && this._fireEvent("movestart", n.originalEvent), s)this._fireEvent(c, s[c]);
            for(var u in n && this._fireEvent("move", n.originalEvent), e1)this._fireEvent(u, e1[u].originalEvent);
            var h, p = {};
            for(var d in this._eventsInProgress){
                var _ = this._eventsInProgress[d], f = _.handlerName, m = _.originalEvent;
                this._handlersById[f].isActive() || (delete this._eventsInProgress[d], p[d + "end"] = h = i[f] || m);
            }
            for(var g in p)this._fireEvent(g, p[g]);
            var v = _r(this._eventsInProgress);
            if (o && (a || n) && !v) {
                this._updatingCamera = !0;
                var y = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), x = function(t1) {
                    return 0 !== t1 && -r._bearingSnap < t1 && t1 < r._bearingSnap;
                };
                y ? (x(y.bearing || this._map.getBearing()) && (y.bearing = 0), this._map.easeTo(y, {
                    originalEvent: h
                })) : (this._map.fire(new t1.Event("moveend", {
                    originalEvent: h
                })), x(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
            }
        }, gr.prototype._fireEvent = function(e1, i) {
            this._map.fire(new t1.Event(e1, i ? {
                originalEvent: i
            } : {}));
        }, gr.prototype._requestFrame = function() {
            var t1 = this;
            return this._map.triggerRepaint(), this._map._renderTaskQueue.add(function(e1) {
                delete t1._frameId, t1.handleEvent(new fr("renderFrame", {
                    timeStamp: e1
                })), t1._applyChanges();
            });
        }, gr.prototype._triggerRenderFrame = function() {
            void 0 === this._frameId && (this._frameId = this._requestFrame());
        };
        var vr = function(e1) {
            function i(i, o) {
                e1.call(this), this._moving = !1, this._zooming = !1, this.transform = i, this._bearingSnap = o.bearingSnap, t1.bindAll([
                    "_renderFrameCallback"
                ], this);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getCenter = function() {
                return new t1.LngLat(this.transform.center.lng, this.transform.center.lat);
            }, i.prototype.setCenter = function(t1, e1) {
                return this.jumpTo({
                    center: t1
                }, e1);
            }, i.prototype.panBy = function(e1, i, o) {
                return e1 = t1.Point.convert(e1).mult(-1), this.panTo(this.transform.center, t1.extend({
                    offset: e1
                }, i), o);
            }, i.prototype.panTo = function(e1, i, o) {
                return this.easeTo(t1.extend({
                    center: e1
                }, i), o);
            }, i.prototype.getZoom = function() {
                return this.transform.zoom;
            }, i.prototype.setZoom = function(t1, e1) {
                return this.jumpTo({
                    zoom: t1
                }, e1), this;
            }, i.prototype.zoomTo = function(e1, i, o) {
                return this.easeTo(t1.extend({
                    zoom: e1
                }, i), o);
            }, i.prototype.zoomIn = function(t1, e1) {
                return this.zoomTo(this.getZoom() + 1, t1, e1), this;
            }, i.prototype.zoomOut = function(t1, e1) {
                return this.zoomTo(this.getZoom() - 1, t1, e1), this;
            }, i.prototype.getBearing = function() {
                return this.transform.bearing;
            }, i.prototype.setBearing = function(t1, e1) {
                return this.jumpTo({
                    bearing: t1
                }, e1), this;
            }, i.prototype.getPadding = function() {
                return this.transform.padding;
            }, i.prototype.setPadding = function(t1, e1) {
                return this.jumpTo({
                    padding: t1
                }, e1), this;
            }, i.prototype.rotateTo = function(e1, i, o) {
                return this.easeTo(t1.extend({
                    bearing: e1
                }, i), o);
            }, i.prototype.resetNorth = function(e1, i) {
                return this.rotateTo(0, t1.extend({
                    duration: 1e3
                }, e1), i), this;
            }, i.prototype.resetNorthPitch = function(e1, i) {
                return this.easeTo(t1.extend({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e1), i), this;
            }, i.prototype.snapToNorth = function(t1, e1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t1, e1) : this;
            }, i.prototype.getPitch = function() {
                return this.transform.pitch;
            }, i.prototype.setPitch = function(t1, e1) {
                return this.jumpTo({
                    pitch: t1
                }, e1), this;
            }, i.prototype.cameraForBounds = function(e1, i) {
                e1 = t1.LngLatBounds.convert(e1);
                var o = i && i.bearing || 0;
                return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), o, i);
            }, i.prototype._cameraForBoxAndBearing = function(e1, i, o, r) {
                var a = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (r = t1.extend({
                    padding: a,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, r)).padding) {
                    var n = r.padding;
                    r.padding = {
                        top: n,
                        bottom: n,
                        right: n,
                        left: n
                    };
                }
                r.padding = t1.extend(a, r.padding);
                var s = this.transform, l = s.padding, c = s.project(t1.LngLat.convert(e1)), u = s.project(t1.LngLat.convert(i)), h = c.rotate(-o * Math.PI / 180), p = u.rotate(-o * Math.PI / 180), d = new t1.Point(Math.max(h.x, p.x), Math.max(h.y, p.y)), _ = new t1.Point(Math.min(h.x, p.x), Math.min(h.y, p.y)), f = d.sub(_), m = (s.width - (l.left + l.right + r.padding.left + r.padding.right)) / f.x, g = (s.height - (l.top + l.bottom + r.padding.top + r.padding.bottom)) / f.y;
                if (!(g < 0 || m < 0)) {
                    var v = Math.min(s.scaleZoom(s.scale * Math.min(m, g)), r.maxZoom), y = "number" == typeof r.offset.x ? new t1.Point(r.offset.x, r.offset.y) : t1.Point.convert(r.offset), x = new t1.Point((r.padding.left - r.padding.right) / 2, (r.padding.top - r.padding.bottom) / 2).rotate(o * Math.PI / 180), b = y.add(x).mult(s.scale / s.zoomScale(v));
                    return {
                        center: s.unproject(c.add(u).div(2).sub(b)),
                        zoom: v,
                        bearing: o
                    };
                }
                t1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
            }, i.prototype.fitBounds = function(t1, e1, i) {
                return this._fitInternal(this.cameraForBounds(t1, e1), e1, i);
            }, i.prototype.fitScreenCoordinates = function(e1, i, o, r, a) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t1.Point.convert(e1)), this.transform.pointLocation(t1.Point.convert(i)), o, r), r, a);
            }, i.prototype._fitInternal = function(e1, i, o) {
                return e1 ? (delete (i = t1.extend(e1, i)).padding, i.linear ? this.easeTo(i, o) : this.flyTo(i, o)) : this;
            }, i.prototype.jumpTo = function(e1, i) {
                this.stop();
                var o = this.transform, r = !1, a = !1, n = !1;
                return "zoom" in e1 && o.zoom !== +e1.zoom && (r = !0, o.zoom = +e1.zoom), void 0 !== e1.center && (o.center = t1.LngLat.convert(e1.center)), "bearing" in e1 && o.bearing !== +e1.bearing && (a = !0, o.bearing = +e1.bearing), "pitch" in e1 && o.pitch !== +e1.pitch && (n = !0, o.pitch = +e1.pitch), null == e1.padding || o.isPaddingEqual(e1.padding) || (o.padding = e1.padding), this.fire(new t1.Event("movestart", i)).fire(new t1.Event("move", i)), r && this.fire(new t1.Event("zoomstart", i)).fire(new t1.Event("zoom", i)).fire(new t1.Event("zoomend", i)), a && this.fire(new t1.Event("rotatestart", i)).fire(new t1.Event("rotate", i)).fire(new t1.Event("rotateend", i)), n && this.fire(new t1.Event("pitchstart", i)).fire(new t1.Event("pitch", i)).fire(new t1.Event("pitchend", i)), this.fire(new t1.Event("moveend", i));
            }, i.prototype.easeTo = function(e1, i) {
                var o = this;
                this._stop(!1, e1.easeId), (!1 === (e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t1.ease
                }, e1)).animate || !e1.essential && t1.browser.prefersReducedMotion) && (e1.duration = 0);
                var r = this.transform, a = this.getZoom(), n = this.getBearing(), s = this.getPitch(), l = this.getPadding(), c = "zoom" in e1 ? +e1.zoom : a, u = "bearing" in e1 ? this._normalizeBearing(e1.bearing, n) : n, h = "pitch" in e1 ? +e1.pitch : s, p = "padding" in e1 ? e1.padding : r.padding, d = t1.Point.convert(e1.offset), _ = r.centerPoint.add(d), f = r.pointLocation(_), m = t1.LngLat.convert(e1.center || f);
                this._normalizeCenter(m);
                var g, v, y = r.project(f), x = r.project(m).sub(y), b = r.zoomScale(c - a);
                e1.around && (g = t1.LngLat.convert(e1.around), v = r.locationPoint(g));
                var w = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = this._zooming || c !== a, this._rotating = this._rotating || n !== u, this._pitching = this._pitching || h !== s, this._padding = !r.isPaddingEqual(p), this._easeId = e1.easeId, this._prepareEase(i, e1.noMoveStart, w), this._ease(function(e1) {
                    if (o._zooming && (r.zoom = t1.number(a, c, e1)), o._rotating && (r.bearing = t1.number(n, u, e1)), o._pitching && (r.pitch = t1.number(s, h, e1)), o._padding && (r.interpolatePadding(l, p, e1), _ = r.centerPoint.add(d)), g) r.setLocationAtPoint(g, v);
                    else {
                        var f = r.zoomScale(r.zoom - a), m = c > a ? Math.min(2, b) : Math.max(.5, b), w = Math.pow(m, 1 - e1), T = r.unproject(y.add(x.mult(e1 * w)).mult(f));
                        r.setLocationAtPoint(r.renderWorldCopies ? T.wrap() : T, _);
                    }
                    o._fireMoveEvents(i);
                }, function(t1) {
                    o._afterEase(i, t1);
                }, e1), this;
            }, i.prototype._prepareEase = function(e1, i, o) {
                void 0 === o && (o = {}), this._moving = !0, i || o.moving || this.fire(new t1.Event("movestart", e1)), this._zooming && !o.zooming && this.fire(new t1.Event("zoomstart", e1)), this._rotating && !o.rotating && this.fire(new t1.Event("rotatestart", e1)), this._pitching && !o.pitching && this.fire(new t1.Event("pitchstart", e1));
            }, i.prototype._fireMoveEvents = function(e1) {
                this.fire(new t1.Event("move", e1)), this._zooming && this.fire(new t1.Event("zoom", e1)), this._rotating && this.fire(new t1.Event("rotate", e1)), this._pitching && this.fire(new t1.Event("pitch", e1));
            }, i.prototype._afterEase = function(e1, i) {
                if (!this._easeId || !i || this._easeId !== i) {
                    delete this._easeId;
                    var o = this._zooming, r = this._rotating, a = this._pitching;
                    this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new t1.Event("zoomend", e1)), r && this.fire(new t1.Event("rotateend", e1)), a && this.fire(new t1.Event("pitchend", e1)), this.fire(new t1.Event("moveend", e1));
                }
            }, i.prototype.flyTo = function(e1, i) {
                var o = this;
                if (!e1.essential && t1.browser.prefersReducedMotion) {
                    var r = t1.pick(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(r, i);
                }
                this.stop(), e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t1.ease
                }, e1);
                var a = this.transform, n = this.getZoom(), s = this.getBearing(), l = this.getPitch(), c = this.getPadding(), u = "zoom" in e1 ? t1.clamp(+e1.zoom, a.minZoom, a.maxZoom) : n, h = "bearing" in e1 ? this._normalizeBearing(e1.bearing, s) : s, p = "pitch" in e1 ? +e1.pitch : l, d = "padding" in e1 ? e1.padding : a.padding, _ = a.zoomScale(u - n), f = t1.Point.convert(e1.offset), m = a.centerPoint.add(f), g = a.pointLocation(m), v = t1.LngLat.convert(e1.center || g);
                this._normalizeCenter(v);
                var y = a.project(g), x = a.project(v).sub(y), b = e1.curve, w = Math.max(a.width, a.height), T = w / _, E = x.mag();
                if ("minZoom" in e1) {
                    var I = t1.clamp(Math.min(e1.minZoom, n, u), a.minZoom, a.maxZoom), P = w / a.zoomScale(I - n);
                    b = Math.sqrt(P / E * 2);
                }
                var S = b * b;
                function C(t1) {
                    var e1 = (T * T - w * w + (t1 ? -1 : 1) * S * S * E * E) / (2 * (t1 ? T : w) * S * E);
                    return Math.log(Math.sqrt(e1 * e1 + 1) - e1);
                }
                function z(t1) {
                    return (Math.exp(t1) - Math.exp(-t1)) / 2;
                }
                function D(t1) {
                    return (Math.exp(t1) + Math.exp(-t1)) / 2;
                }
                var A = C(0), M = function(t1) {
                    return D(A) / D(A + b * t1);
                }, L = function(t1) {
                    var e1;
                    return w * ((D(A) * (z(e1 = A + b * t1) / D(e1)) - z(A)) / S) / E;
                }, R = (C(1) - A) / b;
                if (Math.abs(E) < 1e-6 || !isFinite(R)) {
                    if (Math.abs(w - T) < 1e-6) return this.easeTo(e1, i);
                    var k = T < w ? -1 : 1;
                    R = Math.abs(Math.log(T / w)) / b, L = function() {
                        return 0;
                    }, M = function(t1) {
                        return Math.exp(k * b * t1);
                    };
                }
                return e1.duration = "duration" in e1 ? +e1.duration : 1e3 * R / ("screenSpeed" in e1 ? +e1.screenSpeed / b : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = s !== h, this._pitching = p !== l, this._padding = !a.isPaddingEqual(d), this._prepareEase(i, !1), this._ease(function(e1) {
                    var r = e1 * R, _ = 1 / M(r);
                    a.zoom = 1 === e1 ? u : n + a.scaleZoom(_), o._rotating && (a.bearing = t1.number(s, h, e1)), o._pitching && (a.pitch = t1.number(l, p, e1)), o._padding && (a.interpolatePadding(c, d, e1), m = a.centerPoint.add(f));
                    var g = 1 === e1 ? v : a.unproject(y.add(x.mult(L(r))).mult(_));
                    a.setLocationAtPoint(a.renderWorldCopies ? g.wrap() : g, m), o._fireMoveEvents(i);
                }, function() {
                    return o._afterEase(i);
                }, e1), this;
            }, i.prototype.isEasing = function() {
                return !!this._easeFrameId;
            }, i.prototype.stop = function() {
                return this._stop();
            }, i.prototype._stop = function(t1, e1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    var i = this._onEaseEnd;
                    delete this._onEaseEnd, i.call(this, e1);
                }
                if (!t1) {
                    var o = this.handlers;
                    o && o.stop(!1);
                }
                return this;
            }, i.prototype._ease = function(e1, i, o) {
                !1 === o.animate || 0 === o.duration ? (e1(1), i()) : (this._easeStart = t1.browser.now(), this._easeOptions = o, this._onEaseFrame = e1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }, i.prototype._renderFrameCallback = function() {
                var e1 = Math.min((t1.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
                this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }, i.prototype._normalizeBearing = function(e1, i) {
                e1 = t1.wrap(e1, -180, 180);
                var o = Math.abs(e1 - i);
                return Math.abs(e1 - 360 - i) < o && (e1 -= 360), Math.abs(e1 + 360 - i) < o && (e1 += 360), e1;
            }, i.prototype._normalizeCenter = function(t1) {
                var e1 = this.transform;
                if (e1.renderWorldCopies && !e1.lngRange) {
                    var i = t1.lng - e1.center.lng;
                    t1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
                }
            }, i;
        }(t1.Evented), yr = function(e1) {
            void 0 === e1 && (e1 = {}), this.options = e1, t1.bindAll([
                "_toggleAttribution",
                "_updateEditLink",
                "_updateData",
                "_updateCompact"
            ], this);
        };
        yr.prototype.getDefaultPosition = function() {
            return "bottom-right";
        }, yr.prototype.onAdd = function(t1) {
            var e1 = this.options && this.options.compact;
            return this._map = t1, this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = i.create("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = i.create("div", "mapboxgl-ctrl-attrib-inner", this._container), this._innerContainer.setAttribute("role", "list"), e1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === e1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
        }, yr.prototype.onRemove = function() {
            i.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
        }, yr.prototype._setElementTitle = function(t1, e1) {
            var i = this._map._getUIString("AttributionControl." + e1);
            t1.title = i, t1.setAttribute("aria-label", i);
        }, yr.prototype._toggleAttribution = function() {
            this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "true"));
        }, yr.prototype._updateEditLink = function() {
            var e1 = this._editLink;
            e1 || (e1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
            var i = [
                {
                    key: "owner",
                    value: this.styleOwner
                },
                {
                    key: "id",
                    value: this.styleId
                },
                {
                    key: "access_token",
                    value: this._map._requestManager._customAccessToken || t1.config.ACCESS_TOKEN
                }
            ];
            if (e1) {
                var o = i.reduce(function(t1, e1, o) {
                    return e1.value && (t1 += e1.key + "=" + e1.value + (o < i.length - 1 ? "&" : "")), t1;
                }, "?");
                e1.href = t1.config.FEEDBACK_URL + "/" + o + (this._map._hash ? this._map._hash.getHashString(!0) : ""), e1.rel = "noopener nofollow", this._setElementTitle(e1, "MapFeedback");
            }
        }, yr.prototype._updateData = function(t1) {
            !t1 || "metadata" !== t1.sourceDataType && "visibility" !== t1.sourceDataType && "style" !== t1.dataType || (this._updateAttributions(), this._updateEditLink());
        }, yr.prototype._updateAttributions = function() {
            if (this._map.style) {
                var t1 = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t1 = t1.concat(this.options.customAttribution.map(function(t1) {
                    return "string" != typeof t1 ? "" : t1;
                })) : "string" == typeof this.options.customAttribution && t1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    var e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                var i = this._map.style.sourceCaches;
                for(var o in i){
                    var r = i[o];
                    if (r.used) {
                        var a = r.getSource();
                        a.attribution && t1.indexOf(a.attribution) < 0 && t1.push(a.attribution);
                    }
                }
                t1.sort(function(t1, e1) {
                    return t1.length - e1.length;
                });
                var n = (t1 = t1.filter(function(e1, i) {
                    for(var o = i + 1; o < t1.length; o++)if (t1[o].indexOf(e1) >= 0) return !1;
                    return !0;
                })).join(" | ");
                n !== this._attribHTML && (this._attribHTML = n, t1.length ? (this._innerContainer.innerHTML = n, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
        }, yr.prototype._updateCompact = function() {
            this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
        };
        var xr = function() {
            t1.bindAll([
                "_updateLogo"
            ], this), t1.bindAll([
                "_updateCompact"
            ], this);
        };
        xr.prototype.onAdd = function(t1) {
            this._map = t1, this._container = i.create("div", "mapboxgl-ctrl");
            var e1 = i.create("a", "mapboxgl-ctrl-logo");
            return e1.target = "_blank", e1.rel = "noopener nofollow", e1.href = "https://www.mapbox.com/", e1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
        }, xr.prototype.onRemove = function() {
            i.remove(this._container), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
        }, xr.prototype.getDefaultPosition = function() {
            return "bottom-left";
        }, xr.prototype._updateLogo = function(t1) {
            t1 && "metadata" !== t1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
        }, xr.prototype._logoRequired = function() {
            if (this._map.style) {
                var t1 = this._map.style.sourceCaches;
                for(var e1 in t1)if (t1[e1].getSource().mapbox_logo) return !0;
                return !1;
            }
        }, xr.prototype._updateCompact = function() {
            var t1 = this._container.children;
            if (t1.length) {
                var e1 = t1[0];
                this._map.getCanvasContainer().offsetWidth < 250 ? e1.classList.add("mapboxgl-compact") : e1.classList.remove("mapboxgl-compact");
            }
        };
        var br = function() {
            this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
        };
        br.prototype.add = function(t1) {
            var e1 = ++this._id;
            return this._queue.push({
                callback: t1,
                id: e1,
                cancelled: !1
            }), e1;
        }, br.prototype.remove = function(t1) {
            for(var e1 = this._currentlyRunning, i = 0, o = e1 ? this._queue.concat(e1) : this._queue; i < o.length; i += 1){
                var r = o[i];
                if (r.id === t1) return void (r.cancelled = !0);
            }
        }, br.prototype.run = function(t1) {
            void 0 === t1 && (t1 = 0);
            var e1 = this._currentlyRunning = this._queue;
            this._queue = [];
            for(var i = 0, o = e1; i < o.length; i += 1){
                var r = o[i];
                if (!r.cancelled && (r.callback(t1), this._cleared)) break;
            }
            this._cleared = !1, this._currentlyRunning = !1;
        }, br.prototype.clear = function() {
            this._currentlyRunning && (this._cleared = !0), this._queue = [];
        };
        var wr = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm"
        }, Tr = t1.window.HTMLImageElement, Er = t1.window.HTMLElement, Ir = t1.window.ImageBitmap, Pr = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            crossSourceCollisions: !0
        }, Sr = function(o) {
            function r(e1) {
                var i = this;
                if (null != (e1 = t1.extend({}, Pr, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != e1.maxPitch && e1.maxPitch > 60) throw new Error("maxPitch must be less than or equal to 60");
                var r = new To(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies);
                if (o.call(this, r, e1), this._interactive = e1.interactive, this._maxTileCacheSize = e1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._crossSourceCollisions = e1.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e1.collectResourceTiming, this._renderTaskQueue = new br, this._controls = [], this._mapId = t1.uniqueId(), this._locale = t1.extend({}, wr, e1.locale), this._clickTolerance = e1.clickTolerance, this._requestManager = new t1.RequestManager(e1.transformRequest, e1.accessToken), "string" == typeof e1.container) {
                    if (this._container = t1.window.document.getElementById(e1.container), !this._container) throw new Error("Container '" + e1.container + "' not found.");
                } else {
                    if (!(e1.container instanceof Er)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    this._container = e1.container;
                }
                if (e1.maxBounds && this.setMaxBounds(e1.maxBounds), t1.bindAll([
                    "_onWindowOnline",
                    "_onWindowResize",
                    "_onMapScroll",
                    "_contextLost",
                    "_contextRestored"
                ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                this.on("move", function() {
                    return i._update(!1);
                }), this.on("moveend", function() {
                    return i._update(!1);
                }), this.on("zoom", function() {
                    return i._update(!0);
                }), void 0 !== t1.window && (t1.window.addEventListener("online", this._onWindowOnline, !1), t1.window.addEventListener("resize", this._onWindowResize, !1), t1.window.addEventListener("orientationchange", this._onWindowResize, !1)), this.handlers = new gr(this, e1), this._hash = e1.hash && new Io("string" == typeof e1.hash && e1.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                    center: e1.center,
                    zoom: e1.zoom,
                    bearing: e1.bearing,
                    pitch: e1.pitch
                }), e1.bounds && (this.resize(), this.fitBounds(e1.bounds, t1.extend({}, e1.fitBoundsOptions, {
                    duration: 0
                })))), this.resize(), this._localIdeographFontFamily = e1.localIdeographFontFamily, e1.style && this.setStyle(e1.style, {
                    localIdeographFontFamily: e1.localIdeographFontFamily
                }), e1.attributionControl && this.addControl(new yr({
                    customAttribution: e1.customAttribution
                })), this.addControl(new xr, e1.logoPosition), this.on("style.load", function() {
                    i.transform.unmodified && i.jumpTo(i.style.stylesheet);
                }), this.on("data", function(e1) {
                    i._update("style" === e1.dataType), i.fire(new t1.Event(e1.dataType + "data", e1));
                }), this.on("dataloading", function(e1) {
                    i.fire(new t1.Event(e1.dataType + "dataloading", e1));
                });
            }
            o && (r.__proto__ = o), (r.prototype = Object.create(o && o.prototype)).constructor = r;
            var a = {
                showTileBoundaries: {
                    configurable: !0
                },
                showPadding: {
                    configurable: !0
                },
                showCollisionBoxes: {
                    configurable: !0
                },
                showOverdrawInspector: {
                    configurable: !0
                },
                repaint: {
                    configurable: !0
                },
                vertices: {
                    configurable: !0
                },
                version: {
                    configurable: !0
                }
            };
            return r.prototype._getMapId = function() {
                return this._mapId;
            }, r.prototype.addControl = function(e1, i) {
                if (void 0 === i && (i = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                var o = e1.onAdd(this);
                this._controls.push(e1);
                var r = this._controlPositions[i];
                return -1 !== i.indexOf("bottom") ? r.insertBefore(o, r.firstChild) : r.appendChild(o), this;
            }, r.prototype.removeControl = function(e1) {
                if (!e1 || !e1.onRemove) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                var i = this._controls.indexOf(e1);
                return i > -1 && this._controls.splice(i, 1), e1.onRemove(this), this;
            }, r.prototype.hasControl = function(t1) {
                return this._controls.indexOf(t1) > -1;
            }, r.prototype.resize = function(e1) {
                var i = this._containerDimensions(), o = i[0], r = i[1];
                if (o === this.transform.width && r === this.transform.height) return this;
                this._resizeCanvas(o, r), this.transform.resize(o, r), this.painter.resize(o, r);
                var a = !this._moving;
                return a && this.fire(new t1.Event("movestart", e1)).fire(new t1.Event("move", e1)), this.fire(new t1.Event("resize", e1)), a && this.fire(new t1.Event("moveend", e1)), this;
            }, r.prototype.getBounds = function() {
                return this.transform.getBounds();
            }, r.prototype.getMaxBounds = function() {
                return this.transform.getMaxBounds();
            }, r.prototype.setMaxBounds = function(e1) {
                return this.transform.setMaxBounds(t1.LngLatBounds.convert(e1)), this._update();
            }, r.prototype.setMinZoom = function(t1) {
                if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 && this.setZoom(t1), this;
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }, r.prototype.getMinZoom = function() {
                return this.transform.minZoom;
            }, r.prototype.setMaxZoom = function(t1) {
                if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 && this.setZoom(t1), this;
                throw new Error("maxZoom must be greater than the current minZoom");
            }, r.prototype.getMaxZoom = function() {
                return this.transform.maxZoom;
            }, r.prototype.setMinPitch = function(t1) {
                if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 && this.setPitch(t1), this;
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }, r.prototype.getMinPitch = function() {
                return this.transform.minPitch;
            }, r.prototype.setMaxPitch = function(t1) {
                if ((t1 = null == t1 ? 60 : t1) > 60) throw new Error("maxPitch must be less than or equal to 60");
                if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 && this.setPitch(t1), this;
                throw new Error("maxPitch must be greater than the current minPitch");
            }, r.prototype.getMaxPitch = function() {
                return this.transform.maxPitch;
            }, r.prototype.getRenderWorldCopies = function() {
                return this.transform.renderWorldCopies;
            }, r.prototype.setRenderWorldCopies = function(t1) {
                return this.transform.renderWorldCopies = t1, this._update();
            }, r.prototype.project = function(e1) {
                return this.transform.locationPoint(t1.LngLat.convert(e1));
            }, r.prototype.unproject = function(e1) {
                return this.transform.pointLocation(t1.Point.convert(e1));
            }, r.prototype.isMoving = function() {
                return this._moving || this.handlers.isMoving();
            }, r.prototype.isZooming = function() {
                return this._zooming || this.handlers.isZooming();
            }, r.prototype.isRotating = function() {
                return this._rotating || this.handlers.isRotating();
            }, r.prototype._createDelegatedListener = function(t1, e1, i) {
                var o, r = this;
                if ("mouseenter" === t1 || "mouseover" === t1) {
                    var a = !1;
                    return {
                        layer: e1,
                        listener: i,
                        delegates: {
                            mousemove: function(o) {
                                var n = r.getLayer(e1) ? r.queryRenderedFeatures(o.point, {
                                    layers: [
                                        e1
                                    ]
                                }) : [];
                                n.length ? a || (a = !0, i.call(r, new Ro(t1, r, o.originalEvent, {
                                    features: n
                                }))) : a = !1;
                            },
                            mouseout: function() {
                                a = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === t1 || "mouseout" === t1) {
                    var n = !1;
                    return {
                        layer: e1,
                        listener: i,
                        delegates: {
                            mousemove: function(o) {
                                (r.getLayer(e1) ? r.queryRenderedFeatures(o.point, {
                                    layers: [
                                        e1
                                    ]
                                }) : []).length ? n = !0 : n && (n = !1, i.call(r, new Ro(t1, r, o.originalEvent)));
                            },
                            mouseout: function(e1) {
                                n && (n = !1, i.call(r, new Ro(t1, r, e1.originalEvent)));
                            }
                        }
                    };
                }
                return {
                    layer: e1,
                    listener: i,
                    delegates: (o = {}, o[t1] = function(t1) {
                        var o = r.getLayer(e1) ? r.queryRenderedFeatures(t1.point, {
                            layers: [
                                e1
                            ]
                        }) : [];
                        o.length && (t1.features = o, i.call(r, t1), delete t1.features);
                    }, o)
                };
            }, r.prototype.on = function(t1, e1, i) {
                if (void 0 === i) return o.prototype.on.call(this, t1, e1);
                var r = this._createDelegatedListener(t1, e1, i);
                for(var a in this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t1] = this._delegatedListeners[t1] || [], this._delegatedListeners[t1].push(r), r.delegates)this.on(a, r.delegates[a]);
                return this;
            }, r.prototype.once = function(t1, e1, i) {
                if (void 0 === i) return o.prototype.once.call(this, t1, e1);
                var r = this._createDelegatedListener(t1, e1, i);
                for(var a in r.delegates)this.once(a, r.delegates[a]);
                return this;
            }, r.prototype.off = function(t1, e1, i) {
                var r = this;
                return void 0 === i ? o.prototype.off.call(this, t1, e1) : (this._delegatedListeners && this._delegatedListeners[t1] && function(o) {
                    for(var a = o[t1], n = 0; n < a.length; n++){
                        var s = a[n];
                        if (s.layer === e1 && s.listener === i) {
                            for(var l in s.delegates)r.off(l, s.delegates[l]);
                            return a.splice(n, 1), r;
                        }
                    }
                }(this._delegatedListeners), this);
            }, r.prototype.queryRenderedFeatures = function(e1, i) {
                if (!this.style) return [];
                var o;
                if (void 0 !== i || void 0 === e1 || e1 instanceof t1.Point || Array.isArray(e1) || (i = e1, e1 = void 0), i = i || {}, (e1 = e1 || [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ]) instanceof t1.Point || "number" == typeof e1[0]) o = [
                    t1.Point.convert(e1)
                ];
                else {
                    var r = t1.Point.convert(e1[0]), a = t1.Point.convert(e1[1]);
                    o = [
                        r,
                        new t1.Point(a.x, r.y),
                        a,
                        new t1.Point(r.x, a.y),
                        r
                    ];
                }
                return this.style.queryRenderedFeatures(o, i, this.transform);
            }, r.prototype.querySourceFeatures = function(t1, e1) {
                return this.style.querySourceFeatures(t1, e1);
            }, r.prototype.setStyle = function(e1, i) {
                return !1 !== (i = t1.extend({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e1, i));
            }, r.prototype._getUIString = function(t1) {
                var e1 = this._locale[t1];
                if (null == e1) throw new Error("Missing UI string '" + t1 + "'");
                return e1;
            }, r.prototype._updateStyle = function(t1, e1) {
                return this.style && (this.style.setEventedParent(null), this.style._remove()), t1 ? (this.style = new je(this, e1 || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof t1 ? this.style.loadURL(t1) : this.style.loadJSON(t1), this) : (delete this.style, this);
            }, r.prototype._lazyInitEmptyStyle = function() {
                this.style || (this.style = new je(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }, r.prototype._diffStyle = function(e1, i) {
                var o = this;
                if ("string" == typeof e1) {
                    var r = this._requestManager.normalizeStyleURL(e1), a = this._requestManager.transformRequest(r, t1.ResourceType.Style);
                    t1.getJSON(a, function(e1, r) {
                        e1 ? o.fire(new t1.ErrorEvent(e1)) : r && o._updateDiff(r, i);
                    });
                } else "object" == typeof e1 && this._updateDiff(e1, i);
            }, r.prototype._updateDiff = function(e1, i) {
                try {
                    this.style.setState(e1) && this._update(!0);
                } catch (o) {
                    t1.warnOnce("Unable to perform style diff: " + (o.message || o.error || o) + ".  Rebuilding the style from scratch."), this._updateStyle(e1, i);
                }
            }, r.prototype.getStyle = function() {
                if (this.style) return this.style.serialize();
            }, r.prototype.isStyleLoaded = function() {
                return this.style ? this.style.loaded() : t1.warnOnce("There is no style added to the map.");
            }, r.prototype.addSource = function(t1, e1) {
                return this._lazyInitEmptyStyle(), this.style.addSource(t1, e1), this._update(!0);
            }, r.prototype.isSourceLoaded = function(e1) {
                var i = this.style && this.style.sourceCaches[e1];
                if (void 0 !== i) return i.loaded();
                this.fire(new t1.ErrorEvent(new Error("There is no source with ID '" + e1 + "'")));
            }, r.prototype.areTilesLoaded = function() {
                var t1 = this.style && this.style.sourceCaches;
                for(var e1 in t1){
                    var i = t1[e1]._tiles;
                    for(var o in i){
                        var r = i[o];
                        if ("loaded" !== r.state && "errored" !== r.state) return !1;
                    }
                }
                return !0;
            }, r.prototype.addSourceType = function(t1, e1, i) {
                return this._lazyInitEmptyStyle(), this.style.addSourceType(t1, e1, i);
            }, r.prototype.removeSource = function(t1) {
                return this.style.removeSource(t1), this._update(!0);
            }, r.prototype.getSource = function(t1) {
                return this.style.getSource(t1);
            }, r.prototype.addImage = function(e1, i, o) {
                void 0 === o && (o = {});
                var r = o.pixelRatio;
                void 0 === r && (r = 1);
                var a = o.sdf;
                void 0 === a && (a = !1);
                var n = o.stretchX, s = o.stretchY, l = o.content;
                if (this._lazyInitEmptyStyle(), i instanceof Tr || Ir && i instanceof Ir) {
                    var c = t1.browser.getImageData(i);
                    this.style.addImage(e1, {
                        data: new t1.RGBAImage({
                            width: c.width,
                            height: c.height
                        }, c.data),
                        pixelRatio: r,
                        stretchX: n,
                        stretchY: s,
                        content: l,
                        sdf: a,
                        version: 0
                    });
                } else {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    var u = i;
                    this.style.addImage(e1, {
                        data: new t1.RGBAImage({
                            width: i.width,
                            height: i.height
                        }, new Uint8Array(i.data)),
                        pixelRatio: r,
                        stretchX: n,
                        stretchY: s,
                        content: l,
                        sdf: a,
                        version: 0,
                        userImage: u
                    }), u.onAdd && u.onAdd(this, e1);
                }
            }, r.prototype.updateImage = function(e1, i) {
                var o = this.style.getImage(e1);
                if (!o) return this.fire(new t1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                var r = i instanceof Tr || Ir && i instanceof Ir ? t1.browser.getImageData(i) : i, a = r.width, n = r.height, s = r.data;
                return void 0 === a || void 0 === n ? this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))) : a !== o.data.width || n !== o.data.height ? this.fire(new t1.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image"))) : (o.data.replace(s, !(i instanceof Tr || Ir && i instanceof Ir)), void this.style.updateImage(e1, o));
            }, r.prototype.hasImage = function(e1) {
                return e1 ? !!this.style.getImage(e1) : (this.fire(new t1.ErrorEvent(new Error("Missing required image id"))), !1);
            }, r.prototype.removeImage = function(t1) {
                this.style.removeImage(t1);
            }, r.prototype.loadImage = function(e1, i) {
                t1.getImage(this._requestManager.transformRequest(e1, t1.ResourceType.Image), i);
            }, r.prototype.listImages = function() {
                return this.style.listImages();
            }, r.prototype.addLayer = function(t1, e1) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(t1, e1), this._update(!0);
            }, r.prototype.moveLayer = function(t1, e1) {
                return this.style.moveLayer(t1, e1), this._update(!0);
            }, r.prototype.removeLayer = function(t1) {
                return this.style.removeLayer(t1), this._update(!0);
            }, r.prototype.getLayer = function(t1) {
                return this.style.getLayer(t1);
            }, r.prototype.setLayerZoomRange = function(t1, e1, i) {
                return this.style.setLayerZoomRange(t1, e1, i), this._update(!0);
            }, r.prototype.setFilter = function(t1, e1, i) {
                return void 0 === i && (i = {}), this.style.setFilter(t1, e1, i), this._update(!0);
            }, r.prototype.getFilter = function(t1) {
                return this.style.getFilter(t1);
            }, r.prototype.setPaintProperty = function(t1, e1, i, o) {
                return void 0 === o && (o = {}), this.style.setPaintProperty(t1, e1, i, o), this._update(!0);
            }, r.prototype.getPaintProperty = function(t1, e1) {
                return this.style.getPaintProperty(t1, e1);
            }, r.prototype.setLayoutProperty = function(t1, e1, i, o) {
                return void 0 === o && (o = {}), this.style.setLayoutProperty(t1, e1, i, o), this._update(!0);
            }, r.prototype.getLayoutProperty = function(t1, e1) {
                return this.style.getLayoutProperty(t1, e1);
            }, r.prototype.setLight = function(t1, e1) {
                return void 0 === e1 && (e1 = {}), this._lazyInitEmptyStyle(), this.style.setLight(t1, e1), this._update(!0);
            }, r.prototype.getLight = function() {
                return this.style.getLight();
            }, r.prototype.setFeatureState = function(t1, e1) {
                return this.style.setFeatureState(t1, e1), this._update();
            }, r.prototype.removeFeatureState = function(t1, e1) {
                return this.style.removeFeatureState(t1, e1), this._update();
            }, r.prototype.getFeatureState = function(t1) {
                return this.style.getFeatureState(t1);
            }, r.prototype.getContainer = function() {
                return this._container;
            }, r.prototype.getCanvasContainer = function() {
                return this._canvasContainer;
            }, r.prototype.getCanvas = function() {
                return this._canvas;
            }, r.prototype._containerDimensions = function() {
                var t1 = 0, e1 = 0;
                return this._container && (t1 = this._container.clientWidth || 400, e1 = this._container.clientHeight || 300), [
                    t1,
                    e1
                ];
            }, r.prototype._detectMissingCSS = function() {
                "rgb(250, 128, 114)" !== t1.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && t1.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
            }, r.prototype._setupContainer = function() {
                var t1 = this._container;
                t1.classList.add("mapboxgl-map"), (this._missingCSSCanary = i.create("div", "mapboxgl-canary", t1)).style.visibility = "hidden", this._detectMissingCSS();
                var e1 = this._canvasContainer = i.create("div", "mapboxgl-canvas-container", t1);
                this._interactive && e1.classList.add("mapboxgl-interactive"), this._canvas = i.create("canvas", "mapboxgl-canvas", e1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                var o = this._containerDimensions();
                this._resizeCanvas(o[0], o[1]);
                var r = this._controlContainer = i.create("div", "mapboxgl-control-container", t1), a = this._controlPositions = {};
                [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ].forEach(function(t1) {
                    a[t1] = i.create("div", "mapboxgl-ctrl-" + t1, r);
                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }, r.prototype._resizeCanvas = function(e1, i) {
                var o = t1.browser.devicePixelRatio || 1;
                this._canvas.width = o * e1, this._canvas.height = o * i, this._canvas.style.width = e1 + "px", this._canvas.style.height = i + "px";
            }, r.prototype._setupPainter = function() {
                var i = t1.extend({}, e1.webGLContextAttributes, {
                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                    antialias: this._antialias || !1
                }), o = this._canvas.getContext("webgl", i) || this._canvas.getContext("experimental-webgl", i);
                o ? (this.painter = new yo(o, this.transform), t1.webpSupported.testSupport(o)) : this.fire(new t1.ErrorEvent(new Error("Failed to initialize WebGL")));
            }, r.prototype._contextLost = function(e1) {
                e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t1.Event("webglcontextlost", {
                    originalEvent: e1
                }));
            }, r.prototype._contextRestored = function(e1) {
                this._setupPainter(), this.resize(), this._update(), this.fire(new t1.Event("webglcontextrestored", {
                    originalEvent: e1
                }));
            }, r.prototype._onMapScroll = function(t1) {
                if (t1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
            }, r.prototype.loaded = function() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }, r.prototype._update = function(t1) {
                return this.style ? (this._styleDirty = this._styleDirty || t1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }, r.prototype._requestRenderFrame = function(t1) {
                return this._update(), this._renderTaskQueue.add(t1);
            }, r.prototype._cancelRenderFrame = function(t1) {
                this._renderTaskQueue.remove(t1);
            }, r.prototype._render = function(e1) {
                var i, o = this, r = 0, a = this.painter.context.extTimerQuery;
                if (this.listens("gpu-timing-frame") && (i = a.createQueryEXT(), a.beginQueryEXT(a.TIME_ELAPSED_EXT, i), r = t1.browser.now()), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), !this._removed) {
                    var n = !1;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        var s = this.transform.zoom, l = t1.browser.now();
                        this.style.zoomHistory.update(s, l);
                        var c = new t1.EvaluationParameters(s, {
                            now: l,
                            fadeDuration: this._fadeDuration,
                            zoomHistory: this.style.zoomHistory,
                            transition: this.style.getTransition()
                        }), u = c.crossFadingFactor();
                        1 === u && u === this._crossFadingFactor || (n = !0, this._crossFadingFactor = u), this.style.update(c);
                    }
                    if (this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions), this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showOverdrawInspector: this._showOverdrawInspector,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: this._fadeDuration,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer")
                    }), this.fire(new t1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new t1.Event("load"))), this.style && (this.style.hasTransitions() || n) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
                        var h = t1.browser.now() - r;
                        a.endQueryEXT(a.TIME_ELAPSED_EXT, i), setTimeout(function() {
                            var e1 = a.getQueryObjectEXT(i, a.QUERY_RESULT_EXT) / 1e6;
                            a.deleteQueryEXT(i), o.fire(new t1.Event("gpu-timing-frame", {
                                cpuTime: h,
                                gpuTime: e1
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        var p = this.painter.collectGpuTimers();
                        setTimeout(function() {
                            var e1 = o.painter.queryGpuTimers(p);
                            o.fire(new t1.Event("gpu-timing-layer", {
                                layerTimes: e1
                            }));
                        }, 50);
                    }
                    var d = this._sourcesDirty || this._styleDirty || this._placementDirty;
                    return d || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t1.Event("idle")), !this._loaded || this._fullyLoaded || d || (this._fullyLoaded = !0), this;
                }
            }, r.prototype.remove = function() {
                this._hash && this._hash.remove();
                for(var e1 = 0, i = this._controls; e1 < i.length; e1 += 1)i[e1].onRemove(this);
                this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), void 0 !== t1.window && (t1.window.removeEventListener("resize", this._onWindowResize, !1), t1.window.removeEventListener("orientationchange", this._onWindowResize, !1), t1.window.removeEventListener("online", this._onWindowOnline, !1));
                var o = this.painter.context.gl.getExtension("WEBGL_lose_context");
                o && o.loseContext(), Cr(this._canvasContainer), Cr(this._controlContainer), Cr(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), this._removed = !0, this.fire(new t1.Event("remove"));
            }, r.prototype.triggerRepaint = function() {
                var e1 = this;
                this.style && !this._frame && (this._frame = t1.browser.frame(function(t1) {
                    e1._frame = null, e1._render(t1);
                }));
            }, r.prototype._onWindowOnline = function() {
                this._update();
            }, r.prototype._onWindowResize = function(t1) {
                this._trackResize && this.resize({
                    originalEvent: t1
                })._update();
            }, a.showTileBoundaries.get = function() {
                return !!this._showTileBoundaries;
            }, a.showTileBoundaries.set = function(t1) {
                this._showTileBoundaries !== t1 && (this._showTileBoundaries = t1, this._update());
            }, a.showPadding.get = function() {
                return !!this._showPadding;
            }, a.showPadding.set = function(t1) {
                this._showPadding !== t1 && (this._showPadding = t1, this._update());
            }, a.showCollisionBoxes.get = function() {
                return !!this._showCollisionBoxes;
            }, a.showCollisionBoxes.set = function(t1) {
                this._showCollisionBoxes !== t1 && (this._showCollisionBoxes = t1, t1 ? this.style._generateCollisionBoxes() : this._update());
            }, a.showOverdrawInspector.get = function() {
                return !!this._showOverdrawInspector;
            }, a.showOverdrawInspector.set = function(t1) {
                this._showOverdrawInspector !== t1 && (this._showOverdrawInspector = t1, this._update());
            }, a.repaint.get = function() {
                return !!this._repaint;
            }, a.repaint.set = function(t1) {
                this._repaint !== t1 && (this._repaint = t1, this.triggerRepaint());
            }, a.vertices.get = function() {
                return !!this._vertices;
            }, a.vertices.set = function(t1) {
                this._vertices = t1, this._update();
            }, r.prototype._setCacheLimits = function(e1, i) {
                t1.setCacheLimits(e1, i);
            }, a.version.get = function() {
                return t1.version;
            }, Object.defineProperties(r.prototype, a), r;
        }(vr);
        function Cr(t1) {
            t1.parentNode && t1.parentNode.removeChild(t1);
        }
        var zr = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        }, Dr = function(e1) {
            var o = this;
            this.options = t1.extend({}, zr, e1), this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", function(t1) {
                return t1.preventDefault();
            }), this.options.showZoom && (t1.bindAll([
                "_setButtonTitle",
                "_updateZoomButtons"
            ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function(t1) {
                return o._map.zoomIn({}, {
                    originalEvent: t1
                });
            }), i.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", !0), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function(t1) {
                return o._map.zoomOut({}, {
                    originalEvent: t1
                });
            }), i.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", !0)), this.options.showCompass && (t1.bindAll([
                "_rotateCompassArrow"
            ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", function(t1) {
                o.options.visualizePitch ? o._map.resetNorthPitch({}, {
                    originalEvent: t1
                }) : o._map.resetNorth({}, {
                    originalEvent: t1
                });
            }), this._compassIcon = i.create("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", !0));
        };
        Dr.prototype._updateZoomButtons = function() {
            var t1 = this._map.getZoom(), e1 = t1 === this._map.getMaxZoom(), i = t1 === this._map.getMinZoom();
            this._zoomInButton.disabled = e1, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", e1.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
        }, Dr.prototype._rotateCompassArrow = function() {
            var t1 = this.options.visualizePitch ? "scale(" + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5) + ") rotateX(" + this._map.transform.pitch + "deg) rotateZ(" + this._map.transform.angle * (180 / Math.PI) + "deg)" : "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
            this._compassIcon.style.transform = t1;
        }, Dr.prototype.onAdd = function(t1) {
            return this._map = t1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Ar(this._map, this._compass, this.options.visualizePitch)), this._container;
        }, Dr.prototype.onRemove = function() {
            i.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
        }, Dr.prototype._createButton = function(t1, e1) {
            var o = i.create("button", t1, this._container);
            return o.type = "button", o.addEventListener("click", e1), o;
        }, Dr.prototype._setButtonTitle = function(t1, e1) {
            var i = this._map._getUIString("NavigationControl." + e1);
            t1.title = i, t1.setAttribute("aria-label", i);
        };
        var Ar = function(e1, o, r) {
            void 0 === r && (r = !1), this._clickTolerance = 10, this.element = o, this.mouseRotate = new Xo({
                clickTolerance: e1.dragRotate._mouseRotate._clickTolerance
            }), this.map = e1, r && (this.mousePitch = new Ho({
                clickTolerance: e1.dragRotate._mousePitch._clickTolerance
            })), t1.bindAll([
                "mousedown",
                "mousemove",
                "mouseup",
                "touchstart",
                "touchmove",
                "touchend",
                "reset"
            ], this), i.addEventListener(o, "mousedown", this.mousedown), i.addEventListener(o, "touchstart", this.touchstart, {
                passive: !1
            }), i.addEventListener(o, "touchmove", this.touchmove), i.addEventListener(o, "touchend", this.touchend), i.addEventListener(o, "touchcancel", this.reset);
        };
        function Mr(e1, i, o) {
            if (e1 = new t1.LngLat(e1.lng, e1.lat), i) {
                var r = new t1.LngLat(e1.lng - 360, e1.lat), a = new t1.LngLat(e1.lng + 360, e1.lat), n = o.locationPoint(e1).distSqr(i);
                o.locationPoint(r).distSqr(i) < n ? e1 = r : o.locationPoint(a).distSqr(i) < n && (e1 = a);
            }
            for(; Math.abs(e1.lng - o.center.lng) > 180;){
                var s = o.locationPoint(e1);
                if (s.x >= 0 && s.y >= 0 && s.x <= o.width && s.y <= o.height) break;
                e1.lng > o.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1;
        }
        Ar.prototype.down = function(t1, e1) {
            this.mouseRotate.mousedown(t1, e1), this.mousePitch && this.mousePitch.mousedown(t1, e1), i.disableDrag();
        }, Ar.prototype.move = function(t1, e1) {
            var i = this.map, o = this.mouseRotate.mousemoveWindow(t1, e1);
            if (o && o.bearingDelta && i.setBearing(i.getBearing() + o.bearingDelta), this.mousePitch) {
                var r = this.mousePitch.mousemoveWindow(t1, e1);
                r && r.pitchDelta && i.setPitch(i.getPitch() + r.pitchDelta);
            }
        }, Ar.prototype.off = function() {
            var t1 = this.element;
            i.removeEventListener(t1, "mousedown", this.mousedown), i.removeEventListener(t1, "touchstart", this.touchstart, {
                passive: !1
            }), i.removeEventListener(t1, "touchmove", this.touchmove), i.removeEventListener(t1, "touchend", this.touchend), i.removeEventListener(t1, "touchcancel", this.reset), this.offTemp();
        }, Ar.prototype.offTemp = function() {
            i.enableDrag(), i.removeEventListener(t1.window, "mousemove", this.mousemove), i.removeEventListener(t1.window, "mouseup", this.mouseup);
        }, Ar.prototype.mousedown = function(e1) {
            this.down(t1.extend({}, e1, {
                ctrlKey: !0,
                preventDefault: function() {
                    return e1.preventDefault();
                }
            }), i.mousePos(this.element, e1)), i.addEventListener(t1.window, "mousemove", this.mousemove), i.addEventListener(t1.window, "mouseup", this.mouseup);
        }, Ar.prototype.mousemove = function(t1) {
            this.move(t1, i.mousePos(this.element, t1));
        }, Ar.prototype.mouseup = function(t1) {
            this.mouseRotate.mouseupWindow(t1), this.mousePitch && this.mousePitch.mouseupWindow(t1), this.offTemp();
        }, Ar.prototype.touchstart = function(t1) {
            1 !== t1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = i.touchPos(this.element, t1.targetTouches)[0], this.down({
                type: "mousedown",
                button: 0,
                ctrlKey: !0,
                preventDefault: function() {
                    return t1.preventDefault();
                }
            }, this._startPos));
        }, Ar.prototype.touchmove = function(t1) {
            1 !== t1.targetTouches.length ? this.reset() : (this._lastPos = i.touchPos(this.element, t1.targetTouches)[0], this.move({
                preventDefault: function() {
                    return t1.preventDefault();
                }
            }, this._lastPos));
        }, Ar.prototype.touchend = function(t1) {
            0 === t1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
        }, Ar.prototype.reset = function() {
            this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        };
        var Lr = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function Rr(t1, e1, i) {
            var o = t1.classList;
            for(var r in Lr)o.remove("mapboxgl-" + i + "-anchor-" + r);
            o.add("mapboxgl-" + i + "-anchor-" + e1);
        }
        var kr, Br = function(e1) {
            function o(o, r) {
                if (e1.call(this), (o instanceof t1.window.HTMLElement || r) && (o = t1.extend({
                    element: o
                }, r)), t1.bindAll([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress"
                ], this), this._anchor = o && o.anchor || "center", this._color = o && o.color || "#3FB1CE", this._scale = o && o.scale || 1, this._draggable = o && o.draggable || !1, this._clickTolerance = o && o.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = o && o.rotation || 0, this._rotationAlignment = o && o.rotationAlignment || "auto", this._pitchAlignment = o && o.pitchAlignment && "auto" !== o.pitchAlignment ? o.pitchAlignment : this._rotationAlignment, o && o.element) this._element = o.element, this._offset = t1.Point.convert(o && o.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = i.create("div"), this._element.setAttribute("aria-label", "Map marker");
                    var a = i.createNS("http://www.w3.org/2000/svg", "svg");
                    a.setAttributeNS(null, "display", "block"), a.setAttributeNS(null, "height", "41px"), a.setAttributeNS(null, "width", "27px"), a.setAttributeNS(null, "viewBox", "0 0 27 41");
                    var n = i.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "stroke", "none"), n.setAttributeNS(null, "stroke-width", "1"), n.setAttributeNS(null, "fill", "none"), n.setAttributeNS(null, "fill-rule", "evenodd");
                    var s = i.createNS("http://www.w3.org/2000/svg", "g");
                    s.setAttributeNS(null, "fill-rule", "nonzero");
                    var l = i.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    for(var c = 0, u = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ]; c < u.length; c += 1){
                        var h = u[c], p = i.createNS("http://www.w3.org/2000/svg", "ellipse");
                        p.setAttributeNS(null, "opacity", "0.04"), p.setAttributeNS(null, "cx", "10.5"), p.setAttributeNS(null, "cy", "5.80029008"), p.setAttributeNS(null, "rx", h.rx), p.setAttributeNS(null, "ry", h.ry), l.appendChild(p);
                    }
                    var d = i.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "fill", this._color);
                    var _ = i.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), d.appendChild(_);
                    var f = i.createNS("http://www.w3.org/2000/svg", "g");
                    f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "fill", "#000000");
                    var m = i.createNS("http://www.w3.org/2000/svg", "path");
                    m.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), f.appendChild(m);
                    var g = i.createNS("http://www.w3.org/2000/svg", "g");
                    g.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), g.setAttributeNS(null, "fill", "#FFFFFF");
                    var v = i.createNS("http://www.w3.org/2000/svg", "g");
                    v.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    var y = i.createNS("http://www.w3.org/2000/svg", "circle");
                    y.setAttributeNS(null, "fill", "#000000"), y.setAttributeNS(null, "opacity", "0.25"), y.setAttributeNS(null, "cx", "5.5"), y.setAttributeNS(null, "cy", "5.5"), y.setAttributeNS(null, "r", "5.4999962");
                    var x = i.createNS("http://www.w3.org/2000/svg", "circle");
                    x.setAttributeNS(null, "fill", "#FFFFFF"), x.setAttributeNS(null, "cx", "5.5"), x.setAttributeNS(null, "cy", "5.5"), x.setAttributeNS(null, "r", "5.4999962"), v.appendChild(y), v.appendChild(x), s.appendChild(l), s.appendChild(d), s.appendChild(f), s.appendChild(g), s.appendChild(v), a.appendChild(s), a.setAttributeNS(null, "height", 41 * this._scale + "px"), a.setAttributeNS(null, "width", 27 * this._scale + "px"), this._element.appendChild(a), this._offset = t1.Point.convert(o && o.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", function(t1) {
                    t1.preventDefault();
                }), this._element.addEventListener("mousedown", function(t1) {
                    t1.preventDefault();
                }), Rr(this._element, this._anchor, "marker"), this._popup = null;
            }
            return e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o, o.prototype.addTo = function(t1) {
                return this.remove(), this._map = t1, t1.getCanvasContainer().appendChild(this._element), t1.on("move", this._update), t1.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }, o.prototype.remove = function() {
                return this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), i.remove(this._element), this._popup && this._popup.remove(), this;
            }, o.prototype.getLngLat = function() {
                return this._lngLat;
            }, o.prototype.setLngLat = function(e1) {
                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }, o.prototype.getElement = function() {
                return this._element;
            }, o.prototype.setPopup = function(t1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t1) {
                    if (!("offset" in t1.options)) {
                        var e1 = Math.sqrt(Math.pow(13.5, 2) / 2);
                        t1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -38.1
                            ],
                            "bottom-left": [
                                e1,
                                -1 * (24.6 + e1)
                            ],
                            "bottom-right": [
                                -e1,
                                -1 * (24.6 + e1)
                            ],
                            left: [
                                13.5,
                                -24.6
                            ],
                            right: [
                                -13.5,
                                -24.6
                            ]
                        } : this._offset;
                    }
                    this._popup = t1, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }, o.prototype._onKeyPress = function(t1) {
                var e1 = t1.code, i = t1.charCode || t1.keyCode;
                "Space" !== e1 && "Enter" !== e1 && 32 !== i && 13 !== i || this.togglePopup();
            }, o.prototype._onMapClick = function(t1) {
                var e1 = t1.originalEvent.target, i = this._element;
                this._popup && (e1 === i || i.contains(e1)) && this.togglePopup();
            }, o.prototype.getPopup = function() {
                return this._popup;
            }, o.prototype.togglePopup = function() {
                var t1 = this._popup;
                return t1 ? (t1.isOpen() ? t1.remove() : t1.addTo(this._map), this) : this;
            }, o.prototype._update = function(t1) {
                if (this._map) {
                    this._map.transform.renderWorldCopies && (this._lngLat = Mr(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                    var e1 = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? e1 = "rotateZ(" + this._rotation + "deg)" : "map" === this._rotationAlignment && (e1 = "rotateZ(" + (this._rotation - this._map.getBearing()) + "deg)");
                    var o = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? o = "rotateX(0deg)" : "map" === this._pitchAlignment && (o = "rotateX(" + this._map.getPitch() + "deg)"), t1 && "moveend" !== t1.type || (this._pos = this._pos.round()), i.setTransform(this._element, Lr[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px) " + o + " " + e1);
                }
            }, o.prototype.getOffset = function() {
                return this._offset;
            }, o.prototype.setOffset = function(e1) {
                return this._offset = t1.Point.convert(e1), this._update(), this;
            }, o.prototype._onMove = function(e1) {
                if (!this._isDragging) {
                    var i = this._clickTolerance || this._map._clickTolerance;
                    this._isDragging = e1.point.dist(this._pointerdownPos) >= i;
                }
                this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t1.Event("dragstart"))), this.fire(new t1.Event("drag")));
            }, o.prototype._onUp = function() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t1.Event("dragend")), this._state = "inactive";
            }, o.prototype._addDragHandler = function(t1) {
                this._element.contains(t1.originalEvent.target) && (t1.preventDefault(), this._positionDelta = t1.point.sub(this._pos).add(this._offset), this._pointerdownPos = t1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
            }, o.prototype.setDraggable = function(t1) {
                return this._draggable = !!t1, this._map && (t1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }, o.prototype.isDraggable = function() {
                return this._draggable;
            }, o.prototype.setRotation = function(t1) {
                return this._rotation = t1 || 0, this._update(), this;
            }, o.prototype.getRotation = function() {
                return this._rotation;
            }, o.prototype.setRotationAlignment = function(t1) {
                return this._rotationAlignment = t1 || "auto", this._update(), this;
            }, o.prototype.getRotationAlignment = function() {
                return this._rotationAlignment;
            }, o.prototype.setPitchAlignment = function(t1) {
                return this._pitchAlignment = t1 && "auto" !== t1 ? t1 : this._rotationAlignment, this._update(), this;
            }, o.prototype.getPitchAlignment = function() {
                return this._pitchAlignment;
            }, o;
        }(t1.Evented), Or = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        }, Fr = 0, Ur = !1, Nr = function(e1) {
            function o(i) {
                e1.call(this), this.options = t1.extend({}, Or, i), t1.bindAll([
                    "_onSuccess",
                    "_onError",
                    "_onZoom",
                    "_finish",
                    "_setupUI",
                    "_updateCamera",
                    "_updateMarker"
                ], this);
            }
            return e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o, o.prototype.onAdd = function(e1) {
                var o;
                return this._map = e1, this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), o = this._setupUI, void 0 !== kr ? o(kr) : void 0 !== t1.window.navigator.permissions ? t1.window.navigator.permissions.query({
                    name: "geolocation"
                }).then(function(t1) {
                    o(kr = "denied" !== t1.state);
                }) : o(kr = !!t1.window.navigator.geolocation), this._container;
            }, o.prototype.onRemove = function() {
                void 0 !== this._geolocationWatchID && (t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), i.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Fr = 0, Ur = !1;
            }, o.prototype._isOutOfMapMaxBounds = function(t1) {
                var e1 = this._map.getMaxBounds(), i = t1.coords;
                return e1 && (i.longitude < e1.getWest() || i.longitude > e1.getEast() || i.latitude < e1.getSouth() || i.latitude > e1.getNorth());
            }, o.prototype._setErrorState = function() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                }
            }, o.prototype._onSuccess = function(e1) {
                if (this._map) {
                    if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t1.Event("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                    if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                            break;
                        case "BACKGROUND":
                        case "BACKGROUND_ERROR":
                            this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                    }
                    this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("geolocate", e1)), this._finish();
                }
            }, o.prototype._updateCamera = function(e1) {
                var i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude), o = e1.coords.accuracy, r = this._map.getBearing(), a = t1.extend({
                    bearing: r
                }, this.options.fitBoundsOptions);
                this._map.fitBounds(i.toBounds(o), a, {
                    geolocateSource: !0
                });
            }, o.prototype._updateMarker = function(e1) {
                if (e1) {
                    var i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude);
                    this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
            }, o.prototype._updateCircleRadius = function() {
                var t1 = this._map._container.clientHeight / 2, e1 = this._map.unproject([
                    0,
                    t1
                ]), i = this._map.unproject([
                    1,
                    t1
                ]), o = e1.distanceTo(i), r = Math.ceil(2 * this._accuracy / o);
                this._circleElement.style.width = r + "px", this._circleElement.style.height = r + "px";
            }, o.prototype._onZoom = function() {
                this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
            }, o.prototype._onError = function(e1) {
                if (this._map) {
                    if (this.options.trackUserLocation) {
                        if (1 === e1.code) {
                            this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                            var i = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.title = i, this._geolocateButton.setAttribute("aria-label", i), void 0 !== this._geolocationWatchID && this._clearWatch();
                        } else {
                            if (3 === e1.code && Ur) return;
                            this._setErrorState();
                        }
                    }
                    "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("error", e1)), this._finish();
                }
            }, o.prototype._finish = function() {
                this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
            }, o.prototype._setupUI = function(e1) {
                var o = this;
                if (this._container.addEventListener("contextmenu", function(t1) {
                    return t1.preventDefault();
                }), this._geolocateButton = i.create("button", "mapboxgl-ctrl-geolocate", this._container), i.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", !0), this._geolocateButton.type = "button", !1 === e1) {
                    t1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                    var r = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                    this._geolocateButton.disabled = !0, this._geolocateButton.title = r, this._geolocateButton.setAttribute("aria-label", r);
                } else {
                    var a = this._map._getUIString("GeolocateControl.FindMyLocation");
                    this._geolocateButton.title = a, this._geolocateButton.setAttribute("aria-label", a);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = i.create("div", "mapboxgl-user-location-dot"), this._userLocationDotMarker = new Br(this._dotElement), this._circleElement = i.create("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Br({
                    element: this._circleElement,
                    pitchAlignment: "map"
                }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", function(e1) {
                    e1.geolocateSource || "ACTIVE_LOCK" !== o._watchState || e1.originalEvent && "resize" === e1.originalEvent.type || (o._watchState = "BACKGROUND", o._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), o._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), o.fire(new t1.Event("trackuserlocationend")));
                });
            }, o.prototype.trigger = function() {
                if (!this._setup) return t1.warnOnce("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new t1.Event("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            Fr--, Ur = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new t1.Event("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t1.Event("trackuserlocationstart"));
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_ERROR":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "BACKGROUND":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                            break;
                        case "BACKGROUND_ERROR":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        var e1;
                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), ++Fr > 1 ? (e1 = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, Ur = !0) : (e1 = this.options.positionOptions, Ur = !1), this._geolocationWatchID = t1.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
                    }
                } else t1.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }, o.prototype._clearWatch = function() {
                t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }, o;
        }(t1.Evented), Zr = {
            maxWidth: 100,
            unit: "metric"
        }, qr = function(e1) {
            this.options = t1.extend({}, Zr, e1), t1.bindAll([
                "_onMove",
                "setUnit"
            ], this);
        };
        function jr(t1, e1, i) {
            var o = i && i.maxWidth || 100, r = t1._container.clientHeight / 2, a = t1.unproject([
                0,
                r
            ]), n = t1.unproject([
                o,
                r
            ]), s = a.distanceTo(n);
            if (i && "imperial" === i.unit) {
                var l = 3.2808 * s;
                l > 5280 ? Vr(e1, o, l / 5280, t1._getUIString("ScaleControl.Miles")) : Vr(e1, o, l, t1._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? Vr(e1, o, s / 1852, t1._getUIString("ScaleControl.NauticalMiles")) : s >= 1e3 ? Vr(e1, o, s / 1e3, t1._getUIString("ScaleControl.Kilometers")) : Vr(e1, o, s, t1._getUIString("ScaleControl.Meters"));
        }
        function Vr(t1, e1, i, o) {
            var r, a, n, s = (r = i, (a = Math.pow(10, ("" + Math.floor(r)).length - 1)) * (n = (n = r / a) >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : n >= 1 ? 1 : function(t1) {
                var e1 = Math.pow(10, Math.ceil(-Math.log(t1) / Math.LN10));
                return Math.round(t1 * e1) / e1;
            }(n)));
            t1.style.width = e1 * (s / i) + "px", t1.innerHTML = s + "&nbsp;" + o;
        }
        qr.prototype.getDefaultPosition = function() {
            return "bottom-left";
        }, qr.prototype._onMove = function() {
            jr(this._map, this._container, this.options);
        }, qr.prototype.onAdd = function(t1) {
            return this._map = t1, this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", t1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
        }, qr.prototype.onRemove = function() {
            i.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
        }, qr.prototype.setUnit = function(t1) {
            this.options.unit = t1, jr(this._map, this._container, this.options);
        };
        var Gr = function(e1) {
            this._fullscreen = !1, e1 && e1.container && (e1.container instanceof t1.window.HTMLElement ? this._container = e1.container : t1.warnOnce("Full screen control 'container' must be a DOM element.")), t1.bindAll([
                "_onClickFullscreen",
                "_changeIcon"
            ], this), "onfullscreenchange" in t1.window.document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in t1.window.document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in t1.window.document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in t1.window.document && (this._fullscreenchange = "MSFullscreenChange");
        };
        Gr.prototype.onAdd = function(e1) {
            return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", t1.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
        }, Gr.prototype.onRemove = function() {
            i.remove(this._controlContainer), this._map = null, t1.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
        }, Gr.prototype._checkFullscreenSupport = function() {
            return !!(t1.window.document.fullscreenEnabled || t1.window.document.mozFullScreenEnabled || t1.window.document.msFullscreenEnabled || t1.window.document.webkitFullscreenEnabled);
        }, Gr.prototype._setupUI = function() {
            var e1 = this._fullscreenButton = i.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
            i.create("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", !0), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), t1.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
        }, Gr.prototype._updateTitle = function() {
            var t1 = this._getTitle();
            this._fullscreenButton.setAttribute("aria-label", t1), this._fullscreenButton.title = t1;
        }, Gr.prototype._getTitle = function() {
            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
        }, Gr.prototype._isFullscreen = function() {
            return this._fullscreen;
        }, Gr.prototype._changeIcon = function() {
            (t1.window.document.fullscreenElement || t1.window.document.mozFullScreenElement || t1.window.document.webkitFullscreenElement || t1.window.document.msFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
        }, Gr.prototype._onClickFullscreen = function() {
            this._isFullscreen() ? t1.window.document.exitFullscreen ? t1.window.document.exitFullscreen() : t1.window.document.mozCancelFullScreen ? t1.window.document.mozCancelFullScreen() : t1.window.document.msExitFullscreen ? t1.window.document.msExitFullscreen() : t1.window.document.webkitCancelFullScreen && t1.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
        };
        var Wr = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, Xr = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", "), Hr = function(e1) {
            function o(i) {
                e1.call(this), this.options = t1.extend(Object.create(Wr), i), t1.bindAll([
                    "_update",
                    "_onClose",
                    "remove",
                    "_onMouseMove",
                    "_onMouseUp",
                    "_onDrag"
                ], this);
            }
            return e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o, o.prototype.addTo = function(e1) {
                return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new t1.Event("open")), this;
            }, o.prototype.isOpen = function() {
                return !!this._map;
            }, o.prototype.remove = function() {
                return this._content && i.remove(this._content), this._container && (i.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t1.Event("close")), this;
            }, o.prototype.getLngLat = function() {
                return this._lngLat;
            }, o.prototype.setLngLat = function(e1) {
                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
            }, o.prototype.trackPointer = function() {
                return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
            }, o.prototype.getElement = function() {
                return this._container;
            }, o.prototype.setText = function(e1) {
                return this.setDOMContent(t1.window.document.createTextNode(e1));
            }, o.prototype.setHTML = function(e1) {
                var i, o = t1.window.document.createDocumentFragment(), r = t1.window.document.createElement("body");
                for(r.innerHTML = e1; i = r.firstChild;)o.appendChild(i);
                return this.setDOMContent(o);
            }, o.prototype.getMaxWidth = function() {
                return this._container && this._container.style.maxWidth;
            }, o.prototype.setMaxWidth = function(t1) {
                return this.options.maxWidth = t1, this._update(), this;
            }, o.prototype.setDOMContent = function(t1) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = i.create("div", "mapboxgl-popup-content", this._container);
                return this._content.appendChild(t1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }, o.prototype.addClassName = function(t1) {
                this._container && this._container.classList.add(t1);
            }, o.prototype.removeClassName = function(t1) {
                this._container && this._container.classList.remove(t1);
            }, o.prototype.setOffset = function(t1) {
                return this.options.offset = t1, this._update(), this;
            }, o.prototype.toggleClassName = function(t1) {
                if (this._container) return this._container.classList.toggle(t1);
            }, o.prototype._createCloseButton = function() {
                this.options.closeButton && (this._closeButton = i.create("button", "mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }, o.prototype._onMouseUp = function(t1) {
                this._update(t1.point);
            }, o.prototype._onMouseMove = function(t1) {
                this._update(t1.point);
            }, o.prototype._onDrag = function(t1) {
                this._update(t1.point);
            }, o.prototype._update = function(e1) {
                var o = this;
                if (this._map && (this._lngLat || this._trackPointer) && this._content && (this._container || (this._container = i.create("div", "mapboxgl-popup", this._map.getContainer()), this._tip = i.create("div", "mapboxgl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach(function(t1) {
                    return o._container.classList.add(t1);
                }), this._trackPointer && this._container.classList.add("mapboxgl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Mr(this._lngLat, this._pos, this._map.transform)), !this._trackPointer || e1)) {
                    var r = this._pos = this._trackPointer && e1 ? e1 : this._map.project(this._lngLat), a = this.options.anchor, n = function e1(i) {
                        if (i) {
                            if ("number" == typeof i) {
                                var o = Math.round(Math.sqrt(.5 * Math.pow(i, 2)));
                                return {
                                    center: new t1.Point(0, 0),
                                    top: new t1.Point(0, i),
                                    "top-left": new t1.Point(o, o),
                                    "top-right": new t1.Point(-o, o),
                                    bottom: new t1.Point(0, -i),
                                    "bottom-left": new t1.Point(o, -o),
                                    "bottom-right": new t1.Point(-o, -o),
                                    left: new t1.Point(i, 0),
                                    right: new t1.Point(-i, 0)
                                };
                            }
                            if (i instanceof t1.Point || Array.isArray(i)) {
                                var r = t1.Point.convert(i);
                                return {
                                    center: r,
                                    top: r,
                                    "top-left": r,
                                    "top-right": r,
                                    bottom: r,
                                    "bottom-left": r,
                                    "bottom-right": r,
                                    left: r,
                                    right: r
                                };
                            }
                            return {
                                center: t1.Point.convert(i.center || [
                                    0,
                                    0
                                ]),
                                top: t1.Point.convert(i.top || [
                                    0,
                                    0
                                ]),
                                "top-left": t1.Point.convert(i["top-left"] || [
                                    0,
                                    0
                                ]),
                                "top-right": t1.Point.convert(i["top-right"] || [
                                    0,
                                    0
                                ]),
                                bottom: t1.Point.convert(i.bottom || [
                                    0,
                                    0
                                ]),
                                "bottom-left": t1.Point.convert(i["bottom-left"] || [
                                    0,
                                    0
                                ]),
                                "bottom-right": t1.Point.convert(i["bottom-right"] || [
                                    0,
                                    0
                                ]),
                                left: t1.Point.convert(i.left || [
                                    0,
                                    0
                                ]),
                                right: t1.Point.convert(i.right || [
                                    0,
                                    0
                                ])
                            };
                        }
                        return e1(new t1.Point(0, 0));
                    }(this.options.offset);
                    if (!a) {
                        var s, l = this._container.offsetWidth, c = this._container.offsetHeight;
                        s = r.y + n.bottom.y < c ? [
                            "top"
                        ] : r.y > this._map.transform.height - c ? [
                            "bottom"
                        ] : [], r.x < l / 2 ? s.push("left") : r.x > this._map.transform.width - l / 2 && s.push("right"), a = 0 === s.length ? "bottom" : s.join("-");
                    }
                    var u = r.add(n[a]).round();
                    i.setTransform(this._container, Lr[a] + " translate(" + u.x + "px," + u.y + "px)"), Rr(this._container, a, "popup");
                }
            }, o.prototype._focusFirstElement = function() {
                if (this.options.focusAfterOpen && this._container) {
                    var t1 = this._container.querySelector(Xr);
                    t1 && t1.focus();
                }
            }, o.prototype._onClose = function() {
                this.remove();
            }, o;
        }(t1.Evented), Kr = {
            version: t1.version,
            supported: e1,
            setRTLTextPlugin: t1.setRTLTextPlugin,
            getRTLTextPluginStatus: t1.getRTLTextPluginStatus,
            Map: Sr,
            NavigationControl: Dr,
            GeolocateControl: Nr,
            AttributionControl: yr,
            ScaleControl: qr,
            FullscreenControl: Gr,
            Popup: Hr,
            Marker: Br,
            Style: je,
            LngLat: t1.LngLat,
            LngLatBounds: t1.LngLatBounds,
            Point: t1.Point,
            MercatorCoordinate: t1.MercatorCoordinate,
            Evented: t1.Evented,
            config: t1.config,
            prewarm: function() {
                Ft().acquire(Rt);
            },
            clearPrewarmedResources: function() {
                var t1 = Bt;
                t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(Rt), Bt = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return t1.config.ACCESS_TOKEN;
            },
            set accessToken (e){
                t1.config.ACCESS_TOKEN = e;
            },
            get baseApiUrl () {
                return t1.config.API_URL;
            },
            set baseApiUrl (e){
                t1.config.API_URL = e;
            },
            get workerCount () {
                return kt.workerCount;
            },
            set workerCount (t){
                kt.workerCount = t;
            },
            get maxParallelImageRequests () {
                return t1.config.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (e){
                t1.config.MAX_PARALLEL_IMAGE_REQUESTS = e;
            },
            clearStorage: function(e1) {
                t1.clearTileCache(e1);
            },
            workerUrl: ""
        };
        return Kr;
    });
    //
    return mapboxgl;
});


var $49c0293bc888dc3d$var$_mapboxGl2 = $49c0293bc888dc3d$var$_interopRequireDefault($af44cc7d4ea0e537$exports);
var $21d266c6c6c90868$exports = {};

$parcel$defineInteropFlag($21d266c6c6c90868$exports);

$parcel$export($21d266c6c6c90868$exports, "default", () => $21d266c6c6c90868$export$2e2bcd8739ae039);
var $21d266c6c6c90868$var$defaultStyles = [
    {
        label: "Streets",
        styleName: "Mapbox Streets",
        styleUrl: "mapbox://styles/mapbox/streets-v11"
    },
    {
        label: "Satellite",
        styleName: "Mapbox Satellite Streets",
        styleUrl: "mapbox://sprites/mapbox/satellite-streets-v11"
    }
];
/**
 * Adds style switcher similar to Google Maps.
 * @param {Object} options
 * @param {Array} [options.styles] - Array of style objects:
 * @param {String} options.styles.label - Style label to display on switcher
 * @param {String} options.styles.styleName - [Style name from spec](https://docs.mapbox.com/mapbox-gl-js/style-spec/#root-name)
 * @param {String} options.styles.styleUrl - Style url
 * @param {Function} [options.onChange] - Triggered on style change. Accepts `style` object
 */ var $21d266c6c6c90868$var$StylesControl = function StylesControl(options) {
    if (options === void 0) options = {};
    this.styles = options.styles || $21d266c6c6c90868$var$defaultStyles;
    this.onChange = options.onChange;
};
$21d266c6c6c90868$var$StylesControl.prototype.insertControls = function insertControls() {
    var this$1 = this;
    this.container = document.createElement("div");
    this.container.classList.add("mapboxgl-ctrl");
    this.container.classList.add("mapboxgl-ctrl-group");
    this.container.classList.add("mapboxgl-ctrl-styles");
    this.nodes = [];
    this.styles.forEach(function(style) {
        var node = document.createElement("button");
        node.setAttribute("type", "button");
        node.textContent = style.label;
        node.addEventListener("click", function() {
            if (node.classList.contains("-active")) return;
            this$1.map.setStyle(style.styleUrl);
            if (this$1.onChange) this$1.onChange(style);
        });
        this$1.nodes.push(node);
        this$1.container.appendChild(node);
    });
};
$21d266c6c6c90868$var$StylesControl.prototype.onAdd = function onAdd(map) {
    var this$1 = this;
    this.map = map;
    this.insertControls();
    this.map.on("styledata", function() {
        [].forEach.call(this$1.container.querySelectorAll("button"), function(div) {
            div.classList.remove("-active");
        });
        var styleNames = this$1.styles.map(function(style) {
            return style.styleName;
        });
        var currentStyleIndex = styleNames.indexOf(this$1.map.getStyle().name);
        if (currentStyleIndex !== -1) {
            var currentNode = this$1.nodes[currentStyleIndex];
            currentNode.classList.add("-active");
        }
    });
    return this.container;
};
$21d266c6c6c90868$var$StylesControl.prototype.onRemove = function onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
};
var $21d266c6c6c90868$export$2e2bcd8739ae039 = $21d266c6c6c90868$var$StylesControl;


var $49c0293bc888dc3d$var$_styles2 = $49c0293bc888dc3d$var$_interopRequireDefault($21d266c6c6c90868$exports);
var $6fd65619cf1ecf82$exports = {};

$parcel$defineInteropFlag($6fd65619cf1ecf82$exports);

$parcel$export($6fd65619cf1ecf82$exports, "default", () => $6fd65619cf1ecf82$export$2e2bcd8739ae039);
function $6fd65619cf1ecf82$var$iconPointer() {
    return new DOMParser().parseFromString('<svg viewBox="0 0 24 24" width="22" height="22" xmlns="http://www.w3.org/2000/svg">\n    <g fill="none" fill-rule="evenodd">\n        <path d="M0 0h24v24H0z"/>\n        <path fill="#f44336" d="M12 3l4 8H8z"/>\n        <path fill="#9E9E9E" d="M12 21l-4-8h8z"/>\n    </g>\n</svg>', "image/svg+xml").firstChild;
}
/**
 * Simple compass
 * @param {Object} options
 * @param {Boolean} [options.instant=true] - Show compass if bearing is 0
 */ var $6fd65619cf1ecf82$var$CompassControl = function CompassControl(options) {
    if (options === void 0) options = {};
    this.instant = typeof options.instant === "boolean" ? options.instant : true;
    this.onRotate = this.onRotate.bind(this);
};
$6fd65619cf1ecf82$var$CompassControl.prototype.insertControls = function insertControls() {
    this.container = document.createElement("div");
    this.button = document.createElement("button");
    this.button.setAttribute("type", "button");
    this.container.classList.add("mapboxgl-ctrl");
    this.container.classList.add("mapboxgl-ctrl-group");
    this.container.classList.add("mapboxgl-ctrl-compass");
    this.pointer = $6fd65619cf1ecf82$var$iconPointer();
    if (this.instant) this.container.classList.add("-active");
    this.container.appendChild(this.button);
    this.button.appendChild(this.pointer);
};
$6fd65619cf1ecf82$var$CompassControl.prototype.onAdd = function onAdd(map) {
    var this$1 = this;
    this.map = map;
    this.insertControls();
    this.button.addEventListener("click", function() {
        this$1.map.easeTo({
            bearing: 0,
            pitch: 0
        });
    });
    this.map.on("rotate", this.onRotate);
    this.onRotate();
    return this.container;
};
$6fd65619cf1ecf82$var$CompassControl.prototype.onRemove = function onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
};
$6fd65619cf1ecf82$var$CompassControl.prototype.onRotate = function onRotate() {
    var angle = this.map.getBearing() * -1;
    if (!this.instant) {
        if (angle === 0) this.container.classList.remove("-active");
        else this.container.classList.add("-active");
    }
    this.pointer.style.transform = "rotate(" + angle + "deg)";
};
var $6fd65619cf1ecf82$export$2e2bcd8739ae039 = $6fd65619cf1ecf82$var$CompassControl;


var $49c0293bc888dc3d$var$_compass2 = $49c0293bc888dc3d$var$_interopRequireDefault($6fd65619cf1ecf82$exports);
var $9f2f96e249cc423a$exports = {};

$parcel$defineInteropFlag($9f2f96e249cc423a$exports);

$parcel$export($9f2f96e249cc423a$exports, "default", () => $9f2f96e249cc423a$export$2e2bcd8739ae039);
function $9f2f96e249cc423a$var$iconPlus() {
    return new DOMParser().parseFromString('<svg fill="#505050" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>', "image/svg+xml").firstChild;
}
function $9f2f96e249cc423a$var$iconMinus() {
    return new DOMParser().parseFromString('<svg fill="#505050" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 13H5v-2h14v2z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>', "image/svg+xml").firstChild;
}
/**
 * Simple zoom control
 */ var $9f2f96e249cc423a$var$ZoomControl = function ZoomControl() {};
$9f2f96e249cc423a$var$ZoomControl.prototype.insertControls = function insertControls() {
    this.container = document.createElement("div");
    this.container.classList.add("mapboxgl-ctrl");
    this.container.classList.add("mapboxgl-ctrl-group");
    this.container.classList.add("mapboxgl-ctrl-zoom");
    this.zoomIn = document.createElement("button");
    this.zoomIn.setAttribute("type", "button");
    this.zoomIn.appendChild($9f2f96e249cc423a$var$iconPlus());
    this.zoomOut = document.createElement("button");
    this.zoomOut.setAttribute("type", "button");
    this.zoomOut.appendChild($9f2f96e249cc423a$var$iconMinus());
    this.container.appendChild(this.zoomIn);
    this.container.appendChild(this.zoomOut);
};
$9f2f96e249cc423a$var$ZoomControl.prototype.onAdd = function onAdd(map) {
    var this$1 = this;
    this.map = map;
    this.insertControls();
    this.zoomIn.addEventListener("click", function() {
        this$1.map.zoomIn();
    });
    this.zoomOut.addEventListener("click", function() {
        this$1.map.zoomOut();
    });
    return this.container;
};
$9f2f96e249cc423a$var$ZoomControl.prototype.onRemove = function onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
};
var $9f2f96e249cc423a$export$2e2bcd8739ae039 = $9f2f96e249cc423a$var$ZoomControl;


var $49c0293bc888dc3d$var$_zoom2 = $49c0293bc888dc3d$var$_interopRequireDefault($9f2f96e249cc423a$exports);
var $f951aa5e484c393e$exports = {};

$parcel$defineInteropFlag($f951aa5e484c393e$exports);

$parcel$export($f951aa5e484c393e$exports, "default", () => $f951aa5e484c393e$export$2e2bcd8739ae039);
// http://en.wikipedia.org/wiki/Haversine_formula
// http://www.movable-type.co.uk/scripts/latlong.html
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var $b6be4e54eb2df570$export$e3a1ee0e9945697f = 6371008.8;
var $b6be4e54eb2df570$export$f929e47acbed771a = {
    centimeters: $b6be4e54eb2df570$export$e3a1ee0e9945697f * 100,
    centimetres: $b6be4e54eb2df570$export$e3a1ee0e9945697f * 100,
    degrees: $b6be4e54eb2df570$export$e3a1ee0e9945697f / 111325,
    feet: $b6be4e54eb2df570$export$e3a1ee0e9945697f * 3.28084,
    inches: $b6be4e54eb2df570$export$e3a1ee0e9945697f * 39.37,
    kilometers: $b6be4e54eb2df570$export$e3a1ee0e9945697f / 1000,
    kilometres: $b6be4e54eb2df570$export$e3a1ee0e9945697f / 1000,
    meters: $b6be4e54eb2df570$export$e3a1ee0e9945697f,
    metres: $b6be4e54eb2df570$export$e3a1ee0e9945697f,
    miles: $b6be4e54eb2df570$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $b6be4e54eb2df570$export$e3a1ee0e9945697f * 1000,
    millimetres: $b6be4e54eb2df570$export$e3a1ee0e9945697f * 1000,
    nauticalmiles: $b6be4e54eb2df570$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $b6be4e54eb2df570$export$e3a1ee0e9945697f * 1.0936
};
var $b6be4e54eb2df570$export$95cef4899be7420 = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / $b6be4e54eb2df570$export$e3a1ee0e9945697f,
    yards: 1.0936133
};
var $b6be4e54eb2df570$export$44665ce4f7f4c82b = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $b6be4e54eb2df570$export$42a7622cbf932bb(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return $b6be4e54eb2df570$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $b6be4e54eb2df570$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $b6be4e54eb2df570$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $b6be4e54eb2df570$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $b6be4e54eb2df570$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $b6be4e54eb2df570$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $b6be4e54eb2df570$export$105684a3041cb6f3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$b6be4e54eb2df570$export$7e4aa119212bc614(coordinates[0]) || !$b6be4e54eb2df570$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options);
}
function $b6be4e54eb2df570$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $b6be4e54eb2df570$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $b6be4e54eb2df570$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $b6be4e54eb2df570$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options);
}
function $b6be4e54eb2df570$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $b6be4e54eb2df570$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $b6be4e54eb2df570$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $b6be4e54eb2df570$export$98ec381bb06902c3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options);
}
function $b6be4e54eb2df570$export$74f7306c35db993f(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $b6be4e54eb2df570$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $b6be4e54eb2df570$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $b6be4e54eb2df570$export$4717c67ac3e5e04d(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $b6be4e54eb2df570$export$bd735230309493da(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options);
}
function $b6be4e54eb2df570$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options);
}
function $b6be4e54eb2df570$export$79bd594da96638d3(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options);
}
function $b6be4e54eb2df570$export$9242f1e18250422a(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $b6be4e54eb2df570$export$ced6ed16dfd6a264(geom, properties, options);
}
function $b6be4e54eb2df570$export$2077e0241d6afd3c(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $b6be4e54eb2df570$export$f234631d6a2eedf8(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = $b6be4e54eb2df570$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $b6be4e54eb2df570$export$a2280f7debae8f10(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = $b6be4e54eb2df570$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $b6be4e54eb2df570$export$c7a138e00a89bd01(distance, units) {
    return $b6be4e54eb2df570$export$c41dd2a8460d3196($b6be4e54eb2df570$export$a2280f7debae8f10(distance, units));
}
function $b6be4e54eb2df570$export$f2077d29c73b33ec(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $b6be4e54eb2df570$export$c41dd2a8460d3196(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function $b6be4e54eb2df570$export$c9fcf1a7df975d78(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function $b6be4e54eb2df570$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $b6be4e54eb2df570$export$f234631d6a2eedf8($b6be4e54eb2df570$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $b6be4e54eb2df570$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $b6be4e54eb2df570$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $b6be4e54eb2df570$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $b6be4e54eb2df570$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $b6be4e54eb2df570$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
function $b6be4e54eb2df570$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$b6be4e54eb2df570$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $b6be4e54eb2df570$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}



function $f15b24c39f38ac98$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $f15b24c39f38ac98$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $f15b24c39f38ac98$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $b6be4e54eb2df570$export$7e4aa119212bc614)(coordinates[0]) && (0, $b6be4e54eb2df570$export$7e4aa119212bc614)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $f15b24c39f38ac98$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $f15b24c39f38ac98$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $f15b24c39f38ac98$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $f15b24c39f38ac98$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $f15b24c39f38ac98$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $f15b24c39f38ac98$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}


function $b3e8b16904c908bc$export$2e2bcd8739ae039(origin, distance, bearing, options) {
    if (options === void 0) options = {};
    // Handle input
    var coordinates1 = (0, $f15b24c39f38ac98$export$b4663c6e64a770bc)(origin);
    var longitude1 = (0, $b6be4e54eb2df570$export$c9fcf1a7df975d78)(coordinates1[0]);
    var latitude1 = (0, $b6be4e54eb2df570$export$c9fcf1a7df975d78)(coordinates1[1]);
    var bearingRad = (0, $b6be4e54eb2df570$export$c9fcf1a7df975d78)(bearing);
    var radians = (0, $b6be4e54eb2df570$export$a2280f7debae8f10)(distance, options.units);
    // Main
    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) + Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad));
    var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1), Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
    var lng = (0, $b6be4e54eb2df570$export$c41dd2a8460d3196)(longitude2);
    var lat = (0, $b6be4e54eb2df570$export$c41dd2a8460d3196)(latitude2);
    return (0, $b6be4e54eb2df570$export$105684a3041cb6f3)([
        lng,
        lat
    ], options.properties);
}



/**
 * Takes a {@link Point} and calculates the circle polygon given a radius in degrees, radians, miles, or kilometers; and steps for precision.
 *
 * @name circle
 * @param {Feature<Point>|number[]} center center point
 * @param {number} radius radius of the circle
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.steps=64] number of steps
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {Object} [options.properties={}] properties
 * @returns {Feature<Polygon>} circle polygon
 * @example
 * var center = [-75.343, 39.984];
 * var radius = 5;
 * var options = {steps: 10, units: 'kilometers', properties: {foo: 'bar'}};
 * var circle = turf.circle(center, radius, options);
 *
 * //addToMap
 * var addToMap = [turf.point(center), circle]
 */ function $f951aa5e484c393e$var$circle(center, radius, options) {
    if (options === void 0) options = {};
    // default params
    var steps = options.steps || 64;
    var properties = options.properties ? options.properties : !Array.isArray(center) && center.type === "Feature" && center.properties ? center.properties : {};
    // main
    var coordinates = [];
    for(var i = 0; i < steps; i++)coordinates.push((0, $b3e8b16904c908bc$export$2e2bcd8739ae039)(center, radius, i * -360 / steps, options).geometry.coordinates);
    coordinates.push(coordinates[0]);
    return (0, $b6be4e54eb2df570$export$b7b19aa0ee06c73)([
        coordinates
    ], properties);
}
var $f951aa5e484c393e$export$2e2bcd8739ae039 = $f951aa5e484c393e$var$circle;


var $49c0293bc888dc3d$var$_circle2 = $49c0293bc888dc3d$var$_interopRequireDefault($f951aa5e484c393e$exports);



function $49c0293bc888dc3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49c0293bc888dc3d$var$createMap() {
    const map = new $49c0293bc888dc3d$var$_mapboxGl2.default.Map({
        container: "map",
        minZoom: 2,
        maxZoom: 18,
        hash: true,
        style: "https://geoserveis.icgc.cat/contextmaps/icgc_mapa_base_gris.json",
        center: [
            1.88979,
            41.69589
        ],
        zoom: 13.61,
        attributionControl: false,
        preserveDrawingBuffer: true
    });
    //map.addControl(new mapboxgl.NavigationControl());
    map.addControl(new $49c0293bc888dc3d$var$_zoom2.default(), "top-right");
    map.addControl(new $49c0293bc888dc3d$var$_compass2.default(), "top-right");
    map.addControl(new $49c0293bc888dc3d$var$_mapboxGl2.default.AttributionControl({
        compact: true
    }));
    map.on("load", function() {
        map.addSource("adreca", {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: []
            }
        });
        map.addSource("buffer", {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: []
            }
        });
        map.addLayer({
            id: "adreca",
            type: "circle",
            source: "adreca",
            paint: {
                "circle-radius": 6,
                "circle-stroke-color": "#ffffff",
                "circle-stroke-width": 1,
                "circle-color": "#486DE0"
            }
        });
        map.addLayer({
            id: "buffer",
            type: "fill",
            source: "buffer",
            paint: {
                "fill-color": "#486DE0",
                "fill-opacity": 0.4
            }
        }, "adreca");
        map.on("click", function(e) {});
    });
    return map;
}


var $e73bf42412feb220$var$_map2 = $e73bf42412feb220$var$_interopRequireDefault($49c0293bc888dc3d$exports);
var $de054122d85df2f9$exports = {};
"use strict";
Object.defineProperty($de054122d85df2f9$exports, "__esModule", {
    value: true
});
$de054122d85df2f9$exports.default = $de054122d85df2f9$var$createSidebar;
var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $4eae0a726ab50395$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


var $de054122d85df2f9$var$_jquery2 = $de054122d85df2f9$var$_interopRequireDefault($4eae0a726ab50395$exports);

function $de054122d85df2f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function $de054122d85df2f9$var$createSidebar(parent) {
    const html = `<div id="sidebar" class="movein">
		<div id="toggleBtn" class="ui icon button">
			<i class="angle left icon"></i>
		</div>
		<div class="ui segment" id="panel">
			<div class="ui one column grid">
				<div class="row">
					<div class="column">

						<div id="cercaLlocs"></div>

					</div>

					<div class="column">
						<div class="ui divider"></div>
					</div>

					<div class="ui three mini item secondary menu mm">
						<div class="item">
							<a title="Informaci\xf3" href="https://www.icgc.cat" target="_blank">
								<i class="large info circle link white icon"></i>
							</a>
						</div>
						<!--
						<div class="item">
							<a href="https://twitter.com/share" class="twitter-share-button" {count} data-text="Geocodificador ICGC" data-via="icgcat" data-hashtags="Catalunya">Tweet</a>
							<script>
								! function(d, s, id) {
									var js, fjs = d.getElementsByTagName(s)[0],
										p = /^http:/.test(d.location) ? 'http' : 'https';
									if (!d.getElementById(id)) {
										js = d.createElement(s);
										js.id = id;
										js.src = p + '://platform.twitter.com/widgets.js';
										fjs.parentNode.insertBefore(js, fjs);
									}
								}(document, 'script', 'twitter-wjs');
							</script>
						</div>
						-->
					</div>
				</div>
			</div>
		</div>
	</div>`;
    const template = document.createElement("template");
    template.innerHTML = html;
    (0, $de054122d85df2f9$var$_jquery2.default)(parent).append(template.content.cloneNode(true));
    (0, $de054122d85df2f9$var$_jquery2.default)("#toggleBtn").click(function() {
        if ((0, $de054122d85df2f9$var$_jquery2.default)("#sidebar").hasClass("movein")) {
            (0, $de054122d85df2f9$var$_jquery2.default)("#sidebar").removeClass("movein").addClass("moveout");
            (0, $de054122d85df2f9$var$_jquery2.default)("#toggleBtn > i").removeClass("left").addClass("right");
        } else {
            (0, $de054122d85df2f9$var$_jquery2.default)("#sidebar").removeClass("moveout").addClass("movein");
            (0, $de054122d85df2f9$var$_jquery2.default)("#toggleBtn > i").removeClass("right").addClass("left");
        }
    });
    /*
  $(".ui.launch.button").on("click", function(){
  	console.log($(".ui.launch.button"));
  
  	if ($("#sidebar").hasClass("movein")) {
  		//$("#sidebar").removeClass("movein").addClass("moveout");
  		//$(".ui.launch.button").removeClass("right").addClass("left");
  	} else {
  		//$("#sidebar").removeClass("moveout").addClass("movein");
  		//$(".ui.launch.button").removeClass("left").addClass("right");
  	}
  });
  
  $(".ui.sidebar").sidebar({
  	transition: "overlay",
  	context: $("#sidebar"),
  	dimPage: false
  }).sidebar("attach events",".ui.launch.button");
  */ return true;
}


var $e73bf42412feb220$var$_sidebar2 = $e73bf42412feb220$var$_interopRequireDefault($de054122d85df2f9$exports);
var $3f65818d668a8ba5$exports = {};
"use strict";
Object.defineProperty($3f65818d668a8ba5$exports, "__esModule", {
    value: true
});
$3f65818d668a8ba5$exports.default = $3f65818d668a8ba5$var$createCercaLlocs;

var $3f65818d668a8ba5$var$_jquery2 = $3f65818d668a8ba5$var$_interopRequireDefault($4eae0a726ab50395$exports);


function $3f65818d668a8ba5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3f65818d668a8ba5$var$_options = {
    domain: "https://eines.icgc.cat/geocodificador/autocompletar?text="
};
function $3f65818d668a8ba5$var$initControls(parent, map) {
    parent.find(".searchboxinput").on("keyup", function(event) {
        if (event.which == 13) {
            $3f65818d668a8ba5$var$checkInput(parent, map, true);
            event.preventDefault();
        } else $3f65818d668a8ba5$var$checkInput(parent, map, false);
    });
    parent.on("click", "li a", function(e) {
        if ((0, $3f65818d668a8ba5$var$_jquery2.default)(this).attr("data")) {
            const coords = (0, $3f65818d668a8ba5$var$_jquery2.default)(this).attr("data").split("#");
            $3f65818d668a8ba5$var$zoomTo(parent, map, coords[0], coords[1]);
        }
    });
}
function $3f65818d668a8ba5$var$checkInput(parent, map, keyOrigen) {
    const self = this;
    const _toponim = parent.find(".searchboxinput").val();
    if (_toponim && _toponim.length > 2) $3f65818d668a8ba5$var$sendRequest(parent, map, _toponim, keyOrigen);
    else parent.find(".mygrid").fadeOut();
}
function $3f65818d668a8ba5$var$sendRequest(parent, map, _toponim, keyOrigen) {
    const self = this;
    let mapCenter = map.getCenter();
    //let _focus = "&focus.point.lat=" + mapCenter.lat + "&focus.point.lon=" + mapCenter.lng;
    let _layer = "&layers=topo1,topo2,address";
    let _size = "&size=5";
    $3f65818d668a8ba5$var$_jquery2.default.ajax({
        url: `${$3f65818d668a8ba5$var$_options.domain}${_toponim}${_layer}${_size}`,
        method: "GET",
        dataType: "json",
        success: function success(data) {
            const mygrid1 = parent.find(".mygrid");
            if (data) {
                mygrid1.fadeIn();
                mygrid1.html("");
                if (data.features && data.features.length >= 1) {
                    const cList = (0, $3f65818d668a8ba5$var$_jquery2.default)("<ul>").appendTo(mygrid1);
                    $3f65818d668a8ba5$var$_jquery2.default.each(data.features, function(index, feature) {
                        (0, $3f65818d668a8ba5$var$_jquery2.default)(`<li><a data="${feature.geometry.coordinates[1]}#${feature.geometry.coordinates[0]}" href="#"><b>${feature.properties.label}</b></a>`).appendTo(cList);
                        if (keyOrigen && data.features.length >= 1) $3f65818d668a8ba5$var$zoomTo(parent, map, feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
                    });
                } else mygrid1.html("No s'ha trobat cap resultat");
            } else mygrid1.html("An error occured:");
        },
        error: function error(xhr) {
            console.log(xhr);
            mygrid.html(`An error occured: ${xhr.status} ${xhr.statusText}`);
        }
    });
}
function $3f65818d668a8ba5$var$zoomTo(parent, map, lat, lon) {
    $3f65818d668a8ba5$var$netejaPantalla(parent);
    map.flyTo({
        center: [
            lon,
            lat
        ],
        zoom: 14.5
    });
    $3f65818d668a8ba5$var$createPoint(map, lat, lon);
}
function $3f65818d668a8ba5$var$netejaPantalla(parent) {
    parent.find(".mygrid").fadeOut();
    parent.find(".searchboxinput").val("");
}
function $3f65818d668a8ba5$var$createPoint(map, lat, lon) {
    map.getSource("adreca").setData({
        type: "FeatureCollection",
        features: [
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [
                        lon,
                        lat
                    ]
                }
            }
        ]
    });
}
function $3f65818d668a8ba5$var$createCercaLlocs(parent, map) {
    const html = `<div class="ui fluid icon input"><input class="searchboxinput" type="text" placeholder="Anar a... (adre\xe7a)"><i class="search icon"></i></div><div class="mygrid"></div>`;
    const template = document.createElement("template");
    template.innerHTML = html;
    (0, $3f65818d668a8ba5$var$_jquery2.default)(parent).append(template.content.cloneNode(true));
    $3f65818d668a8ba5$var$initControls((0, $3f65818d668a8ba5$var$_jquery2.default)(parent), map);
}


var $e73bf42412feb220$var$_cercaLlocs2 = $e73bf42412feb220$var$_interopRequireDefault($3f65818d668a8ba5$exports);

function $e73bf42412feb220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$e73bf42412feb220$exports.default = async ()=>{
    console.log("Init app...");
    document.getElementById("header").innerHTML = (0, $e73bf42412feb220$var$_header2.default)();
    document.getElementById("root").innerHTML = (0, $e73bf42412feb220$var$_root2.default)();
    //document.getElementById("footer").innerHTML = createFooter();
    const map = (0, $e73bf42412feb220$var$_map2.default)();
    await (0, $e73bf42412feb220$var$_sidebar2.default)(document.getElementById("root"));
    (0, $e73bf42412feb220$var$_cercaLlocs2.default)(document.getElementById("cercaLlocs"), map);
};


var $35da740d59af89ba$var$_app2 = $35da740d59af89ba$var$_interopRequireDefault($e73bf42412feb220$exports);
function $35da740d59af89ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
(0, $35da740d59af89ba$var$_app2.default)();


//# sourceMappingURL=index.7fe09647.js.map
